/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CDF Template API
 * OpenAPI-first contract for the CDF template.
 * All protected workplace requests require an X-Tenant-Slug header identifying
 * an entity currently granted to the caller. The API validates the grant and
 * derives ownership from that entity; identifiers from another entity are
 * rejected. Browser requests use the selected entity URL for this header.
 * User-specific search, favourites, teams, files, notifications and AI history
 * are also isolated by the selected entity.
 *
 * Workflow:
 *   1. Edit this spec FIRST for any API change.
 *   2. Run `pnpm gen:api` to regenerate the React Query client
 *      (lib/api-client-react) and Zod schemas (lib/api-zod).
 *   3. Implement/adjust the Fastify routes in artifacts/api-server
 *      to match, validating with the generated Zod schemas.
 *
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';

export const ListTenantExchangeSyncConflictsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listTenantExchangeSyncConflictsQueryLimitMax = 25;

export const listTenantExchangeSyncConflictsQueryOffsetMin = 0;
export const listTenantExchangeSyncConflictsQueryOffsetMax = 100000;



export const ListTenantExchangeSyncConflictsQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "limit": zod.int().min(1).max(listTenantExchangeSyncConflictsQueryLimitMax).optional(),
  "offset": zod.int().min(listTenantExchangeSyncConflictsQueryOffsetMin).max(listTenantExchangeSyncConflictsQueryOffsetMax).optional()
}))()


export const listTenantExchangeSyncConflicts200ResponseItemsMax = 25;

export const listTenantExchangeSyncConflicts200ResponseTotalMin = 0;

export const listTenantExchangeSyncConflicts200ResponseLimitMax = 25;

export const listTenantExchangeSyncConflicts200ResponseOffsetMin = 0;



export const ListTenantExchangeSyncConflicts200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "kind": zod.enum(['remote_edit', 'remote_cancel', 'ambiguous_copy']),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listTenantExchangeSyncConflicts200ResponseItemsMax),
  "total": zod.int().min(listTenantExchangeSyncConflicts200ResponseTotalMin),
  "limit": zod.int().min(1).max(listTenantExchangeSyncConflicts200ResponseLimitMax),
  "offset": zod.int().min(listTenantExchangeSyncConflicts200ResponseOffsetMin)
}))()


export const ListExchangeValidationsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listExchangeValidationsQueryLimitMax = 25;

export const listExchangeValidationsQueryOffsetMin = 0;
export const listExchangeValidationsQueryOffsetMax = 100000;



export const ListExchangeValidationsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listExchangeValidationsQueryLimitMax).optional(),
  "offset": zod.int().min(listExchangeValidationsQueryOffsetMin).max(listExchangeValidationsQueryOffsetMax).optional()
}))()




export const listExchangeValidations200ResponseItemsMax = 25;

export const listExchangeValidations200ResponseTotalMin = 0;

export const listExchangeValidations200ResponseLimitMax = 25;

export const listExchangeValidations200ResponseOffsetMin = 0;



export const ListExchangeValidations200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "revision": zod.int().min(1),
  "phase": zod.enum(['preview', 'creating', 'create_unknown', 'created', 'updating', 'update_unknown', 'updated', 'cancelling', 'cancel_unknown', 'cleaned']),
  "connectionRevision": zod.int().min(1),
  "connectionVersion": zod.int().min(1),
  "organizer": zod.email(),
  "roomMailbox": zod.email(),
  "employeeMailbox": zod.email().nullable(),
  "subject": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "updatedEnd": zod.iso.datetime({"offset":true}),
  "eventId": zod.string().nullable(),
  "roomResponse": zod.string(),
  "createVerified": zod.boolean(),
  "updateVerified": zod.boolean(),
  "cleanupEvidence": zod.string().nullable(),
  "failureCode": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listExchangeValidations200ResponseItemsMax),
  "total": zod.int().min(listExchangeValidations200ResponseTotalMin),
  "limit": zod.int().min(1).max(listExchangeValidations200ResponseLimitMax),
  "offset": zod.int().min(listExchangeValidations200ResponseOffsetMin)
}))()

export const ListExchangeValidations400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListExchangeValidations403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListExchangeValidations409Response = /*#__PURE__*/ (() => zod.unknown())()


export const PreviewExchangeValidationParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()


export const previewExchangeValidationBodyRoomIdMax = 2048;

export const previewExchangeValidationBodyRoomMailboxMax = 254;

export const previewExchangeValidationBodyEmployeeMailboxMax = 254;



export const PreviewExchangeValidationBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "roomId": zod.string().min(1).max(previewExchangeValidationBodyRoomIdMax),
  "cursor": zod.uuid().optional(),
  "roomMailbox": zod.email().max(previewExchangeValidationBodyRoomMailboxMax),
  "employeeMailbox": zod.email().max(previewExchangeValidationBodyEmployeeMailboxMax).optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))()






export const PreviewExchangeValidation200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "revision": zod.int().min(1),
  "phase": zod.enum(['preview', 'creating', 'create_unknown', 'created', 'updating', 'update_unknown', 'updated', 'cancelling', 'cancel_unknown', 'cleaned']),
  "connectionRevision": zod.int().min(1),
  "connectionVersion": zod.int().min(1),
  "organizer": zod.email(),
  "roomMailbox": zod.email(),
  "employeeMailbox": zod.email().nullable(),
  "subject": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "updatedEnd": zod.iso.datetime({"offset":true}),
  "eventId": zod.string().nullable(),
  "roomResponse": zod.string(),
  "createVerified": zod.boolean(),
  "updateVerified": zod.boolean(),
  "cleanupEvidence": zod.string().nullable(),
  "failureCode": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const PreviewExchangeValidation400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewExchangeValidation403Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewExchangeValidation409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetExchangeValidationParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "runId": zod.uuid()
}))()






export const GetExchangeValidation200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "revision": zod.int().min(1),
  "phase": zod.enum(['preview', 'creating', 'create_unknown', 'created', 'updating', 'update_unknown', 'updated', 'cancelling', 'cancel_unknown', 'cleaned']),
  "connectionRevision": zod.int().min(1),
  "connectionVersion": zod.int().min(1),
  "organizer": zod.email(),
  "roomMailbox": zod.email(),
  "employeeMailbox": zod.email().nullable(),
  "subject": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "updatedEnd": zod.iso.datetime({"offset":true}),
  "eventId": zod.string().nullable(),
  "roomResponse": zod.string(),
  "createVerified": zod.boolean(),
  "updateVerified": zod.boolean(),
  "cleanupEvidence": zod.string().nullable(),
  "failureCode": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const GetExchangeValidation400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetExchangeValidation403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetExchangeValidation409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ActExchangeValidationParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "runId": zod.uuid()
}))()




export const ActExchangeValidationBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1),
  "action": zod.enum(['confirm', 'update', 'cancel', 'reconcile'])
}))()






export const ActExchangeValidation200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "revision": zod.int().min(1),
  "phase": zod.enum(['preview', 'creating', 'create_unknown', 'created', 'updating', 'update_unknown', 'updated', 'cancelling', 'cancel_unknown', 'cleaned']),
  "connectionRevision": zod.int().min(1),
  "connectionVersion": zod.int().min(1),
  "organizer": zod.email(),
  "roomMailbox": zod.email(),
  "employeeMailbox": zod.email().nullable(),
  "subject": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "updatedEnd": zod.iso.datetime({"offset":true}),
  "eventId": zod.string().nullable(),
  "roomResponse": zod.string(),
  "createVerified": zod.boolean(),
  "updateVerified": zod.boolean(),
  "cleanupEvidence": zod.string().nullable(),
  "failureCode": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const ActExchangeValidation400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ActExchangeValidation403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ActExchangeValidation409Response = /*#__PURE__*/ (() => zod.unknown())()


export const DiscoverExchangeRoomsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const DiscoverExchangeRoomsQueryParams = /*#__PURE__*/ (() => zod.object({
  "cursor": zod.uuid().optional()
}))()

export const discoverExchangeRooms200ResponseItemsMax = 100;

export const discoverExchangeRooms200ResponseLimitMax = 100;



export const DiscoverExchangeRooms200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string().nullable(),
  "emailAddress": zod.string().nullable(),
  "capacity": zod.int().nullable(),
  "building": zod.string().nullable(),
  "floorLabel": zod.string().nullable(),
  "tags": zod.array(zod.string())
})).max(discoverExchangeRooms200ResponseItemsMax),
  "nextCursor": zod.uuid().nullable(),
  "limit": zod.int().min(1).max(discoverExchangeRooms200ResponseLimitMax)
}))()


export const ListExchangeMappingChoicesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listExchangeMappingChoicesQueryLimitDefault = 25;
export const listExchangeMappingChoicesQueryLimitMax = 25;

export const listExchangeMappingChoicesQueryOffsetDefault = 0;
export const listExchangeMappingChoicesQueryOffsetMin = 0;
export const listExchangeMappingChoicesQueryOffsetMax = 100000;



export const ListExchangeMappingChoicesQueryParams = /*#__PURE__*/ (() => zod.object({
  "kind": zod.enum(['space', 'zone', 'type']),
  "limit": zod.int().min(1).max(listExchangeMappingChoicesQueryLimitMax).default(listExchangeMappingChoicesQueryLimitDefault),
  "offset": zod.int().min(listExchangeMappingChoicesQueryOffsetMin).max(listExchangeMappingChoicesQueryOffsetMax).default(listExchangeMappingChoicesQueryOffsetDefault)
}))()

export const listExchangeMappingChoices200ResponseItemsMax = 25;

export const listExchangeMappingChoices200ResponseTotalMin = 0;

export const listExchangeMappingChoices200ResponseLimitMax = 25;

export const listExchangeMappingChoices200ResponseOffsetMin = 0;



export const ListExchangeMappingChoices200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string()
})).max(listExchangeMappingChoices200ResponseItemsMax),
  "total": zod.int().min(listExchangeMappingChoices200ResponseTotalMin),
  "limit": zod.int().min(1).max(listExchangeMappingChoices200ResponseLimitMax),
  "offset": zod.int().min(listExchangeMappingChoices200ResponseOffsetMin),
  "kind": zod.enum(['space', 'zone', 'type'])
}))()


export const PreviewExchangeMappingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const previewExchangeMappingBodyRoomIdMax = 512;

export const previewExchangeMappingBodyTargetTwoCodeMax = 64;

export const previewExchangeMappingBodyTargetTwoNameMax = 200;



export const PreviewExchangeMappingBody = /*#__PURE__*/ (() => zod.object({
  "roomId": zod.string().min(1).max(previewExchangeMappingBodyRoomIdMax),
  "cursor": zod.uuid().optional(),
  "target": zod.union([zod.object({
  "kind": zod.enum(['link']),
  "spaceId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['import']),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string().min(1).max(previewExchangeMappingBodyTargetTwoCodeMax),
  "name": zod.string().min(1).max(previewExchangeMappingBodyTargetTwoNameMax)
})])
}))()

export const PreviewExchangeMapping200Response = /*#__PURE__*/ (() => zod.object({
  "reviewId": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "label": zod.string(),
  "mailbox": zod.email(),
  "kind": zod.enum(['link', 'import']),
  "summary": zod.string()
}))()


export const ConfirmExchangeMappingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const ConfirmExchangeMappingBody = /*#__PURE__*/ (() => zod.object({
  "reviewId": zod.uuid()
}))()

export const ConfirmExchangeMapping200Response = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "reviewId": zod.uuid()
}))()


export const ListTenantExchangeSyncsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listTenantExchangeSyncsQueryLimitDefault = 25;
export const listTenantExchangeSyncsQueryLimitMax = 25;

export const listTenantExchangeSyncsQueryOffsetDefault = 0;
export const listTenantExchangeSyncsQueryOffsetMin = 0;
export const listTenantExchangeSyncsQueryOffsetMax = 100000;



export const ListTenantExchangeSyncsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listTenantExchangeSyncsQueryLimitMax).default(listTenantExchangeSyncsQueryLimitDefault),
  "offset": zod.int().min(listTenantExchangeSyncsQueryOffsetMin).max(listTenantExchangeSyncsQueryOffsetMax).default(listTenantExchangeSyncsQueryOffsetDefault)
}))()

export const listTenantExchangeSyncs200ResponseItemsItemRevisionMin = 0;
export const listTenantExchangeSyncs200ResponseItemsItemRevisionMax = 2147483646;

export const listTenantExchangeSyncs200ResponseItemsItemPendingWindowsMin = 0;
export const listTenantExchangeSyncs200ResponseItemsItemPendingWindowsMax = 3100;

export const listTenantExchangeSyncs200ResponseItemsItemConflictCountMin = 0;
export const listTenantExchangeSyncs200ResponseItemsItemConflictCountMax = 2147483646;

export const listTenantExchangeSyncs200ResponseItemsMax = 25;

export const listTenantExchangeSyncs200ResponseTotalMin = 0;
export const listTenantExchangeSyncs200ResponseTotalMax = 2147483646;

export const listTenantExchangeSyncs200ResponseLimitMax = 25;

export const listTenantExchangeSyncs200ResponseOffsetMin = 0;
export const listTenantExchangeSyncs200ResponseOffsetMax = 100000;



export const ListTenantExchangeSyncs200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "revision": zod.int().min(listTenantExchangeSyncs200ResponseItemsItemRevisionMin).max(listTenantExchangeSyncs200ResponseItemsItemRevisionMax),
  "enabled": zod.boolean(),
  "state": zod.enum(['disabled', 'incomplete', 'current', 'stale', 'throttled', 'failed', 'unavailable']),
  "coverageStart": zod.iso.datetime({"offset":true}).nullable(),
  "coverageEnd": zod.iso.datetime({"offset":true}).nullable(),
  "lastSucceededAt": zod.iso.datetime({"offset":true}).nullable(),
  "pendingWindows": zod.int().min(listTenantExchangeSyncs200ResponseItemsItemPendingWindowsMin).max(listTenantExchangeSyncs200ResponseItemsItemPendingWindowsMax),
  "conflictCount": zod.int().min(listTenantExchangeSyncs200ResponseItemsItemConflictCountMin).max(listTenantExchangeSyncs200ResponseItemsItemConflictCountMax),
  "calendarRead": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}).optional()
})).max(listTenantExchangeSyncs200ResponseItemsMax),
  "total": zod.int().min(listTenantExchangeSyncs200ResponseTotalMin).max(listTenantExchangeSyncs200ResponseTotalMax),
  "limit": zod.int().min(1).max(listTenantExchangeSyncs200ResponseLimitMax),
  "offset": zod.int().min(listTenantExchangeSyncs200ResponseOffsetMin).max(listTenantExchangeSyncs200ResponseOffsetMax)
}))()


export const ChangeTenantExchangeSyncParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const changeTenantExchangeSyncBodyExpectedRevisionMin = 0;
export const changeTenantExchangeSyncBodyExpectedRevisionMax = 2147483646;

export const changeTenantExchangeSyncBodyExpectedConnectionRevisionMax = 2147483646;



export const ChangeTenantExchangeSyncBody = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "action": zod.enum(['enable', 'disable', 'refresh']),
  "expectedRevision": zod.int().min(changeTenantExchangeSyncBodyExpectedRevisionMin).max(changeTenantExchangeSyncBodyExpectedRevisionMax),
  "expectedConnectionRevision": zod.int().min(1).max(changeTenantExchangeSyncBodyExpectedConnectionRevisionMax),
  "confirmed": zod.literal(true)
}))()

export const changeTenantExchangeSync200ResponseRevisionMax = 2147483646;



export const ChangeTenantExchangeSync200Response = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "revision": zod.int().min(1).max(changeTenantExchangeSync200ResponseRevisionMax),
  "enabled": zod.boolean(),
  "state": zod.enum(['disabled', 'pending'])
}))()


export const ListIncomingFloorBusyParams = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid()
}))()

export const listIncomingFloorBusyQueryLimitDefault = 25;
export const listIncomingFloorBusyQueryLimitMax = 25;

export const listIncomingFloorBusyQueryOffsetDefault = 0;
export const listIncomingFloorBusyQueryOffsetMin = 0;
export const listIncomingFloorBusyQueryOffsetMax = 100000;



export const ListIncomingFloorBusyQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "limit": zod.int().min(1).max(listIncomingFloorBusyQueryLimitMax).default(listIncomingFloorBusyQueryLimitDefault),
  "offset": zod.int().min(listIncomingFloorBusyQueryOffsetMin).max(listIncomingFloorBusyQueryOffsetMax).default(listIncomingFloorBusyQueryOffsetDefault)
}))()

export const listIncomingFloorBusy200ResponseItemsItemMirrorExternalBusyMax = 10000;

export const listIncomingFloorBusy200ResponseItemsMax = 25;

export const listIncomingFloorBusy200ResponseTotalMin = 0;
export const listIncomingFloorBusy200ResponseTotalMax = 2147483646;

export const listIncomingFloorBusy200ResponseLimitMax = 25;

export const listIncomingFloorBusy200ResponseOffsetMin = 0;
export const listIncomingFloorBusy200ResponseOffsetMax = 100000;



export const ListIncomingFloorBusy200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "mirror": zod.object({
  "state": zod.enum(['disabled', 'incomplete', 'current', 'stale', 'throttled', 'failed', 'unavailable']),
  "covered": zod.boolean(),
  "lastSucceededAt": zod.iso.datetime({"offset":true}).nullable(),
  "externalBusy": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
})).max(listIncomingFloorBusy200ResponseItemsItemMirrorExternalBusyMax)
})
})).max(listIncomingFloorBusy200ResponseItemsMax),
  "total": zod.int().min(listIncomingFloorBusy200ResponseTotalMin).max(listIncomingFloorBusy200ResponseTotalMax),
  "limit": zod.int().min(1).max(listIncomingFloorBusy200ResponseLimitMax),
  "offset": zod.int().min(listIncomingFloorBusy200ResponseOffsetMin).max(listIncomingFloorBusy200ResponseOffsetMax)
}))()


/**
 * No browser calendar token or arbitrary mailbox access. The separate request-local group credential preserves current admission checks. Unconfirmed reads remain app-only and do not establish write permission.
 * @summary Read free/busy for persisted Exchange rooms in the selected entity
 */
export const readTenantRoomSchedulesHeaderXGroupGraphTokenMax = 16384;


export const readTenantRoomSchedulesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ReadTenantRoomSchedulesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(readTenantRoomSchedulesHeaderXGroupGraphTokenMax).regex(readTenantRoomSchedulesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const readTenantRoomSchedulesBodyMailboxesItemMax = 320;

export const readTenantRoomSchedulesBodyMailboxesMax = 20;



export const ReadTenantRoomSchedulesBody = /*#__PURE__*/ (() => zod.object({
  "entityId": zod.uuid(),
  "mailboxes": zod.array(zod.email().max(readTenantRoomSchedulesBodyMailboxesItemMax)).min(1).max(readTenantRoomSchedulesBodyMailboxesMax),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))()

export const readTenantRoomSchedules200ResponseItemsItemMirrorExternalBusyMax = 10000;

export const readTenantRoomSchedules200ResponseItemsMax = 20;



export const ReadTenantRoomSchedules200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "mailbox": zod.email(),
  "confirmed": zod.boolean(),
  "source": zod.enum(['live', 'mirror', 'unconfirmed']).optional(),
  "busy": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
})),
  "mirror": zod.object({
  "state": zod.enum(['disabled', 'incomplete', 'current', 'stale', 'throttled', 'failed', 'unavailable']),
  "covered": zod.boolean(),
  "lastSucceededAt": zod.iso.datetime({"offset":true}).nullable(),
  "externalBusy": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
})).max(readTenantRoomSchedules200ResponseItemsItemMirrorExternalBusyMax)
}).optional()
})).max(readTenantRoomSchedules200ResponseItemsMax)
}))()

export const ReadTenantRoomSchedules403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ReadTenantRoomSchedules409Response = /*#__PURE__*/ (() => zod.unknown())()


export const getTenantExchangeDiagnosticsPathTenantSlugMax = 200;



export const GetTenantExchangeDiagnosticsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(getTenantExchangeDiagnosticsPathTenantSlugMax)
}))()

export const getTenantExchangeDiagnostics200ResponseVersionMax = 2147483646;

export const getTenantExchangeDiagnostics200ResponseRevisionMax = 2147483646;



export const GetTenantExchangeDiagnostics200Response = /*#__PURE__*/ (() => zod.object({
  "connectionId": zod.uuid().nullable(),
  "version": zod.int().min(1).max(getTenantExchangeDiagnostics200ResponseVersionMax).nullable(),
  "revision": zod.int().min(1).max(getTenantExchangeDiagnostics200ResponseRevisionMax).nullable(),
  "selected": zod.boolean(),
  "reason": zod.string(),
  "checks": zod.object({
  "token": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "discovery": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "organizerRead": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "availability": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
})
}),
  "bookingWrites": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "roomAcceptance": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
})
}))()

export const GetTenantExchangeDiagnostics403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantExchangeDiagnostics409Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantExchangeDiagnostics503Response = /*#__PURE__*/ (() => zod.unknown())()


export const checkTenantExchangeReadsPathTenantSlugMax = 200;



export const CheckTenantExchangeReadsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(checkTenantExchangeReadsPathTenantSlugMax)
}))()

export const checkTenantExchangeReadsBodyExpectedRevisionMin = 0;
export const checkTenantExchangeReadsBodyExpectedRevisionMax = 2147483646;

export const checkTenantExchangeReadsBodyVersionMax = 2147483646;



export const CheckTenantExchangeReadsBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(checkTenantExchangeReadsBodyExpectedRevisionMin).max(checkTenantExchangeReadsBodyExpectedRevisionMax),
  "version": zod.int().min(1).max(checkTenantExchangeReadsBodyVersionMax)
}))()

export const checkTenantExchangeReads200ResponseVersionMax = 2147483646;

export const checkTenantExchangeReads200ResponseRevisionMax = 2147483646;



export const CheckTenantExchangeReads200Response = /*#__PURE__*/ (() => zod.object({
  "connectionId": zod.uuid().nullable(),
  "version": zod.int().min(1).max(checkTenantExchangeReads200ResponseVersionMax).nullable(),
  "revision": zod.int().min(1).max(checkTenantExchangeReads200ResponseRevisionMax).nullable(),
  "selected": zod.boolean(),
  "reason": zod.string(),
  "checks": zod.object({
  "token": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "discovery": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "organizerRead": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "availability": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
})
}),
  "bookingWrites": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "roomAcceptance": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
})
}))()

export const CheckTenantExchangeReads403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CheckTenantExchangeReads409Response = /*#__PURE__*/ (() => zod.unknown())()

export const CheckTenantExchangeReads503Response = /*#__PURE__*/ (() => zod.unknown())()


export const listTenantExchangeRoomsPathTenantSlugMax = 200;



export const ListTenantExchangeRoomsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(listTenantExchangeRoomsPathTenantSlugMax)
}))()

export const listTenantExchangeRoomsQueryLimitDefault = 25;
export const listTenantExchangeRoomsQueryLimitMax = 100;



export const ListTenantExchangeRoomsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listTenantExchangeRoomsQueryLimitMax).default(listTenantExchangeRoomsQueryLimitDefault),
  "cursor": zod.uuid().optional()
}))()

export const listTenantExchangeRooms200ResponseItemsMax = 100;

export const listTenantExchangeRooms200ResponseLimitMax = 100;



export const ListTenantExchangeRooms200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string().nullable(),
  "emailAddress": zod.string().nullable(),
  "capacity": zod.int().nullable(),
  "building": zod.string().nullable(),
  "floorLabel": zod.string().nullable(),
  "tags": zod.array(zod.string())
})).max(listTenantExchangeRooms200ResponseItemsMax),
  "nextCursor": zod.uuid().nullable(),
  "limit": zod.int().min(1).max(listTenantExchangeRooms200ResponseLimitMax)
}))()

export const ListTenantExchangeRooms403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantExchangeRooms409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantExchangeRooms503Response = /*#__PURE__*/ (() => zod.unknown())()


export const checkTenantExchangeAvailabilityPathTenantSlugMax = 200;



export const CheckTenantExchangeAvailabilityParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(checkTenantExchangeAvailabilityPathTenantSlugMax)
}))()

export const checkTenantExchangeAvailabilityBodyExpectedRevisionMin = 0;
export const checkTenantExchangeAvailabilityBodyExpectedRevisionMax = 2147483646;

export const checkTenantExchangeAvailabilityBodyVersionMax = 2147483646;



export const CheckTenantExchangeAvailabilityBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(checkTenantExchangeAvailabilityBodyExpectedRevisionMin).max(checkTenantExchangeAvailabilityBodyExpectedRevisionMax),
  "version": zod.int().min(1).max(checkTenantExchangeAvailabilityBodyVersionMax),
  "spaceId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))()

export const checkTenantExchangeAvailability200ResponseVersionMax = 2147483646;

export const checkTenantExchangeAvailability200ResponseRevisionMax = 2147483646;



export const CheckTenantExchangeAvailability200Response = /*#__PURE__*/ (() => zod.object({
  "connectionId": zod.uuid().nullable(),
  "version": zod.int().min(1).max(checkTenantExchangeAvailability200ResponseVersionMax).nullable(),
  "revision": zod.int().min(1).max(checkTenantExchangeAvailability200ResponseRevisionMax).nullable(),
  "selected": zod.boolean(),
  "reason": zod.string(),
  "checks": zod.object({
  "token": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "discovery": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "organizerRead": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "availability": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
})
}),
  "bookingWrites": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "roomAcceptance": zod.object({
  "state": zod.enum(['unverified', 'succeeded', 'failed']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "code": zod.string().nullable()
}),
  "availabilityConfirmed": zod.boolean(),
  "spaceId": zod.uuid(),
  "busy": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))
}))()

export const CheckTenantExchangeAvailability403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CheckTenantExchangeAvailability409Response = /*#__PURE__*/ (() => zod.unknown())()

export const CheckTenantExchangeAvailability503Response = /*#__PURE__*/ (() => zod.unknown())()


export const getTenantExchangeConnectionPathTenantSlugMax = 200;



export const GetTenantExchangeConnectionParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(getTenantExchangeConnectionPathTenantSlugMax)
}))()

export const getTenantExchangeConnection200ResponseRevisionMin = 0;
export const getTenantExchangeConnection200ResponseRevisionMax = 2147483646;

export const getTenantExchangeConnection200ResponseActiveVersionMin = 0;
export const getTenantExchangeConnection200ResponseActiveVersionMax = 2147483646;

export const getTenantExchangeConnection200ResponseLatestOneVersionMax = 2147483646;

export const getTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax = 254;

export const getTenantExchangeConnection200ResponseImpactTrackedBookingsMin = 0;

export const getTenantExchangeConnection200ResponseImpactPendingMovesMin = 0;

export const getTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin = 0;

export const getTenantExchangeConnection200ResponseImpactTrackedTestsMin = 0;

export const getTenantExchangeConnection200ResponseImpactOutstandingTestsMin = 0;



export const GetTenantExchangeConnection200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getTenantExchangeConnection200ResponseRevisionMin).max(getTenantExchangeConnection200ResponseRevisionMax),
  "state": zod.enum(['unconfigured', 'draft', 'active', 'disabled', 'requires_reconfiguration']),
  "activeVersion": zod.int().min(getTenantExchangeConnection200ResponseActiveVersionMin).max(getTenantExchangeConnection200ResponseActiveVersionMax).nullable(),
  "latest": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1).max(getTenantExchangeConnection200ResponseLatestOneVersionMax),
  "microsoftTenantId": zod.uuid(),
  "clientId": zod.uuid(),
  "organizerMailbox": zod.email().max(getTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax),
  "secretPresent": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "keyReady": zod.boolean(),
  "verification": zod.enum(['unverified']),
  "impact": zod.object({
  "trackedBookings": zod.int().min(getTenantExchangeConnection200ResponseImpactTrackedBookingsMin),
  "pendingMoves": zod.int().min(getTenantExchangeConnection200ResponseImpactPendingMovesMin),
  "unverifiedLegacyBookings": zod.int().min(getTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin),
  "trackedTests": zod.int().min(getTenantExchangeConnection200ResponseImpactTrackedTestsMin).optional(),
  "outstandingTests": zod.int().min(getTenantExchangeConnection200ResponseImpactOutstandingTestsMin).optional(),
  "credentialRetirementAllowed": zod.literal(false)
}).optional()
}))()

export const GetTenantExchangeConnection403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantExchangeConnection409Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantExchangeConnection503Response = /*#__PURE__*/ (() => zod.unknown())()


export const saveTenantExchangeConnectionPathTenantSlugMax = 200;



export const SaveTenantExchangeConnectionParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(saveTenantExchangeConnectionPathTenantSlugMax)
}))()

export const saveTenantExchangeConnectionBodyExpectedRevisionMin = 0;
export const saveTenantExchangeConnectionBodyExpectedRevisionMax = 2147483646;

export const saveTenantExchangeConnectionBodyOrganizerMailboxMax = 254;

export const saveTenantExchangeConnectionBodyClientSecretMax = 4096;



export const SaveTenantExchangeConnectionBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveTenantExchangeConnectionBodyExpectedRevisionMin).max(saveTenantExchangeConnectionBodyExpectedRevisionMax),
  "microsoftTenantId": zod.uuid(),
  "clientId": zod.uuid(),
  "organizerMailbox": zod.email().max(saveTenantExchangeConnectionBodyOrganizerMailboxMax),
  "clientSecret": zod.string().min(1).max(saveTenantExchangeConnectionBodyClientSecretMax).optional()
}))()

export const saveTenantExchangeConnection200ResponseRevisionMin = 0;
export const saveTenantExchangeConnection200ResponseRevisionMax = 2147483646;

export const saveTenantExchangeConnection200ResponseActiveVersionMin = 0;
export const saveTenantExchangeConnection200ResponseActiveVersionMax = 2147483646;

export const saveTenantExchangeConnection200ResponseLatestOneVersionMax = 2147483646;

export const saveTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax = 254;

export const saveTenantExchangeConnection200ResponseImpactTrackedBookingsMin = 0;

export const saveTenantExchangeConnection200ResponseImpactPendingMovesMin = 0;

export const saveTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin = 0;

export const saveTenantExchangeConnection200ResponseImpactTrackedTestsMin = 0;

export const saveTenantExchangeConnection200ResponseImpactOutstandingTestsMin = 0;



export const SaveTenantExchangeConnection200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(saveTenantExchangeConnection200ResponseRevisionMin).max(saveTenantExchangeConnection200ResponseRevisionMax),
  "state": zod.enum(['unconfigured', 'draft', 'active', 'disabled', 'requires_reconfiguration']),
  "activeVersion": zod.int().min(saveTenantExchangeConnection200ResponseActiveVersionMin).max(saveTenantExchangeConnection200ResponseActiveVersionMax).nullable(),
  "latest": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1).max(saveTenantExchangeConnection200ResponseLatestOneVersionMax),
  "microsoftTenantId": zod.uuid(),
  "clientId": zod.uuid(),
  "organizerMailbox": zod.email().max(saveTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax),
  "secretPresent": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "keyReady": zod.boolean(),
  "verification": zod.enum(['unverified']),
  "impact": zod.object({
  "trackedBookings": zod.int().min(saveTenantExchangeConnection200ResponseImpactTrackedBookingsMin),
  "pendingMoves": zod.int().min(saveTenantExchangeConnection200ResponseImpactPendingMovesMin),
  "unverifiedLegacyBookings": zod.int().min(saveTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin),
  "trackedTests": zod.int().min(saveTenantExchangeConnection200ResponseImpactTrackedTestsMin).optional(),
  "outstandingTests": zod.int().min(saveTenantExchangeConnection200ResponseImpactOutstandingTestsMin).optional(),
  "credentialRetirementAllowed": zod.literal(false)
}).optional()
}))()

export const SaveTenantExchangeConnection403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveTenantExchangeConnection409Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveTenantExchangeConnection503Response = /*#__PURE__*/ (() => zod.unknown())()


export const changeTenantExchangeConnectionPathTenantSlugMax = 200;



export const ChangeTenantExchangeConnectionParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(changeTenantExchangeConnectionPathTenantSlugMax)
}))()

export const changeTenantExchangeConnectionBodyExpectedRevisionMin = 0;
export const changeTenantExchangeConnectionBodyExpectedRevisionMax = 2147483646;

export const changeTenantExchangeConnectionBodyVersionMax = 2147483646;



export const ChangeTenantExchangeConnectionBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(changeTenantExchangeConnectionBodyExpectedRevisionMin).max(changeTenantExchangeConnectionBodyExpectedRevisionMax),
  "version": zod.int().min(1).max(changeTenantExchangeConnectionBodyVersionMax).optional(),
  "action": zod.enum(['activate', 'disable'])
}))()

export const changeTenantExchangeConnection200ResponseRevisionMin = 0;
export const changeTenantExchangeConnection200ResponseRevisionMax = 2147483646;

export const changeTenantExchangeConnection200ResponseActiveVersionMin = 0;
export const changeTenantExchangeConnection200ResponseActiveVersionMax = 2147483646;

export const changeTenantExchangeConnection200ResponseLatestOneVersionMax = 2147483646;

export const changeTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax = 254;

export const changeTenantExchangeConnection200ResponseImpactTrackedBookingsMin = 0;

export const changeTenantExchangeConnection200ResponseImpactPendingMovesMin = 0;

export const changeTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin = 0;

export const changeTenantExchangeConnection200ResponseImpactTrackedTestsMin = 0;

export const changeTenantExchangeConnection200ResponseImpactOutstandingTestsMin = 0;



export const ChangeTenantExchangeConnection200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(changeTenantExchangeConnection200ResponseRevisionMin).max(changeTenantExchangeConnection200ResponseRevisionMax),
  "state": zod.enum(['unconfigured', 'draft', 'active', 'disabled', 'requires_reconfiguration']),
  "activeVersion": zod.int().min(changeTenantExchangeConnection200ResponseActiveVersionMin).max(changeTenantExchangeConnection200ResponseActiveVersionMax).nullable(),
  "latest": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1).max(changeTenantExchangeConnection200ResponseLatestOneVersionMax),
  "microsoftTenantId": zod.uuid(),
  "clientId": zod.uuid(),
  "organizerMailbox": zod.email().max(changeTenantExchangeConnection200ResponseLatestOneOrganizerMailboxMax),
  "secretPresent": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "keyReady": zod.boolean(),
  "verification": zod.enum(['unverified']),
  "impact": zod.object({
  "trackedBookings": zod.int().min(changeTenantExchangeConnection200ResponseImpactTrackedBookingsMin),
  "pendingMoves": zod.int().min(changeTenantExchangeConnection200ResponseImpactPendingMovesMin),
  "unverifiedLegacyBookings": zod.int().min(changeTenantExchangeConnection200ResponseImpactUnverifiedLegacyBookingsMin),
  "trackedTests": zod.int().min(changeTenantExchangeConnection200ResponseImpactTrackedTestsMin).optional(),
  "outstandingTests": zod.int().min(changeTenantExchangeConnection200ResponseImpactOutstandingTestsMin).optional(),
  "credentialRetirementAllowed": zod.literal(false)
}).optional()
}))()

export const ChangeTenantExchangeConnection403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ChangeTenantExchangeConnection409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ChangeTenantExchangeConnection503Response = /*#__PURE__*/ (() => zod.unknown())()


export const listTenantExchangeVersionsPathTenantSlugMax = 200;



export const ListTenantExchangeVersionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(listTenantExchangeVersionsPathTenantSlugMax)
}))()

export const listTenantExchangeVersionsQueryLimitDefault = 25;
export const listTenantExchangeVersionsQueryLimitMax = 100;

export const listTenantExchangeVersionsQueryOffsetDefault = 0;
export const listTenantExchangeVersionsQueryOffsetMin = 0;
export const listTenantExchangeVersionsQueryOffsetMax = 10000;



export const ListTenantExchangeVersionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listTenantExchangeVersionsQueryLimitMax).default(listTenantExchangeVersionsQueryLimitDefault),
  "offset": zod.int().min(listTenantExchangeVersionsQueryOffsetMin).max(listTenantExchangeVersionsQueryOffsetMax).default(listTenantExchangeVersionsQueryOffsetDefault)
}))()

export const listTenantExchangeVersions200ResponseItemsItemVersionMax = 2147483646;

export const listTenantExchangeVersions200ResponseItemsItemOrganizerMailboxMax = 254;

export const listTenantExchangeVersions200ResponseItemsMax = 100;



export const ListTenantExchangeVersions200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1).max(listTenantExchangeVersions200ResponseItemsItemVersionMax),
  "microsoftTenantId": zod.uuid(),
  "clientId": zod.uuid(),
  "organizerMailbox": zod.email().max(listTenantExchangeVersions200ResponseItemsItemOrganizerMailboxMax),
  "secretPresent": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listTenantExchangeVersions200ResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const ListTenantExchangeVersions403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantExchangeVersions409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantExchangeVersions503Response = /*#__PURE__*/ (() => zod.unknown())()


export const listCapacityScenarioSitesQueryLimitDefault = 25;
export const listCapacityScenarioSitesQueryLimitMax = 100;

export const listCapacityScenarioSitesQueryOffsetDefault = 0;
export const listCapacityScenarioSitesQueryOffsetMin = 0;
export const listCapacityScenarioSitesQueryOffsetMax = 10000;



export const ListCapacityScenarioSitesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listCapacityScenarioSitesQueryLimitMax).default(listCapacityScenarioSitesQueryLimitDefault),
  "offset": zod.int().min(listCapacityScenarioSitesQueryOffsetMin).max(listCapacityScenarioSitesQueryOffsetMax).default(listCapacityScenarioSitesQueryOffsetDefault)
}))()

export const listCapacityScenarioSitesHeaderXGroupGraphTokenMax = 16384;


export const listCapacityScenarioSitesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListCapacityScenarioSitesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listCapacityScenarioSitesHeaderXGroupGraphTokenMax).regex(listCapacityScenarioSitesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listCapacityScenarioSites200ResponseTotalMin = 0;

export const listCapacityScenarioSites200ResponseLimitMin = 0;

export const listCapacityScenarioSites200ResponseOffsetMin = 0;



export const ListCapacityScenarioSites200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "timezone": zod.string()
})),
  "total": zod.int().min(listCapacityScenarioSites200ResponseTotalMin),
  "limit": zod.int().min(listCapacityScenarioSites200ResponseLimitMin),
  "offset": zod.int().min(listCapacityScenarioSites200ResponseOffsetMin)
}))()

export const ListCapacityScenarioSites403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListCapacityScenarioSites409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listCapacityScenariosQueryLimitDefault = 25;
export const listCapacityScenariosQueryLimitMax = 100;

export const listCapacityScenariosQueryOffsetDefault = 0;
export const listCapacityScenariosQueryOffsetMin = 0;
export const listCapacityScenariosQueryOffsetMax = 10000;



export const ListCapacityScenariosQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listCapacityScenariosQueryLimitMax).default(listCapacityScenariosQueryLimitDefault),
  "offset": zod.int().min(listCapacityScenariosQueryOffsetMin).max(listCapacityScenariosQueryOffsetMax).default(listCapacityScenariosQueryOffsetDefault)
}))()

export const listCapacityScenariosHeaderXGroupGraphTokenMax = 16384;


export const listCapacityScenariosHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListCapacityScenariosHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listCapacityScenariosHeaderXGroupGraphTokenMax).regex(listCapacityScenariosHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listCapacityScenarios200ResponseTotalMin = 0;

export const listCapacityScenarios200ResponseLimitMin = 0;

export const listCapacityScenarios200ResponseOffsetMin = 0;



export const ListCapacityScenarios200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "siteId": zod.uuid(),
  "shared": zod.boolean(),
  "revision": zod.int().min(1),
  "canEdit": zod.boolean(),
  "updatedAt": zod.string()
})),
  "total": zod.int().min(listCapacityScenarios200ResponseTotalMin),
  "limit": zod.int().min(listCapacityScenarios200ResponseLimitMin),
  "offset": zod.int().min(listCapacityScenarios200ResponseOffsetMin)
}))()

export const ListCapacityScenarios403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListCapacityScenarios409Response = /*#__PURE__*/ (() => zod.unknown())()


export const createCapacityScenarioHeaderXGroupGraphTokenMax = 16384;


export const createCapacityScenarioHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateCapacityScenarioHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createCapacityScenarioHeaderXGroupGraphTokenMax).regex(createCapacityScenarioHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createCapacityScenarioBodyInputNameMax = 120;

export const createCapacityScenarioBodyInputStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputAssumptionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputAssumptionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputAssumptionsItemStaffingMin = 0;
export const createCapacityScenarioBodyInputAssumptionsItemStaffingMax = 1000000;

export const createCapacityScenarioBodyInputAssumptionsItemFractionMin = 0;
export const createCapacityScenarioBodyInputAssumptionsItemFractionMax = 1;

export const createCapacityScenarioBodyInputAssumptionsItemAttendanceCountMin = 0;
export const createCapacityScenarioBodyInputAssumptionsItemAttendanceCountMax = 1000000;

export const createCapacityScenarioBodyInputAssumptionsMax = 100;

export const createCapacityScenarioBodyInputExclusionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputExclusionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const createCapacityScenarioBodyInputExclusionsItemReasonMin = 3;
export const createCapacityScenarioBodyInputExclusionsItemReasonMax = 300;

export const createCapacityScenarioBodyInputExclusionsMax = 100;




export const CreateCapacityScenarioBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "input": zod.object({
  "name": zod.string().min(1).max(createCapacityScenarioBodyInputNameMax),
  "siteId": zod.uuid(),
  "startLocal": zod.string().regex(createCapacityScenarioBodyInputStartLocalRegExp),
  "endLocal": zod.string().regex(createCapacityScenarioBodyInputEndLocalRegExp),
  "assumptions": zod.array(zod.object({
  "startLocal": zod.string().regex(createCapacityScenarioBodyInputAssumptionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(createCapacityScenarioBodyInputAssumptionsItemEndLocalRegExp),
  "staffing": zod.number().min(createCapacityScenarioBodyInputAssumptionsItemStaffingMin).max(createCapacityScenarioBodyInputAssumptionsItemStaffingMax).nullable(),
  "fraction": zod.number().min(createCapacityScenarioBodyInputAssumptionsItemFractionMin).max(createCapacityScenarioBodyInputAssumptionsItemFractionMax).nullable(),
  "attendanceCount": zod.number().min(createCapacityScenarioBodyInputAssumptionsItemAttendanceCountMin).max(createCapacityScenarioBodyInputAssumptionsItemAttendanceCountMax).nullable()
})).max(createCapacityScenarioBodyInputAssumptionsMax),
  "exclusions": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "startLocal": zod.string().regex(createCapacityScenarioBodyInputExclusionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(createCapacityScenarioBodyInputExclusionsItemEndLocalRegExp),
  "reason": zod.string().min(createCapacityScenarioBodyInputExclusionsItemReasonMin).max(createCapacityScenarioBodyInputExclusionsItemReasonMax)
})).max(createCapacityScenarioBodyInputExclusionsMax),
  "baselineScenarioId": zod.uuid().nullable(),
  "baselineRevision": zod.int().min(1).nullable()
})
}))()




export const CreateCapacityScenario200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "siteId": zod.uuid(),
  "shared": zod.boolean(),
  "revision": zod.int().min(1),
  "canEdit": zod.boolean(),
  "updatedAt": zod.string()
}))()

export const CreateCapacityScenario403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateCapacityScenario409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetCapacityScenarioParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getCapacityScenarioQueryLimitDefault = 25;
export const getCapacityScenarioQueryLimitMax = 100;

export const getCapacityScenarioQueryOffsetDefault = 0;
export const getCapacityScenarioQueryOffsetMin = 0;
export const getCapacityScenarioQueryOffsetMax = 10000;

export const getCapacityScenarioQueryRevisionMax = 100;



export const GetCapacityScenarioQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getCapacityScenarioQueryLimitMax).default(getCapacityScenarioQueryLimitDefault),
  "offset": zod.int().min(getCapacityScenarioQueryOffsetMin).max(getCapacityScenarioQueryOffsetMax).default(getCapacityScenarioQueryOffsetDefault),
  "revision": zod.int().min(1).max(getCapacityScenarioQueryRevisionMax).optional()
}))()

export const getCapacityScenarioHeaderXGroupGraphTokenMax = 16384;


export const getCapacityScenarioHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetCapacityScenarioHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getCapacityScenarioHeaderXGroupGraphTokenMax).regex(getCapacityScenarioHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getCapacityScenario200ResponseVersionMin = 0;

export const getCapacityScenario200ResponseInputNameMax = 120;

export const getCapacityScenario200ResponseInputStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputAssumptionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputAssumptionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputAssumptionsItemStaffingMin = 0;
export const getCapacityScenario200ResponseInputAssumptionsItemStaffingMax = 1000000;

export const getCapacityScenario200ResponseInputAssumptionsItemFractionMin = 0;
export const getCapacityScenario200ResponseInputAssumptionsItemFractionMax = 1;

export const getCapacityScenario200ResponseInputAssumptionsItemAttendanceCountMin = 0;
export const getCapacityScenario200ResponseInputAssumptionsItemAttendanceCountMax = 1000000;

export const getCapacityScenario200ResponseInputAssumptionsMax = 100;

export const getCapacityScenario200ResponseInputExclusionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputExclusionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const getCapacityScenario200ResponseInputExclusionsItemReasonMin = 3;
export const getCapacityScenario200ResponseInputExclusionsItemReasonMax = 300;

export const getCapacityScenario200ResponseInputExclusionsMax = 100;


export const getCapacityScenario200ResponseEvidenceResourceCountMin = 0;

export const getCapacityScenario200ResponseSummaryKnownMinutesMin = 0;

export const getCapacityScenario200ResponseSummaryUnknownMinutesMin = 0;

export const getCapacityScenario200ResponseIntervalsItemsItemMinutesMin = 0;

export const getCapacityScenario200ResponseIntervalsItemsItemOtherUnmappedResourcesMin = 0;

export const getCapacityScenario200ResponseIntervalsTotalMin = 0;

export const getCapacityScenario200ResponseIntervalsLimitMin = 0;

export const getCapacityScenario200ResponseIntervalsOffsetMin = 0;

export const getCapacityScenario200ResponseBaselineRevisionMin = 0;

export const getCapacityScenario200ResponseVersionsItemMin = 0;



export const GetCapacityScenario200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "siteId": zod.uuid(),
  "shared": zod.boolean(),
  "revision": zod.int().min(1),
  "canEdit": zod.boolean(),
  "updatedAt": zod.string(),
  "version": zod.int().min(getCapacityScenario200ResponseVersionMin),
  "createdAt": zod.string(),
  "input": zod.object({
  "name": zod.string().min(1).max(getCapacityScenario200ResponseInputNameMax),
  "siteId": zod.uuid(),
  "startLocal": zod.string().regex(getCapacityScenario200ResponseInputStartLocalRegExp),
  "endLocal": zod.string().regex(getCapacityScenario200ResponseInputEndLocalRegExp),
  "assumptions": zod.array(zod.object({
  "startLocal": zod.string().regex(getCapacityScenario200ResponseInputAssumptionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(getCapacityScenario200ResponseInputAssumptionsItemEndLocalRegExp),
  "staffing": zod.number().min(getCapacityScenario200ResponseInputAssumptionsItemStaffingMin).max(getCapacityScenario200ResponseInputAssumptionsItemStaffingMax).nullable(),
  "fraction": zod.number().min(getCapacityScenario200ResponseInputAssumptionsItemFractionMin).max(getCapacityScenario200ResponseInputAssumptionsItemFractionMax).nullable(),
  "attendanceCount": zod.number().min(getCapacityScenario200ResponseInputAssumptionsItemAttendanceCountMin).max(getCapacityScenario200ResponseInputAssumptionsItemAttendanceCountMax).nullable()
})).max(getCapacityScenario200ResponseInputAssumptionsMax),
  "exclusions": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "startLocal": zod.string().regex(getCapacityScenario200ResponseInputExclusionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(getCapacityScenario200ResponseInputExclusionsItemEndLocalRegExp),
  "reason": zod.string().min(getCapacityScenario200ResponseInputExclusionsItemReasonMin).max(getCapacityScenario200ResponseInputExclusionsItemReasonMax)
})).max(getCapacityScenario200ResponseInputExclusionsMax),
  "baselineScenarioId": zod.uuid().nullable(),
  "baselineRevision": zod.int().min(1).nullable()
}),
  "evidence": zod.object({
  "siteName": zod.string(),
  "timezone": zod.string(),
  "start": zod.string(),
  "end": zod.string(),
  "dataAsOf": zod.string(),
  "sourceHash": zod.string(),
  "resourceCount": zod.int().min(getCapacityScenario200ResponseEvidenceResourceCountMin),
  "calculationVersion": zod.string()
}),
  "summary": zod.object({
  "knownMinutes": zod.number().min(getCapacityScenario200ResponseSummaryKnownMinutesMin),
  "unknownMinutes": zod.number().min(getCapacityScenario200ResponseSummaryUnknownMinutesMin),
  "mean": zod.object({
  "demand": zod.number().nullable(),
  "capacity": zod.number().nullable(),
  "shortage": zod.number().nullable(),
  "spare": zod.number().nullable()
}),
  "peak": zod.object({
  "demand": zod.number().nullable(),
  "capacity": zod.number().nullable(),
  "shortage": zod.number().nullable(),
  "spare": zod.number().nullable()
})
}),
  "intervals": zod.object({
  "items": zod.array(zod.object({
  "start": zod.string(),
  "end": zod.string(),
  "minutes": zod.number().min(getCapacityScenario200ResponseIntervalsItemsItemMinutesMin),
  "demand": zod.number().nullable(),
  "capacity": zod.number().nullable(),
  "shortage": zod.number().nullable(),
  "spare": zod.number().nullable(),
  "reservedDeskResources": zod.number().nullable(),
  "heldDeskResources": zod.number().nullable(),
  "provisionalDeskResources": zod.number().nullable(),
  "excludedDeskIds": zod.array(zod.uuid()),
  "other": zod.object({
  "rooms": zod.number().nullable(),
  "roomSeats": zod.number().nullable(),
  "offices": zod.number().nullable(),
  "parking": zod.number().nullable(),
  "unmappedResources": zod.number().min(getCapacityScenario200ResponseIntervalsItemsItemOtherUnmappedResourcesMin)
})
})),
  "total": zod.int().min(getCapacityScenario200ResponseIntervalsTotalMin),
  "limit": zod.int().min(getCapacityScenario200ResponseIntervalsLimitMin),
  "offset": zod.int().min(getCapacityScenario200ResponseIntervalsOffsetMin)
}),
  "baseline": zod.object({
  "scenarioId": zod.uuid(),
  "revision": zod.int().min(getCapacityScenario200ResponseBaselineRevisionMin),
  "meanDelta": zod.object({
  "demand": zod.number().nullable(),
  "capacity": zod.number().nullable(),
  "shortage": zod.number().nullable(),
  "spare": zod.number().nullable()
})
}).nullable(),
  "baselineWithheld": zod.boolean(),
  "versions": zod.array(zod.int().min(getCapacityScenario200ResponseVersionsItemMin))
}))()

export const GetCapacityScenario403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetCapacityScenario409Response = /*#__PURE__*/ (() => zod.unknown())()


export const SaveCapacityScenarioParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveCapacityScenarioHeaderXGroupGraphTokenMax = 16384;


export const saveCapacityScenarioHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveCapacityScenarioHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveCapacityScenarioHeaderXGroupGraphTokenMax).regex(saveCapacityScenarioHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const saveCapacityScenarioBodyInputNameMax = 120;

export const saveCapacityScenarioBodyInputStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputAssumptionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputAssumptionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputAssumptionsItemStaffingMin = 0;
export const saveCapacityScenarioBodyInputAssumptionsItemStaffingMax = 1000000;

export const saveCapacityScenarioBodyInputAssumptionsItemFractionMin = 0;
export const saveCapacityScenarioBodyInputAssumptionsItemFractionMax = 1;

export const saveCapacityScenarioBodyInputAssumptionsItemAttendanceCountMin = 0;
export const saveCapacityScenarioBodyInputAssumptionsItemAttendanceCountMax = 1000000;

export const saveCapacityScenarioBodyInputAssumptionsMax = 100;

export const saveCapacityScenarioBodyInputExclusionsItemStartLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputExclusionsItemEndLocalRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T([01]\\d|2[0-3]):[0-5]\\d$');
export const saveCapacityScenarioBodyInputExclusionsItemReasonMin = 3;
export const saveCapacityScenarioBodyInputExclusionsItemReasonMax = 300;

export const saveCapacityScenarioBodyInputExclusionsMax = 100;




export const SaveCapacityScenarioBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1),
  "input": zod.object({
  "name": zod.string().min(1).max(saveCapacityScenarioBodyInputNameMax),
  "siteId": zod.uuid(),
  "startLocal": zod.string().regex(saveCapacityScenarioBodyInputStartLocalRegExp),
  "endLocal": zod.string().regex(saveCapacityScenarioBodyInputEndLocalRegExp),
  "assumptions": zod.array(zod.object({
  "startLocal": zod.string().regex(saveCapacityScenarioBodyInputAssumptionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(saveCapacityScenarioBodyInputAssumptionsItemEndLocalRegExp),
  "staffing": zod.number().min(saveCapacityScenarioBodyInputAssumptionsItemStaffingMin).max(saveCapacityScenarioBodyInputAssumptionsItemStaffingMax).nullable(),
  "fraction": zod.number().min(saveCapacityScenarioBodyInputAssumptionsItemFractionMin).max(saveCapacityScenarioBodyInputAssumptionsItemFractionMax).nullable(),
  "attendanceCount": zod.number().min(saveCapacityScenarioBodyInputAssumptionsItemAttendanceCountMin).max(saveCapacityScenarioBodyInputAssumptionsItemAttendanceCountMax).nullable()
})).max(saveCapacityScenarioBodyInputAssumptionsMax),
  "exclusions": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "startLocal": zod.string().regex(saveCapacityScenarioBodyInputExclusionsItemStartLocalRegExp),
  "endLocal": zod.string().regex(saveCapacityScenarioBodyInputExclusionsItemEndLocalRegExp),
  "reason": zod.string().min(saveCapacityScenarioBodyInputExclusionsItemReasonMin).max(saveCapacityScenarioBodyInputExclusionsItemReasonMax)
})).max(saveCapacityScenarioBodyInputExclusionsMax),
  "baselineScenarioId": zod.uuid().nullable(),
  "baselineRevision": zod.int().min(1).nullable()
})
}))()




export const SaveCapacityScenario200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "siteId": zod.uuid(),
  "shared": zod.boolean(),
  "revision": zod.int().min(1),
  "canEdit": zod.boolean(),
  "updatedAt": zod.string()
}))()

export const SaveCapacityScenario403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveCapacityScenario409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ShareCapacityScenarioParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const shareCapacityScenarioHeaderXGroupGraphTokenMax = 16384;


export const shareCapacityScenarioHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ShareCapacityScenarioHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(shareCapacityScenarioHeaderXGroupGraphTokenMax).regex(shareCapacityScenarioHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const ShareCapacityScenarioBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1),
  "shared": zod.boolean()
}))()




export const ShareCapacityScenario200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "siteId": zod.uuid(),
  "shared": zod.boolean(),
  "revision": zod.int().min(1),
  "canEdit": zod.boolean(),
  "updatedAt": zod.string()
}))()

export const ShareCapacityScenario403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ShareCapacityScenario409Response = /*#__PURE__*/ (() => zod.unknown())()


export const getCapacityScenarioEvidencePathRevisionMax = 100;



export const GetCapacityScenarioEvidenceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1).max(getCapacityScenarioEvidencePathRevisionMax)
}))()

export const getCapacityScenarioEvidenceQueryLimitDefault = 25;
export const getCapacityScenarioEvidenceQueryLimitMax = 100;

export const getCapacityScenarioEvidenceQueryOffsetDefault = 0;
export const getCapacityScenarioEvidenceQueryOffsetMin = 0;
export const getCapacityScenarioEvidenceQueryOffsetMax = 10000;



export const GetCapacityScenarioEvidenceQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getCapacityScenarioEvidenceQueryLimitMax).default(getCapacityScenarioEvidenceQueryLimitDefault),
  "offset": zod.int().min(getCapacityScenarioEvidenceQueryOffsetMin).max(getCapacityScenarioEvidenceQueryOffsetMax).default(getCapacityScenarioEvidenceQueryOffsetDefault)
}))()

export const getCapacityScenarioEvidenceHeaderXGroupGraphTokenMax = 16384;


export const getCapacityScenarioEvidenceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetCapacityScenarioEvidenceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getCapacityScenarioEvidenceHeaderXGroupGraphTokenMax).regex(getCapacityScenarioEvidenceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getCapacityScenarioEvidence200ResponseTotalMin = 0;

export const getCapacityScenarioEvidence200ResponseLimitMin = 0;

export const getCapacityScenarioEvidence200ResponseOffsetMin = 0;



export const GetCapacityScenarioEvidence200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "buildingId": zod.uuid(),
  "floorId": zod.uuid(),
  "zoneId": zod.uuid(),
  "resourceClass": zod.enum(['desk', 'room', 'office', 'parking', 'unmapped']),
  "roomSeats": zod.number().nullable(),
  "eligibility": zod.enum(['known', 'unknown']),
  "spans": zod.array(zod.object({
  "start": zod.string(),
  "end": zod.string()
}))
})),
  "total": zod.int().min(getCapacityScenarioEvidence200ResponseTotalMin),
  "limit": zod.int().min(getCapacityScenarioEvidence200ResponseLimitMin),
  "offset": zod.int().min(getCapacityScenarioEvidence200ResponseOffsetMin)
}))()

export const GetCapacityScenarioEvidence403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetCapacityScenarioEvidence409Response = /*#__PURE__*/ (() => zod.unknown())()


export const exportCapacityScenarioPathRevisionMax = 100;



export const ExportCapacityScenarioParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1).max(exportCapacityScenarioPathRevisionMax)
}))()

export const exportCapacityScenarioHeaderXGroupGraphTokenMax = 16384;


export const exportCapacityScenarioHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportCapacityScenarioHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportCapacityScenarioHeaderXGroupGraphTokenMax).regex(exportCapacityScenarioHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ExportCapacityScenario200Response = /*#__PURE__*/ (() => zod.unknown())()

export const ExportCapacityScenario403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ExportCapacityScenario409Response = /*#__PURE__*/ (() => zod.unknown())()


export const getReportingAccessHeaderXGroupGraphTokenMax = 16384;


export const getReportingAccessHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetReportingAccessHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getReportingAccessHeaderXGroupGraphTokenMax).regex(getReportingAccessHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getReportingAccess200ResponseRangeDaysMax = 366;

export const getReportingAccess200ResponseMaxInteractiveDaysMax = 366;



export const GetReportingAccess200Response = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['legacy', 'enhanced']),
  "canPeople": zod.boolean(),
  "canExtract": zod.boolean(),
  "canMetadata": zod.boolean(),
  "canScenarios": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(getReportingAccess200ResponseRangeDaysMax),
  "maxInteractiveDays": zod.int().min(1).max(getReportingAccess200ResponseMaxInteractiveDaysMax)
}))()

export const GetReportingAccess403Response = /*#__PURE__*/ (() => zod.unknown())()


export const listReportingChoicesQuerySearchMax = 100;

export const listReportingChoicesQueryLimitMax = 100;

export const listReportingChoicesQueryOffsetMin = 0;
export const listReportingChoicesQueryOffsetMax = 10000;



export const ListReportingChoicesQueryParams = /*#__PURE__*/ (() => zod.object({
  "kind": zod.enum(['member', 'team', 'resource']),
  "search": zod.string().max(listReportingChoicesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listReportingChoicesQueryLimitMax).optional(),
  "offset": zod.int().min(listReportingChoicesQueryOffsetMin).max(listReportingChoicesQueryOffsetMax).optional()
}))()

export const listReportingChoicesHeaderXGroupGraphTokenMax = 16384;


export const listReportingChoicesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListReportingChoicesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listReportingChoicesHeaderXGroupGraphTokenMax).regex(listReportingChoicesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listReportingChoices200ResponseItemsMax = 100;

export const listReportingChoices200ResponseTotalMin = 0;

export const listReportingChoices200ResponseLimitMin = 0;

export const listReportingChoices200ResponseOffsetMin = 0;



export const ListReportingChoices200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string()
})).max(listReportingChoices200ResponseItemsMax),
  "total": zod.int().min(listReportingChoices200ResponseTotalMin),
  "limit": zod.int().min(listReportingChoices200ResponseLimitMin),
  "offset": zod.int().min(listReportingChoices200ResponseOffsetMin)
}))()

export const ListReportingChoices403Response = /*#__PURE__*/ (() => zod.unknown())()


export const getDimensionReportQueryGroupByDefault = `site`;
export const getDimensionReportQueryTypeCodeMax = 80;

export const getDimensionReportQueryDepartmentMax = 120;

export const getDimensionReportQueryNeighbourhoodMax = 120;

export const getDimensionReportQueryLimitDefault = 50;
export const getDimensionReportQueryLimitMax = 100;

export const getDimensionReportQueryOffsetDefault = 0;
export const getDimensionReportQueryOffsetMin = 0;
export const getDimensionReportQueryOffsetMax = 10000;



export const GetDimensionReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(getDimensionReportQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(getDimensionReportQueryTypeCodeMax).optional(),
  "department": zod.string().max(getDimensionReportQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(getDimensionReportQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(getDimensionReportQueryLimitMax).default(getDimensionReportQueryLimitDefault),
  "offset": zod.int().min(getDimensionReportQueryOffsetMin).max(getDimensionReportQueryOffsetMax).default(getDimensionReportQueryOffsetDefault)
}))()

export const getDimensionReportHeaderXGroupGraphTokenMax = 16384;


export const getDimensionReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDimensionReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDimensionReportHeaderXGroupGraphTokenMax).regex(getDimensionReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getDimensionReport200ResponseGroupByDefault = `site`;
export const getDimensionReport200ResponseLimitMin = 0;

export const getDimensionReport200ResponseOffsetMin = 0;

export const getDimensionReport200ResponseTotalMin = 0;

export const getDimensionReport200ResponseSummaryBookingsMin = 0;

export const getDimensionReport200ResponseSummaryUniquePeopleMin = 0;

export const getDimensionReport200ResponseSummaryReservationMinutesMin = 0;

export const getDimensionReport200ResponseSummaryCapacityWeightedMinutesMin = 0;

export const getDimensionReport200ResponseSummaryRecordedMinutesMin = 0;

export const getDimensionReport200ResponseSummaryEstimatedMinutesMin = 0;

export const getDimensionReport200ResponseSummaryCheckInsMin = 0;

export const getDimensionReport200ResponseSummaryNoShowsMin = 0;

export const getDimensionReport200ResponseSummaryOwnNameReservationsMin = 0;

export const getDimensionReport200ResponseSummaryNamedBookingsMin = 0;

export const getDimensionReport200ResponseSummaryClaimedBookingsMin = 0;

export const getDimensionReport200ResponseSummaryUnclaimedHoldSlotsMin = 0;

export const getDimensionReport200ResponseSummaryHoldMinutesMin = 0;

export const getDimensionReport200ResponseSummaryProvisionalMinutesMin = 0;

export const getDimensionReport200ResponseSummaryReleasesMin = 0;

export const getDimensionReport200ResponseItemsItemBookingsMin = 0;

export const getDimensionReport200ResponseItemsItemUniquePeopleMin = 0;

export const getDimensionReport200ResponseItemsItemReservationMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemCapacityWeightedMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemRecordedMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemEstimatedMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemCheckInsMin = 0;

export const getDimensionReport200ResponseItemsItemNoShowsMin = 0;

export const getDimensionReport200ResponseItemsItemOwnNameReservationsMin = 0;

export const getDimensionReport200ResponseItemsItemNamedBookingsMin = 0;

export const getDimensionReport200ResponseItemsItemClaimedBookingsMin = 0;

export const getDimensionReport200ResponseItemsItemUnclaimedHoldSlotsMin = 0;

export const getDimensionReport200ResponseItemsItemHoldMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemProvisionalMinutesMin = 0;

export const getDimensionReport200ResponseItemsItemReleasesMin = 0;

export const getDimensionReport200ResponseItemsMax = 10000;

export const getDimensionReport200ResponsePrivacyMinimumPeopleMin = 5;



export const GetDimensionReport200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(getDimensionReport200ResponseGroupByDefault),
  "limit": zod.int().min(getDimensionReport200ResponseLimitMin),
  "offset": zod.int().min(getDimensionReport200ResponseOffsetMin),
  "suppressed": zod.boolean(),
  "total": zod.int().min(getDimensionReport200ResponseTotalMin).nullable(),
  "summary": zod.object({
  "bookings": zod.number().min(getDimensionReport200ResponseSummaryBookingsMin),
  "uniquePeople": zod.number().min(getDimensionReport200ResponseSummaryUniquePeopleMin),
  "reservationMinutes": zod.number().min(getDimensionReport200ResponseSummaryReservationMinutesMin),
  "capacityWeightedMinutes": zod.number().min(getDimensionReport200ResponseSummaryCapacityWeightedMinutesMin),
  "recordedMinutes": zod.number().min(getDimensionReport200ResponseSummaryRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getDimensionReport200ResponseSummaryEstimatedMinutesMin),
  "checkIns": zod.number().min(getDimensionReport200ResponseSummaryCheckInsMin),
  "noShows": zod.number().min(getDimensionReport200ResponseSummaryNoShowsMin),
  "ownNameReservations": zod.number().min(getDimensionReport200ResponseSummaryOwnNameReservationsMin),
  "namedBookings": zod.number().min(getDimensionReport200ResponseSummaryNamedBookingsMin),
  "claimedBookings": zod.number().min(getDimensionReport200ResponseSummaryClaimedBookingsMin),
  "unclaimedHoldSlots": zod.number().min(getDimensionReport200ResponseSummaryUnclaimedHoldSlotsMin),
  "holdMinutes": zod.number().min(getDimensionReport200ResponseSummaryHoldMinutesMin),
  "provisionalMinutes": zod.number().min(getDimensionReport200ResponseSummaryProvisionalMinutesMin),
  "releases": zod.number().min(getDimensionReport200ResponseSummaryReleasesMin)
}).nullable(),
  "items": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "bookings": zod.number().min(getDimensionReport200ResponseItemsItemBookingsMin),
  "uniquePeople": zod.number().min(getDimensionReport200ResponseItemsItemUniquePeopleMin),
  "reservationMinutes": zod.number().min(getDimensionReport200ResponseItemsItemReservationMinutesMin),
  "capacityWeightedMinutes": zod.number().min(getDimensionReport200ResponseItemsItemCapacityWeightedMinutesMin),
  "recordedMinutes": zod.number().min(getDimensionReport200ResponseItemsItemRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getDimensionReport200ResponseItemsItemEstimatedMinutesMin),
  "checkIns": zod.number().min(getDimensionReport200ResponseItemsItemCheckInsMin),
  "noShows": zod.number().min(getDimensionReport200ResponseItemsItemNoShowsMin),
  "ownNameReservations": zod.number().min(getDimensionReport200ResponseItemsItemOwnNameReservationsMin),
  "namedBookings": zod.number().min(getDimensionReport200ResponseItemsItemNamedBookingsMin),
  "claimedBookings": zod.number().min(getDimensionReport200ResponseItemsItemClaimedBookingsMin),
  "unclaimedHoldSlots": zod.number().min(getDimensionReport200ResponseItemsItemUnclaimedHoldSlotsMin),
  "holdMinutes": zod.number().min(getDimensionReport200ResponseItemsItemHoldMinutesMin),
  "provisionalMinutes": zod.number().min(getDimensionReport200ResponseItemsItemProvisionalMinutesMin),
  "releases": zod.number().min(getDimensionReport200ResponseItemsItemReleasesMin)
})).max(getDimensionReport200ResponseItemsMax),
  "privacy": zod.object({
  "minimumPeople": zod.int().min(getDimensionReport200ResponsePrivacyMinimumPeopleMin),
  "personLevel": zod.boolean(),
  "suppressed": zod.boolean(),
  "reason": zod.string().nullable(),
  "assurance": zod.string()
}),
  "evidence": zod.object({
  "dataAsOf": zod.iso.datetime({"offset":true}),
  "stale": zod.boolean(),
  "error": zod.string().nullable(),
  "refreshAfterSeconds": zod.literal(60),
  "units": zod.object({
  "bookings": zod.string(),
  "uniquePeople": zod.string(),
  "reservationMinutes": zod.string(),
  "capacityWeightedMinutes": zod.string(),
  "recordedMinutes": zod.string(),
  "estimatedMinutes": zod.string(),
  "checkIns": zod.string(),
  "noShows": zod.string(),
  "holdMinutes": zod.string(),
  "provisionalMinutes": zod.string(),
  "declaredPlans": zod.string(),
  "simulation": zod.string()
}),
  "capacityBasis": zod.string(),
  "historicalDimensions": zod.string(),
  "observation": zod.string()
})
}))()

export const GetDimensionReport403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetDimensionReport409Response = /*#__PURE__*/ (() => zod.unknown())()


export const exportDimensionReportQueryGroupByDefault = `site`;
export const exportDimensionReportQueryTypeCodeMax = 80;

export const exportDimensionReportQueryDepartmentMax = 120;

export const exportDimensionReportQueryNeighbourhoodMax = 120;

export const exportDimensionReportQueryLimitDefault = 50;
export const exportDimensionReportQueryLimitMax = 100;

export const exportDimensionReportQueryOffsetDefault = 0;
export const exportDimensionReportQueryOffsetMin = 0;
export const exportDimensionReportQueryOffsetMax = 10000;



export const ExportDimensionReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(exportDimensionReportQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(exportDimensionReportQueryTypeCodeMax).optional(),
  "department": zod.string().max(exportDimensionReportQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(exportDimensionReportQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(exportDimensionReportQueryLimitMax).default(exportDimensionReportQueryLimitDefault),
  "offset": zod.int().min(exportDimensionReportQueryOffsetMin).max(exportDimensionReportQueryOffsetMax).default(exportDimensionReportQueryOffsetDefault)
}))()

export const exportDimensionReportHeaderXGroupGraphTokenMax = 16384;


export const exportDimensionReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportDimensionReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportDimensionReportHeaderXGroupGraphTokenMax).regex(exportDimensionReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ExportDimensionReport200Response = /*#__PURE__*/ (() => zod.unknown())()

export const ExportDimensionReport403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ExportDimensionReport409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listReportExtractsQueryLimitDefault = 50;
export const listReportExtractsQueryLimitMax = 100;

export const listReportExtractsQueryOffsetDefault = 0;
export const listReportExtractsQueryOffsetMin = 0;
export const listReportExtractsQueryOffsetMax = 10000;



export const ListReportExtractsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listReportExtractsQueryLimitMax).default(listReportExtractsQueryLimitDefault),
  "offset": zod.int().min(listReportExtractsQueryOffsetMin).max(listReportExtractsQueryOffsetMax).default(listReportExtractsQueryOffsetDefault)
}))()

export const listReportExtractsHeaderXGroupGraphTokenMax = 16384;


export const listReportExtractsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListReportExtractsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listReportExtractsHeaderXGroupGraphTokenMax).regex(listReportExtractsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listReportExtracts200ResponseItemsItemPurposeMin = 10;
export const listReportExtracts200ResponseItemsItemPurposeMax = 500;

export const listReportExtracts200ResponseItemsItemQueryGroupByDefault = `site`;
export const listReportExtracts200ResponseItemsItemQueryTypeCodeMax = 80;

export const listReportExtracts200ResponseItemsItemQueryDepartmentMax = 120;

export const listReportExtracts200ResponseItemsItemQueryNeighbourhoodMax = 120;

export const listReportExtracts200ResponseItemsItemQueryLimitDefault = 50;
export const listReportExtracts200ResponseItemsItemQueryLimitMax = 100;

export const listReportExtracts200ResponseItemsItemQueryOffsetDefault = 0;
export const listReportExtracts200ResponseItemsItemQueryOffsetMin = 0;
export const listReportExtracts200ResponseItemsItemQueryOffsetMax = 10000;

export const listReportExtracts200ResponseItemsMax = 100;

export const listReportExtracts200ResponseTotalMin = 0;

export const listReportExtracts200ResponseLimitMin = 0;

export const listReportExtracts200ResponseOffsetMin = 0;



export const ListReportExtracts200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "state": zod.enum(['pending', 'running', 'withheld', 'ready', 'revoked', 'expired', 'failed']),
  "revision": zod.int().min(1),
  "purpose": zod.string().min(listReportExtracts200ResponseItemsItemPurposeMin).max(listReportExtracts200ResponseItemsItemPurposeMax),
  "query": zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(listReportExtracts200ResponseItemsItemQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(listReportExtracts200ResponseItemsItemQueryTypeCodeMax).optional(),
  "department": zod.string().max(listReportExtracts200ResponseItemsItemQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(listReportExtracts200ResponseItemsItemQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listReportExtracts200ResponseItemsItemQueryLimitMax).default(listReportExtracts200ResponseItemsItemQueryLimitDefault),
  "offset": zod.int().min(listReportExtracts200ResponseItemsItemQueryOffsetMin).max(listReportExtracts200ResponseItemsItemQueryOffsetMax).default(listReportExtracts200ResponseItemsItemQueryOffsetDefault)
}),
  "outcome": zod.string().nullable(),
  "dataAsOf": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listReportExtracts200ResponseItemsMax),
  "total": zod.int().min(listReportExtracts200ResponseTotalMin),
  "limit": zod.int().min(listReportExtracts200ResponseLimitMin),
  "offset": zod.int().min(listReportExtracts200ResponseOffsetMin)
}))()

export const ListReportExtracts403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListReportExtracts409Response = /*#__PURE__*/ (() => zod.unknown())()


export const createReportExtractHeaderXGroupGraphTokenMax = 16384;


export const createReportExtractHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateReportExtractHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createReportExtractHeaderXGroupGraphTokenMax).regex(createReportExtractHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createReportExtractBodyPurposeMin = 10;
export const createReportExtractBodyPurposeMax = 500;

export const createReportExtractBodyQueryGroupByDefault = `site`;
export const createReportExtractBodyQueryTypeCodeMax = 80;

export const createReportExtractBodyQueryDepartmentMax = 120;

export const createReportExtractBodyQueryNeighbourhoodMax = 120;

export const createReportExtractBodyQueryLimitDefault = 50;
export const createReportExtractBodyQueryLimitMax = 100;

export const createReportExtractBodyQueryOffsetDefault = 0;
export const createReportExtractBodyQueryOffsetMin = 0;
export const createReportExtractBodyQueryOffsetMax = 10000;



export const CreateReportExtractBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "purpose": zod.string().min(createReportExtractBodyPurposeMin).max(createReportExtractBodyPurposeMax),
  "query": zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(createReportExtractBodyQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(createReportExtractBodyQueryTypeCodeMax).optional(),
  "department": zod.string().max(createReportExtractBodyQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(createReportExtractBodyQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(createReportExtractBodyQueryLimitMax).default(createReportExtractBodyQueryLimitDefault),
  "offset": zod.int().min(createReportExtractBodyQueryOffsetMin).max(createReportExtractBodyQueryOffsetMax).default(createReportExtractBodyQueryOffsetDefault)
})
}))()


export const createReportExtract200ResponsePurposeMin = 10;
export const createReportExtract200ResponsePurposeMax = 500;

export const createReportExtract200ResponseQueryGroupByDefault = `site`;
export const createReportExtract200ResponseQueryTypeCodeMax = 80;

export const createReportExtract200ResponseQueryDepartmentMax = 120;

export const createReportExtract200ResponseQueryNeighbourhoodMax = 120;

export const createReportExtract200ResponseQueryLimitDefault = 50;
export const createReportExtract200ResponseQueryLimitMax = 100;

export const createReportExtract200ResponseQueryOffsetDefault = 0;
export const createReportExtract200ResponseQueryOffsetMin = 0;
export const createReportExtract200ResponseQueryOffsetMax = 10000;



export const CreateReportExtract200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "state": zod.enum(['pending', 'running', 'withheld', 'ready', 'revoked', 'expired', 'failed']),
  "revision": zod.int().min(1),
  "purpose": zod.string().min(createReportExtract200ResponsePurposeMin).max(createReportExtract200ResponsePurposeMax),
  "query": zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(createReportExtract200ResponseQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(createReportExtract200ResponseQueryTypeCodeMax).optional(),
  "department": zod.string().max(createReportExtract200ResponseQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(createReportExtract200ResponseQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(createReportExtract200ResponseQueryLimitMax).default(createReportExtract200ResponseQueryLimitDefault),
  "offset": zod.int().min(createReportExtract200ResponseQueryOffsetMin).max(createReportExtract200ResponseQueryOffsetMax).default(createReportExtract200ResponseQueryOffsetDefault)
}),
  "outcome": zod.string().nullable(),
  "dataAsOf": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const CreateReportExtract403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateReportExtract409Response = /*#__PURE__*/ (() => zod.unknown())()


export const RevalidateReportExtractParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const revalidateReportExtractHeaderXGroupGraphTokenMax = 16384;


export const revalidateReportExtractHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RevalidateReportExtractHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(revalidateReportExtractHeaderXGroupGraphTokenMax).regex(revalidateReportExtractHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const RevalidateReportExtractBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()


export const revalidateReportExtract200ResponsePurposeMin = 10;
export const revalidateReportExtract200ResponsePurposeMax = 500;

export const revalidateReportExtract200ResponseQueryGroupByDefault = `site`;
export const revalidateReportExtract200ResponseQueryTypeCodeMax = 80;

export const revalidateReportExtract200ResponseQueryDepartmentMax = 120;

export const revalidateReportExtract200ResponseQueryNeighbourhoodMax = 120;

export const revalidateReportExtract200ResponseQueryLimitDefault = 50;
export const revalidateReportExtract200ResponseQueryLimitMax = 100;

export const revalidateReportExtract200ResponseQueryOffsetDefault = 0;
export const revalidateReportExtract200ResponseQueryOffsetMin = 0;
export const revalidateReportExtract200ResponseQueryOffsetMax = 10000;



export const RevalidateReportExtract200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "state": zod.enum(['pending', 'running', 'withheld', 'ready', 'revoked', 'expired', 'failed']),
  "revision": zod.int().min(1),
  "purpose": zod.string().min(revalidateReportExtract200ResponsePurposeMin).max(revalidateReportExtract200ResponsePurposeMax),
  "query": zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(revalidateReportExtract200ResponseQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(revalidateReportExtract200ResponseQueryTypeCodeMax).optional(),
  "department": zod.string().max(revalidateReportExtract200ResponseQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(revalidateReportExtract200ResponseQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(revalidateReportExtract200ResponseQueryLimitMax).default(revalidateReportExtract200ResponseQueryLimitDefault),
  "offset": zod.int().min(revalidateReportExtract200ResponseQueryOffsetMin).max(revalidateReportExtract200ResponseQueryOffsetMax).default(revalidateReportExtract200ResponseQueryOffsetDefault)
}),
  "outcome": zod.string().nullable(),
  "dataAsOf": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const RevalidateReportExtract403Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevalidateReportExtract409Response = /*#__PURE__*/ (() => zod.unknown())()


export const RevokeReportExtractParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const revokeReportExtractHeaderXGroupGraphTokenMax = 16384;


export const revokeReportExtractHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RevokeReportExtractHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(revokeReportExtractHeaderXGroupGraphTokenMax).regex(revokeReportExtractHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const RevokeReportExtractBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()


export const revokeReportExtract200ResponsePurposeMin = 10;
export const revokeReportExtract200ResponsePurposeMax = 500;

export const revokeReportExtract200ResponseQueryGroupByDefault = `site`;
export const revokeReportExtract200ResponseQueryTypeCodeMax = 80;

export const revokeReportExtract200ResponseQueryDepartmentMax = 120;

export const revokeReportExtract200ResponseQueryNeighbourhoodMax = 120;

export const revokeReportExtract200ResponseQueryLimitDefault = 50;
export const revokeReportExtract200ResponseQueryLimitMax = 100;

export const revokeReportExtract200ResponseQueryOffsetDefault = 0;
export const revokeReportExtract200ResponseQueryOffsetMin = 0;
export const revokeReportExtract200ResponseQueryOffsetMax = 10000;



export const RevokeReportExtract200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "state": zod.enum(['pending', 'running', 'withheld', 'ready', 'revoked', 'expired', 'failed']),
  "revision": zod.int().min(1),
  "purpose": zod.string().min(revokeReportExtract200ResponsePurposeMin).max(revokeReportExtract200ResponsePurposeMax),
  "query": zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type', 'department', 'primary_team', 'neighbourhood', 'user']).default(revokeReportExtract200ResponseQueryGroupByDefault),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCode": zod.string().max(revokeReportExtract200ResponseQueryTypeCodeMax).optional(),
  "department": zod.string().max(revokeReportExtract200ResponseQueryDepartmentMax).optional(),
  "primaryTeamId": zod.uuid().optional(),
  "anyTeamId": zod.uuid().optional(),
  "neighbourhood": zod.string().max(revokeReportExtract200ResponseQueryNeighbourhoodMax).optional(),
  "userId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(revokeReportExtract200ResponseQueryLimitMax).default(revokeReportExtract200ResponseQueryLimitDefault),
  "offset": zod.int().min(revokeReportExtract200ResponseQueryOffsetMin).max(revokeReportExtract200ResponseQueryOffsetMax).default(revokeReportExtract200ResponseQueryOffsetDefault)
}),
  "outcome": zod.string().nullable(),
  "dataAsOf": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const RevokeReportExtract403Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevokeReportExtract409Response = /*#__PURE__*/ (() => zod.unknown())()


export const DownloadReportExtractParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const downloadReportExtractHeaderXGroupGraphTokenMax = 16384;


export const downloadReportExtractHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DownloadReportExtractHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(downloadReportExtractHeaderXGroupGraphTokenMax).regex(downloadReportExtractHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DownloadReportExtract200Response = /*#__PURE__*/ (() => zod.unknown())()

export const DownloadReportExtract403Response = /*#__PURE__*/ (() => zod.unknown())()

export const DownloadReportExtract409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listReportingPeopleQueryLimitDefault = 50;
export const listReportingPeopleQueryLimitMax = 100;

export const listReportingPeopleQueryOffsetDefault = 0;
export const listReportingPeopleQueryOffsetMin = 0;
export const listReportingPeopleQueryOffsetMax = 10000;



export const ListReportingPeopleQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listReportingPeopleQueryLimitMax).default(listReportingPeopleQueryLimitDefault),
  "offset": zod.int().min(listReportingPeopleQueryOffsetMin).max(listReportingPeopleQueryOffsetMax).default(listReportingPeopleQueryOffsetDefault)
}))()

export const listReportingPeopleHeaderXGroupGraphTokenMax = 16384;


export const listReportingPeopleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListReportingPeopleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listReportingPeopleHeaderXGroupGraphTokenMax).regex(listReportingPeopleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listReportingPeople200ResponseItemsItemRevisionMin = 0;

export const listReportingPeople200ResponseItemsMax = 100;

export const listReportingPeople200ResponseTotalMin = 0;

export const listReportingPeople200ResponseLimitMin = 0;

export const listReportingPeople200ResponseOffsetMin = 0;



export const ListReportingPeople200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "userId": zod.uuid(),
  "department": zod.string().nullable(),
  "primaryTeamId": zod.uuid().nullable(),
  "revision": zod.int().min(listReportingPeople200ResponseItemsItemRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listReportingPeople200ResponseItemsMax),
  "total": zod.int().min(listReportingPeople200ResponseTotalMin),
  "limit": zod.int().min(listReportingPeople200ResponseLimitMin),
  "offset": zod.int().min(listReportingPeople200ResponseOffsetMin)
}))()

export const ListReportingPeople403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListReportingPeople409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetReportingPersonParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getReportingPersonHeaderXGroupGraphTokenMax = 16384;


export const getReportingPersonHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetReportingPersonHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getReportingPersonHeaderXGroupGraphTokenMax).regex(getReportingPersonHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getReportingPerson200ResponseExpectedRevisionMin = 0;

export const getReportingPerson200ResponseDepartmentMax = 120;



export const GetReportingPerson200Response = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(getReportingPerson200ResponseExpectedRevisionMin),
  "department": zod.string().min(1).max(getReportingPerson200ResponseDepartmentMax).nullable(),
  "primaryTeamId": zod.uuid().nullable()
}))()

export const GetReportingPerson403Response = /*#__PURE__*/ (() => zod.unknown())()


export const SaveReportingPersonParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveReportingPersonHeaderXGroupGraphTokenMax = 16384;


export const saveReportingPersonHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveReportingPersonHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveReportingPersonHeaderXGroupGraphTokenMax).regex(saveReportingPersonHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveReportingPersonBodyExpectedRevisionMin = 0;

export const saveReportingPersonBodyDepartmentMax = 120;



export const SaveReportingPersonBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveReportingPersonBodyExpectedRevisionMin),
  "department": zod.string().min(1).max(saveReportingPersonBodyDepartmentMax).nullable(),
  "primaryTeamId": zod.uuid().nullable()
}))()




export const SaveReportingPerson200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1)
}))()

export const SaveReportingPerson403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveReportingPerson409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listReportingResourcesQueryLimitDefault = 50;
export const listReportingResourcesQueryLimitMax = 100;

export const listReportingResourcesQueryOffsetDefault = 0;
export const listReportingResourcesQueryOffsetMin = 0;
export const listReportingResourcesQueryOffsetMax = 10000;



export const ListReportingResourcesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listReportingResourcesQueryLimitMax).default(listReportingResourcesQueryLimitDefault),
  "offset": zod.int().min(listReportingResourcesQueryOffsetMin).max(listReportingResourcesQueryOffsetMax).default(listReportingResourcesQueryOffsetDefault)
}))()

export const listReportingResourcesHeaderXGroupGraphTokenMax = 16384;


export const listReportingResourcesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListReportingResourcesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listReportingResourcesHeaderXGroupGraphTokenMax).regex(listReportingResourcesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listReportingResources200ResponseItemsItemRevisionMin = 0;

export const listReportingResources200ResponseItemsMax = 100;

export const listReportingResources200ResponseTotalMin = 0;

export const listReportingResources200ResponseLimitMin = 0;

export const listReportingResources200ResponseOffsetMin = 0;



export const ListReportingResources200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "spaceId": zod.uuid(),
  "neighbourhood": zod.string().nullable(),
  "revision": zod.int().min(listReportingResources200ResponseItemsItemRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listReportingResources200ResponseItemsMax),
  "total": zod.int().min(listReportingResources200ResponseTotalMin),
  "limit": zod.int().min(listReportingResources200ResponseLimitMin),
  "offset": zod.int().min(listReportingResources200ResponseOffsetMin)
}))()

export const ListReportingResources403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListReportingResources409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetReportingResourceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getReportingResourceHeaderXGroupGraphTokenMax = 16384;


export const getReportingResourceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetReportingResourceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getReportingResourceHeaderXGroupGraphTokenMax).regex(getReportingResourceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getReportingResource200ResponseExpectedRevisionMin = 0;

export const getReportingResource200ResponseNeighbourhoodMax = 120;



export const GetReportingResource200Response = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(getReportingResource200ResponseExpectedRevisionMin),
  "neighbourhood": zod.string().min(1).max(getReportingResource200ResponseNeighbourhoodMax).nullable()
}))()

export const GetReportingResource403Response = /*#__PURE__*/ (() => zod.unknown())()


export const SaveReportingResourceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveReportingResourceHeaderXGroupGraphTokenMax = 16384;


export const saveReportingResourceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveReportingResourceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveReportingResourceHeaderXGroupGraphTokenMax).regex(saveReportingResourceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveReportingResourceBodyExpectedRevisionMin = 0;

export const saveReportingResourceBodyNeighbourhoodMax = 120;



export const SaveReportingResourceBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveReportingResourceBodyExpectedRevisionMin),
  "neighbourhood": zod.string().min(1).max(saveReportingResourceBodyNeighbourhoodMax).nullable()
}))()




export const SaveReportingResource200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1)
}))()

export const SaveReportingResource403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveReportingResource409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetBookingInvitationStatusParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBookingInvitationStatusHeaderXGroupGraphTokenMax = 16384;


export const getBookingInvitationStatusHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingInvitationStatusHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingInvitationStatusHeaderXGroupGraphTokenMax).regex(getBookingInvitationStatusHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getBookingInvitationStatus200ResponseCurrentEventIdMax = 2048;


export const getBookingInvitationStatus200ResponsePendingMoveOneOriginalEventIdMax = 2048;

export const getBookingInvitationStatus200ResponsePendingMoveOneCandidateEventIdMax = 2048;

export const getBookingInvitationStatus200ResponsePendingMoveOneBeneficiaryCountKeyMax = 256;

export const getBookingInvitationStatus200ResponseReadinessReasonMax = 1000;



export const GetBookingInvitationStatus200Response = /*#__PURE__*/ (() => zod.object({
  "bookingId": zod.uuid(),
  "bookingRevision": zod.int().min(1),
  "state": zod.enum(['not_requested', 'queued', 'accepted_by_provider', 'unconfirmed', 'reconciling', 'failed', 'cancel_pending', 'cancelled']),
  "roomResponse": zod.enum(['not_applicable', 'pending', 'accepted', 'declined', 'unknown']),
  "currentEventId": zod.string().max(getBookingInvitationStatus200ResponseCurrentEventIdMax).nullable(),
  "pendingMove": zod.union([zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "revision": zod.int().min(1),
  "state": zod.enum(['reserved', 'awaiting_acceptance', 'promoting', 'promoted', 'cleanup_pending', 'complete', 'declined', 'aborting', 'unresolved', 'failed', 'cancelled']),
  "originalResourceId": zod.uuid(),
  "originalAllocationId": zod.uuid().optional(),
  "destinationAllocationId": zod.uuid().nullish(),
  "remoteExecutionReady": zod.boolean().optional(),
  "destinationResourceId": zod.uuid(),
  "originalEventId": zod.string().max(getBookingInvitationStatus200ResponsePendingMoveOneOriginalEventIdMax).nullable(),
  "candidateEventId": zod.string().max(getBookingInvitationStatus200ResponsePendingMoveOneCandidateEventIdMax).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "beneficiaryCountKey": zod.string().max(getBookingInvitationStatus200ResponsePendingMoveOneBeneficiaryCountKeyMax),
  "originalRetained": zod.boolean(),
  "cleanupRequired": zod.boolean()
}),zod.null()]),
  "readiness": zod.object({
  "state": zod.enum(['not_implemented', 'disabled', 'setup_required', 'unavailable', 'ready']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().max(getBookingInvitationStatus200ResponseReadinessReasonMax),
  "roomAcceptanceRequired": zod.boolean()
}),
  "employeeResponse": zod.enum(['accepted', 'declined', 'unknown']).optional()
}))()

export const GetBookingInvitationStatus403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingInvitationStatus409Response = /*#__PURE__*/ (() => zod.unknown())()


export const getBookingInvitationReadinessHeaderXGroupGraphTokenMax = 16384;


export const getBookingInvitationReadinessHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingInvitationReadinessHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingInvitationReadinessHeaderXGroupGraphTokenMax).regex(getBookingInvitationReadinessHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingInvitationReadiness200ResponseReasonMax = 1000;



export const GetBookingInvitationReadiness200Response = /*#__PURE__*/ (() => zod.object({
  "state": zod.enum(['not_implemented', 'disabled', 'setup_required', 'unavailable', 'ready']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().max(getBookingInvitationReadiness200ResponseReasonMax),
  "roomAcceptanceRequired": zod.boolean()
}))()

export const GetBookingInvitationReadiness403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingInvitationReadiness409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ReconcileBookingMoveParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "moveId": zod.uuid()
}))()

export const reconcileBookingMoveHeaderXGroupGraphTokenMax = 16384;


export const reconcileBookingMoveHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ReconcileBookingMoveHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(reconcileBookingMoveHeaderXGroupGraphTokenMax).regex(reconcileBookingMoveHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const ReconcileBookingMoveBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()


export const reconcileBookingMove200ResponseCurrentEventIdMax = 2048;


export const reconcileBookingMove200ResponsePendingMoveOneOriginalEventIdMax = 2048;

export const reconcileBookingMove200ResponsePendingMoveOneCandidateEventIdMax = 2048;

export const reconcileBookingMove200ResponsePendingMoveOneBeneficiaryCountKeyMax = 256;

export const reconcileBookingMove200ResponseReadinessReasonMax = 1000;



export const ReconcileBookingMove200Response = /*#__PURE__*/ (() => zod.object({
  "bookingId": zod.uuid(),
  "bookingRevision": zod.int().min(1),
  "state": zod.enum(['not_requested', 'queued', 'accepted_by_provider', 'unconfirmed', 'reconciling', 'failed', 'cancel_pending', 'cancelled']),
  "roomResponse": zod.enum(['not_applicable', 'pending', 'accepted', 'declined', 'unknown']),
  "currentEventId": zod.string().max(reconcileBookingMove200ResponseCurrentEventIdMax).nullable(),
  "pendingMove": zod.union([zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "revision": zod.int().min(1),
  "state": zod.enum(['reserved', 'awaiting_acceptance', 'promoting', 'promoted', 'cleanup_pending', 'complete', 'declined', 'aborting', 'unresolved', 'failed', 'cancelled']),
  "originalResourceId": zod.uuid(),
  "originalAllocationId": zod.uuid().optional(),
  "destinationAllocationId": zod.uuid().nullish(),
  "remoteExecutionReady": zod.boolean().optional(),
  "destinationResourceId": zod.uuid(),
  "originalEventId": zod.string().max(reconcileBookingMove200ResponsePendingMoveOneOriginalEventIdMax).nullable(),
  "candidateEventId": zod.string().max(reconcileBookingMove200ResponsePendingMoveOneCandidateEventIdMax).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "beneficiaryCountKey": zod.string().max(reconcileBookingMove200ResponsePendingMoveOneBeneficiaryCountKeyMax),
  "originalRetained": zod.boolean(),
  "cleanupRequired": zod.boolean()
}),zod.null()]),
  "readiness": zod.object({
  "state": zod.enum(['not_implemented', 'disabled', 'setup_required', 'unavailable', 'ready']),
  "checkedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().max(reconcileBookingMove200ResponseReadinessReasonMax),
  "roomAcceptanceRequired": zod.boolean()
}),
  "employeeResponse": zod.enum(['accepted', 'declined', 'unknown']).optional()
}))()

export const ReconcileBookingMove403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ReconcileBookingMove409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listBookingScheduleSitesQueryLimitDefault = 25;
export const listBookingScheduleSitesQueryLimitMax = 100;

export const listBookingScheduleSitesQueryOffsetDefault = 0;
export const listBookingScheduleSitesQueryOffsetMin = 0;
export const listBookingScheduleSitesQueryOffsetMax = 100000;



export const ListBookingScheduleSitesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listBookingScheduleSitesQueryLimitMax).default(listBookingScheduleSitesQueryLimitDefault),
  "offset": zod.int().min(listBookingScheduleSitesQueryOffsetMin).max(listBookingScheduleSitesQueryOffsetMax).default(listBookingScheduleSitesQueryOffsetDefault)
}))()

export const listBookingScheduleSitesHeaderXGroupGraphTokenMax = 16384;


export const listBookingScheduleSitesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBookingScheduleSitesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBookingScheduleSitesHeaderXGroupGraphTokenMax).regex(listBookingScheduleSitesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listBookingScheduleSites200ResponseItemsMax = 100;

export const listBookingScheduleSites200ResponseTotalMin = 0;

export const listBookingScheduleSites200ResponseLimitMax = 100;

export const listBookingScheduleSites200ResponseOffsetMin = 0;
export const listBookingScheduleSites200ResponseOffsetMax = 100000;



export const ListBookingScheduleSites200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "timeZone": zod.string()
})).max(listBookingScheduleSites200ResponseItemsMax),
  "total": zod.int().min(listBookingScheduleSites200ResponseTotalMin),
  "limit": zod.int().min(1).max(listBookingScheduleSites200ResponseLimitMax),
  "offset": zod.int().min(listBookingScheduleSites200ResponseOffsetMin).max(listBookingScheduleSites200ResponseOffsetMax)
}))()

export const ListBookingScheduleSites403Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetBookingScheduleSettingsParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid()
}))()

export const getBookingScheduleSettingsHeaderXGroupGraphTokenMax = 16384;


export const getBookingScheduleSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingScheduleSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingScheduleSettingsHeaderXGroupGraphTokenMax).regex(getBookingScheduleSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingScheduleSettings200ResponseTimeZoneMax = 100;

export const getBookingScheduleSettings200ResponseConfigurationCalendarLabelMax = 120;

export const getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMin = 0;
export const getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMax = 6;

export const getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysMax = 7;

export const getBookingScheduleSettings200ResponseConfigurationCalendarHolidaysMax = 1000;

export const getBookingScheduleSettings200ResponseConfigurationRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const getBookingScheduleSettings200ResponseConfigurationRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMin = 0;
export const getBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMax = 366;

export const getBookingScheduleSettings200ResponseConfigurationRulesItemChannelsMax = 2;

export const getBookingScheduleSettings200ResponseConfigurationRulesMax = 12;

export const getBookingScheduleSettings200ResponseConfigurationReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMin = 0;
export const getBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMax = 1440;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarLabelMax = 120;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMin = 0;
export const getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMax = 6;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysMax = 7;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarHolidaysMax = 1000;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMin = 0;
export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMax = 366;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemChannelsMax = 2;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneRulesMax = 12;

export const getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMin = 0;
export const getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMax = 1440;

export const getBookingScheduleSettings200ResponseRevisionMin = 64;
export const getBookingScheduleSettings200ResponseRevisionMax = 64;



export const GetBookingScheduleSettings200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "enabled": zod.boolean(),
  "timeZone": zod.string().max(getBookingScheduleSettings200ResponseTimeZoneMax),
  "configuration": zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(getBookingScheduleSettings200ResponseConfigurationCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMin).max(getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMax)).min(1).max(getBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(getBookingScheduleSettings200ResponseConfigurationCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(getBookingScheduleSettings200ResponseConfigurationRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(getBookingScheduleSettings200ResponseConfigurationRulesItemTimeRegExp),
  "offset": zod.int().min(getBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMin).max(getBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(getBookingScheduleSettings200ResponseConfigurationRulesItemChannelsMax)
})).max(getBookingScheduleSettings200ResponseConfigurationRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(getBookingScheduleSettings200ResponseConfigurationReleaseTimeRegExp),
  "graceMinutes": zod.int().min(getBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMin).max(getBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMax)
})
}),
  "storedConfiguration": zod.union([zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMin).max(getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMax)).min(1).max(getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(getBookingScheduleSettings200ResponseStoredConfigurationOneCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemTimeRegExp),
  "offset": zod.int().min(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMin).max(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemChannelsMax)
})).max(getBookingScheduleSettings200ResponseStoredConfigurationOneRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseTimeRegExp),
  "graceMinutes": zod.int().min(getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMin).max(getBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMax)
})
}),zod.null()]),
  "overrideAllowed": zod.boolean(),
  "source": zod.enum(['site', 'inherited']),
  "revision": zod.string().min(getBookingScheduleSettings200ResponseRevisionMin).max(getBookingScheduleSettings200ResponseRevisionMax)
}))()

export const GetBookingScheduleSettings403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingScheduleSettings409Response = /*#__PURE__*/ (() => zod.unknown())()


export const SaveBookingScheduleSettingsParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid()
}))()

export const saveBookingScheduleSettingsHeaderXGroupGraphTokenMax = 16384;


export const saveBookingScheduleSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveBookingScheduleSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveBookingScheduleSettingsHeaderXGroupGraphTokenMax).regex(saveBookingScheduleSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveBookingScheduleSettingsBodyExpectedRevisionMin = 64;
export const saveBookingScheduleSettingsBodyExpectedRevisionMax = 64;

export const saveBookingScheduleSettingsBodyConfigurationOneCalendarLabelMax = 120;

export const saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysItemMin = 0;
export const saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysItemMax = 6;

export const saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysMax = 7;

export const saveBookingScheduleSettingsBodyConfigurationOneCalendarHolidaysMax = 1000;

export const saveBookingScheduleSettingsBodyConfigurationOneRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const saveBookingScheduleSettingsBodyConfigurationOneRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettingsBodyConfigurationOneRulesItemOffsetMin = 0;
export const saveBookingScheduleSettingsBodyConfigurationOneRulesItemOffsetMax = 366;

export const saveBookingScheduleSettingsBodyConfigurationOneRulesItemChannelsMax = 2;

export const saveBookingScheduleSettingsBodyConfigurationOneRulesMax = 12;

export const saveBookingScheduleSettingsBodyConfigurationOneReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettingsBodyConfigurationOneReleaseGraceMinutesMin = 0;
export const saveBookingScheduleSettingsBodyConfigurationOneReleaseGraceMinutesMax = 1440;



export const SaveBookingScheduleSettingsBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.string().min(saveBookingScheduleSettingsBodyExpectedRevisionMin).max(saveBookingScheduleSettingsBodyExpectedRevisionMax),
  "configuration": zod.union([zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(saveBookingScheduleSettingsBodyConfigurationOneCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysItemMin).max(saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysItemMax)).min(1).max(saveBookingScheduleSettingsBodyConfigurationOneCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(saveBookingScheduleSettingsBodyConfigurationOneCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(saveBookingScheduleSettingsBodyConfigurationOneRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(saveBookingScheduleSettingsBodyConfigurationOneRulesItemTimeRegExp),
  "offset": zod.int().min(saveBookingScheduleSettingsBodyConfigurationOneRulesItemOffsetMin).max(saveBookingScheduleSettingsBodyConfigurationOneRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(saveBookingScheduleSettingsBodyConfigurationOneRulesItemChannelsMax)
})).max(saveBookingScheduleSettingsBodyConfigurationOneRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(saveBookingScheduleSettingsBodyConfigurationOneReleaseTimeRegExp),
  "graceMinutes": zod.int().min(saveBookingScheduleSettingsBodyConfigurationOneReleaseGraceMinutesMin).max(saveBookingScheduleSettingsBodyConfigurationOneReleaseGraceMinutesMax)
})
}),zod.null()])
}))()

export const saveBookingScheduleSettings200ResponseTimeZoneMax = 100;

export const saveBookingScheduleSettings200ResponseConfigurationCalendarLabelMax = 120;

export const saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMin = 0;
export const saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMax = 6;

export const saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysMax = 7;

export const saveBookingScheduleSettings200ResponseConfigurationCalendarHolidaysMax = 1000;

export const saveBookingScheduleSettings200ResponseConfigurationRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const saveBookingScheduleSettings200ResponseConfigurationRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMin = 0;
export const saveBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMax = 366;

export const saveBookingScheduleSettings200ResponseConfigurationRulesItemChannelsMax = 2;

export const saveBookingScheduleSettings200ResponseConfigurationRulesMax = 12;

export const saveBookingScheduleSettings200ResponseConfigurationReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMin = 0;
export const saveBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMax = 1440;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarLabelMax = 120;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMin = 0;
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMax = 6;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysMax = 7;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarHolidaysMax = 1000;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMin = 0;
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMax = 366;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemChannelsMax = 2;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesMax = 12;

export const saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMin = 0;
export const saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMax = 1440;

export const saveBookingScheduleSettings200ResponseRevisionMin = 64;
export const saveBookingScheduleSettings200ResponseRevisionMax = 64;



export const SaveBookingScheduleSettings200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "enabled": zod.boolean(),
  "timeZone": zod.string().max(saveBookingScheduleSettings200ResponseTimeZoneMax),
  "configuration": zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(saveBookingScheduleSettings200ResponseConfigurationCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMin).max(saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysItemMax)).min(1).max(saveBookingScheduleSettings200ResponseConfigurationCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(saveBookingScheduleSettings200ResponseConfigurationCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(saveBookingScheduleSettings200ResponseConfigurationRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(saveBookingScheduleSettings200ResponseConfigurationRulesItemTimeRegExp),
  "offset": zod.int().min(saveBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMin).max(saveBookingScheduleSettings200ResponseConfigurationRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(saveBookingScheduleSettings200ResponseConfigurationRulesItemChannelsMax)
})).max(saveBookingScheduleSettings200ResponseConfigurationRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(saveBookingScheduleSettings200ResponseConfigurationReleaseTimeRegExp),
  "graceMinutes": zod.int().min(saveBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMin).max(saveBookingScheduleSettings200ResponseConfigurationReleaseGraceMinutesMax)
})
}),
  "storedConfiguration": zod.union([zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMin).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysItemMax)).min(1).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemTimeRegExp),
  "offset": zod.int().min(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMin).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesItemChannelsMax)
})).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseTimeRegExp),
  "graceMinutes": zod.int().min(saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMin).max(saveBookingScheduleSettings200ResponseStoredConfigurationOneReleaseGraceMinutesMax)
})
}),zod.null()]),
  "overrideAllowed": zod.boolean(),
  "source": zod.enum(['site', 'inherited']),
  "revision": zod.string().min(saveBookingScheduleSettings200ResponseRevisionMin).max(saveBookingScheduleSettings200ResponseRevisionMax)
}))()

export const SaveBookingScheduleSettings403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveBookingScheduleSettings409Response = /*#__PURE__*/ (() => zod.unknown())()


export const previewBookingScheduleHeaderXGroupGraphTokenMax = 16384;


export const previewBookingScheduleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewBookingScheduleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewBookingScheduleHeaderXGroupGraphTokenMax).regex(previewBookingScheduleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewBookingScheduleBodyRuleDraftHorizonDaysMin = 0;
export const previewBookingScheduleBodyRuleDraftHorizonDaysMax = 366;

export const previewBookingScheduleBodyRuleDraftSimultaneousPerClassMax = 20;

export const previewBookingScheduleBodyRuleDraftOrganiserDeskLimitMax = 20;

export const previewBookingScheduleBodyRuleDraftMaxAssignmentsMax = 20;

export const previewBookingScheduleBodyRuleDraftMaxDesksMax = 20;

export const previewBookingScheduleBodyRuleDraftClaimMinutesBeforeStartMin = 0;
export const previewBookingScheduleBodyRuleDraftClaimMinutesBeforeStartMax = 10080;

export const previewBookingScheduleBodyRuleDraftCandidateWaitMinutesMax = 60;

export const previewBookingScheduleBodyRuleDraftEventReminderMinutesMin = 0;
export const previewBookingScheduleBodyRuleDraftEventReminderMinutesMax = 10080;

export const previewBookingScheduleBodyRuleDraftMinPeopleMin = 5;
export const previewBookingScheduleBodyRuleDraftMinPeopleMax = 100;

export const previewBookingScheduleBodyRuleDraftRangeDaysMax = 366;

export const previewBookingScheduleBodyRuleDraftMaxInteractiveDaysMax = 366;

export const previewBookingScheduleBodyRuleDraftNoShowGraceMinutesMin = 0;
export const previewBookingScheduleBodyRuleDraftNoShowGraceMinutesMax = 1440;

export const previewBookingScheduleBodyRuleDraftPriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const previewBookingScheduleBodyRuleDraftBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const previewBookingScheduleBodyRuleDraftNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const previewBookingScheduleBodyExpectedRuleRevisionMax = 128;

export const previewBookingScheduleBodyConfigurationCalendarLabelMax = 120;

export const previewBookingScheduleBodyConfigurationCalendarWeekdaysItemMin = 0;
export const previewBookingScheduleBodyConfigurationCalendarWeekdaysItemMax = 6;

export const previewBookingScheduleBodyConfigurationCalendarWeekdaysMax = 7;

export const previewBookingScheduleBodyConfigurationCalendarHolidaysMax = 1000;

export const previewBookingScheduleBodyConfigurationRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const previewBookingScheduleBodyConfigurationRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const previewBookingScheduleBodyConfigurationRulesItemOffsetMin = 0;
export const previewBookingScheduleBodyConfigurationRulesItemOffsetMax = 366;

export const previewBookingScheduleBodyConfigurationRulesItemChannelsMax = 2;

export const previewBookingScheduleBodyConfigurationRulesMax = 12;

export const previewBookingScheduleBodyConfigurationReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const previewBookingScheduleBodyConfigurationReleaseGraceMinutesMin = 0;
export const previewBookingScheduleBodyConfigurationReleaseGraceMinutesMax = 1440;



export const PreviewBookingScheduleBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "checkInRequired": zod.boolean(),
  "ruleDraft": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(previewBookingScheduleBodyRuleDraftHorizonDaysMin).max(previewBookingScheduleBodyRuleDraftHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(previewBookingScheduleBodyRuleDraftClaimMinutesBeforeStartMin).max(previewBookingScheduleBodyRuleDraftClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(previewBookingScheduleBodyRuleDraftEventReminderMinutesMin).max(previewBookingScheduleBodyRuleDraftEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(previewBookingScheduleBodyRuleDraftMinPeopleMin).max(previewBookingScheduleBodyRuleDraftMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(previewBookingScheduleBodyRuleDraftMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(previewBookingScheduleBodyRuleDraftNoShowGraceMinutesMin).max(previewBookingScheduleBodyRuleDraftNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(previewBookingScheduleBodyRuleDraftPriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(previewBookingScheduleBodyRuleDraftBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(previewBookingScheduleBodyRuleDraftNoShowLocalTimeRegExp).optional()
}).optional(),
  "expectedRuleRevision": zod.string().max(previewBookingScheduleBodyExpectedRuleRevisionMax).optional(),
  "configuration": zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(previewBookingScheduleBodyConfigurationCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(previewBookingScheduleBodyConfigurationCalendarWeekdaysItemMin).max(previewBookingScheduleBodyConfigurationCalendarWeekdaysItemMax)).min(1).max(previewBookingScheduleBodyConfigurationCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(previewBookingScheduleBodyConfigurationCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(previewBookingScheduleBodyConfigurationRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(previewBookingScheduleBodyConfigurationRulesItemTimeRegExp),
  "offset": zod.int().min(previewBookingScheduleBodyConfigurationRulesItemOffsetMin).max(previewBookingScheduleBodyConfigurationRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(previewBookingScheduleBodyConfigurationRulesItemChannelsMax)
})).max(previewBookingScheduleBodyConfigurationRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(previewBookingScheduleBodyConfigurationReleaseTimeRegExp),
  "graceMinutes": zod.int().min(previewBookingScheduleBodyConfigurationReleaseGraceMinutesMin).max(previewBookingScheduleBodyConfigurationReleaseGraceMinutesMax)
})
}).optional()
}).describe('Authorised draft preview only. Site zone is resolved by the server; preview never schedules a job or grants booking eligibility.'))()


export const previewBookingSchedule200ResponseRuleRevisionMax = 128;

export const previewBookingSchedule200ResponseTimeZoneMax = 100;

export const previewBookingSchedule200ResponseOccurrencesItemRuleIdMax = 128;

export const previewBookingSchedule200ResponseOccurrencesItemLocalDateTimeMax = 40;

export const previewBookingSchedule200ResponseOccurrencesItemReasonMax = 1000;

export const previewBookingSchedule200ResponseOccurrencesMax = 100;



export const PreviewBookingSchedule200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "bookingRevision": zod.int().min(1),
  "ruleRevision": zod.string().max(previewBookingSchedule200ResponseRuleRevisionMax),
  "timeZone": zod.string().max(previewBookingSchedule200ResponseTimeZoneMax),
  "checkInRequired": zod.boolean(),
  "checkInDeadline": zod.iso.datetime({"offset":true}).nullable(),
  "occurrences": zod.array(zod.object({
  "ruleId": zod.string().max(previewBookingSchedule200ResponseOccurrencesItemRuleIdMax),
  "channel": zod.enum(['email', 'application']),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "localDateTime": zod.string().max(previewBookingSchedule200ResponseOccurrencesItemLocalDateTimeMax),
  "resolution": zod.enum(['exact', 'gap_forward', 'overlap_earlier', 'elapsed', 'none']),
  "disposition": zod.enum(['scheduled', 'past', 'ended', 'cancelled', 'checked_in', 'duplicate', 'no_valid_release']),
  "reason": zod.string().max(previewBookingSchedule200ResponseOccurrencesItemReasonMax)
})).max(previewBookingSchedule200ResponseOccurrencesMax)
}))()

export const PreviewBookingSchedule403Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewBookingSchedule409Response = /*#__PURE__*/ (() => zod.unknown())()


export const getBookingSchedulePreferencesHeaderXGroupGraphTokenMax = 16384;


export const getBookingSchedulePreferencesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingSchedulePreferencesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingSchedulePreferencesHeaderXGroupGraphTokenMax).regex(getBookingSchedulePreferencesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingSchedulePreferences200ResponseRevisionMin = 0;

export const getBookingSchedulePreferences200ResponsePreferencesRulesItemRuleIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const getBookingSchedulePreferences200ResponsePreferencesRulesMax = 24;



export const GetBookingSchedulePreferences200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(getBookingSchedulePreferences200ResponseRevisionMin),
  "preferences": zod.object({
  "allOptionalEmail": zod.boolean(),
  "rules": zod.array(zod.object({
  "ruleId": zod.string().regex(getBookingSchedulePreferences200ResponsePreferencesRulesItemRuleIdRegExp),
  "channel": zod.enum(['application', 'email']),
  "enabled": zod.boolean()
})).max(getBookingSchedulePreferences200ResponsePreferencesRulesMax)
})
}))()

export const GetBookingSchedulePreferences403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingSchedulePreferences409Response = /*#__PURE__*/ (() => zod.unknown())()


export const saveBookingSchedulePreferencesHeaderXGroupGraphTokenMax = 16384;


export const saveBookingSchedulePreferencesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveBookingSchedulePreferencesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveBookingSchedulePreferencesHeaderXGroupGraphTokenMax).regex(saveBookingSchedulePreferencesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveBookingSchedulePreferencesBodyExpectedRevisionMin = 0;

export const saveBookingSchedulePreferencesBodyPreferencesRulesItemRuleIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const saveBookingSchedulePreferencesBodyPreferencesRulesMax = 24;



export const SaveBookingSchedulePreferencesBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveBookingSchedulePreferencesBodyExpectedRevisionMin),
  "preferences": zod.object({
  "allOptionalEmail": zod.boolean(),
  "rules": zod.array(zod.object({
  "ruleId": zod.string().regex(saveBookingSchedulePreferencesBodyPreferencesRulesItemRuleIdRegExp),
  "channel": zod.enum(['application', 'email']),
  "enabled": zod.boolean()
})).max(saveBookingSchedulePreferencesBodyPreferencesRulesMax)
})
}))()

export const saveBookingSchedulePreferences200ResponseRevisionMin = 0;

export const saveBookingSchedulePreferences200ResponsePreferencesRulesItemRuleIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const saveBookingSchedulePreferences200ResponsePreferencesRulesMax = 24;



export const SaveBookingSchedulePreferences200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(saveBookingSchedulePreferences200ResponseRevisionMin),
  "preferences": zod.object({
  "allOptionalEmail": zod.boolean(),
  "rules": zod.array(zod.object({
  "ruleId": zod.string().regex(saveBookingSchedulePreferences200ResponsePreferencesRulesItemRuleIdRegExp),
  "channel": zod.enum(['application', 'email']),
  "enabled": zod.boolean()
})).max(saveBookingSchedulePreferences200ResponsePreferencesRulesMax)
})
}))()

export const SaveBookingSchedulePreferences403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveBookingSchedulePreferences409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetBookingScheduleStatusParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBookingScheduleStatusQueryLimitMax = 100;

export const getBookingScheduleStatusQueryOffsetMin = 0;
export const getBookingScheduleStatusQueryOffsetMax = 100000;



export const GetBookingScheduleStatusQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getBookingScheduleStatusQueryLimitMax).optional(),
  "offset": zod.int().min(getBookingScheduleStatusQueryOffsetMin).max(getBookingScheduleStatusQueryOffsetMax).optional()
}))()

export const getBookingScheduleStatusHeaderXGroupGraphTokenMax = 16384;


export const getBookingScheduleStatusHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingScheduleStatusHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingScheduleStatusHeaderXGroupGraphTokenMax).regex(getBookingScheduleStatusHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingScheduleStatus200ResponseScheduleRevisionMin = 0;


export const getBookingScheduleStatus200ResponseSnapshotOneRuleRevisionMax = 128;

export const getBookingScheduleStatus200ResponseSnapshotOneTimeZoneMax = 100;

export const getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemRuleIdMax = 128;

export const getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemLocalDateTimeMax = 40;

export const getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemReasonMax = 1000;

export const getBookingScheduleStatus200ResponseSnapshotOneOccurrencesMax = 100;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarLabelMax = 120;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysItemMin = 0;
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysItemMax = 6;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysMax = 7;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarHolidaysMax = 1000;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemIdRegExp = new RegExp('^[a-z][a-z0-9_-]{0,63}$');
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemOffsetMin = 0;
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemOffsetMax = 366;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemChannelsMax = 2;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesMax = 12;

export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseGraceMinutesMin = 0;
export const getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseGraceMinutesMax = 1440;

export const getBookingScheduleStatus200ResponseItemsItemRuleIdsItemMax = 64;

export const getBookingScheduleStatus200ResponseItemsItemRuleIdsMax = 12;

export const getBookingScheduleStatus200ResponseItemsItemAttemptCountMin = 0;
export const getBookingScheduleStatus200ResponseItemsItemAttemptCountMax = 1000;

export const getBookingScheduleStatus200ResponseItemsItemLastOutcomeMax = 128;



export const getBookingScheduleStatus200ResponseItemsMax = 100;

export const getBookingScheduleStatus200ResponseTotalMin = 0;

export const getBookingScheduleStatus200ResponseLimitMax = 100;

export const getBookingScheduleStatus200ResponseOffsetMin = 0;
export const getBookingScheduleStatus200ResponseOffsetMax = 100000;



export const GetBookingScheduleStatus200Response = /*#__PURE__*/ (() => zod.object({
  "bookingId": zod.uuid(),
  "scheduleRevision": zod.int().min(getBookingScheduleStatus200ResponseScheduleRevisionMin),
  "snapshot": zod.union([zod.object({
  "version": zod.literal(1),
  "bookingRevision": zod.int().min(1),
  "ruleRevision": zod.string().max(getBookingScheduleStatus200ResponseSnapshotOneRuleRevisionMax),
  "timeZone": zod.string().max(getBookingScheduleStatus200ResponseSnapshotOneTimeZoneMax),
  "checkInRequired": zod.boolean(),
  "checkInDeadline": zod.iso.datetime({"offset":true}).nullable(),
  "occurrences": zod.array(zod.object({
  "ruleId": zod.string().max(getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemRuleIdMax),
  "channel": zod.enum(['email', 'application']),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "localDateTime": zod.string().max(getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemLocalDateTimeMax),
  "resolution": zod.enum(['exact', 'gap_forward', 'overlap_earlier', 'elapsed', 'none']),
  "disposition": zod.enum(['scheduled', 'past', 'ended', 'cancelled', 'checked_in', 'duplicate', 'no_valid_release']),
  "reason": zod.string().max(getBookingScheduleStatus200ResponseSnapshotOneOccurrencesItemReasonMax)
})).max(getBookingScheduleStatus200ResponseSnapshotOneOccurrencesMax),
  "configuration": zod.object({
  "version": zod.literal(1),
  "calendar": zod.object({
  "label": zod.string().min(1).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarLabelMax),
  "verified": zod.boolean(),
  "weekdays": zod.array(zod.int().min(getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysItemMin).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysItemMax)).min(1).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarWeekdaysMax),
  "holidays": zod.array(zod.iso.date()).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationCalendarHolidaysMax)
}),
  "rules": zod.array(zod.object({
  "id": zod.string().regex(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemIdRegExp),
  "enabled": zod.boolean(),
  "timing": zod.enum(['prior_business_day', 'booking_day', 'relative_hours', 'calendar_days', 'business_days']),
  "time": zod.string().regex(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemTimeRegExp),
  "offset": zod.int().min(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemOffsetMin).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemOffsetMax),
  "prompt": zod.boolean(),
  "channels": zod.array(zod.enum(['application', 'email'])).min(1).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesItemChannelsMax)
})).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationRulesMax),
  "release": zod.object({
  "enabled": zod.boolean(),
  "time": zod.string().regex(getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseTimeRegExp),
  "graceMinutes": zod.int().min(getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseGraceMinutesMin).max(getBookingScheduleStatus200ResponseSnapshotOneConfigurationReleaseGraceMinutesMax)
})
}),
  "capturedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "ruleIds": zod.array(zod.string().max(getBookingScheduleStatus200ResponseItemsItemRuleIdsItemMax)).max(getBookingScheduleStatus200ResponseItemsItemRuleIdsMax),
  "kind": zod.enum(['reminder', 'release', 'operational']),
  "channel": zod.enum(['application', 'email']),
  "dueAt": zod.iso.datetime({"offset":true}),
  "state": zod.enum(['pending', 'leased', 'sending', 'accepted', 'complete', 'unconfirmed', 'rejected', 'cancelled', 'skipped']),
  "attemptCount": zod.int().min(getBookingScheduleStatus200ResponseItemsItemAttemptCountMin).max(getBookingScheduleStatus200ResponseItemsItemAttemptCountMax),
  "lastOutcome": zod.string().max(getBookingScheduleStatus200ResponseItemsItemLastOutcomeMax).nullable(),
  "bookingRevision": zod.int().min(1),
  "scheduleRevision": zod.int().min(1)
})).max(getBookingScheduleStatus200ResponseItemsMax),
  "total": zod.int().min(getBookingScheduleStatus200ResponseTotalMin),
  "limit": zod.int().min(1).max(getBookingScheduleStatus200ResponseLimitMax),
  "offset": zod.int().min(getBookingScheduleStatus200ResponseOffsetMin).max(getBookingScheduleStatus200ResponseOffsetMax)
}))()

export const GetBookingScheduleStatus403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingScheduleStatus409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ListWayfindingNodesParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listWayfindingNodesQueryLimitMax = 25;

export const listWayfindingNodesQueryOffsetMin = 0;
export const listWayfindingNodesQueryOffsetMax = 1000;

export const listWayfindingNodesQueryQMax = 120;



export const ListWayfindingNodesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listWayfindingNodesQueryLimitMax).optional(),
  "offset": zod.int().min(listWayfindingNodesQueryOffsetMin).max(listWayfindingNodesQueryOffsetMax).optional(),
  "q": zod.string().max(listWayfindingNodesQueryQMax).optional()
}))()

export const listWayfindingNodesHeaderXGroupGraphTokenMax = 16384;


export const listWayfindingNodesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListWayfindingNodesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listWayfindingNodesHeaderXGroupGraphTokenMax).regex(listWayfindingNodesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listWayfindingNodes200ResponseItemsItemLabelMax = 160;

export const listWayfindingNodes200ResponseItemsItemXMin = 0;
export const listWayfindingNodes200ResponseItemsItemXMax = 1000;

export const listWayfindingNodes200ResponseItemsItemYMin = 0;
export const listWayfindingNodes200ResponseItemsItemYMax = 1000;

export const listWayfindingNodes200ResponseItemsMax = 25;



export const ListWayfindingNodes200Response = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean(),
  "publicationId": zod.uuid().nullable(),
  "items": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(listWayfindingNodes200ResponseItemsItemLabelMax),
  "x": zod.number().min(listWayfindingNodes200ResponseItemsItemXMin).max(listWayfindingNodes200ResponseItemsItemXMax),
  "y": zod.number().min(listWayfindingNodes200ResponseItemsItemYMin).max(listWayfindingNodes200ResponseItemsItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(listWayfindingNodes200ResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()


export const GetWayfindingRouteParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const GetWayfindingRouteQueryParams = /*#__PURE__*/ (() => zod.object({
  "fromNodeId": zod.uuid(),
  "toFloorId": zod.uuid(),
  "toNodeId": zod.uuid(),
  "accessible": zod.enum(['true', 'false']).optional()
}))()

export const getWayfindingRouteHeaderXGroupGraphTokenMax = 16384;


export const getWayfindingRouteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWayfindingRouteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWayfindingRouteHeaderXGroupGraphTokenMax).regex(getWayfindingRouteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getWayfindingRoute200ResponseVersionsMax = 20;

export const getWayfindingRoute200ResponseStepsItemFromXMin = 0;
export const getWayfindingRoute200ResponseStepsItemFromXMax = 1000;

export const getWayfindingRoute200ResponseStepsItemFromYMin = 0;
export const getWayfindingRoute200ResponseStepsItemFromYMax = 1000;

export const getWayfindingRoute200ResponseStepsItemToXMin = 0;
export const getWayfindingRoute200ResponseStepsItemToXMax = 1000;

export const getWayfindingRoute200ResponseStepsItemToYMin = 0;
export const getWayfindingRoute200ResponseStepsItemToYMax = 1000;

export const getWayfindingRoute200ResponseStepsMax = 4000;



export const GetWayfindingRoute200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['ok', 'unmapped', 'no_route', 'unavailable', 'too_large']),
  "message": zod.string(),
  "asOf": zod.iso.datetime({"offset":true}),
  "accessible": zod.boolean(),
  "versions": zod.array(zod.object({
  "floorId": zod.uuid(),
  "publicationId": zod.uuid(),
  "revision": zod.int(),
  "floorLabel": zod.string()
})).max(getWayfindingRoute200ResponseVersionsMax),
  "steps": zod.array(zod.object({
  "from": zod.object({
  "floorId": zod.uuid(),
  "nodeId": zod.uuid(),
  "label": zod.string(),
  "x": zod.number().min(getWayfindingRoute200ResponseStepsItemFromXMin).max(getWayfindingRoute200ResponseStepsItemFromXMax),
  "y": zod.number().min(getWayfindingRoute200ResponseStepsItemFromYMin).max(getWayfindingRoute200ResponseStepsItemFromYMax)
}),
  "to": zod.object({
  "floorId": zod.uuid(),
  "nodeId": zod.uuid(),
  "label": zod.string(),
  "x": zod.number().min(getWayfindingRoute200ResponseStepsItemToXMin).max(getWayfindingRoute200ResponseStepsItemToXMax),
  "y": zod.number().min(getWayfindingRoute200ResponseStepsItemToYMin).max(getWayfindingRoute200ResponseStepsItemToYMax)
}),
  "label": zod.string(),
  "kind": zod.enum(['walkway', 'stairs', 'lift']),
  "weight": zod.number()
})).max(getWayfindingRoute200ResponseStepsMax),
  "totalWeight": zod.number()
}))()


export const GetPublishedFloorMapParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getPublishedFloorMapHeaderXGroupGraphTokenMax = 16384;


export const getPublishedFloorMapHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetPublishedFloorMapHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getPublishedFloorMapHeaderXGroupGraphTokenMax).regex(getPublishedFloorMapHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getPublishedFloorMap200ResponseLegacyBookingViewRevisionMin = 0;

export const getPublishedFloorMap200ResponseRevisionMin = 0;

export const getPublishedFloorMap200ResponseDocumentOneImageOneDataMax = 6990508;

export const getPublishedFloorMap200ResponseDocumentOneImageOneWidthMax = 20000;

export const getPublishedFloorMap200ResponseDocumentOneImageOneHeightMax = 20000;

export const getPublishedFloorMap200ResponseDocumentOneImageOneFileNameMax = 255;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneSourceNameMax = 255;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneImageWidthMax = 20000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneImageHeightMax = 20000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesMax = 500;

export const getPublishedFloorMap200ResponseDocumentOnePinsItemXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePinsItemXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePinsItemYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePinsItemYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineMin = 3;
export const getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineMax = 12;

export const getPublishedFloorMap200ResponseDocumentOnePinsMax = 2000;

export const getPublishedFloorMap200ResponseDocumentOnePoisItemLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOnePoisItemXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePoisItemXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePoisItemYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOnePoisItemYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOnePoisItemContactLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOnePoisItemContactOwnerLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOnePoisMax = 300;

export const getPublishedFloorMap200ResponseDocumentOneLayersItemLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOneLayersItemSpaceIdsMax = 2000;

export const getPublishedFloorMap200ResponseDocumentOneLayersMax = 100;

export const getPublishedFloorMap200ResponseDocumentOneGraphReviewedByMax = 160;

export const getPublishedFloorMap200ResponseDocumentOneGraphNodesItemLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOneGraphNodesItemXMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGraphNodesItemXMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGraphNodesItemYMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGraphNodesItemYMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGraphNodesMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemWeightMax = 1000000;

export const getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemLabelMax = 160;

export const getPublishedFloorMap200ResponseDocumentOneGraphEdgesMax = 3000;

export const getPublishedFloorMap200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const getPublishedFloorMap200ResponseDocumentOneGraphConnectorsMax = 100;

export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;



export const GetPublishedFloorMap200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional(),
  "legacyBookingViewRevision": zod.int().min(getPublishedFloorMap200ResponseLegacyBookingViewRevisionMin).optional(),
  "wayfindingEnabled": zod.boolean().optional(),
  "authoringEnabled": zod.boolean().optional().describe('Present only on an authorised inventory draft read; effective publishing availability. Writes recheck current authority and configuration.'),
  "floorId": zod.uuid(),
  "revision": zod.int().min(getPublishedFloorMap200ResponseRevisionMin),
  "mode": zod.enum(['legacy', 'publication']),
  "publishedId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(getPublishedFloorMap200ResponseDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(getPublishedFloorMap200ResponseDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(getPublishedFloorMap200ResponseDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(getPublishedFloorMap200ResponseDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(getPublishedFloorMap200ResponseDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePinsItemXMin).max(getPublishedFloorMap200ResponseDocumentOnePinsItemXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePinsItemYMin).max(getPublishedFloorMap200ResponseDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemXMin).max(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemYMin).max(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineItemYMax)
})).min(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineMin).max(getPublishedFloorMap200ResponseDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(getPublishedFloorMap200ResponseDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOnePoisItemLabelMax),
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePoisItemXMin).max(getPublishedFloorMap200ResponseDocumentOnePoisItemXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOnePoisItemYMin).max(getPublishedFloorMap200ResponseDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(getPublishedFloorMap200ResponseDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(getPublishedFloorMap200ResponseDocumentOneLayersItemSpaceIdsMax)
})).max(getPublishedFloorMap200ResponseDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(getPublishedFloorMap200ResponseDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGraphNodesItemXMin).max(getPublishedFloorMap200ResponseDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(getPublishedFloorMap200ResponseDocumentOneGraphNodesItemYMin).max(getPublishedFloorMap200ResponseDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(getPublishedFloorMap200ResponseDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(getPublishedFloorMap200ResponseDocumentOneGraphEdgesItemLabelMax)
})).max(getPublishedFloorMap200ResponseDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(getPublishedFloorMap200ResponseDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(getPublishedFloorMap200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const SaveLegacyFloorBookingViewParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveLegacyFloorBookingViewHeaderXGroupGraphTokenMax = 16384;


export const saveLegacyFloorBookingViewHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveLegacyFloorBookingViewHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveLegacyFloorBookingViewHeaderXGroupGraphTokenMax).regex(saveLegacyFloorBookingViewHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveLegacyFloorBookingViewBodyExpectedRevisionMin = 0;



export const SaveLegacyFloorBookingViewBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveLegacyFloorBookingViewBodyExpectedRevisionMin),
  "bookingView": zod.enum(['full', 'trimmed'])
}))()

export const saveLegacyFloorBookingView200ResponseLegacyBookingViewRevisionMin = 0;

export const saveLegacyFloorBookingView200ResponseRevisionMin = 0;

export const saveLegacyFloorBookingView200ResponseDocumentOneImageOneDataMax = 6990508;

export const saveLegacyFloorBookingView200ResponseDocumentOneImageOneWidthMax = 20000;

export const saveLegacyFloorBookingView200ResponseDocumentOneImageOneHeightMax = 20000;

export const saveLegacyFloorBookingView200ResponseDocumentOneImageOneFileNameMax = 255;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneSourceNameMax = 255;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneImageWidthMax = 20000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneImageHeightMax = 20000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesMax = 500;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineMin = 3;
export const saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineMax = 12;

export const saveLegacyFloorBookingView200ResponseDocumentOnePinsMax = 2000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemContactLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisItemContactOwnerLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOnePoisMax = 300;

export const saveLegacyFloorBookingView200ResponseDocumentOneLayersItemLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOneLayersItemSpaceIdsMax = 2000;

export const saveLegacyFloorBookingView200ResponseDocumentOneLayersMax = 100;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphReviewedByMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemXMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemXMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemYMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemYMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemWeightMax = 1000000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemLabelMax = 160;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesMax = 3000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsMax = 100;

export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;



export const SaveLegacyFloorBookingView200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional(),
  "legacyBookingViewRevision": zod.int().min(saveLegacyFloorBookingView200ResponseLegacyBookingViewRevisionMin).optional(),
  "wayfindingEnabled": zod.boolean().optional(),
  "authoringEnabled": zod.boolean().optional().describe('Present only on an authorised inventory draft read; effective publishing availability. Writes recheck current authority and configuration.'),
  "floorId": zod.uuid(),
  "revision": zod.int().min(saveLegacyFloorBookingView200ResponseRevisionMin),
  "mode": zod.enum(['legacy', 'publication']),
  "publishedId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(saveLegacyFloorBookingView200ResponseDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(saveLegacyFloorBookingView200ResponseDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(saveLegacyFloorBookingView200ResponseDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemXMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemYMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemXMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemYMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineItemYMax)
})).min(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(saveLegacyFloorBookingView200ResponseDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemLabelMax),
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemXMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemYMin).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(saveLegacyFloorBookingView200ResponseDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(saveLegacyFloorBookingView200ResponseDocumentOneLayersItemSpaceIdsMax)
})).max(saveLegacyFloorBookingView200ResponseDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(saveLegacyFloorBookingView200ResponseDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemXMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemYMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesItemLabelMax)
})).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(saveLegacyFloorBookingView200ResponseDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(saveLegacyFloorBookingView200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetFloorMapDraftParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorMapDraftHeaderXGroupGraphTokenMax = 16384;


export const getFloorMapDraftHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorMapDraftHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorMapDraftHeaderXGroupGraphTokenMax).regex(getFloorMapDraftHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getFloorMapDraft200ResponseLegacyBookingViewRevisionMin = 0;

export const getFloorMapDraft200ResponseRevisionMin = 0;

export const getFloorMapDraft200ResponseDocumentOneImageOneDataMax = 6990508;

export const getFloorMapDraft200ResponseDocumentOneImageOneWidthMax = 20000;

export const getFloorMapDraft200ResponseDocumentOneImageOneHeightMax = 20000;

export const getFloorMapDraft200ResponseDocumentOneImageOneFileNameMax = 255;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneSourceNameMax = 255;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneImageWidthMax = 20000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneImageHeightMax = 20000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesMax = 500;

export const getFloorMapDraft200ResponseDocumentOnePinsItemXMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePinsItemXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePinsItemYMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePinsItemYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineMin = 3;
export const getFloorMapDraft200ResponseDocumentOnePinsItemOutlineMax = 12;

export const getFloorMapDraft200ResponseDocumentOnePinsMax = 2000;

export const getFloorMapDraft200ResponseDocumentOnePoisItemLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOnePoisItemXMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePoisItemXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePoisItemYMin = 0;
export const getFloorMapDraft200ResponseDocumentOnePoisItemYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOnePoisItemContactLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOnePoisItemContactOwnerLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOnePoisMax = 300;

export const getFloorMapDraft200ResponseDocumentOneLayersItemLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOneLayersItemSpaceIdsMax = 2000;

export const getFloorMapDraft200ResponseDocumentOneLayersMax = 100;

export const getFloorMapDraft200ResponseDocumentOneGraphReviewedByMax = 160;

export const getFloorMapDraft200ResponseDocumentOneGraphNodesItemLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOneGraphNodesItemXMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGraphNodesItemXMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGraphNodesItemYMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGraphNodesItemYMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGraphNodesMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightMax = 1000000;

export const getFloorMapDraft200ResponseDocumentOneGraphEdgesItemLabelMax = 160;

export const getFloorMapDraft200ResponseDocumentOneGraphEdgesMax = 3000;

export const getFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const getFloorMapDraft200ResponseDocumentOneGraphConnectorsMax = 100;

export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;



export const GetFloorMapDraft200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional(),
  "legacyBookingViewRevision": zod.int().min(getFloorMapDraft200ResponseLegacyBookingViewRevisionMin).optional(),
  "wayfindingEnabled": zod.boolean().optional(),
  "authoringEnabled": zod.boolean().optional().describe('Present only on an authorised inventory draft read; effective publishing availability. Writes recheck current authority and configuration.'),
  "floorId": zod.uuid(),
  "revision": zod.int().min(getFloorMapDraft200ResponseRevisionMin),
  "mode": zod.enum(['legacy', 'publication']),
  "publishedId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(getFloorMapDraft200ResponseDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(getFloorMapDraft200ResponseDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(getFloorMapDraft200ResponseDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(getFloorMapDraft200ResponseDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(getFloorMapDraft200ResponseDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(getFloorMapDraft200ResponseDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(getFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOnePinsItemXMin).max(getFloorMapDraft200ResponseDocumentOnePinsItemXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOnePinsItemYMin).max(getFloorMapDraft200ResponseDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMin).max(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMin).max(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMax)
})).min(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineMin).max(getFloorMapDraft200ResponseDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(getFloorMapDraft200ResponseDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOnePoisItemLabelMax),
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOnePoisItemXMin).max(getFloorMapDraft200ResponseDocumentOnePoisItemXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOnePoisItemYMin).max(getFloorMapDraft200ResponseDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(getFloorMapDraft200ResponseDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(getFloorMapDraft200ResponseDocumentOneLayersItemSpaceIdsMax)
})).max(getFloorMapDraft200ResponseDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(getFloorMapDraft200ResponseDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(getFloorMapDraft200ResponseDocumentOneGraphNodesItemXMin).max(getFloorMapDraft200ResponseDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(getFloorMapDraft200ResponseDocumentOneGraphNodesItemYMin).max(getFloorMapDraft200ResponseDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(getFloorMapDraft200ResponseDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(getFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(getFloorMapDraft200ResponseDocumentOneGraphEdgesItemLabelMax)
})).max(getFloorMapDraft200ResponseDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(getFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(getFloorMapDraft200ResponseDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(getFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const SaveFloorMapDraftParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveFloorMapDraftHeaderXGroupGraphTokenMax = 16384;


export const saveFloorMapDraftHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveFloorMapDraftHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveFloorMapDraftHeaderXGroupGraphTokenMax).regex(saveFloorMapDraftHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveFloorMapDraftBodyExpectedRevisionMin = 0;

export const saveFloorMapDraftBodyDocumentImageOneDataMax = 6990508;

export const saveFloorMapDraftBodyDocumentImageOneWidthMax = 20000;

export const saveFloorMapDraftBodyDocumentImageOneHeightMax = 20000;

export const saveFloorMapDraftBodyDocumentImageOneFileNameMax = 255;

export const saveFloorMapDraftBodyDocumentGeometryOneSourceNameMax = 255;

export const saveFloorMapDraftBodyDocumentGeometryOneImageWidthMax = 20000;

export const saveFloorMapDraftBodyDocumentGeometryOneImageHeightMax = 20000;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemCodeMax = 64;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemLabelMax = 200;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemXMin = 0;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemYMin = 0;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonMin = 3;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonMax = 24;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneXMin = 0;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneXMax = 1000;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneYMin = 0;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneYMax = 1000;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemHeightMetersMin = 0;
export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemHeightMetersMax = 10;

export const saveFloorMapDraftBodyDocumentGeometryOneFeaturesMax = 500;

export const saveFloorMapDraftBodyDocumentPinsItemXMin = 0;
export const saveFloorMapDraftBodyDocumentPinsItemXMax = 1000;

export const saveFloorMapDraftBodyDocumentPinsItemYMin = 0;
export const saveFloorMapDraftBodyDocumentPinsItemYMax = 1000;

export const saveFloorMapDraftBodyDocumentPinsItemOutlineItemXMin = 0;
export const saveFloorMapDraftBodyDocumentPinsItemOutlineItemXMax = 1000;

export const saveFloorMapDraftBodyDocumentPinsItemOutlineItemYMin = 0;
export const saveFloorMapDraftBodyDocumentPinsItemOutlineItemYMax = 1000;

export const saveFloorMapDraftBodyDocumentPinsItemOutlineMin = 3;
export const saveFloorMapDraftBodyDocumentPinsItemOutlineMax = 12;

export const saveFloorMapDraftBodyDocumentPinsMax = 2000;

export const saveFloorMapDraftBodyDocumentPoisItemLabelMax = 160;

export const saveFloorMapDraftBodyDocumentPoisItemXMin = 0;
export const saveFloorMapDraftBodyDocumentPoisItemXMax = 1000;

export const saveFloorMapDraftBodyDocumentPoisItemYMin = 0;
export const saveFloorMapDraftBodyDocumentPoisItemYMax = 1000;

export const saveFloorMapDraftBodyDocumentPoisItemContactLabelMax = 160;

export const saveFloorMapDraftBodyDocumentPoisItemContactOwnerLabelMax = 160;

export const saveFloorMapDraftBodyDocumentPoisMax = 300;

export const saveFloorMapDraftBodyDocumentLayersItemLabelMax = 160;

export const saveFloorMapDraftBodyDocumentLayersItemSpaceIdsMax = 2000;

export const saveFloorMapDraftBodyDocumentLayersMax = 100;

export const saveFloorMapDraftBodyDocumentGraphReviewedByMax = 160;

export const saveFloorMapDraftBodyDocumentGraphNodesItemLabelMax = 160;

export const saveFloorMapDraftBodyDocumentGraphNodesItemXMin = 0;
export const saveFloorMapDraftBodyDocumentGraphNodesItemXMax = 1000;

export const saveFloorMapDraftBodyDocumentGraphNodesItemYMin = 0;
export const saveFloorMapDraftBodyDocumentGraphNodesItemYMax = 1000;

export const saveFloorMapDraftBodyDocumentGraphNodesMax = 1000;

export const saveFloorMapDraftBodyDocumentGraphEdgesItemWeightExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentGraphEdgesItemWeightMax = 1000000;

export const saveFloorMapDraftBodyDocumentGraphEdgesItemLabelMax = 160;

export const saveFloorMapDraftBodyDocumentGraphEdgesMax = 3000;

export const saveFloorMapDraftBodyDocumentGraphConnectorsItemWeightExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentGraphConnectorsItemWeightMax = 1000000;

export const saveFloorMapDraftBodyDocumentGraphConnectorsMax = 100;

export const saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneWidthMax = 1000;

export const saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneHeightMax = 1000;

export const saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneWidthMax = 1000;

export const saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneHeightMax = 1000;



export const SaveFloorMapDraftBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveFloorMapDraftBodyExpectedRevisionMin),
  "document": zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(saveFloorMapDraftBodyDocumentImageOneDataMax),
  "width": zod.int().min(1).max(saveFloorMapDraftBodyDocumentImageOneWidthMax),
  "height": zod.int().min(1).max(saveFloorMapDraftBodyDocumentImageOneHeightMax),
  "fileName": zod.string().max(saveFloorMapDraftBodyDocumentImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(saveFloorMapDraftBodyDocumentGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(saveFloorMapDraftBodyDocumentGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(saveFloorMapDraftBodyDocumentGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemXMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemYMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonItemYMax)
})).min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneXMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneYMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemHeightMetersMin).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesItemHeightMetersMax)
})).max(saveFloorMapDraftBodyDocumentGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(saveFloorMapDraftBodyDocumentPinsItemXMin).max(saveFloorMapDraftBodyDocumentPinsItemXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentPinsItemYMin).max(saveFloorMapDraftBodyDocumentPinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(saveFloorMapDraftBodyDocumentPinsItemOutlineItemXMin).max(saveFloorMapDraftBodyDocumentPinsItemOutlineItemXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentPinsItemOutlineItemYMin).max(saveFloorMapDraftBodyDocumentPinsItemOutlineItemYMax)
})).min(saveFloorMapDraftBodyDocumentPinsItemOutlineMin).max(saveFloorMapDraftBodyDocumentPinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(saveFloorMapDraftBodyDocumentPinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentPoisItemLabelMax),
  "x": zod.number().min(saveFloorMapDraftBodyDocumentPoisItemXMin).max(saveFloorMapDraftBodyDocumentPoisItemXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentPoisItemYMin).max(saveFloorMapDraftBodyDocumentPoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentPoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(saveFloorMapDraftBodyDocumentPoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(saveFloorMapDraftBodyDocumentPoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(saveFloorMapDraftBodyDocumentLayersItemSpaceIdsMax)
})).max(saveFloorMapDraftBodyDocumentLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(saveFloorMapDraftBodyDocumentGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentGraphNodesItemLabelMax),
  "x": zod.number().min(saveFloorMapDraftBodyDocumentGraphNodesItemXMin).max(saveFloorMapDraftBodyDocumentGraphNodesItemXMax),
  "y": zod.number().min(saveFloorMapDraftBodyDocumentGraphNodesItemYMin).max(saveFloorMapDraftBodyDocumentGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(saveFloorMapDraftBodyDocumentGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(saveFloorMapDraftBodyDocumentGraphEdgesItemWeightExclusiveMin).max(saveFloorMapDraftBodyDocumentGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(saveFloorMapDraftBodyDocumentGraphEdgesItemLabelMax)
})).max(saveFloorMapDraftBodyDocumentGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(saveFloorMapDraftBodyDocumentGraphConnectorsItemWeightExclusiveMin).max(saveFloorMapDraftBodyDocumentGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(saveFloorMapDraftBodyDocumentGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneWidthExclusiveMin).max(saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneHeightExclusiveMin).max(saveFloorMapDraftBodyDocumentStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneWidthExclusiveMin).max(saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneHeightExclusiveMin).max(saveFloorMapDraftBodyDocumentStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
})
}))()

export const saveFloorMapDraft200ResponseLegacyBookingViewRevisionMin = 0;

export const saveFloorMapDraft200ResponseRevisionMin = 0;

export const saveFloorMapDraft200ResponseDocumentOneImageOneDataMax = 6990508;

export const saveFloorMapDraft200ResponseDocumentOneImageOneWidthMax = 20000;

export const saveFloorMapDraft200ResponseDocumentOneImageOneHeightMax = 20000;

export const saveFloorMapDraft200ResponseDocumentOneImageOneFileNameMax = 255;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneSourceNameMax = 255;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneImageWidthMax = 20000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneImageHeightMax = 20000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesMax = 500;

export const saveFloorMapDraft200ResponseDocumentOnePinsItemXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePinsItemXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePinsItemYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePinsItemYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineMin = 3;
export const saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineMax = 12;

export const saveFloorMapDraft200ResponseDocumentOnePinsMax = 2000;

export const saveFloorMapDraft200ResponseDocumentOnePoisItemLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOnePoisItemXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePoisItemXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePoisItemYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOnePoisItemYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOnePoisItemContactLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOnePoisItemContactOwnerLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOnePoisMax = 300;

export const saveFloorMapDraft200ResponseDocumentOneLayersItemLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOneLayersItemSpaceIdsMax = 2000;

export const saveFloorMapDraft200ResponseDocumentOneLayersMax = 100;

export const saveFloorMapDraft200ResponseDocumentOneGraphReviewedByMax = 160;

export const saveFloorMapDraft200ResponseDocumentOneGraphNodesItemLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOneGraphNodesItemXMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGraphNodesItemXMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGraphNodesItemYMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGraphNodesItemYMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGraphNodesMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightMax = 1000000;

export const saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemLabelMax = 160;

export const saveFloorMapDraft200ResponseDocumentOneGraphEdgesMax = 3000;

export const saveFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const saveFloorMapDraft200ResponseDocumentOneGraphConnectorsMax = 100;

export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;



export const SaveFloorMapDraft200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional(),
  "legacyBookingViewRevision": zod.int().min(saveFloorMapDraft200ResponseLegacyBookingViewRevisionMin).optional(),
  "wayfindingEnabled": zod.boolean().optional(),
  "authoringEnabled": zod.boolean().optional().describe('Present only on an authorised inventory draft read; effective publishing availability. Writes recheck current authority and configuration.'),
  "floorId": zod.uuid(),
  "revision": zod.int().min(saveFloorMapDraft200ResponseRevisionMin),
  "mode": zod.enum(['legacy', 'publication']),
  "publishedId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(saveFloorMapDraft200ResponseDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(saveFloorMapDraft200ResponseDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(saveFloorMapDraft200ResponseDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(saveFloorMapDraft200ResponseDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(saveFloorMapDraft200ResponseDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePinsItemXMin).max(saveFloorMapDraft200ResponseDocumentOnePinsItemXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePinsItemYMin).max(saveFloorMapDraft200ResponseDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMin).max(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMin).max(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineItemYMax)
})).min(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineMin).max(saveFloorMapDraft200ResponseDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(saveFloorMapDraft200ResponseDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOnePoisItemLabelMax),
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePoisItemXMin).max(saveFloorMapDraft200ResponseDocumentOnePoisItemXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOnePoisItemYMin).max(saveFloorMapDraft200ResponseDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(saveFloorMapDraft200ResponseDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(saveFloorMapDraft200ResponseDocumentOneLayersItemSpaceIdsMax)
})).max(saveFloorMapDraft200ResponseDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(saveFloorMapDraft200ResponseDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGraphNodesItemXMin).max(saveFloorMapDraft200ResponseDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(saveFloorMapDraft200ResponseDocumentOneGraphNodesItemYMin).max(saveFloorMapDraft200ResponseDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(saveFloorMapDraft200ResponseDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(saveFloorMapDraft200ResponseDocumentOneGraphEdgesItemLabelMax)
})).max(saveFloorMapDraft200ResponseDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(saveFloorMapDraft200ResponseDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(saveFloorMapDraft200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const PreviewFloorMapChangeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const previewFloorMapChangeHeaderXGroupGraphTokenMax = 16384;


export const previewFloorMapChangeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewFloorMapChangeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewFloorMapChangeHeaderXGroupGraphTokenMax).regex(previewFloorMapChangeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewFloorMapChangeBodyExpectedRevisionMin = 0;

export const previewFloorMapChangeBodyDocumentImageOneDataMax = 6990508;

export const previewFloorMapChangeBodyDocumentImageOneWidthMax = 20000;

export const previewFloorMapChangeBodyDocumentImageOneHeightMax = 20000;

export const previewFloorMapChangeBodyDocumentImageOneFileNameMax = 255;

export const previewFloorMapChangeBodyDocumentGeometryOneSourceNameMax = 255;

export const previewFloorMapChangeBodyDocumentGeometryOneImageWidthMax = 20000;

export const previewFloorMapChangeBodyDocumentGeometryOneImageHeightMax = 20000;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemCodeMax = 64;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemLabelMax = 200;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemXMin = 0;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemYMin = 0;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonMin = 3;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonMax = 24;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneXMin = 0;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneXMax = 1000;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneYMin = 0;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneYMax = 1000;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemHeightMetersMin = 0;
export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemHeightMetersMax = 10;

export const previewFloorMapChangeBodyDocumentGeometryOneFeaturesMax = 500;

export const previewFloorMapChangeBodyDocumentPinsItemXMin = 0;
export const previewFloorMapChangeBodyDocumentPinsItemXMax = 1000;

export const previewFloorMapChangeBodyDocumentPinsItemYMin = 0;
export const previewFloorMapChangeBodyDocumentPinsItemYMax = 1000;

export const previewFloorMapChangeBodyDocumentPinsItemOutlineItemXMin = 0;
export const previewFloorMapChangeBodyDocumentPinsItemOutlineItemXMax = 1000;

export const previewFloorMapChangeBodyDocumentPinsItemOutlineItemYMin = 0;
export const previewFloorMapChangeBodyDocumentPinsItemOutlineItemYMax = 1000;

export const previewFloorMapChangeBodyDocumentPinsItemOutlineMin = 3;
export const previewFloorMapChangeBodyDocumentPinsItemOutlineMax = 12;

export const previewFloorMapChangeBodyDocumentPinsMax = 2000;

export const previewFloorMapChangeBodyDocumentPoisItemLabelMax = 160;

export const previewFloorMapChangeBodyDocumentPoisItemXMin = 0;
export const previewFloorMapChangeBodyDocumentPoisItemXMax = 1000;

export const previewFloorMapChangeBodyDocumentPoisItemYMin = 0;
export const previewFloorMapChangeBodyDocumentPoisItemYMax = 1000;

export const previewFloorMapChangeBodyDocumentPoisItemContactLabelMax = 160;

export const previewFloorMapChangeBodyDocumentPoisItemContactOwnerLabelMax = 160;

export const previewFloorMapChangeBodyDocumentPoisMax = 300;

export const previewFloorMapChangeBodyDocumentLayersItemLabelMax = 160;

export const previewFloorMapChangeBodyDocumentLayersItemSpaceIdsMax = 2000;

export const previewFloorMapChangeBodyDocumentLayersMax = 100;

export const previewFloorMapChangeBodyDocumentGraphReviewedByMax = 160;

export const previewFloorMapChangeBodyDocumentGraphNodesItemLabelMax = 160;

export const previewFloorMapChangeBodyDocumentGraphNodesItemXMin = 0;
export const previewFloorMapChangeBodyDocumentGraphNodesItemXMax = 1000;

export const previewFloorMapChangeBodyDocumentGraphNodesItemYMin = 0;
export const previewFloorMapChangeBodyDocumentGraphNodesItemYMax = 1000;

export const previewFloorMapChangeBodyDocumentGraphNodesMax = 1000;

export const previewFloorMapChangeBodyDocumentGraphEdgesItemWeightExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentGraphEdgesItemWeightMax = 1000000;

export const previewFloorMapChangeBodyDocumentGraphEdgesItemLabelMax = 160;

export const previewFloorMapChangeBodyDocumentGraphEdgesMax = 3000;

export const previewFloorMapChangeBodyDocumentGraphConnectorsItemWeightExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentGraphConnectorsItemWeightMax = 1000000;

export const previewFloorMapChangeBodyDocumentGraphConnectorsMax = 100;

export const previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneWidthMax = 1000;

export const previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneHeightMax = 1000;

export const previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneWidthMax = 1000;

export const previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneHeightMax = 1000;



export const PreviewFloorMapChangeBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(previewFloorMapChangeBodyExpectedRevisionMin),
  "action": zod.enum(['enable', 'publish', 'restore', 'unpublish', 'import', 'discard']),
  "publicationId": zod.uuid().optional(),
  "document": zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(previewFloorMapChangeBodyDocumentImageOneDataMax),
  "width": zod.int().min(1).max(previewFloorMapChangeBodyDocumentImageOneWidthMax),
  "height": zod.int().min(1).max(previewFloorMapChangeBodyDocumentImageOneHeightMax),
  "fileName": zod.string().max(previewFloorMapChangeBodyDocumentImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(previewFloorMapChangeBodyDocumentGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(previewFloorMapChangeBodyDocumentGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(previewFloorMapChangeBodyDocumentGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemXMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemYMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonItemYMax)
})).min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneXMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneYMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemHeightMetersMin).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesItemHeightMetersMax)
})).max(previewFloorMapChangeBodyDocumentGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(previewFloorMapChangeBodyDocumentPinsItemXMin).max(previewFloorMapChangeBodyDocumentPinsItemXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentPinsItemYMin).max(previewFloorMapChangeBodyDocumentPinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(previewFloorMapChangeBodyDocumentPinsItemOutlineItemXMin).max(previewFloorMapChangeBodyDocumentPinsItemOutlineItemXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentPinsItemOutlineItemYMin).max(previewFloorMapChangeBodyDocumentPinsItemOutlineItemYMax)
})).min(previewFloorMapChangeBodyDocumentPinsItemOutlineMin).max(previewFloorMapChangeBodyDocumentPinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(previewFloorMapChangeBodyDocumentPinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentPoisItemLabelMax),
  "x": zod.number().min(previewFloorMapChangeBodyDocumentPoisItemXMin).max(previewFloorMapChangeBodyDocumentPoisItemXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentPoisItemYMin).max(previewFloorMapChangeBodyDocumentPoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentPoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(previewFloorMapChangeBodyDocumentPoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(previewFloorMapChangeBodyDocumentPoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(previewFloorMapChangeBodyDocumentLayersItemSpaceIdsMax)
})).max(previewFloorMapChangeBodyDocumentLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(previewFloorMapChangeBodyDocumentGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentGraphNodesItemLabelMax),
  "x": zod.number().min(previewFloorMapChangeBodyDocumentGraphNodesItemXMin).max(previewFloorMapChangeBodyDocumentGraphNodesItemXMax),
  "y": zod.number().min(previewFloorMapChangeBodyDocumentGraphNodesItemYMin).max(previewFloorMapChangeBodyDocumentGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(previewFloorMapChangeBodyDocumentGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(previewFloorMapChangeBodyDocumentGraphEdgesItemWeightExclusiveMin).max(previewFloorMapChangeBodyDocumentGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(previewFloorMapChangeBodyDocumentGraphEdgesItemLabelMax)
})).max(previewFloorMapChangeBodyDocumentGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(previewFloorMapChangeBodyDocumentGraphConnectorsItemWeightExclusiveMin).max(previewFloorMapChangeBodyDocumentGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(previewFloorMapChangeBodyDocumentGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneWidthExclusiveMin).max(previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneHeightExclusiveMin).max(previewFloorMapChangeBodyDocumentStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneWidthExclusiveMin).max(previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneHeightExclusiveMin).max(previewFloorMapChangeBodyDocumentStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}).optional()
}))()

export const previewFloorMapChange200ResponsePreviewDocumentOneImageOneDataMax = 6990508;

export const previewFloorMapChange200ResponsePreviewDocumentOneImageOneWidthMax = 20000;

export const previewFloorMapChange200ResponsePreviewDocumentOneImageOneHeightMax = 20000;

export const previewFloorMapChange200ResponsePreviewDocumentOneImageOneFileNameMax = 255;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneSourceNameMax = 255;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneImageWidthMax = 20000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneImageHeightMax = 20000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesMax = 500;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineMin = 3;
export const previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineMax = 12;

export const previewFloorMapChange200ResponsePreviewDocumentOnePinsMax = 2000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemContactLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisItemContactOwnerLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOnePoisMax = 300;

export const previewFloorMapChange200ResponsePreviewDocumentOneLayersItemLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOneLayersItemSpaceIdsMax = 2000;

export const previewFloorMapChange200ResponsePreviewDocumentOneLayersMax = 100;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphReviewedByMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemXMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemXMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemYMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemYMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemWeightMax = 1000000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemLabelMax = 160;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesMax = 3000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsMax = 100;

export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;

export const previewFloorMapChange200ResponseExpectedRevisionMin = 0;

export const previewFloorMapChange200ResponseRemovedSpaceIdsMax = 2000;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemSelectedBeforeRevisionMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemSelectedAfterRevisionMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBeforeRevisionMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemAfterRevisionMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBookingImpactCancellationCountMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBookingImpactUnderwayCountMin = 0;

export const previewFloorMapChange200ResponseLifecyclePreviewsMax = 2001;

export const previewFloorMapChange200ResponseWarningsMax = 20;



export const PreviewFloorMapChange200Response = /*#__PURE__*/ (() => zod.object({
  "previewDocument": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(previewFloorMapChange200ResponsePreviewDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(previewFloorMapChange200ResponsePreviewDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneXMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneYMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(previewFloorMapChange200ResponsePreviewDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemXMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemYMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemXMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemYMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineItemYMax)
})).min(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(previewFloorMapChange200ResponsePreviewDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemLabelMax),
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemXMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemYMin).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(previewFloorMapChange200ResponsePreviewDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(previewFloorMapChange200ResponsePreviewDocumentOneLayersItemSpaceIdsMax)
})).max(previewFloorMapChange200ResponsePreviewDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(previewFloorMapChange200ResponsePreviewDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemXMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemYMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemWeightExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesItemLabelMax)
})).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsItemWeightExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(previewFloorMapChange200ResponsePreviewDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(previewFloorMapChange200ResponsePreviewDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]).optional().describe('Exact reviewed target with current public contact filtering; never changes the draft or publication.'),
  "reviewId": zod.uuid(),
  "expectedRevision": zod.int().min(previewFloorMapChange200ResponseExpectedRevisionMin),
  "fingerprint": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.string(),
  "removedSpaceIds": zod.array(zod.uuid()).max(previewFloorMapChange200ResponseRemovedSpaceIdsMax),
  "lifecyclePreviews": zod.array(zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "selectedBefore": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemSelectedBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "selectedAfter": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemSelectedAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "counts": zod.record(zod.string(), zod.int()),
  "children": zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(previewFloorMapChange200ResponseLifecyclePreviewsItemChildrenItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}),
  "bookingImpact": zod.object({
  "available": zod.boolean(),
  "cancellationCount": zod.int().nullable(),
  "underwayCount": zod.int().nullable(),
  "revision": zod.string().nullable(),
  "bookings": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}).optional()
}),
  "confirmationAvailable": zod.boolean(),
  "explanation": zod.string()
})).max(previewFloorMapChange200ResponseLifecyclePreviewsMax),
  "warnings": zod.array(zod.string()).max(previewFloorMapChange200ResponseWarningsMax)
}))()


export const ConfirmFloorMapChangeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const confirmFloorMapChangeHeaderXGroupGraphTokenMax = 16384;


export const confirmFloorMapChangeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ConfirmFloorMapChangeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(confirmFloorMapChangeHeaderXGroupGraphTokenMax).regex(confirmFloorMapChangeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const confirmFloorMapChangeBodyFingerprintMin = 64;
export const confirmFloorMapChangeBodyFingerprintMax = 64;



export const ConfirmFloorMapChangeBody = /*#__PURE__*/ (() => zod.object({
  "reviewId": zod.uuid(),
  "fingerprint": zod.string().min(confirmFloorMapChangeBodyFingerprintMin).max(confirmFloorMapChangeBodyFingerprintMax)
}))()

export const confirmFloorMapChange200ResponseLegacyBookingViewRevisionMin = 0;

export const confirmFloorMapChange200ResponseRevisionMin = 0;

export const confirmFloorMapChange200ResponseDocumentOneImageOneDataMax = 6990508;

export const confirmFloorMapChange200ResponseDocumentOneImageOneWidthMax = 20000;

export const confirmFloorMapChange200ResponseDocumentOneImageOneHeightMax = 20000;

export const confirmFloorMapChange200ResponseDocumentOneImageOneFileNameMax = 255;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneSourceNameMax = 255;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneImageWidthMax = 20000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneImageHeightMax = 20000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemCodeMax = 64;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemLabelMax = 200;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin = 3;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax = 24;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax = 10;

export const confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesMax = 500;

export const confirmFloorMapChange200ResponseDocumentOnePinsItemXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePinsItemXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePinsItemYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePinsItemYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineMin = 3;
export const confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineMax = 12;

export const confirmFloorMapChange200ResponseDocumentOnePinsMax = 2000;

export const confirmFloorMapChange200ResponseDocumentOnePoisItemLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOnePoisItemXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePoisItemXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePoisItemYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOnePoisItemYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOnePoisItemContactLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOnePoisItemContactOwnerLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOnePoisMax = 300;

export const confirmFloorMapChange200ResponseDocumentOneLayersItemLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOneLayersItemSpaceIdsMax = 2000;

export const confirmFloorMapChange200ResponseDocumentOneLayersMax = 100;

export const confirmFloorMapChange200ResponseDocumentOneGraphReviewedByMax = 160;

export const confirmFloorMapChange200ResponseDocumentOneGraphNodesItemLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOneGraphNodesItemXMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGraphNodesItemXMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGraphNodesItemYMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGraphNodesItemYMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGraphNodesMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemWeightMax = 1000000;

export const confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemLabelMax = 160;

export const confirmFloorMapChange200ResponseDocumentOneGraphEdgesMax = 3000;

export const confirmFloorMapChange200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneGraphConnectorsItemWeightMax = 1000000;

export const confirmFloorMapChange200ResponseDocumentOneGraphConnectorsMax = 100;

export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneWidthMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneHeightMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax = 1000;

export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax = 1000;



export const ConfirmFloorMapChange200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional(),
  "legacyBookingViewRevision": zod.int().min(confirmFloorMapChange200ResponseLegacyBookingViewRevisionMin).optional(),
  "wayfindingEnabled": zod.boolean().optional(),
  "authoringEnabled": zod.boolean().optional().describe('Present only on an authorised inventory draft read; effective publishing availability. Writes recheck current authority and configuration.'),
  "floorId": zod.uuid(),
  "revision": zod.int().min(confirmFloorMapChange200ResponseRevisionMin),
  "mode": zod.enum(['legacy', 'publication']),
  "publishedId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(confirmFloorMapChange200ResponseDocumentOneImageOneDataMax),
  "width": zod.int().min(1).max(confirmFloorMapChange200ResponseDocumentOneImageOneWidthMax),
  "height": zod.int().min(1).max(confirmFloorMapChange200ResponseDocumentOneImageOneHeightMax),
  "fileName": zod.string().max(confirmFloorMapChange200ResponseDocumentOneImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonItemYMax)
})).min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMin).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesItemHeightMetersMax)
})).max(confirmFloorMapChange200ResponseDocumentOneGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePinsItemXMin).max(confirmFloorMapChange200ResponseDocumentOnePinsItemXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePinsItemYMin).max(confirmFloorMapChange200ResponseDocumentOnePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemXMin).max(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemYMin).max(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineItemYMax)
})).min(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineMin).max(confirmFloorMapChange200ResponseDocumentOnePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(confirmFloorMapChange200ResponseDocumentOnePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOnePoisItemLabelMax),
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePoisItemXMin).max(confirmFloorMapChange200ResponseDocumentOnePoisItemXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOnePoisItemYMin).max(confirmFloorMapChange200ResponseDocumentOnePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOnePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOnePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(confirmFloorMapChange200ResponseDocumentOnePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(confirmFloorMapChange200ResponseDocumentOneLayersItemSpaceIdsMax)
})).max(confirmFloorMapChange200ResponseDocumentOneLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(confirmFloorMapChange200ResponseDocumentOneGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneGraphNodesItemLabelMax),
  "x": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGraphNodesItemXMin).max(confirmFloorMapChange200ResponseDocumentOneGraphNodesItemXMax),
  "y": zod.number().min(confirmFloorMapChange200ResponseDocumentOneGraphNodesItemYMin).max(confirmFloorMapChange200ResponseDocumentOneGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(confirmFloorMapChange200ResponseDocumentOneGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemWeightExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(confirmFloorMapChange200ResponseDocumentOneGraphEdgesItemLabelMax)
})).max(confirmFloorMapChange200ResponseDocumentOneGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneGraphConnectorsItemWeightExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(confirmFloorMapChange200ResponseDocumentOneGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneWidthExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneHeightExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneWidthExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneHeightExclusiveMin).max(confirmFloorMapChange200ResponseDocumentOneStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const ExportFloorMapParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const exportFloorMapHeaderXGroupGraphTokenMax = 16384;


export const exportFloorMapHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportFloorMapHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportFloorMapHeaderXGroupGraphTokenMax).regex(exportFloorMapHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const exportFloorMap200ResponseImageOneDataMax = 6990508;

export const exportFloorMap200ResponseImageOneWidthMax = 20000;

export const exportFloorMap200ResponseImageOneHeightMax = 20000;

export const exportFloorMap200ResponseImageOneFileNameMax = 255;

export const exportFloorMap200ResponseGeometryOneSourceNameMax = 255;

export const exportFloorMap200ResponseGeometryOneImageWidthMax = 20000;

export const exportFloorMap200ResponseGeometryOneImageHeightMax = 20000;

export const exportFloorMap200ResponseGeometryOneFeaturesItemCodeMax = 64;

export const exportFloorMap200ResponseGeometryOneFeaturesItemLabelMax = 200;

export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemXMin = 0;
export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemXMax = 1000;

export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemYMin = 0;
export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemYMax = 1000;

export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonMin = 3;
export const exportFloorMap200ResponseGeometryOneFeaturesItemPolygonMax = 24;

export const exportFloorMap200ResponseGeometryOneFeaturesItemPinOneXMin = 0;
export const exportFloorMap200ResponseGeometryOneFeaturesItemPinOneXMax = 1000;

export const exportFloorMap200ResponseGeometryOneFeaturesItemPinOneYMin = 0;
export const exportFloorMap200ResponseGeometryOneFeaturesItemPinOneYMax = 1000;

export const exportFloorMap200ResponseGeometryOneFeaturesItemHeightMetersMin = 0;
export const exportFloorMap200ResponseGeometryOneFeaturesItemHeightMetersMax = 10;

export const exportFloorMap200ResponseGeometryOneFeaturesMax = 500;

export const exportFloorMap200ResponsePinsItemXMin = 0;
export const exportFloorMap200ResponsePinsItemXMax = 1000;

export const exportFloorMap200ResponsePinsItemYMin = 0;
export const exportFloorMap200ResponsePinsItemYMax = 1000;

export const exportFloorMap200ResponsePinsItemOutlineItemXMin = 0;
export const exportFloorMap200ResponsePinsItemOutlineItemXMax = 1000;

export const exportFloorMap200ResponsePinsItemOutlineItemYMin = 0;
export const exportFloorMap200ResponsePinsItemOutlineItemYMax = 1000;

export const exportFloorMap200ResponsePinsItemOutlineMin = 3;
export const exportFloorMap200ResponsePinsItemOutlineMax = 12;

export const exportFloorMap200ResponsePinsMax = 2000;

export const exportFloorMap200ResponsePoisItemLabelMax = 160;

export const exportFloorMap200ResponsePoisItemXMin = 0;
export const exportFloorMap200ResponsePoisItemXMax = 1000;

export const exportFloorMap200ResponsePoisItemYMin = 0;
export const exportFloorMap200ResponsePoisItemYMax = 1000;

export const exportFloorMap200ResponsePoisItemContactLabelMax = 160;

export const exportFloorMap200ResponsePoisItemContactOwnerLabelMax = 160;

export const exportFloorMap200ResponsePoisMax = 300;

export const exportFloorMap200ResponseLayersItemLabelMax = 160;

export const exportFloorMap200ResponseLayersItemSpaceIdsMax = 2000;

export const exportFloorMap200ResponseLayersMax = 100;

export const exportFloorMap200ResponseGraphReviewedByMax = 160;

export const exportFloorMap200ResponseGraphNodesItemLabelMax = 160;

export const exportFloorMap200ResponseGraphNodesItemXMin = 0;
export const exportFloorMap200ResponseGraphNodesItemXMax = 1000;

export const exportFloorMap200ResponseGraphNodesItemYMin = 0;
export const exportFloorMap200ResponseGraphNodesItemYMax = 1000;

export const exportFloorMap200ResponseGraphNodesMax = 1000;

export const exportFloorMap200ResponseGraphEdgesItemWeightExclusiveMin = 0;
export const exportFloorMap200ResponseGraphEdgesItemWeightMax = 1000000;

export const exportFloorMap200ResponseGraphEdgesItemLabelMax = 160;

export const exportFloorMap200ResponseGraphEdgesMax = 3000;

export const exportFloorMap200ResponseGraphConnectorsItemWeightExclusiveMin = 0;
export const exportFloorMap200ResponseGraphConnectorsItemWeightMax = 1000000;

export const exportFloorMap200ResponseGraphConnectorsMax = 100;

export const exportFloorMap200ResponseStandardOutlinesDeskOneWidthExclusiveMin = 0;
export const exportFloorMap200ResponseStandardOutlinesDeskOneWidthMax = 1000;

export const exportFloorMap200ResponseStandardOutlinesDeskOneHeightExclusiveMin = 0;
export const exportFloorMap200ResponseStandardOutlinesDeskOneHeightMax = 1000;

export const exportFloorMap200ResponseStandardOutlinesOfficeOneWidthExclusiveMin = 0;
export const exportFloorMap200ResponseStandardOutlinesOfficeOneWidthMax = 1000;

export const exportFloorMap200ResponseStandardOutlinesOfficeOneHeightExclusiveMin = 0;
export const exportFloorMap200ResponseStandardOutlinesOfficeOneHeightMax = 1000;



export const ExportFloorMap200Response = /*#__PURE__*/ (() => zod.object({
  "bookingView": zod.enum(['full', 'trimmed']).optional().describe('Absent means trimmed.'),
  "version": zod.literal(1),
  "floorId": zod.uuid(),
  "image": zod.union([zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/svg+xml']),
  "data": zod.string().max(exportFloorMap200ResponseImageOneDataMax),
  "width": zod.int().min(1).max(exportFloorMap200ResponseImageOneWidthMax),
  "height": zod.int().min(1).max(exportFloorMap200ResponseImageOneHeightMax),
  "fileName": zod.string().max(exportFloorMap200ResponseImageOneFileNameMax).nullable()
}),zod.null()]),
  "geometry": zod.union([zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(exportFloorMap200ResponseGeometryOneSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(exportFloorMap200ResponseGeometryOneImageWidthMax),
  "imageHeight": zod.int().min(1).max(exportFloorMap200ResponseGeometryOneImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(exportFloorMap200ResponseGeometryOneFeaturesItemCodeMax),
  "label": zod.string().min(1).max(exportFloorMap200ResponseGeometryOneFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemXMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemXMax),
  "y": zod.number().min(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemYMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonItemYMax)
})).min(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(exportFloorMap200ResponseGeometryOneFeaturesItemPinOneXMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemPinOneXMax),
  "y": zod.number().min(exportFloorMap200ResponseGeometryOneFeaturesItemPinOneYMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(exportFloorMap200ResponseGeometryOneFeaturesItemHeightMetersMin).max(exportFloorMap200ResponseGeometryOneFeaturesItemHeightMetersMax)
})).max(exportFloorMap200ResponseGeometryOneFeaturesMax)
}),zod.null()]),
  "pins": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "x": zod.number().min(exportFloorMap200ResponsePinsItemXMin).max(exportFloorMap200ResponsePinsItemXMax),
  "y": zod.number().min(exportFloorMap200ResponsePinsItemYMin).max(exportFloorMap200ResponsePinsItemYMax),
  "outline": zod.array(zod.object({
  "x": zod.number().min(exportFloorMap200ResponsePinsItemOutlineItemXMin).max(exportFloorMap200ResponsePinsItemOutlineItemXMax),
  "y": zod.number().min(exportFloorMap200ResponsePinsItemOutlineItemYMin).max(exportFloorMap200ResponsePinsItemOutlineItemYMax)
})).min(exportFloorMap200ResponsePinsItemOutlineMin).max(exportFloorMap200ResponsePinsItemOutlineMax).optional().describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.')
})).max(exportFloorMap200ResponsePinsMax),
  "pois": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['exit', 'first_aid', 'first_aider', 'printer', 'extinguisher', 'aed', 'kitchen']),
  "label": zod.string().min(1).max(exportFloorMap200ResponsePoisItemLabelMax),
  "x": zod.number().min(exportFloorMap200ResponsePoisItemXMin).max(exportFloorMap200ResponsePoisItemXMax),
  "y": zod.number().min(exportFloorMap200ResponsePoisItemYMin).max(exportFloorMap200ResponsePoisItemYMax),
  "contact": zod.object({
  "label": zod.string().min(1).max(exportFloorMap200ResponsePoisItemContactLabelMax),
  "personal": zod.boolean(),
  "publishPersonal": zod.boolean(),
  "ownerLabel": zod.string().min(1).max(exportFloorMap200ResponsePoisItemContactOwnerLabelMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}).optional()
})).max(exportFloorMap200ResponsePoisMax),
  "layers": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['department', 'team', 'neighbourhood']),
  "label": zod.string().min(1).max(exportFloorMap200ResponseLayersItemLabelMax),
  "spaceIds": zod.array(zod.uuid()).max(exportFloorMap200ResponseLayersItemSpaceIdsMax)
})).max(exportFloorMap200ResponseLayersMax),
  "graph": zod.object({
  "version": zod.literal(1),
  "reviewed": zod.boolean(),
  "reviewedBy": zod.string().max(exportFloorMap200ResponseGraphReviewedByMax),
  "nodes": zod.array(zod.object({
  "accessible": zod.boolean().optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "label": zod.string().min(1).max(exportFloorMap200ResponseGraphNodesItemLabelMax),
  "x": zod.number().min(exportFloorMap200ResponseGraphNodesItemXMin).max(exportFloorMap200ResponseGraphNodesItemXMax),
  "y": zod.number().min(exportFloorMap200ResponseGraphNodesItemYMin).max(exportFloorMap200ResponseGraphNodesItemYMax),
  "kind": zod.enum(['entrance', 'landmark', 'junction', 'destination', 'stairs', 'lift']),
  "spaceId": zod.uuid().nullable(),
  "poiId": zod.uuid().nullable()
})).max(exportFloorMap200ResponseGraphNodesMax),
  "edges": zod.array(zod.object({
  "weight": zod.number().gt(exportFloorMap200ResponseGraphEdgesItemWeightExclusiveMin).max(exportFloorMap200ResponseGraphEdgesItemWeightMax).optional().describe('Positive reviewed route cost; omitted legacy values cost 1. Not a distance.'),
  "kind": zod.enum(['walkway', 'stairs', 'lift']).optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "from": zod.uuid(),
  "to": zod.uuid(),
  "accessible": zod.boolean(),
  "blocked": zod.boolean(),
  "label": zod.string().min(1).max(exportFloorMap200ResponseGraphEdgesItemLabelMax)
})).max(exportFloorMap200ResponseGraphEdgesMax),
  "connectors": zod.array(zod.object({
  "bidirectional": zod.boolean().optional().describe('Explicitly reviewed return travel using the same compatible publication pair; default false.'),
  "weight": zod.number().gt(exportFloorMap200ResponseGraphConnectorsItemWeightExclusiveMin).max(exportFloorMap200ResponseGraphConnectorsItemWeightMax).optional(),
  "blocked": zod.boolean().optional(),
  "closureZoneId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "nodeId": zod.uuid(),
  "peerFloorId": zod.uuid(),
  "peerNodeId": zod.uuid(),
  "peerPublicationId": zod.uuid(),
  "kind": zod.enum(['stairs', 'lift']),
  "accessible": zod.boolean()
})).max(exportFloorMap200ResponseGraphConnectorsMax)
}),
  "standardOutlines": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(exportFloorMap200ResponseStandardOutlinesDeskOneWidthExclusiveMin).max(exportFloorMap200ResponseStandardOutlinesDeskOneWidthMax),
  "height": zod.number().gt(exportFloorMap200ResponseStandardOutlinesDeskOneHeightExclusiveMin).max(exportFloorMap200ResponseStandardOutlinesDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(exportFloorMap200ResponseStandardOutlinesOfficeOneWidthExclusiveMin).max(exportFloorMap200ResponseStandardOutlinesOfficeOneWidthMax),
  "height": zod.number().gt(exportFloorMap200ResponseStandardOutlinesOfficeOneHeightExclusiveMin).max(exportFloorMap200ResponseStandardOutlinesOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).optional().describe('Null or absent classes use the organisation default.')
}))()


export const ListFloorMapPublicationsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listFloorMapPublicationsQueryLimitDefault = 25;
export const listFloorMapPublicationsQueryLimitMax = 100;

export const listFloorMapPublicationsQueryOffsetDefault = 0;
export const listFloorMapPublicationsQueryOffsetMin = 0;
export const listFloorMapPublicationsQueryOffsetMax = 100000;



export const ListFloorMapPublicationsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listFloorMapPublicationsQueryLimitMax).default(listFloorMapPublicationsQueryLimitDefault),
  "offset": zod.int().min(listFloorMapPublicationsQueryOffsetMin).max(listFloorMapPublicationsQueryOffsetMax).default(listFloorMapPublicationsQueryOffsetDefault)
}))()

export const listFloorMapPublicationsHeaderXGroupGraphTokenMax = 16384;


export const listFloorMapPublicationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListFloorMapPublicationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listFloorMapPublicationsHeaderXGroupGraphTokenMax).regex(listFloorMapPublicationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listFloorMapPublications200ResponseItemsMax = 100;



export const ListFloorMapPublications200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int(),
  "sha256": zod.string(),
  "restoredFrom": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listFloorMapPublications200ResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()


/**
 * Read-only backup readiness. All backup paths are contract-only and unmounted in the foundation.
 */
export const GetTenantBackupReadinessParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const getTenantBackupReadiness200ResponseCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupReadiness200ResponseBlockersItemMax = 1000;

export const getTenantBackupReadiness200ResponseBlockersMax = 1000;



export const GetTenantBackupReadiness200Response = /*#__PURE__*/ (() => zod.object({
  "exportEnabled": zod.literal(false),
  "restoreEnabled": zod.literal(false),
  "coverageRevision": zod.string().regex(getTenantBackupReadiness200ResponseCoverageRevisionRegExp),
  "blockers": zod.array(zod.string().max(getTenantBackupReadiness200ResponseBlockersItemMax)).max(getTenantBackupReadiness200ResponseBlockersMax)
}))()

export const GetTenantBackupReadiness403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantBackupReadiness409Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantBackupReadiness503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Actor-bound idempotent export. Capture all reviewed families in one repeatable-read snapshot, reconcile canonical rows and content-addressed bytes, then atomically publish private chunks. Execution remains gated until the remaining safety gates pass.
 */
export const CreateTenantBackupExportParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const CreateTenantBackupExportBody = /*#__PURE__*/ (() => zod.object({
  "idempotencyKey": zod.uuid()
}))()

export const createTenantBackupExport202ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenantBackupExport202ResponseManifestEntityIdsMax = 10000;

export const createTenantBackupExport202ResponseManifestApplicationVersionMax = 100;

export const createTenantBackupExport202ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenantBackupExport202ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenantBackupExport202ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenantBackupExport202ResponseManifestIdentitiesMax = 100000;

export const createTenantBackupExport202ResponseManifestEntriesItemPathMax = 200;


export const createTenantBackupExport202ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const createTenantBackupExport202ResponseManifestEntriesItemTableMax = 100;


export const createTenantBackupExport202ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const createTenantBackupExport202ResponseManifestEntriesItemRecordCountMin = 0;
export const createTenantBackupExport202ResponseManifestEntriesItemRecordCountMax = 1000000;

export const createTenantBackupExport202ResponseManifestEntriesItemByteSizeMin = 0;
export const createTenantBackupExport202ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const createTenantBackupExport202ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenantBackupExport202ResponseManifestEntriesItemRecordKeyMax = 500;

export const createTenantBackupExport202ResponseManifestEntriesItemFieldMax = 100;

export const createTenantBackupExport202ResponseManifestEntriesItemContentTypeMax = 200;

export const createTenantBackupExport202ResponseManifestEntriesMax = 100000;

export const createTenantBackupExport202ResponseManifestExclusionsItemTableMax = 100;

export const createTenantBackupExport202ResponseManifestExclusionsItemFieldsItemMax = 100;

export const createTenantBackupExport202ResponseManifestExclusionsItemFieldsMax = 200;

export const createTenantBackupExport202ResponseManifestExclusionsItemReasonMax = 1000;

export const createTenantBackupExport202ResponseManifestExclusionsMax = 1000;

export const createTenantBackupExport202ResponseManifestExternalReconciliationItemMax = 1000;

export const createTenantBackupExport202ResponseManifestExternalReconciliationMax = 100000;

export const createTenantBackupExport202ResponseBlockersItemMax = 1000;

export const createTenantBackupExport202ResponseBlockersMax = 1000;

export const createTenantBackupExport202ResponseErrorCodeMax = 100;



export const CreateTenantBackupExport202Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(createTenantBackupExport202ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(createTenantBackupExport202ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(createTenantBackupExport202ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(createTenantBackupExport202ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(createTenantBackupExport202ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(createTenantBackupExport202ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(createTenantBackupExport202ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(createTenantBackupExport202ResponseManifestEntriesItemPathMax).regex(createTenantBackupExport202ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(createTenantBackupExport202ResponseManifestEntriesItemTableMax).regex(createTenantBackupExport202ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(createTenantBackupExport202ResponseManifestEntriesItemRecordCountMin).max(createTenantBackupExport202ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(createTenantBackupExport202ResponseManifestEntriesItemByteSizeMin).max(createTenantBackupExport202ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(createTenantBackupExport202ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(createTenantBackupExport202ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(createTenantBackupExport202ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(createTenantBackupExport202ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(createTenantBackupExport202ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(createTenantBackupExport202ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(createTenantBackupExport202ResponseManifestExclusionsItemFieldsItemMax)).max(createTenantBackupExport202ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(createTenantBackupExport202ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(createTenantBackupExport202ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(createTenantBackupExport202ResponseManifestExternalReconciliationItemMax)).max(createTenantBackupExport202ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(createTenantBackupExport202ResponseBlockersItemMax)).max(createTenantBackupExport202ResponseBlockersMax),
  "errorCode": zod.string().max(createTenantBackupExport202ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const CreateTenantBackupExport403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateTenantBackupExport409Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateTenantBackupExport503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Private bounded version-1 ZIP32 upload using stored entries only. Reject compression, encryption, descriptors, links, unsafe paths, duplicates, unknown entries and noncanonical JSON before private staging. Maximum archive 256 MiB; authenticate and authorize before multipart parsing. The idempotency key must identify the same archive digest. No business writes.
 */
export const UploadTenantBackupParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const UploadTenantBackupBody = /*#__PURE__*/ (() => zod.object({
  "archive": zod.instanceof(Blob),
  "idempotencyKey": zod.uuid()
}))()

export const uploadTenantBackup202ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenantBackup202ResponseManifestEntityIdsMax = 10000;

export const uploadTenantBackup202ResponseManifestApplicationVersionMax = 100;

export const uploadTenantBackup202ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenantBackup202ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenantBackup202ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenantBackup202ResponseManifestIdentitiesMax = 100000;

export const uploadTenantBackup202ResponseManifestEntriesItemPathMax = 200;


export const uploadTenantBackup202ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const uploadTenantBackup202ResponseManifestEntriesItemTableMax = 100;


export const uploadTenantBackup202ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const uploadTenantBackup202ResponseManifestEntriesItemRecordCountMin = 0;
export const uploadTenantBackup202ResponseManifestEntriesItemRecordCountMax = 1000000;

export const uploadTenantBackup202ResponseManifestEntriesItemByteSizeMin = 0;
export const uploadTenantBackup202ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const uploadTenantBackup202ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenantBackup202ResponseManifestEntriesItemRecordKeyMax = 500;

export const uploadTenantBackup202ResponseManifestEntriesItemFieldMax = 100;

export const uploadTenantBackup202ResponseManifestEntriesItemContentTypeMax = 200;

export const uploadTenantBackup202ResponseManifestEntriesMax = 100000;

export const uploadTenantBackup202ResponseManifestExclusionsItemTableMax = 100;

export const uploadTenantBackup202ResponseManifestExclusionsItemFieldsItemMax = 100;

export const uploadTenantBackup202ResponseManifestExclusionsItemFieldsMax = 200;

export const uploadTenantBackup202ResponseManifestExclusionsItemReasonMax = 1000;

export const uploadTenantBackup202ResponseManifestExclusionsMax = 1000;

export const uploadTenantBackup202ResponseManifestExternalReconciliationItemMax = 1000;

export const uploadTenantBackup202ResponseManifestExternalReconciliationMax = 100000;

export const uploadTenantBackup202ResponseBlockersItemMax = 1000;

export const uploadTenantBackup202ResponseBlockersMax = 1000;

export const uploadTenantBackup202ResponseErrorCodeMax = 100;



export const UploadTenantBackup202Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(uploadTenantBackup202ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(uploadTenantBackup202ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(uploadTenantBackup202ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(uploadTenantBackup202ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(uploadTenantBackup202ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(uploadTenantBackup202ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(uploadTenantBackup202ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(uploadTenantBackup202ResponseManifestEntriesItemPathMax).regex(uploadTenantBackup202ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(uploadTenantBackup202ResponseManifestEntriesItemTableMax).regex(uploadTenantBackup202ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(uploadTenantBackup202ResponseManifestEntriesItemRecordCountMin).max(uploadTenantBackup202ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(uploadTenantBackup202ResponseManifestEntriesItemByteSizeMin).max(uploadTenantBackup202ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(uploadTenantBackup202ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(uploadTenantBackup202ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(uploadTenantBackup202ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(uploadTenantBackup202ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(uploadTenantBackup202ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(uploadTenantBackup202ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(uploadTenantBackup202ResponseManifestExclusionsItemFieldsItemMax)).max(uploadTenantBackup202ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(uploadTenantBackup202ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(uploadTenantBackup202ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(uploadTenantBackup202ResponseManifestExternalReconciliationItemMax)).max(uploadTenantBackup202ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(uploadTenantBackup202ResponseBlockersItemMax)).max(uploadTenantBackup202ResponseBlockersMax),
  "errorCode": zod.string().max(uploadTenantBackup202ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const UploadTenantBackup403Response = /*#__PURE__*/ (() => zod.unknown())()

export const UploadTenantBackup409Response = /*#__PURE__*/ (() => zod.unknown())()

export const UploadTenantBackup503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Read-only recovery after a lost export or upload response. Look up the exact original actor, tenant, kind and request key without reserving, uploading, capturing or replaying anything. A missing operation is not permission to retry automatically.
 */
export const FindTenantBackupRequestParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "requestKey": zod.uuid()
}))()

export const FindTenantBackupRequestQueryParams = /*#__PURE__*/ (() => zod.object({
  "kind": zod.enum(['export', 'import'])
}))()

export const findTenantBackupRequest200ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const findTenantBackupRequest200ResponseManifestEntityIdsMax = 10000;

export const findTenantBackupRequest200ResponseManifestApplicationVersionMax = 100;

export const findTenantBackupRequest200ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const findTenantBackupRequest200ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const findTenantBackupRequest200ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const findTenantBackupRequest200ResponseManifestIdentitiesMax = 100000;

export const findTenantBackupRequest200ResponseManifestEntriesItemPathMax = 200;


export const findTenantBackupRequest200ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const findTenantBackupRequest200ResponseManifestEntriesItemTableMax = 100;


export const findTenantBackupRequest200ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const findTenantBackupRequest200ResponseManifestEntriesItemRecordCountMin = 0;
export const findTenantBackupRequest200ResponseManifestEntriesItemRecordCountMax = 1000000;

export const findTenantBackupRequest200ResponseManifestEntriesItemByteSizeMin = 0;
export const findTenantBackupRequest200ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const findTenantBackupRequest200ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const findTenantBackupRequest200ResponseManifestEntriesItemRecordKeyMax = 500;

export const findTenantBackupRequest200ResponseManifestEntriesItemFieldMax = 100;

export const findTenantBackupRequest200ResponseManifestEntriesItemContentTypeMax = 200;

export const findTenantBackupRequest200ResponseManifestEntriesMax = 100000;

export const findTenantBackupRequest200ResponseManifestExclusionsItemTableMax = 100;

export const findTenantBackupRequest200ResponseManifestExclusionsItemFieldsItemMax = 100;

export const findTenantBackupRequest200ResponseManifestExclusionsItemFieldsMax = 200;

export const findTenantBackupRequest200ResponseManifestExclusionsItemReasonMax = 1000;

export const findTenantBackupRequest200ResponseManifestExclusionsMax = 1000;

export const findTenantBackupRequest200ResponseManifestExternalReconciliationItemMax = 1000;

export const findTenantBackupRequest200ResponseManifestExternalReconciliationMax = 100000;

export const findTenantBackupRequest200ResponseBlockersItemMax = 1000;

export const findTenantBackupRequest200ResponseBlockersMax = 1000;

export const findTenantBackupRequest200ResponseErrorCodeMax = 100;



export const FindTenantBackupRequest200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(findTenantBackupRequest200ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(findTenantBackupRequest200ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(findTenantBackupRequest200ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(findTenantBackupRequest200ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(findTenantBackupRequest200ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(findTenantBackupRequest200ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(findTenantBackupRequest200ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(findTenantBackupRequest200ResponseManifestEntriesItemPathMax).regex(findTenantBackupRequest200ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(findTenantBackupRequest200ResponseManifestEntriesItemTableMax).regex(findTenantBackupRequest200ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(findTenantBackupRequest200ResponseManifestEntriesItemRecordCountMin).max(findTenantBackupRequest200ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(findTenantBackupRequest200ResponseManifestEntriesItemByteSizeMin).max(findTenantBackupRequest200ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(findTenantBackupRequest200ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(findTenantBackupRequest200ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(findTenantBackupRequest200ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(findTenantBackupRequest200ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(findTenantBackupRequest200ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(findTenantBackupRequest200ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(findTenantBackupRequest200ResponseManifestExclusionsItemFieldsItemMax)).max(findTenantBackupRequest200ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(findTenantBackupRequest200ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(findTenantBackupRequest200ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(findTenantBackupRequest200ResponseManifestExternalReconciliationItemMax)).max(findTenantBackupRequest200ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(findTenantBackupRequest200ResponseBlockersItemMax)).max(findTenantBackupRequest200ResponseBlockersMax),
  "errorCode": zod.string().max(findTenantBackupRequest200ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const FindTenantBackupRequest403Response = /*#__PURE__*/ (() => zod.unknown())()

export const FindTenantBackupRequest404Response = /*#__PURE__*/ (() => zod.unknown())()

export const FindTenantBackupRequest503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Actor-bound authenticated uncertain-outcome recovery; a status read never retries a write.
 */
export const GetTenantBackupOperationParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const getTenantBackupOperation200ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupOperation200ResponseManifestEntityIdsMax = 10000;

export const getTenantBackupOperation200ResponseManifestApplicationVersionMax = 100;

export const getTenantBackupOperation200ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupOperation200ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupOperation200ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupOperation200ResponseManifestIdentitiesMax = 100000;

export const getTenantBackupOperation200ResponseManifestEntriesItemPathMax = 200;


export const getTenantBackupOperation200ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const getTenantBackupOperation200ResponseManifestEntriesItemTableMax = 100;


export const getTenantBackupOperation200ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const getTenantBackupOperation200ResponseManifestEntriesItemRecordCountMin = 0;
export const getTenantBackupOperation200ResponseManifestEntriesItemRecordCountMax = 1000000;

export const getTenantBackupOperation200ResponseManifestEntriesItemByteSizeMin = 0;
export const getTenantBackupOperation200ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const getTenantBackupOperation200ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenantBackupOperation200ResponseManifestEntriesItemRecordKeyMax = 500;

export const getTenantBackupOperation200ResponseManifestEntriesItemFieldMax = 100;

export const getTenantBackupOperation200ResponseManifestEntriesItemContentTypeMax = 200;

export const getTenantBackupOperation200ResponseManifestEntriesMax = 100000;

export const getTenantBackupOperation200ResponseManifestExclusionsItemTableMax = 100;

export const getTenantBackupOperation200ResponseManifestExclusionsItemFieldsItemMax = 100;

export const getTenantBackupOperation200ResponseManifestExclusionsItemFieldsMax = 200;

export const getTenantBackupOperation200ResponseManifestExclusionsItemReasonMax = 1000;

export const getTenantBackupOperation200ResponseManifestExclusionsMax = 1000;

export const getTenantBackupOperation200ResponseManifestExternalReconciliationItemMax = 1000;

export const getTenantBackupOperation200ResponseManifestExternalReconciliationMax = 100000;

export const getTenantBackupOperation200ResponseBlockersItemMax = 1000;

export const getTenantBackupOperation200ResponseBlockersMax = 1000;

export const getTenantBackupOperation200ResponseErrorCodeMax = 100;



export const GetTenantBackupOperation200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(getTenantBackupOperation200ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(getTenantBackupOperation200ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(getTenantBackupOperation200ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(getTenantBackupOperation200ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(getTenantBackupOperation200ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(getTenantBackupOperation200ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(getTenantBackupOperation200ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(getTenantBackupOperation200ResponseManifestEntriesItemPathMax).regex(getTenantBackupOperation200ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(getTenantBackupOperation200ResponseManifestEntriesItemTableMax).regex(getTenantBackupOperation200ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(getTenantBackupOperation200ResponseManifestEntriesItemRecordCountMin).max(getTenantBackupOperation200ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(getTenantBackupOperation200ResponseManifestEntriesItemByteSizeMin).max(getTenantBackupOperation200ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(getTenantBackupOperation200ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(getTenantBackupOperation200ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(getTenantBackupOperation200ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(getTenantBackupOperation200ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(getTenantBackupOperation200ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(getTenantBackupOperation200ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(getTenantBackupOperation200ResponseManifestExclusionsItemFieldsItemMax)).max(getTenantBackupOperation200ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(getTenantBackupOperation200ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(getTenantBackupOperation200ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(getTenantBackupOperation200ResponseManifestExternalReconciliationItemMax)).max(getTenantBackupOperation200ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(getTenantBackupOperation200ResponseBlockersItemMax)).max(getTenantBackupOperation200ResponseBlockersMax),
  "errorCode": zod.string().max(getTenantBackupOperation200ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const GetTenantBackupOperation403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantBackupOperation409Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantBackupOperation503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Cancel uncommitted work and expire private staged bytes; never cancel or replay a committed restore.
 */
export const CancelTenantBackupOperationParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const cancelTenantBackupOperation200ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenantBackupOperation200ResponseManifestEntityIdsMax = 10000;

export const cancelTenantBackupOperation200ResponseManifestApplicationVersionMax = 100;

export const cancelTenantBackupOperation200ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenantBackupOperation200ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenantBackupOperation200ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenantBackupOperation200ResponseManifestIdentitiesMax = 100000;

export const cancelTenantBackupOperation200ResponseManifestEntriesItemPathMax = 200;


export const cancelTenantBackupOperation200ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const cancelTenantBackupOperation200ResponseManifestEntriesItemTableMax = 100;


export const cancelTenantBackupOperation200ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const cancelTenantBackupOperation200ResponseManifestEntriesItemRecordCountMin = 0;
export const cancelTenantBackupOperation200ResponseManifestEntriesItemRecordCountMax = 1000000;

export const cancelTenantBackupOperation200ResponseManifestEntriesItemByteSizeMin = 0;
export const cancelTenantBackupOperation200ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const cancelTenantBackupOperation200ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenantBackupOperation200ResponseManifestEntriesItemRecordKeyMax = 500;

export const cancelTenantBackupOperation200ResponseManifestEntriesItemFieldMax = 100;

export const cancelTenantBackupOperation200ResponseManifestEntriesItemContentTypeMax = 200;

export const cancelTenantBackupOperation200ResponseManifestEntriesMax = 100000;

export const cancelTenantBackupOperation200ResponseManifestExclusionsItemTableMax = 100;

export const cancelTenantBackupOperation200ResponseManifestExclusionsItemFieldsItemMax = 100;

export const cancelTenantBackupOperation200ResponseManifestExclusionsItemFieldsMax = 200;

export const cancelTenantBackupOperation200ResponseManifestExclusionsItemReasonMax = 1000;

export const cancelTenantBackupOperation200ResponseManifestExclusionsMax = 1000;

export const cancelTenantBackupOperation200ResponseManifestExternalReconciliationItemMax = 1000;

export const cancelTenantBackupOperation200ResponseManifestExternalReconciliationMax = 100000;

export const cancelTenantBackupOperation200ResponseBlockersItemMax = 1000;

export const cancelTenantBackupOperation200ResponseBlockersMax = 1000;

export const cancelTenantBackupOperation200ResponseErrorCodeMax = 100;



export const CancelTenantBackupOperation200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(cancelTenantBackupOperation200ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(cancelTenantBackupOperation200ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(cancelTenantBackupOperation200ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(cancelTenantBackupOperation200ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(cancelTenantBackupOperation200ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(cancelTenantBackupOperation200ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(cancelTenantBackupOperation200ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(cancelTenantBackupOperation200ResponseManifestEntriesItemPathMax).regex(cancelTenantBackupOperation200ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(cancelTenantBackupOperation200ResponseManifestEntriesItemTableMax).regex(cancelTenantBackupOperation200ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(cancelTenantBackupOperation200ResponseManifestEntriesItemRecordCountMin).max(cancelTenantBackupOperation200ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(cancelTenantBackupOperation200ResponseManifestEntriesItemByteSizeMin).max(cancelTenantBackupOperation200ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(cancelTenantBackupOperation200ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(cancelTenantBackupOperation200ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(cancelTenantBackupOperation200ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(cancelTenantBackupOperation200ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(cancelTenantBackupOperation200ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(cancelTenantBackupOperation200ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(cancelTenantBackupOperation200ResponseManifestExclusionsItemFieldsItemMax)).max(cancelTenantBackupOperation200ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(cancelTenantBackupOperation200ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(cancelTenantBackupOperation200ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(cancelTenantBackupOperation200ResponseManifestExternalReconciliationItemMax)).max(cancelTenantBackupOperation200ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(cancelTenantBackupOperation200ResponseBlockersItemMax)).max(cancelTenantBackupOperation200ResponseBlockersMax),
  "errorCode": zod.string().max(cancelTenantBackupOperation200ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const CancelTenantBackupOperation403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CancelTenantBackupOperation409Response = /*#__PURE__*/ (() => zod.unknown())()

export const CancelTenantBackupOperation503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Fresh original-parent administrator authority and exact actor ownership are required. Verify contiguous chunks, total size and archive digest before streaming. Expired or cancelled bytes are unavailable; no public URL or bearer capability.
 */
export const DownloadTenantBackupArchiveParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const DownloadTenantBackupArchive200Response = /*#__PURE__*/ (() => zod.unknown())()

export const DownloadTenantBackupArchive403Response = /*#__PURE__*/ (() => zod.unknown())()

export const DownloadTenantBackupArchive503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Validate the original-tenant archive against one current read-only snapshot. Return redacted replacement, audit retention, capability and external reconciliation impacts plus blockers. Store a 15-minute actor/tenant/archive/data/authority-bound receipt; this action never restores business records.
 */
export const PreviewTenantBackupRestoreParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const previewTenantBackupRestore200ResponseReceiptArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewTenantBackupRestore200ResponseReceiptDataRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewTenantBackupRestore200ResponseReceiptAuthorityRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewTenantBackupRestore200ResponseReceiptCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewTenantBackupRestore200ResponseAdditionsMin = 0;

export const previewTenantBackupRestore200ResponseUpdatesMin = 0;

export const previewTenantBackupRestore200ResponseRemovalsMin = 0;

export const previewTenantBackupRestore200ResponsePreservedAuditCountMin = 0;

export const previewTenantBackupRestore200ResponseAccessEffectsItemMax = 1000;

export const previewTenantBackupRestore200ResponseAccessEffectsMax = 1000;

export const previewTenantBackupRestore200ResponseExternalReconciliationItemMax = 1000;

export const previewTenantBackupRestore200ResponseExternalReconciliationMax = 1000;

export const previewTenantBackupRestore200ResponseBlockersItemMax = 1000;

export const previewTenantBackupRestore200ResponseBlockersMax = 1000;

export const previewTenantBackupRestore200ResponseConfirmationPhraseMax = 200;



export const PreviewTenantBackupRestore200Response = /*#__PURE__*/ (() => zod.object({
  "receipt": zod.object({
  "id": zod.uuid(),
  "operationId": zod.uuid(),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "archiveDigest": zod.string().regex(previewTenantBackupRestore200ResponseReceiptArchiveDigestRegExp),
  "dataRevision": zod.string().regex(previewTenantBackupRestore200ResponseReceiptDataRevisionRegExp),
  "authorityRevision": zod.string().regex(previewTenantBackupRestore200ResponseReceiptAuthorityRevisionRegExp),
  "coverageRevision": zod.string().regex(previewTenantBackupRestore200ResponseReceiptCoverageRevisionRegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}).describe('Durable server-owned non-bearer receipt; client fields cannot replace stored bindings. Single-use review expires within 15 minutes.'),
  "additions": zod.int().min(previewTenantBackupRestore200ResponseAdditionsMin),
  "updates": zod.int().min(previewTenantBackupRestore200ResponseUpdatesMin),
  "removals": zod.int().min(previewTenantBackupRestore200ResponseRemovalsMin),
  "preservedAuditCount": zod.int().min(previewTenantBackupRestore200ResponsePreservedAuditCountMin),
  "accessEffects": zod.array(zod.string().max(previewTenantBackupRestore200ResponseAccessEffectsItemMax)).max(previewTenantBackupRestore200ResponseAccessEffectsMax),
  "externalReconciliation": zod.array(zod.string().max(previewTenantBackupRestore200ResponseExternalReconciliationItemMax)).max(previewTenantBackupRestore200ResponseExternalReconciliationMax),
  "blockers": zod.array(zod.string().max(previewTenantBackupRestore200ResponseBlockersItemMax)).max(previewTenantBackupRestore200ResponseBlockersMax),
  "confirmationPhrase": zod.string().max(previewTenantBackupRestore200ResponseConfirmationPhraseMax)
}))()

export const PreviewTenantBackupRestore403Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewTenantBackupRestore409Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewTenantBackupRestore503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Recompute the redacted change page against a read-only current snapshot and reject changed data, authority, receipt, archive or expiry. Paging never refreshes the receipt or replays a write.
 */
export const ListTenantBackupChangesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const listTenantBackupChangesQueryLimitDefault = 25;
export const listTenantBackupChangesQueryLimitMax = 100;

export const listTenantBackupChangesQueryOffsetDefault = 0;
export const listTenantBackupChangesQueryOffsetMin = 0;
export const listTenantBackupChangesQueryOffsetMax = 10000000;



export const ListTenantBackupChangesQueryParams = /*#__PURE__*/ (() => zod.object({
  "receiptId": zod.uuid(),
  "limit": zod.int().min(1).max(listTenantBackupChangesQueryLimitMax).default(listTenantBackupChangesQueryLimitDefault),
  "offset": zod.int().min(listTenantBackupChangesQueryOffsetMin).max(listTenantBackupChangesQueryOffsetMax).default(listTenantBackupChangesQueryOffsetDefault)
}))()

export const listTenantBackupChanges200ResponseItemsItemTableMax = 100;

export const listTenantBackupChanges200ResponseItemsItemRecordKeyMax = 500;

export const listTenantBackupChanges200ResponseItemsItemEffectMax = 1000;

export const listTenantBackupChanges200ResponseItemsMax = 100;

export const listTenantBackupChanges200ResponseTotalMin = 0;

export const listTenantBackupChanges200ResponseLimitMax = 100;

export const listTenantBackupChanges200ResponseOffsetMin = 0;



export const ListTenantBackupChanges200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "table": zod.string().max(listTenantBackupChanges200ResponseItemsItemTableMax),
  "recordKey": zod.string().max(listTenantBackupChanges200ResponseItemsItemRecordKeyMax),
  "action": zod.enum(['add', 'update', 'remove', 'preserve_audit', 'reissue', 'reconcile_external']),
  "effect": zod.string().max(listTenantBackupChanges200ResponseItemsItemEffectMax)
}).describe('Redacted review summary; never include secret values or entire personal records.')).max(listTenantBackupChanges200ResponseItemsMax),
  "total": zod.int().min(listTenantBackupChanges200ResponseTotalMin),
  "limit": zod.int().min(1).max(listTenantBackupChanges200ResponseLimitMax),
  "offset": zod.int().min(listTenantBackupChanges200ResponseOffsetMin),
  "receiptId": zod.uuid()
}))()

export const ListTenantBackupChanges403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantBackupChanges409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListTenantBackupChanges503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Same-original-tenant atomic replacement only. Reauthorize and revalidate stored receipt, archive and revisions after a bounded application write barrier and database locks. Commit business replacement, retained audit and restore evidence with durable success together. Repeating the identical confirmation key and binding returns the committed result; altered bindings conflict. On an uncertain response, read operation status before retrying. Blob-backed restoration is blocked without safe publication; never replay providers or notifications.
 */
export const ConfirmTenantBackupRestoreParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "operationId": zod.uuid()
}))()

export const confirmTenantBackupRestoreBodyArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestoreBodyDataRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestoreBodyAuthorityRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestoreBodyConfirmationPhraseMax = 200;



export const ConfirmTenantBackupRestoreBody = /*#__PURE__*/ (() => zod.object({
  "receiptId": zod.uuid(),
  "archiveDigest": zod.string().regex(confirmTenantBackupRestoreBodyArchiveDigestRegExp),
  "dataRevision": zod.string().regex(confirmTenantBackupRestoreBodyDataRevisionRegExp),
  "authorityRevision": zod.string().regex(confirmTenantBackupRestoreBodyAuthorityRevisionRegExp),
  "idempotencyKey": zod.uuid().describe('Stable confirmation key; retain for status recovery and identical retry'),
  "confirmationPhrase": zod.string().min(1).max(confirmTenantBackupRestoreBodyConfirmationPhraseMax).describe('Must exactly equal RESTORE followed by the original tenant UUID')
}).describe('Compare every supplied value with the durable server receipt. Confirmation expires with that receipt; a committed identical retry does not repeat mutations.'))()

export const confirmTenantBackupRestore202ResponseArchiveDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestore202ResponseManifestEntityIdsMax = 10000;

export const confirmTenantBackupRestore202ResponseManifestApplicationVersionMax = 100;

export const confirmTenantBackupRestore202ResponseManifestSchemaRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestore202ResponseManifestCoverageRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestore202ResponseManifestSnapshotRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestore202ResponseManifestIdentitiesMax = 100000;

export const confirmTenantBackupRestore202ResponseManifestEntriesItemPathMax = 200;


export const confirmTenantBackupRestore202ResponseManifestEntriesItemPathRegExp = new RegExp('^(tables/[a-z_]+\\.ndjson|binaries/[a-f0-9]{64})$');
export const confirmTenantBackupRestore202ResponseManifestEntriesItemTableMax = 100;


export const confirmTenantBackupRestore202ResponseManifestEntriesItemTableRegExp = new RegExp('^[a-z_]+$');
export const confirmTenantBackupRestore202ResponseManifestEntriesItemRecordCountMin = 0;
export const confirmTenantBackupRestore202ResponseManifestEntriesItemRecordCountMax = 1000000;

export const confirmTenantBackupRestore202ResponseManifestEntriesItemByteSizeMin = 0;
export const confirmTenantBackupRestore202ResponseManifestEntriesItemByteSizeMax = 1073741824;

export const confirmTenantBackupRestore202ResponseManifestEntriesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenantBackupRestore202ResponseManifestEntriesItemRecordKeyMax = 500;

export const confirmTenantBackupRestore202ResponseManifestEntriesItemFieldMax = 100;

export const confirmTenantBackupRestore202ResponseManifestEntriesItemContentTypeMax = 200;

export const confirmTenantBackupRestore202ResponseManifestEntriesMax = 100000;

export const confirmTenantBackupRestore202ResponseManifestExclusionsItemTableMax = 100;

export const confirmTenantBackupRestore202ResponseManifestExclusionsItemFieldsItemMax = 100;

export const confirmTenantBackupRestore202ResponseManifestExclusionsItemFieldsMax = 200;

export const confirmTenantBackupRestore202ResponseManifestExclusionsItemReasonMax = 1000;

export const confirmTenantBackupRestore202ResponseManifestExclusionsMax = 1000;

export const confirmTenantBackupRestore202ResponseManifestExternalReconciliationItemMax = 1000;

export const confirmTenantBackupRestore202ResponseManifestExternalReconciliationMax = 100000;

export const confirmTenantBackupRestore202ResponseBlockersItemMax = 1000;

export const confirmTenantBackupRestore202ResponseBlockersMax = 1000;

export const confirmTenantBackupRestore202ResponseErrorCodeMax = 100;



export const ConfirmTenantBackupRestore202Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "actorId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "state": zod.enum(['staging', 'validating', 'ready', 'reviewed', 'committing', 'succeeded', 'failed', 'cancelled', 'expired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "archiveDigest": zod.string().regex(confirmTenantBackupRestore202ResponseArchiveDigestRegExp).optional(),
  "manifest": zod.object({
  "format": zod.enum(['commons-tenant-backup']),
  "version": zod.literal(1),
  "archiveId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityIds": zod.array(zod.uuid()).min(1).max(confirmTenantBackupRestore202ResponseManifestEntityIdsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "applicationVersion": zod.string().max(confirmTenantBackupRestore202ResponseManifestApplicationVersionMax),
  "schemaRevision": zod.string().regex(confirmTenantBackupRestore202ResponseManifestSchemaRevisionRegExp),
  "coverageRevision": zod.string().regex(confirmTenantBackupRestore202ResponseManifestCoverageRevisionRegExp),
  "snapshotRevision": zod.string().regex(confirmTenantBackupRestore202ResponseManifestSnapshotRevisionRegExp),
  "identities": zod.array(zod.object({
  "namespace": zod.enum(['app_users', 'users']),
  "id": zod.uuid(),
  "entraTenantId": zod.uuid().optional(),
  "entraObjectId": zod.uuid().optional()
}).describe('Minimum shared identity reference; existing immutable ID plus tid/oid must agree. Legacy users resolve by exact existing ID. No email matching or user creation.')).max(confirmTenantBackupRestore202ResponseManifestIdentitiesMax),
  "entries": zod.array(zod.object({
  "path": zod.string().max(confirmTenantBackupRestore202ResponseManifestEntriesItemPathMax).regex(confirmTenantBackupRestore202ResponseManifestEntriesItemPathRegExp),
  "kind": zod.enum(['rows', 'binary']),
  "table": zod.string().max(confirmTenantBackupRestore202ResponseManifestEntriesItemTableMax).regex(confirmTenantBackupRestore202ResponseManifestEntriesItemTableRegExp),
  "recordCount": zod.int().min(confirmTenantBackupRestore202ResponseManifestEntriesItemRecordCountMin).max(confirmTenantBackupRestore202ResponseManifestEntriesItemRecordCountMax),
  "byteSize": zod.int().min(confirmTenantBackupRestore202ResponseManifestEntriesItemByteSizeMin).max(confirmTenantBackupRestore202ResponseManifestEntriesItemByteSizeMax),
  "sha256": zod.string().regex(confirmTenantBackupRestore202ResponseManifestEntriesItemSha256RegExp),
  "recordKey": zod.string().max(confirmTenantBackupRestore202ResponseManifestEntriesItemRecordKeyMax).optional(),
  "field": zod.string().max(confirmTenantBackupRestore202ResponseManifestEntriesItemFieldMax).optional(),
  "contentType": zod.string().max(confirmTenantBackupRestore202ResponseManifestEntriesItemContentTypeMax).optional()
}).describe('Every covered table has one NDJSON entry including empty tables. Binary entries bind row key/field and metadata to content-addressed bytes.')).max(confirmTenantBackupRestore202ResponseManifestEntriesMax),
  "exclusions": zod.array(zod.object({
  "table": zod.string().max(confirmTenantBackupRestore202ResponseManifestExclusionsItemTableMax),
  "fields": zod.array(zod.string().max(confirmTenantBackupRestore202ResponseManifestExclusionsItemFieldsItemMax)).max(confirmTenantBackupRestore202ResponseManifestExclusionsItemFieldsMax),
  "reason": zod.string().max(confirmTenantBackupRestore202ResponseManifestExclusionsItemReasonMax),
  "disposition": zod.enum(['shared_reference', 'secret', 'transient', 'platform', 'generated'])
})).max(confirmTenantBackupRestore202ResponseManifestExclusionsMax),
  "externalReconciliation": zod.array(zod.string().max(confirmTenantBackupRestore202ResponseManifestExternalReconciliationItemMax)).max(confirmTenantBackupRestore202ResponseManifestExternalReconciliationMax)
}).optional().describe('manifest.json UTF-8; table lines use canonical JSON with sorted keys, stable PK order, UTC timestamps, exact decimals and binary references. Hash uncompressed bytes; archive digest is independent and bound by server receipt. Checksums never confer authority. Reject unknown properties/tables/fields and missing entries.'),
  "blockers": zod.array(zod.string().max(confirmTenantBackupRestore202ResponseBlockersItemMax)).max(confirmTenantBackupRestore202ResponseBlockersMax),
  "errorCode": zod.string().max(confirmTenantBackupRestore202ResponseErrorCodeMax).optional(),
  "restoreAuditId": zod.uuid().optional()
}))()

export const ConfirmTenantBackupRestore403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ConfirmTenantBackupRestore409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ConfirmTenantBackupRestore503Response = /*#__PURE__*/ (() => zod.unknown())()


export const listPolicyCatalogueQueryLimitDefault = 25;
export const listPolicyCatalogueQueryLimitMax = 100;

export const listPolicyCatalogueQueryOffsetDefault = 0;
export const listPolicyCatalogueQueryOffsetMin = 0;
export const listPolicyCatalogueQueryOffsetMax = 100000;



export const ListPolicyCatalogueQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listPolicyCatalogueQueryLimitMax).default(listPolicyCatalogueQueryLimitDefault),
  "offset": zod.int().min(listPolicyCatalogueQueryOffsetMin).max(listPolicyCatalogueQueryOffsetMax).default(listPolicyCatalogueQueryOffsetDefault)
}))()

export const listPolicyCatalogueHeaderXGroupGraphTokenMax = 16384;


export const listPolicyCatalogueHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListPolicyCatalogueHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listPolicyCatalogueHeaderXGroupGraphTokenMax).regex(listPolicyCatalogueHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listPolicyCatalogue200ResponseItemsItemOneTitleMax = 200;

export const listPolicyCatalogue200ResponseItemsItemOneBodyMax = 20000;

export const listPolicyCatalogue200ResponseItemsItemOneValidityDaysMax = 3650;




export const ListPolicyCatalogue200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(listPolicyCatalogue200ResponseItemsItemOneTitleMax),
  "body": zod.string().min(1).max(listPolicyCatalogue200ResponseItemsItemOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(listPolicyCatalogue200ResponseItemsItemOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
}))),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "canManageCatalogue": zod.boolean()
}))()


export const savePolicyCatalogueRuleHeaderXGroupGraphTokenMax = 16384;


export const savePolicyCatalogueRuleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SavePolicyCatalogueRuleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(savePolicyCatalogueRuleHeaderXGroupGraphTokenMax).regex(savePolicyCatalogueRuleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const savePolicyCatalogueRuleBodyTitleMax = 200;

export const savePolicyCatalogueRuleBodyBodyMax = 20000;

export const savePolicyCatalogueRuleBodyValidityDaysMax = 3650;




export const SavePolicyCatalogueRuleBody = /*#__PURE__*/ (() => zod.object({
  "title": zod.string().min(1).max(savePolicyCatalogueRuleBodyTitleMax),
  "body": zod.string().min(1).max(savePolicyCatalogueRuleBodyBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(savePolicyCatalogueRuleBodyValidityDaysMax).nullable(),
  "ruleId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "expectedActive": zod.boolean().optional(),
  "active": zod.boolean()
}))()

export const savePolicyCatalogueRule200ResponseOneTitleMax = 200;

export const savePolicyCatalogueRule200ResponseOneBodyMax = 20000;

export const savePolicyCatalogueRule200ResponseOneValidityDaysMax = 3650;




export const SavePolicyCatalogueRule200Response = /*#__PURE__*/ (() => zod.object({
  "title": zod.string().min(1).max(savePolicyCatalogueRule200ResponseOneTitleMax),
  "body": zod.string().min(1).max(savePolicyCatalogueRule200ResponseOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(savePolicyCatalogueRule200ResponseOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})))()

export const SavePolicyCatalogueRule403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SavePolicyCatalogueRule409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ListPolicyRuleVersionsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listPolicyRuleVersionsQueryLimitDefault = 25;
export const listPolicyRuleVersionsQueryLimitMax = 100;

export const listPolicyRuleVersionsQueryOffsetDefault = 0;
export const listPolicyRuleVersionsQueryOffsetMin = 0;
export const listPolicyRuleVersionsQueryOffsetMax = 100000;



export const ListPolicyRuleVersionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listPolicyRuleVersionsQueryLimitMax).default(listPolicyRuleVersionsQueryLimitDefault),
  "offset": zod.int().min(listPolicyRuleVersionsQueryOffsetMin).max(listPolicyRuleVersionsQueryOffsetMax).default(listPolicyRuleVersionsQueryOffsetDefault)
}))()

export const listPolicyRuleVersionsHeaderXGroupGraphTokenMax = 16384;


export const listPolicyRuleVersionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListPolicyRuleVersionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listPolicyRuleVersionsHeaderXGroupGraphTokenMax).regex(listPolicyRuleVersionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listPolicyRuleVersions200ResponseItemsItemOneTitleMax = 200;

export const listPolicyRuleVersions200ResponseItemsItemOneBodyMax = 20000;

export const listPolicyRuleVersions200ResponseItemsItemOneValidityDaysMax = 3650;




export const ListPolicyRuleVersions200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(listPolicyRuleVersions200ResponseItemsItemOneTitleMax),
  "body": zod.string().min(1).max(listPolicyRuleVersions200ResponseItemsItemOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(listPolicyRuleVersions200ResponseItemsItemOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
}))),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "canManageCatalogue": zod.boolean()
}))()


export const listPolicyScopeRulesQueryLimitDefault = 25;
export const listPolicyScopeRulesQueryLimitMax = 100;

export const listPolicyScopeRulesQueryOffsetDefault = 0;
export const listPolicyScopeRulesQueryOffsetMin = 0;
export const listPolicyScopeRulesQueryOffsetMax = 100000;



export const ListPolicyScopeRulesQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid(),
  "limit": zod.int().min(1).max(listPolicyScopeRulesQueryLimitMax).default(listPolicyScopeRulesQueryLimitDefault),
  "offset": zod.int().min(listPolicyScopeRulesQueryOffsetMin).max(listPolicyScopeRulesQueryOffsetMax).default(listPolicyScopeRulesQueryOffsetDefault)
}))()

export const listPolicyScopeRulesHeaderXGroupGraphTokenMax = 16384;


export const listPolicyScopeRulesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListPolicyScopeRulesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listPolicyScopeRulesHeaderXGroupGraphTokenMax).regex(listPolicyScopeRulesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listPolicyScopeRules200ResponseItemsItemRuleOneTitleMax = 200;

export const listPolicyScopeRules200ResponseItemsItemRuleOneBodyMax = 20000;

export const listPolicyScopeRules200ResponseItemsItemRuleOneValidityDaysMax = 3650;


export const listPolicyScopeRules200ResponseRevisionMin = 64;
export const listPolicyScopeRules200ResponseRevisionMax = 64;



export const ListPolicyScopeRules200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "rule": zod.object({
  "title": zod.string().min(1).max(listPolicyScopeRules200ResponseItemsItemRuleOneTitleMax),
  "body": zod.string().min(1).max(listPolicyScopeRules200ResponseItemsItemRuleOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(listPolicyScopeRules200ResponseItemsItemRuleOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})),
  "sources": zod.array(zod.object({
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid(),
  "name": zod.string(),
  "inherited": zod.boolean()
}))
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "revision": zod.string().min(listPolicyScopeRules200ResponseRevisionMin).max(listPolicyScopeRules200ResponseRevisionMax),
  "canManageAssignments": zod.boolean()
}))()


export const setPolicyScopeRuleHeaderXGroupGraphTokenMax = 16384;


export const setPolicyScopeRuleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetPolicyScopeRuleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setPolicyScopeRuleHeaderXGroupGraphTokenMax).regex(setPolicyScopeRuleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setPolicyScopeRuleBodyRevisionMin = 64;
export const setPolicyScopeRuleBodyRevisionMax = 64;



export const SetPolicyScopeRuleBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid(),
  "ruleId": zod.uuid(),
  "active": zod.boolean(),
  "revision": zod.string().min(setPolicyScopeRuleBodyRevisionMin).max(setPolicyScopeRuleBodyRevisionMax)
}))()

export const SetPolicyScopeRule200Response = /*#__PURE__*/ (() => zod.object({
  "saved": zod.boolean()
}))()

export const SetPolicyScopeRule403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SetPolicyScopeRule409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetSiteArrivalSafetyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSiteArrivalSafetyHeaderXGroupGraphTokenMax = 16384;


export const getSiteArrivalSafetyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteArrivalSafetyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteArrivalSafetyHeaderXGroupGraphTokenMax).regex(getSiteArrivalSafetyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getSiteArrivalSafety200ResponseArrivalItemsItemIdMax = 64;

export const getSiteArrivalSafety200ResponseArrivalItemsItemLabelMax = 200;

export const getSiteArrivalSafety200ResponseArrivalItemsItemDetailMax = 1000;

export const getSiteArrivalSafety200ResponseArrivalItemsMax = 50;

export const getSiteArrivalSafety200ResponseSafetyGuidanceMax = 4000;

export const getSiteArrivalSafety200ResponseRevisionMin = 64;
export const getSiteArrivalSafety200ResponseRevisionMax = 64;



export const GetSiteArrivalSafety200Response = /*#__PURE__*/ (() => zod.object({
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(getSiteArrivalSafety200ResponseArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(getSiteArrivalSafety200ResponseArrivalItemsItemLabelMax),
  "detail": zod.string().max(getSiteArrivalSafety200ResponseArrivalItemsItemDetailMax).optional()
})).max(getSiteArrivalSafety200ResponseArrivalItemsMax),
  "safetyGuidance": zod.string().max(getSiteArrivalSafety200ResponseSafetyGuidanceMax),
  "revision": zod.string().min(getSiteArrivalSafety200ResponseRevisionMin).max(getSiteArrivalSafety200ResponseRevisionMax)
}))()


export const SaveSiteArrivalSafetyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const saveSiteArrivalSafetyHeaderXGroupGraphTokenMax = 16384;


export const saveSiteArrivalSafetyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveSiteArrivalSafetyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveSiteArrivalSafetyHeaderXGroupGraphTokenMax).regex(saveSiteArrivalSafetyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveSiteArrivalSafetyBodyArrivalItemsItemIdMax = 64;

export const saveSiteArrivalSafetyBodyArrivalItemsItemLabelMax = 200;

export const saveSiteArrivalSafetyBodyArrivalItemsItemDetailMax = 1000;

export const saveSiteArrivalSafetyBodyArrivalItemsMax = 50;

export const saveSiteArrivalSafetyBodySafetyGuidanceMax = 4000;

export const saveSiteArrivalSafetyBodyRevisionMin = 64;
export const saveSiteArrivalSafetyBodyRevisionMax = 64;



export const SaveSiteArrivalSafetyBody = /*#__PURE__*/ (() => zod.object({
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(saveSiteArrivalSafetyBodyArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(saveSiteArrivalSafetyBodyArrivalItemsItemLabelMax),
  "detail": zod.string().max(saveSiteArrivalSafetyBodyArrivalItemsItemDetailMax).optional()
})).max(saveSiteArrivalSafetyBodyArrivalItemsMax),
  "safetyGuidance": zod.string().max(saveSiteArrivalSafetyBodySafetyGuidanceMax),
  "revision": zod.string().min(saveSiteArrivalSafetyBodyRevisionMin).max(saveSiteArrivalSafetyBodyRevisionMax)
}))()

export const saveSiteArrivalSafety200ResponseArrivalItemsItemIdMax = 64;

export const saveSiteArrivalSafety200ResponseArrivalItemsItemLabelMax = 200;

export const saveSiteArrivalSafety200ResponseArrivalItemsItemDetailMax = 1000;

export const saveSiteArrivalSafety200ResponseArrivalItemsMax = 50;

export const saveSiteArrivalSafety200ResponseSafetyGuidanceMax = 4000;

export const saveSiteArrivalSafety200ResponseRevisionMin = 64;
export const saveSiteArrivalSafety200ResponseRevisionMax = 64;



export const SaveSiteArrivalSafety200Response = /*#__PURE__*/ (() => zod.object({
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(saveSiteArrivalSafety200ResponseArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(saveSiteArrivalSafety200ResponseArrivalItemsItemLabelMax),
  "detail": zod.string().max(saveSiteArrivalSafety200ResponseArrivalItemsItemDetailMax).optional()
})).max(saveSiteArrivalSafety200ResponseArrivalItemsMax),
  "safetyGuidance": zod.string().max(saveSiteArrivalSafety200ResponseSafetyGuidanceMax),
  "revision": zod.string().min(saveSiteArrivalSafety200ResponseRevisionMin).max(saveSiteArrivalSafety200ResponseRevisionMax)
}))()

export const SaveSiteArrivalSafety409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Resolve current cumulative Policies and standards for a space
 */
export const GetMyPolicyRequirementsQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid()
}))()

export const getMyPolicyRequirementsHeaderXGroupGraphTokenMax = 16384;


export const getMyPolicyRequirementsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyPolicyRequirementsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyPolicyRequirementsHeaderXGroupGraphTokenMax).regex(getMyPolicyRequirementsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyPolicyRequirements200ResponseRulesItemOneOneTitleMax = 200;

export const getMyPolicyRequirements200ResponseRulesItemOneOneBodyMax = 20000;

export const getMyPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax = 3650;





export const GetMyPolicyRequirements200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "spaceId": zod.uuid(),
  "revision": zod.string(),
  "rules": zod.array(zod.object({
  "title": zod.string().min(1).max(getMyPolicyRequirements200ResponseRulesItemOneOneTitleMax),
  "body": zod.string().min(1).max(getMyPolicyRequirements200ResponseRulesItemOneOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(getMyPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "ruleId": zod.uuid(),
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid()
})),
  "acceptance": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "userId": zod.uuid(),
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "acceptedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "method": zod.enum(['individual', 'shared']),
  "checkedRuleIds": zod.array(zod.uuid()),
  "batchId": zod.uuid(),
  "source": zod.enum(['user', 'legacy_exact'])
}),zod.null()]),
  "needsAcceptance": zod.boolean()
}))),
  "complete": zod.boolean()
}))()

export const GetMyPolicyRequirements403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetMyPolicyRequirements404Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Accept the exact current set as the authenticated caller
 */
export const acceptMyPolicyRequirementsHeaderXGroupGraphTokenMax = 16384;


export const acceptMyPolicyRequirementsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AcceptMyPolicyRequirementsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(acceptMyPolicyRequirementsHeaderXGroupGraphTokenMax).regex(acceptMyPolicyRequirementsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const acceptMyPolicyRequirementsBodyRevisionMin = 64;
export const acceptMyPolicyRequirementsBodyRevisionMax = 64;


export const acceptMyPolicyRequirementsBodyRulesMax = 1000;

export const acceptMyPolicyRequirementsBodyCheckedRuleIdsMax = 1000;



export const AcceptMyPolicyRequirementsBody = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "revision": zod.string().min(acceptMyPolicyRequirementsBodyRevisionMin).max(acceptMyPolicyRequirementsBodyRevisionMax),
  "rules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1)
})).max(acceptMyPolicyRequirementsBodyRulesMax),
  "checkedRuleIds": zod.array(zod.uuid()).max(acceptMyPolicyRequirementsBodyCheckedRuleIdsMax)
}))()

export const acceptMyPolicyRequirements200ResponseRulesItemOneOneTitleMax = 200;

export const acceptMyPolicyRequirements200ResponseRulesItemOneOneBodyMax = 20000;

export const acceptMyPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax = 3650;





export const AcceptMyPolicyRequirements200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "spaceId": zod.uuid(),
  "revision": zod.string(),
  "rules": zod.array(zod.object({
  "title": zod.string().min(1).max(acceptMyPolicyRequirements200ResponseRulesItemOneOneTitleMax),
  "body": zod.string().min(1).max(acceptMyPolicyRequirements200ResponseRulesItemOneOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(acceptMyPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "ruleId": zod.uuid(),
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid()
})),
  "acceptance": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "userId": zod.uuid(),
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "acceptedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "method": zod.enum(['individual', 'shared']),
  "checkedRuleIds": zod.array(zod.uuid()),
  "batchId": zod.uuid(),
  "source": zod.enum(['user', 'legacy_exact'])
}),zod.null()]),
  "needsAcceptance": zod.boolean()
}))),
  "complete": zod.boolean()
}))()

export const AcceptMyPolicyRequirements400Response = /*#__PURE__*/ (() => zod.unknown())()

export const AcceptMyPolicyRequirements403Response = /*#__PURE__*/ (() => zod.unknown())()

export const AcceptMyPolicyRequirements409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read own, inherited and pending lifecycle restrictions
 */
export const GetInventoryLifecycleParams = /*#__PURE__*/ (() => zod.object({
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "id": zod.uuid()
}))()

export const getInventoryLifecycleHeaderXGroupGraphTokenMax = 16384;


export const getInventoryLifecycleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetInventoryLifecycleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getInventoryLifecycleHeaderXGroupGraphTokenMax).regex(getInventoryLifecycleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getInventoryLifecycle200ResponseRevisionMin = 0;



export const GetInventoryLifecycle200Response = /*#__PURE__*/ (() => zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getInventoryLifecycle200ResponseRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}))()

export const GetInventoryLifecycle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetInventoryLifecycle403Response = /*#__PURE__*/ (() => zod.unknown())()

export const getInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin = 16;
export const getInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax = 256;


export const getInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInventoryLifecycle409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin).max(getInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Review a lifecycle action without changing inventory or bookings
 */
export const PreviewInventoryLifecycleParams = /*#__PURE__*/ (() => zod.object({
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "id": zod.uuid()
}))()

export const previewInventoryLifecycleHeaderXGroupGraphTokenMax = 16384;


export const previewInventoryLifecycleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewInventoryLifecycleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewInventoryLifecycleHeaderXGroupGraphTokenMax).regex(previewInventoryLifecycleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewInventoryLifecycleBodyLocalEffectiveTimeRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}$');


export const PreviewInventoryLifecycleBody = /*#__PURE__*/ (() => zod.object({
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}).optional().describe('Explicit UTC offset required; immediate actions use the reviewed instant'),
  "localEffectiveTime": zod.string().regex(previewInventoryLifecycleBodyLocalEffectiveTimeRegExp).optional().describe('Optional site wall-clock assertion; rejected if offset and timezone disagree, including DST gaps'),
  "transitionId": zod.uuid().optional()
}))()

export const previewInventoryLifecycle200ResponseSelectedBeforeRevisionMin = 0;

export const previewInventoryLifecycle200ResponseSelectedAfterRevisionMin = 0;

export const previewInventoryLifecycle200ResponseChildrenItemsItemBeforeRevisionMin = 0;

export const previewInventoryLifecycle200ResponseChildrenItemsItemAfterRevisionMin = 0;

export const previewInventoryLifecycle200ResponseChildrenItemsItemBookingImpactCancellationCountMin = 0;

export const previewInventoryLifecycle200ResponseChildrenItemsItemBookingImpactUnderwayCountMin = 0;



export const PreviewInventoryLifecycle200Response = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "selectedBefore": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewInventoryLifecycle200ResponseSelectedBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "selectedAfter": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewInventoryLifecycle200ResponseSelectedAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "counts": zod.record(zod.string(), zod.int()),
  "children": zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewInventoryLifecycle200ResponseChildrenItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewInventoryLifecycle200ResponseChildrenItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(previewInventoryLifecycle200ResponseChildrenItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(previewInventoryLifecycle200ResponseChildrenItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}),
  "bookingImpact": zod.object({
  "available": zod.boolean(),
  "cancellationCount": zod.int().nullable(),
  "underwayCount": zod.int().nullable(),
  "revision": zod.string().nullable(),
  "bookings": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}).optional()
}),
  "confirmationAvailable": zod.boolean(),
  "explanation": zod.string()
}))()

export const PreviewInventoryLifecycle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewInventoryLifecycle403Response = /*#__PURE__*/ (() => zod.unknown())()

export const previewInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin = 16;
export const previewInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax = 256;


export const previewInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewInventoryLifecycle409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin).max(previewInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Confirm reviewed lifecycle and booking impact
 */
export const ConfirmInventoryLifecycleParams = /*#__PURE__*/ (() => zod.object({
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "id": zod.uuid()
}))()

export const confirmInventoryLifecycleHeaderXGroupGraphTokenMax = 16384;


export const confirmInventoryLifecycleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ConfirmInventoryLifecycleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(confirmInventoryLifecycleHeaderXGroupGraphTokenMax).regex(confirmInventoryLifecycleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const confirmInventoryLifecycleBodyImpactRevisionMin = 64;
export const confirmInventoryLifecycleBodyImpactRevisionMax = 64;



export const ConfirmInventoryLifecycleBody = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string().min(confirmInventoryLifecycleBodyImpactRevisionMin).max(confirmInventoryLifecycleBodyImpactRevisionMax),
  "idempotencyKey": zod.uuid()
}))()

export const confirmInventoryLifecycle200ResponseRevisionMin = 0;



export const ConfirmInventoryLifecycle200Response = /*#__PURE__*/ (() => zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(confirmInventoryLifecycle200ResponseRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}))()

export const ConfirmInventoryLifecycle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ConfirmInventoryLifecycle403Response = /*#__PURE__*/ (() => zod.unknown())()

export const confirmInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const confirmInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const confirmInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin = 16;
export const confirmInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax = 256;


export const confirmInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ConfirmInventoryLifecycle409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmInventoryLifecycle409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmInventoryLifecycle409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(confirmInventoryLifecycle409ResponseOverlapWarningAcknowledgementMin).max(confirmInventoryLifecycle409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(confirmInventoryLifecycle409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Paginated durable lifecycle history including removed schedules
 */
export const ListInventoryLifecycleHistoryParams = /*#__PURE__*/ (() => zod.object({
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "id": zod.uuid()
}))()

export const listInventoryLifecycleHistoryQueryLimitDefault = 20;
export const listInventoryLifecycleHistoryQueryLimitMax = 100;

export const listInventoryLifecycleHistoryQueryOffsetDefault = 0;
export const listInventoryLifecycleHistoryQueryOffsetMin = 0;



export const ListInventoryLifecycleHistoryQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listInventoryLifecycleHistoryQueryLimitMax).default(listInventoryLifecycleHistoryQueryLimitDefault),
  "offset": zod.int().min(listInventoryLifecycleHistoryQueryOffsetMin).default(listInventoryLifecycleHistoryQueryOffsetDefault)
}))()

export const listInventoryLifecycleHistoryHeaderXGroupGraphTokenMax = 16384;


export const listInventoryLifecycleHistoryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListInventoryLifecycleHistoryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listInventoryLifecycleHistoryHeaderXGroupGraphTokenMax).regex(listInventoryLifecycleHistoryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListInventoryLifecycleHistory200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "removedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int(),
  "hierarchyPath": zod.array(zod.string()),
  "cause": zod.union([zod.literal('floor_plan_pin_removed'),zod.literal('floor_plan_removed'),zod.literal(null)]).nullish()
})),
  "total": zod.int()
}))()

export const ListInventoryLifecycleHistory400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListInventoryLifecycleHistory403Response = /*#__PURE__*/ (() => zod.unknown())()

export const listInventoryLifecycleHistory409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listInventoryLifecycleHistory409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listInventoryLifecycleHistory409ResponseOverlapWarningAcknowledgementMin = 16;
export const listInventoryLifecycleHistory409ResponseOverlapWarningAcknowledgementMax = 256;


export const listInventoryLifecycleHistory409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListInventoryLifecycleHistory409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listInventoryLifecycleHistory409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listInventoryLifecycleHistory409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listInventoryLifecycleHistory409ResponseOverlapWarningAcknowledgementMin).max(listInventoryLifecycleHistory409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listInventoryLifecycleHistory409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Browse every reviewed descendant without truncating totals
 */
export const ListInventoryLifecyclePreviewChildrenParams = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid()
}))()

export const listInventoryLifecyclePreviewChildrenQueryLimitDefault = 20;
export const listInventoryLifecyclePreviewChildrenQueryLimitMax = 100;

export const listInventoryLifecyclePreviewChildrenQueryOffsetDefault = 0;
export const listInventoryLifecyclePreviewChildrenQueryOffsetMin = 0;



export const ListInventoryLifecyclePreviewChildrenQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listInventoryLifecyclePreviewChildrenQueryLimitMax).default(listInventoryLifecyclePreviewChildrenQueryLimitDefault),
  "offset": zod.int().min(listInventoryLifecyclePreviewChildrenQueryOffsetMin).default(listInventoryLifecyclePreviewChildrenQueryOffsetDefault)
}))()

export const listInventoryLifecyclePreviewChildrenHeaderXGroupGraphTokenMax = 16384;


export const listInventoryLifecyclePreviewChildrenHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListInventoryLifecyclePreviewChildrenHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listInventoryLifecyclePreviewChildrenHeaderXGroupGraphTokenMax).regex(listInventoryLifecyclePreviewChildrenHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listInventoryLifecyclePreviewChildren200ResponseItemsItemBeforeRevisionMin = 0;

export const listInventoryLifecyclePreviewChildren200ResponseItemsItemAfterRevisionMin = 0;

export const listInventoryLifecyclePreviewChildren200ResponseItemsItemBookingImpactCancellationCountMin = 0;

export const listInventoryLifecyclePreviewChildren200ResponseItemsItemBookingImpactUnderwayCountMin = 0;



export const ListInventoryLifecyclePreviewChildren200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listInventoryLifecyclePreviewChildren200ResponseItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listInventoryLifecyclePreviewChildren200ResponseItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(listInventoryLifecyclePreviewChildren200ResponseItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(listInventoryLifecyclePreviewChildren200ResponseItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const ListInventoryLifecyclePreviewChildren400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListInventoryLifecyclePreviewChildren403Response = /*#__PURE__*/ (() => zod.unknown())()

export const listInventoryLifecyclePreviewChildren409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listInventoryLifecyclePreviewChildren409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listInventoryLifecyclePreviewChildren409ResponseOverlapWarningAcknowledgementMin = 16;
export const listInventoryLifecyclePreviewChildren409ResponseOverlapWarningAcknowledgementMax = 256;


export const listInventoryLifecyclePreviewChildren409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListInventoryLifecyclePreviewChildren409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listInventoryLifecyclePreviewChildren409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listInventoryLifecyclePreviewChildren409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listInventoryLifecyclePreviewChildren409ResponseOverlapWarningAcknowledgementMin).max(listInventoryLifecyclePreviewChildren409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listInventoryLifecyclePreviewChildren409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Browse reviewed bookings, optionally for one affected space
 */
export const ListInventoryLifecyclePreviewBookingsParams = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid()
}))()

export const listInventoryLifecyclePreviewBookingsQueryLimitDefault = 20;
export const listInventoryLifecyclePreviewBookingsQueryLimitMax = 100;

export const listInventoryLifecyclePreviewBookingsQueryOffsetDefault = 0;
export const listInventoryLifecyclePreviewBookingsQueryOffsetMin = 0;



export const ListInventoryLifecyclePreviewBookingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid().optional().describe('Filter the reviewed snapshot to one space before pagination'),
  "limit": zod.int().min(1).max(listInventoryLifecyclePreviewBookingsQueryLimitMax).default(listInventoryLifecyclePreviewBookingsQueryLimitDefault),
  "offset": zod.int().min(listInventoryLifecyclePreviewBookingsQueryOffsetMin).default(listInventoryLifecyclePreviewBookingsQueryOffsetDefault)
}))()

export const listInventoryLifecyclePreviewBookingsHeaderXGroupGraphTokenMax = 16384;


export const listInventoryLifecyclePreviewBookingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListInventoryLifecyclePreviewBookingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listInventoryLifecyclePreviewBookingsHeaderXGroupGraphTokenMax).regex(listInventoryLifecyclePreviewBookingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListInventoryLifecyclePreviewBookings200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const ListInventoryLifecyclePreviewBookings403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListInventoryLifecyclePreviewBookings409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary List active staffed services; administrators may include inactive ones
 */
export const listStaffedServicesQueryLimitDefault = 20;
export const listStaffedServicesQueryLimitMax = 100;

export const listStaffedServicesQueryOffsetDefault = 0;
export const listStaffedServicesQueryOffsetMin = 0;

export const listStaffedServicesQueryIncludeInactiveDefault = false;

export const ListStaffedServicesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listStaffedServicesQueryLimitMax).default(listStaffedServicesQueryLimitDefault),
  "offset": zod.int().min(listStaffedServicesQueryOffsetMin).default(listStaffedServicesQueryOffsetDefault),
  "includeInactive": zod.boolean().default(listStaffedServicesQueryIncludeInactiveDefault)
}))()

export const listStaffedServicesHeaderXGroupGraphTokenMax = 16384;


export const listStaffedServicesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListStaffedServicesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listStaffedServicesHeaderXGroupGraphTokenMax).regex(listStaffedServicesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listStaffedServices200ResponseTotalMin = 0;



export const ListStaffedServices200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listStaffedServices200ResponseTotalMin)
}))()


/**
 * @summary Configure a service and responsible team (inventory administrator)
 */
export const createStaffedServiceHeaderXGroupGraphTokenMax = 16384;


export const createStaffedServiceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateStaffedServiceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createStaffedServiceHeaderXGroupGraphTokenMax).regex(createStaffedServiceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createStaffedServiceBodyNameMax = 120;

export const createStaffedServiceBodyDescriptionMax = 1000;



export const CreateStaffedServiceBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(createStaffedServiceBodyNameMax),
  "description": zod.string().max(createStaffedServiceBodyDescriptionMax).nullish(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid()
}))()

export const CreateStaffedService201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary Update a staffed service (inventory administrator)
 */
export const UpdateStaffedServiceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateStaffedServiceHeaderXGroupGraphTokenMax = 16384;


export const updateStaffedServiceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateStaffedServiceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateStaffedServiceHeaderXGroupGraphTokenMax).regex(updateStaffedServiceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateStaffedServiceBodyNameMax = 120;

export const updateStaffedServiceBodyDescriptionMax = 1000;



export const UpdateStaffedServiceBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(updateStaffedServiceBodyNameMax).optional(),
  "description": zod.string().max(updateStaffedServiceBodyDescriptionMax).nullish(),
  "responsibleWorkgroupId": zod.uuid().optional(),
  "active": zod.boolean().optional()
}))()

export const UpdateStaffedService200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary List entity teams for service configuration (inventory administrator)
 */
export const listStaffedServiceTeamsQueryLimitDefault = 20;
export const listStaffedServiceTeamsQueryLimitMax = 100;

export const listStaffedServiceTeamsQueryOffsetDefault = 0;
export const listStaffedServiceTeamsQueryOffsetMin = 0;



export const ListStaffedServiceTeamsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listStaffedServiceTeamsQueryLimitMax).default(listStaffedServiceTeamsQueryLimitDefault),
  "offset": zod.int().min(listStaffedServiceTeamsQueryOffsetMin).default(listStaffedServiceTeamsQueryOffsetDefault)
}))()

export const listStaffedServiceTeamsHeaderXGroupGraphTokenMax = 16384;


export const listStaffedServiceTeamsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListStaffedServiceTeamsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listStaffedServiceTeamsHeaderXGroupGraphTokenMax).regex(listStaffedServiceTeamsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listStaffedServiceTeams200ResponseTotalMin = 0;



export const ListStaffedServiceTeams200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})),
  "total": zod.int().min(listStaffedServiceTeams200ResponseTotalMin)
}))()


/**
 * @summary List my service requests
 */
export const listMyStaffedServiceRequestsQueryLimitDefault = 20;
export const listMyStaffedServiceRequestsQueryLimitMax = 100;

export const listMyStaffedServiceRequestsQueryOffsetDefault = 0;
export const listMyStaffedServiceRequestsQueryOffsetMin = 0;



export const ListMyStaffedServiceRequestsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listMyStaffedServiceRequestsQueryLimitMax).default(listMyStaffedServiceRequestsQueryLimitDefault),
  "offset": zod.int().min(listMyStaffedServiceRequestsQueryOffsetMin).default(listMyStaffedServiceRequestsQueryOffsetDefault)
}))()

export const listMyStaffedServiceRequestsHeaderXGroupGraphTokenMax = 16384;


export const listMyStaffedServiceRequestsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyStaffedServiceRequestsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyStaffedServiceRequestsHeaderXGroupGraphTokenMax).regex(listMyStaffedServiceRequestsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listMyStaffedServiceRequests200ResponseTotalMin = 0;



export const ListMyStaffedServiceRequests200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "serviceId": zod.uuid(),
  "serviceName": zod.string(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "requesterUserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "location": zod.string(),
  "details": zod.string(),
  "status": zod.enum(['requested', 'confirmed', 'declined', 'cancelled', 'completed']),
  "assignedUserId": zod.uuid().nullable(),
  "declineReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMyStaffedServiceRequests200ResponseTotalMin)
}))()


/**
 * @summary Submit a pending staffed-service request
 */
export const createStaffedServiceRequestHeaderXGroupGraphTokenMax = 16384;


export const createStaffedServiceRequestHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateStaffedServiceRequestHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createStaffedServiceRequestHeaderXGroupGraphTokenMax).regex(createStaffedServiceRequestHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createStaffedServiceRequestBodyLocationMax = 200;

export const createStaffedServiceRequestBodyDetailsMax = 2000;



export const CreateStaffedServiceRequestBody = /*#__PURE__*/ (() => zod.object({
  "serviceId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}).describe('Must be on a 15-minute mark.'),
  "end": zod.iso.datetime({"offset":true}).describe('Must be on a 15-minute mark.'),
  "location": zod.string().min(1).max(createStaffedServiceRequestBodyLocationMax),
  "details": zod.string().min(1).max(createStaffedServiceRequestBodyDetailsMax),
  "clientRequestId": zod.uuid()
}))()

export const CreateStaffedServiceRequest201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "serviceId": zod.uuid(),
  "serviceName": zod.string(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "requesterUserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "location": zod.string(),
  "details": zod.string(),
  "status": zod.enum(['requested', 'confirmed', 'declined', 'cancelled', 'completed']),
  "assignedUserId": zod.uuid().nullable(),
  "declineReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary List requests for my responsible teams
 */
export const listTeamStaffedServiceRequestsQueryLimitDefault = 20;
export const listTeamStaffedServiceRequestsQueryLimitMax = 100;

export const listTeamStaffedServiceRequestsQueryOffsetDefault = 0;
export const listTeamStaffedServiceRequestsQueryOffsetMin = 0;



export const ListTeamStaffedServiceRequestsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listTeamStaffedServiceRequestsQueryLimitMax).default(listTeamStaffedServiceRequestsQueryLimitDefault),
  "offset": zod.int().min(listTeamStaffedServiceRequestsQueryOffsetMin).default(listTeamStaffedServiceRequestsQueryOffsetDefault)
}))()

export const listTeamStaffedServiceRequestsHeaderXGroupGraphTokenMax = 16384;


export const listTeamStaffedServiceRequestsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListTeamStaffedServiceRequestsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listTeamStaffedServiceRequestsHeaderXGroupGraphTokenMax).regex(listTeamStaffedServiceRequestsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listTeamStaffedServiceRequests200ResponseTotalMin = 0;



export const ListTeamStaffedServiceRequests200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "serviceId": zod.uuid(),
  "serviceName": zod.string(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "requesterUserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "location": zod.string(),
  "details": zod.string(),
  "status": zod.enum(['requested', 'confirmed', 'declined', 'cancelled', 'completed']),
  "assignedUserId": zod.uuid().nullable(),
  "declineReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTeamStaffedServiceRequests200ResponseTotalMin)
}))()


/**
 * @summary Assign, confirm, decline, cancel or complete a service request
 */
export const TransitionStaffedServiceRequestParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const transitionStaffedServiceRequestHeaderXGroupGraphTokenMax = 16384;


export const transitionStaffedServiceRequestHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const TransitionStaffedServiceRequestHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(transitionStaffedServiceRequestHeaderXGroupGraphTokenMax).regex(transitionStaffedServiceRequestHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const transitionStaffedServiceRequestBodyReasonMax = 1000;



export const TransitionStaffedServiceRequestBody = /*#__PURE__*/ (() => zod.object({
  "action": zod.enum(['assign', 'confirm', 'decline', 'cancel', 'complete']),
  "assignedUserId": zod.uuid().optional(),
  "reason": zod.string().min(1).max(transitionStaffedServiceRequestBodyReasonMax).optional()
}))()

export const TransitionStaffedServiceRequest200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "serviceId": zod.uuid(),
  "serviceName": zod.string(),
  "siteId": zod.uuid(),
  "responsibleWorkgroupId": zod.uuid(),
  "requesterUserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "location": zod.string(),
  "details": zod.string(),
  "status": zod.enum(['requested', 'confirmed', 'declined', 'cancelled', 'completed']),
  "assignedUserId": zod.uuid().nullable(),
  "declineReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary Liveness probe
 */
export const GetHealth200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['ok']),
  "uptimeSeconds": zod.number(),
  "timestamp": zod.iso.datetime({"offset":true}),
  "database": zod.enum(['connected', 'not_configured']),
  "plugins": zod.object({
  "database": zod.boolean(),
  "storage": zod.boolean(),
  "ai": zod.boolean(),
  "auth": zod.boolean()
})
}))()


/**
 * Real aggregates from inventory, bookings, check-ins, presence, and
 * blackouts. Returns zeros when the database plugin is off.
 * @summary Portfolio KPIs, top buildings, and upcoming blackouts
 */
export const getDashboardStatsHeaderXGroupGraphTokenMax = 16384;


export const getDashboardStatsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDashboardStatsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDashboardStatsHeaderXGroupGraphTokenMax).regex(getDashboardStatsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getDashboardStats200ResponseSiteCountMin = 0;

export const getDashboardStats200ResponseBuildingCountMin = 0;

export const getDashboardStats200ResponseSpaceCountMin = 0;

export const getDashboardStats200ResponseTodayBookingsMin = 0;

export const getDashboardStats200ResponseTodayCheckedInMin = 0;

export const getDashboardStats200ResponseTodayCheckInRateMin = 0;

export const getDashboardStats200ResponseActiveUsersThisWeekMin = 0;

export const getDashboardStats200ResponseDeclaredOfficeTodayMin = 0;

export const getDashboardStats200ResponseTodayVisitorsExpectedMin = 0;

export const getDashboardStats200ResponseTodayVisitorsOnSiteMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemSpaceCountMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemBookedMinutesMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemAvailableMinutesMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemUtilisationPctMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemRecordedMinutesMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemEstimatedMinutesMin = 0;

export const getDashboardStats200ResponseTopBuildingsItemMissingScheduleSpaceCountMin = 0;



export const GetDashboardStats200Response = /*#__PURE__*/ (() => zod.object({
  "siteCount": zod.int().min(getDashboardStats200ResponseSiteCountMin),
  "buildingCount": zod.int().min(getDashboardStats200ResponseBuildingCountMin),
  "spaceCount": zod.int().min(getDashboardStats200ResponseSpaceCountMin),
  "todayBookings": zod.int().min(getDashboardStats200ResponseTodayBookingsMin),
  "todayCheckedIn": zod.int().min(getDashboardStats200ResponseTodayCheckedInMin),
  "todayCheckInRate": zod.number().min(getDashboardStats200ResponseTodayCheckInRateMin).describe('Percent of today\'s bookings that are checked in (0–100)'),
  "activeUsersThisWeek": zod.int().min(getDashboardStats200ResponseActiveUsersThisWeekMin).describe('App users with lastLoginAt in the last 7 days'),
  "declaredOfficeToday": zod.int().min(getDashboardStats200ResponseDeclaredOfficeTodayMin).describe('Distinct users with presence status=office today (UTC)'),
  "todayVisitorsExpected": zod.int().min(getDashboardStats200ResponseTodayVisitorsExpectedMin).describe('Visitors scheduled for today (expected + checked in/out)'),
  "todayVisitorsOnSite": zod.int().min(getDashboardStats200ResponseTodayVisitorsOnSiteMin).describe('Visitors currently checked in'),
  "topBuildings": zod.array(zod.object({
  "buildingId": zod.uuid(),
  "buildingCode": zod.string(),
  "buildingName": zod.string(),
  "siteName": zod.string(),
  "spaceCount": zod.int().min(getDashboardStats200ResponseTopBuildingsItemSpaceCountMin),
  "bookedMinutes": zod.number().min(getDashboardStats200ResponseTopBuildingsItemBookedMinutesMin),
  "availableMinutes": zod.number().min(getDashboardStats200ResponseTopBuildingsItemAvailableMinutesMin),
  "utilisationPct": zod.number().min(getDashboardStats200ResponseTopBuildingsItemUtilisationPctMin).nullable(),
  "recordedMinutes": zod.number().min(getDashboardStats200ResponseTopBuildingsItemRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getDashboardStats200ResponseTopBuildingsItemEstimatedMinutesMin),
  "missingScheduleSpaceCount": zod.int().min(getDashboardStats200ResponseTopBuildingsItemMissingScheduleSpaceCountMin)
})),
  "upcomingBlackouts": zod.array(zod.object({
  "id": zod.uuid(),
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "scopeLabel": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Site timezone for this disclosed blackout.'),
  "reason": zod.string(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true})
})),
  "generatedAt": zod.iso.datetime({"offset":true})
}))()

export const getDashboardStats401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDashboardStats401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDashboardStats401ResponseOverlapWarningAcknowledgementMin = 16;
export const getDashboardStats401ResponseOverlapWarningAcknowledgementMax = 256;


export const getDashboardStats401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDashboardStats401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardStats401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardStats401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDashboardStats401ResponseOverlapWarningAcknowledgementMin).max(getDashboardStats401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDashboardStats401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDashboardStats403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDashboardStats403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDashboardStats403ResponseOverlapWarningAcknowledgementMin = 16;
export const getDashboardStats403ResponseOverlapWarningAcknowledgementMax = 256;


export const getDashboardStats403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDashboardStats403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardStats403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardStats403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDashboardStats403ResponseOverlapWarningAcknowledgementMin).max(getDashboardStats403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDashboardStats403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Real daily series for the selected window (UTC days). Declared-office
 * is 0 on days with no presence data. Returns zero series when the
 * database plugin is off.
 * @summary Daily bookings, check-ins, and declared-office series
 */
export const getDashboardTimeseriesQueryDaysDefault = 30;
export const getDashboardTimeseriesQueryDaysMin = 7;
export const getDashboardTimeseriesQueryDaysMax = 90;



export const GetDashboardTimeseriesQueryParams = /*#__PURE__*/ (() => zod.object({
  "days": zod.int().min(getDashboardTimeseriesQueryDaysMin).max(getDashboardTimeseriesQueryDaysMax).default(getDashboardTimeseriesQueryDaysDefault)
}))()

export const getDashboardTimeseriesHeaderXGroupGraphTokenMax = 16384;


export const getDashboardTimeseriesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDashboardTimeseriesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDashboardTimeseriesHeaderXGroupGraphTokenMax).regex(getDashboardTimeseriesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getDashboardTimeseries200ResponsePointsItemBookingsMin = 0;

export const getDashboardTimeseries200ResponsePointsItemCheckInsMin = 0;

export const getDashboardTimeseries200ResponsePointsItemDeclaredOfficeMin = 0;



export const GetDashboardTimeseries200Response = /*#__PURE__*/ (() => zod.object({
  "days": zod.int(),
  "points": zod.array(zod.object({
  "date": zod.iso.date(),
  "bookings": zod.int().min(getDashboardTimeseries200ResponsePointsItemBookingsMin).describe('Bookings that started on this UTC day'),
  "checkIns": zod.int().min(getDashboardTimeseries200ResponsePointsItemCheckInsMin).describe('Check-in events on this UTC day'),
  "declaredOffice": zod.int().min(getDashboardTimeseries200ResponsePointsItemDeclaredOfficeMin).describe('Users declared office on this calendar day')
}))
}))()

export const getDashboardTimeseries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDashboardTimeseries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDashboardTimeseries400ResponseOverlapWarningAcknowledgementMin = 16;
export const getDashboardTimeseries400ResponseOverlapWarningAcknowledgementMax = 256;


export const getDashboardTimeseries400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDashboardTimeseries400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDashboardTimeseries400ResponseOverlapWarningAcknowledgementMin).max(getDashboardTimeseries400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDashboardTimeseries400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDashboardTimeseries401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDashboardTimeseries401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDashboardTimeseries401ResponseOverlapWarningAcknowledgementMin = 16;
export const getDashboardTimeseries401ResponseOverlapWarningAcknowledgementMax = 256;


export const getDashboardTimeseries401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDashboardTimeseries401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDashboardTimeseries401ResponseOverlapWarningAcknowledgementMin).max(getDashboardTimeseries401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDashboardTimeseries401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDashboardTimeseries403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDashboardTimeseries403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDashboardTimeseries403ResponseOverlapWarningAcknowledgementMin = 16;
export const getDashboardTimeseries403ResponseOverlapWarningAcknowledgementMax = 256;


export const getDashboardTimeseries403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDashboardTimeseries403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDashboardTimeseries403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDashboardTimeseries403ResponseOverlapWarningAcknowledgementMin).max(getDashboardTimeseries403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDashboardTimeseries403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Public (unauthenticated) endpoint. Returns only readiness booleans and
 * the non-secret MSAL public client config required before sign-in. It
 * omits diagnostic reasons, capability details, and provider metadata.
 * @summary Public availability and auth bootstrap config for platform plugins
 */
export const GetPluginsStatus200Response = /*#__PURE__*/ (() => zod.object({
  "database": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled'])
}),
  "storage": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled'])
}),
  "ai": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled'])
}),
  "auth": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled']),
  "config": zod.object({
  "clientId": zod.string(),
  "authority": zod.string(),
  "redirectUri": zod.string(),
  "postLoginRedirect": zod.string(),
  "scopes": zod.array(zod.string())
}).optional().describe('Public MSAL client configuration (no secrets).')
}),
  "notifications": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled'])
})
}))()


/**
 * Full plugin status for integration administrators.
 * @summary Detailed platform plugin diagnostics
 */
export const GetPluginsStatusDetail200Response = /*#__PURE__*/ (() => zod.object({
  "database": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional(),
  "capabilities": zod.object({
  "persistentStorage": zod.boolean(),
  "appUsers": zod.boolean()
})
}),
  "storage": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional(),
  "capabilities": zod.object({
  "fileUpload": zod.boolean(),
  "fileDownload": zod.boolean()
})
}),
  "ai": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional(),
  "capabilities": zod.object({
  "llm": zod.boolean(),
  "embeddings": zod.boolean(),
  "semanticSearch": zod.boolean()
})
}),
  "auth": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional(),
  "provider": zod.enum(['microsoft_entra_workforce']).optional(),
  "mode": zod.string().optional(),
  "capabilities": zod.object({
  "login": zod.boolean(),
  "protectedRoutes": zod.boolean(),
  "persistentUsers": zod.boolean()
}),
  "config": zod.object({
  "clientId": zod.string(),
  "authority": zod.string(),
  "redirectUri": zod.string(),
  "postLoginRedirect": zod.string(),
  "scopes": zod.array(zod.string())
}).optional().describe('Public MSAL client configuration (no secrets).')
}),
  "notifications": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional(),
  "capabilities": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "emailMode": zod.enum(['acs', 'graph', 'cdf_relay', 'in_app_only']).optional(),
  "senderHint": zod.string().nullish().describe('Masked sender domain only (never the connection string).')
})
}))()

export const getPluginsStatusDetail401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPluginsStatusDetail401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPluginsStatusDetail401ResponseOverlapWarningAcknowledgementMin = 16;
export const getPluginsStatusDetail401ResponseOverlapWarningAcknowledgementMax = 256;


export const getPluginsStatusDetail401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPluginsStatusDetail401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPluginsStatusDetail401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPluginsStatusDetail401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPluginsStatusDetail401ResponseOverlapWarningAcknowledgementMin).max(getPluginsStatusDetail401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPluginsStatusDetail401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getPluginsStatusDetail403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPluginsStatusDetail403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPluginsStatusDetail403ResponseOverlapWarningAcknowledgementMin = 16;
export const getPluginsStatusDetail403ResponseOverlapWarningAcknowledgementMax = 256;


export const getPluginsStatusDetail403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPluginsStatusDetail403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPluginsStatusDetail403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPluginsStatusDetail403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPluginsStatusDetail403ResponseOverlapWarningAcknowledgementMin).max(getPluginsStatusDetail403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPluginsStatusDetail403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Current authenticated user
 */
export const getCurrentUserHeaderXGroupGraphTokenMax = 16384;


export const getCurrentUserHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetCurrentUserHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getCurrentUserHeaderXGroupGraphTokenMax).regex(getCurrentUserHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getCurrentUser200ResponseTenantsItemGroupBindingIdsMax = 100;

export const getCurrentUser200ResponseGroupAccessMessageMax = 500;



export const GetCurrentUser200Response = /*#__PURE__*/ (() => zod.object({
  "appUserId": zod.uuid().nullish(),
  "entraObjectId": zod.string(),
  "entraTenantId": zod.string(),
  "email": zod.string().nullish(),
  "displayName": zod.string(),
  "persistent": zod.boolean().describe('True when the user is synced to the app_users table.'),
  "role": zod.enum(['viewer', 'editor', 'admin']).describe('UI AppRole derived from product role assignments (it_admin/space_admin → admin; employee/team_assistant/visitor_host → editor).\n'),
  "productRoles": zod.array(zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])).describe('Product persona role codes assigned in the database.'),
  "capabilities": zod.array(zod.string()).describe('Effective capability codes from product roles plus explicit user_capabilities grants (e.g. booking:self, inventory:manage).\n'),
  "workplaceReportNavigation": zod.boolean().optional().describe('Selected-entity report navigation only; not a durable reports:view grant. Report APIs recheck current scoped authority.'),
  "isPlatformAdmin": zod.boolean().describe('True when the user has a platform_admins row (platform-plane access).'),
  "tenants": zod.array(zod.object({
  "individualAccess": zod.boolean().optional().describe('A current independent individual source grants access.'),
  "groupBindingIds": zod.array(zod.uuid()).max(getCurrentUser200ResponseTenantsItemGroupBindingIdsMax).optional().describe('Currently verified organisation bindings; these IDs cannot be submitted as membership proof.'),
  "id": zod.uuid(),
  "slug": zod.string().describe('Preferred address, using the current alias when present.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "name": zod.string(),
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "isSystem": zod.boolean()
})),
  "permissions": zod.array(zod.string()).describe('Effective permission keys from the member\'s roles plus any active elevation or override overlays. Contains \'*\' when an override session grants full tenant-admin permissions.\n')
})).describe('Organisation choices from current individual and verified Microsoft group sources. Override sessions never manufacture organisation membership.\n'),
  "groupAccess": zod.object({
  "state": zod.enum(['verified', 'unavailable']),
  "message": zod.string().max(getCurrentUser200ResponseGroupAccessMessageMax),
  "retryable": zod.boolean()
}).optional().describe('Current server verification outcome; no directory enumeration. Unavailable checks withhold group access while preserving independent access.'),
  "activeElevations": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid().nullable(),
  "permissionKeys": zod.array(zod.string()).nullable(),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true})
})).describe('Approved, non-expired JIT elevation grants.'),
  "activeOverrides": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "reason": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})).describe('Active (non-ended, non-expired) break-glass override sessions.')
}))()

export const getCurrentUser401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getCurrentUser401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getCurrentUser401ResponseOverlapWarningAcknowledgementMin = 16;
export const getCurrentUser401ResponseOverlapWarningAcknowledgementMax = 256;


export const getCurrentUser401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetCurrentUser401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getCurrentUser401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getCurrentUser401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getCurrentUser401ResponseOverlapWarningAcknowledgementMin).max(getCurrentUser401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getCurrentUser401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getCurrentUser409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getCurrentUser409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getCurrentUser409ResponseOverlapWarningAcknowledgementMin = 16;
export const getCurrentUser409ResponseOverlapWarningAcknowledgementMax = 256;


export const getCurrentUser409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetCurrentUser409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getCurrentUser409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getCurrentUser409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getCurrentUser409ResponseOverlapWarningAcknowledgementMin).max(getCurrentUser409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getCurrentUser409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Scaffold endpoint proving requireCapability(inventory:manage). Full inventory CRUD lands in S3.
 * @summary Inventory admin guard probe
 */
export const getAdminInventoryHealthHeaderXGroupGraphTokenMax = 16384;


export const getAdminInventoryHealthHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetAdminInventoryHealthHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getAdminInventoryHealthHeaderXGroupGraphTokenMax).regex(getAdminInventoryHealthHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetAdminInventoryHealth200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean(),
  "capability": zod.string(),
  "role": zod.enum(['viewer', 'editor', 'admin']),
  "appUserId": zod.uuid().nullable()
}))()

export const getAdminInventoryHealth401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminInventoryHealth401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminInventoryHealth401ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminInventoryHealth401ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminInventoryHealth401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminInventoryHealth401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminInventoryHealth401ResponseOverlapWarningAcknowledgementMin).max(getAdminInventoryHealth401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminInventoryHealth401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getAdminInventoryHealth403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminInventoryHealth403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminInventoryHealth403ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminInventoryHealth403ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminInventoryHealth403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminInventoryHealth403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminInventoryHealth403ResponseOverlapWarningAcknowledgementMin).max(getAdminInventoryHealth403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminInventoryHealth403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getAdminInventoryHealth409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminInventoryHealth409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminInventoryHealth409ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminInventoryHealth409ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminInventoryHealth409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminInventoryHealth409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminInventoryHealth409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminInventoryHealth409ResponseOverlapWarningAcknowledgementMin).max(getAdminInventoryHealth409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminInventoryHealth409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Scaffold endpoint proving requireCapability(policy:manage). Full policy engine lands in S4.
 * @summary Policy admin guard probe
 */
export const getAdminPoliciesHealthHeaderXGroupGraphTokenMax = 16384;


export const getAdminPoliciesHealthHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetAdminPoliciesHealthHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getAdminPoliciesHealthHeaderXGroupGraphTokenMax).regex(getAdminPoliciesHealthHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetAdminPoliciesHealth200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean(),
  "capability": zod.string(),
  "role": zod.enum(['viewer', 'editor', 'admin']),
  "appUserId": zod.uuid().nullable()
}))()

export const getAdminPoliciesHealth401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminPoliciesHealth401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminPoliciesHealth401ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminPoliciesHealth401ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminPoliciesHealth401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminPoliciesHealth401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminPoliciesHealth401ResponseOverlapWarningAcknowledgementMin).max(getAdminPoliciesHealth401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminPoliciesHealth401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getAdminPoliciesHealth403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminPoliciesHealth403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminPoliciesHealth403ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminPoliciesHealth403ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminPoliciesHealth403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminPoliciesHealth403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminPoliciesHealth403ResponseOverlapWarningAcknowledgementMin).max(getAdminPoliciesHealth403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminPoliciesHealth403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getAdminPoliciesHealth409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminPoliciesHealth409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminPoliciesHealth409ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminPoliciesHealth409ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminPoliciesHealth409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminPoliciesHealth409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminPoliciesHealth409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminPoliciesHealth409ResponseOverlapWarningAcknowledgementMin).max(getAdminPoliciesHealth409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminPoliciesHealth409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Newest-first audit events for the selected entity, with text, action, actor and date filters.
 * @summary Search the entity audit history
 */
export const listAdminAuditEventsQueryQMax = 200;

export const listAdminAuditEventsQueryActionMax = 120;

export const listAdminAuditEventsQueryEntityTypeMax = 60;

export const listAdminAuditEventsQueryLimitMax = 200;

export const listAdminAuditEventsQueryOffsetMin = 0;



export const ListAdminAuditEventsQueryParams = /*#__PURE__*/ (() => zod.object({
  "q": zod.string().max(listAdminAuditEventsQueryQMax).optional(),
  "action": zod.string().max(listAdminAuditEventsQueryActionMax).optional(),
  "entityType": zod.string().max(listAdminAuditEventsQueryEntityTypeMax).optional(),
  "actorUserId": zod.uuid().optional(),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "limit": zod.int().min(1).max(listAdminAuditEventsQueryLimitMax).optional(),
  "offset": zod.int().min(listAdminAuditEventsQueryOffsetMin).optional()
}))()

export const listAdminAuditEventsHeaderXGroupGraphTokenMax = 16384;


export const listAdminAuditEventsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListAdminAuditEventsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listAdminAuditEventsHeaderXGroupGraphTokenMax).regex(listAdminAuditEventsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListAdminAuditEvents200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "at": zod.iso.datetime({"offset":true}),
  "actorUserId": zod.uuid().nullish(),
  "actorName": zod.string().nullish(),
  "action": zod.string(),
  "entityType": zod.string(),
  "entityId": zod.uuid(),
  "summary": zod.string(),
  "before": zod.record(zod.string(), zod.unknown()).nullish(),
  "after": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestId": zod.string().nullish(),
  "correlationId": zod.uuid().nullish()
})),
  "total": zod.int()
}))()

export const listAdminAuditEvents401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAdminAuditEvents401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAdminAuditEvents401ResponseOverlapWarningAcknowledgementMin = 16;
export const listAdminAuditEvents401ResponseOverlapWarningAcknowledgementMax = 256;


export const listAdminAuditEvents401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAdminAuditEvents401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminAuditEvents401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminAuditEvents401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAdminAuditEvents401ResponseOverlapWarningAcknowledgementMin).max(listAdminAuditEvents401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAdminAuditEvents401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listAdminAuditEvents403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAdminAuditEvents403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAdminAuditEvents403ResponseOverlapWarningAcknowledgementMin = 16;
export const listAdminAuditEvents403ResponseOverlapWarningAcknowledgementMax = 256;


export const listAdminAuditEvents403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAdminAuditEvents403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminAuditEvents403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminAuditEvents403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAdminAuditEvents403ResponseOverlapWarningAcknowledgementMin).max(listAdminAuditEvents403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAdminAuditEvents403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Idempotent administrator action scoped to the active default entity; preserves existing edits on repeat runs.
 * @summary Import Harbour Exchange source inventory for the default test entity
 */
export const importHarbourExchangeHeaderXGroupGraphTokenMax = 16384;


export const importHarbourExchangeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ImportHarbourExchangeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(importHarbourExchangeHeaderXGroupGraphTokenMax).regex(importHarbourExchangeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const importHarbourExchange200ResponseCountsFloorsMin = 0;

export const importHarbourExchange200ResponseCountsRoomsMin = 0;

export const importHarbourExchange200ResponseCountsWorkAreasMin = 0;

export const importHarbourExchange200ResponseCountsDesksMin = 0;

export const importHarbourExchange200ResponseCreatedMin = 0;

export const importHarbourExchange200ResponseSkippedMin = 0;



export const ImportHarbourExchange200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "buildingId": zod.uuid(),
  "floorIds": zod.record(zod.string(), zod.uuid()),
  "workAreaIds": zod.record(zod.string(), zod.uuid()),
  "counts": zod.object({
  "floors": zod.int().min(importHarbourExchange200ResponseCountsFloorsMin),
  "rooms": zod.int().min(importHarbourExchange200ResponseCountsRoomsMin),
  "workAreas": zod.int().min(importHarbourExchange200ResponseCountsWorkAreasMin),
  "desks": zod.int().min(importHarbourExchange200ResponseCountsDesksMin)
}),
  "created": zod.int().min(importHarbourExchange200ResponseCreatedMin),
  "skipped": zod.int().min(importHarbourExchange200ResponseSkippedMin),
  "mappings": zod.array(zod.object({
  "sourceId": zod.string(),
  "spaceId": zod.uuid(),
  "floorSourceId": zod.string(),
  "kind": zod.enum(['room', 'desk'])
}))
}))()

export const importHarbourExchange401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const importHarbourExchange401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const importHarbourExchange401ResponseOverlapWarningAcknowledgementMin = 16;
export const importHarbourExchange401ResponseOverlapWarningAcknowledgementMax = 256;


export const importHarbourExchange401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ImportHarbourExchange401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(importHarbourExchange401ResponseOverlapWarningAcknowledgementMin).max(importHarbourExchange401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(importHarbourExchange401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const importHarbourExchange403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const importHarbourExchange403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const importHarbourExchange403ResponseOverlapWarningAcknowledgementMin = 16;
export const importHarbourExchange403ResponseOverlapWarningAcknowledgementMax = 256;


export const importHarbourExchange403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ImportHarbourExchange403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(importHarbourExchange403ResponseOverlapWarningAcknowledgementMin).max(importHarbourExchange403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(importHarbourExchange403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const importHarbourExchange409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const importHarbourExchange409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const importHarbourExchange409ResponseOverlapWarningAcknowledgementMin = 16;
export const importHarbourExchange409ResponseOverlapWarningAcknowledgementMax = 256;


export const importHarbourExchange409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ImportHarbourExchange409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importHarbourExchange409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(importHarbourExchange409ResponseOverlapWarningAcknowledgementMin).max(importHarbourExchange409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(importHarbourExchange409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Preview the scoped Harbour Exchange deployment location correction
 */
export const getHarbourLocationHeaderXGroupGraphTokenMax = 16384;


export const getHarbourLocationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetHarbourLocationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getHarbourLocationHeaderXGroupGraphTokenMax).regex(getHarbourLocationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getHarbourLocation200ResponseTargetLatitudeMin = -90;
export const getHarbourLocation200ResponseTargetLatitudeMax = 90;

export const getHarbourLocation200ResponseTargetLongitudeMin = -180;
export const getHarbourLocation200ResponseTargetLongitudeMax = 180;



export const GetHarbourLocation200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['missing', 'conflict', 'needs_update', 'current']),
  "reason": zod.string().nullable(),
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "current": zod.object({
  "address": zod.string().nullable(),
  "siteLatitude": zod.number().nullable(),
  "siteLongitude": zod.number().nullable(),
  "buildingLatitude": zod.number().nullable(),
  "buildingLongitude": zod.number().nullable()
}),
  "target": zod.object({
  "address": zod.string(),
  "latitude": zod.number().min(getHarbourLocation200ResponseTargetLatitudeMin).max(getHarbourLocation200ResponseTargetLatitudeMax),
  "longitude": zod.number().min(getHarbourLocation200ResponseTargetLongitudeMin).max(getHarbourLocation200ResponseTargetLongitudeMax),
  "source": zod.url(),
  "sourceRecordId": zod.string()
})
}))()

export const getHarbourLocation401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getHarbourLocation401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getHarbourLocation401ResponseOverlapWarningAcknowledgementMin = 16;
export const getHarbourLocation401ResponseOverlapWarningAcknowledgementMax = 256;


export const getHarbourLocation401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetHarbourLocation401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourLocation401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourLocation401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getHarbourLocation401ResponseOverlapWarningAcknowledgementMin).max(getHarbourLocation401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getHarbourLocation401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getHarbourLocation403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getHarbourLocation403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getHarbourLocation403ResponseOverlapWarningAcknowledgementMin = 16;
export const getHarbourLocation403ResponseOverlapWarningAcknowledgementMax = 256;


export const getHarbourLocation403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetHarbourLocation403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourLocation403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourLocation403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getHarbourLocation403ResponseOverlapWarningAcknowledgementMin).max(getHarbourLocation403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getHarbourLocation403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Explicit, audited, idempotent administrator action; rejects unrelated source or administrator location edits.
 * @summary Apply the verified location to the existing Harbour site and building
 */
export const applyHarbourLocationHeaderXGroupGraphTokenMax = 16384;


export const applyHarbourLocationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ApplyHarbourLocationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(applyHarbourLocationHeaderXGroupGraphTokenMax).regex(applyHarbourLocationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const applyHarbourLocation200ResponseTargetLatitudeMin = -90;
export const applyHarbourLocation200ResponseTargetLatitudeMax = 90;

export const applyHarbourLocation200ResponseTargetLongitudeMin = -180;
export const applyHarbourLocation200ResponseTargetLongitudeMax = 180;



export const ApplyHarbourLocation200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['missing', 'conflict', 'needs_update', 'current']),
  "reason": zod.string().nullable(),
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "current": zod.object({
  "address": zod.string().nullable(),
  "siteLatitude": zod.number().nullable(),
  "siteLongitude": zod.number().nullable(),
  "buildingLatitude": zod.number().nullable(),
  "buildingLongitude": zod.number().nullable()
}),
  "target": zod.object({
  "address": zod.string(),
  "latitude": zod.number().min(applyHarbourLocation200ResponseTargetLatitudeMin).max(applyHarbourLocation200ResponseTargetLatitudeMax),
  "longitude": zod.number().min(applyHarbourLocation200ResponseTargetLongitudeMin).max(applyHarbourLocation200ResponseTargetLongitudeMax),
  "source": zod.url(),
  "sourceRecordId": zod.string()
})
}))()

export const applyHarbourLocation401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyHarbourLocation401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyHarbourLocation401ResponseOverlapWarningAcknowledgementMin = 16;
export const applyHarbourLocation401ResponseOverlapWarningAcknowledgementMax = 256;


export const applyHarbourLocation401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyHarbourLocation401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyHarbourLocation401ResponseOverlapWarningAcknowledgementMin).max(applyHarbourLocation401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyHarbourLocation401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyHarbourLocation403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyHarbourLocation403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyHarbourLocation403ResponseOverlapWarningAcknowledgementMin = 16;
export const applyHarbourLocation403ResponseOverlapWarningAcknowledgementMax = 256;


export const applyHarbourLocation403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyHarbourLocation403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyHarbourLocation403ResponseOverlapWarningAcknowledgementMin).max(applyHarbourLocation403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyHarbourLocation403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyHarbourLocation409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyHarbourLocation409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyHarbourLocation409ResponseOverlapWarningAcknowledgementMin = 16;
export const applyHarbourLocation409ResponseOverlapWarningAcknowledgementMax = 256;


export const applyHarbourLocation409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyHarbourLocation409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyHarbourLocation409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyHarbourLocation409ResponseOverlapWarningAcknowledgementMin).max(applyHarbourLocation409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyHarbourLocation409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the default test entity's Harbour Exchange demonstration status
 */
export const getHarbourDemoHeaderXGroupGraphTokenMax = 16384;


export const getHarbourDemoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetHarbourDemoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getHarbourDemoHeaderXGroupGraphTokenMax).regex(getHarbourDemoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetHarbourDemo200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "date": zod.iso.date().nullable(),
  "timezone": zod.string(),
  "lastRefreshedAt": zod.iso.datetime({"offset":true}).nullable(),
  "replayed": zod.boolean(),
  "scenarios": zod.array(zod.object({
  "key": zod.string(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid(),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))
}))()

export const getHarbourDemo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getHarbourDemo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getHarbourDemo403ResponseOverlapWarningAcknowledgementMin = 16;
export const getHarbourDemo403ResponseOverlapWarningAcknowledgementMax = 256;


export const getHarbourDemo403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetHarbourDemo403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourDemo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHarbourDemo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getHarbourDemo403ResponseOverlapWarningAcknowledgementMin).max(getHarbourDemo403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getHarbourDemo403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Refresh managed Harbour Exchange bookings for a site-local date
 */
export const refreshHarbourDemoHeaderXGroupGraphTokenMax = 16384;


export const refreshHarbourDemoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RefreshHarbourDemoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(refreshHarbourDemoHeaderXGroupGraphTokenMax).regex(refreshHarbourDemoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const RefreshHarbourDemoBody = /*#__PURE__*/ (() => zod.object({
  "date": zod.iso.date().optional().describe('Australia/Melbourne date; defaults to today'),
  "requestId": zod.uuid().describe('Client-generated idempotency key')
}))()

export const RefreshHarbourDemo200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "date": zod.iso.date().nullable(),
  "timezone": zod.string(),
  "lastRefreshedAt": zod.iso.datetime({"offset":true}).nullable(),
  "replayed": zod.boolean(),
  "scenarios": zod.array(zod.object({
  "key": zod.string(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid(),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))
}))()

export const refreshHarbourDemo400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const refreshHarbourDemo400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const refreshHarbourDemo400ResponseOverlapWarningAcknowledgementMin = 16;
export const refreshHarbourDemo400ResponseOverlapWarningAcknowledgementMax = 256;


export const refreshHarbourDemo400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RefreshHarbourDemo400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(refreshHarbourDemo400ResponseOverlapWarningAcknowledgementMin).max(refreshHarbourDemo400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(refreshHarbourDemo400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const refreshHarbourDemo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const refreshHarbourDemo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const refreshHarbourDemo403ResponseOverlapWarningAcknowledgementMin = 16;
export const refreshHarbourDemo403ResponseOverlapWarningAcknowledgementMax = 256;


export const refreshHarbourDemo403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RefreshHarbourDemo403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(refreshHarbourDemo403ResponseOverlapWarningAcknowledgementMin).max(refreshHarbourDemo403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(refreshHarbourDemo403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const refreshHarbourDemo409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const refreshHarbourDemo409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const refreshHarbourDemo409ResponseOverlapWarningAcknowledgementMin = 16;
export const refreshHarbourDemo409ResponseOverlapWarningAcknowledgementMax = 256;


export const refreshHarbourDemo409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RefreshHarbourDemo409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(refreshHarbourDemo409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(refreshHarbourDemo409ResponseOverlapWarningAcknowledgementMin).max(refreshHarbourDemo409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(refreshHarbourDemo409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Idempotent administrator action; existing inventory and geometry edits are preserved.
 * @summary Import the reviewed Brisbane Level 14 plan and inventory
 */
export const importBrisbaneLevel14HeaderXGroupGraphTokenMax = 16384;


export const importBrisbaneLevel14HeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ImportBrisbaneLevel14Header = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(importBrisbaneLevel14HeaderXGroupGraphTokenMax).regex(importBrisbaneLevel14HeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const importBrisbaneLevel14200ResponseCreatedMin = 0;

export const importBrisbaneLevel14200ResponseSkippedMin = 0;



export const ImportBrisbaneLevel14200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "floorId": zod.uuid(),
  "created": zod.int().min(importBrisbaneLevel14200ResponseCreatedMin),
  "skipped": zod.int().min(importBrisbaneLevel14200ResponseSkippedMin)
}))()

export const importBrisbaneLevel14401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const importBrisbaneLevel14401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const importBrisbaneLevel14401ResponseOverlapWarningAcknowledgementMin = 16;
export const importBrisbaneLevel14401ResponseOverlapWarningAcknowledgementMax = 256;


export const importBrisbaneLevel14401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ImportBrisbaneLevel14401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importBrisbaneLevel14401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importBrisbaneLevel14401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(importBrisbaneLevel14401ResponseOverlapWarningAcknowledgementMin).max(importBrisbaneLevel14401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(importBrisbaneLevel14401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const importBrisbaneLevel14403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const importBrisbaneLevel14403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const importBrisbaneLevel14403ResponseOverlapWarningAcknowledgementMin = 16;
export const importBrisbaneLevel14403ResponseOverlapWarningAcknowledgementMax = 256;


export const importBrisbaneLevel14403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ImportBrisbaneLevel14403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importBrisbaneLevel14403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(importBrisbaneLevel14403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(importBrisbaneLevel14403ResponseOverlapWarningAcknowledgementMin).max(importBrisbaneLevel14403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(importBrisbaneLevel14403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns a paginated list of users in the active booking tenant and their product-role assignments. Requires integrations:manage.
 * @summary List tenant users and product roles
 */
export const listAdminUsersQueryLimitDefault = 50;
export const listAdminUsersQueryLimitMax = 100;

export const listAdminUsersQueryOffsetDefault = 0;
export const listAdminUsersQueryOffsetMin = 0;
export const listAdminUsersQueryOffsetMax = 10000;



export const ListAdminUsersQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listAdminUsersQueryLimitMax).default(listAdminUsersQueryLimitDefault),
  "offset": zod.int().min(listAdminUsersQueryOffsetMin).max(listAdminUsersQueryOffsetMax).default(listAdminUsersQueryOffsetDefault)
}))()

export const listAdminUsersHeaderXGroupGraphTokenMax = 16384;


export const listAdminUsersHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListAdminUsersHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listAdminUsersHeaderXGroupGraphTokenMax).regex(listAdminUsersHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listAdminUsers200ResponseTotalMin = 0;


export const listAdminUsers200ResponseOffsetMin = 0;



export const ListAdminUsers200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "email": zod.string().nullable(),
  "lastLoginAt": zod.iso.datetime({"offset":true}).nullable(),
  "roles": zod.array(zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host']))
})),
  "total": zod.int().min(listAdminUsers200ResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listAdminUsers200ResponseOffsetMin)
}))()

export const listAdminUsers401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAdminUsers401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAdminUsers401ResponseOverlapWarningAcknowledgementMin = 16;
export const listAdminUsers401ResponseOverlapWarningAcknowledgementMax = 256;


export const listAdminUsers401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAdminUsers401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminUsers401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminUsers401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAdminUsers401ResponseOverlapWarningAcknowledgementMin).max(listAdminUsers401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAdminUsers401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listAdminUsers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAdminUsers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAdminUsers403ResponseOverlapWarningAcknowledgementMin = 16;
export const listAdminUsers403ResponseOverlapWarningAcknowledgementMax = 256;


export const listAdminUsers403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAdminUsers403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminUsers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminUsers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAdminUsers403ResponseOverlapWarningAcknowledgementMin).max(listAdminUsers403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAdminUsers403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Assigns a validated product role, writes a tenant audit event, and invalidates cached identity grants. Assigning it_admin additionally requires the target principal to be in BOOKING_BOOTSTRAP_ADMIN_OIDS or BOOKING_BOOTSTRAP_ADMIN_EMAILS. Requires integrations:manage.
 * @summary Assign a product role to a tenant user
 */
export const AssignAdminUserRoleParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const assignAdminUserRoleHeaderXGroupGraphTokenMax = 16384;


export const assignAdminUserRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AssignAdminUserRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(assignAdminUserRoleHeaderXGroupGraphTokenMax).regex(assignAdminUserRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const AssignAdminUserRoleBody = /*#__PURE__*/ (() => zod.object({
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}))()

export const AssignAdminUserRole201Response = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid(),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host']),
  "roles": zod.array(zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])),
  "created": zod.boolean()
}))()

export const assignAdminUserRole400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const assignAdminUserRole400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const assignAdminUserRole400ResponseOverlapWarningAcknowledgementMin = 16;
export const assignAdminUserRole400ResponseOverlapWarningAcknowledgementMax = 256;


export const assignAdminUserRole400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AssignAdminUserRole400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(assignAdminUserRole400ResponseOverlapWarningAcknowledgementMin).max(assignAdminUserRole400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(assignAdminUserRole400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const assignAdminUserRole401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const assignAdminUserRole401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const assignAdminUserRole401ResponseOverlapWarningAcknowledgementMin = 16;
export const assignAdminUserRole401ResponseOverlapWarningAcknowledgementMax = 256;


export const assignAdminUserRole401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AssignAdminUserRole401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(assignAdminUserRole401ResponseOverlapWarningAcknowledgementMin).max(assignAdminUserRole401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(assignAdminUserRole401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const assignAdminUserRole403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const assignAdminUserRole403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const assignAdminUserRole403ResponseOverlapWarningAcknowledgementMin = 16;
export const assignAdminUserRole403ResponseOverlapWarningAcknowledgementMax = 256;


export const assignAdminUserRole403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AssignAdminUserRole403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(assignAdminUserRole403ResponseOverlapWarningAcknowledgementMin).max(assignAdminUserRole403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(assignAdminUserRole403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const assignAdminUserRole404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const assignAdminUserRole404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const assignAdminUserRole404ResponseOverlapWarningAcknowledgementMin = 16;
export const assignAdminUserRole404ResponseOverlapWarningAcknowledgementMax = 256;


export const assignAdminUserRole404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AssignAdminUserRole404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(assignAdminUserRole404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(assignAdminUserRole404ResponseOverlapWarningAcknowledgementMin).max(assignAdminUserRole404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(assignAdminUserRole404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Removes a validated product role, writes a tenant audit event, and invalidates cached identity grants. A caller cannot remove their own final it_admin assignment. Requires integrations:manage.
 * @summary Remove a product role from a tenant user
 */
export const RemoveAdminUserRoleParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid(),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}))()

export const removeAdminUserRoleHeaderXGroupGraphTokenMax = 16384;


export const removeAdminUserRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveAdminUserRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeAdminUserRoleHeaderXGroupGraphTokenMax).regex(removeAdminUserRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const RemoveAdminUserRole204Response = /*#__PURE__*/ (() => zod.void())()

export const removeAdminUserRole400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminUserRole400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminUserRole400ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminUserRole400ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminUserRole400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminUserRole400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminUserRole400ResponseOverlapWarningAcknowledgementMin).max(removeAdminUserRole400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminUserRole400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeAdminUserRole401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminUserRole401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminUserRole401ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminUserRole401ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminUserRole401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminUserRole401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminUserRole401ResponseOverlapWarningAcknowledgementMin).max(removeAdminUserRole401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminUserRole401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeAdminUserRole403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminUserRole403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminUserRole403ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminUserRole403ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminUserRole403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminUserRole403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminUserRole403ResponseOverlapWarningAcknowledgementMin).max(removeAdminUserRole403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminUserRole403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeAdminUserRole404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminUserRole404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminUserRole404ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminUserRole404ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminUserRole404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminUserRole404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminUserRole404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminUserRole404ResponseOverlapWarningAcknowledgementMin).max(removeAdminUserRole404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminUserRole404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Directory mode resolves fresh direct reports and filters them to current members of the active tenant. Local mode uses only audited assignments. An unavailable directory returns status=unavailable and no reports. Directory access uses the manager's browser-acquired delegated Graph credential, checked by Graph against the independently authenticated API actor and tenant.
 * @summary Resolve the signed-in manager's own direct reports
 */
export const getMyManagerScopeQueryLimitDefault = 50;
export const getMyManagerScopeQueryLimitMax = 100;

export const getMyManagerScopeQueryOffsetDefault = 0;
export const getMyManagerScopeQueryOffsetMin = 0;



export const GetMyManagerScopeQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getMyManagerScopeQueryLimitMax).default(getMyManagerScopeQueryLimitDefault),
  "offset": zod.int().min(getMyManagerScopeQueryOffsetMin).default(getMyManagerScopeQueryOffsetDefault)
}))()

export const getMyManagerScopeHeaderXGroupGraphTokenMax = 16384;


export const getMyManagerScopeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');
export const getMyManagerScopeHeaderXManagerGraphTokenMax = 16384;


export const getMyManagerScopeHeaderXManagerGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyManagerScopeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyManagerScopeHeaderXGroupGraphTokenMax).regex(getMyManagerScopeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n'),
  "X-Manager-Graph-Token": zod.string().min(1).max(getMyManagerScopeHeaderXManagerGraphTokenMax).regex(getMyManagerScopeHeaderXManagerGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph access token from the signed-in manager\'s existing browser session. Only a downstream Graph credential; Authorization must still contain the independently validated custom-API bearer. The server checks Graph /me and /organization against API oid/tid before reading reports. Never persist, log or include in URLs. Missing access makes directory mode unavailable; local assignments remain usable.\n')
}))()

export const getMyManagerScope200ResponseReportsTotalMin = 0;


export const getMyManagerScope200ResponseReportsOffsetMin = 0;



export const GetMyManagerScope200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['ready', 'unavailable']),
  "source": zod.enum(['directory', 'local']),
  "reason": zod.enum(['setup_required', 'consent_required', 'tenant_mismatch', 'directory_error', 'incomplete_directory', 'scope_changed']).optional(),
  "checkedAt": zod.iso.datetime({"offset":true}),
  "reports": zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(getMyManagerScope200ResponseReportsTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getMyManagerScope200ResponseReportsOffsetMin)
})
}))()

export const getMyManagerScope401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyManagerScope401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyManagerScope401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyManagerScope401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyManagerScope401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyManagerScope401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyManagerScope401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyManagerScope401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyManagerScope401ResponseOverlapWarningAcknowledgementMin).max(getMyManagerScope401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyManagerScope401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getMyManagerScope403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyManagerScope403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyManagerScope403ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyManagerScope403ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyManagerScope403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyManagerScope403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyManagerScope403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyManagerScope403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyManagerScope403ResponseOverlapWarningAcknowledgementMin).max(getMyManagerScope403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyManagerScope403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Review a tenant manager's source mode and local assignments
 */
export const GetAdminManagerScopeParams = /*#__PURE__*/ (() => zod.object({
  "managerUserId": zod.uuid()
}))()

export const getAdminManagerScopeQueryLimitDefault = 50;
export const getAdminManagerScopeQueryLimitMax = 100;

export const getAdminManagerScopeQueryOffsetDefault = 0;
export const getAdminManagerScopeQueryOffsetMin = 0;



export const GetAdminManagerScopeQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getAdminManagerScopeQueryLimitMax).default(getAdminManagerScopeQueryLimitDefault),
  "offset": zod.int().min(getAdminManagerScopeQueryOffsetMin).default(getAdminManagerScopeQueryOffsetDefault)
}))()

export const getAdminManagerScopeHeaderXGroupGraphTokenMax = 16384;


export const getAdminManagerScopeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');
export const getAdminManagerScopeHeaderXManagerGraphTokenMax = 16384;


export const getAdminManagerScopeHeaderXManagerGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetAdminManagerScopeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getAdminManagerScopeHeaderXGroupGraphTokenMax).regex(getAdminManagerScopeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n'),
  "X-Manager-Graph-Token": zod.string().min(1).max(getAdminManagerScopeHeaderXManagerGraphTokenMax).regex(getAdminManagerScopeHeaderXManagerGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph access token from the signed-in manager\'s existing browser session. Only a downstream Graph credential; Authorization must still contain the independently validated custom-API bearer. The server checks Graph /me and /organization against API oid/tid before reading reports. Never persist, log or include in URLs. Missing access makes directory mode unavailable; local assignments remain usable.\n')
}))()

export const getAdminManagerScope200ResponseLocalReportsTotalMin = 0;


export const getAdminManagerScope200ResponseLocalReportsOffsetMin = 0;



export const GetAdminManagerScope200Response = /*#__PURE__*/ (() => zod.object({
  "manager": zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable()
}),
  "mode": zod.enum(['directory', 'local']),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "resolution": zod.object({
  "status": zod.enum(['ready', 'unavailable']),
  "reason": zod.enum(['setup_required', 'consent_required', 'tenant_mismatch', 'directory_error', 'incomplete_directory', 'scope_changed']).optional(),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "localReports": zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(getAdminManagerScope200ResponseLocalReportsTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getAdminManagerScope200ResponseLocalReportsOffsetMin)
})
}))()

export const getAdminManagerScope403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminManagerScope403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminManagerScope403ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminManagerScope403ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminManagerScope403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminManagerScope403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminManagerScope403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminManagerScope403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminManagerScope403ResponseOverlapWarningAcknowledgementMin).max(getAdminManagerScope403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminManagerScope403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getAdminManagerScope404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getAdminManagerScope404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getAdminManagerScope404ResponseOverlapWarningAcknowledgementMin = 16;
export const getAdminManagerScope404ResponseOverlapWarningAcknowledgementMax = 256;


export const getAdminManagerScope404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetAdminManagerScope404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminManagerScope404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getAdminManagerScope404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getAdminManagerScope404ResponseOverlapWarningAcknowledgementMin).max(getAdminManagerScope404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getAdminManagerScope404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Explicitly select directory or local replacement scope
 */
export const SetAdminManagerScopeModeParams = /*#__PURE__*/ (() => zod.object({
  "managerUserId": zod.uuid()
}))()

export const setAdminManagerScopeModeHeaderXGroupGraphTokenMax = 16384;


export const setAdminManagerScopeModeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetAdminManagerScopeModeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setAdminManagerScopeModeHeaderXGroupGraphTokenMax).regex(setAdminManagerScopeModeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setAdminManagerScopeModeBodyReasonMin = 3;
export const setAdminManagerScopeModeBodyReasonMax = 500;



export const SetAdminManagerScopeModeBody = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['directory', 'local']),
  "reason": zod.string().min(setAdminManagerScopeModeBodyReasonMin).max(setAdminManagerScopeModeBodyReasonMax)
}))()

export const SetAdminManagerScopeMode200Response = /*#__PURE__*/ (() => zod.object({
  "managerUserId": zod.uuid(),
  "mode": zod.enum(['directory', 'local'])
}))()

export const setAdminManagerScopeMode403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setAdminManagerScopeMode403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setAdminManagerScopeMode403ResponseOverlapWarningAcknowledgementMin = 16;
export const setAdminManagerScopeMode403ResponseOverlapWarningAcknowledgementMax = 256;


export const setAdminManagerScopeMode403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetAdminManagerScopeMode403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setAdminManagerScopeMode403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setAdminManagerScopeMode403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setAdminManagerScopeMode403ResponseOverlapWarningAcknowledgementMin).max(setAdminManagerScopeMode403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setAdminManagerScopeMode403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Add an audited local direct-report assignment
 */
export const AddAdminManagerReportParams = /*#__PURE__*/ (() => zod.object({
  "managerUserId": zod.uuid()
}))()

export const addAdminManagerReportHeaderXGroupGraphTokenMax = 16384;


export const addAdminManagerReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AddAdminManagerReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(addAdminManagerReportHeaderXGroupGraphTokenMax).regex(addAdminManagerReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const addAdminManagerReportBodyReasonMin = 3;
export const addAdminManagerReportBodyReasonMax = 500;



export const AddAdminManagerReportBody = /*#__PURE__*/ (() => zod.object({
  "reportUserId": zod.uuid(),
  "reason": zod.string().min(addAdminManagerReportBodyReasonMin).max(addAdminManagerReportBodyReasonMax)
}))()

export const AddAdminManagerReport201Response = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable()
}))()

export const addAdminManagerReport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addAdminManagerReport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addAdminManagerReport400ResponseOverlapWarningAcknowledgementMin = 16;
export const addAdminManagerReport400ResponseOverlapWarningAcknowledgementMax = 256;


export const addAdminManagerReport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddAdminManagerReport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addAdminManagerReport400ResponseOverlapWarningAcknowledgementMin).max(addAdminManagerReport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addAdminManagerReport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const addAdminManagerReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addAdminManagerReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addAdminManagerReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const addAdminManagerReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const addAdminManagerReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddAdminManagerReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addAdminManagerReport403ResponseOverlapWarningAcknowledgementMin).max(addAdminManagerReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addAdminManagerReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const addAdminManagerReport404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addAdminManagerReport404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addAdminManagerReport404ResponseOverlapWarningAcknowledgementMin = 16;
export const addAdminManagerReport404ResponseOverlapWarningAcknowledgementMax = 256;


export const addAdminManagerReport404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddAdminManagerReport404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addAdminManagerReport404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addAdminManagerReport404ResponseOverlapWarningAcknowledgementMin).max(addAdminManagerReport404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addAdminManagerReport404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove an audited local direct-report assignment
 */
export const RemoveAdminManagerReportParams = /*#__PURE__*/ (() => zod.object({
  "managerUserId": zod.uuid(),
  "reportUserId": zod.uuid()
}))()

export const removeAdminManagerReportHeaderXGroupGraphTokenMax = 16384;


export const removeAdminManagerReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveAdminManagerReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeAdminManagerReportHeaderXGroupGraphTokenMax).regex(removeAdminManagerReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const removeAdminManagerReportBodyReasonMin = 3;
export const removeAdminManagerReportBodyReasonMax = 500;



export const RemoveAdminManagerReportBody = /*#__PURE__*/ (() => zod.object({
  "reason": zod.string().min(removeAdminManagerReportBodyReasonMin).max(removeAdminManagerReportBodyReasonMax)
}))()

export const RemoveAdminManagerReport204Response = /*#__PURE__*/ (() => zod.void())()

export const removeAdminManagerReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminManagerReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminManagerReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminManagerReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminManagerReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminManagerReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminManagerReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminManagerReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminManagerReport403ResponseOverlapWarningAcknowledgementMin).max(removeAdminManagerReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminManagerReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeAdminManagerReport404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeAdminManagerReport404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeAdminManagerReport404ResponseOverlapWarningAcknowledgementMin = 16;
export const removeAdminManagerReport404ResponseOverlapWarningAcknowledgementMax = 256;


export const removeAdminManagerReport404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveAdminManagerReport404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminManagerReport404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeAdminManagerReport404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeAdminManagerReport404ResponseOverlapWarningAcknowledgementMin).max(removeAdminManagerReport404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeAdminManagerReport404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Honest degradation signals for room search banners and admin connector cards (FR-AD-050, FR-DG-001–004, FR-EU-017). No secrets returned.
 * @summary Connector readiness (Graph, LLM, DB, auth)
 */
export const GetIntegrationsStatus200Response = /*#__PURE__*/ (() => zod.object({
  "graph": zod.object({
  "status": zod.enum(['ready', 'disconnected', 'degraded', 'disabled', 'not_configured']),
  "connected": zod.boolean(),
  "mode": zod.enum(['mock', 'live', 'none']),
  "message": zod.string(),
  "envConfigured": zod.boolean().optional(),
  "forceMock": zod.boolean().optional(),
  "liveSelected": zod.boolean().optional(),
  "lastError": zod.string().nullish(),
  "lastCheckedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastFallbackAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastFallbackError": zod.string().nullish(),
  "consentSteps": zod.array(zod.string()).optional(),
  "tenantIdMasked": zod.string().nullish(),
  "clientIdMasked": zod.string().nullish()
}),
  "llm": zod.object({
  "status": zod.enum(['ready', 'disconnected', 'degraded', 'disabled', 'not_configured']),
  "message": zod.string()
}),
  "database": zod.object({
  "status": zod.enum(['ready', 'disconnected', 'degraded', 'disabled', 'not_configured']),
  "message": zod.string()
}),
  "auth": zod.object({
  "status": zod.enum(['ready', 'disconnected', 'degraded', 'disabled', 'not_configured']),
  "message": zod.string()
}),
  "roomAvailability": zod.object({
  "source": zod.enum(['app', 'app_fallback', 'exchange']),
  "banner": zod.string().nullable()
})
}))()

export const getIntegrationsStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getIntegrationsStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getIntegrationsStatus401ResponseOverlapWarningAcknowledgementMin = 16;
export const getIntegrationsStatus401ResponseOverlapWarningAcknowledgementMax = 256;


export const getIntegrationsStatus401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetIntegrationsStatus401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntegrationsStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntegrationsStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getIntegrationsStatus401ResponseOverlapWarningAcknowledgementMin).max(getIntegrationsStatus401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getIntegrationsStatus401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Read-only checks of the selected entity's parent tenant connection. Requires current parent tenant administration; View as denied. Token, discovery and organiser calendar reads never prove write consent, room acceptance or delivery. No global fallback.
 * @summary Probe Microsoft Graph room connector (admin)
 */
export const TestGraphConnection200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean(),
  "mode": zod.enum(['mock', 'live', 'force_mock', 'none']),
  "message": zod.string(),
  "consentSteps": zod.array(zod.string())
}))()

export const testGraphConnection401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const testGraphConnection401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const testGraphConnection401ResponseOverlapWarningAcknowledgementMin = 16;
export const testGraphConnection401ResponseOverlapWarningAcknowledgementMax = 256;


export const testGraphConnection401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TestGraphConnection401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(testGraphConnection401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(testGraphConnection401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(testGraphConnection401ResponseOverlapWarningAcknowledgementMin).max(testGraphConnection401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(testGraphConnection401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const testGraphConnection403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const testGraphConnection403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const testGraphConnection403ResponseOverlapWarningAcknowledgementMin = 16;
export const testGraphConnection403ResponseOverlapWarningAcknowledgementMax = 256;


export const testGraphConnection403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TestGraphConnection403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(testGraphConnection403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(testGraphConnection403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(testGraphConnection403ResponseOverlapWarningAcknowledgementMin).max(testGraphConnection403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(testGraphConnection403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Paged tenant-owned Places rooms for explicit inventory matching. Requires current parent tenant administration; View as denied. Never creates or links inventory on read.
 * @summary List Exchange room places from Graph (admin discovery)
 */
export const listGraphRoomsQueryLimitDefault = 25;
export const listGraphRoomsQueryLimitMax = 100;



export const ListGraphRoomsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listGraphRoomsQueryLimitMax).default(listGraphRoomsQueryLimitDefault),
  "cursor": zod.uuid().optional()
}))()

export const listGraphRooms200ResponseLimitMax = 100;



export const ListGraphRooms200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string().nullish(),
  "emailAddress": zod.string().nullish(),
  "capacity": zod.int().nullish(),
  "building": zod.string().nullish(),
  "floorLabel": zod.string().nullish(),
  "tags": zod.array(zod.string()).optional()
})),
  "total": zod.int().describe('Number of items on this page, not a directory-wide total.'),
  "nextCursor": zod.uuid().nullish(),
  "limit": zod.int().min(1).max(listGraphRooms200ResponseLimitMax).optional(),
  "matchingHint": zod.string()
}))()

export const listGraphRooms401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listGraphRooms401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listGraphRooms401ResponseOverlapWarningAcknowledgementMin = 16;
export const listGraphRooms401ResponseOverlapWarningAcknowledgementMax = 256;


export const listGraphRooms401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListGraphRooms401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listGraphRooms401ResponseOverlapWarningAcknowledgementMin).max(listGraphRooms401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listGraphRooms401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listGraphRooms403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listGraphRooms403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listGraphRooms403ResponseOverlapWarningAcknowledgementMin = 16;
export const listGraphRooms403ResponseOverlapWarningAcknowledgementMax = 256;


export const listGraphRooms403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListGraphRooms403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listGraphRooms403ResponseOverlapWarningAcknowledgementMin).max(listGraphRooms403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listGraphRooms403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listGraphRooms422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listGraphRooms422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listGraphRooms422ResponseOverlapWarningAcknowledgementMin = 16;
export const listGraphRooms422ResponseOverlapWarningAcknowledgementMax = 256;


export const listGraphRooms422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListGraphRooms422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listGraphRooms422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listGraphRooms422ResponseOverlapWarningAcknowledgementMin).max(listGraphRooms422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listGraphRooms422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Per-entity site setup rules. `siteCoordinatesDisabled` hides and refuses site latitude/longitude; `australianTimezoneList` restricts the site timezone to the Australian zones returned in `timezones`.
 * @summary Site setup options for the selected entity
 */
export const getSiteFormOptionsHeaderXGroupGraphTokenMax = 16384;


export const getSiteFormOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteFormOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteFormOptionsHeaderXGroupGraphTokenMax).regex(getSiteFormOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetSiteFormOptions200Response = /*#__PURE__*/ (() => zod.object({
  "siteCoordinatesDisabled": zod.boolean().describe('Hide site latitude/longitude and refuse stored site coordinates.'),
  "australianTimezoneList": zod.boolean().describe('Restrict the timezone dropdown to Australian timezones.'),
  "defaultSiteTimezone": zod.string().describe('Tenant default for new sites, or Australia/Sydney when unset or outside the entity\'s permitted list.'),
  "timezones": zod.array(zod.object({
  "value": zod.string().describe('IANA zone identifier, for example Australia/Adelaide'),
  "label": zod.string().describe('Friendly label, for example Adelaide (South Australia)')
})).describe('IANA timezone dropdown choices; restricted to Australian zones when configured.')
}))()

export const getSiteFormOptions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteFormOptions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteFormOptions401ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteFormOptions401ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteFormOptions401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteFormOptions401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteFormOptions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteFormOptions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteFormOptions401ResponseOverlapWarningAcknowledgementMin).max(getSiteFormOptions401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteFormOptions401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * The same one-screen Where, When and What layout is used for every entity. The legacy `oneScreenBook` response field is always true.
 * @summary Booking layout for the selected entity
 */
export const getBookingOptionsHeaderXGroupGraphTokenMax = 16384;


export const getBookingOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingOptionsHeaderXGroupGraphTokenMax).regex(getBookingOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetBookingOptions200Response = /*#__PURE__*/ (() => zod.object({
  "oneScreenBook": zod.boolean().describe('Always true. Book uses Where, When and What on one screen for every entity.')
}))()

export const getBookingOptions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getBookingOptions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getBookingOptions401ResponseOverlapWarningAcknowledgementMin = 16;
export const getBookingOptions401ResponseOverlapWarningAcknowledgementMax = 256;


export const getBookingOptions401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetBookingOptions401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBookingOptions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBookingOptions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getBookingOptions401ResponseOverlapWarningAcknowledgementMin).max(getBookingOptions401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getBookingOptions401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const getDeskReservationOptionsHeaderXGroupGraphTokenMax = 16384;


export const getDeskReservationOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDeskReservationOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDeskReservationOptionsHeaderXGroupGraphTokenMax).regex(getDeskReservationOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetDeskReservationOptions200Response = /*#__PURE__*/ (() => zod.object({
  "namedEnabled": zod.boolean(),
  "holdsEnabled": zod.boolean()
}))()


export const PreviewDeskHoldQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))()

export const previewDeskHoldHeaderXGroupGraphTokenMax = 16384;


export const previewDeskHoldHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewDeskHoldHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewDeskHoldHeaderXGroupGraphTokenMax).regex(previewDeskHoldHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewDeskHold200ResponseOrganiserLimitMin = 0;

export const previewDeskHold200ResponseUsedMin = 0;

export const previewDeskHold200ResponseRemainingMin = 0;

export const previewDeskHold200ResponseMaxDesksMin = 0;



export const PreviewDeskHold200Response = /*#__PURE__*/ (() => zod.object({
  "organiserLimit": zod.int().min(previewDeskHold200ResponseOrganiserLimitMin),
  "used": zod.int().min(previewDeskHold200ResponseUsedMin),
  "remaining": zod.int().min(previewDeskHold200ResponseRemainingMin),
  "maxDesks": zod.int().min(previewDeskHold200ResponseMaxDesksMin),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "siteTimeZone": zod.string(),
  "settingsRevision": zod.string(),
  "deadlinePassed": zod.boolean()
}))()

export const PreviewDeskHold400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewDeskHold401Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewDeskHold403Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewDeskHold409Response = /*#__PURE__*/ (() => zod.unknown())()


export const createDeskHoldHeaderXGroupGraphTokenMax = 16384;


export const createDeskHoldHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateDeskHoldHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createDeskHoldHeaderXGroupGraphTokenMax).regex(createDeskHoldHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createDeskHoldBodySpaceIdsMax = 20;



export const CreateDeskHoldBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "spaceIds": zod.array(zod.uuid()).min(1).max(createDeskHoldBodySpaceIdsMax),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
}))()



export const createDeskHold200ResponseSlotsMax = 20;



export const CreateDeskHold200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "canConfigureSite": zod.boolean().optional(),
  "canCancel": zod.boolean().optional(),
  "canClaim": zod.boolean().optional(),
  "siteTimeZone": zod.string().optional(),
  "slots": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid().nullable(),
  "claimedBy": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1)
})).max(createDeskHold200ResponseSlotsMax)
}))()

export const createDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createDeskHold400ResponseOverlapWarningAcknowledgementMin = 16;
export const createDeskHold400ResponseOverlapWarningAcknowledgementMax = 256;


export const createDeskHold400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateDeskHold400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createDeskHold400ResponseOverlapWarningAcknowledgementMin).max(createDeskHold400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createDeskHold400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createDeskHold401ResponseOverlapWarningAcknowledgementMin = 16;
export const createDeskHold401ResponseOverlapWarningAcknowledgementMax = 256;


export const createDeskHold401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateDeskHold401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createDeskHold401ResponseOverlapWarningAcknowledgementMin).max(createDeskHold401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createDeskHold401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createDeskHold403ResponseOverlapWarningAcknowledgementMin = 16;
export const createDeskHold403ResponseOverlapWarningAcknowledgementMax = 256;


export const createDeskHold403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateDeskHold403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createDeskHold403ResponseOverlapWarningAcknowledgementMin).max(createDeskHold403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createDeskHold403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createDeskHold404ResponseOverlapWarningAcknowledgementMin = 16;
export const createDeskHold404ResponseOverlapWarningAcknowledgementMax = 256;


export const createDeskHold404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateDeskHold404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createDeskHold404ResponseOverlapWarningAcknowledgementMin).max(createDeskHold404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createDeskHold404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createDeskHold409ResponseOverlapWarningAcknowledgementMin = 16;
export const createDeskHold409ResponseOverlapWarningAcknowledgementMax = 256;


export const createDeskHold409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateDeskHold409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createDeskHold409ResponseOverlapWarningAcknowledgementMin).max(createDeskHold409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createDeskHold409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const listDeskHoldsQueryLimitDefault = 25;
export const listDeskHoldsQueryLimitMax = 100;

export const listDeskHoldsQueryOffsetDefault = 0;
export const listDeskHoldsQueryOffsetMin = 0;
export const listDeskHoldsQueryOffsetMax = 100000;



export const ListDeskHoldsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listDeskHoldsQueryLimitMax).default(listDeskHoldsQueryLimitDefault),
  "offset": zod.int().min(listDeskHoldsQueryOffsetMin).max(listDeskHoldsQueryOffsetMax).default(listDeskHoldsQueryOffsetDefault),
  "workgroupId": zod.uuid().optional(),
  "siteId": zod.uuid().optional()
}))()

export const listDeskHoldsHeaderXGroupGraphTokenMax = 16384;


export const listDeskHoldsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListDeskHoldsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listDeskHoldsHeaderXGroupGraphTokenMax).regex(listDeskHoldsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listDeskHolds200ResponseItemsMax = 100;



export const ListDeskHolds200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listDeskHolds200ResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const listDeskHolds400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDeskHolds400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDeskHolds400ResponseOverlapWarningAcknowledgementMin = 16;
export const listDeskHolds400ResponseOverlapWarningAcknowledgementMax = 256;


export const listDeskHolds400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDeskHolds400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDeskHolds400ResponseOverlapWarningAcknowledgementMin).max(listDeskHolds400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDeskHolds400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listDeskHolds401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDeskHolds401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDeskHolds401ResponseOverlapWarningAcknowledgementMin = 16;
export const listDeskHolds401ResponseOverlapWarningAcknowledgementMax = 256;


export const listDeskHolds401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDeskHolds401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDeskHolds401ResponseOverlapWarningAcknowledgementMin).max(listDeskHolds401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDeskHolds401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listDeskHolds403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDeskHolds403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDeskHolds403ResponseOverlapWarningAcknowledgementMin = 16;
export const listDeskHolds403ResponseOverlapWarningAcknowledgementMax = 256;


export const listDeskHolds403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDeskHolds403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDeskHolds403ResponseOverlapWarningAcknowledgementMin).max(listDeskHolds403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDeskHolds403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listDeskHolds404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDeskHolds404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDeskHolds404ResponseOverlapWarningAcknowledgementMin = 16;
export const listDeskHolds404ResponseOverlapWarningAcknowledgementMax = 256;


export const listDeskHolds404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDeskHolds404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDeskHolds404ResponseOverlapWarningAcknowledgementMin).max(listDeskHolds404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDeskHolds404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listDeskHolds409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDeskHolds409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDeskHolds409ResponseOverlapWarningAcknowledgementMin = 16;
export const listDeskHolds409ResponseOverlapWarningAcknowledgementMax = 256;


export const listDeskHolds409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDeskHolds409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDeskHolds409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDeskHolds409ResponseOverlapWarningAcknowledgementMin).max(listDeskHolds409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDeskHolds409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const GetDeskHoldParams = /*#__PURE__*/ (() => zod.object({
  "holdId": zod.uuid()
}))()

export const getDeskHoldHeaderXGroupGraphTokenMax = 16384;


export const getDeskHoldHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDeskHoldHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDeskHoldHeaderXGroupGraphTokenMax).regex(getDeskHoldHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const getDeskHold200ResponseSlotsMax = 20;



export const GetDeskHold200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "canConfigureSite": zod.boolean().optional(),
  "canCancel": zod.boolean().optional(),
  "canClaim": zod.boolean().optional(),
  "siteTimeZone": zod.string().optional(),
  "slots": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid().nullable(),
  "claimedBy": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1)
})).max(getDeskHold200ResponseSlotsMax)
}))()

export const getDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDeskHold400ResponseOverlapWarningAcknowledgementMin = 16;
export const getDeskHold400ResponseOverlapWarningAcknowledgementMax = 256;


export const getDeskHold400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDeskHold400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDeskHold400ResponseOverlapWarningAcknowledgementMin).max(getDeskHold400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDeskHold400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDeskHold401ResponseOverlapWarningAcknowledgementMin = 16;
export const getDeskHold401ResponseOverlapWarningAcknowledgementMax = 256;


export const getDeskHold401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDeskHold401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDeskHold401ResponseOverlapWarningAcknowledgementMin).max(getDeskHold401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDeskHold401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDeskHold403ResponseOverlapWarningAcknowledgementMin = 16;
export const getDeskHold403ResponseOverlapWarningAcknowledgementMax = 256;


export const getDeskHold403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDeskHold403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDeskHold403ResponseOverlapWarningAcknowledgementMin).max(getDeskHold403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDeskHold403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDeskHold404ResponseOverlapWarningAcknowledgementMin = 16;
export const getDeskHold404ResponseOverlapWarningAcknowledgementMax = 256;


export const getDeskHold404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDeskHold404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDeskHold404ResponseOverlapWarningAcknowledgementMin).max(getDeskHold404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDeskHold404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getDeskHold409ResponseOverlapWarningAcknowledgementMin = 16;
export const getDeskHold409ResponseOverlapWarningAcknowledgementMax = 256;


export const getDeskHold409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetDeskHold409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getDeskHold409ResponseOverlapWarningAcknowledgementMin).max(getDeskHold409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getDeskHold409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const ClaimDeskHoldParams = /*#__PURE__*/ (() => zod.object({
  "holdId": zod.uuid(),
  "slotId": zod.uuid()
}))()

export const claimDeskHoldHeaderXGroupGraphTokenMax = 16384;


export const claimDeskHoldHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ClaimDeskHoldHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(claimDeskHoldHeaderXGroupGraphTokenMax).regex(claimDeskHoldHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const ClaimDeskHoldBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()



export const claimDeskHold200ResponseSlotsMax = 20;



export const ClaimDeskHold200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "canConfigureSite": zod.boolean().optional(),
  "canCancel": zod.boolean().optional(),
  "canClaim": zod.boolean().optional(),
  "siteTimeZone": zod.string().optional(),
  "slots": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid().nullable(),
  "claimedBy": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1)
})).max(claimDeskHold200ResponseSlotsMax)
}))()

export const claimDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const claimDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const claimDeskHold400ResponseOverlapWarningAcknowledgementMin = 16;
export const claimDeskHold400ResponseOverlapWarningAcknowledgementMax = 256;


export const claimDeskHold400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ClaimDeskHold400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(claimDeskHold400ResponseOverlapWarningAcknowledgementMin).max(claimDeskHold400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(claimDeskHold400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const claimDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const claimDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const claimDeskHold401ResponseOverlapWarningAcknowledgementMin = 16;
export const claimDeskHold401ResponseOverlapWarningAcknowledgementMax = 256;


export const claimDeskHold401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ClaimDeskHold401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(claimDeskHold401ResponseOverlapWarningAcknowledgementMin).max(claimDeskHold401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(claimDeskHold401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const claimDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const claimDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const claimDeskHold403ResponseOverlapWarningAcknowledgementMin = 16;
export const claimDeskHold403ResponseOverlapWarningAcknowledgementMax = 256;


export const claimDeskHold403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ClaimDeskHold403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(claimDeskHold403ResponseOverlapWarningAcknowledgementMin).max(claimDeskHold403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(claimDeskHold403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const claimDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const claimDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const claimDeskHold404ResponseOverlapWarningAcknowledgementMin = 16;
export const claimDeskHold404ResponseOverlapWarningAcknowledgementMax = 256;


export const claimDeskHold404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ClaimDeskHold404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(claimDeskHold404ResponseOverlapWarningAcknowledgementMin).max(claimDeskHold404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(claimDeskHold404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const claimDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const claimDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const claimDeskHold409ResponseOverlapWarningAcknowledgementMin = 16;
export const claimDeskHold409ResponseOverlapWarningAcknowledgementMax = 256;


export const claimDeskHold409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ClaimDeskHold409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(claimDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(claimDeskHold409ResponseOverlapWarningAcknowledgementMin).max(claimDeskHold409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(claimDeskHold409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const CancelDeskHoldParams = /*#__PURE__*/ (() => zod.object({
  "holdId": zod.uuid()
}))()

export const cancelDeskHoldHeaderXGroupGraphTokenMax = 16384;


export const cancelDeskHoldHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CancelDeskHoldHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(cancelDeskHoldHeaderXGroupGraphTokenMax).regex(cancelDeskHoldHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const CancelDeskHoldBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()



export const cancelDeskHold200ResponseSlotsMax = 20;



export const CancelDeskHold200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "canConfigureSite": zod.boolean().optional(),
  "canCancel": zod.boolean().optional(),
  "canClaim": zod.boolean().optional(),
  "siteTimeZone": zod.string().optional(),
  "slots": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid().nullable(),
  "claimedBy": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1)
})).max(cancelDeskHold200ResponseSlotsMax)
}))()

export const cancelDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelDeskHold400ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelDeskHold400ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelDeskHold400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelDeskHold400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelDeskHold400ResponseOverlapWarningAcknowledgementMin).max(cancelDeskHold400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelDeskHold400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const cancelDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelDeskHold401ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelDeskHold401ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelDeskHold401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelDeskHold401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelDeskHold401ResponseOverlapWarningAcknowledgementMin).max(cancelDeskHold401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelDeskHold401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const cancelDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelDeskHold403ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelDeskHold403ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelDeskHold403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelDeskHold403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelDeskHold403ResponseOverlapWarningAcknowledgementMin).max(cancelDeskHold403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelDeskHold403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const cancelDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelDeskHold404ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelDeskHold404ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelDeskHold404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelDeskHold404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelDeskHold404ResponseOverlapWarningAcknowledgementMin).max(cancelDeskHold404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelDeskHold404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const cancelDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelDeskHold409ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelDeskHold409ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelDeskHold409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelDeskHold409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelDeskHold409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelDeskHold409ResponseOverlapWarningAcknowledgementMin).max(cancelDeskHold409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelDeskHold409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const GetSiteDeskHoldSettingsParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid()
}))()

export const getSiteDeskHoldSettingsHeaderXGroupGraphTokenMax = 16384;


export const getSiteDeskHoldSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteDeskHoldSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteDeskHoldSettingsHeaderXGroupGraphTokenMax).regex(getSiteDeskHoldSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getSiteDeskHoldSettings200ResponseRevisionMin = 64;
export const getSiteDeskHoldSettings200ResponseRevisionMax = 64;

export const getSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMin = 0;
export const getSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMax = 10080;

export const getSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMin = 0;
export const getSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMax = 10080;



export const GetSiteDeskHoldSettings200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "revision": zod.string().min(getSiteDeskHoldSettings200ResponseRevisionMin).max(getSiteDeskHoldSettings200ResponseRevisionMax),
  "claimMinutesBeforeStart": zod.int().min(getSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMin).max(getSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMax).nullable(),
  "effectiveClaimMinutesBeforeStart": zod.int().min(getSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMin).max(getSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMax),
  "source": zod.enum(['site', 'tenant', 'entity', 'default', 'legacy']),
  "overrideAllowed": zod.boolean()
}))()

export const getSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteDeskHoldSettings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteDeskHoldSettings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMin).max(getSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteDeskHoldSettings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteDeskHoldSettings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteDeskHoldSettings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMin).max(getSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteDeskHoldSettings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteDeskHoldSettings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteDeskHoldSettings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMin).max(getSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteDeskHoldSettings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteDeskHoldSettings404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteDeskHoldSettings404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMin).max(getSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteDeskHoldSettings404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteDeskHoldSettings409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteDeskHoldSettings409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMin).max(getSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteDeskHoldSettings409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const SaveSiteDeskHoldSettingsParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid()
}))()

export const saveSiteDeskHoldSettingsHeaderXGroupGraphTokenMax = 16384;


export const saveSiteDeskHoldSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveSiteDeskHoldSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveSiteDeskHoldSettingsHeaderXGroupGraphTokenMax).regex(saveSiteDeskHoldSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveSiteDeskHoldSettingsBodyExpectedRevisionMin = 64;
export const saveSiteDeskHoldSettingsBodyExpectedRevisionMax = 64;

export const saveSiteDeskHoldSettingsBodyClaimMinutesBeforeStartMin = 0;
export const saveSiteDeskHoldSettingsBodyClaimMinutesBeforeStartMax = 10080;



export const SaveSiteDeskHoldSettingsBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.string().min(saveSiteDeskHoldSettingsBodyExpectedRevisionMin).max(saveSiteDeskHoldSettingsBodyExpectedRevisionMax),
  "claimMinutesBeforeStart": zod.int().min(saveSiteDeskHoldSettingsBodyClaimMinutesBeforeStartMin).max(saveSiteDeskHoldSettingsBodyClaimMinutesBeforeStartMax).nullable()
}))()

export const saveSiteDeskHoldSettings200ResponseRevisionMin = 64;
export const saveSiteDeskHoldSettings200ResponseRevisionMax = 64;

export const saveSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMin = 0;
export const saveSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMax = 10080;

export const saveSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMin = 0;
export const saveSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMax = 10080;



export const SaveSiteDeskHoldSettings200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "revision": zod.string().min(saveSiteDeskHoldSettings200ResponseRevisionMin).max(saveSiteDeskHoldSettings200ResponseRevisionMax),
  "claimMinutesBeforeStart": zod.int().min(saveSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMin).max(saveSiteDeskHoldSettings200ResponseClaimMinutesBeforeStartMax).nullable(),
  "effectiveClaimMinutesBeforeStart": zod.int().min(saveSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMin).max(saveSiteDeskHoldSettings200ResponseEffectiveClaimMinutesBeforeStartMax),
  "source": zod.enum(['site', 'tenant', 'entity', 'default', 'legacy']),
  "overrideAllowed": zod.boolean()
}))()

export const saveSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMin = 16;
export const saveSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMax = 256;


export const saveSiteDeskHoldSettings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveSiteDeskHoldSettings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMin).max(saveSiteDeskHoldSettings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveSiteDeskHoldSettings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMin = 16;
export const saveSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMax = 256;


export const saveSiteDeskHoldSettings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveSiteDeskHoldSettings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMin).max(saveSiteDeskHoldSettings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveSiteDeskHoldSettings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMin = 16;
export const saveSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMax = 256;


export const saveSiteDeskHoldSettings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveSiteDeskHoldSettings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMin).max(saveSiteDeskHoldSettings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveSiteDeskHoldSettings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMin = 16;
export const saveSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMax = 256;


export const saveSiteDeskHoldSettings404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveSiteDeskHoldSettings404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMin).max(saveSiteDeskHoldSettings404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveSiteDeskHoldSettings404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMin = 16;
export const saveSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMax = 256;


export const saveSiteDeskHoldSettings409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveSiteDeskHoldSettings409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveSiteDeskHoldSettings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMin).max(saveSiteDeskHoldSettings409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveSiteDeskHoldSettings409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const GetDeskHoldByRequestParams = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid()
}))()

export const getDeskHoldByRequestHeaderXGroupGraphTokenMax = 16384;


export const getDeskHoldByRequestHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetDeskHoldByRequestHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getDeskHoldByRequestHeaderXGroupGraphTokenMax).regex(getDeskHoldByRequestHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const getDeskHoldByRequest200ResponseSlotsMax = 20;



export const GetDeskHoldByRequest200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "siteId": zod.uuid(),
  "workgroupId": zod.uuid(),
  "organiserId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "claimDeadline": zod.iso.datetime({"offset":true}),
  "revision": zod.int().min(1),
  "state": zod.enum(['active', 'cancelled', 'released']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "canConfigureSite": zod.boolean().optional(),
  "canCancel": zod.boolean().optional(),
  "canClaim": zod.boolean().optional(),
  "siteTimeZone": zod.string().optional(),
  "slots": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "bookingId": zod.uuid().nullable(),
  "claimedBy": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1)
})).max(getDeskHoldByRequest200ResponseSlotsMax)
}))()

export const GetDeskHoldByRequest404Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * One selected entity, distinct admitted members and desks, maximum 20. Exact successful retries return the same creation receipt. Failure rolls back all assignments and notices. Each booking has independent ordinary lifecycle; the receipt is not extra capacity. No adjacent-seat guarantee. No automatic client retries.
 * @summary Atomically reserve desks for named members
 */
export const createNamedDeskRequestHeaderXGroupGraphTokenMax = 16384;


export const createNamedDeskRequestHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateNamedDeskRequestHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createNamedDeskRequestHeaderXGroupGraphTokenMax).regex(createNamedDeskRequestHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createNamedDeskRequestBodyAssignmentsMax = 20;



export const CreateNamedDeskRequestBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "assignments": zod.array(zod.object({
  "beneficiaryId": zod.uuid(),
  "spaceId": zod.uuid()
})).min(1).max(createNamedDeskRequestBodyAssignmentsMax)
}))()

export const createNamedDeskRequest200ResponseOneAssignmentCountMax = 20;

export const createNamedDeskRequest200ResponseTwoAssignmentsMax = 20;



export const CreateNamedDeskRequest200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "entityId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "assignmentCount": zod.int().min(1).max(createNamedDeskRequest200ResponseOneAssignmentCountMax),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "beneficiaryId": zod.uuid(),
  "spaceId": zod.uuid()
})).min(1).max(createNamedDeskRequest200ResponseTwoAssignmentsMax)
})))()

export const createNamedDeskRequest400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createNamedDeskRequest400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createNamedDeskRequest400ResponseOverlapWarningAcknowledgementMin = 16;
export const createNamedDeskRequest400ResponseOverlapWarningAcknowledgementMax = 256;


export const createNamedDeskRequest400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateNamedDeskRequest400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createNamedDeskRequest400ResponseOverlapWarningAcknowledgementMin).max(createNamedDeskRequest400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createNamedDeskRequest400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createNamedDeskRequest403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createNamedDeskRequest403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createNamedDeskRequest403ResponseOverlapWarningAcknowledgementMin = 16;
export const createNamedDeskRequest403ResponseOverlapWarningAcknowledgementMax = 256;


export const createNamedDeskRequest403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateNamedDeskRequest403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createNamedDeskRequest403ResponseOverlapWarningAcknowledgementMin).max(createNamedDeskRequest403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createNamedDeskRequest403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createNamedDeskRequest409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createNamedDeskRequest409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createNamedDeskRequest409ResponseOverlapWarningAcknowledgementMin = 16;
export const createNamedDeskRequest409ResponseOverlapWarningAcknowledgementMax = 256;


export const createNamedDeskRequest409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateNamedDeskRequest409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createNamedDeskRequest409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createNamedDeskRequest409ResponseOverlapWarningAcknowledgementMin).max(createNamedDeskRequest409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createNamedDeskRequest409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Page the current creator's named request summaries
 */
export const listNamedDeskRequestsQueryLimitDefault = 25;
export const listNamedDeskRequestsQueryLimitMax = 100;

export const listNamedDeskRequestsQueryOffsetDefault = 0;
export const listNamedDeskRequestsQueryOffsetMin = 0;
export const listNamedDeskRequestsQueryOffsetMax = 100000;



export const ListNamedDeskRequestsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listNamedDeskRequestsQueryLimitMax).default(listNamedDeskRequestsQueryLimitDefault),
  "offset": zod.int().min(listNamedDeskRequestsQueryOffsetMin).max(listNamedDeskRequestsQueryOffsetMax).default(listNamedDeskRequestsQueryOffsetDefault)
}))()

export const listNamedDeskRequestsHeaderXGroupGraphTokenMax = 16384;


export const listNamedDeskRequestsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListNamedDeskRequestsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listNamedDeskRequestsHeaderXGroupGraphTokenMax).regex(listNamedDeskRequestsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listNamedDeskRequests200ResponseItemsItemAssignmentCountMax = 20;

export const listNamedDeskRequests200ResponseItemsMax = 100;

export const listNamedDeskRequests200ResponseTotalMin = 0;

export const listNamedDeskRequests200ResponseLimitMax = 100;

export const listNamedDeskRequests200ResponseOffsetMin = 0;
export const listNamedDeskRequests200ResponseOffsetMax = 100000;



export const ListNamedDeskRequests200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "entityId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "assignmentCount": zod.int().min(1).max(listNamedDeskRequests200ResponseItemsItemAssignmentCountMax),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listNamedDeskRequests200ResponseItemsMax),
  "total": zod.int().min(listNamedDeskRequests200ResponseTotalMin),
  "limit": zod.int().min(1).max(listNamedDeskRequests200ResponseLimitMax),
  "offset": zod.int().min(listNamedDeskRequests200ResponseOffsetMin).max(listNamedDeskRequests200ResponseOffsetMax)
}))()


/**
 * Read-only lost-response recovery, including when named work is disabled. Current admission and beneficiary authority remain required. Missing or foreign requests return 404; writes are never replayed automatically.
 * @summary Read the current creator's committed receipt using the original client request ID
 */
export const GetNamedDeskRequestParams = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid()
}))()

export const getNamedDeskRequestHeaderXGroupGraphTokenMax = 16384;


export const getNamedDeskRequestHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetNamedDeskRequestHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getNamedDeskRequestHeaderXGroupGraphTokenMax).regex(getNamedDeskRequestHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getNamedDeskRequest200ResponseOneAssignmentCountMax = 20;

export const getNamedDeskRequest200ResponseTwoAssignmentsMax = 20;



export const GetNamedDeskRequest200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "entityId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "assignmentCount": zod.int().min(1).max(getNamedDeskRequest200ResponseOneAssignmentCountMax),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "beneficiaryId": zod.uuid(),
  "spaceId": zod.uuid()
})).min(1).max(getNamedDeskRequest200ResponseTwoAssignmentsMax)
})))()

export const getNamedDeskRequest404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNamedDeskRequest404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNamedDeskRequest404ResponseOverlapWarningAcknowledgementMin = 16;
export const getNamedDeskRequest404ResponseOverlapWarningAcknowledgementMax = 256;


export const getNamedDeskRequest404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNamedDeskRequest404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNamedDeskRequest404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNamedDeskRequest404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNamedDeskRequest404ResponseOverlapWarningAcknowledgementMin).max(getNamedDeskRequest404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNamedDeskRequest404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Current admitted beneficiary rules only. No foreign booking details or role assignments. Writes recheck all rules and capacity.
 * @summary Destination-scoped booking eligibility preview
 */
export const GetBookingEligibilityQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryId": zod.uuid().optional()
}))()

export const getBookingEligibilityHeaderXGroupGraphTokenMax = 16384;


export const getBookingEligibilityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingEligibilityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingEligibilityHeaderXGroupGraphTokenMax).regex(getBookingEligibilityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingEligibility200ResponseGrantsPermissionsMax = 9;

export const getBookingEligibility200ResponseGrantsLimitsDeskMax = 20;

export const getBookingEligibility200ResponseGrantsLimitsRoomMax = 20;

export const getBookingEligibility200ResponseGrantsLimitsOfficeMax = 20;

export const getBookingEligibility200ResponseGrantsLimitsParkingMax = 20;

export const getBookingEligibility200ResponseGrantsOrganiserDeskLimitMax = 20;

export const getBookingEligibility200ResponseGrantsHorizonDaysMin = 0;
export const getBookingEligibility200ResponseGrantsHorizonDaysMax = 366;



export const GetBookingEligibility200Response = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['legacy', 'scoped']),
  "spaceId": zod.uuid(),
  "siteId": zod.uuid(),
  "beneficiaryId": zod.uuid(),
  "resourceClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullable(),
  "eligible": zod.boolean(),
  "canDelegate": zod.boolean().describe('Candidate delegate selection is available; the selected member and destination scope are checked separately.'),
  "canOrganise": zod.boolean(),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(getBookingEligibility200ResponseGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(getBookingEligibility200ResponseGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(getBookingEligibility200ResponseGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(getBookingEligibility200ResponseGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(getBookingEligibility200ResponseGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(getBookingEligibility200ResponseGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(getBookingEligibility200ResponseGrantsHorizonDaysMin).max(getBookingEligibility200ResponseGrantsHorizonDaysMax)
})
}))()

export const getBookingEligibility403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getBookingEligibility403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getBookingEligibility403ResponseOverlapWarningAcknowledgementMin = 16;
export const getBookingEligibility403ResponseOverlapWarningAcknowledgementMax = 256;


export const getBookingEligibility403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetBookingEligibility403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBookingEligibility403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBookingEligibility403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getBookingEligibility403ResponseOverlapWarningAcknowledgementMin).max(getBookingEligibility403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getBookingEligibility403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List sites
 */
export const ListSitesQueryParams = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['active', 'inactive']).optional(),
  "includeInactive": zod.enum(['true', 'false']).optional()
}))()

export const listSitesHeaderXGroupGraphTokenMax = 16384;


export const listSitesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListSitesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listSitesHeaderXGroupGraphTokenMax).regex(listSitesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listSites200ResponseItemsItemLifecycleRevisionMin = 0;

export const listSites200ResponseItemsItemLatitudeMin = -90;
export const listSites200ResponseItemsItemLatitudeMax = 90;

export const listSites200ResponseItemsItemLongitudeMin = -180;
export const listSites200ResponseItemsItemLongitudeMax = 180;

export const listSites200ResponseTotalMin = 0;



export const ListSites200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listSites200ResponseItemsItemLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "timezone": zod.string(),
  "address": zod.string().nullish(),
  "latitude": zod.number().min(listSites200ResponseItemsItemLatitudeMin).max(listSites200ResponseItemsItemLatitudeMax).nullish().describe('WGS84 latitude'),
  "longitude": zod.number().min(listSites200ResponseItemsItemLongitudeMin).max(listSites200ResponseItemsItemLongitudeMax).nullish().describe('WGS84 longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "siteMapEnabled": zod.boolean().describe('Whether the Site map is shown. Defaults to true.'),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSites200ResponseTotalMin)
}))()

export const listSites401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listSites401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listSites401ResponseOverlapWarningAcknowledgementMin = 16;
export const listSites401ResponseOverlapWarningAcknowledgementMax = 256;


export const listSites401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListSites401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listSites401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listSites401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listSites401ResponseOverlapWarningAcknowledgementMin).max(listSites401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listSites401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create site
 */
export const createSiteHeaderXGroupGraphTokenMax = 16384;


export const createSiteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateSiteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createSiteHeaderXGroupGraphTokenMax).regex(createSiteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createSiteBodyCodeMax = 64;

export const createSiteBodyNameMax = 200;

export const createSiteBodyTimezoneMax = 64;

export const createSiteBodyAddressMax = 500;

export const createSiteBodyLatitudeMin = -90;
export const createSiteBodyLatitudeMax = 90;

export const createSiteBodyLongitudeMin = -180;
export const createSiteBodyLongitudeMax = 180;



export const CreateSiteBody = /*#__PURE__*/ (() => zod.object({
  "code": zod.string().min(1).max(createSiteBodyCodeMax),
  "name": zod.string().min(1).max(createSiteBodyNameMax),
  "timezone": zod.string().min(1).max(createSiteBodyTimezoneMax).optional().describe('IANA timezone for the site; defaults to Australia/Sydney when omitted.'),
  "address": zod.string().max(createSiteBodyAddressMax).nullish(),
  "latitude": zod.number().min(createSiteBodyLatitudeMin).max(createSiteBodyLatitudeMax).nullish(),
  "longitude": zod.number().min(createSiteBodyLongitudeMin).max(createSiteBodyLongitudeMax).nullish(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "siteMapEnabled": zod.boolean().optional().describe('Defaults to true when omitted.'),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish()
}))()

export const createSite201ResponseLifecycleRevisionMin = 0;

export const createSite201ResponseLatitudeMin = -90;
export const createSite201ResponseLatitudeMax = 90;

export const createSite201ResponseLongitudeMin = -180;
export const createSite201ResponseLongitudeMax = 180;



export const CreateSite201Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(createSite201ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "timezone": zod.string(),
  "address": zod.string().nullish(),
  "latitude": zod.number().min(createSite201ResponseLatitudeMin).max(createSite201ResponseLatitudeMax).nullish().describe('WGS84 latitude'),
  "longitude": zod.number().min(createSite201ResponseLongitudeMin).max(createSite201ResponseLongitudeMax).nullish().describe('WGS84 longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "siteMapEnabled": zod.boolean().describe('Whether the Site map is shown. Defaults to true.'),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const createSite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createSite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createSite401ResponseOverlapWarningAcknowledgementMin = 16;
export const createSite401ResponseOverlapWarningAcknowledgementMax = 256;


export const createSite401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateSite401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createSite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createSite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createSite401ResponseOverlapWarningAcknowledgementMin).max(createSite401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createSite401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createSite403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createSite403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createSite403ResponseOverlapWarningAcknowledgementMin = 16;
export const createSite403ResponseOverlapWarningAcknowledgementMax = 256;


export const createSite403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateSite403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createSite403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createSite403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createSite403ResponseOverlapWarningAcknowledgementMin).max(createSite403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createSite403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get site
 */
export const GetSiteParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSiteHeaderXGroupGraphTokenMax = 16384;


export const getSiteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteHeaderXGroupGraphTokenMax).regex(getSiteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getSite200ResponseLifecycleRevisionMin = 0;

export const getSite200ResponseLatitudeMin = -90;
export const getSite200ResponseLatitudeMax = 90;

export const getSite200ResponseLongitudeMin = -180;
export const getSite200ResponseLongitudeMax = 180;



export const GetSite200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getSite200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "timezone": zod.string(),
  "address": zod.string().nullish(),
  "latitude": zod.number().min(getSite200ResponseLatitudeMin).max(getSite200ResponseLatitudeMax).nullish().describe('WGS84 latitude'),
  "longitude": zod.number().min(getSite200ResponseLongitudeMin).max(getSite200ResponseLongitudeMax).nullish().describe('WGS84 longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "siteMapEnabled": zod.boolean().describe('Whether the Site map is shown. Defaults to true.'),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getSite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSite404ResponseOverlapWarningAcknowledgementMin = 16;
export const getSite404ResponseOverlapWarningAcknowledgementMax = 256;


export const getSite404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSite404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSite404ResponseOverlapWarningAcknowledgementMin).max(getSite404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSite404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update site
 */
export const UpdateSiteParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateSiteHeaderXGroupGraphTokenMax = 16384;


export const updateSiteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateSiteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateSiteHeaderXGroupGraphTokenMax).regex(updateSiteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateSiteBodyCodeMax = 64;

export const updateSiteBodyNameMax = 200;

export const updateSiteBodyTimezoneMax = 64;

export const updateSiteBodyAddressMax = 500;

export const updateSiteBodyLatitudeMin = -90;
export const updateSiteBodyLatitudeMax = 90;

export const updateSiteBodyLongitudeMin = -180;
export const updateSiteBodyLongitudeMax = 180;



export const UpdateSiteBody = /*#__PURE__*/ (() => zod.object({
  "code": zod.string().min(1).max(updateSiteBodyCodeMax).optional(),
  "name": zod.string().min(1).max(updateSiteBodyNameMax).optional(),
  "timezone": zod.string().min(1).max(updateSiteBodyTimezoneMax).optional(),
  "address": zod.string().max(updateSiteBodyAddressMax).nullish(),
  "latitude": zod.number().min(updateSiteBodyLatitudeMin).max(updateSiteBodyLatitudeMax).nullish(),
  "longitude": zod.number().min(updateSiteBodyLongitudeMin).max(updateSiteBodyLongitudeMax).nullish(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "siteMapEnabled": zod.boolean().optional(),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish()
}))()

export const updateSite200ResponseLifecycleRevisionMin = 0;

export const updateSite200ResponseLatitudeMin = -90;
export const updateSite200ResponseLatitudeMax = 90;

export const updateSite200ResponseLongitudeMin = -180;
export const updateSite200ResponseLongitudeMax = 180;



export const UpdateSite200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(updateSite200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "timezone": zod.string(),
  "address": zod.string().nullish(),
  "latitude": zod.number().min(updateSite200ResponseLatitudeMin).max(updateSite200ResponseLatitudeMax).nullish().describe('WGS84 latitude'),
  "longitude": zod.number().min(updateSite200ResponseLongitudeMin).max(updateSite200ResponseLongitudeMax).nullish().describe('WGS84 longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "siteMapEnabled": zod.boolean().describe('Whether the Site map is shown. Defaults to true.'),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Blocked while the site still has buildings or is referenced by visitor records.
 * @summary Delete a site
 */
export const DeleteSiteParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteSiteHeaderXGroupGraphTokenMax = 16384;


export const deleteSiteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteSiteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteSiteHeaderXGroupGraphTokenMax).regex(deleteSiteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteSite204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteSite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSite404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSite404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSite404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSite404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSite404ResponseOverlapWarningAcknowledgementMin).max(deleteSite404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSite404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteSite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSite409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSite409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSite409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSite409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSite409ResponseOverlapWarningAcknowledgementMin).max(deleteSite409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSite409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get configured site-local opening hours for utilisation
 */
export const GetSiteOpeningHoursParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSiteOpeningHoursHeaderXGroupGraphTokenMax = 16384;


export const getSiteOpeningHoursHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteOpeningHoursHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteOpeningHoursHeaderXGroupGraphTokenMax).regex(getSiteOpeningHoursHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getSiteOpeningHours200ResponseWeeklyItemWeekdayMin = 0;
export const getSiteOpeningHours200ResponseWeeklyItemWeekdayMax = 6;

export const getSiteOpeningHours200ResponseWeeklyItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getSiteOpeningHours200ResponseWeeklyItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');
export const getSiteOpeningHours200ResponseExceptionsItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getSiteOpeningHours200ResponseExceptionsItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');


export const GetSiteOpeningHours200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "timezone": zod.string(),
  "configured": zod.boolean(),
  "weekly": zod.array(zod.object({
  "weekday": zod.int().min(getSiteOpeningHours200ResponseWeeklyItemWeekdayMin).max(getSiteOpeningHours200ResponseWeeklyItemWeekdayMax).describe('0=Sunday in the site timezone'),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(getSiteOpeningHours200ResponseWeeklyItemIntervalsItemStartRegExp),
  "end": zod.string().regex(getSiteOpeningHours200ResponseWeeklyItemIntervalsItemEndRegExp)
}))
})),
  "exceptions": zod.array(zod.object({
  "date": zod.iso.date(),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(getSiteOpeningHours200ResponseExceptionsItemIntervalsItemStartRegExp),
  "end": zod.string().regex(getSiteOpeningHours200ResponseExceptionsItemIntervalsItemEndRegExp)
}))
})),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()


/**
 * @summary Replace site-local weekly hours and dated overrides
 */
export const PutSiteOpeningHoursParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const putSiteOpeningHoursHeaderXGroupGraphTokenMax = 16384;


export const putSiteOpeningHoursHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutSiteOpeningHoursHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putSiteOpeningHoursHeaderXGroupGraphTokenMax).regex(putSiteOpeningHoursHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putSiteOpeningHoursBodyWeeklyItemWeekdayMin = 0;
export const putSiteOpeningHoursBodyWeeklyItemWeekdayMax = 6;

export const putSiteOpeningHoursBodyWeeklyItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const putSiteOpeningHoursBodyWeeklyItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');
export const putSiteOpeningHoursBodyWeeklyMax = 7;

export const putSiteOpeningHoursBodyExceptionsItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const putSiteOpeningHoursBodyExceptionsItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');
export const putSiteOpeningHoursBodyExceptionsMax = 366;

export const putSiteOpeningHoursBodyReasonMin = 3;
export const putSiteOpeningHoursBodyReasonMax = 500;



export const PutSiteOpeningHoursBody = /*#__PURE__*/ (() => zod.object({
  "weekly": zod.array(zod.object({
  "weekday": zod.int().min(putSiteOpeningHoursBodyWeeklyItemWeekdayMin).max(putSiteOpeningHoursBodyWeeklyItemWeekdayMax).describe('0=Sunday in the site timezone'),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(putSiteOpeningHoursBodyWeeklyItemIntervalsItemStartRegExp),
  "end": zod.string().regex(putSiteOpeningHoursBodyWeeklyItemIntervalsItemEndRegExp)
}))
})).max(putSiteOpeningHoursBodyWeeklyMax),
  "exceptions": zod.array(zod.object({
  "date": zod.iso.date(),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(putSiteOpeningHoursBodyExceptionsItemIntervalsItemStartRegExp),
  "end": zod.string().regex(putSiteOpeningHoursBodyExceptionsItemIntervalsItemEndRegExp)
}))
})).max(putSiteOpeningHoursBodyExceptionsMax),
  "reason": zod.string().min(putSiteOpeningHoursBodyReasonMin).max(putSiteOpeningHoursBodyReasonMax)
}))()

export const putSiteOpeningHours200ResponseWeeklyItemWeekdayMin = 0;
export const putSiteOpeningHours200ResponseWeeklyItemWeekdayMax = 6;

export const putSiteOpeningHours200ResponseWeeklyItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const putSiteOpeningHours200ResponseWeeklyItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');
export const putSiteOpeningHours200ResponseExceptionsItemIntervalsItemStartRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const putSiteOpeningHours200ResponseExceptionsItemIntervalsItemEndRegExp = new RegExp('^(([01][0-9]|2[0-3]):[0-5][0-9]|24:00)$');


export const PutSiteOpeningHours200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "timezone": zod.string(),
  "configured": zod.boolean(),
  "weekly": zod.array(zod.object({
  "weekday": zod.int().min(putSiteOpeningHours200ResponseWeeklyItemWeekdayMin).max(putSiteOpeningHours200ResponseWeeklyItemWeekdayMax).describe('0=Sunday in the site timezone'),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(putSiteOpeningHours200ResponseWeeklyItemIntervalsItemStartRegExp),
  "end": zod.string().regex(putSiteOpeningHours200ResponseWeeklyItemIntervalsItemEndRegExp)
}))
})),
  "exceptions": zod.array(zod.object({
  "date": zod.iso.date(),
  "intervals": zod.array(zod.object({
  "start": zod.string().regex(putSiteOpeningHours200ResponseExceptionsItemIntervalsItemStartRegExp),
  "end": zod.string().regex(putSiteOpeningHours200ResponseExceptionsItemIntervalsItemEndRegExp)
}))
})),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const putSiteOpeningHours403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putSiteOpeningHours403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putSiteOpeningHours403ResponseOverlapWarningAcknowledgementMin = 16;
export const putSiteOpeningHours403ResponseOverlapWarningAcknowledgementMax = 256;


export const putSiteOpeningHours403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutSiteOpeningHours403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putSiteOpeningHours403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putSiteOpeningHours403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putSiteOpeningHours403ResponseOverlapWarningAcknowledgementMin).max(putSiteOpeningHours403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putSiteOpeningHours403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get the active OH&S induction checklist for a site
 */
export const GetSiteInductionChecklistParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSiteInductionChecklistHeaderXGroupGraphTokenMax = 16384;


export const getSiteInductionChecklistHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSiteInductionChecklistHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSiteInductionChecklistHeaderXGroupGraphTokenMax).regex(getSiteInductionChecklistHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getSiteInductionChecklist200ResponseItemsItemIdMax = 64;

export const getSiteInductionChecklist200ResponseItemsItemLabelMax = 200;

export const getSiteInductionChecklist200ResponseItemsItemDetailMax = 1000;

export const getSiteInductionChecklist200ResponseValidityDaysMax = 3650;

export const getSiteInductionChecklist200ResponseArrivalItemsItemIdMax = 64;

export const getSiteInductionChecklist200ResponseArrivalItemsItemLabelMax = 200;

export const getSiteInductionChecklist200ResponseArrivalItemsItemDetailMax = 1000;

export const getSiteInductionChecklist200ResponseArrivalItemsMax = 50;

export const getSiteInductionChecklist200ResponseSafetyGuidanceMax = 4000;



export const GetSiteInductionChecklist200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "version": zod.int().min(1),
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(getSiteInductionChecklist200ResponseItemsItemIdMax),
  "label": zod.string().min(1).max(getSiteInductionChecklist200ResponseItemsItemLabelMax),
  "detail": zod.string().max(getSiteInductionChecklist200ResponseItemsItemDetailMax).optional()
})),
  "active": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "validityDays": zod.int().min(1).max(getSiteInductionChecklist200ResponseValidityDaysMax).nullable(),
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(getSiteInductionChecklist200ResponseArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(getSiteInductionChecklist200ResponseArrivalItemsItemLabelMax),
  "detail": zod.string().max(getSiteInductionChecklist200ResponseArrivalItemsItemDetailMax).optional()
})).max(getSiteInductionChecklist200ResponseArrivalItemsMax),
  "safetyGuidance": zod.string().max(getSiteInductionChecklist200ResponseSafetyGuidanceMax)
}))()

export const getSiteInductionChecklist401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteInductionChecklist401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteInductionChecklist401ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteInductionChecklist401ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteInductionChecklist401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteInductionChecklist401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteInductionChecklist401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteInductionChecklist401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteInductionChecklist401ResponseOverlapWarningAcknowledgementMin).max(getSiteInductionChecklist401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteInductionChecklist401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getSiteInductionChecklist404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getSiteInductionChecklist404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getSiteInductionChecklist404ResponseOverlapWarningAcknowledgementMin = 16;
export const getSiteInductionChecklist404ResponseOverlapWarningAcknowledgementMax = 256;


export const getSiteInductionChecklist404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetSiteInductionChecklist404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteInductionChecklist404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getSiteInductionChecklist404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getSiteInductionChecklist404ResponseOverlapWarningAcknowledgementMin).max(getSiteInductionChecklist404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getSiteInductionChecklist404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Configure site induction validity, arrival checks and safety guidance
 */
export const PutSiteSafetyConfigParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const putSiteSafetyConfigHeaderXGroupGraphTokenMax = 16384;


export const putSiteSafetyConfigHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutSiteSafetyConfigHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putSiteSafetyConfigHeaderXGroupGraphTokenMax).regex(putSiteSafetyConfigHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putSiteSafetyConfigBodyItemsItemIdMax = 64;

export const putSiteSafetyConfigBodyItemsItemLabelMax = 200;

export const putSiteSafetyConfigBodyItemsItemDetailMax = 1000;

export const putSiteSafetyConfigBodyItemsMax = 50;

export const putSiteSafetyConfigBodyValidityDaysMax = 3650;

export const putSiteSafetyConfigBodyArrivalItemsItemIdMax = 64;

export const putSiteSafetyConfigBodyArrivalItemsItemLabelMax = 200;

export const putSiteSafetyConfigBodyArrivalItemsItemDetailMax = 1000;

export const putSiteSafetyConfigBodyArrivalItemsMax = 50;

export const putSiteSafetyConfigBodySafetyGuidanceMax = 4000;



export const PutSiteSafetyConfigBody = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(putSiteSafetyConfigBodyItemsItemIdMax),
  "label": zod.string().min(1).max(putSiteSafetyConfigBodyItemsItemLabelMax),
  "detail": zod.string().max(putSiteSafetyConfigBodyItemsItemDetailMax).optional()
})).min(1).max(putSiteSafetyConfigBodyItemsMax),
  "validityDays": zod.int().min(1).max(putSiteSafetyConfigBodyValidityDaysMax).nullable(),
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(putSiteSafetyConfigBodyArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(putSiteSafetyConfigBodyArrivalItemsItemLabelMax),
  "detail": zod.string().max(putSiteSafetyConfigBodyArrivalItemsItemDetailMax).optional()
})).max(putSiteSafetyConfigBodyArrivalItemsMax),
  "safetyGuidance": zod.string().max(putSiteSafetyConfigBodySafetyGuidanceMax)
}))()


export const putSiteSafetyConfig200ResponseItemsItemIdMax = 64;

export const putSiteSafetyConfig200ResponseItemsItemLabelMax = 200;

export const putSiteSafetyConfig200ResponseItemsItemDetailMax = 1000;

export const putSiteSafetyConfig200ResponseValidityDaysMax = 3650;

export const putSiteSafetyConfig200ResponseArrivalItemsItemIdMax = 64;

export const putSiteSafetyConfig200ResponseArrivalItemsItemLabelMax = 200;

export const putSiteSafetyConfig200ResponseArrivalItemsItemDetailMax = 1000;

export const putSiteSafetyConfig200ResponseArrivalItemsMax = 50;

export const putSiteSafetyConfig200ResponseSafetyGuidanceMax = 4000;



export const PutSiteSafetyConfig200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "version": zod.int().min(1),
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(putSiteSafetyConfig200ResponseItemsItemIdMax),
  "label": zod.string().min(1).max(putSiteSafetyConfig200ResponseItemsItemLabelMax),
  "detail": zod.string().max(putSiteSafetyConfig200ResponseItemsItemDetailMax).optional()
})),
  "active": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "validityDays": zod.int().min(1).max(putSiteSafetyConfig200ResponseValidityDaysMax).nullable(),
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(putSiteSafetyConfig200ResponseArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(putSiteSafetyConfig200ResponseArrivalItemsItemLabelMax),
  "detail": zod.string().max(putSiteSafetyConfig200ResponseArrivalItemsItemDetailMax).optional()
})).max(putSiteSafetyConfig200ResponseArrivalItemsMax),
  "safetyGuidance": zod.string().max(putSiteSafetyConfig200ResponseSafetyGuidanceMax)
}))()

export const putSiteSafetyConfig403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putSiteSafetyConfig403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putSiteSafetyConfig403ResponseOverlapWarningAcknowledgementMin = 16;
export const putSiteSafetyConfig403ResponseOverlapWarningAcknowledgementMax = 256;


export const putSiteSafetyConfig403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutSiteSafetyConfig403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putSiteSafetyConfig403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putSiteSafetyConfig403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putSiteSafetyConfig403ResponseOverlapWarningAcknowledgementMin).max(putSiteSafetyConfig403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putSiteSafetyConfig403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List the signed-in user's site induction status
 */
export const ListMySiteInductionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().optional().describe('When set, return status for this site only')
}))()

export const listMySiteInductionsHeaderXGroupGraphTokenMax = 16384;


export const listMySiteInductionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMySiteInductionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMySiteInductionsHeaderXGroupGraphTokenMax).regex(listMySiteInductionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()





export const ListMySiteInductions200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "currentVersion": zod.int().min(1).nullable(),
  "hasActiveChecklist": zod.boolean(),
  "acknowledgedVersion": zod.int().min(1).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "isComplete": zod.boolean().describe('True when the site has no active checklist, or the user has acknowledged the current version.\n')
}))
}))()

export const listMySiteInductions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMySiteInductions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMySiteInductions401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMySiteInductions401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMySiteInductions401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMySiteInductions401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMySiteInductions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMySiteInductions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMySiteInductions401ResponseOverlapWarningAcknowledgementMin).max(listMySiteInductions401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMySiteInductions401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Idempotent for the same user/site/version. Requires every checklist item id to be acknowledged. Fails when the submitted version is not the active checklist version.
 * @summary Complete (or re-ack) the active OH&S checklist for a site
 */
export const completeMySiteInductionHeaderXGroupGraphTokenMax = 16384;


export const completeMySiteInductionHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CompleteMySiteInductionHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(completeMySiteInductionHeaderXGroupGraphTokenMax).regex(completeMySiteInductionHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const completeMySiteInductionBodyItemIdsItemMax = 64;

export const completeMySiteInductionBodyItemIdsMax = 50;



export const CompleteMySiteInductionBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "version": zod.int().min(1),
  "itemIds": zod.array(zod.string().min(1).max(completeMySiteInductionBodyItemIdsItemMax)).min(1).max(completeMySiteInductionBodyItemIdsMax)
}))()





export const CompleteMySiteInduction200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "currentVersion": zod.int().min(1).nullable(),
  "hasActiveChecklist": zod.boolean(),
  "acknowledgedVersion": zod.int().min(1).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "isComplete": zod.boolean().describe('True when the site has no active checklist, or the user has acknowledged the current version.\n')
}))()

export const completeMySiteInduction400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const completeMySiteInduction400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const completeMySiteInduction400ResponseOverlapWarningAcknowledgementMin = 16;
export const completeMySiteInduction400ResponseOverlapWarningAcknowledgementMax = 256;


export const completeMySiteInduction400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CompleteMySiteInduction400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(completeMySiteInduction400ResponseOverlapWarningAcknowledgementMin).max(completeMySiteInduction400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(completeMySiteInduction400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const completeMySiteInduction401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const completeMySiteInduction401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const completeMySiteInduction401ResponseOverlapWarningAcknowledgementMin = 16;
export const completeMySiteInduction401ResponseOverlapWarningAcknowledgementMax = 256;


export const completeMySiteInduction401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CompleteMySiteInduction401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(completeMySiteInduction401ResponseOverlapWarningAcknowledgementMin).max(completeMySiteInduction401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(completeMySiteInduction401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const completeMySiteInduction404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const completeMySiteInduction404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const completeMySiteInduction404ResponseOverlapWarningAcknowledgementMin = 16;
export const completeMySiteInduction404ResponseOverlapWarningAcknowledgementMax = 256;


export const completeMySiteInduction404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CompleteMySiteInduction404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(completeMySiteInduction404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(completeMySiteInduction404ResponseOverlapWarningAcknowledgementMin).max(completeMySiteInduction404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(completeMySiteInduction404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List buildings
 */
export const ListBuildingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "includeInactive": zod.enum(['true', 'false']).optional()
}))()

export const listBuildingsHeaderXGroupGraphTokenMax = 16384;


export const listBuildingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBuildingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBuildingsHeaderXGroupGraphTokenMax).regex(listBuildingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listBuildings200ResponseItemsItemLifecycleRevisionMin = 0;

export const listBuildings200ResponseItemsItemLatitudeMin = -90;
export const listBuildings200ResponseItemsItemLatitudeMax = 90;

export const listBuildings200ResponseItemsItemLongitudeMin = -180;
export const listBuildings200ResponseItemsItemLongitudeMax = 180;

export const listBuildings200ResponseTotalMin = 0;



export const ListBuildings200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listBuildings200ResponseItemsItemLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "latitude": zod.number().min(listBuildings200ResponseItemsItemLatitudeMin).max(listBuildings200ResponseItemsItemLatitudeMax).nullish().describe('Building pin latitude (preferred for directions)'),
  "longitude": zod.number().min(listBuildings200ResponseItemsItemLongitudeMin).max(listBuildings200ResponseItemsItemLongitudeMax).nullish().describe('Building pin longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listBuildings200ResponseTotalMin)
}))()


/**
 * @summary Create building
 */
export const createBuildingHeaderXGroupGraphTokenMax = 16384;


export const createBuildingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateBuildingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createBuildingHeaderXGroupGraphTokenMax).regex(createBuildingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createBuildingBodyCodeMax = 64;

export const createBuildingBodyNameMax = 200;

export const createBuildingBodyLatitudeMin = -90;
export const createBuildingBodyLatitudeMax = 90;

export const createBuildingBodyLongitudeMin = -180;
export const createBuildingBodyLongitudeMax = 180;



export const CreateBuildingBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "code": zod.string().min(1).max(createBuildingBodyCodeMax),
  "name": zod.string().min(1).max(createBuildingBodyNameMax),
  "latitude": zod.number().min(createBuildingBodyLatitudeMin).max(createBuildingBodyLatitudeMax).nullish(),
  "longitude": zod.number().min(createBuildingBodyLongitudeMin).max(createBuildingBodyLongitudeMax).nullish(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish()
}))()

export const createBuilding201ResponseLifecycleRevisionMin = 0;

export const createBuilding201ResponseLatitudeMin = -90;
export const createBuilding201ResponseLatitudeMax = 90;

export const createBuilding201ResponseLongitudeMin = -180;
export const createBuilding201ResponseLongitudeMax = 180;



export const CreateBuilding201Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(createBuilding201ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "latitude": zod.number().min(createBuilding201ResponseLatitudeMin).max(createBuilding201ResponseLatitudeMax).nullish().describe('Building pin latitude (preferred for directions)'),
  "longitude": zod.number().min(createBuilding201ResponseLongitudeMin).max(createBuilding201ResponseLongitudeMax).nullish().describe('Building pin longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetBuildingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBuildingHeaderXGroupGraphTokenMax = 16384;


export const getBuildingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBuildingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBuildingHeaderXGroupGraphTokenMax).regex(getBuildingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBuilding200ResponseLifecycleRevisionMin = 0;

export const getBuilding200ResponseLatitudeMin = -90;
export const getBuilding200ResponseLatitudeMax = 90;

export const getBuilding200ResponseLongitudeMin = -180;
export const getBuilding200ResponseLongitudeMax = 180;



export const GetBuilding200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getBuilding200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "latitude": zod.number().min(getBuilding200ResponseLatitudeMin).max(getBuilding200ResponseLatitudeMax).nullish().describe('Building pin latitude (preferred for directions)'),
  "longitude": zod.number().min(getBuilding200ResponseLongitudeMin).max(getBuilding200ResponseLongitudeMax).nullish().describe('Building pin longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateBuildingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateBuildingHeaderXGroupGraphTokenMax = 16384;


export const updateBuildingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateBuildingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateBuildingHeaderXGroupGraphTokenMax).regex(updateBuildingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateBuildingBodyCodeMax = 64;

export const updateBuildingBodyNameMax = 200;

export const updateBuildingBodyLatitudeMin = -90;
export const updateBuildingBodyLatitudeMax = 90;

export const updateBuildingBodyLongitudeMin = -180;
export const updateBuildingBodyLongitudeMax = 180;



export const UpdateBuildingBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().optional(),
  "code": zod.string().min(1).max(updateBuildingBodyCodeMax).optional(),
  "name": zod.string().min(1).max(updateBuildingBodyNameMax).optional(),
  "latitude": zod.number().min(updateBuildingBodyLatitudeMin).max(updateBuildingBodyLatitudeMax).nullish(),
  "longitude": zod.number().min(updateBuildingBodyLongitudeMin).max(updateBuildingBodyLongitudeMax).nullish(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish()
}))()

export const updateBuilding200ResponseLifecycleRevisionMin = 0;

export const updateBuilding200ResponseLatitudeMin = -90;
export const updateBuilding200ResponseLatitudeMax = 90;

export const updateBuilding200ResponseLongitudeMin = -180;
export const updateBuilding200ResponseLongitudeMax = 180;



export const UpdateBuilding200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(updateBuilding200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "latitude": zod.number().min(updateBuilding200ResponseLatitudeMin).max(updateBuilding200ResponseLatitudeMax).nullish().describe('Building pin latitude (preferred for directions)'),
  "longitude": zod.number().min(updateBuilding200ResponseLongitudeMin).max(updateBuilding200ResponseLongitudeMax).nullish().describe('Building pin longitude'),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Blocked while the building still has floors.
 * @summary Delete a building
 */
export const DeleteBuildingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteBuildingHeaderXGroupGraphTokenMax = 16384;


export const deleteBuildingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteBuildingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteBuildingHeaderXGroupGraphTokenMax).regex(deleteBuildingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteBuilding204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteBuilding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteBuilding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteBuilding404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteBuilding404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteBuilding404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteBuilding404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBuilding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBuilding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteBuilding404ResponseOverlapWarningAcknowledgementMin).max(deleteBuilding404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteBuilding404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteBuilding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteBuilding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteBuilding409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteBuilding409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteBuilding409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteBuilding409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBuilding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBuilding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteBuilding409ResponseOverlapWarningAcknowledgementMin).max(deleteBuilding409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteBuilding409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const ListFloorsQueryParams = /*#__PURE__*/ (() => zod.object({
  "buildingId": zod.uuid().optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "includeInactive": zod.enum(['true', 'false']).optional()
}))()

export const listFloorsHeaderXGroupGraphTokenMax = 16384;


export const listFloorsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListFloorsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listFloorsHeaderXGroupGraphTokenMax).regex(listFloorsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listFloors200ResponseItemsItemLifecycleRevisionMin = 0;

export const listFloors200ResponseTotalMin = 0;



export const ListFloors200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listFloors200ResponseItemsItemLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "buildingId": zod.uuid(),
  "levelIndex": zod.int(),
  "name": zod.string(),
  "code": zod.string(),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "mapAssetUrl": zod.string().nullish(),
  "hasFloorPlan": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listFloors200ResponseTotalMin)
}))()


export const createFloorHeaderXGroupGraphTokenMax = 16384;


export const createFloorHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateFloorHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createFloorHeaderXGroupGraphTokenMax).regex(createFloorHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createFloorBodyNameMax = 200;

export const createFloorBodyCodeMax = 64;

export const createFloorBodyMapAssetUrlMax = 1000;



export const CreateFloorBody = /*#__PURE__*/ (() => zod.object({
  "buildingId": zod.uuid(),
  "levelIndex": zod.int(),
  "name": zod.string().min(1).max(createFloorBodyNameMax),
  "code": zod.string().min(1).max(createFloorBodyCodeMax),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "mapAssetUrl": zod.string().max(createFloorBodyMapAssetUrlMax).nullish()
}))()

export const createFloor201ResponseLifecycleRevisionMin = 0;



export const CreateFloor201Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(createFloor201ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "buildingId": zod.uuid(),
  "levelIndex": zod.int(),
  "name": zod.string(),
  "code": zod.string(),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "mapAssetUrl": zod.string().nullish(),
  "hasFloorPlan": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetFloorParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorHeaderXGroupGraphTokenMax = 16384;


export const getFloorHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorHeaderXGroupGraphTokenMax).regex(getFloorHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getFloor200ResponseLifecycleRevisionMin = 0;



export const GetFloor200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getFloor200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "buildingId": zod.uuid(),
  "levelIndex": zod.int(),
  "name": zod.string(),
  "code": zod.string(),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "mapAssetUrl": zod.string().nullish(),
  "hasFloorPlan": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateFloorParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateFloorHeaderXGroupGraphTokenMax = 16384;


export const updateFloorHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateFloorHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateFloorHeaderXGroupGraphTokenMax).regex(updateFloorHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateFloorBodyNameMax = 200;

export const updateFloorBodyCodeMax = 64;

export const updateFloorBodyMapAssetUrlMax = 1000;



export const UpdateFloorBody = /*#__PURE__*/ (() => zod.object({
  "buildingId": zod.uuid().optional(),
  "levelIndex": zod.int().optional(),
  "name": zod.string().min(1).max(updateFloorBodyNameMax).optional(),
  "code": zod.string().min(1).max(updateFloorBodyCodeMax).optional(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "mapAssetUrl": zod.string().max(updateFloorBodyMapAssetUrlMax).nullish()
}))()

export const updateFloor200ResponseLifecycleRevisionMin = 0;



export const UpdateFloor200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(updateFloor200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "buildingId": zod.uuid(),
  "levelIndex": zod.int(),
  "name": zod.string(),
  "code": zod.string(),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "mapAssetUrl": zod.string().nullish(),
  "hasFloorPlan": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Blocked while the floor still has zones. Floor plans and geometry cascade.
 * @summary Delete a floor
 */
export const DeleteFloorParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteFloorHeaderXGroupGraphTokenMax = 16384;


export const deleteFloorHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteFloorHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteFloorHeaderXGroupGraphTokenMax).regex(deleteFloorHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteFloor204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteFloor404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFloor404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFloor404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFloor404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFloor404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFloor404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloor404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloor404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFloor404ResponseOverlapWarningAcknowledgementMin).max(deleteFloor404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFloor404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteFloor409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFloor409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFloor409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFloor409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFloor409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFloor409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloor409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloor409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFloor409ResponseOverlapWarningAcknowledgementMin).max(deleteFloor409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFloor409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const ListZonesQueryParams = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid().optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "includeInactive": zod.enum(['true', 'false']).optional()
}))()

export const listZonesHeaderXGroupGraphTokenMax = 16384;


export const listZonesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListZonesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listZonesHeaderXGroupGraphTokenMax).regex(listZonesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listZones200ResponseItemsItemLifecycleRevisionMin = 0;

export const listZones200ResponseTotalMin = 0;



export const ListZones200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listZones200ResponseItemsItemLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "floorId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "zoneKind": zod.string().nullish(),
  "teamAffinityTags": zod.array(zod.string()),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listZones200ResponseTotalMin)
}))()


export const createZoneHeaderXGroupGraphTokenMax = 16384;


export const createZoneHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateZoneHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createZoneHeaderXGroupGraphTokenMax).regex(createZoneHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createZoneBodyCodeMax = 64;

export const createZoneBodyNameMax = 200;

export const createZoneBodyZoneKindMax = 64;



export const CreateZoneBody = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "code": zod.string().min(1).max(createZoneBodyCodeMax),
  "name": zod.string().min(1).max(createZoneBodyNameMax),
  "zoneKind": zod.string().max(createZoneBodyZoneKindMax).nullish(),
  "teamAffinityTags": zod.array(zod.string()).optional(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional()
}))()

export const createZone201ResponseLifecycleRevisionMin = 0;



export const CreateZone201Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(createZone201ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "floorId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "zoneKind": zod.string().nullish(),
  "teamAffinityTags": zod.array(zod.string()),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetZoneParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getZoneHeaderXGroupGraphTokenMax = 16384;


export const getZoneHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetZoneHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getZoneHeaderXGroupGraphTokenMax).regex(getZoneHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getZone200ResponseLifecycleRevisionMin = 0;



export const GetZone200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getZone200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "floorId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "zoneKind": zod.string().nullish(),
  "teamAffinityTags": zod.array(zod.string()),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateZoneParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateZoneHeaderXGroupGraphTokenMax = 16384;


export const updateZoneHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateZoneHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateZoneHeaderXGroupGraphTokenMax).regex(updateZoneHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateZoneBodyCodeMax = 64;

export const updateZoneBodyNameMax = 200;

export const updateZoneBodyZoneKindMax = 64;



export const UpdateZoneBody = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid().optional(),
  "code": zod.string().min(1).max(updateZoneBodyCodeMax).optional(),
  "name": zod.string().min(1).max(updateZoneBodyNameMax).optional(),
  "zoneKind": zod.string().max(updateZoneBodyZoneKindMax).nullish(),
  "teamAffinityTags": zod.array(zod.string()).optional(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional()
}))()

export const updateZone200ResponseLifecycleRevisionMin = 0;



export const UpdateZone200Response = /*#__PURE__*/ (() => zod.object({
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(updateZone200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "floorId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "zoneKind": zod.string().nullish(),
  "teamAffinityTags": zod.array(zod.string()),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Blocked while the zone still has spaces.
 * @summary Delete a zone
 */
export const DeleteZoneParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteZoneHeaderXGroupGraphTokenMax = 16384;


export const deleteZoneHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteZoneHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteZoneHeaderXGroupGraphTokenMax).regex(deleteZoneHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteZone204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteZone404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteZone404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteZone404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteZone404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteZone404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteZone404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteZone404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteZone404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteZone404ResponseOverlapWarningAcknowledgementMin).max(deleteZone404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteZone404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteZone409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteZone409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteZone409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteZone409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteZone409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteZone409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteZone409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteZone409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteZone409ResponseOverlapWarningAcknowledgementMin).max(deleteZone409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteZone409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List space types
 */
export const listSpaceTypesHeaderXGroupGraphTokenMax = 16384;


export const listSpaceTypesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListSpaceTypesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listSpaceTypesHeaderXGroupGraphTokenMax).regex(listSpaceTypesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const listSpaceTypes200ResponseItemsItemDefaultRulesAdvanceWindowDaysMin = 0;

export const listSpaceTypes200ResponseItemsItemDefaultRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const listSpaceTypes200ResponseItemsItemDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const listSpaceTypes200ResponseItemsItemDefaultRulesMinLeadMinutesMin = 0;

export const listSpaceTypes200ResponseItemsItemDefaultRulesMaxRecurrenceHorizonDaysMax = 365;


export const listSpaceTypes200ResponseItemsItemDefaultRulesAllowedAppUserIdsMax = 100;

export const listSpaceTypes200ResponseItemsItemDefaultRulesAllowedEntraGroupIdsMax = 100;

export const listSpaceTypes200ResponseTotalMin = 0;



export const ListSpaceTypes200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(listSpaceTypes200ResponseItemsItemDefaultRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(listSpaceTypes200ResponseItemsItemDefaultRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(listSpaceTypes200ResponseItemsItemDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(listSpaceTypes200ResponseItemsItemDefaultRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(listSpaceTypes200ResponseItemsItemDefaultRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(listSpaceTypes200ResponseItemsItemDefaultRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(listSpaceTypes200ResponseItemsItemDefaultRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "uiSchema": zod.record(zod.string(), zod.unknown()).nullish(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.'),
  "isSystem": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSpaceTypes200ResponseTotalMin)
}))()


/**
 * @summary Create a custom space type
 */
export const createSpaceTypeHeaderXGroupGraphTokenMax = 16384;


export const createSpaceTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateSpaceTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createSpaceTypeHeaderXGroupGraphTokenMax).regex(createSpaceTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createSpaceTypeBodyCodeMax = 64;

export const createSpaceTypeBodyDisplayNameMax = 200;

export const createSpaceTypeBodyDescriptionMax = 2000;



export const createSpaceTypeBodyDefaultRulesAdvanceWindowDaysMin = 0;

export const createSpaceTypeBodyDefaultRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const createSpaceTypeBodyDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const createSpaceTypeBodyDefaultRulesMinLeadMinutesMin = 0;

export const createSpaceTypeBodyDefaultRulesMaxRecurrenceHorizonDaysMax = 365;


export const createSpaceTypeBodyDefaultRulesAllowedAppUserIdsMax = 100;

export const createSpaceTypeBodyDefaultRulesAllowedEntraGroupIdsMax = 100;



export const CreateSpaceTypeBody = /*#__PURE__*/ (() => zod.object({
  "code": zod.string().min(1).max(createSpaceTypeBodyCodeMax),
  "displayName": zod.string().min(1).max(createSpaceTypeBodyDisplayNameMax),
  "description": zod.string().max(createSpaceTypeBodyDescriptionMax).nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']).optional(),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(createSpaceTypeBodyDefaultRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(createSpaceTypeBodyDefaultRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(createSpaceTypeBodyDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(createSpaceTypeBodyDefaultRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(createSpaceTypeBodyDefaultRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(createSpaceTypeBodyDefaultRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(createSpaceTypeBodyDefaultRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}).optional(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.')
}))()



export const createSpaceType201ResponseDefaultRulesAdvanceWindowDaysMin = 0;

export const createSpaceType201ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const createSpaceType201ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const createSpaceType201ResponseDefaultRulesMinLeadMinutesMin = 0;

export const createSpaceType201ResponseDefaultRulesMaxRecurrenceHorizonDaysMax = 365;


export const createSpaceType201ResponseDefaultRulesAllowedAppUserIdsMax = 100;

export const createSpaceType201ResponseDefaultRulesAllowedEntraGroupIdsMax = 100;



export const CreateSpaceType201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(createSpaceType201ResponseDefaultRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(createSpaceType201ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(createSpaceType201ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(createSpaceType201ResponseDefaultRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(createSpaceType201ResponseDefaultRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(createSpaceType201ResponseDefaultRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(createSpaceType201ResponseDefaultRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "uiSchema": zod.record(zod.string(), zod.unknown()).nullish(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.'),
  "isSystem": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetSpaceTypeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSpaceTypeHeaderXGroupGraphTokenMax = 16384;


export const getSpaceTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSpaceTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSpaceTypeHeaderXGroupGraphTokenMax).regex(getSpaceTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const getSpaceType200ResponseDefaultRulesAdvanceWindowDaysMin = 0;

export const getSpaceType200ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const getSpaceType200ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const getSpaceType200ResponseDefaultRulesMinLeadMinutesMin = 0;

export const getSpaceType200ResponseDefaultRulesMaxRecurrenceHorizonDaysMax = 365;


export const getSpaceType200ResponseDefaultRulesAllowedAppUserIdsMax = 100;

export const getSpaceType200ResponseDefaultRulesAllowedEntraGroupIdsMax = 100;



export const GetSpaceType200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(getSpaceType200ResponseDefaultRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(getSpaceType200ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(getSpaceType200ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(getSpaceType200ResponseDefaultRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(getSpaceType200ResponseDefaultRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(getSpaceType200ResponseDefaultRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(getSpaceType200ResponseDefaultRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "uiSchema": zod.record(zod.string(), zod.unknown()).nullish(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.'),
  "isSystem": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateSpaceTypeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateSpaceTypeHeaderXGroupGraphTokenMax = 16384;


export const updateSpaceTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateSpaceTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateSpaceTypeHeaderXGroupGraphTokenMax).regex(updateSpaceTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateSpaceTypeBodyDisplayNameMax = 200;

export const updateSpaceTypeBodyDescriptionMax = 2000;



export const UpdateSpaceTypeBody = /*#__PURE__*/ (() => zod.object({
  "displayName": zod.string().min(1).max(updateSpaceTypeBodyDisplayNameMax).optional(),
  "description": zod.string().max(updateSpaceTypeBodyDescriptionMax).nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']).optional(),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.record(zod.string(), zod.unknown()).optional(),
  "uiSchema": zod.record(zod.string(), zod.unknown()).nullish(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.')
}))()



export const updateSpaceType200ResponseDefaultRulesAdvanceWindowDaysMin = 0;

export const updateSpaceType200ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const updateSpaceType200ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const updateSpaceType200ResponseDefaultRulesMinLeadMinutesMin = 0;

export const updateSpaceType200ResponseDefaultRulesMaxRecurrenceHorizonDaysMax = 365;


export const updateSpaceType200ResponseDefaultRulesAllowedAppUserIdsMax = 100;

export const updateSpaceType200ResponseDefaultRulesAllowedEntraGroupIdsMax = 100;



export const UpdateSpaceType200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullish(),
  "sotStrategy": zod.enum(['exchange', 'app']),
  "semanticClass": zod.union([zod.literal('desk'),zod.literal('room'),zod.literal('office'),zod.literal('parking'),zod.literal(null)]).nullish(),
  "defaultRules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(updateSpaceType200ResponseDefaultRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(updateSpaceType200ResponseDefaultRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(updateSpaceType200ResponseDefaultRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(updateSpaceType200ResponseDefaultRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(updateSpaceType200ResponseDefaultRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(updateSpaceType200ResponseDefaultRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(updateSpaceType200ResponseDefaultRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "uiSchema": zod.record(zod.string(), zod.unknown()).nullish(),
  "iconId": zod.union([zod.literal('desk'),zod.literal('meeting-room'),zod.literal('office'),zod.literal('parking'),zod.literal('building'),zod.literal('users'),zod.literal('presentation'),zod.literal('monitor'),zod.literal('coffee'),zod.literal('bike'),zod.literal('charging'),zod.literal('lock-keyhole'),zod.literal('handshake'),zod.literal('space'),zod.literal(null)]).nullish().describe('Bounded display icon identifier. Null resets to the semantic/code default; omitted updates preserve the saved choice.'),
  "isSystem": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Built-in types are protected; types used by spaces, policies or visitor records cannot be deleted.
 * @summary Delete a space type
 */
export const DeleteSpaceTypeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteSpaceTypeHeaderXGroupGraphTokenMax = 16384;


export const deleteSpaceTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteSpaceTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteSpaceTypeHeaderXGroupGraphTokenMax).regex(deleteSpaceTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteSpaceType204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteSpaceType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSpaceType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSpaceType404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSpaceType404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSpaceType404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSpaceType404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpaceType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpaceType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSpaceType404ResponseOverlapWarningAcknowledgementMin).max(deleteSpaceType404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSpaceType404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteSpaceType409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSpaceType409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSpaceType409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSpaceType409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSpaceType409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSpaceType409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpaceType409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpaceType409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSpaceType409ResponseOverlapWarningAcknowledgementMin).max(deleteSpaceType409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSpaceType409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Current selected entity only. Absent category rules apply to all types. Invalid stored policy returns a conflict.
 */
export const getAmenityCategoryPolicyHeaderXGroupGraphTokenMax = 16384;


export const getAmenityCategoryPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetAmenityCategoryPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getAmenityCategoryPolicyHeaderXGroupGraphTokenMax).regex(getAmenityCategoryPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getAmenityCategoryPolicy200ResponseRevisionMin = 0;
export const getAmenityCategoryPolicy200ResponseRevisionMax = 2147483647;

export const getAmenityCategoryPolicy200ResponseRulesItemCategoryMax = 64;

export const getAmenityCategoryPolicy200ResponseRulesItemSpaceTypeIdsMax = 200;

export const getAmenityCategoryPolicy200ResponseRulesMax = 200;



export const GetAmenityCategoryPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "entityId": zod.uuid(),
  "revision": zod.int().min(getAmenityCategoryPolicy200ResponseRevisionMin).max(getAmenityCategoryPolicy200ResponseRevisionMax),
  "rules": zod.array(zod.object({
  "category": zod.string().min(1).max(getAmenityCategoryPolicy200ResponseRulesItemCategoryMax),
  "mode": zod.enum(['all', 'restricted']),
  "spaceTypeIds": zod.array(zod.uuid()).max(getAmenityCategoryPolicy200ResponseRulesItemSpaceTypeIdsMax)
}).describe('Category is the trimmed stored category, with null/blank mapped to general. All requires an empty ID list; restricted requires at least one unique entity-owned type ID.')).max(getAmenityCategoryPolicy200ResponseRulesMax)
}))()

export const GetAmenityCategoryPolicy403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetAmenityCategoryPolicy409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Inventory administrator replaces the rules with optimistic revision protection. Existing assignments are preserved.
 */
export const updateAmenityCategoryPolicyHeaderXGroupGraphTokenMax = 16384;


export const updateAmenityCategoryPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateAmenityCategoryPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateAmenityCategoryPolicyHeaderXGroupGraphTokenMax).regex(updateAmenityCategoryPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateAmenityCategoryPolicyBodyExpectedRevisionMin = 0;
export const updateAmenityCategoryPolicyBodyExpectedRevisionMax = 2147483646;

export const updateAmenityCategoryPolicyBodyRulesItemCategoryMax = 64;

export const updateAmenityCategoryPolicyBodyRulesItemSpaceTypeIdsMax = 200;

export const updateAmenityCategoryPolicyBodyRulesMax = 200;



export const UpdateAmenityCategoryPolicyBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(updateAmenityCategoryPolicyBodyExpectedRevisionMin).max(updateAmenityCategoryPolicyBodyExpectedRevisionMax),
  "rules": zod.array(zod.object({
  "category": zod.string().min(1).max(updateAmenityCategoryPolicyBodyRulesItemCategoryMax),
  "mode": zod.enum(['all', 'restricted']),
  "spaceTypeIds": zod.array(zod.uuid()).max(updateAmenityCategoryPolicyBodyRulesItemSpaceTypeIdsMax)
}).describe('Category is the trimmed stored category, with null/blank mapped to general. All requires an empty ID list; restricted requires at least one unique entity-owned type ID.')).max(updateAmenityCategoryPolicyBodyRulesMax)
}))()

export const updateAmenityCategoryPolicy200ResponseRevisionMin = 0;
export const updateAmenityCategoryPolicy200ResponseRevisionMax = 2147483647;

export const updateAmenityCategoryPolicy200ResponseRulesItemCategoryMax = 64;

export const updateAmenityCategoryPolicy200ResponseRulesItemSpaceTypeIdsMax = 200;

export const updateAmenityCategoryPolicy200ResponseRulesMax = 200;



export const UpdateAmenityCategoryPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "entityId": zod.uuid(),
  "revision": zod.int().min(updateAmenityCategoryPolicy200ResponseRevisionMin).max(updateAmenityCategoryPolicy200ResponseRevisionMax),
  "rules": zod.array(zod.object({
  "category": zod.string().min(1).max(updateAmenityCategoryPolicy200ResponseRulesItemCategoryMax),
  "mode": zod.enum(['all', 'restricted']),
  "spaceTypeIds": zod.array(zod.uuid()).max(updateAmenityCategoryPolicy200ResponseRulesItemSpaceTypeIdsMax)
}).describe('Category is the trimmed stored category, with null/blank mapped to general. All requires an empty ID list; restricted requires at least one unique entity-owned type ID.')).max(updateAmenityCategoryPolicy200ResponseRulesMax)
}))()

export const UpdateAmenityCategoryPolicy400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateAmenityCategoryPolicy403Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateAmenityCategoryPolicy409Response = /*#__PURE__*/ (() => zod.unknown())()


export const listAmenitiesHeaderXGroupGraphTokenMax = 16384;


export const listAmenitiesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListAmenitiesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listAmenitiesHeaderXGroupGraphTokenMax).regex(listAmenitiesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listAmenities200ResponseTotalMin = 0;



export const ListAmenities200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "category": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAmenities200ResponseTotalMin)
}))()


export const createAmenityHeaderXGroupGraphTokenMax = 16384;


export const createAmenityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateAmenityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createAmenityHeaderXGroupGraphTokenMax).regex(createAmenityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createAmenityBodyCodeMax = 64;

export const createAmenityBodyDisplayNameMax = 200;

export const createAmenityBodyCategoryMax = 64;



export const CreateAmenityBody = /*#__PURE__*/ (() => zod.object({
  "code": zod.string().min(1).max(createAmenityBodyCodeMax),
  "displayName": zod.string().min(1).max(createAmenityBodyDisplayNameMax),
  "category": zod.string().max(createAmenityBodyCategoryMax).nullish()
}))()

export const CreateAmenity201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "category": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()


export const GetAmenityParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getAmenityHeaderXGroupGraphTokenMax = 16384;


export const getAmenityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetAmenityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getAmenityHeaderXGroupGraphTokenMax).regex(getAmenityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetAmenity200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "category": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateAmenityParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateAmenityHeaderXGroupGraphTokenMax = 16384;


export const updateAmenityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateAmenityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateAmenityHeaderXGroupGraphTokenMax).regex(updateAmenityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateAmenityBodyDisplayNameMax = 200;

export const updateAmenityBodyCategoryMax = 64;



export const UpdateAmenityBody = /*#__PURE__*/ (() => zod.object({
  "displayName": zod.string().min(1).max(updateAmenityBodyDisplayNameMax).optional(),
  "category": zod.string().max(updateAmenityBodyCategoryMax).nullish()
}))()

export const UpdateAmenity200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "category": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Deleting an amenity also removes it from every space that uses it.
 * @summary Delete an amenity
 */
export const DeleteAmenityParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteAmenityHeaderXGroupGraphTokenMax = 16384;


export const deleteAmenityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteAmenityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteAmenityHeaderXGroupGraphTokenMax).regex(deleteAmenityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteAmenity204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteAmenity404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteAmenity404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteAmenity404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteAmenity404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteAmenity404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteAmenity404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteAmenity404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteAmenity404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteAmenity404ResponseOverlapWarningAcknowledgementMin).max(deleteAmenity404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteAmenity404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


export const ListSpaceLayoutsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listSpaceLayoutsQueryLimitDefault = 50;
export const listSpaceLayoutsQueryLimitMax = 100;

export const listSpaceLayoutsQueryOffsetDefault = 0;
export const listSpaceLayoutsQueryOffsetMin = 0;



export const ListSpaceLayoutsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listSpaceLayoutsQueryLimitMax).default(listSpaceLayoutsQueryLimitDefault),
  "offset": zod.int().min(listSpaceLayoutsQueryOffsetMin).default(listSpaceLayoutsQueryOffsetDefault)
}))()

export const listSpaceLayoutsHeaderXGroupGraphTokenMax = 16384;


export const listSpaceLayoutsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListSpaceLayoutsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listSpaceLayoutsHeaderXGroupGraphTokenMax).regex(listSpaceLayoutsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listSpaceLayouts200ResponseTotalMin = 0;



export const ListSpaceLayouts200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSpaceLayouts200ResponseTotalMin)
}))()


export const CreateSpaceLayoutParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const createSpaceLayoutHeaderXGroupGraphTokenMax = 16384;


export const createSpaceLayoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateSpaceLayoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createSpaceLayoutHeaderXGroupGraphTokenMax).regex(createSpaceLayoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createSpaceLayoutBodyNameMax = 200;

export const createSpaceLayoutBodyCapacityMax = 2147483647;



export const CreateSpaceLayoutBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(createSpaceLayoutBodyNameMax),
  "capacity": zod.int().min(1).max(createSpaceLayoutBodyCapacityMax),
  "active": zod.boolean().optional()
}))()




export const CreateSpaceLayout201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateSpaceLayoutParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "layoutId": zod.uuid()
}))()

export const updateSpaceLayoutHeaderXGroupGraphTokenMax = 16384;


export const updateSpaceLayoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateSpaceLayoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateSpaceLayoutHeaderXGroupGraphTokenMax).regex(updateSpaceLayoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateSpaceLayoutBodyNameMax = 200;

export const updateSpaceLayoutBodyCapacityMax = 2147483647;



export const UpdateSpaceLayoutBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(updateSpaceLayoutBodyNameMax).optional(),
  "capacity": zod.int().min(1).max(updateSpaceLayoutBodyCapacityMax).optional(),
  "active": zod.boolean().optional()
}))()




export const UpdateSpaceLayout200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Supply resourceId alone, or siteId with optional buildingId. No inventory lists or availability claims. Deduplicate exact scopes on the consumer. Unknown never proves a singleton.
 * @summary Read current active sibling choices for one exact resource or planned office
 */
export const GetBookingHierarchyCardinalityQueryParams = /*#__PURE__*/ (() => zod.object({
  "resourceId": zod.uuid().optional(),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional()
}))()

export const getBookingHierarchyCardinalityHeaderXGroupGraphTokenMax = 16384;


export const getBookingHierarchyCardinalityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingHierarchyCardinalityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingHierarchyCardinalityHeaderXGroupGraphTokenMax).regex(getBookingHierarchyCardinalityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetBookingHierarchyCardinality200Response = /*#__PURE__*/ (() => zod.object({
  "organizationId": zod.uuid(),
  "resourceId": zod.uuid().nullable(),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullable(),
  "floorId": zod.uuid().nullable(),
  "zoneId": zod.uuid().nullable(),
  "sites": zod.object({
  "parentId": zod.uuid().nullable(),
  "cardinality": zod.enum(['zero', 'one', 'many', 'unknown']).describe('One proves exactly one active eligible sibling; unknown must retain the label.')
}),
  "buildings": zod.object({
  "parentId": zod.uuid().nullable(),
  "cardinality": zod.enum(['zero', 'one', 'many', 'unknown']).describe('One proves exactly one active eligible sibling; unknown must retain the label.')
}),
  "floors": zod.object({
  "parentId": zod.uuid().nullable(),
  "cardinality": zod.enum(['zero', 'one', 'many', 'unknown']).describe('One proves exactly one active eligible sibling; unknown must retain the label.')
}),
  "zones": zod.object({
  "parentId": zod.uuid().nullable(),
  "cardinality": zod.enum(['zero', 'one', 'many', 'unknown']).describe('One proves exactly one active eligible sibling; unknown must retain the label.')
})
}))()

export const GetBookingHierarchyCardinality400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingHierarchyCardinality403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingHierarchyCardinality404Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetBookingHierarchyCardinality409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Browse authorized active spaces without a booking interval or availability claims
 */
export const browseBookingSpacesQueryAmenityCodesMax = 3249;


export const browseBookingSpacesQueryAmenityCodesRegExp = new RegExp('^[^,]{1,64}(,[^,]{1,64}){0,49}$');
export const browseBookingSpacesQueryTypeCodesMax = 1000;

export const browseBookingSpacesQueryLimitDefault = 24;
export const browseBookingSpacesQueryLimitMax = 60;

export const browseBookingSpacesQueryOffsetDefault = 0;
export const browseBookingSpacesQueryOffsetMin = 0;
export const browseBookingSpacesQueryOffsetMax = 1000000;



export const BrowseBookingSpacesQueryParams = /*#__PURE__*/ (() => zod.object({
  "amenityCodes": zod.string().max(browseBookingSpacesQueryAmenityCodesMax).regex(browseBookingSpacesQueryAmenityCodesRegExp).optional().describe('Require every selected Inventory amenity code, before pagination. Omission allows any amenities.'),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "typeCodes": zod.string().max(browseBookingSpacesQueryTypeCodesMax).optional(),
  "limit": zod.int().min(1).max(browseBookingSpacesQueryLimitMax).default(browseBookingSpacesQueryLimitDefault),
  "offset": zod.int().min(browseBookingSpacesQueryOffsetMin).max(browseBookingSpacesQueryOffsetMax).default(browseBookingSpacesQueryOffsetDefault)
}))()

export const browseBookingSpacesHeaderXGroupGraphTokenMax = 16384;


export const browseBookingSpacesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const BrowseBookingSpacesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(browseBookingSpacesHeaderXGroupGraphTokenMax).regex(browseBookingSpacesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const browseBookingSpaces200ResponseItemsItemMapOutlineOneItemXMin = 0;
export const browseBookingSpaces200ResponseItemsItemMapOutlineOneItemXMax = 1000;

export const browseBookingSpaces200ResponseItemsItemMapOutlineOneItemYMin = 0;
export const browseBookingSpaces200ResponseItemsItemMapOutlineOneItemYMax = 1000;

export const browseBookingSpaces200ResponseItemsItemMapOutlineOneMin = 3;
export const browseBookingSpaces200ResponseItemsItemMapOutlineOneMax = 12;



export const BrowseBookingSpaces200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish(),
  "mapY": zod.int().nullish(),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(browseBookingSpaces200ResponseItemsItemMapOutlineOneItemXMin).max(browseBookingSpaces200ResponseItemsItemMapOutlineOneItemXMax),
  "y": zod.number().min(browseBookingSpaces200ResponseItemsItemMapOutlineOneItemYMin).max(browseBookingSpaces200ResponseItemsItemMapOutlineOneItemYMax)
})).min(browseBookingSpaces200ResponseItemsItemMapOutlineOneMin).max(browseBookingSpaces200ResponseItemsItemMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "amenityIds": zod.array(zod.uuid()).optional().describe('IDs of Inventory Amenities assigned to this space in the current organisation.')
})),
  "nextOffset": zod.int().nullable()
}))()


/**
 * @summary List spaces (retired hidden by default)
 */
export const listSpacesQueryQMax = 120;

export const listSpacesQueryLimitMax = 200;

export const listSpacesQueryOffsetMin = 0;



export const ListSpacesQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "zoneId": zod.uuid().optional(),
  "spaceTypeId": zod.uuid().optional(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "includeRetired": zod.enum(['true', 'false']).optional(),
  "includeInactive": zod.enum(['true', 'false']).optional(),
  "q": zod.string().max(listSpacesQueryQMax).optional(),
  "limit": zod.int().min(1).max(listSpacesQueryLimitMax).optional(),
  "offset": zod.int().min(listSpacesQueryOffsetMin).optional()
}))()

export const listSpacesHeaderXGroupGraphTokenMax = 16384;


export const listSpacesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListSpacesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listSpacesHeaderXGroupGraphTokenMax).regex(listSpacesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listSpaces200ResponseItemsItemLifecycleRevisionMin = 0;


export const listSpaces200ResponseItemsItemMapXMin = 0;
export const listSpaces200ResponseItemsItemMapXMax = 1000;

export const listSpaces200ResponseItemsItemMapYMin = 0;
export const listSpaces200ResponseItemsItemMapYMax = 1000;

export const listSpaces200ResponseItemsItemMapOutlineOneItemXMin = 0;
export const listSpaces200ResponseItemsItemMapOutlineOneItemXMax = 1000;

export const listSpaces200ResponseItemsItemMapOutlineOneItemYMin = 0;
export const listSpaces200ResponseItemsItemMapOutlineOneItemYMax = 1000;

export const listSpaces200ResponseItemsItemMapOutlineOneMin = 3;
export const listSpaces200ResponseItemsItemMapOutlineOneMax = 12;

export const listSpaces200ResponseItemsItemMapSnapEnabledDefault = true;
export const listSpaces200ResponseTotalMin = 0;



export const ListSpaces200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "layoutRequired": zod.boolean().optional().describe('True if this physical space has any layout records, including retired layouts.'),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(listSpaces200ResponseItemsItemLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()),
  "mapX": zod.int().min(listSpaces200ResponseItemsItemMapXMin).max(listSpaces200ResponseItemsItemMapXMax).nullish().describe('Floor-plan marker X (0–1000 normalized; schematic grid values remain small integers)'),
  "mapY": zod.int().min(listSpaces200ResponseItemsItemMapYMin).max(listSpaces200ResponseItemsItemMapYMax).nullish().describe('Floor-plan marker Y (0–1000 normalized; schematic grid values remain small integers)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(listSpaces200ResponseItemsItemMapOutlineOneItemXMin).max(listSpaces200ResponseItemsItemMapOutlineOneItemXMax),
  "y": zod.number().min(listSpaces200ResponseItemsItemMapOutlineOneItemYMin).max(listSpaces200ResponseItemsItemMapOutlineOneItemYMax)
})).min(listSpaces200ResponseItemsItemMapOutlineOneMin).max(listSpaces200ResponseItemsItemMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "mapSnapEnabled": zod.boolean().default(listSpaces200ResponseItemsItemMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "assignedUserId": zod.uuid().nullish(),
  "imageFileId": zod.uuid().nullish(),
  "retiredAt": zod.iso.datetime({"offset":true}).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSpaces200ResponseTotalMin)
}))()


/**
 * @summary Create space
 */
export const createSpaceHeaderXGroupGraphTokenMax = 16384;


export const createSpaceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateSpaceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createSpaceHeaderXGroupGraphTokenMax).regex(createSpaceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createSpaceBodyCodeMax = 64;

export const createSpaceBodyNameMax = 200;


export const createSpaceBodyMapXMin = 0;
export const createSpaceBodyMapXMax = 1000;

export const createSpaceBodyMapYMin = 0;
export const createSpaceBodyMapYMax = 1000;

export const createSpaceBodyMapSnapEnabledDefault = true;

export const CreateSpaceBody = /*#__PURE__*/ (() => zod.object({
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string().min(1).max(createSpaceBodyCodeMax),
  "name": zod.string().min(1).max(createSpaceBodyNameMax),
  "capacity": zod.int().min(1).optional(),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']).optional(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()).optional(),
  "mapX": zod.int().min(createSpaceBodyMapXMin).max(createSpaceBodyMapXMax).nullish(),
  "mapY": zod.int().min(createSpaceBodyMapYMin).max(createSpaceBodyMapYMax).nullish(),
  "mapSnapEnabled": zod.boolean().default(createSpaceBodyMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional()
}))()


export const createSpace201ResponseLifecycleRevisionMin = 0;


export const createSpace201ResponseMapXMin = 0;
export const createSpace201ResponseMapXMax = 1000;

export const createSpace201ResponseMapYMin = 0;
export const createSpace201ResponseMapYMax = 1000;

export const createSpace201ResponseMapOutlineOneItemXMin = 0;
export const createSpace201ResponseMapOutlineOneItemXMax = 1000;

export const createSpace201ResponseMapOutlineOneItemYMin = 0;
export const createSpace201ResponseMapOutlineOneItemYMax = 1000;

export const createSpace201ResponseMapOutlineOneMin = 3;
export const createSpace201ResponseMapOutlineOneMax = 12;

export const createSpace201ResponseMapSnapEnabledDefault = true;

export const CreateSpace201Response = /*#__PURE__*/ (() => zod.object({
  "layoutRequired": zod.boolean().optional().describe('True if this physical space has any layout records, including retired layouts.'),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(createSpace201ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()),
  "mapX": zod.int().min(createSpace201ResponseMapXMin).max(createSpace201ResponseMapXMax).nullish().describe('Floor-plan marker X (0–1000 normalized; schematic grid values remain small integers)'),
  "mapY": zod.int().min(createSpace201ResponseMapYMin).max(createSpace201ResponseMapYMax).nullish().describe('Floor-plan marker Y (0–1000 normalized; schematic grid values remain small integers)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(createSpace201ResponseMapOutlineOneItemXMin).max(createSpace201ResponseMapOutlineOneItemXMax),
  "y": zod.number().min(createSpace201ResponseMapOutlineOneItemYMin).max(createSpace201ResponseMapOutlineOneItemYMax)
})).min(createSpace201ResponseMapOutlineOneMin).max(createSpace201ResponseMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "mapSnapEnabled": zod.boolean().default(createSpace201ResponseMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "assignedUserId": zod.uuid().nullish(),
  "imageFileId": zod.uuid().nullish(),
  "retiredAt": zod.iso.datetime({"offset":true}).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetSpaceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSpaceHeaderXGroupGraphTokenMax = 16384;


export const getSpaceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSpaceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSpaceHeaderXGroupGraphTokenMax).regex(getSpaceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getSpace200ResponseLifecycleRevisionMin = 0;


export const getSpace200ResponseMapXMin = 0;
export const getSpace200ResponseMapXMax = 1000;

export const getSpace200ResponseMapYMin = 0;
export const getSpace200ResponseMapYMax = 1000;

export const getSpace200ResponseMapOutlineOneItemXMin = 0;
export const getSpace200ResponseMapOutlineOneItemXMax = 1000;

export const getSpace200ResponseMapOutlineOneItemYMin = 0;
export const getSpace200ResponseMapOutlineOneItemYMax = 1000;

export const getSpace200ResponseMapOutlineOneMin = 3;
export const getSpace200ResponseMapOutlineOneMax = 12;

export const getSpace200ResponseMapSnapEnabledDefault = true;

export const GetSpace200Response = /*#__PURE__*/ (() => zod.object({
  "layoutRequired": zod.boolean().optional().describe('True if this physical space has any layout records, including retired layouts.'),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(getSpace200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()),
  "mapX": zod.int().min(getSpace200ResponseMapXMin).max(getSpace200ResponseMapXMax).nullish().describe('Floor-plan marker X (0–1000 normalized; schematic grid values remain small integers)'),
  "mapY": zod.int().min(getSpace200ResponseMapYMin).max(getSpace200ResponseMapYMax).nullish().describe('Floor-plan marker Y (0–1000 normalized; schematic grid values remain small integers)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(getSpace200ResponseMapOutlineOneItemXMin).max(getSpace200ResponseMapOutlineOneItemXMax),
  "y": zod.number().min(getSpace200ResponseMapOutlineOneItemYMin).max(getSpace200ResponseMapOutlineOneItemYMax)
})).min(getSpace200ResponseMapOutlineOneMin).max(getSpace200ResponseMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "mapSnapEnabled": zod.boolean().default(getSpace200ResponseMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "assignedUserId": zod.uuid().nullish(),
  "imageFileId": zod.uuid().nullish(),
  "retiredAt": zod.iso.datetime({"offset":true}).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateSpaceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateSpaceHeaderXGroupGraphTokenMax = 16384;


export const updateSpaceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateSpaceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateSpaceHeaderXGroupGraphTokenMax).regex(updateSpaceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateSpaceBodyCodeMax = 64;

export const updateSpaceBodyNameMax = 200;


export const updateSpaceBodyMapXMin = 0;
export const updateSpaceBodyMapXMax = 1000;

export const updateSpaceBodyMapYMin = 0;
export const updateSpaceBodyMapYMax = 1000;

export const updateSpaceBodyMapSnapEnabledDefault = true;

export const UpdateSpaceBody = /*#__PURE__*/ (() => zod.object({
  "zoneId": zod.uuid().optional(),
  "spaceTypeId": zod.uuid().optional(),
  "code": zod.string().min(1).max(updateSpaceBodyCodeMax).optional(),
  "name": zod.string().min(1).max(updateSpaceBodyNameMax).optional(),
  "capacity": zod.int().min(1).optional(),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']).optional(),
  "assignedUserId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'inactive', 'retired']).optional(),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()).optional(),
  "mapX": zod.int().min(updateSpaceBodyMapXMin).max(updateSpaceBodyMapXMax).nullish(),
  "mapY": zod.int().min(updateSpaceBodyMapYMin).max(updateSpaceBodyMapYMax).nullish(),
  "mapSnapEnabled": zod.boolean().default(updateSpaceBodyMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional()
}))()


export const updateSpace200ResponseLifecycleRevisionMin = 0;


export const updateSpace200ResponseMapXMin = 0;
export const updateSpace200ResponseMapXMax = 1000;

export const updateSpace200ResponseMapYMin = 0;
export const updateSpace200ResponseMapYMax = 1000;

export const updateSpace200ResponseMapOutlineOneItemXMin = 0;
export const updateSpace200ResponseMapOutlineOneItemXMax = 1000;

export const updateSpace200ResponseMapOutlineOneItemYMin = 0;
export const updateSpace200ResponseMapOutlineOneItemYMax = 1000;

export const updateSpace200ResponseMapOutlineOneMin = 3;
export const updateSpace200ResponseMapOutlineOneMax = 12;

export const updateSpace200ResponseMapSnapEnabledDefault = true;

export const UpdateSpace200Response = /*#__PURE__*/ (() => zod.object({
  "layoutRequired": zod.boolean().optional().describe('True if this physical space has any layout records, including retired layouts.'),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(updateSpace200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()),
  "mapX": zod.int().min(updateSpace200ResponseMapXMin).max(updateSpace200ResponseMapXMax).nullish().describe('Floor-plan marker X (0–1000 normalized; schematic grid values remain small integers)'),
  "mapY": zod.int().min(updateSpace200ResponseMapYMin).max(updateSpace200ResponseMapYMax).nullish().describe('Floor-plan marker Y (0–1000 normalized; schematic grid values remain small integers)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(updateSpace200ResponseMapOutlineOneItemXMin).max(updateSpace200ResponseMapOutlineOneItemXMax),
  "y": zod.number().min(updateSpace200ResponseMapOutlineOneItemYMin).max(updateSpace200ResponseMapOutlineOneItemYMax)
})).min(updateSpace200ResponseMapOutlineOneMin).max(updateSpace200ResponseMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "mapSnapEnabled": zod.boolean().default(updateSpace200ResponseMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "assignedUserId": zod.uuid().nullish(),
  "imageFileId": zod.uuid().nullish(),
  "retiredAt": zod.iso.datetime({"offset":true}).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Blocked when the space has booking history; retire it instead.
 * @summary Delete a space
 */
export const DeleteSpaceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteSpaceHeaderXGroupGraphTokenMax = 16384;


export const deleteSpaceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteSpaceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteSpaceHeaderXGroupGraphTokenMax).regex(deleteSpaceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteSpace204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteSpace404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSpace404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSpace404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSpace404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSpace404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSpace404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpace404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpace404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSpace404ResponseOverlapWarningAcknowledgementMin).max(deleteSpace404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSpace404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteSpace409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteSpace409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteSpace409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteSpace409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteSpace409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteSpace409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpace409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteSpace409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteSpace409ResponseOverlapWarningAcknowledgementMin).max(deleteSpace409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteSpace409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Soft-retire a space
 */
export const RetireSpaceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const retireSpaceHeaderXGroupGraphTokenMax = 16384;


export const retireSpaceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RetireSpaceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(retireSpaceHeaderXGroupGraphTokenMax).regex(retireSpaceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const retireSpace200ResponseLifecycleRevisionMin = 0;


export const retireSpace200ResponseMapXMin = 0;
export const retireSpace200ResponseMapXMax = 1000;

export const retireSpace200ResponseMapYMin = 0;
export const retireSpace200ResponseMapYMax = 1000;

export const retireSpace200ResponseMapOutlineOneItemXMin = 0;
export const retireSpace200ResponseMapOutlineOneItemXMax = 1000;

export const retireSpace200ResponseMapOutlineOneItemYMin = 0;
export const retireSpace200ResponseMapOutlineOneItemYMax = 1000;

export const retireSpace200ResponseMapOutlineOneMin = 3;
export const retireSpace200ResponseMapOutlineOneMax = 12;

export const retireSpace200ResponseMapSnapEnabledDefault = true;

export const RetireSpace200Response = /*#__PURE__*/ (() => zod.object({
  "layoutRequired": zod.boolean().optional().describe('True if this physical space has any layout records, including retired layouts.'),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "lifecycle": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(retireSpace200ResponseLifecycleRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}).optional(),
  "id": zod.uuid(),
  "zoneId": zod.uuid(),
  "spaceTypeId": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "mode": zod.enum(['reservable', 'drop_in', 'assigned', 'unavailable']),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "attributes": zod.record(zod.string(), zod.unknown()).nullish(),
  "tags": zod.array(zod.string()),
  "mapX": zod.int().min(retireSpace200ResponseMapXMin).max(retireSpace200ResponseMapXMax).nullish().describe('Floor-plan marker X (0–1000 normalized; schematic grid values remain small integers)'),
  "mapY": zod.int().min(retireSpace200ResponseMapYMin).max(retireSpace200ResponseMapYMax).nullish().describe('Floor-plan marker Y (0–1000 normalized; schematic grid values remain small integers)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(retireSpace200ResponseMapOutlineOneItemXMin).max(retireSpace200ResponseMapOutlineOneItemXMax),
  "y": zod.number().min(retireSpace200ResponseMapOutlineOneItemYMin).max(retireSpace200ResponseMapOutlineOneItemYMax)
})).min(retireSpace200ResponseMapOutlineOneMin).max(retireSpace200ResponseMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional(),
  "mapSnapEnabled": zod.boolean().default(retireSpace200ResponseMapSnapEnabledDefault).describe('Align this space to nearby placed spaces of the same type (desks and hot desks share one group) when editing its position'),
  "sotOverride": zod.union([zod.enum(['exchange', 'app']),zod.null()]).optional(),
  "externalRef": zod.record(zod.string(), zod.unknown()).nullish(),
  "assignedUserId": zod.uuid().nullish(),
  "imageFileId": zod.uuid().nullish(),
  "retiredAt": zod.iso.datetime({"offset":true}).nullish(),
  "amenityIds": zod.array(zod.uuid()).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary Resolve effective booking policy for a space
 */
export const GetSpaceEffectivePolicyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getSpaceEffectivePolicyHeaderXGroupGraphTokenMax = 16384;


export const getSpaceEffectivePolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetSpaceEffectivePolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getSpaceEffectivePolicyHeaderXGroupGraphTokenMax).regex(getSpaceEffectivePolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const getSpaceEffectivePolicy200ResponseRulesAdvanceWindowDaysMin = 0;

export const getSpaceEffectivePolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const getSpaceEffectivePolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const getSpaceEffectivePolicy200ResponseRulesMinLeadMinutesMin = 0;

export const getSpaceEffectivePolicy200ResponseRulesMaxRecurrenceHorizonDaysMax = 365;


export const getSpaceEffectivePolicy200ResponseRulesAllowedAppUserIdsMax = 100;

export const getSpaceEffectivePolicy200ResponseRulesAllowedEntraGroupIdsMax = 100;



export const GetSpaceEffectivePolicy200Response = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "policyId": zod.uuid().nullish(),
  "policyName": zod.string().nullish(),
  "scopeKind": zod.string(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(getSpaceEffectivePolicy200ResponseRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(getSpaceEffectivePolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(getSpaceEffectivePolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(getSpaceEffectivePolicy200ResponseRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(getSpaceEffectivePolicy200ResponseRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(getSpaceEffectivePolicy200ResponseRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(getSpaceEffectivePolicy200ResponseRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
})
}))()


export const ListBookingPoliciesQueryParams = /*#__PURE__*/ (() => zod.object({
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']).optional(),
  "scopeId": zod.uuid().optional(),
  "spaceTypeId": zod.uuid().optional(),
  "enabled": zod.enum(['true', 'false']).optional()
}))()

export const listBookingPoliciesHeaderXGroupGraphTokenMax = 16384;


export const listBookingPoliciesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBookingPoliciesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBookingPoliciesHeaderXGroupGraphTokenMax).regex(listBookingPoliciesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listBookingPolicies200ResponseItemsItemTagFilterItemMax = 64;

export const listBookingPolicies200ResponseItemsItemTagFilterMax = 20;



export const listBookingPolicies200ResponseItemsItemRulesAdvanceWindowDaysMin = 0;

export const listBookingPolicies200ResponseItemsItemRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const listBookingPolicies200ResponseItemsItemRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const listBookingPolicies200ResponseItemsItemRulesMinLeadMinutesMin = 0;

export const listBookingPolicies200ResponseItemsItemRulesMaxRecurrenceHorizonDaysMax = 365;


export const listBookingPolicies200ResponseItemsItemRulesAllowedAppUserIdsMax = 100;

export const listBookingPolicies200ResponseItemsItemRulesAllowedEntraGroupIdsMax = 100;

export const listBookingPolicies200ResponseTotalMin = 0;



export const ListBookingPolicies200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(listBookingPolicies200ResponseItemsItemTagFilterItemMax)).max(listBookingPolicies200ResponseItemsItemTagFilterMax).nullish().describe('When set, the policy applies only if the space carries every listed tag (case-insensitive AND match). Empty/null means no tag constraint.\n'),
  "priority": zod.int(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(listBookingPolicies200ResponseItemsItemRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(listBookingPolicies200ResponseItemsItemRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(listBookingPolicies200ResponseItemsItemRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(listBookingPolicies200ResponseItemsItemRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(listBookingPolicies200ResponseItemsItemRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(listBookingPolicies200ResponseItemsItemRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(listBookingPolicies200ResponseItemsItemRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "enabled": zod.boolean(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listBookingPolicies200ResponseTotalMin)
}))()


export const createBookingPolicyHeaderXGroupGraphTokenMax = 16384;


export const createBookingPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateBookingPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createBookingPolicyHeaderXGroupGraphTokenMax).regex(createBookingPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createBookingPolicyBodyNameMax = 200;

export const createBookingPolicyBodyTagFilterItemMax = 64;

export const createBookingPolicyBodyTagFilterMax = 20;



export const createBookingPolicyBodyRulesAdvanceWindowDaysMin = 0;

export const createBookingPolicyBodyRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const createBookingPolicyBodyRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const createBookingPolicyBodyRulesMinLeadMinutesMin = 0;

export const createBookingPolicyBodyRulesMaxRecurrenceHorizonDaysMax = 365;


export const createBookingPolicyBodyRulesAllowedAppUserIdsMax = 100;

export const createBookingPolicyBodyRulesAllowedEntraGroupIdsMax = 100;



export const CreateBookingPolicyBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(createBookingPolicyBodyNameMax),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(createBookingPolicyBodyTagFilterItemMax)).max(createBookingPolicyBodyTagFilterMax).nullish(),
  "priority": zod.int().optional(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(createBookingPolicyBodyRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(createBookingPolicyBodyRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(createBookingPolicyBodyRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(createBookingPolicyBodyRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(createBookingPolicyBodyRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(createBookingPolicyBodyRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(createBookingPolicyBodyRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "enabled": zod.boolean().optional()
}))()

export const createBookingPolicy201ResponseTagFilterItemMax = 64;

export const createBookingPolicy201ResponseTagFilterMax = 20;



export const createBookingPolicy201ResponseRulesAdvanceWindowDaysMin = 0;

export const createBookingPolicy201ResponseRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const createBookingPolicy201ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const createBookingPolicy201ResponseRulesMinLeadMinutesMin = 0;

export const createBookingPolicy201ResponseRulesMaxRecurrenceHorizonDaysMax = 365;


export const createBookingPolicy201ResponseRulesAllowedAppUserIdsMax = 100;

export const createBookingPolicy201ResponseRulesAllowedEntraGroupIdsMax = 100;



export const CreateBookingPolicy201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(createBookingPolicy201ResponseTagFilterItemMax)).max(createBookingPolicy201ResponseTagFilterMax).nullish().describe('When set, the policy applies only if the space carries every listed tag (case-insensitive AND match). Empty/null means no tag constraint.\n'),
  "priority": zod.int(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(createBookingPolicy201ResponseRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(createBookingPolicy201ResponseRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(createBookingPolicy201ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(createBookingPolicy201ResponseRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(createBookingPolicy201ResponseRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(createBookingPolicy201ResponseRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(createBookingPolicy201ResponseRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "enabled": zod.boolean(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetBookingPolicyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBookingPolicyHeaderXGroupGraphTokenMax = 16384;


export const getBookingPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingPolicyHeaderXGroupGraphTokenMax).regex(getBookingPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getBookingPolicy200ResponseTagFilterItemMax = 64;

export const getBookingPolicy200ResponseTagFilterMax = 20;



export const getBookingPolicy200ResponseRulesAdvanceWindowDaysMin = 0;

export const getBookingPolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const getBookingPolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const getBookingPolicy200ResponseRulesMinLeadMinutesMin = 0;

export const getBookingPolicy200ResponseRulesMaxRecurrenceHorizonDaysMax = 365;


export const getBookingPolicy200ResponseRulesAllowedAppUserIdsMax = 100;

export const getBookingPolicy200ResponseRulesAllowedEntraGroupIdsMax = 100;



export const GetBookingPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(getBookingPolicy200ResponseTagFilterItemMax)).max(getBookingPolicy200ResponseTagFilterMax).nullish().describe('When set, the policy applies only if the space carries every listed tag (case-insensitive AND match). Empty/null means no tag constraint.\n'),
  "priority": zod.int(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(getBookingPolicy200ResponseRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(getBookingPolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(getBookingPolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(getBookingPolicy200ResponseRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(getBookingPolicy200ResponseRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(getBookingPolicy200ResponseRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(getBookingPolicy200ResponseRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "enabled": zod.boolean(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateBookingPolicyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateBookingPolicyHeaderXGroupGraphTokenMax = 16384;


export const updateBookingPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateBookingPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateBookingPolicyHeaderXGroupGraphTokenMax).regex(updateBookingPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateBookingPolicyBodyNameMax = 200;

export const updateBookingPolicyBodyTagFilterItemMax = 64;

export const updateBookingPolicyBodyTagFilterMax = 20;



export const updateBookingPolicyBodyRulesAdvanceWindowDaysMin = 0;

export const updateBookingPolicyBodyRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const updateBookingPolicyBodyRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const updateBookingPolicyBodyRulesMinLeadMinutesMin = 0;

export const updateBookingPolicyBodyRulesMaxRecurrenceHorizonDaysMax = 365;


export const updateBookingPolicyBodyRulesAllowedAppUserIdsMax = 100;

export const updateBookingPolicyBodyRulesAllowedEntraGroupIdsMax = 100;



export const UpdateBookingPolicyBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(updateBookingPolicyBodyNameMax).optional(),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']).optional(),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(updateBookingPolicyBodyTagFilterItemMax)).max(updateBookingPolicyBodyTagFilterMax).nullish(),
  "priority": zod.int().optional(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(updateBookingPolicyBodyRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(updateBookingPolicyBodyRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(updateBookingPolicyBodyRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(updateBookingPolicyBodyRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(updateBookingPolicyBodyRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(updateBookingPolicyBodyRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(updateBookingPolicyBodyRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}).optional(),
  "enabled": zod.boolean().optional()
}))()

export const updateBookingPolicy200ResponseTagFilterItemMax = 64;

export const updateBookingPolicy200ResponseTagFilterMax = 20;



export const updateBookingPolicy200ResponseRulesAdvanceWindowDaysMin = 0;

export const updateBookingPolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const updateBookingPolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const updateBookingPolicy200ResponseRulesMinLeadMinutesMin = 0;

export const updateBookingPolicy200ResponseRulesMaxRecurrenceHorizonDaysMax = 365;


export const updateBookingPolicy200ResponseRulesAllowedAppUserIdsMax = 100;

export const updateBookingPolicy200ResponseRulesAllowedEntraGroupIdsMax = 100;



export const UpdateBookingPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scopeKind": zod.enum(['global', 'space_type', 'site', 'building', 'floor', 'zone', 'space']),
  "scopeId": zod.uuid().nullish(),
  "spaceTypeId": zod.uuid().nullish(),
  "tagFilter": zod.array(zod.string().min(1).max(updateBookingPolicy200ResponseTagFilterItemMax)).max(updateBookingPolicy200ResponseTagFilterMax).nullish().describe('When set, the policy applies only if the space carries every listed tag (case-insensitive AND match). Empty/null means no tag constraint.\n'),
  "priority": zod.int(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(updateBookingPolicy200ResponseRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(updateBookingPolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(updateBookingPolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(updateBookingPolicy200ResponseRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(updateBookingPolicy200ResponseRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(updateBookingPolicy200ResponseRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(updateBookingPolicy200ResponseRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
}),
  "enabled": zod.boolean(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const DeleteBookingPolicyParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteBookingPolicyHeaderXGroupGraphTokenMax = 16384;


export const deleteBookingPolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteBookingPolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteBookingPolicyHeaderXGroupGraphTokenMax).regex(deleteBookingPolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteBookingPolicy204Response = /*#__PURE__*/ (() => zod.void())()


export const ListBlackoutsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']).optional(),
  "scopeId": zod.uuid().optional(),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional()
}))()

export const listBlackoutsHeaderXGroupGraphTokenMax = 16384;


export const listBlackoutsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBlackoutsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBlackoutsHeaderXGroupGraphTokenMax).regex(listBlackoutsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listBlackouts200ResponseTotalMin = 0;



export const ListBlackouts200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "timezone": zod.string().nullish().describe('Site IANA zone for this authorized blackout scope.'),
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listBlackouts200ResponseTotalMin)
}))()


export const createBlackoutHeaderXGroupGraphTokenMax = 16384;


export const createBlackoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateBlackoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createBlackoutHeaderXGroupGraphTokenMax).regex(createBlackoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createBlackoutBodyReasonMax = 500;



export const CreateBlackoutBody = /*#__PURE__*/ (() => zod.object({
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(1).max(createBlackoutBodyReasonMax)
}))()

export const CreateBlackout201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "timezone": zod.string().nullish().describe('Site IANA zone for this authorized blackout scope.'),
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const GetBlackoutParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBlackoutHeaderXGroupGraphTokenMax = 16384;


export const getBlackoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBlackoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBlackoutHeaderXGroupGraphTokenMax).regex(getBlackoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetBlackout200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "timezone": zod.string().nullish().describe('Site IANA zone for this authorized blackout scope.'),
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const UpdateBlackoutParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateBlackoutHeaderXGroupGraphTokenMax = 16384;


export const updateBlackoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateBlackoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateBlackoutHeaderXGroupGraphTokenMax).regex(updateBlackoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateBlackoutBodyReasonMax = 500;



export const UpdateBlackoutBody = /*#__PURE__*/ (() => zod.object({
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']).optional(),
  "scopeId": zod.uuid().optional(),
  "startAt": zod.iso.datetime({"offset":true}).optional(),
  "endAt": zod.iso.datetime({"offset":true}).optional(),
  "reason": zod.string().min(1).max(updateBlackoutBodyReasonMax).optional()
}))()

export const UpdateBlackout200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "timezone": zod.string().nullish().describe('Site IANA zone for this authorized blackout scope.'),
  "scopeKind": zod.enum(['space', 'zone', 'floor', 'building']),
  "scopeId": zod.uuid(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string(),
  "createdBy": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


export const DeleteBlackoutParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteBlackoutHeaderXGroupGraphTokenMax = 16384;


export const deleteBlackoutHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteBlackoutHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteBlackoutHeaderXGroupGraphTokenMax).regex(deleteBlackoutHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteBlackout204Response = /*#__PURE__*/ (() => zod.void())()


/**
 * Returns allowed=true when the window passes duration, advance, and blackout checks. Violations return 422 with a POLICY_* code.
 * @summary Evaluate a proposed booking window against PolicyEngine
 */
export const evaluatePolicyHeaderXGroupGraphTokenMax = 16384;


export const evaluatePolicyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const EvaluatePolicyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(evaluatePolicyHeaderXGroupGraphTokenMax).regex(evaluatePolicyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const EvaluatePolicyBody = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "hasVehicle": zod.boolean().optional(),
  "hasPermit": zod.boolean().optional(),
  "now": zod.iso.datetime({"offset":true}).optional()
}))()



export const evaluatePolicy200ResponseRulesAdvanceWindowDaysMin = 0;

export const evaluatePolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax = 3;

export const evaluatePolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax = 168;

export const evaluatePolicy200ResponseRulesMinLeadMinutesMin = 0;

export const evaluatePolicy200ResponseRulesMaxRecurrenceHorizonDaysMax = 365;


export const evaluatePolicy200ResponseRulesAllowedAppUserIdsMax = 100;

export const evaluatePolicy200ResponseRulesAllowedEntraGroupIdsMax = 100;



export const EvaluatePolicy200Response = /*#__PURE__*/ (() => zod.object({
  "allowed": zod.boolean(),
  "spaceId": zod.uuid(),
  "policyId": zod.uuid().nullish(),
  "policyName": zod.string().nullish(),
  "scopeKind": zod.string(),
  "rules": zod.object({
  "minDurationMinutes": zod.int().min(1),
  "maxDurationMinutes": zod.int().min(1),
  "advanceWindowDays": zod.int().min(evaluatePolicy200ResponseRulesAdvanceWindowDaysMin),
  "officeEligibility": zod.object({
  "advanceClassifications": zod.array(zod.enum(['EL2', 'SES', 'Conciliator'])).min(1).max(evaluatePolicy200ResponseRulesOfficeEligibilityAdvanceClassificationsMax),
  "generalAccessLeadHours": zod.int().min(1).max(evaluatePolicy200ResponseRulesOfficeEligibilityGeneralAccessLeadHoursMax)
}).optional(),
  "minLeadMinutes": zod.int().min(evaluatePolicy200ResponseRulesMinLeadMinutesMin).optional(),
  "allowRecurrence": zod.boolean(),
  "maxRecurrenceHorizonDays": zod.int().min(1).max(evaluatePolicy200ResponseRulesMaxRecurrenceHorizonDaysMax).optional().describe('Max days from the series anchor start to the last occurrence (inclusive). Default 90 when unset.'),
  "checkInRequired": zod.boolean(),
  "autoReleaseGraceMinutes": zod.int().nullable(),
  "requireApproval": zod.boolean(),
  "requireVehicle": zod.boolean(),
  "requirePermit": zod.boolean(),
  "maxActiveBookingsPerUser": zod.int().min(1).optional(),
  "businessDayBooking": zod.boolean(),
  "requiredCredentialTypeIds": zod.array(zod.uuid()).optional().describe('Credential type ids that the booker must hold as approved and unexpired before a booking is allowed under this policy scope.'),
  "allowedAppUserIds": zod.array(zod.uuid()).max(evaluatePolicy200ResponseRulesAllowedAppUserIdsMax).optional().describe('Application user IDs explicitly allowed to book this space. This field is valid only on a space-scoped booking policy. Empty or omitted means no individual restriction; malformed, duplicate, or over-limit entries are rejected.'),
  "allowedEntraGroupIds": zod.array(zod.uuid()).max(evaluatePolicy200ResponseRulesAllowedEntraGroupIdsMax).optional().describe('Stable Entra security-group object IDs allowed to book this space. Membership is checked live at booking time; group names and membership snapshots are not authorization data. This field is valid only on a space-scoped booking policy. Empty or omitted means no group restriction; malformed, duplicate, or over-limit entries are rejected.')
})
}))()

export const evaluatePolicy422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const evaluatePolicy422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const evaluatePolicy422ResponseOverlapWarningAcknowledgementMin = 16;
export const evaluatePolicy422ResponseOverlapWarningAcknowledgementMax = 256;


export const evaluatePolicy422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const EvaluatePolicy422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(evaluatePolicy422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(evaluatePolicy422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(evaluatePolicy422ResponseOverlapWarningAcknowledgementMin).max(evaluatePolicy422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(evaluatePolicy422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Server-side LLM proxy. The client may only send a message and an
 * optional conversation id — model, endpoint, and credentials are
 * resolved exclusively on the server.
 * @summary Send a chat message to the app assistant
 */
export const postAiChatHeaderXGroupGraphTokenMax = 16384;


export const postAiChatHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostAiChatHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postAiChatHeaderXGroupGraphTokenMax).regex(postAiChatHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postAiChatBodyMessageMax = 4000;



export const PostAiChatBody = /*#__PURE__*/ (() => zod.object({
  "message": zod.string().min(1).max(postAiChatBodyMessageMax),
  "conversationId": zod.uuid().optional()
}))()

export const PostAiChat200Response = /*#__PURE__*/ (() => zod.object({
  "reply": zod.string(),
  "conversationId": zod.uuid()
}))()

export const postAiChat400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiChat400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiChat400ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiChat400ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiChat400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiChat400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiChat400ResponseOverlapWarningAcknowledgementMin).max(postAiChat400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiChat400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiChat401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiChat401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiChat401ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiChat401ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiChat401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiChat401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiChat401ResponseOverlapWarningAcknowledgementMin).max(postAiChat401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiChat401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiChat409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiChat409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiChat409ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiChat409ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiChat409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiChat409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiChat409ResponseOverlapWarningAcknowledgementMin).max(postAiChat409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiChat409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiChat429ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiChat429ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiChat429ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiChat429ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiChat429ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiChat429Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat429ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat429ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiChat429ResponseOverlapWarningAcknowledgementMin).max(postAiChat429ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiChat429ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiChat503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiChat503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiChat503ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiChat503ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiChat503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiChat503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiChat503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiChat503ResponseOverlapWarningAcknowledgementMin).max(postAiChat503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiChat503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Natural-language booking assistant. Searches/books only via server tools.
 * Bookings are never created in this call — propose actions require
 * POST /api/ai/assistant/confirm after explicit user confirmation.
 * @summary Tool-calling booking assistant turn
 */
export const postAiAssistantChatHeaderXGroupGraphTokenMax = 16384;


export const postAiAssistantChatHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostAiAssistantChatHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postAiAssistantChatHeaderXGroupGraphTokenMax).regex(postAiAssistantChatHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postAiAssistantChatBodyMessageMax = 4000;



export const PostAiAssistantChatBody = /*#__PURE__*/ (() => zod.object({
  "message": zod.string().min(1).max(postAiAssistantChatBodyMessageMax),
  "conversationId": zod.uuid().optional(),
  "bookForUserId": zod.uuid().optional().describe('Optional book-on-behalf target (requires booking:on_behalf)')
}))()

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewSelectedBeforeRevisionMin = 0;

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewSelectedAfterRevisionMin = 0;

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBeforeRevisionMin = 0;

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemAfterRevisionMin = 0;

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBookingImpactCancellationCountMin = 0;

export const postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBookingImpactUnderwayCountMin = 0;



export const PostAiAssistantChat200Response = /*#__PURE__*/ (() => zod.object({
  "conversationId": zod.uuid(),
  "reply": zod.string(),
  "proposedActions": zod.array(zod.object({
  "type": zod.enum(['create_booking', 'create_booking_series', 'cancel_booking', 'set_work_plan', 'set_timed_plan', 'decide_location_needs', 'admin_action']),
  "summary": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "confirmationToken": zod.string(),
  "lifecycleReview": zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "selectedBefore": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewSelectedBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "selectedAfter": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewSelectedAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "counts": zod.record(zod.string(), zod.int()),
  "children": zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(postAiAssistantChat200ResponseProposedActionsItemLifecycleReviewChildrenItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}),
  "bookingImpact": zod.object({
  "available": zod.boolean(),
  "cancellationCount": zod.int().nullable(),
  "underwayCount": zod.int().nullable(),
  "revision": zod.string().nullable(),
  "bookings": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}).optional()
}),
  "confirmationAvailable": zod.boolean(),
  "explanation": zod.string()
}).optional()
})),
  "selectableOptions": zod.array(zod.object({
  "id": zod.string().describe('Stable option id (usually a space UUID)'),
  "label": zod.string().describe('Short button label shown in the chat UI'),
  "message": zod.string().describe('Message sent on behalf of the user when the option is clicked')
})).describe('Clickable choices derived from tool results (e.g. available desks). The UI renders these as chips under the assistant reply.\n'),
  "screenHints": zod.array(zod.object({
  "id": zod.string().describe('Stable screen id (see the guidance registry)'),
  "label": zod.string(),
  "description": zod.string().optional(),
  "path": zod.string().describe('Fully resolved in-app path (tenant-prefixed by the server)')
})).optional().describe('In-app screen links the assistant suggests (e.g. open the Floor Map or Reports screen). The UI renders these as buttons.\n'),
  "requestedFields": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "kind": zod.enum(['date', 'time', 'duration', 'text'])
})).optional().describe('Optional controls to help the user answer this assistant question.')
}))()

export const postAiAssistantChat400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat400ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat400ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat400ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantChat401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat401ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat401ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat401ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantChat403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat403ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat403ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat403ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantChat409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat409ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat409ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat409ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantChat429ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat429ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat429ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat429ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat429ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat429Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat429ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat429ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat429ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat429ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat429ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantChat503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantChat503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantChat503ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantChat503ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantChat503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantChat503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantChat503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantChat503ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantChat503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantChat503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Consumes a short-lived confirmation token issued by the assistant tools
 * and executes the write with source=ai (create) or cancel.
 * @summary Confirm a proposed AI booking/cancel action
 */
export const postAiAssistantConfirmHeaderXGroupGraphTokenMax = 16384;


export const postAiAssistantConfirmHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostAiAssistantConfirmHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postAiAssistantConfirmHeaderXGroupGraphTokenMax).regex(postAiAssistantConfirmHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postAiAssistantConfirmBodyOverlapAcknowledgementMin = 16;
export const postAiAssistantConfirmBodyOverlapAcknowledgementMax = 256;

export const postAiAssistantConfirmBodyConfirmationTokenMin = 16;
export const postAiAssistantConfirmBodyConfirmationTokenMax = 128;



export const PostAiAssistantConfirmBody = /*#__PURE__*/ (() => zod.object({
  "overlapAcknowledgement": zod.string().min(postAiAssistantConfirmBodyOverlapAcknowledgementMin).max(postAiAssistantConfirmBodyOverlapAcknowledgementMax).optional(),
  "confirmationToken": zod.string().min(postAiAssistantConfirmBodyConfirmationTokenMin).max(postAiAssistantConfirmBodyConfirmationTokenMax)
}))()



export const postAiAssistantConfirm200ResponseSeriesWeekdaysItemMin = 0;
export const postAiAssistantConfirm200ResponseSeriesWeekdaysItemMax = 6;



export const postAiAssistantConfirm200ResponseTimedPlanStopsItemPositionMin = 0;

export const postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsTypeCodeMax = 64;

export const postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsAmenityIdsMax = 20;

export const postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsMinCapacityMax = 1000;



export const PostAiAssistantConfirm200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean(),
  "action": zod.enum(['create_booking', 'create_booking_series', 'cancel_booking', 'create_itinerary', 'set_work_plan', 'set_timed_plan', 'decide_location_needs', 'admin_action']),
  "booking": zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}).optional(),
  "series": zod.object({
  "seriesId": zod.uuid(),
  "frequency": zod.enum(['daily_workdays', 'weekly']).describe('daily_workdays = Mon–Fri; weekly = selected weekdays (0=Sun … 6=Sat).\n'),
  "weekdays": zod.array(zod.int().min(postAiAssistantConfirm200ResponseSeriesWeekdaysItemMin).max(postAiAssistantConfirm200ResponseSeriesWeekdaysItemMax)).nullish(),
  "until": zod.iso.datetime({"offset":true}),
  "bookings": zod.array(zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
})),
  "skipped": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}))
}).optional(),
  "cancelledId": zod.uuid().nullish(),
  "workPlanDays": zod.array(zod.object({
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish()
})).optional().describe('Days written when action is set_work_plan'),
  "timedPlan": zod.object({
  "id": zod.uuid(),
  "date": zod.iso.date(),
  "timezone": zod.string(),
  "revision": zod.int(),
  "stops": zod.array(zod.object({
  "id": zod.uuid(),
  "position": zod.int().min(postAiAssistantConfirm200ResponseTimedPlanStopsItemPositionMin),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullable(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "requirements": zod.object({
  "typeCode": zod.string().max(postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsTypeCodeMax).nullable(),
  "amenityIds": zod.array(zod.uuid()).max(postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsAmenityIdsMax),
  "minCapacity": zod.int().min(1).max(postAiAssistantConfirm200ResponseTimedPlanStopsItemRequirementsMinCapacityMax).nullable()
}),
  "bookingLinks": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid()
}))
})),
  "adjustments": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevision": zod.int(),
  "stopId": zod.uuid().nullable(),
  "originalBookingId": zod.uuid(),
  "replacementBookingId": zod.uuid().nullable(),
  "action": zod.enum(['replace', 'cancel']),
  "state": zod.enum(['pending', 'awaiting_calendar', 'succeeded', 'unresolved']),
  "reason": zod.string().nullable(),
  "attempts": zod.int(),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "updatedAt": zod.iso.datetime({"offset":true})
}).optional(),
  "locationNeeds": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "adminResult": zod.object({
  "tool": zod.string().optional(),
  "summary": zod.string().optional(),
  "result": zod.record(zod.string(), zod.unknown()).optional()
}).optional().describe('Result of a confirmed administration action')
}))()

export const postAiAssistantConfirm400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantConfirm400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantConfirm400ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantConfirm400ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantConfirm400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantConfirm400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantConfirm400ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantConfirm400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantConfirm400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantConfirm401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantConfirm401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantConfirm401ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantConfirm401ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantConfirm401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantConfirm401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantConfirm401ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantConfirm401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantConfirm401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantConfirm403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantConfirm403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantConfirm403ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantConfirm403ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantConfirm403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantConfirm403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantConfirm403ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantConfirm403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantConfirm403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantConfirm409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantConfirm409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantConfirm409ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantConfirm409ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantConfirm409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantConfirm409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantConfirm409ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantConfirm409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantConfirm409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postAiAssistantConfirm422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postAiAssistantConfirm422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postAiAssistantConfirm422ResponseOverlapWarningAcknowledgementMin = 16;
export const postAiAssistantConfirm422ResponseOverlapWarningAcknowledgementMax = 256;


export const postAiAssistantConfirm422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostAiAssistantConfirm422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postAiAssistantConfirm422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postAiAssistantConfirm422ResponseOverlapWarningAcknowledgementMin).max(postAiAssistantConfirm422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postAiAssistantConfirm422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List stored files
 */
export const listFilesHeaderXGroupGraphTokenMax = 16384;


export const listFilesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListFilesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listFilesHeaderXGroupGraphTokenMax).regex(listFilesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listFiles200ResponseTotalMin = 0;



export const ListFiles200Response = /*#__PURE__*/ (() => zod.object({
  "files": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "ownerDisplayName": zod.string().nullish()
})),
  "total": zod.int().min(listFiles200ResponseTotalMin)
}))()

export const listFiles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listFiles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listFiles409ResponseOverlapWarningAcknowledgementMin = 16;
export const listFiles409ResponseOverlapWarningAcknowledgementMax = 256;


export const listFiles409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListFiles409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFiles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFiles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listFiles409ResponseOverlapWarningAcknowledgementMin).max(listFiles409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listFiles409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Upload a file
 */
export const uploadFileHeaderXGroupGraphTokenMax = 16384;


export const uploadFileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UploadFileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(uploadFileHeaderXGroupGraphTokenMax).regex(uploadFileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const UploadFileBody = /*#__PURE__*/ (() => zod.object({
  "file": zod.instanceof(Blob)
}))()

export const UploadFile201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "ownerDisplayName": zod.string().nullish()
}))()

export const uploadFile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const uploadFile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const uploadFile400ResponseOverlapWarningAcknowledgementMin = 16;
export const uploadFile400ResponseOverlapWarningAcknowledgementMax = 256;


export const uploadFile400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UploadFile400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(uploadFile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(uploadFile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(uploadFile400ResponseOverlapWarningAcknowledgementMin).max(uploadFile400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(uploadFile400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const uploadFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const uploadFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const uploadFile409ResponseOverlapWarningAcknowledgementMin = 16;
export const uploadFile409ResponseOverlapWarningAcknowledgementMax = 256;


export const uploadFile409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UploadFile409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(uploadFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(uploadFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(uploadFile409ResponseOverlapWarningAcknowledgementMin).max(uploadFile409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(uploadFile409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Delete a stored file
 */
export const DeleteFileParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.string()
}))()

export const deleteFileHeaderXGroupGraphTokenMax = 16384;


export const deleteFileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteFileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteFileHeaderXGroupGraphTokenMax).regex(deleteFileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteFile204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteFile404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFile404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFile404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFile404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFile404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFile404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFile404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFile404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFile404ResponseOverlapWarningAcknowledgementMin).max(deleteFile404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFile404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFile409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFile409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFile409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFile409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFile409ResponseOverlapWarningAcknowledgementMin).max(deleteFile409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFile409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Download file content
 */
export const DownloadFileParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.string()
}))()

export const downloadFileHeaderXGroupGraphTokenMax = 16384;


export const downloadFileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DownloadFileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(downloadFileHeaderXGroupGraphTokenMax).regex(downloadFileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DownloadFile200Response = /*#__PURE__*/ (() => zod.unknown())()

export const downloadFile404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadFile404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadFile404ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadFile404ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadFile404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadFile404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadFile404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadFile404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadFile404ResponseOverlapWarningAcknowledgementMin).max(downloadFile404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadFile404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const downloadFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadFile409ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadFile409ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadFile409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadFile409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadFile409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadFile409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadFile409ResponseOverlapWarningAcknowledgementMin).max(downloadFile409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadFile409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns bookable spaces free of app conflicts, blackouts, and policy violations for the requested half-open window [start, end). Day-window semantics per FR-EU-008.
 * @summary Search spaces available for a day/window
 */

export const searchAvailabilityQueryLimitDefault = 50;
export const searchAvailabilityQueryLimitMax = 200;

export const searchAvailabilityQueryOffsetDefault = 0;
export const searchAvailabilityQueryOffsetMin = 0;



export const SearchAvailabilityQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "floorId": zod.uuid().optional(),
  "zoneId": zod.uuid().optional(),
  "typeCodes": zod.string().optional().describe('Comma-separated space type codes'),
  "amenityCodes": zod.string().optional().describe('Comma-separated amenity codes (all required)'),
  "tags": zod.string().optional().describe('Comma-separated space tags (all required, case-insensitive). Quiet/focus rooms use tag `quiet` (Exchange Set-Place Focus/Quiet model).\n'),
  "minCapacity": zod.int().min(1).optional(),
  "accessibilityOnly": zod.union([zod.literal(true),zod.literal(false)]).optional(),
  "bookForUserId": zod.uuid().optional(),
  "spaceId": zod.uuid().optional().describe('Exact resource lookup, retaining entity access and availability rules'),
  "includeUnavailable": zod.union([zod.literal(true),zod.literal(false)]).optional(),
  "limit": zod.int().min(1).max(searchAvailabilityQueryLimitMax).default(searchAvailabilityQueryLimitDefault),
  "offset": zod.int().min(searchAvailabilityQueryOffsetMin).default(searchAvailabilityQueryOffsetDefault),
  "hasVehicle": zod.union([zod.literal(true),zod.literal(false)]).optional(),
  "hasPermit": zod.union([zod.literal(true),zod.literal(false)]).optional()
}))()

export const searchAvailabilityHeaderXGroupGraphTokenMax = 16384;


export const searchAvailabilityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SearchAvailabilityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(searchAvailabilityHeaderXGroupGraphTokenMax).regex(searchAvailabilityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const searchAvailability200ResponseItemsItemSpaceMapOutlineOneMax = 12;

export const searchAvailability200ResponseTotalMin = 0;



export const SearchAvailability200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(searchAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(searchAvailability200ResponseItemsItemSpaceMapOutlineOneMin).max(searchAvailability200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "available": zod.boolean(),
  "reasons": zod.array(zod.enum(['AVAILABLE', 'CONFLICT', 'POLICY_VIOLATION', 'BLACKOUT', 'UNAVAILABLE_MODE', 'RETIRED', 'TYPE_FILTER'])),
  "reasonDetail": zod.string().nullish(),
  "policyScopeKind": zod.string(),
  "availabilitySource": zod.enum(['app', 'app_fallback', 'exchange']),
  "blockingBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "checkInRequired": zod.boolean(),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "end": zod.iso.datetime({"offset":true}).optional().describe('Original booking end (takeover books until this instant)'),
  "isOwnBooking": zod.boolean().optional().describe('True only when the signed-in viewer owns the blocking booking')
}).describe('Active booking that makes a space unavailable for the search window.\nUsed by the floor map to enable walk-up takeover after missed check-in.\n'),zod.null()]).optional().describe('Present when an app booking makes the space unavailable')
})),
  "total": zod.int().min(searchAvailability200ResponseTotalMin),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "graphStatus": zod.enum(['connected', 'disconnected', 'degraded']).describe('Exchange/Graph readiness for meeting-room SoT (FR-EU-017)'),
  "graphBanner": zod.string().nullish().describe('User-facing degradation copy when rooms are on app_fallback')
}))()

export const searchAvailability401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchAvailability401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchAvailability401ResponseOverlapWarningAcknowledgementMin = 16;
export const searchAvailability401ResponseOverlapWarningAcknowledgementMax = 256;


export const searchAvailability401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchAvailability401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchAvailability401ResponseOverlapWarningAcknowledgementMin).max(searchAvailability401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchAvailability401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchAvailability403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchAvailability403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchAvailability403ResponseOverlapWarningAcknowledgementMin = 16;
export const searchAvailability403ResponseOverlapWarningAcknowledgementMax = 256;


export const searchAvailability403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchAvailability403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchAvailability403ResponseOverlapWarningAcknowledgementMin).max(searchAvailability403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchAvailability403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchAvailability422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchAvailability422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchAvailability422ResponseOverlapWarningAcknowledgementMin = 16;
export const searchAvailability422ResponseOverlapWarningAcknowledgementMax = 256;


export const searchAvailability422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchAvailability422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchAvailability422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchAvailability422ResponseOverlapWarningAcknowledgementMin).max(searchAvailability422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchAvailability422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List bookings for the signed-in user
 */
export const listBookingsQueryMineDefault = true;
export const listBookingsQueryLimitMax = 200;

export const listBookingsQueryOffsetMin = 0;
export const listBookingsQueryOffsetMax = 10000;



export const ListBookingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid().optional(),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']).optional(),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "mine": zod.union([zod.literal(true),zod.literal(false)]).default(listBookingsQueryMineDefault),
  "limit": zod.int().min(1).max(listBookingsQueryLimitMax).optional().describe('Page size for the bounded result set (default 200).'),
  "offset": zod.int().min(listBookingsQueryOffsetMin).max(listBookingsQueryOffsetMax).optional().describe('Number of bookings to skip, for paging through entity history.')
}))()

export const listBookingsHeaderXGroupGraphTokenMax = 16384;


export const listBookingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBookingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBookingsHeaderXGroupGraphTokenMax).regex(listBookingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()



export const listBookings200ResponseTotalMin = 0;



export const ListBookings200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
})),
  "total": zod.int().min(listBookings200ResponseTotalMin).describe('Total matching bookings in the entity for the current filters.')
}))()

export const listBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listBookings401ResponseOverlapWarningAcknowledgementMin = 16;
export const listBookings401ResponseOverlapWarningAcknowledgementMax = 256;


export const listBookings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListBookings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listBookings401ResponseOverlapWarningAcknowledgementMin).max(listBookings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listBookings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a single-space booking
 */
export const createBookingHeaderXGroupGraphTokenMax = 16384;


export const createBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createBookingHeaderXGroupGraphTokenMax).regex(createBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createBookingBodyOverlapAcknowledgementMin = 16;
export const createBookingBodyOverlapAcknowledgementMax = 256;

export const createBookingBodyTitleMax = 200;

export const createBookingBodyNotesMax = 2000;

export const createBookingBodyVehicleOnePlateMax = 32;

export const createBookingBodyVehicleOnePermitIdMax = 100;

export const createBookingBodyVehicleOneSizeClassMax = 40;

export const createBookingBodyVehicleOneLabelMax = 100;

export const createBookingBodyClientRequestIdMax = 100;



export const CreateBookingBody = /*#__PURE__*/ (() => zod.object({
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "overlapAcknowledgement": zod.string().min(createBookingBodyOverlapAcknowledgementMin).max(createBookingBodyOverlapAcknowledgementMax).optional(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "title": zod.string().max(createBookingBodyTitleMax).nullish(),
  "notes": zod.string().max(createBookingBodyNotesMax).nullish(),
  "bookedForUserId": zod.uuid().optional(),
  "itineraryId": zod.uuid().nullish(),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().optional(),
  "plate": zod.string().min(1).max(createBookingBodyVehicleOnePlateMax).optional(),
  "permitId": zod.string().max(createBookingBodyVehicleOnePermitIdMax).nullish(),
  "sizeClass": zod.string().max(createBookingBodyVehicleOneSizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(createBookingBodyVehicleOneLabelMax).nullish()
}),zod.null()]).optional(),
  "clientRequestId": zod.string().max(createBookingBodyClientRequestIdMax).nullish(),
  "source": zod.enum(['ui', 'ai', 'import']).optional()
}))()





export const CreateBooking201Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const createBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBooking401ResponseOverlapWarningAcknowledgementMin = 16;
export const createBooking401ResponseOverlapWarningAcknowledgementMax = 256;


export const createBooking401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBooking401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBooking401ResponseOverlapWarningAcknowledgementMin).max(createBooking401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBooking401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const createBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const createBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBooking403ResponseOverlapWarningAcknowledgementMin).max(createBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBooking409ResponseOverlapWarningAcknowledgementMin = 16;
export const createBooking409ResponseOverlapWarningAcknowledgementMax = 256;


export const createBooking409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBooking409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBooking409ResponseOverlapWarningAcknowledgementMin).max(createBooking409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBooking409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBooking422ResponseOverlapWarningAcknowledgementMin = 16;
export const createBooking422ResponseOverlapWarningAcknowledgementMax = 256;


export const createBooking422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBooking422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBooking422ResponseOverlapWarningAcknowledgementMin).max(createBooking422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBooking422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get a booking by id
 */
export const GetBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getBookingHeaderXGroupGraphTokenMax = 16384;


export const getBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getBookingHeaderXGroupGraphTokenMax).regex(getBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()





export const GetBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const getBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getBooking401ResponseOverlapWarningAcknowledgementMin = 16;
export const getBooking401ResponseOverlapWarningAcknowledgementMax = 256;


export const getBooking401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetBooking401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getBooking401ResponseOverlapWarningAcknowledgementMin).max(getBooking401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getBooking401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const getBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const getBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getBooking403ResponseOverlapWarningAcknowledgementMin).max(getBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getBooking404ResponseOverlapWarningAcknowledgementMin = 16;
export const getBooking404ResponseOverlapWarningAcknowledgementMax = 256;


export const getBooking404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetBooking404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getBooking404ResponseOverlapWarningAcknowledgementMin).max(getBooking404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getBooking404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Modify an active booking window or title
 */
export const UpdateBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateBookingHeaderXGroupGraphTokenMax = 16384;


export const updateBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateBookingHeaderXGroupGraphTokenMax).regex(updateBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const updateBookingBodyTitleMax = 200;

export const updateBookingBodyNotesMax = 2000;



export const UpdateBookingBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1).optional(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}).optional(),
  "end": zod.iso.datetime({"offset":true}).optional(),
  "title": zod.string().max(updateBookingBodyTitleMax).nullish(),
  "notes": zod.string().max(updateBookingBodyNotesMax).nullish(),
  "seriesScope": zod.enum(['one', 'forward']).optional().describe('forward applies title/notes/time delta to this occurrence and all later active occurrences in the same series.\n')
}))()





export const UpdateBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const updateBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateBooking409ResponseOverlapWarningAcknowledgementMin = 16;
export const updateBooking409ResponseOverlapWarningAcknowledgementMax = 256;


export const updateBooking409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateBooking409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateBooking409ResponseOverlapWarningAcknowledgementMin).max(updateBooking409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateBooking409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateBooking422ResponseOverlapWarningAcknowledgementMin = 16;
export const updateBooking422ResponseOverlapWarningAcknowledgementMax = 256;


export const updateBooking422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateBooking422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateBooking422ResponseOverlapWarningAcknowledgementMin).max(updateBooking422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateBooking422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Permanently removes a booking that has already ended, or was cancelled
 * or auto-released. Future bookings must be cancelled first, and bookings
 * still waiting on a calendar sync are refused until it settles. The
 * deletion is recorded in the append-only audit trail.
 * @summary Delete a past or cancelled booking from history
 */
export const DeleteBookingHistoryParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteBookingHistoryHeaderXGroupGraphTokenMax = 16384;


export const deleteBookingHistoryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteBookingHistoryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteBookingHistoryHeaderXGroupGraphTokenMax).regex(deleteBookingHistoryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteBookingHistory204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteBookingHistory403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteBookingHistory403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteBookingHistory403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteBookingHistory403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteBookingHistory403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteBookingHistory403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteBookingHistory403ResponseOverlapWarningAcknowledgementMin).max(deleteBookingHistory403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteBookingHistory403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteBookingHistory404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteBookingHistory404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteBookingHistory404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteBookingHistory404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteBookingHistory404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteBookingHistory404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteBookingHistory404ResponseOverlapWarningAcknowledgementMin).max(deleteBookingHistory404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteBookingHistory404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteBookingHistory409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteBookingHistory409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteBookingHistory409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteBookingHistory409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteBookingHistory409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteBookingHistory409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteBookingHistory409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteBookingHistory409ResponseOverlapWarningAcknowledgementMin).max(deleteBookingHistory409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteBookingHistory409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Remote execution is unavailable until calendar integration is complete. Failure retains the original.
 * @summary Revision-bound local resource move
 */
export const MoveBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const moveBookingHeaderXGroupGraphTokenMax = 16384;


export const moveBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const MoveBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(moveBookingHeaderXGroupGraphTokenMax).regex(moveBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const moveBookingBodyVehiclePlateMax = 32;

export const moveBookingBodyVehiclePermitIdMax = 100;

export const moveBookingBodyVehicleSizeClassMax = 40;

export const moveBookingBodyVehicleLabelMax = 100;



export const MoveBookingBody = /*#__PURE__*/ (() => zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "destinationSpaceId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "layoutId": zod.uuid().optional(),
  "vehicle": zod.object({
  "vehicleId": zod.uuid().optional(),
  "plate": zod.string().min(1).max(moveBookingBodyVehiclePlateMax).optional(),
  "permitId": zod.string().max(moveBookingBodyVehiclePermitIdMax).nullish(),
  "sizeClass": zod.string().max(moveBookingBodyVehicleSizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(moveBookingBodyVehicleLabelMax).nullish()
}).optional()
}))()


export const moveBooking200ResponseMoveOriginalEventIdMax = 2048;

export const moveBooking200ResponseMoveCandidateEventIdMax = 2048;

export const moveBooking200ResponseMoveBeneficiaryCountKeyMax = 256;





export const MoveBooking200Response = /*#__PURE__*/ (() => zod.object({
  "move": zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "revision": zod.int().min(1),
  "state": zod.enum(['reserved', 'awaiting_acceptance', 'promoting', 'promoted', 'cleanup_pending', 'complete', 'declined', 'aborting', 'unresolved', 'failed', 'cancelled']),
  "originalResourceId": zod.uuid(),
  "originalAllocationId": zod.uuid().optional(),
  "destinationAllocationId": zod.uuid().nullish(),
  "remoteExecutionReady": zod.boolean().optional(),
  "destinationResourceId": zod.uuid(),
  "originalEventId": zod.string().max(moveBooking200ResponseMoveOriginalEventIdMax).nullable(),
  "candidateEventId": zod.string().max(moveBooking200ResponseMoveCandidateEventIdMax).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "beneficiaryCountKey": zod.string().max(moveBooking200ResponseMoveBeneficiaryCountKeyMax),
  "originalRetained": zod.boolean(),
  "cleanupRequired": zod.boolean()
}),
  "booking": zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
})
}))()

export const moveBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const moveBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const moveBooking409ResponseOverlapWarningAcknowledgementMin = 16;
export const moveBooking409ResponseOverlapWarningAcknowledgementMax = 256;


export const moveBooking409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MoveBooking409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(moveBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(moveBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(moveBooking409ResponseOverlapWarningAcknowledgementMin).max(moveBooking409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(moveBooking409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read scoped move and recovery history
 */
export const ListBookingMovesParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listBookingMovesQueryLimitDefault = 25;
export const listBookingMovesQueryLimitMax = 100;

export const listBookingMovesQueryOffsetDefault = 0;
export const listBookingMovesQueryOffsetMin = 0;
export const listBookingMovesQueryOffsetMax = 100000;



export const ListBookingMovesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listBookingMovesQueryLimitMax).default(listBookingMovesQueryLimitDefault),
  "offset": zod.int().min(listBookingMovesQueryOffsetMin).max(listBookingMovesQueryOffsetMax).default(listBookingMovesQueryOffsetDefault)
}))()

export const listBookingMovesHeaderXGroupGraphTokenMax = 16384;


export const listBookingMovesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBookingMovesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBookingMovesHeaderXGroupGraphTokenMax).regex(listBookingMovesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listBookingMoves200ResponseItemsItemOriginalEventIdMax = 2048;

export const listBookingMoves200ResponseItemsItemCandidateEventIdMax = 2048;

export const listBookingMoves200ResponseItemsItemBeneficiaryCountKeyMax = 256;

export const listBookingMoves200ResponseItemsMax = 100;

export const listBookingMoves200ResponseTotalMin = 0;



export const ListBookingMoves200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "revision": zod.int().min(1),
  "state": zod.enum(['reserved', 'awaiting_acceptance', 'promoting', 'promoted', 'cleanup_pending', 'complete', 'declined', 'aborting', 'unresolved', 'failed', 'cancelled']),
  "originalResourceId": zod.uuid(),
  "originalAllocationId": zod.uuid().optional(),
  "destinationAllocationId": zod.uuid().nullish(),
  "remoteExecutionReady": zod.boolean().optional(),
  "destinationResourceId": zod.uuid(),
  "originalEventId": zod.string().max(listBookingMoves200ResponseItemsItemOriginalEventIdMax).nullable(),
  "candidateEventId": zod.string().max(listBookingMoves200ResponseItemsItemCandidateEventIdMax).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "beneficiaryCountKey": zod.string().max(listBookingMoves200ResponseItemsItemBeneficiaryCountKeyMax),
  "originalRetained": zod.boolean(),
  "cleanupRequired": zod.boolean()
})).max(listBookingMoves200ResponseItemsMax),
  "total": zod.int().min(listBookingMoves200ResponseTotalMin)
}))()


/**
 * @summary Cancel a booking (or remaining series from this occurrence)
 */
export const CancelBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const cancelBookingHeaderXGroupGraphTokenMax = 16384;


export const cancelBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CancelBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(cancelBookingHeaderXGroupGraphTokenMax).regex(cancelBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const cancelBookingBodyScopeDefault = `one`;

export const CancelBookingBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['one', 'series']).default(cancelBookingBodyScopeDefault).describe('one = cancel this occurrence only; series = cancel this and future active occurrences in the same series.\n')
}))()





export const CancelBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const cancelBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelBooking403ResponseOverlapWarningAcknowledgementMin).max(cancelBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const cancelBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelBooking404ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelBooking404ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelBooking404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelBooking404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelBooking404ResponseOverlapWarningAcknowledgementMin).max(cancelBooking404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelBooking404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Dry-run a recurring series and list planned vs skipped occurrences
 */
export const previewBookingSeriesHeaderXGroupGraphTokenMax = 16384;


export const previewBookingSeriesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewBookingSeriesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewBookingSeriesHeaderXGroupGraphTokenMax).regex(previewBookingSeriesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewBookingSeriesBodyOverlapAcknowledgementMin = 16;
export const previewBookingSeriesBodyOverlapAcknowledgementMax = 256;

export const previewBookingSeriesBodyTitleMax = 200;

export const previewBookingSeriesBodyNotesMax = 2000;

export const previewBookingSeriesBodyVehicleOnePlateMax = 32;

export const previewBookingSeriesBodyVehicleOnePermitIdMax = 100;

export const previewBookingSeriesBodyVehicleOneSizeClassMax = 40;

export const previewBookingSeriesBodyVehicleOneLabelMax = 100;

export const previewBookingSeriesBodyClientRequestIdMax = 100;

export const previewBookingSeriesBodyRecurrenceWeekdaysItemMin = 0;
export const previewBookingSeriesBodyRecurrenceWeekdaysItemMax = 6;

export const previewBookingSeriesBodyRecurrenceWeekdaysMax = 7;



export const PreviewBookingSeriesBody = /*#__PURE__*/ (() => zod.object({
  "overlapAcknowledgement": zod.string().min(previewBookingSeriesBodyOverlapAcknowledgementMin).max(previewBookingSeriesBodyOverlapAcknowledgementMax).optional(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "title": zod.string().max(previewBookingSeriesBodyTitleMax).nullish(),
  "notes": zod.string().max(previewBookingSeriesBodyNotesMax).nullish(),
  "bookedForUserId": zod.uuid().optional(),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().optional(),
  "plate": zod.string().min(1).max(previewBookingSeriesBodyVehicleOnePlateMax).optional(),
  "permitId": zod.string().max(previewBookingSeriesBodyVehicleOnePermitIdMax).nullish(),
  "sizeClass": zod.string().max(previewBookingSeriesBodyVehicleOneSizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(previewBookingSeriesBodyVehicleOneLabelMax).nullish()
}),zod.null()]).optional(),
  "clientRequestId": zod.string().max(previewBookingSeriesBodyClientRequestIdMax).nullish(),
  "source": zod.enum(['ui', 'ai', 'import']).optional(),
  "recurrence": zod.object({
  "frequency": zod.enum(['daily_workdays', 'weekly']).describe('daily_workdays = Mon–Fri; weekly = selected weekdays (0=Sun … 6=Sat).\n'),
  "weekdays": zod.array(zod.int().min(previewBookingSeriesBodyRecurrenceWeekdaysItemMin).max(previewBookingSeriesBodyRecurrenceWeekdaysItemMax)).max(previewBookingSeriesBodyRecurrenceWeekdaysMax).nullish().describe('Required when frequency is weekly. Site-local weekday 0=Sun … 6=Sat (resolved via the space\'s site IANA timezone, not the client\'s browser-local getDay).'),
  "until": zod.iso.datetime({"offset":true}).describe('Inclusive last candidate start for the series.')
})
}))()

export const previewBookingSeries200ResponseWeekdaysItemMin = 0;
export const previewBookingSeries200ResponseWeekdaysItemMax = 6;




export const PreviewBookingSeries200Response = /*#__PURE__*/ (() => zod.object({
  "frequency": zod.enum(['daily_workdays', 'weekly']).describe('daily_workdays = Mon–Fri; weekly = selected weekdays (0=Sun … 6=Sat).\n'),
  "weekdays": zod.array(zod.int().min(previewBookingSeries200ResponseWeekdaysItemMin).max(previewBookingSeries200ResponseWeekdaysItemMax)).nullish(),
  "until": zod.iso.datetime({"offset":true}),
  "planned": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true})
})),
  "skipped": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
})),
  "horizonDays": zod.int().min(1)
}))()

export const previewBookingSeries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewBookingSeries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewBookingSeries400ResponseOverlapWarningAcknowledgementMin = 16;
export const previewBookingSeries400ResponseOverlapWarningAcknowledgementMax = 256;


export const previewBookingSeries400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewBookingSeries400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewBookingSeries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewBookingSeries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewBookingSeries400ResponseOverlapWarningAcknowledgementMin).max(previewBookingSeries400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewBookingSeries400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewBookingSeries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewBookingSeries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewBookingSeries422ResponseOverlapWarningAcknowledgementMin = 16;
export const previewBookingSeries422ResponseOverlapWarningAcknowledgementMax = 256;


export const previewBookingSeries422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewBookingSeries422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewBookingSeries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewBookingSeries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewBookingSeries422ResponseOverlapWarningAcknowledgementMin).max(previewBookingSeries422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewBookingSeries422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a recurring booking series (skip conflicted occurrences)
 */
export const createBookingSeriesHeaderXGroupGraphTokenMax = 16384;


export const createBookingSeriesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateBookingSeriesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createBookingSeriesHeaderXGroupGraphTokenMax).regex(createBookingSeriesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createBookingSeriesBodyOverlapAcknowledgementMin = 16;
export const createBookingSeriesBodyOverlapAcknowledgementMax = 256;

export const createBookingSeriesBodyTitleMax = 200;

export const createBookingSeriesBodyNotesMax = 2000;

export const createBookingSeriesBodyVehicleOnePlateMax = 32;

export const createBookingSeriesBodyVehicleOnePermitIdMax = 100;

export const createBookingSeriesBodyVehicleOneSizeClassMax = 40;

export const createBookingSeriesBodyVehicleOneLabelMax = 100;

export const createBookingSeriesBodyClientRequestIdMax = 100;

export const createBookingSeriesBodyRecurrenceWeekdaysItemMin = 0;
export const createBookingSeriesBodyRecurrenceWeekdaysItemMax = 6;

export const createBookingSeriesBodyRecurrenceWeekdaysMax = 7;



export const CreateBookingSeriesBody = /*#__PURE__*/ (() => zod.object({
  "overlapAcknowledgement": zod.string().min(createBookingSeriesBodyOverlapAcknowledgementMin).max(createBookingSeriesBodyOverlapAcknowledgementMax).optional(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "title": zod.string().max(createBookingSeriesBodyTitleMax).nullish(),
  "notes": zod.string().max(createBookingSeriesBodyNotesMax).nullish(),
  "bookedForUserId": zod.uuid().optional(),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().optional(),
  "plate": zod.string().min(1).max(createBookingSeriesBodyVehicleOnePlateMax).optional(),
  "permitId": zod.string().max(createBookingSeriesBodyVehicleOnePermitIdMax).nullish(),
  "sizeClass": zod.string().max(createBookingSeriesBodyVehicleOneSizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(createBookingSeriesBodyVehicleOneLabelMax).nullish()
}),zod.null()]).optional(),
  "clientRequestId": zod.string().max(createBookingSeriesBodyClientRequestIdMax).nullish(),
  "source": zod.enum(['ui', 'ai', 'import']).optional(),
  "recurrence": zod.object({
  "frequency": zod.enum(['daily_workdays', 'weekly']).describe('daily_workdays = Mon–Fri; weekly = selected weekdays (0=Sun … 6=Sat).\n'),
  "weekdays": zod.array(zod.int().min(createBookingSeriesBodyRecurrenceWeekdaysItemMin).max(createBookingSeriesBodyRecurrenceWeekdaysItemMax)).max(createBookingSeriesBodyRecurrenceWeekdaysMax).nullish().describe('Required when frequency is weekly. Site-local weekday 0=Sun … 6=Sat (resolved via the space\'s site IANA timezone, not the client\'s browser-local getDay).'),
  "until": zod.iso.datetime({"offset":true}).describe('Inclusive last candidate start for the series.')
})
}))()

export const createBookingSeries201ResponseWeekdaysItemMin = 0;
export const createBookingSeries201ResponseWeekdaysItemMax = 6;





export const CreateBookingSeries201Response = /*#__PURE__*/ (() => zod.object({
  "seriesId": zod.uuid(),
  "frequency": zod.enum(['daily_workdays', 'weekly']).describe('daily_workdays = Mon–Fri; weekly = selected weekdays (0=Sun … 6=Sat).\n'),
  "weekdays": zod.array(zod.int().min(createBookingSeries201ResponseWeekdaysItemMin).max(createBookingSeries201ResponseWeekdaysItemMax)).nullish(),
  "until": zod.iso.datetime({"offset":true}),
  "bookings": zod.array(zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
})),
  "skipped": zod.array(zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}))
}))()

export const createBookingSeries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBookingSeries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBookingSeries400ResponseOverlapWarningAcknowledgementMin = 16;
export const createBookingSeries400ResponseOverlapWarningAcknowledgementMax = 256;


export const createBookingSeries400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBookingSeries400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBookingSeries400ResponseOverlapWarningAcknowledgementMin).max(createBookingSeries400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBookingSeries400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createBookingSeries409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBookingSeries409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBookingSeries409ResponseOverlapWarningAcknowledgementMin = 16;
export const createBookingSeries409ResponseOverlapWarningAcknowledgementMax = 256;


export const createBookingSeries409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBookingSeries409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBookingSeries409ResponseOverlapWarningAcknowledgementMin).max(createBookingSeries409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBookingSeries409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createBookingSeries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createBookingSeries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createBookingSeries422ResponseOverlapWarningAcknowledgementMin = 16;
export const createBookingSeries422ResponseOverlapWarningAcknowledgementMax = 256;


export const createBookingSeries422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateBookingSeries422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createBookingSeries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createBookingSeries422ResponseOverlapWarningAcknowledgementMin).max(createBookingSeries422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createBookingSeries422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Check in to a booking within the policy window
 */
export const CheckInBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const checkInBookingHeaderXGroupGraphTokenMax = 16384;


export const checkInBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CheckInBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(checkInBookingHeaderXGroupGraphTokenMax).regex(checkInBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const checkInBookingBodyMethodDefault = `web`;
export const checkInBookingBodyArrivalItemIdsItemMax = 64;

export const checkInBookingBodyArrivalItemIdsMax = 50;



export const CheckInBookingBody = /*#__PURE__*/ (() => zod.object({
  "method": zod.enum(['web', 'qr', 'admin']).default(checkInBookingBodyMethodDefault),
  "arrivalItemIds": zod.array(zod.string().min(1).max(checkInBookingBodyArrivalItemIdsItemMax)).max(checkInBookingBodyArrivalItemIdsMax).optional().describe('Every configured arrival check must be acknowledged for each check-in.')
}))()





export const CheckInBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const checkInBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInBooking400ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInBooking400ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInBooking400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInBooking400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInBooking400ResponseOverlapWarningAcknowledgementMin).max(checkInBooking400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInBooking400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkInBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInBooking403ResponseOverlapWarningAcknowledgementMin).max(checkInBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkInBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInBooking404ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInBooking404ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInBooking404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInBooking404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInBooking404ResponseOverlapWarningAcknowledgementMin).max(checkInBooking404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInBooking404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkInBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInBooking422ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInBooking422ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInBooking422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInBooking422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInBooking422ResponseOverlapWarningAcknowledgementMin).max(checkInBooking422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInBooking422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Truncates the booking endAt to now so the remaining interval becomes
 * available to other occupants. The booking stays in its current active
 * status (e.g. checked_in) so attendance history remains honest — it is
 * not marked cancelled. Eligible when startAt <= now < endAt and the
 * status is checked_in, confirmed, or pending_check_in.
 * @summary Check out early from an in-progress booking to free remaining time
 */
export const CheckOutBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const checkOutBookingHeaderXGroupGraphTokenMax = 16384;


export const checkOutBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CheckOutBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(checkOutBookingHeaderXGroupGraphTokenMax).regex(checkOutBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const checkOutBookingBodyMethodDefault = `web`;

export const CheckOutBookingBody = /*#__PURE__*/ (() => zod.object({
  "method": zod.enum(['web', 'qr', 'admin']).default(checkOutBookingBodyMethodDefault)
}))()





export const CheckOutBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const checkOutBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkOutBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkOutBooking400ResponseOverlapWarningAcknowledgementMin = 16;
export const checkOutBooking400ResponseOverlapWarningAcknowledgementMax = 256;


export const checkOutBooking400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckOutBooking400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkOutBooking400ResponseOverlapWarningAcknowledgementMin).max(checkOutBooking400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkOutBooking400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkOutBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkOutBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkOutBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const checkOutBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const checkOutBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckOutBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkOutBooking403ResponseOverlapWarningAcknowledgementMin).max(checkOutBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkOutBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkOutBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkOutBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkOutBooking404ResponseOverlapWarningAcknowledgementMin = 16;
export const checkOutBooking404ResponseOverlapWarningAcknowledgementMax = 256;


export const checkOutBooking404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckOutBooking404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkOutBooking404ResponseOverlapWarningAcknowledgementMin).max(checkOutBooking404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkOutBooking404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Any signed-in employee may claim a desk whose blocking booking is still
 * pending_check_in after checkInBy and before end. In one transaction the
 * original booking becomes auto_released and a new checked_in booking is
 * created for the caller until the original end time. The original booker
 * should use check-in instead.
 * @summary Take over an unclaimed desk after the check-in grace period
 */
export const TakeOverBookingParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const takeOverBookingHeaderXGroupGraphTokenMax = 16384;


export const takeOverBookingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const TakeOverBookingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(takeOverBookingHeaderXGroupGraphTokenMax).regex(takeOverBookingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const TakeOverBookingBody = /*#__PURE__*/ (() => zod.object({
  "layoutId": zod.uuid().optional()
}))()





export const TakeOverBooking200Response = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))()

export const takeOverBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking400ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking400ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking400ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const takeOverBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking401ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking401ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking401ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const takeOverBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking403ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking403ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking403ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const takeOverBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking404ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking404ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking404ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const takeOverBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking409ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking409ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking409ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const takeOverBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const takeOverBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const takeOverBooking422ResponseOverlapWarningAcknowledgementMin = 16;
export const takeOverBooking422ResponseOverlapWarningAcknowledgementMax = 256;


export const takeOverBooking422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const TakeOverBooking422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(takeOverBooking422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(takeOverBooking422ResponseOverlapWarningAcknowledgementMin).max(takeOverBooking422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(takeOverBooking422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Lifecycle audit history for a booking
 */
export const ListBookingHistoryParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listBookingHistoryHeaderXGroupGraphTokenMax = 16384;


export const listBookingHistoryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListBookingHistoryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listBookingHistoryHeaderXGroupGraphTokenMax).regex(listBookingHistoryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListBookingHistory200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "at": zod.iso.datetime({"offset":true}),
  "actorUserId": zod.uuid().nullish(),
  "actorName": zod.string().nullish(),
  "action": zod.string(),
  "entityType": zod.string(),
  "entityId": zod.uuid(),
  "summary": zod.string(),
  "before": zod.record(zod.string(), zod.unknown()).nullish(),
  "after": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestId": zod.string().nullish(),
  "correlationId": zod.uuid().nullish()
})),
  "total": zod.int()
}))()

export const listBookingHistory401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listBookingHistory401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listBookingHistory401ResponseOverlapWarningAcknowledgementMin = 16;
export const listBookingHistory401ResponseOverlapWarningAcknowledgementMax = 256;


export const listBookingHistory401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListBookingHistory401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listBookingHistory401ResponseOverlapWarningAcknowledgementMin).max(listBookingHistory401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listBookingHistory401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listBookingHistory403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listBookingHistory403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listBookingHistory403ResponseOverlapWarningAcknowledgementMin = 16;
export const listBookingHistory403ResponseOverlapWarningAcknowledgementMax = 256;


export const listBookingHistory403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListBookingHistory403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listBookingHistory403ResponseOverlapWarningAcknowledgementMin).max(listBookingHistory403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listBookingHistory403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listBookingHistory404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listBookingHistory404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listBookingHistory404ResponseOverlapWarningAcknowledgementMin = 16;
export const listBookingHistory404ResponseOverlapWarningAcknowledgementMax = 256;


export const listBookingHistory404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListBookingHistory404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listBookingHistory404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listBookingHistory404ResponseOverlapWarningAcknowledgementMin).max(listBookingHistory404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listBookingHistory404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Directory search for book-on-behalf recipients
 */
export const listDirectoryUsersQueryOffsetDefault = 0;
export const listDirectoryUsersQueryOffsetMin = 0;
export const listDirectoryUsersQueryOffsetMax = 100000;

export const listDirectoryUsersQueryLimitDefault = 30;
export const listDirectoryUsersQueryLimitMax = 100;



export const ListDirectoryUsersQueryParams = /*#__PURE__*/ (() => zod.object({
  "offset": zod.int().min(listDirectoryUsersQueryOffsetMin).max(listDirectoryUsersQueryOffsetMax).default(listDirectoryUsersQueryOffsetDefault),
  "q": zod.string().optional(),
  "limit": zod.int().min(1).max(listDirectoryUsersQueryLimitMax).default(listDirectoryUsersQueryLimitDefault)
}))()

export const listDirectoryUsersHeaderXGroupGraphTokenMax = 16384;


export const listDirectoryUsersHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListDirectoryUsersHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listDirectoryUsersHeaderXGroupGraphTokenMax).regex(listDirectoryUsersHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListDirectoryUsers200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "displayName": zod.string().nullish(),
  "email": zod.string(),
  "department": zod.string().nullish()
})),
  "total": zod.int()
}))()

export const listDirectoryUsers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listDirectoryUsers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listDirectoryUsers403ResponseOverlapWarningAcknowledgementMin = 16;
export const listDirectoryUsers403ResponseOverlapWarningAcknowledgementMax = 256;


export const listDirectoryUsers403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListDirectoryUsers403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDirectoryUsers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listDirectoryUsers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listDirectoryUsers403ResponseOverlapWarningAcknowledgementMin).max(listDirectoryUsers403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listDirectoryUsers403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Aggregates booked occupancy versus capacity for the report window, grouped by site, building, and space type. Requires reports:view. Pass format=csv for a CSV download of the item rows.
 * @summary Space utilisation report
 */
export const getUtilisationReportQueryFormatDefault = `json`;

export const GetUtilisationReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getUtilisationReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.'),
  "groupBy": zod.enum(['site', 'building', 'floor', 'type']).optional().describe('Collapse results to the requested granularity.')
}))()

export const getUtilisationReportHeaderXGroupGraphTokenMax = 16384;


export const getUtilisationReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUtilisationReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUtilisationReportHeaderXGroupGraphTokenMax).regex(getUtilisationReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getUtilisationReport200ResponseSummaryCheckedInMinutesMin = 0;

export const getUtilisationReport200ResponseSummaryCheckedInPctMin = 0;

export const getUtilisationReport200ResponseSummaryRecordedMinutesMin = 0;

export const getUtilisationReport200ResponseSummaryEstimatedMinutesMin = 0;

export const getUtilisationReport200ResponseSummaryMissingScheduleSpaceCountMin = 0;

export const getUtilisationReport200ResponseSummaryClosedSpaceCountMin = 0;

export const getUtilisationReport200ResponseItemsItemSpaceCountMin = 0;

export const getUtilisationReport200ResponseItemsItemCapacityUnitsMin = 0;

export const getUtilisationReport200ResponseItemsItemBookedMinutesMin = 0;

export const getUtilisationReport200ResponseItemsItemAvailableMinutesMin = 0;

export const getUtilisationReport200ResponseItemsItemUtilisationPctMin = 0;

export const getUtilisationReport200ResponseItemsItemCheckedInMinutesMin = 0;

export const getUtilisationReport200ResponseItemsItemCheckedInPctMin = 0;

export const getUtilisationReport200ResponseItemsItemRecordedMinutesMin = 0;

export const getUtilisationReport200ResponseItemsItemEstimatedMinutesMin = 0;

export const getUtilisationReport200ResponseItemsItemMissingScheduleSpaceCountMin = 0;

export const getUtilisationReport200ResponseItemsItemClosedSpaceCountMin = 0;



export const GetUtilisationReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable(),
  "groupBy": zod.union([zod.literal('site'),zod.literal('building'),zod.literal('floor'),zod.literal('type'),zod.literal(null)]).nullable()
}),
  "summary": zod.object({
  "spaceCount": zod.int(),
  "capacityUnits": zod.int(),
  "bookedMinutes": zod.number(),
  "availableMinutes": zod.number(),
  "utilisationPct": zod.number().nullable(),
  "checkedInMinutes": zod.number().min(getUtilisationReport200ResponseSummaryCheckedInMinutesMin),
  "checkedInPct": zod.number().min(getUtilisationReport200ResponseSummaryCheckedInPctMin),
  "recordedMinutes": zod.number().min(getUtilisationReport200ResponseSummaryRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getUtilisationReport200ResponseSummaryEstimatedMinutesMin),
  "missingScheduleSpaceCount": zod.int().min(getUtilisationReport200ResponseSummaryMissingScheduleSpaceCountMin),
  "closedSpaceCount": zod.int().min(getUtilisationReport200ResponseSummaryClosedSpaceCountMin)
}),
  "items": zod.array(zod.object({
  "siteId": zod.uuid(),
  "siteCode": zod.string(),
  "siteName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingCode": zod.string(),
  "buildingName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "spaceCount": zod.int().min(getUtilisationReport200ResponseItemsItemSpaceCountMin),
  "capacityUnits": zod.int().min(getUtilisationReport200ResponseItemsItemCapacityUnitsMin),
  "bookedMinutes": zod.number().min(getUtilisationReport200ResponseItemsItemBookedMinutesMin),
  "availableMinutes": zod.number().min(getUtilisationReport200ResponseItemsItemAvailableMinutesMin),
  "utilisationPct": zod.number().min(getUtilisationReport200ResponseItemsItemUtilisationPctMin).nullable(),
  "checkedInMinutes": zod.number().min(getUtilisationReport200ResponseItemsItemCheckedInMinutesMin),
  "checkedInPct": zod.number().min(getUtilisationReport200ResponseItemsItemCheckedInPctMin),
  "recordedMinutes": zod.number().min(getUtilisationReport200ResponseItemsItemRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getUtilisationReport200ResponseItemsItemEstimatedMinutesMin),
  "missingScheduleSpaceCount": zod.int().min(getUtilisationReport200ResponseItemsItemMissingScheduleSpaceCountMin),
  "closedSpaceCount": zod.int().min(getUtilisationReport200ResponseItemsItemClosedSpaceCountMin)
}))
}))()

export const getUtilisationReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationReport401ResponseOverlapWarningAcknowledgementMin).max(getUtilisationReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUtilisationReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationReport403ResponseOverlapWarningAcknowledgementMin).max(getUtilisationReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUtilisationReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationReport422ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationReport422ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationReport422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationReport422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationReport422ResponseOverlapWarningAcknowledgementMin).max(getUtilisationReport422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationReport422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns per-day per-site utilisation series for the report window. Requires reports:view. Pass format=csv for a CSV download.
 * @summary Utilisation trend over time
 */
export const getUtilisationTimeseriesQueryFormatDefault = `json`;
export const getUtilisationTimeseriesQueryPeriodDefault = `day`;
export const getUtilisationTimeseriesQueryScopeDefault = `site`;

export const GetUtilisationTimeseriesQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getUtilisationTimeseriesQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.'),
  "period": zod.enum(['day', 'month', 'quarter']).default(getUtilisationTimeseriesQueryPeriodDefault).describe('UTC calendar period; every site\'s denominator uses its local opening schedule.'),
  "scope": zod.enum(['site', 'national']).default(getUtilisationTimeseriesQueryScopeDefault).describe('National values sum eligible durations before division.')
}))()

export const getUtilisationTimeseriesHeaderXGroupGraphTokenMax = 16384;


export const getUtilisationTimeseriesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUtilisationTimeseriesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUtilisationTimeseriesHeaderXGroupGraphTokenMax).regex(getUtilisationTimeseriesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getUtilisationTimeseries200ResponseSummaryDayCountMin = 0;

export const getUtilisationTimeseries200ResponseSummarySiteCountMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemBookedMinutesMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemAvailableMinutesMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemUtilisationPctMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemRecordedMinutesMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemEstimatedMinutesMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemMissingScheduleSpaceCountMin = 0;

export const getUtilisationTimeseries200ResponseItemsItemClosedSpaceCountMin = 0;



export const GetUtilisationTimeseries200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "period": zod.enum(['day', 'month', 'quarter']),
  "scope": zod.enum(['site', 'national']),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable()
}),
  "summary": zod.object({
  "dayCount": zod.int().min(getUtilisationTimeseries200ResponseSummaryDayCountMin),
  "siteCount": zod.int().min(getUtilisationTimeseries200ResponseSummarySiteCountMin)
}),
  "items": zod.array(zod.object({
  "day": zod.iso.date(),
  "siteId": zod.uuid().nullable(),
  "siteCode": zod.string(),
  "siteName": zod.string(),
  "bookedMinutes": zod.number().min(getUtilisationTimeseries200ResponseItemsItemBookedMinutesMin),
  "availableMinutes": zod.number().min(getUtilisationTimeseries200ResponseItemsItemAvailableMinutesMin),
  "utilisationPct": zod.number().min(getUtilisationTimeseries200ResponseItemsItemUtilisationPctMin).nullable(),
  "recordedMinutes": zod.number().min(getUtilisationTimeseries200ResponseItemsItemRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getUtilisationTimeseries200ResponseItemsItemEstimatedMinutesMin),
  "missingScheduleSpaceCount": zod.int().min(getUtilisationTimeseries200ResponseItemsItemMissingScheduleSpaceCountMin),
  "closedSpaceCount": zod.int().min(getUtilisationTimeseries200ResponseItemsItemClosedSpaceCountMin)
}))
}))()

export const getUtilisationTimeseries401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationTimeseries401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationTimeseries401ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationTimeseries401ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationTimeseries401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationTimeseries401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationTimeseries401ResponseOverlapWarningAcknowledgementMin).max(getUtilisationTimeseries401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationTimeseries401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUtilisationTimeseries403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationTimeseries403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationTimeseries403ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationTimeseries403ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationTimeseries403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationTimeseries403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationTimeseries403ResponseOverlapWarningAcknowledgementMin).max(getUtilisationTimeseries403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationTimeseries403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUtilisationTimeseries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUtilisationTimeseries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUtilisationTimeseries422ResponseOverlapWarningAcknowledgementMin = 16;
export const getUtilisationTimeseries422ResponseOverlapWarningAcknowledgementMax = 256;


export const getUtilisationTimeseries422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUtilisationTimeseries422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUtilisationTimeseries422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUtilisationTimeseries422ResponseOverlapWarningAcknowledgementMin).max(getUtilisationTimeseries422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUtilisationTimeseries422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Lists bookings that were auto-released for missed check-in in the window. Requires reports:view. Pass format=csv for a CSV download.
 * @summary No-show (auto-released) report
 */
export const getNoShowReportQueryFormatDefault = `json`;

export const GetNoShowReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getNoShowReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.')
}))()

export const getNoShowReportHeaderXGroupGraphTokenMax = 16384;


export const getNoShowReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetNoShowReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getNoShowReportHeaderXGroupGraphTokenMax).regex(getNoShowReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getNoShowReport200ResponseSummaryNoShowCountMin = 0;

export const getNoShowReport200ResponseSummaryByTypeItemCountMin = 0;



export const GetNoShowReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable()
}),
  "summary": zod.object({
  "noShowCount": zod.int().min(getNoShowReport200ResponseSummaryNoShowCountMin),
  "byType": zod.array(zod.object({
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "count": zod.int().min(getNoShowReport200ResponseSummaryByTypeItemCountMin)
}))
}),
  "items": zod.array(zod.object({
  "bookingId": zod.uuid(),
  "spaceId": zod.uuid(),
  "spaceCode": zod.string(),
  "spaceName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "checkInBy": zod.iso.datetime({"offset":true}).nullable(),
  "releasedAt": zod.iso.datetime({"offset":true}).nullable(),
  "bookedForUserId": zod.uuid()
}))
}))()

export const getNoShowReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNoShowReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNoShowReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getNoShowReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getNoShowReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNoShowReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNoShowReport401ResponseOverlapWarningAcknowledgementMin).max(getNoShowReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNoShowReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getNoShowReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNoShowReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNoShowReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getNoShowReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getNoShowReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNoShowReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNoShowReport403ResponseOverlapWarningAcknowledgementMin).max(getNoShowReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNoShowReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getNoShowReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNoShowReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNoShowReport422ResponseOverlapWarningAcknowledgementMin = 16;
export const getNoShowReport422ResponseOverlapWarningAcknowledgementMax = 256;


export const getNoShowReport422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNoShowReport422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNoShowReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNoShowReport422ResponseOverlapWarningAcknowledgementMin).max(getNoShowReport422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNoShowReport422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Compares declared office presence (intent) and bookings against check-ins (actual) per building per day. When no presence data exists, bookings are used as the intent signal. Requires reports:view.
 * @summary Intent vs actual occupancy report
 */
export const getIntentVsActualReportQueryFormatDefault = `json`;

export const GetIntentVsActualReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getIntentVsActualReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.')
}))()

export const getIntentVsActualReportHeaderXGroupGraphTokenMax = 16384;


export const getIntentVsActualReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetIntentVsActualReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getIntentVsActualReportHeaderXGroupGraphTokenMax).regex(getIntentVsActualReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getIntentVsActualReport200ResponseSummaryDayCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryBuildingCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryDeclaredOfficeCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryBookedCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryCheckedInCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryIntentCountMin = 0;

export const getIntentVsActualReport200ResponseSummaryAttendanceRatioMin = 0;

export const getIntentVsActualReport200ResponseItemsItemDeclaredOfficeCountMin = 0;

export const getIntentVsActualReport200ResponseItemsItemBookedCountMin = 0;

export const getIntentVsActualReport200ResponseItemsItemCheckedInCountMin = 0;

export const getIntentVsActualReport200ResponseItemsItemIntentCountMin = 0;

export const getIntentVsActualReport200ResponseItemsItemAttendanceRatioMin = 0;



export const GetIntentVsActualReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable()
}),
  "summary": zod.object({
  "dayCount": zod.int().min(getIntentVsActualReport200ResponseSummaryDayCountMin),
  "buildingCount": zod.int().min(getIntentVsActualReport200ResponseSummaryBuildingCountMin),
  "declaredOfficeCount": zod.int().min(getIntentVsActualReport200ResponseSummaryDeclaredOfficeCountMin),
  "bookedCount": zod.int().min(getIntentVsActualReport200ResponseSummaryBookedCountMin),
  "checkedInCount": zod.int().min(getIntentVsActualReport200ResponseSummaryCheckedInCountMin),
  "intentCount": zod.int().min(getIntentVsActualReport200ResponseSummaryIntentCountMin),
  "attendanceRatio": zod.number().min(getIntentVsActualReport200ResponseSummaryAttendanceRatioMin),
  "usingPresenceSignal": zod.boolean()
}),
  "items": zod.array(zod.object({
  "day": zod.iso.date(),
  "siteId": zod.uuid(),
  "siteCode": zod.string(),
  "siteName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingCode": zod.string(),
  "buildingName": zod.string(),
  "declaredOfficeCount": zod.int().min(getIntentVsActualReport200ResponseItemsItemDeclaredOfficeCountMin),
  "bookedCount": zod.int().min(getIntentVsActualReport200ResponseItemsItemBookedCountMin),
  "checkedInCount": zod.int().min(getIntentVsActualReport200ResponseItemsItemCheckedInCountMin),
  "intentCount": zod.int().min(getIntentVsActualReport200ResponseItemsItemIntentCountMin),
  "attendanceRatio": zod.number().min(getIntentVsActualReport200ResponseItemsItemAttendanceRatioMin)
}))
}))()

export const getIntentVsActualReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getIntentVsActualReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getIntentVsActualReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getIntentVsActualReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getIntentVsActualReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetIntentVsActualReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getIntentVsActualReport401ResponseOverlapWarningAcknowledgementMin).max(getIntentVsActualReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getIntentVsActualReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getIntentVsActualReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getIntentVsActualReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getIntentVsActualReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getIntentVsActualReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getIntentVsActualReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetIntentVsActualReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getIntentVsActualReport403ResponseOverlapWarningAcknowledgementMin).max(getIntentVsActualReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getIntentVsActualReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getIntentVsActualReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getIntentVsActualReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getIntentVsActualReport422ResponseOverlapWarningAcknowledgementMin = 16;
export const getIntentVsActualReport422ResponseOverlapWarningAcknowledgementMax = 256;


export const getIntentVsActualReport422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetIntentVsActualReport422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getIntentVsActualReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getIntentVsActualReport422ResponseOverlapWarningAcknowledgementMin).max(getIntentVsActualReport422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getIntentVsActualReport422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Resolves the signed-in manager's current directory or audited local direct reports in the active entity. Site-local dates determine day boundaries. Only the selected page of authorised staff is returned or exported. Missing check-in is not proof of absence; missing checkout is estimated. Directory mode uses a browser-acquired delegated Graph credential, never a backend token exchange or application token. Local mode needs no Graph credential.
 * @summary Named work plan, booking and recorded arrival comparison for direct reports
 */
export const getManagerAttendanceReportQueryLimitDefault = 10;
export const getManagerAttendanceReportQueryLimitMax = 25;

export const getManagerAttendanceReportQueryOffsetDefault = 0;
export const getManagerAttendanceReportQueryOffsetMin = 0;

export const getManagerAttendanceReportQueryFormatDefault = `json`;

export const GetManagerAttendanceReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "staffId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(getManagerAttendanceReportQueryLimitMax).default(getManagerAttendanceReportQueryLimitDefault),
  "offset": zod.int().min(getManagerAttendanceReportQueryOffsetMin).default(getManagerAttendanceReportQueryOffsetDefault),
  "format": zod.enum(['json', 'csv']).default(getManagerAttendanceReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.')
}))()

export const getManagerAttendanceReportHeaderXGroupGraphTokenMax = 16384;


export const getManagerAttendanceReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');
export const getManagerAttendanceReportHeaderXManagerGraphTokenMax = 16384;


export const getManagerAttendanceReportHeaderXManagerGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetManagerAttendanceReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getManagerAttendanceReportHeaderXGroupGraphTokenMax).regex(getManagerAttendanceReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n'),
  "X-Manager-Graph-Token": zod.string().min(1).max(getManagerAttendanceReportHeaderXManagerGraphTokenMax).regex(getManagerAttendanceReportHeaderXManagerGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph access token from the signed-in manager\'s existing browser session. Only a downstream Graph credential; Authorization must still contain the independently validated custom-API bearer. The server checks Graph /me and /organization against API oid/tid before reading reports. Never persist, log or include in URLs. Missing access makes directory mode unavailable; local assignments remain usable.\n')
}))()

export const getManagerAttendanceReport200ResponseStaffTotalMin = 0;


export const getManagerAttendanceReport200ResponseStaffOffsetMin = 0;

export const getManagerAttendanceReport200ResponseItemsItemBookingCountMin = 0;

export const getManagerAttendanceReport200ResponseItemsItemCancelledCountMin = 0;

export const getManagerAttendanceReport200ResponseItemsItemNoShowCountMin = 0;

export const getManagerAttendanceReport200ResponseItemsItemBookingsItemDurationMinutesMin = 0;



export const GetManagerAttendanceReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "timezone": zod.string(),
  "scopeSource": zod.enum(['directory', 'local']),
  "scopeCheckedAt": zod.iso.datetime({"offset":true}),
  "staff": zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(getManagerAttendanceReport200ResponseStaffTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getManagerAttendanceReport200ResponseStaffOffsetMin)
}),
  "items": zod.array(zod.object({
  "staffId": zod.uuid(),
  "staffName": zod.string(),
  "staffEmail": zod.string().nullable(),
  "day": zod.iso.date(),
  "planStatus": zod.enum(['office', 'remote', 'off', 'unknown']),
  "planSource": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable(),
  "planBuildingId": zod.uuid().nullable(),
  "planBuildingName": zod.string().nullable(),
  "planAtSite": zod.boolean(),
  "bookingCount": zod.int().min(getManagerAttendanceReport200ResponseItemsItemBookingCountMin),
  "cancelledCount": zod.int().min(getManagerAttendanceReport200ResponseItemsItemCancelledCountMin),
  "noShowCount": zod.int().min(getManagerAttendanceReport200ResponseItemsItemNoShowCountMin),
  "arrivalMethods": zod.array(zod.enum(['web', 'qr', 'admin'])),
  "comparison": zod.enum(['matched', 'no_recorded_arrival', 'unexpected_arrival', 'no_comparison']),
  "bookings": zod.array(zod.object({
  "bookingId": zod.uuid(),
  "status": zod.string(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "checkInAt": zod.iso.datetime({"offset":true}).nullable(),
  "checkInMethod": zod.union([zod.literal('web'),zod.literal('qr'),zod.literal('admin'),zod.literal(null)]).nullable(),
  "checkOutAt": zod.iso.datetime({"offset":true}).nullable(),
  "checkOutMethod": zod.union([zod.literal('web'),zod.literal('qr'),zod.literal('admin'),zod.literal(null)]).nullable(),
  "durationEvidence": zod.enum(['none', 'recorded_checkout', 'estimated_no_checkout']),
  "durationMinutes": zod.number().min(getManagerAttendanceReport200ResponseItemsItemBookingsItemDurationMinutesMin).nullable()
}))
})),
  "definition": zod.string()
}))()

export const getManagerAttendanceReport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getManagerAttendanceReport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getManagerAttendanceReport400ResponseOverlapWarningAcknowledgementMin = 16;
export const getManagerAttendanceReport400ResponseOverlapWarningAcknowledgementMax = 256;


export const getManagerAttendanceReport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetManagerAttendanceReport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getManagerAttendanceReport400ResponseOverlapWarningAcknowledgementMin).max(getManagerAttendanceReport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getManagerAttendanceReport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getManagerAttendanceReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getManagerAttendanceReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getManagerAttendanceReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getManagerAttendanceReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getManagerAttendanceReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetManagerAttendanceReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getManagerAttendanceReport401ResponseOverlapWarningAcknowledgementMin).max(getManagerAttendanceReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getManagerAttendanceReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getManagerAttendanceReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getManagerAttendanceReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getManagerAttendanceReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getManagerAttendanceReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getManagerAttendanceReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetManagerAttendanceReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getManagerAttendanceReport403ResponseOverlapWarningAcknowledgementMin).max(getManagerAttendanceReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getManagerAttendanceReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getManagerAttendanceReport503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getManagerAttendanceReport503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getManagerAttendanceReport503ResponseOverlapWarningAcknowledgementMin = 16;
export const getManagerAttendanceReport503ResponseOverlapWarningAcknowledgementMax = 256;


export const getManagerAttendanceReport503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetManagerAttendanceReport503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getManagerAttendanceReport503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getManagerAttendanceReport503ResponseOverlapWarningAcknowledgementMin).max(getManagerAttendanceReport503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getManagerAttendanceReport503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Booking activity by weekday and hour-of-day (UTC) for the selected filters. Requires reports:view.
 * @summary Peak occupancy heatmap data
 */
export const getPeakReportQueryFormatDefault = `json`;

export const GetPeakReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getPeakReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.')
}))()

export const getPeakReportHeaderXGroupGraphTokenMax = 16384;


export const getPeakReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetPeakReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getPeakReportHeaderXGroupGraphTokenMax).regex(getPeakReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getPeakReport200ResponseSummaryMaxBookedMinutesMin = 0;

export const getPeakReport200ResponseSummaryTotalBookedMinutesMin = 0;

export const getPeakReport200ResponseSummarySpaceCountMin = 0;

export const getPeakReport200ResponseCellsItemWeekdayMin = 0;
export const getPeakReport200ResponseCellsItemWeekdayMax = 6;

export const getPeakReport200ResponseCellsItemHourMin = 0;
export const getPeakReport200ResponseCellsItemHourMax = 23;

export const getPeakReport200ResponseCellsItemBookedMinutesMin = 0;

export const getPeakReport200ResponseCellsItemBookingHitsMin = 0;



export const GetPeakReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable()
}),
  "summary": zod.object({
  "maxBookedMinutes": zod.int().min(getPeakReport200ResponseSummaryMaxBookedMinutesMin),
  "totalBookedMinutes": zod.int().min(getPeakReport200ResponseSummaryTotalBookedMinutesMin),
  "spaceCount": zod.int().min(getPeakReport200ResponseSummarySpaceCountMin)
}),
  "cells": zod.array(zod.object({
  "weekday": zod.int().min(getPeakReport200ResponseCellsItemWeekdayMin).max(getPeakReport200ResponseCellsItemWeekdayMax).describe('0 = Sunday … 6 = Saturday (UTC)'),
  "hour": zod.int().min(getPeakReport200ResponseCellsItemHourMin).max(getPeakReport200ResponseCellsItemHourMax).describe('Hour of day (UTC)'),
  "bookedMinutes": zod.number().min(getPeakReport200ResponseCellsItemBookedMinutesMin),
  "bookingHits": zod.int().min(getPeakReport200ResponseCellsItemBookingHitsMin)
}))
}))()

export const getPeakReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPeakReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPeakReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getPeakReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getPeakReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPeakReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPeakReport401ResponseOverlapWarningAcknowledgementMin).max(getPeakReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPeakReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getPeakReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPeakReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPeakReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getPeakReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getPeakReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPeakReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPeakReport403ResponseOverlapWarningAcknowledgementMin).max(getPeakReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPeakReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getPeakReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPeakReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPeakReport422ResponseOverlapWarningAcknowledgementMin = 16;
export const getPeakReport422ResponseOverlapWarningAcknowledgementMax = 256;


export const getPeakReport422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPeakReport422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPeakReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPeakReport422ResponseOverlapWarningAcknowledgementMin).max(getPeakReport422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPeakReport422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Lists active spaces whose occupancy percentage in the window is below the threshold (default 25). Includes auto-release and never-checked-in counts. Requires reports:view.
 * @summary Underutilised spaces report
 */
export const getUnderutilisedReportQueryFormatDefault = `json`;
export const getUnderutilisedReportQueryThresholdPctDefault = 25;
export const getUnderutilisedReportQueryThresholdPctMin = 0;
export const getUnderutilisedReportQueryThresholdPctMax = 100;



export const GetUnderutilisedReportQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional(),
  "format": zod.enum(['json', 'csv']).default(getUnderutilisedReportQueryFormatDefault).describe('Response format. csv returns a downloadable attachment of the row data.'),
  "thresholdPct": zod.number().min(getUnderutilisedReportQueryThresholdPctMin).max(getUnderutilisedReportQueryThresholdPctMax).default(getUnderutilisedReportQueryThresholdPctDefault).describe('Occupancy % below which a space is considered underutilised')
}))()

export const getUnderutilisedReportHeaderXGroupGraphTokenMax = 16384;


export const getUnderutilisedReportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUnderutilisedReportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUnderutilisedReportHeaderXGroupGraphTokenMax).regex(getUnderutilisedReportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getUnderutilisedReport200ResponseFiltersThresholdPctMin = 0;
export const getUnderutilisedReport200ResponseFiltersThresholdPctMax = 100;

export const getUnderutilisedReport200ResponseSummarySpaceCountMin = 0;

export const getUnderutilisedReport200ResponseSummaryUnderutilisedCountMin = 0;

export const getUnderutilisedReport200ResponseSummaryAvgOccupancyPctMin = 0;

export const getUnderutilisedReport200ResponseSummaryMissingScheduleSpaceCountMin = 0;


export const getUnderutilisedReport200ResponseItemsItemBookedMinutesMin = 0;

export const getUnderutilisedReport200ResponseItemsItemAvailableMinutesMin = 0;

export const getUnderutilisedReport200ResponseItemsItemOccupancyPctMin = 0;

export const getUnderutilisedReport200ResponseItemsItemRecordedMinutesMin = 0;

export const getUnderutilisedReport200ResponseItemsItemEstimatedMinutesMin = 0;

export const getUnderutilisedReport200ResponseItemsItemBookingCountMin = 0;

export const getUnderutilisedReport200ResponseItemsItemNoShowCountMin = 0;

export const getUnderutilisedReport200ResponseItemsItemNeverCheckedInCountMin = 0;



export const GetUnderutilisedReport200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "filters": zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable(),
  "thresholdPct": zod.number().min(getUnderutilisedReport200ResponseFiltersThresholdPctMin).max(getUnderutilisedReport200ResponseFiltersThresholdPctMax)
}),
  "summary": zod.object({
  "spaceCount": zod.int().min(getUnderutilisedReport200ResponseSummarySpaceCountMin),
  "underutilisedCount": zod.int().min(getUnderutilisedReport200ResponseSummaryUnderutilisedCountMin),
  "thresholdPct": zod.number(),
  "avgOccupancyPct": zod.number().min(getUnderutilisedReport200ResponseSummaryAvgOccupancyPctMin),
  "missingScheduleSpaceCount": zod.int().min(getUnderutilisedReport200ResponseSummaryMissingScheduleSpaceCountMin)
}),
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "spaceCode": zod.string(),
  "spaceName": zod.string(),
  "siteId": zod.uuid(),
  "siteCode": zod.string(),
  "siteName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingCode": zod.string(),
  "buildingName": zod.string(),
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "capacity": zod.int().min(1),
  "bookedMinutes": zod.number().min(getUnderutilisedReport200ResponseItemsItemBookedMinutesMin),
  "availableMinutes": zod.number().min(getUnderutilisedReport200ResponseItemsItemAvailableMinutesMin),
  "occupancyPct": zod.number().min(getUnderutilisedReport200ResponseItemsItemOccupancyPctMin),
  "recordedMinutes": zod.number().min(getUnderutilisedReport200ResponseItemsItemRecordedMinutesMin),
  "estimatedMinutes": zod.number().min(getUnderutilisedReport200ResponseItemsItemEstimatedMinutesMin),
  "bookingCount": zod.int().min(getUnderutilisedReport200ResponseItemsItemBookingCountMin),
  "noShowCount": zod.int().min(getUnderutilisedReport200ResponseItemsItemNoShowCountMin),
  "neverCheckedInCount": zod.int().min(getUnderutilisedReport200ResponseItemsItemNeverCheckedInCountMin)
}))
}))()

export const getUnderutilisedReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUnderutilisedReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUnderutilisedReport401ResponseOverlapWarningAcknowledgementMin = 16;
export const getUnderutilisedReport401ResponseOverlapWarningAcknowledgementMax = 256;


export const getUnderutilisedReport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUnderutilisedReport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUnderutilisedReport401ResponseOverlapWarningAcknowledgementMin).max(getUnderutilisedReport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUnderutilisedReport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUnderutilisedReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUnderutilisedReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUnderutilisedReport403ResponseOverlapWarningAcknowledgementMin = 16;
export const getUnderutilisedReport403ResponseOverlapWarningAcknowledgementMax = 256;


export const getUnderutilisedReport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUnderutilisedReport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUnderutilisedReport403ResponseOverlapWarningAcknowledgementMin).max(getUnderutilisedReport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUnderutilisedReport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUnderutilisedReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUnderutilisedReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUnderutilisedReport422ResponseOverlapWarningAcknowledgementMin = 16;
export const getUnderutilisedReport422ResponseOverlapWarningAcknowledgementMax = 256;


export const getUnderutilisedReport422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUnderutilisedReport422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUnderutilisedReport422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUnderutilisedReport422ResponseOverlapWarningAcknowledgementMin).max(getUnderutilisedReport422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUnderutilisedReport422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List lifecycle audit events (ops)
 */
export const listAuditEventsQueryLimitDefault = 50;
export const listAuditEventsQueryLimitMax = 200;



export const ListAuditEventsQueryParams = /*#__PURE__*/ (() => zod.object({
  "entityType": zod.string().optional(),
  "entityId": zod.uuid().optional(),
  "actorUserId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAuditEventsQueryLimitMax).default(listAuditEventsQueryLimitDefault)
}))()

export const listAuditEventsHeaderXGroupGraphTokenMax = 16384;


export const listAuditEventsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListAuditEventsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listAuditEventsHeaderXGroupGraphTokenMax).regex(listAuditEventsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListAuditEvents200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "at": zod.iso.datetime({"offset":true}),
  "actorUserId": zod.uuid().nullish(),
  "actorName": zod.string().nullish(),
  "action": zod.string(),
  "entityType": zod.string(),
  "entityId": zod.uuid(),
  "summary": zod.string(),
  "before": zod.record(zod.string(), zod.unknown()).nullish(),
  "after": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestId": zod.string().nullish(),
  "correlationId": zod.uuid().nullish()
})),
  "total": zod.int()
}))()

export const listAuditEvents403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAuditEvents403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAuditEvents403ResponseOverlapWarningAcknowledgementMin = 16;
export const listAuditEvents403ResponseOverlapWarningAcknowledgementMax = 256;


export const listAuditEvents403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAuditEvents403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAuditEvents403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAuditEvents403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAuditEvents403ResponseOverlapWarningAcknowledgementMin).max(listAuditEvents403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAuditEvents403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Run no-show auto-release (ops / scheduler)
 */
export const runAutoReleaseJob200ResponseReleasedMin = 0;



export const RunAutoReleaseJob200Response = /*#__PURE__*/ (() => zod.object({
  "released": zod.int().min(runAutoReleaseJob200ResponseReleasedMin),
  "bookingIds": zod.array(zod.uuid())
}))()

export const runAutoReleaseJob403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const runAutoReleaseJob403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const runAutoReleaseJob403ResponseOverlapWarningAcknowledgementMin = 16;
export const runAutoReleaseJob403ResponseOverlapWarningAcknowledgementMax = 256;


export const runAutoReleaseJob403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RunAutoReleaseJob403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(runAutoReleaseJob403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(runAutoReleaseJob403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(runAutoReleaseJob403ResponseOverlapWarningAcknowledgementMin).max(runAutoReleaseJob403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(runAutoReleaseJob403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * App booking legs are created in one transaction. After commit, room calendar reconciliation may cancel individual legs that Exchange rejects; inspect each returned booking status before presenting the result. Use for multi-resource confirmations (FR-EU-011).
 * @summary Create a multi-space itinerary in one transaction
 */
export const createItineraryHeaderXGroupGraphTokenMax = 16384;


export const createItineraryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateItineraryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createItineraryHeaderXGroupGraphTokenMax).regex(createItineraryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createItineraryBodyOverlapAcknowledgementMin = 16;
export const createItineraryBodyOverlapAcknowledgementMax = 256;

export const createItineraryBodyLabelMax = 200;

export const createItineraryBodyClientRequestIdMax = 100;

export const createItineraryBodyLegsItemTitleMax = 200;

export const createItineraryBodyLegsItemVehicleOnePlateMax = 32;

export const createItineraryBodyLegsItemVehicleOnePermitIdMax = 100;

export const createItineraryBodyLegsItemVehicleOneSizeClassMax = 40;

export const createItineraryBodyLegsItemVehicleOneLabelMax = 100;

export const createItineraryBodyLegsMax = 20;



export const CreateItineraryBody = /*#__PURE__*/ (() => zod.object({
  "overlapAcknowledgement": zod.string().min(createItineraryBodyOverlapAcknowledgementMin).max(createItineraryBodyOverlapAcknowledgementMax).optional(),
  "label": zod.string().max(createItineraryBodyLabelMax).nullish(),
  "dayDate": zod.iso.date().nullish(),
  "clientRequestId": zod.string().max(createItineraryBodyClientRequestIdMax).nullish(),
  "source": zod.enum(['ui', 'ai', 'import']).optional(),
  "legs": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "title": zod.string().max(createItineraryBodyLegsItemTitleMax).nullish(),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().optional(),
  "plate": zod.string().min(1).max(createItineraryBodyLegsItemVehicleOnePlateMax).optional(),
  "permitId": zod.string().max(createItineraryBodyLegsItemVehicleOnePermitIdMax).nullish(),
  "sizeClass": zod.string().max(createItineraryBodyLegsItemVehicleOneSizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(createItineraryBodyLegsItemVehicleOneLabelMax).nullish()
}),zod.null()]).optional()
})).min(1).max(createItineraryBodyLegsMax)
}))()





export const CreateItinerary201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "ownerUserId": zod.uuid(),
  "label": zod.string().nullish(),
  "dayDate": zod.iso.date().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "bookings": zod.array(zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}))
}))()

export const createItinerary409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createItinerary409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createItinerary409ResponseOverlapWarningAcknowledgementMin = 16;
export const createItinerary409ResponseOverlapWarningAcknowledgementMax = 256;


export const createItinerary409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateItinerary409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createItinerary409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createItinerary409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createItinerary409ResponseOverlapWarningAcknowledgementMin).max(createItinerary409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createItinerary409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createItinerary422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createItinerary422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createItinerary422ResponseOverlapWarningAcknowledgementMin = 16;
export const createItinerary422ResponseOverlapWarningAcknowledgementMax = 256;


export const createItinerary422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateItinerary422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createItinerary422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createItinerary422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createItinerary422ResponseOverlapWarningAcknowledgementMin).max(createItinerary422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createItinerary422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List vehicles for the signed-in user
 */
export const listVehiclesHeaderXGroupGraphTokenMax = 16384;


export const listVehiclesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListVehiclesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listVehiclesHeaderXGroupGraphTokenMax).regex(listVehiclesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listVehicles200ResponseTotalMin = 0;



export const ListVehicles200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish(),
  "isEv": zod.boolean(),
  "label": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listVehicles200ResponseTotalMin)
}))()

export const listVehicles401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listVehicles401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listVehicles401ResponseOverlapWarningAcknowledgementMin = 16;
export const listVehicles401ResponseOverlapWarningAcknowledgementMax = 256;


export const listVehicles401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListVehicles401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVehicles401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVehicles401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listVehicles401ResponseOverlapWarningAcknowledgementMin).max(listVehicles401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listVehicles401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Register a vehicle/permit for parking bookings
 */
export const createVehicleHeaderXGroupGraphTokenMax = 16384;


export const createVehicleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateVehicleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createVehicleHeaderXGroupGraphTokenMax).regex(createVehicleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createVehicleBodyPlateMax = 32;

export const createVehicleBodyPermitIdMax = 100;

export const createVehicleBodySizeClassMax = 40;

export const createVehicleBodyLabelMax = 100;



export const CreateVehicleBody = /*#__PURE__*/ (() => zod.object({
  "plate": zod.string().min(1).max(createVehicleBodyPlateMax),
  "permitId": zod.string().max(createVehicleBodyPermitIdMax).nullish(),
  "sizeClass": zod.string().max(createVehicleBodySizeClassMax).nullish(),
  "isEv": zod.boolean().optional(),
  "label": zod.string().max(createVehicleBodyLabelMax).nullish()
}))()

export const CreateVehicle201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish(),
  "isEv": zod.boolean(),
  "label": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const createVehicle400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createVehicle400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createVehicle400ResponseOverlapWarningAcknowledgementMin = 16;
export const createVehicle400ResponseOverlapWarningAcknowledgementMax = 256;


export const createVehicle400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateVehicle400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVehicle400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVehicle400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createVehicle400ResponseOverlapWarningAcknowledgementMin).max(createVehicle400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createVehicle400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Materialises recurring weekly defaults into concrete days for the
 * requested window. Explicit day entries override defaults.
 * @summary Get the signed-in user's work plan for a date window
 */
export const GetMyPresencePlanQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date().describe('Inclusive start date (YYYY-MM-DD)'),
  "to": zod.iso.date().describe('Inclusive end date (YYYY-MM-DD)')
}))()

export const getMyPresencePlanHeaderXGroupGraphTokenMax = 16384;


export const getMyPresencePlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyPresencePlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyPresencePlanHeaderXGroupGraphTokenMax).regex(getMyPresencePlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyPresencePlan200ResponseDaysItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getMyPresencePlan200ResponseDaysItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getMyPresencePlan200ResponseDefaultsItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getMyPresencePlan200ResponseDefaultsItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getMyPresencePlan200ResponseDefaultsItemWeekdayMin = 0;
export const getMyPresencePlan200ResponseDefaultsItemWeekdayMax = 6;

export const getMyPresencePlan200ResponseSettingsPrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getMyPresencePlan200ResponseSettingsSelectedColleagueIdsMax = 50;

export const getMyPresencePlan200ResponseSettingsSelectedColleaguesMax = 50;



export const GetMyPresencePlan200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "days": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "officeStartTime": zod.string().regex(getMyPresencePlan200ResponseDaysItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(getMyPresencePlan200ResponseDaysItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "officeHoursSource": zod.union([zod.literal('dated'),zod.literal('recurring'),zod.literal('timed'),zod.literal('ambiguous'),zod.literal(null)]).nullish().describe('Ambiguous timed days have no usable single-office window and must not receive default hours or an inferred office.'),
  "officeStartAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact original start for an unambiguous timed stop, preserving timestamp precision.'),
  "officeEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "source": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable()
})),
  "defaults": zod.array(zod.object({
  "officeStartTime": zod.string().regex(getMyPresencePlan200ResponseDefaultsItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(getMyPresencePlan200ResponseDefaultsItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "weekday": zod.int().min(getMyPresencePlan200ResponseDefaultsItemWeekdayMin).max(getMyPresencePlan200ResponseDefaultsItemWeekdayMax).describe('0 = Sunday … 6 = Saturday'),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable()
})),
  "settings": zod.object({
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(getMyPresencePlan200ResponseSettingsPrivacyRevisionRegExp)
}).optional(),
  "personalSettingsEditable": zod.boolean().optional().describe('False in forced modes; personal updates return 409 and preserve stored choices.'),
  "sharingLevel": zod.enum(['everyone', 'workgroups', 'selected', 'private']),
  "selectedColleagueIds": zod.array(zod.uuid()).max(getMyPresencePlan200ResponseSettingsSelectedColleagueIdsMax),
  "selectedColleagues": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string()
})).max(getMyPresencePlan200ResponseSettingsSelectedColleaguesMax),
  "shareDeskLocation": zod.boolean(),
  "shareTeamsAvailability": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Personal values are dormant preferences in forced modes. Effective policy is privacy; Teams uses effective desk identity, never the legacy shareTeamsAvailability flag.')
}))()

export const getMyPresencePlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyPresencePlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyPresencePlan401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyPresencePlan401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyPresencePlan401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyPresencePlan401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyPresencePlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyPresencePlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyPresencePlan401ResponseOverlapWarningAcknowledgementMin).max(getMyPresencePlan401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyPresencePlan401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Upsert explicit presence days for the signed-in user
 */
export const upsertMyPresencePlanHeaderXGroupGraphTokenMax = 16384;


export const upsertMyPresencePlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpsertMyPresencePlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(upsertMyPresencePlanHeaderXGroupGraphTokenMax).regex(upsertMyPresencePlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const upsertMyPresencePlanBodyEntriesItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const upsertMyPresencePlanBodyEntriesItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const upsertMyPresencePlanBodyEntriesMax = 90;



export const UpsertMyPresencePlanBody = /*#__PURE__*/ (() => zod.object({
  "entries": zod.array(zod.object({
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullish(),
  "officeStartTime": zod.string().regex(upsertMyPresencePlanBodyEntriesItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(upsertMyPresencePlanBodyEntriesItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.')
})).min(1).max(upsertMyPresencePlanBodyEntriesMax)
}))()

export const upsertMyPresencePlan200ResponseDaysItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const upsertMyPresencePlan200ResponseDaysItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');


export const UpsertMyPresencePlan200Response = /*#__PURE__*/ (() => zod.object({
  "days": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "officeStartTime": zod.string().regex(upsertMyPresencePlan200ResponseDaysItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(upsertMyPresencePlan200ResponseDaysItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "officeHoursSource": zod.union([zod.literal('dated'),zod.literal('recurring'),zod.literal('timed'),zod.literal('ambiguous'),zod.literal(null)]).nullish().describe('Ambiguous timed days have no usable single-office window and must not receive default hours or an inferred office.'),
  "officeStartAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact original start for an unambiguous timed stop, preserving timestamp precision.'),
  "officeEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "source": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable()
}))
}))()

export const upsertMyPresencePlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertMyPresencePlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertMyPresencePlan400ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertMyPresencePlan400ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertMyPresencePlan400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertMyPresencePlan400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertMyPresencePlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertMyPresencePlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertMyPresencePlan400ResponseOverlapWarningAcknowledgementMin).max(upsertMyPresencePlan400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertMyPresencePlan400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const upsertMyPresencePlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertMyPresencePlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertMyPresencePlan401ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertMyPresencePlan401ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertMyPresencePlan401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertMyPresencePlan401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertMyPresencePlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertMyPresencePlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertMyPresencePlan401ResponseOverlapWarningAcknowledgementMin).max(upsertMyPresencePlan401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertMyPresencePlan401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Replace the signed-in user's recurring weekly presence pattern
 */
export const setMyPresenceDefaultsHeaderXGroupGraphTokenMax = 16384;


export const setMyPresenceDefaultsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetMyPresenceDefaultsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setMyPresenceDefaultsHeaderXGroupGraphTokenMax).regex(setMyPresenceDefaultsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setMyPresenceDefaultsBodyDefaultsItemWeekdayMin = 0;
export const setMyPresenceDefaultsBodyDefaultsItemWeekdayMax = 6;

export const setMyPresenceDefaultsBodyDefaultsItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const setMyPresenceDefaultsBodyDefaultsItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const setMyPresenceDefaultsBodyDefaultsMax = 7;



export const SetMyPresenceDefaultsBody = /*#__PURE__*/ (() => zod.object({
  "defaults": zod.array(zod.object({
  "weekday": zod.int().min(setMyPresenceDefaultsBodyDefaultsItemWeekdayMin).max(setMyPresenceDefaultsBodyDefaultsItemWeekdayMax),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullish(),
  "officeStartTime": zod.string().regex(setMyPresenceDefaultsBodyDefaultsItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(setMyPresenceDefaultsBodyDefaultsItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.')
})).max(setMyPresenceDefaultsBodyDefaultsMax)
}))()

export const setMyPresenceDefaults200ResponseDefaultsItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const setMyPresenceDefaults200ResponseDefaultsItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const setMyPresenceDefaults200ResponseDefaultsItemWeekdayMin = 0;
export const setMyPresenceDefaults200ResponseDefaultsItemWeekdayMax = 6;



export const SetMyPresenceDefaults200Response = /*#__PURE__*/ (() => zod.object({
  "defaults": zod.array(zod.object({
  "officeStartTime": zod.string().regex(setMyPresenceDefaults200ResponseDefaultsItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(setMyPresenceDefaults200ResponseDefaultsItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "weekday": zod.int().min(setMyPresenceDefaults200ResponseDefaultsItemWeekdayMin).max(setMyPresenceDefaults200ResponseDefaultsItemWeekdayMax).describe('0 = Sunday … 6 = Saturday'),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable()
}))
}))()

export const setMyPresenceDefaults400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setMyPresenceDefaults400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setMyPresenceDefaults400ResponseOverlapWarningAcknowledgementMin = 16;
export const setMyPresenceDefaults400ResponseOverlapWarningAcknowledgementMax = 256;


export const setMyPresenceDefaults400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetMyPresenceDefaults400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceDefaults400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceDefaults400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setMyPresenceDefaults400ResponseOverlapWarningAcknowledgementMin).max(setMyPresenceDefaults400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setMyPresenceDefaults400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const setMyPresenceDefaults401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setMyPresenceDefaults401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setMyPresenceDefaults401ResponseOverlapWarningAcknowledgementMin = 16;
export const setMyPresenceDefaults401ResponseOverlapWarningAcknowledgementMax = 256;


export const setMyPresenceDefaults401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetMyPresenceDefaults401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceDefaults401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceDefaults401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setMyPresenceDefaults401ResponseOverlapWarningAcknowledgementMin).max(setMyPresenceDefaults401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setMyPresenceDefaults401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get the signed-in user's presence privacy settings
 */
export const getMyPresenceSettingsHeaderXGroupGraphTokenMax = 16384;


export const getMyPresenceSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyPresenceSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyPresenceSettingsHeaderXGroupGraphTokenMax).regex(getMyPresenceSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyPresenceSettings200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getMyPresenceSettings200ResponseSelectedColleagueIdsMax = 50;

export const getMyPresenceSettings200ResponseSelectedColleaguesMax = 50;



export const GetMyPresenceSettings200Response = /*#__PURE__*/ (() => zod.object({
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(getMyPresenceSettings200ResponsePrivacyRevisionRegExp)
}).optional(),
  "personalSettingsEditable": zod.boolean().optional().describe('False in forced modes; personal updates return 409 and preserve stored choices.'),
  "sharingLevel": zod.enum(['everyone', 'workgroups', 'selected', 'private']),
  "selectedColleagueIds": zod.array(zod.uuid()).max(getMyPresenceSettings200ResponseSelectedColleagueIdsMax),
  "selectedColleagues": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string()
})).max(getMyPresenceSettings200ResponseSelectedColleaguesMax),
  "shareDeskLocation": zod.boolean(),
  "shareTeamsAvailability": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Personal values are dormant preferences in forced modes. Effective policy is privacy; Teams uses effective desk identity, never the legacy shareTeamsAvailability flag.'))()

export const getMyPresenceSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyPresenceSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyPresenceSettings401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyPresenceSettings401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyPresenceSettings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyPresenceSettings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyPresenceSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyPresenceSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyPresenceSettings401ResponseOverlapWarningAcknowledgementMin).max(getMyPresenceSettings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyPresenceSettings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update the signed-in user's presence privacy settings
 */
export const setMyPresenceSettingsHeaderXGroupGraphTokenMax = 16384;


export const setMyPresenceSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetMyPresenceSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setMyPresenceSettingsHeaderXGroupGraphTokenMax).regex(setMyPresenceSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setMyPresenceSettingsBodySelectedColleagueIdsMax = 50;



export const SetMyPresenceSettingsBody = /*#__PURE__*/ (() => zod.object({
  "sharingLevel": zod.enum(['everyone', 'workgroups', 'selected', 'private']),
  "selectedColleagueIds": zod.array(zod.uuid()).max(setMyPresenceSettingsBodySelectedColleagueIdsMax).optional(),
  "shareDeskLocation": zod.boolean().optional(),
  "shareTeamsAvailability": zod.boolean().optional()
}).describe('Forced entity modes reject personal changes with 409 without changing dormant choices. Legacy shareTeamsAvailability is ignored; effective Teams disclosure follows desk identity.'))()

export const setMyPresenceSettings200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const setMyPresenceSettings200ResponseSelectedColleagueIdsMax = 50;

export const setMyPresenceSettings200ResponseSelectedColleaguesMax = 50;



export const SetMyPresenceSettings200Response = /*#__PURE__*/ (() => zod.object({
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(setMyPresenceSettings200ResponsePrivacyRevisionRegExp)
}).optional(),
  "personalSettingsEditable": zod.boolean().optional().describe('False in forced modes; personal updates return 409 and preserve stored choices.'),
  "sharingLevel": zod.enum(['everyone', 'workgroups', 'selected', 'private']),
  "selectedColleagueIds": zod.array(zod.uuid()).max(setMyPresenceSettings200ResponseSelectedColleagueIdsMax),
  "selectedColleagues": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string()
})).max(setMyPresenceSettings200ResponseSelectedColleaguesMax),
  "shareDeskLocation": zod.boolean(),
  "shareTeamsAvailability": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Personal values are dormant preferences in forced modes. Effective policy is privacy; Teams uses effective desk identity, never the legacy shareTeamsAvailability flag.'))()

export const setMyPresenceSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setMyPresenceSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setMyPresenceSettings400ResponseOverlapWarningAcknowledgementMin = 16;
export const setMyPresenceSettings400ResponseOverlapWarningAcknowledgementMax = 256;


export const setMyPresenceSettings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetMyPresenceSettings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceSettings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceSettings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setMyPresenceSettings400ResponseOverlapWarningAcknowledgementMin).max(setMyPresenceSettings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setMyPresenceSettings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const setMyPresenceSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setMyPresenceSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setMyPresenceSettings401ResponseOverlapWarningAcknowledgementMin = 16;
export const setMyPresenceSettings401ResponseOverlapWarningAcknowledgementMax = 256;


export const setMyPresenceSettings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetMyPresenceSettings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceSettings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setMyPresenceSettings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setMyPresenceSettings401ResponseOverlapWarningAcknowledgementMin).max(setMyPresenceSettings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setMyPresenceSettings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List my private timed plans in a bounded date window
 */
export const ListMyTimedPlansQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date()
}))()

export const listMyTimedPlansHeaderXGroupGraphTokenMax = 16384;


export const listMyTimedPlansHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyTimedPlansHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyTimedPlansHeaderXGroupGraphTokenMax).regex(listMyTimedPlansHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listMyTimedPlans200ResponseItemsItemStopsItemPositionMin = 0;

export const listMyTimedPlans200ResponseItemsItemStopsItemRequirementsTypeCodeMax = 64;

export const listMyTimedPlans200ResponseItemsItemStopsItemRequirementsAmenityIdsMax = 20;

export const listMyTimedPlans200ResponseItemsItemStopsItemRequirementsMinCapacityMax = 1000;



export const ListMyTimedPlans200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "date": zod.iso.date(),
  "timezone": zod.string(),
  "revision": zod.int(),
  "stops": zod.array(zod.object({
  "id": zod.uuid(),
  "position": zod.int().min(listMyTimedPlans200ResponseItemsItemStopsItemPositionMin),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullable(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "requirements": zod.object({
  "typeCode": zod.string().max(listMyTimedPlans200ResponseItemsItemStopsItemRequirementsTypeCodeMax).nullable(),
  "amenityIds": zod.array(zod.uuid()).max(listMyTimedPlans200ResponseItemsItemStopsItemRequirementsAmenityIdsMax),
  "minCapacity": zod.int().min(1).max(listMyTimedPlans200ResponseItemsItemStopsItemRequirementsMinCapacityMax).nullable()
}),
  "bookingLinks": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid()
}))
})),
  "adjustments": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevision": zod.int(),
  "stopId": zod.uuid().nullable(),
  "originalBookingId": zod.uuid(),
  "replacementBookingId": zod.uuid().nullable(),
  "action": zod.enum(['replace', 'cancel']),
  "state": zod.enum(['pending', 'awaiting_calendar', 'succeeded', 'unresolved']),
  "reason": zod.string().nullable(),
  "attempts": zod.int(),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))()

export const listMyTimedPlans400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyTimedPlans400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyTimedPlans400ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyTimedPlans400ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyTimedPlans400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyTimedPlans400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyTimedPlans400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyTimedPlans400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyTimedPlans400ResponseOverlapWarningAcknowledgementMin).max(listMyTimedPlans400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyTimedPlans400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read my private timed plan for a local date
 */
export const GetMyTimedPlanParams = /*#__PURE__*/ (() => zod.object({
  "date": zod.iso.date()
}))()

export const getMyTimedPlanHeaderXGroupGraphTokenMax = 16384;


export const getMyTimedPlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyTimedPlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyTimedPlanHeaderXGroupGraphTokenMax).regex(getMyTimedPlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyTimedPlan200ResponseStopsItemPositionMin = 0;

export const getMyTimedPlan200ResponseStopsItemRequirementsTypeCodeMax = 64;

export const getMyTimedPlan200ResponseStopsItemRequirementsAmenityIdsMax = 20;

export const getMyTimedPlan200ResponseStopsItemRequirementsMinCapacityMax = 1000;



export const GetMyTimedPlan200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "date": zod.iso.date(),
  "timezone": zod.string(),
  "revision": zod.int(),
  "stops": zod.array(zod.object({
  "id": zod.uuid(),
  "position": zod.int().min(getMyTimedPlan200ResponseStopsItemPositionMin),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullable(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "requirements": zod.object({
  "typeCode": zod.string().max(getMyTimedPlan200ResponseStopsItemRequirementsTypeCodeMax).nullable(),
  "amenityIds": zod.array(zod.uuid()).max(getMyTimedPlan200ResponseStopsItemRequirementsAmenityIdsMax),
  "minCapacity": zod.int().min(1).max(getMyTimedPlan200ResponseStopsItemRequirementsMinCapacityMax).nullable()
}),
  "bookingLinks": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid()
}))
})),
  "adjustments": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevision": zod.int(),
  "stopId": zod.uuid().nullable(),
  "originalBookingId": zod.uuid(),
  "replacementBookingId": zod.uuid().nullable(),
  "action": zod.enum(['replace', 'cancel']),
  "state": zod.enum(['pending', 'awaiting_calendar', 'succeeded', 'unresolved']),
  "reason": zod.string().nullable(),
  "attempts": zod.int(),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getMyTimedPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyTimedPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyTimedPlan404ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyTimedPlan404ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyTimedPlan404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyTimedPlan404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyTimedPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyTimedPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyTimedPlan404ResponseOverlapWarningAcknowledgementMin).max(getMyTimedPlan404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyTimedPlan404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * expectedRevision is 0 on creation. This foundation save records intent only; booking reconciliation is added separately.
 * @summary Save timed stops with optimistic revision and explicit personal booking links
 */
export const SaveMyTimedPlanParams = /*#__PURE__*/ (() => zod.object({
  "date": zod.iso.date()
}))()

export const saveMyTimedPlanHeaderXGroupGraphTokenMax = 16384;


export const saveMyTimedPlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveMyTimedPlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveMyTimedPlanHeaderXGroupGraphTokenMax).regex(saveMyTimedPlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveMyTimedPlanBodyExpectedRevisionMin = 0;

export const saveMyTimedPlanBodyTimezoneMax = 100;

export const saveMyTimedPlanBodyStopsItemRequirementsTypeCodeMax = 64;

export const saveMyTimedPlanBodyStopsItemRequirementsAmenityIdsMax = 20;

export const saveMyTimedPlanBodyStopsItemRequirementsMinCapacityMax = 1000;

export const saveMyTimedPlanBodyStopsItemBookingIdsMax = 10;

export const saveMyTimedPlanBodyStopsMax = 24;



export const SaveMyTimedPlanBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(saveMyTimedPlanBodyExpectedRevisionMin),
  "timezone": zod.string().max(saveMyTimedPlanBodyTimezoneMax),
  "stops": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullish(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "requirements": zod.object({
  "typeCode": zod.string().max(saveMyTimedPlanBodyStopsItemRequirementsTypeCodeMax).nullable(),
  "amenityIds": zod.array(zod.uuid()).max(saveMyTimedPlanBodyStopsItemRequirementsAmenityIdsMax),
  "minCapacity": zod.int().min(1).max(saveMyTimedPlanBodyStopsItemRequirementsMinCapacityMax).nullable()
}),
  "bookingIds": zod.array(zod.uuid()).max(saveMyTimedPlanBodyStopsItemBookingIdsMax)
})).max(saveMyTimedPlanBodyStopsMax)
}))()

export const saveMyTimedPlan200ResponseStopsItemPositionMin = 0;

export const saveMyTimedPlan200ResponseStopsItemRequirementsTypeCodeMax = 64;

export const saveMyTimedPlan200ResponseStopsItemRequirementsAmenityIdsMax = 20;

export const saveMyTimedPlan200ResponseStopsItemRequirementsMinCapacityMax = 1000;



export const SaveMyTimedPlan200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "date": zod.iso.date(),
  "timezone": zod.string(),
  "revision": zod.int(),
  "stops": zod.array(zod.object({
  "id": zod.uuid(),
  "position": zod.int().min(saveMyTimedPlan200ResponseStopsItemPositionMin),
  "siteId": zod.uuid(),
  "buildingId": zod.uuid().nullable(),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "requirements": zod.object({
  "typeCode": zod.string().max(saveMyTimedPlan200ResponseStopsItemRequirementsTypeCodeMax).nullable(),
  "amenityIds": zod.array(zod.uuid()).max(saveMyTimedPlan200ResponseStopsItemRequirementsAmenityIdsMax),
  "minCapacity": zod.int().min(1).max(saveMyTimedPlan200ResponseStopsItemRequirementsMinCapacityMax).nullable()
}),
  "bookingLinks": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid()
}))
})),
  "adjustments": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevision": zod.int(),
  "stopId": zod.uuid().nullable(),
  "originalBookingId": zod.uuid(),
  "replacementBookingId": zod.uuid().nullable(),
  "action": zod.enum(['replace', 'cancel']),
  "state": zod.enum(['pending', 'awaiting_calendar', 'succeeded', 'unresolved']),
  "reason": zod.string().nullable(),
  "attempts": zod.int(),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const saveMyTimedPlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveMyTimedPlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveMyTimedPlan400ResponseOverlapWarningAcknowledgementMin = 16;
export const saveMyTimedPlan400ResponseOverlapWarningAcknowledgementMax = 256;


export const saveMyTimedPlan400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveMyTimedPlan400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveMyTimedPlan400ResponseOverlapWarningAcknowledgementMin).max(saveMyTimedPlan400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveMyTimedPlan400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveMyTimedPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveMyTimedPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveMyTimedPlan404ResponseOverlapWarningAcknowledgementMin = 16;
export const saveMyTimedPlan404ResponseOverlapWarningAcknowledgementMax = 256;


export const saveMyTimedPlan404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveMyTimedPlan404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveMyTimedPlan404ResponseOverlapWarningAcknowledgementMin).max(saveMyTimedPlan404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveMyTimedPlan404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const saveMyTimedPlan409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const saveMyTimedPlan409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const saveMyTimedPlan409ResponseOverlapWarningAcknowledgementMin = 16;
export const saveMyTimedPlan409ResponseOverlapWarningAcknowledgementMax = 256;


export const saveMyTimedPlan409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SaveMyTimedPlan409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(saveMyTimedPlan409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(saveMyTimedPlan409ResponseOverlapWarningAcknowledgementMin).max(saveMyTimedPlan409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(saveMyTimedPlan409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read only my most recent personal location context
 */
export const getMyLocationContextHeaderXGroupGraphTokenMax = 16384;


export const getMyLocationContextHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyLocationContextHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyLocationContextHeaderXGroupGraphTokenMax).regex(getMyLocationContextHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyLocationContext200ResponseContextOneLatitudeMin = -90;
export const getMyLocationContext200ResponseContextOneLatitudeMax = 90;

export const getMyLocationContext200ResponseContextOneLongitudeMin = -180;
export const getMyLocationContext200ResponseContextOneLongitudeMax = 180;

export const getMyLocationContext200ResponseContextOneAccuracyMetersMin = 0;



export const GetMyLocationContext200Response = /*#__PURE__*/ (() => zod.object({
  "context": zod.union([zod.object({
  "source": zod.enum(['manual', 'device']),
  "label": zod.string().nullable(),
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "latitude": zod.number().min(getMyLocationContext200ResponseContextOneLatitudeMin).max(getMyLocationContext200ResponseContextOneLatitudeMax).nullable(),
  "longitude": zod.number().min(getMyLocationContext200ResponseContextOneLongitudeMin).max(getMyLocationContext200ResponseContextOneLongitudeMax).nullable(),
  "accuracyMeters": zod.number().min(getMyLocationContext200ResponseContextOneAccuracyMetersMin).nullable(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}))()


/**
 * Overwrites the prior context; never changes a plan, booking or shared presence.
 * @summary Set a manually chosen or explicitly requested device location
 */
export const putMyLocationContextHeaderXGroupGraphTokenMax = 16384;


export const putMyLocationContextHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutMyLocationContextHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putMyLocationContextHeaderXGroupGraphTokenMax).regex(putMyLocationContextHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putMyLocationContextBodyLabelMax = 160;

export const putMyLocationContextBodyLatitudeMin = -90;
export const putMyLocationContextBodyLatitudeMax = 90;

export const putMyLocationContextBodyLongitudeMin = -180;
export const putMyLocationContextBodyLongitudeMax = 180;

export const putMyLocationContextBodyAccuracyMetersMin = 0;



export const PutMyLocationContextBody = /*#__PURE__*/ (() => zod.object({
  "source": zod.enum(['manual', 'device']),
  "label": zod.string().max(putMyLocationContextBodyLabelMax).nullish(),
  "siteId": zod.uuid().nullish(),
  "buildingId": zod.uuid().nullish(),
  "latitude": zod.number().min(putMyLocationContextBodyLatitudeMin).max(putMyLocationContextBodyLatitudeMax).nullish(),
  "longitude": zod.number().min(putMyLocationContextBodyLongitudeMin).max(putMyLocationContextBodyLongitudeMax).nullish(),
  "accuracyMeters": zod.number().min(putMyLocationContextBodyAccuracyMetersMin).nullish(),
  "observedAt": zod.iso.datetime({"offset":true})
}))()

export const putMyLocationContext200ResponseContextOneLatitudeMin = -90;
export const putMyLocationContext200ResponseContextOneLatitudeMax = 90;

export const putMyLocationContext200ResponseContextOneLongitudeMin = -180;
export const putMyLocationContext200ResponseContextOneLongitudeMax = 180;

export const putMyLocationContext200ResponseContextOneAccuracyMetersMin = 0;



export const PutMyLocationContext200Response = /*#__PURE__*/ (() => zod.object({
  "context": zod.union([zod.object({
  "source": zod.enum(['manual', 'device']),
  "label": zod.string().nullable(),
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "latitude": zod.number().min(putMyLocationContext200ResponseContextOneLatitudeMin).max(putMyLocationContext200ResponseContextOneLatitudeMax).nullable(),
  "longitude": zod.number().min(putMyLocationContext200ResponseContextOneLongitudeMin).max(putMyLocationContext200ResponseContextOneLongitudeMax).nullable(),
  "accuracyMeters": zod.number().min(putMyLocationContext200ResponseContextOneAccuracyMetersMin).nullable(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}))()

export const putMyLocationContext400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyLocationContext400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyLocationContext400ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyLocationContext400ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyLocationContext400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyLocationContext400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyLocationContext400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyLocationContext400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyLocationContext400ResponseOverlapWarningAcknowledgementMin).max(putMyLocationContext400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyLocationContext400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Forget my most recent location
 */
export const forgetMyLocationContextHeaderXGroupGraphTokenMax = 16384;


export const forgetMyLocationContextHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ForgetMyLocationContextHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(forgetMyLocationContextHeaderXGroupGraphTokenMax).regex(forgetMyLocationContextHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ForgetMyLocationContext204Response = /*#__PURE__*/ (() => zod.void())()


/**
 * @summary List my approved, pending and dismissed location needs
 */
export const ListMyLocationNeedsQueryParams = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().optional()
}))()

export const listMyLocationNeedsHeaderXGroupGraphTokenMax = 16384;


export const listMyLocationNeedsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyLocationNeedsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyLocationNeedsHeaderXGroupGraphTokenMax).regex(listMyLocationNeedsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListMyLocationNeeds200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))()


/**
 * @summary Record a manually approved need for one Commons site
 */
export const createMyLocationNeedHeaderXGroupGraphTokenMax = 16384;


export const createMyLocationNeedHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateMyLocationNeedHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createMyLocationNeedHeaderXGroupGraphTokenMax).regex(createMyLocationNeedHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createMyLocationNeedBodyFeatureCodeMax = 64;



export const CreateMyLocationNeedBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string().min(1).max(createMyLocationNeedBodyFeatureCodeMax),
  "strength": zod.enum(['required', 'preferred'])
}))()

export const CreateMyLocationNeed201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const createMyLocationNeed400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createMyLocationNeed400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createMyLocationNeed400ResponseOverlapWarningAcknowledgementMin = 16;
export const createMyLocationNeed400ResponseOverlapWarningAcknowledgementMax = 256;


export const createMyLocationNeed400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateMyLocationNeed400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createMyLocationNeed400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createMyLocationNeed400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createMyLocationNeed400ResponseOverlapWarningAcknowledgementMin).max(createMyLocationNeed400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createMyLocationNeed400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Propose private location preferences from my booking history
 */
export const suggestMyLocationNeedsHeaderXGroupGraphTokenMax = 16384;


export const suggestMyLocationNeedsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SuggestMyLocationNeedsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(suggestMyLocationNeedsHeaderXGroupGraphTokenMax).regex(suggestMyLocationNeedsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const SuggestMyLocationNeedsBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid()
}))()

export const SuggestMyLocationNeeds200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))()


/**
 * @summary Approve or dismiss several private suggestions together
 */
export const decideMyLocationNeedsHeaderXGroupGraphTokenMax = 16384;


export const decideMyLocationNeedsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DecideMyLocationNeedsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(decideMyLocationNeedsHeaderXGroupGraphTokenMax).regex(decideMyLocationNeedsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const decideMyLocationNeedsBodyItemsMax = 20;



export const DecideMyLocationNeedsBody = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "decision": zod.enum(['approved', 'dismissed']),
  "strength": zod.enum(['required', 'preferred'])
})).min(1).max(decideMyLocationNeedsBodyItemsMax)
}))()

export const DecideMyLocationNeeds200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))()


/**
 * @summary Currently eligible resources for my saved stop, ranked by approved preferences
 */
export const GetMyStopRecommendationsParams = /*#__PURE__*/ (() => zod.object({
  "date": zod.iso.date(),
  "stopId": zod.uuid()
}))()

export const getMyStopRecommendationsHeaderXGroupGraphTokenMax = 16384;


export const getMyStopRecommendationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyStopRecommendationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyStopRecommendationsHeaderXGroupGraphTokenMax).regex(getMyStopRecommendationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneMax = 12;

export const getMyStopRecommendations200ResponseTotalEligibleMin = 0;



export const GetMyStopRecommendations200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneMin).max(getMyStopRecommendations200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "score": zod.number(),
  "reasons": zod.array(zod.string()),
  "availabilitySource": zod.enum(['app', 'app_fallback', 'exchange'])
})),
  "totalEligible": zod.int().min(getMyStopRecommendations200ResponseTotalEligibleMin),
  "truncated": zod.boolean().describe('More inventory exists beyond the bounded eligibility scan'),
  "requiredNeeds": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "preferredNeeds": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "explanation": zod.string()
}))()


/**
 * @summary Approve, edit or dismiss my own location need
 */
export const UpdateMyLocationNeedParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateMyLocationNeedHeaderXGroupGraphTokenMax = 16384;


export const updateMyLocationNeedHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateMyLocationNeedHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateMyLocationNeedHeaderXGroupGraphTokenMax).regex(updateMyLocationNeedHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const UpdateMyLocationNeedBody = /*#__PURE__*/ (() => zod.object({
  "decision": zod.enum(['approved', 'dismissed']),
  "strength": zod.enum(['required', 'preferred'])
}))()

export const UpdateMyLocationNeed200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "siteId": zod.uuid(),
  "featureKind": zod.enum(['space_type', 'amenity', 'tag']),
  "featureCode": zod.string(),
  "strength": zod.enum(['required', 'preferred']),
  "decision": zod.enum(['pending', 'approved', 'dismissed']),
  "source": zod.enum(['manual', 'inferred']),
  "evidence": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const updateMyLocationNeed404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateMyLocationNeed404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateMyLocationNeed404ResponseOverlapWarningAcknowledgementMin = 16;
export const updateMyLocationNeed404ResponseOverlapWarningAcknowledgementMax = 256;


export const updateMyLocationNeed404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateMyLocationNeed404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateMyLocationNeed404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateMyLocationNeed404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateMyLocationNeed404ResponseOverlapWarningAcknowledgementMin).max(updateMyLocationNeed404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateMyLocationNeed404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Forget my own location need
 */
export const ForgetMyLocationNeedParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const forgetMyLocationNeedHeaderXGroupGraphTokenMax = 16384;


export const forgetMyLocationNeedHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ForgetMyLocationNeedHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(forgetMyLocationNeedHeaderXGroupGraphTokenMax).regex(forgetMyLocationNeedHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ForgetMyLocationNeed204Response = /*#__PURE__*/ (() => zod.void())()


export const getApiMeUiPrefsHeaderXGroupGraphTokenMax = 16384;


export const getApiMeUiPrefsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiMeUiPrefsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiMeUiPrefsHeaderXGroupGraphTokenMax).regex(getApiMeUiPrefsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiMeUiPrefs200Response = /*#__PURE__*/ (() => zod.object({
  "sidebarHidden": zod.boolean().nullable()
}))()

export const GetApiMeUiPrefs401Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetApiMeUiPrefs403Response = /*#__PURE__*/ (() => zod.unknown())()


export const putApiMeUiPrefsHeaderXGroupGraphTokenMax = 16384;


export const putApiMeUiPrefsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutApiMeUiPrefsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putApiMeUiPrefsHeaderXGroupGraphTokenMax).regex(putApiMeUiPrefsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PutApiMeUiPrefsBody = /*#__PURE__*/ (() => zod.object({
  "sidebarHidden": zod.boolean()
}))()

export const PutApiMeUiPrefs200Response = /*#__PURE__*/ (() => zod.object({
  "sidebarHidden": zod.boolean().nullable()
}))()

export const PutApiMeUiPrefs400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PutApiMeUiPrefs401Response = /*#__PURE__*/ (() => zod.unknown())()

export const PutApiMeUiPrefs403Response = /*#__PURE__*/ (() => zod.unknown())()


export const deleteApiMeUiPrefsSidebarHeaderXGroupGraphTokenMax = 16384;


export const deleteApiMeUiPrefsSidebarHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteApiMeUiPrefsSidebarHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteApiMeUiPrefsSidebarHeaderXGroupGraphTokenMax).regex(deleteApiMeUiPrefsSidebarHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteApiMeUiPrefsSidebar200Response = /*#__PURE__*/ (() => zod.object({
  "sidebarHidden": zod.boolean().nullable()
}))()

export const DeleteApiMeUiPrefsSidebar401Response = /*#__PURE__*/ (() => zod.unknown())()

export const DeleteApiMeUiPrefsSidebar403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Returns the last saved search preferences for the caller (site, building, space type, time-of-day window). Empty/null fields when the user has no saved context yet.
 * @summary Get the signed-in user's remembered booking search context
 */
export const getMySearchPrefsHeaderXGroupGraphTokenMax = 16384;


export const getMySearchPrefsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMySearchPrefsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMySearchPrefsHeaderXGroupGraphTokenMax).regex(getMySearchPrefsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMySearchPrefs200ResponseStartTimeOfDayRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const getMySearchPrefs200ResponseDurationMinutesMin = 15;
export const getMySearchPrefs200ResponseDurationMinutesMax = 1440;



export const GetMySearchPrefs200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable().describe('Space type code (e.g. desk, room)'),
  "startTimeOfDay": zod.string().regex(getMySearchPrefs200ResponseStartTimeOfDayRegExp).nullable().describe('Local wall-clock start as HH:MM (24h)'),
  "durationMinutes": zod.int().min(getMySearchPrefs200ResponseDurationMinutesMin).max(getMySearchPrefs200ResponseDurationMinutesMax).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const getMySearchPrefs401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMySearchPrefs401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMySearchPrefs401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMySearchPrefs401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMySearchPrefs401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMySearchPrefs401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMySearchPrefs401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMySearchPrefs401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMySearchPrefs401ResponseOverlapWarningAcknowledgementMin).max(getMySearchPrefs401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMySearchPrefs401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getMySearchPrefs409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMySearchPrefs409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMySearchPrefs409ResponseOverlapWarningAcknowledgementMin = 16;
export const getMySearchPrefs409ResponseOverlapWarningAcknowledgementMax = 256;


export const getMySearchPrefs409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMySearchPrefs409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMySearchPrefs409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMySearchPrefs409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMySearchPrefs409ResponseOverlapWarningAcknowledgementMin).max(getMySearchPrefs409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMySearchPrefs409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Persists the last used booking search filters and time-of-day window for the caller. Scoped to the authenticated app user; never readable by other users.
 * @summary Upsert the signed-in user's remembered booking search context
 */
export const putMySearchPrefsHeaderXGroupGraphTokenMax = 16384;


export const putMySearchPrefsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutMySearchPrefsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putMySearchPrefsHeaderXGroupGraphTokenMax).regex(putMySearchPrefsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putMySearchPrefsBodyTypeCodeMax = 64;

export const putMySearchPrefsBodyStartTimeOfDayRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const putMySearchPrefsBodyDurationMinutesMin = 15;
export const putMySearchPrefsBodyDurationMinutesMax = 1440;



export const PutMySearchPrefsBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().nullish(),
  "buildingId": zod.uuid().nullish(),
  "typeCode": zod.string().max(putMySearchPrefsBodyTypeCodeMax).nullish(),
  "startTimeOfDay": zod.string().regex(putMySearchPrefsBodyStartTimeOfDayRegExp).nullish().describe('Local wall-clock start as HH:MM (24h)'),
  "durationMinutes": zod.int().min(putMySearchPrefsBodyDurationMinutesMin).max(putMySearchPrefsBodyDurationMinutesMax).nullish()
}))()

export const putMySearchPrefs200ResponseStartTimeOfDayRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const putMySearchPrefs200ResponseDurationMinutesMin = 15;
export const putMySearchPrefs200ResponseDurationMinutesMax = 1440;



export const PutMySearchPrefs200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid().nullable(),
  "buildingId": zod.uuid().nullable(),
  "typeCode": zod.string().nullable().describe('Space type code (e.g. desk, room)'),
  "startTimeOfDay": zod.string().regex(putMySearchPrefs200ResponseStartTimeOfDayRegExp).nullable().describe('Local wall-clock start as HH:MM (24h)'),
  "durationMinutes": zod.int().min(putMySearchPrefs200ResponseDurationMinutesMin).max(putMySearchPrefs200ResponseDurationMinutesMax).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const putMySearchPrefs400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMySearchPrefs400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMySearchPrefs400ResponseOverlapWarningAcknowledgementMin = 16;
export const putMySearchPrefs400ResponseOverlapWarningAcknowledgementMax = 256;


export const putMySearchPrefs400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMySearchPrefs400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMySearchPrefs400ResponseOverlapWarningAcknowledgementMin).max(putMySearchPrefs400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMySearchPrefs400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMySearchPrefs401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMySearchPrefs401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMySearchPrefs401ResponseOverlapWarningAcknowledgementMin = 16;
export const putMySearchPrefs401ResponseOverlapWarningAcknowledgementMax = 256;


export const putMySearchPrefs401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMySearchPrefs401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMySearchPrefs401ResponseOverlapWarningAcknowledgementMin).max(putMySearchPrefs401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMySearchPrefs401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMySearchPrefs409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMySearchPrefs409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMySearchPrefs409ResponseOverlapWarningAcknowledgementMin = 16;
export const putMySearchPrefs409ResponseOverlapWarningAcknowledgementMax = 256;


export const putMySearchPrefs409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMySearchPrefs409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMySearchPrefs409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMySearchPrefs409ResponseOverlapWarningAcknowledgementMin).max(putMySearchPrefs409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMySearchPrefs409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get the signed-in user's entity-scoped office and neighbourhood preferences
 */
export const getMyWorkplaceProfileHeaderXGroupGraphTokenMax = 16384;


export const getMyWorkplaceProfileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyWorkplaceProfileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyWorkplaceProfileHeaderXGroupGraphTokenMax).regex(getMyWorkplaceProfileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetMyWorkplaceProfile200Response = /*#__PURE__*/ (() => zod.object({
  "defaultSiteId": zod.uuid().nullable(),
  "defaultBuildingId": zod.uuid().nullable(),
  "defaultFloorId": zod.uuid().nullable(),
  "assignedZoneIds": zod.array(zod.uuid()),
  "assignedZones": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "floorName": zod.string(),
  "siteName": zod.string()
})),
  "primaryZoneId": zod.uuid().nullable(),
  "primaryZoneFloorId": zod.uuid().nullable(),
  "primaryZoneSiteId": zod.uuid().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const getMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyWorkplaceProfile403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin).max(getMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Save the signed-in user's default office site and optional building
 */
export const putMyWorkplaceProfileHeaderXGroupGraphTokenMax = 16384;


export const putMyWorkplaceProfileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutMyWorkplaceProfileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putMyWorkplaceProfileHeaderXGroupGraphTokenMax).regex(putMyWorkplaceProfileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PutMyWorkplaceProfileBody = /*#__PURE__*/ (() => zod.object({
  "defaultSiteId": zod.uuid().nullable(),
  "defaultBuildingId": zod.uuid().nullish(),
  "defaultFloorId": zod.uuid().nullish()
}))()

export const PutMyWorkplaceProfile200Response = /*#__PURE__*/ (() => zod.object({
  "defaultSiteId": zod.uuid().nullable(),
  "defaultBuildingId": zod.uuid().nullable(),
  "defaultFloorId": zod.uuid().nullable(),
  "assignedZoneIds": zod.array(zod.uuid()),
  "assignedZones": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "floorName": zod.string(),
  "siteName": zod.string()
})),
  "primaryZoneId": zod.uuid().nullable(),
  "primaryZoneFloorId": zod.uuid().nullable(),
  "primaryZoneSiteId": zod.uuid().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const putMyWorkplaceProfile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyWorkplaceProfile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyWorkplaceProfile400ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyWorkplaceProfile400ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyWorkplaceProfile400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyWorkplaceProfile400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyWorkplaceProfile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyWorkplaceProfile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyWorkplaceProfile400ResponseOverlapWarningAcknowledgementMin).max(putMyWorkplaceProfile400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyWorkplaceProfile400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyWorkplaceProfile403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin).max(putMyWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Search active neighbourhoods in the selected entity for assignment
 */
export const searchWorkplaceZonesQueryQMax = 100;

export const searchWorkplaceZonesQueryLimitDefault = 25;
export const searchWorkplaceZonesQueryLimitMax = 50;

export const searchWorkplaceZonesQueryOffsetDefault = 0;
export const searchWorkplaceZonesQueryOffsetMin = 0;



export const SearchWorkplaceZonesQueryParams = /*#__PURE__*/ (() => zod.object({
  "q": zod.string().max(searchWorkplaceZonesQueryQMax).optional(),
  "limit": zod.int().min(1).max(searchWorkplaceZonesQueryLimitMax).default(searchWorkplaceZonesQueryLimitDefault),
  "offset": zod.int().min(searchWorkplaceZonesQueryOffsetMin).default(searchWorkplaceZonesQueryOffsetDefault)
}))()

export const searchWorkplaceZonesHeaderXGroupGraphTokenMax = 16384;


export const searchWorkplaceZonesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SearchWorkplaceZonesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(searchWorkplaceZonesHeaderXGroupGraphTokenMax).regex(searchWorkplaceZonesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const SearchWorkplaceZones200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "floorName": zod.string(),
  "siteName": zod.string()
})),
  "total": zod.int()
}))()

export const searchWorkplaceZones403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchWorkplaceZones403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchWorkplaceZones403ResponseOverlapWarningAcknowledgementMin = 16;
export const searchWorkplaceZones403ResponseOverlapWarningAcknowledgementMax = 256;


export const searchWorkplaceZones403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchWorkplaceZones403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchWorkplaceZones403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchWorkplaceZones403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchWorkplaceZones403ResponseOverlapWarningAcknowledgementMin).max(searchWorkplaceZones403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchWorkplaceZones403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read an entity member's booking eligibility classification (user administrators only)
 */
export const GetUserStaffClassificationParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const getUserStaffClassificationHeaderXGroupGraphTokenMax = 16384;


export const getUserStaffClassificationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUserStaffClassificationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUserStaffClassificationHeaderXGroupGraphTokenMax).regex(getUserStaffClassificationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetUserStaffClassification200Response = /*#__PURE__*/ (() => zod.object({
  "value": zod.union([zod.literal('EL2'),zod.literal('SES'),zod.literal('Conciliator'),zod.literal(null)]).nullable()
}))()

export const getUserStaffClassification403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUserStaffClassification403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUserStaffClassification403ResponseOverlapWarningAcknowledgementMin = 16;
export const getUserStaffClassification403ResponseOverlapWarningAcknowledgementMax = 256;


export const getUserStaffClassification403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUserStaffClassification403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUserStaffClassification403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUserStaffClassification403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUserStaffClassification403ResponseOverlapWarningAcknowledgementMin).max(getUserStaffClassification403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUserStaffClassification403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Audit and save an entity member's booking eligibility classification
 */
export const PutUserStaffClassificationParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const putUserStaffClassificationHeaderXGroupGraphTokenMax = 16384;


export const putUserStaffClassificationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutUserStaffClassificationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putUserStaffClassificationHeaderXGroupGraphTokenMax).regex(putUserStaffClassificationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PutUserStaffClassificationBody = /*#__PURE__*/ (() => zod.object({
  "value": zod.union([zod.literal('EL2'),zod.literal('SES'),zod.literal('Conciliator'),zod.literal(null)]).nullable()
}))()

export const PutUserStaffClassification200Response = /*#__PURE__*/ (() => zod.object({
  "value": zod.union([zod.literal('EL2'),zod.literal('SES'),zod.literal('Conciliator'),zod.literal(null)]).nullable()
}))()

export const putUserStaffClassification403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putUserStaffClassification403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putUserStaffClassification403ResponseOverlapWarningAcknowledgementMin = 16;
export const putUserStaffClassification403ResponseOverlapWarningAcknowledgementMax = 256;


export const putUserStaffClassification403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutUserStaffClassification403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserStaffClassification403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserStaffClassification403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putUserStaffClassification403ResponseOverlapWarningAcknowledgementMin).max(putUserStaffClassification403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putUserStaffClassification403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get an entity member's neighbourhood assignments
 */
export const GetUserWorkplaceProfileParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const getUserWorkplaceProfileHeaderXGroupGraphTokenMax = 16384;


export const getUserWorkplaceProfileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUserWorkplaceProfileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUserWorkplaceProfileHeaderXGroupGraphTokenMax).regex(getUserWorkplaceProfileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetUserWorkplaceProfile200Response = /*#__PURE__*/ (() => zod.object({
  "defaultSiteId": zod.uuid().nullable(),
  "defaultBuildingId": zod.uuid().nullable(),
  "defaultFloorId": zod.uuid().nullable(),
  "assignedZoneIds": zod.array(zod.uuid()),
  "assignedZones": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "floorName": zod.string(),
  "siteName": zod.string()
})),
  "primaryZoneId": zod.uuid().nullable(),
  "primaryZoneFloorId": zod.uuid().nullable(),
  "primaryZoneSiteId": zod.uuid().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const getUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin = 16;
export const getUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax = 256;


export const getUserWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUserWorkplaceProfile403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin).max(getUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUserWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Assign an entity member to one or more neighbourhoods
 */
export const PutUserWorkplaceProfileParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const putUserWorkplaceProfileHeaderXGroupGraphTokenMax = 16384;


export const putUserWorkplaceProfileHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutUserWorkplaceProfileHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putUserWorkplaceProfileHeaderXGroupGraphTokenMax).regex(putUserWorkplaceProfileHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putUserWorkplaceProfileBodyAssignedZoneIdsMax = 20;



export const PutUserWorkplaceProfileBody = /*#__PURE__*/ (() => zod.object({
  "assignedZoneIds": zod.array(zod.uuid()).max(putUserWorkplaceProfileBodyAssignedZoneIdsMax),
  "primaryZoneId": zod.uuid().nullable()
}))()

export const PutUserWorkplaceProfile200Response = /*#__PURE__*/ (() => zod.object({
  "defaultSiteId": zod.uuid().nullable(),
  "defaultBuildingId": zod.uuid().nullable(),
  "defaultFloorId": zod.uuid().nullable(),
  "assignedZoneIds": zod.array(zod.uuid()),
  "assignedZones": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "floorName": zod.string(),
  "siteName": zod.string()
})),
  "primaryZoneId": zod.uuid().nullable(),
  "primaryZoneFloorId": zod.uuid().nullable(),
  "primaryZoneSiteId": zod.uuid().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const putUserWorkplaceProfile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putUserWorkplaceProfile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putUserWorkplaceProfile400ResponseOverlapWarningAcknowledgementMin = 16;
export const putUserWorkplaceProfile400ResponseOverlapWarningAcknowledgementMax = 256;


export const putUserWorkplaceProfile400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutUserWorkplaceProfile400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserWorkplaceProfile400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserWorkplaceProfile400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putUserWorkplaceProfile400ResponseOverlapWarningAcknowledgementMin).max(putUserWorkplaceProfile400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putUserWorkplaceProfile400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin = 16;
export const putUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax = 256;


export const putUserWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutUserWorkplaceProfile403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putUserWorkplaceProfile403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMin).max(putUserWorkplaceProfile403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putUserWorkplaceProfile403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List the signed-in user's notifications
 */
export const listMyNotificationsQueryUnreadOnlyDefault = false;
export const listMyNotificationsQueryLimitDefault = 30;
export const listMyNotificationsQueryLimitMax = 100;



export const ListMyNotificationsQueryParams = /*#__PURE__*/ (() => zod.object({
  "unreadOnly": zod.boolean().default(listMyNotificationsQueryUnreadOnlyDefault),
  "limit": zod.int().min(1).max(listMyNotificationsQueryLimitMax).default(listMyNotificationsQueryLimitDefault)
}))()

export const listMyNotificationsHeaderXGroupGraphTokenMax = 16384;


export const listMyNotificationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyNotificationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyNotificationsHeaderXGroupGraphTokenMax).regex(listMyNotificationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listMyNotifications200ResponseUnreadCountMin = 0;



export const ListMyNotifications200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "type": zod.string(),
  "category": zod.string(),
  "title": zod.string(),
  "body": zod.string().nullish(),
  "href": zod.string().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()).nullish(),
  "emailStatus": zod.string().nullish(),
  "readAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "unreadCount": zod.int().min(listMyNotifications200ResponseUnreadCountMin)
}))()

export const listMyNotifications401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyNotifications401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyNotifications401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyNotifications401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyNotifications401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyNotifications401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyNotifications401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyNotifications401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyNotifications401ResponseOverlapWarningAcknowledgementMin).max(listMyNotifications401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyNotifications401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyNotifications409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyNotifications409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyNotifications409ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyNotifications409ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyNotifications409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyNotifications409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyNotifications409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyNotifications409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyNotifications409ResponseOverlapWarningAcknowledgementMin).max(listMyNotifications409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyNotifications409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Unread notification count for the signed-in user
 */
export const getMyNotificationUnreadCountHeaderXGroupGraphTokenMax = 16384;


export const getMyNotificationUnreadCountHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyNotificationUnreadCountHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyNotificationUnreadCountHeaderXGroupGraphTokenMax).regex(getMyNotificationUnreadCountHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getMyNotificationUnreadCount200ResponseUnreadCountMin = 0;



export const GetMyNotificationUnreadCount200Response = /*#__PURE__*/ (() => zod.object({
  "unreadCount": zod.int().min(getMyNotificationUnreadCount200ResponseUnreadCountMin)
}))()

export const getMyNotificationUnreadCount401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyNotificationUnreadCount401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyNotificationUnreadCount401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyNotificationUnreadCount401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyNotificationUnreadCount401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyNotificationUnreadCount401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationUnreadCount401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationUnreadCount401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyNotificationUnreadCount401ResponseOverlapWarningAcknowledgementMin).max(getMyNotificationUnreadCount401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyNotificationUnreadCount401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getMyNotificationUnreadCount409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyNotificationUnreadCount409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyNotificationUnreadCount409ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyNotificationUnreadCount409ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyNotificationUnreadCount409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyNotificationUnreadCount409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationUnreadCount409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationUnreadCount409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyNotificationUnreadCount409ResponseOverlapWarningAcknowledgementMin).max(getMyNotificationUnreadCount409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyNotificationUnreadCount409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Mark all notifications as read
 */
export const markAllMyNotificationsReadHeaderXGroupGraphTokenMax = 16384;


export const markAllMyNotificationsReadHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const MarkAllMyNotificationsReadHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(markAllMyNotificationsReadHeaderXGroupGraphTokenMax).regex(markAllMyNotificationsReadHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const MarkAllMyNotificationsRead200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean()
}))()

export const markAllMyNotificationsRead401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const markAllMyNotificationsRead401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const markAllMyNotificationsRead401ResponseOverlapWarningAcknowledgementMin = 16;
export const markAllMyNotificationsRead401ResponseOverlapWarningAcknowledgementMax = 256;


export const markAllMyNotificationsRead401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MarkAllMyNotificationsRead401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markAllMyNotificationsRead401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markAllMyNotificationsRead401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(markAllMyNotificationsRead401ResponseOverlapWarningAcknowledgementMin).max(markAllMyNotificationsRead401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(markAllMyNotificationsRead401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const markAllMyNotificationsRead409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const markAllMyNotificationsRead409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const markAllMyNotificationsRead409ResponseOverlapWarningAcknowledgementMin = 16;
export const markAllMyNotificationsRead409ResponseOverlapWarningAcknowledgementMax = 256;


export const markAllMyNotificationsRead409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MarkAllMyNotificationsRead409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markAllMyNotificationsRead409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markAllMyNotificationsRead409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(markAllMyNotificationsRead409ResponseOverlapWarningAcknowledgementMin).max(markAllMyNotificationsRead409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(markAllMyNotificationsRead409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Mark a single notification as read
 */
export const MarkMyNotificationReadParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const markMyNotificationReadHeaderXGroupGraphTokenMax = 16384;


export const markMyNotificationReadHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const MarkMyNotificationReadHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(markMyNotificationReadHeaderXGroupGraphTokenMax).regex(markMyNotificationReadHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const MarkMyNotificationRead200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "type": zod.string(),
  "category": zod.string(),
  "title": zod.string(),
  "body": zod.string().nullish(),
  "href": zod.string().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()).nullish(),
  "emailStatus": zod.string().nullish(),
  "readAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const markMyNotificationRead401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const markMyNotificationRead401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const markMyNotificationRead401ResponseOverlapWarningAcknowledgementMin = 16;
export const markMyNotificationRead401ResponseOverlapWarningAcknowledgementMax = 256;


export const markMyNotificationRead401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MarkMyNotificationRead401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(markMyNotificationRead401ResponseOverlapWarningAcknowledgementMin).max(markMyNotificationRead401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(markMyNotificationRead401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const markMyNotificationRead404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const markMyNotificationRead404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const markMyNotificationRead404ResponseOverlapWarningAcknowledgementMin = 16;
export const markMyNotificationRead404ResponseOverlapWarningAcknowledgementMax = 256;


export const markMyNotificationRead404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MarkMyNotificationRead404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(markMyNotificationRead404ResponseOverlapWarningAcknowledgementMin).max(markMyNotificationRead404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(markMyNotificationRead404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const markMyNotificationRead409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const markMyNotificationRead409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const markMyNotificationRead409ResponseOverlapWarningAcknowledgementMin = 16;
export const markMyNotificationRead409ResponseOverlapWarningAcknowledgementMax = 256;


export const markMyNotificationRead409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const MarkMyNotificationRead409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(markMyNotificationRead409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(markMyNotificationRead409ResponseOverlapWarningAcknowledgementMin).max(markMyNotificationRead409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(markMyNotificationRead409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get notification category and channel preferences
 */
export const getMyNotificationPreferencesHeaderXGroupGraphTokenMax = 16384;


export const getMyNotificationPreferencesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyNotificationPreferencesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyNotificationPreferencesHeaderXGroupGraphTokenMax).regex(getMyNotificationPreferencesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetMyNotificationPreferences200Response = /*#__PURE__*/ (() => zod.object({
  "preferences": zod.object({
  "confirmations": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "reminders": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "check_in": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "cancellations": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "modifications": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "visitors": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
})
}),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "channels": zod.object({
  "emailEnabled": zod.boolean(),
  "emailStatus": zod.enum(['ready', 'disabled']),
  "emailMode": zod.enum(['acs', 'graph', 'cdf_relay', 'in_app_only']),
  "senderHint": zod.string().nullish(),
  "message": zod.string()
})
}))()

export const getMyNotificationPreferences401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyNotificationPreferences401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyNotificationPreferences401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyNotificationPreferences401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationPreferences401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationPreferences401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMin).max(getMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyNotificationPreferences401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getMyNotificationPreferences409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyNotificationPreferences409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyNotificationPreferences409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyNotificationPreferences409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationPreferences409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationPreferences409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMin).max(getMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyNotificationPreferences409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update notification preferences
 */
export const putMyNotificationPreferencesHeaderXGroupGraphTokenMax = 16384;


export const putMyNotificationPreferencesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutMyNotificationPreferencesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putMyNotificationPreferencesHeaderXGroupGraphTokenMax).regex(putMyNotificationPreferencesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PutMyNotificationPreferencesBody = /*#__PURE__*/ (() => zod.object({
  "preferences": zod.record(zod.string(), zod.object({
  "inApp": zod.boolean().optional(),
  "email": zod.boolean().optional()
})).optional()
}))()

export const PutMyNotificationPreferences200Response = /*#__PURE__*/ (() => zod.object({
  "preferences": zod.object({
  "confirmations": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "reminders": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "check_in": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "cancellations": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "modifications": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
}),
  "visitors": zod.object({
  "inApp": zod.boolean(),
  "email": zod.boolean()
})
}),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "channels": zod.object({
  "emailEnabled": zod.boolean(),
  "emailStatus": zod.enum(['ready', 'disabled']),
  "emailMode": zod.enum(['acs', 'graph', 'cdf_relay', 'in_app_only']),
  "senderHint": zod.string().nullish(),
  "message": zod.string()
})
}))()

export const putMyNotificationPreferences400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyNotificationPreferences400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyNotificationPreferences400ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyNotificationPreferences400ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyNotificationPreferences400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyNotificationPreferences400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyNotificationPreferences400ResponseOverlapWarningAcknowledgementMin).max(putMyNotificationPreferences400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyNotificationPreferences400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyNotificationPreferences401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyNotificationPreferences401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyNotificationPreferences401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyNotificationPreferences401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMin).max(putMyNotificationPreferences401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyNotificationPreferences401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyNotificationPreferences409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyNotificationPreferences409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyNotificationPreferences409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyNotificationPreferences409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyNotificationPreferences409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMin).max(putMyNotificationPreferences409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyNotificationPreferences409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Surfaces whether ACS email is configured. Secrets are never returned — only a masked sender domain when email is ready.
 * @summary Email/in-app channel readiness for notifications
 */
export const getMyNotificationChannelsHeaderXGroupGraphTokenMax = 16384;


export const getMyNotificationChannelsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetMyNotificationChannelsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getMyNotificationChannelsHeaderXGroupGraphTokenMax).regex(getMyNotificationChannelsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetMyNotificationChannels200Response = /*#__PURE__*/ (() => zod.object({
  "emailEnabled": zod.boolean(),
  "emailStatus": zod.enum(['ready', 'disabled']),
  "emailMode": zod.enum(['acs', 'graph', 'cdf_relay', 'in_app_only']),
  "senderHint": zod.string().nullish(),
  "message": zod.string()
}))()

export const getMyNotificationChannels401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getMyNotificationChannels401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getMyNotificationChannels401ResponseOverlapWarningAcknowledgementMin = 16;
export const getMyNotificationChannels401ResponseOverlapWarningAcknowledgementMax = 256;


export const getMyNotificationChannels401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetMyNotificationChannels401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationChannels401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getMyNotificationChannels401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getMyNotificationChannels401ResponseOverlapWarningAcknowledgementMin).max(getMyNotificationChannels401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getMyNotificationChannels401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read entity visitor booking mode
 */
export const getVisitorBookingSettingsHeaderXGroupGraphTokenMax = 16384;


export const getVisitorBookingSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetVisitorBookingSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getVisitorBookingSettingsHeaderXGroupGraphTokenMax).regex(getVisitorBookingSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetVisitorBookingSettings200Response = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['host_only', 'self_service', 'both'])
}))()


/**
 * @summary Administrator sets entity visitor booking mode
 */
export const setVisitorBookingSettingsHeaderXGroupGraphTokenMax = 16384;


export const setVisitorBookingSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetVisitorBookingSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setVisitorBookingSettingsHeaderXGroupGraphTokenMax).regex(setVisitorBookingSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const SetVisitorBookingSettingsBody = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['host_only', 'self_service', 'both'])
}))()

export const SetVisitorBookingSettings200Response = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['host_only', 'self_service', 'both'])
}))()


/**
 * @summary Host approval queue within the selected entity
 */
export const listHostVisitorApprovalsQueryLimitMax = 100;

export const listHostVisitorApprovalsQueryOffsetMin = 0;



export const ListHostVisitorApprovalsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listHostVisitorApprovalsQueryLimitMax).optional(),
  "offset": zod.int().min(listHostVisitorApprovalsQueryOffsetMin).optional()
}))()

export const listHostVisitorApprovalsHeaderXGroupGraphTokenMax = 16384;


export const listHostVisitorApprovalsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListHostVisitorApprovalsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listHostVisitorApprovalsHeaderXGroupGraphTokenMax).regex(listHostVisitorApprovalsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listHostVisitorApprovals200ResponseTotalMin = 0;



export const ListHostVisitorApprovals200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "visitId": zod.uuid(),
  "organizationId": zod.uuid(),
  "guestUserId": zod.uuid(),
  "status": zod.enum(['pending', 'approved', 'revoked']),
  "siteId": zod.uuid().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the approved site, disclosed only with this approval.'),
  "spaceTypeId": zod.uuid().nullish(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "linkedBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish(),
  "layoutCapacity": zod.int().min(1).nullish(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "retryId": zod.uuid().nullish(),
  "calendarPending": zod.boolean()
}),zod.null()]).optional(),
  "visitorName": zod.string().optional(),
  "guestName": zod.string().optional(),
  "guestEmail": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).optional(),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listHostVisitorApprovals200ResponseTotalMin)
}))()


/**
 * @summary Host approves or revokes a visitor request
 */
export const DecideVisitorApprovalParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const decideVisitorApprovalHeaderXGroupGraphTokenMax = 16384;


export const decideVisitorApprovalHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DecideVisitorApprovalHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(decideVisitorApprovalHeaderXGroupGraphTokenMax).regex(decideVisitorApprovalHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DecideVisitorApprovalBody = /*#__PURE__*/ (() => zod.object({
  "decision": zod.enum(['approve', 'revoke']),
  "siteId": zod.uuid().optional(),
  "spaceTypeId": zod.uuid().optional(),
  "validFrom": zod.iso.datetime({"offset":true}).optional().describe('Must be on a 15-minute mark when approving.'),
  "validUntil": zod.iso.datetime({"offset":true}).optional().describe('Must be on a 15-minute mark when approving.')
}))()




export const DecideVisitorApproval200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitId": zod.uuid(),
  "organizationId": zod.uuid(),
  "guestUserId": zod.uuid(),
  "status": zod.enum(['pending', 'approved', 'revoked']),
  "siteId": zod.uuid().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the approved site, disclosed only with this approval.'),
  "spaceTypeId": zod.uuid().nullish(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "linkedBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish(),
  "layoutCapacity": zod.int().min(1).nullish(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "retryId": zod.uuid().nullish(),
  "calendarPending": zod.boolean()
}),zod.null()]).optional(),
  "visitorName": zod.string().optional(),
  "guestName": zod.string().optional(),
  "guestEmail": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).optional(),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish()
}))()


/**
 * @summary Signed-in visitor approval status
 */
export const listMyVisitorApprovalsQueryLimitMax = 100;

export const listMyVisitorApprovalsQueryOffsetMin = 0;



export const ListMyVisitorApprovalsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listMyVisitorApprovalsQueryLimitMax).optional(),
  "offset": zod.int().min(listMyVisitorApprovalsQueryOffsetMin).optional()
}))()


export const listMyVisitorApprovals200ResponseTotalMin = 0;



export const ListMyVisitorApprovals200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "visitId": zod.uuid(),
  "organizationId": zod.uuid(),
  "guestUserId": zod.uuid(),
  "status": zod.enum(['pending', 'approved', 'revoked']),
  "siteId": zod.uuid().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the approved site, disclosed only with this approval.'),
  "spaceTypeId": zod.uuid().nullish(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "linkedBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish(),
  "layoutCapacity": zod.int().min(1).nullish(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "retryId": zod.uuid().nullish(),
  "calendarPending": zod.boolean()
}),zod.null()]).optional(),
  "visitorName": zod.string().optional(),
  "guestName": zod.string().optional(),
  "guestEmail": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).optional(),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listMyVisitorApprovals200ResponseTotalMin)
}))()


/**
 * @summary Request approval for a host-registered visit using verified sign-in
 */
export const RequestVisitorApprovalBody = /*#__PURE__*/ (() => zod.object({
  "visitId": zod.uuid()
}))()




export const RequestVisitorApproval200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitId": zod.uuid(),
  "organizationId": zod.uuid(),
  "guestUserId": zod.uuid(),
  "status": zod.enum(['pending', 'approved', 'revoked']),
  "siteId": zod.uuid().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the approved site, disclosed only with this approval.'),
  "spaceTypeId": zod.uuid().nullish(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "linkedBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish(),
  "layoutCapacity": zod.int().min(1).nullish(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "retryId": zod.uuid().nullish(),
  "calendarPending": zod.boolean()
}),zod.null()]).optional(),
  "visitorName": zod.string().optional(),
  "guestName": zod.string().optional(),
  "guestEmail": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).optional(),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish()
}))()


/**
 * @summary Search only the approved site and resource type
 */
export const SearchVisitorAvailabilityParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const searchVisitorAvailabilityQueryLimitMax = 100;

export const searchVisitorAvailabilityQueryOffsetMin = 0;



export const SearchVisitorAvailabilityQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "limit": zod.int().min(1).max(searchVisitorAvailabilityQueryLimitMax).optional(),
  "offset": zod.int().min(searchVisitorAvailabilityQueryOffsetMin).optional()
}))()


export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneMax = 12;

export const searchVisitorAvailability200ResponseTotalMin = 0;



export const SearchVisitorAvailability200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneMin).max(searchVisitorAvailability200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "available": zod.boolean(),
  "reasons": zod.array(zod.enum(['AVAILABLE', 'CONFLICT', 'POLICY_VIOLATION', 'BLACKOUT', 'UNAVAILABLE_MODE', 'RETIRED', 'TYPE_FILTER'])),
  "reasonDetail": zod.string().nullish(),
  "policyScopeKind": zod.string(),
  "availabilitySource": zod.enum(['app', 'app_fallback', 'exchange']),
  "blockingBooking": zod.union([zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "checkInRequired": zod.boolean(),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "end": zod.iso.datetime({"offset":true}).optional().describe('Original booking end (takeover books until this instant)'),
  "isOwnBooking": zod.boolean().optional().describe('True only when the signed-in viewer owns the blocking booking')
}).describe('Active booking that makes a space unavailable for the search window.\nUsed by the floor map to enable walk-up takeover after missed check-in.\n'),zod.null()]).optional().describe('Present when an app booking makes the space unavailable')
})),
  "total": zod.int().min(searchVisitorAvailability200ResponseTotalMin),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "graphStatus": zod.enum(['connected', 'disconnected', 'degraded']).describe('Exchange/Graph readiness for meeting-room SoT (FR-EU-017)'),
  "graphBanner": zod.string().nullish().describe('User-facing degradation copy when rooms are on app_fallback')
}))()


/**
 * @summary Create one policy-checked booking for an approved visit
 */
export const BookVisitorResourceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const bookVisitorResourceBodyOverlapAcknowledgementMin = 16;
export const bookVisitorResourceBodyOverlapAcknowledgementMax = 256;



export const BookVisitorResourceBody = /*#__PURE__*/ (() => zod.object({
  "overlapAcknowledgement": zod.string().min(bookVisitorResourceBodyOverlapAcknowledgementMin).max(bookVisitorResourceBodyOverlapAcknowledgementMax).optional(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().optional(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "clientRequestId": zod.uuid()
}))()





export const BookVisitorResource200Response = /*#__PURE__*/ (() => zod.object({
  "booking": zod.object({
  "revision": zod.int().min(1).optional(),
  "allocationKind": zod.enum(['beneficiary_booking', 'own_name_reservation']).optional(),
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "layoutId": zod.uuid().nullish(),
  "layoutName": zod.string().nullish().describe('Immutable selected layout name snapshot.'),
  "layoutCapacity": zod.int().min(1).nullish().describe('Immutable selected layout capacity snapshot.'),
  "itineraryId": zod.uuid().nullish(),
  "seriesId": zod.uuid().nullish(),
  "bookedByUserId": zod.uuid(),
  "bookedForUserId": zod.uuid(),
  "bookedByDisplayName": zod.string().nullish().describe('Current organiser name from the authorised booking read.'),
  "bookedForDisplayName": zod.string().nullish().describe('Current beneficiary name from the authorised booking read.'),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['confirmed', 'pending_check_in', 'checked_in', 'cancelled', 'auto_released', 'pending_approval', 'pending_sync']),
  "title": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "source": zod.enum(['ui', 'ai', 'import']),
  "checkInRequired": zod.boolean(),
  "checkInWaived": zod.boolean().optional().describe('The current tenant policy permanently waived this outstanding check-in obligation.'),
  "checkInBy": zod.iso.datetime({"offset":true}).nullish(),
  "exchangeEventId": zod.string().nullish(),
  "exchangeSyncState": zod.union([zod.literal('pending'),zod.literal('awaiting_response'),zod.literal('accepted'),zod.literal('declined'),zod.literal('failed'),zod.literal('app_fallback'),zod.literal('cancelled'),zod.literal('legacy_unverified'),zod.literal(null)]).nullish().describe('Calendar outcome for Exchange rooms; null for app-managed resources.'),
  "exchangeSyncAction": zod.union([zod.literal('create'),zod.literal('update'),zod.literal('cancel'),zod.literal('poll'),zod.literal(null)]).nullish(),
  "exchangeSyncError": zod.string().nullish(),
  "clientRequestId": zod.string().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "vehicle": zod.union([zod.object({
  "vehicleId": zod.uuid().nullish(),
  "plate": zod.string(),
  "permitId": zod.string().nullish(),
  "sizeClass": zod.string().nullish()
}),zod.null()]).optional()
}),
  "visitId": zod.uuid(),
  "outcome": zod.enum(['confirmed', 'calendar_pending', 'app_only'])
}))()


/**
 * @summary Read the signed-in visitor's requirements within a current host approval
 */
export const GetVisitorPolicyRequirementsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const GetVisitorPolicyRequirementsQueryParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid()
}))()

export const getVisitorPolicyRequirements200ResponseRulesItemOneOneTitleMax = 200;

export const getVisitorPolicyRequirements200ResponseRulesItemOneOneBodyMax = 20000;

export const getVisitorPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax = 3650;





export const GetVisitorPolicyRequirements200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "spaceId": zod.uuid(),
  "revision": zod.string(),
  "rules": zod.array(zod.object({
  "title": zod.string().min(1).max(getVisitorPolicyRequirements200ResponseRulesItemOneOneTitleMax),
  "body": zod.string().min(1).max(getVisitorPolicyRequirements200ResponseRulesItemOneOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(getVisitorPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "ruleId": zod.uuid(),
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid()
})),
  "acceptance": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "userId": zod.uuid(),
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "acceptedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "method": zod.enum(['individual', 'shared']),
  "checkedRuleIds": zod.array(zod.uuid()),
  "batchId": zod.uuid(),
  "source": zod.enum(['user', 'legacy_exact'])
}),zod.null()]),
  "needsAcceptance": zod.boolean()
}))),
  "complete": zod.boolean()
}))()

export const GetVisitorPolicyRequirements403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetVisitorPolicyRequirements404Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Accept the exact current set as the verified visitor
 */
export const AcceptVisitorPolicyRequirementsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const acceptVisitorPolicyRequirementsBodyRevisionMin = 64;
export const acceptVisitorPolicyRequirementsBodyRevisionMax = 64;


export const acceptVisitorPolicyRequirementsBodyRulesMax = 1000;

export const acceptVisitorPolicyRequirementsBodyCheckedRuleIdsMax = 1000;



export const AcceptVisitorPolicyRequirementsBody = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "revision": zod.string().min(acceptVisitorPolicyRequirementsBodyRevisionMin).max(acceptVisitorPolicyRequirementsBodyRevisionMax),
  "rules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1)
})).max(acceptVisitorPolicyRequirementsBodyRulesMax),
  "checkedRuleIds": zod.array(zod.uuid()).max(acceptVisitorPolicyRequirementsBodyCheckedRuleIdsMax)
}))()

export const acceptVisitorPolicyRequirements200ResponseRulesItemOneOneTitleMax = 200;

export const acceptVisitorPolicyRequirements200ResponseRulesItemOneOneBodyMax = 20000;

export const acceptVisitorPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax = 3650;





export const AcceptVisitorPolicyRequirements200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "spaceId": zod.uuid(),
  "revision": zod.string(),
  "rules": zod.array(zod.object({
  "title": zod.string().min(1).max(acceptVisitorPolicyRequirements200ResponseRulesItemOneOneTitleMax),
  "body": zod.string().min(1).max(acceptVisitorPolicyRequirements200ResponseRulesItemOneOneBodyMax),
  "requiresIndividualAcknowledgement": zod.boolean(),
  "validityDays": zod.int().min(1).max(acceptVisitorPolicyRequirements200ResponseRulesItemOneOneValidityDaysMax).nullable()
}).and(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "version": zod.int().min(1),
  "active": zod.boolean()
})).and(zod.object({
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "ruleId": zod.uuid(),
  "scope": zod.enum(['site', 'building', 'floor', 'zone', 'space_type']),
  "scopeId": zod.uuid()
})),
  "acceptance": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "userId": zod.uuid(),
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "acceptedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "method": zod.enum(['individual', 'shared']),
  "checkedRuleIds": zod.array(zod.uuid()),
  "batchId": zod.uuid(),
  "source": zod.enum(['user', 'legacy_exact'])
}),zod.null()]),
  "needsAcceptance": zod.boolean()
}))),
  "complete": zod.boolean()
}))()

export const AcceptVisitorPolicyRequirements403Response = /*#__PURE__*/ (() => zod.unknown())()

export const AcceptVisitorPolicyRequirements409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Get induction checklist and status for the approved visitor site
 */
export const GetVisitorInductionParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()


export const getVisitorInduction200ResponseChecklistItemsItemIdMax = 64;

export const getVisitorInduction200ResponseChecklistItemsItemLabelMax = 200;

export const getVisitorInduction200ResponseChecklistItemsItemDetailMax = 1000;

export const getVisitorInduction200ResponseChecklistValidityDaysMax = 3650;

export const getVisitorInduction200ResponseChecklistArrivalItemsItemIdMax = 64;

export const getVisitorInduction200ResponseChecklistArrivalItemsItemLabelMax = 200;

export const getVisitorInduction200ResponseChecklistArrivalItemsItemDetailMax = 1000;

export const getVisitorInduction200ResponseChecklistArrivalItemsMax = 50;

export const getVisitorInduction200ResponseChecklistSafetyGuidanceMax = 4000;





export const GetVisitorInduction200Response = /*#__PURE__*/ (() => zod.object({
  "checklist": zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "version": zod.int().min(1),
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(getVisitorInduction200ResponseChecklistItemsItemIdMax),
  "label": zod.string().min(1).max(getVisitorInduction200ResponseChecklistItemsItemLabelMax),
  "detail": zod.string().max(getVisitorInduction200ResponseChecklistItemsItemDetailMax).optional()
})),
  "active": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "validityDays": zod.int().min(1).max(getVisitorInduction200ResponseChecklistValidityDaysMax).nullable(),
  "arrivalItems": zod.array(zod.object({
  "id": zod.string().min(1).max(getVisitorInduction200ResponseChecklistArrivalItemsItemIdMax),
  "label": zod.string().min(1).max(getVisitorInduction200ResponseChecklistArrivalItemsItemLabelMax),
  "detail": zod.string().max(getVisitorInduction200ResponseChecklistArrivalItemsItemDetailMax).optional()
})).max(getVisitorInduction200ResponseChecklistArrivalItemsMax),
  "safetyGuidance": zod.string().max(getVisitorInduction200ResponseChecklistSafetyGuidanceMax)
}),
  "status": zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "currentVersion": zod.int().min(1).nullable(),
  "hasActiveChecklist": zod.boolean(),
  "acknowledgedVersion": zod.int().min(1).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "isComplete": zod.boolean().describe('True when the site has no active checklist, or the user has acknowledged the current version.\n')
})
}))()


/**
 * @summary Acknowledge every item in the current approved site induction
 */
export const CompleteVisitorInductionParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()


export const completeVisitorInductionBodyItemIdsItemMax = 64;

export const completeVisitorInductionBodyItemIdsMax = 50;



export const CompleteVisitorInductionBody = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "version": zod.int().min(1),
  "itemIds": zod.array(zod.string().min(1).max(completeVisitorInductionBodyItemIdsItemMax)).min(1).max(completeVisitorInductionBodyItemIdsMax)
}))()





export const CompleteVisitorInduction200Response = /*#__PURE__*/ (() => zod.object({
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "currentVersion": zod.int().min(1).nullable(),
  "hasActiveChecklist": zod.boolean(),
  "acknowledgedVersion": zod.int().min(1).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "isComplete": zod.boolean().describe('True when the site has no active checklist, or the user has acknowledged the current version.\n')
}))()


/**
 * @summary Visitor cancels their own approval-bound resource booking
 */
export const CancelVisitorResourceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const CancelVisitorResource200Response = /*#__PURE__*/ (() => zod.object({
  "visitId": zod.uuid(),
  "status": zod.enum(['cancelled', 'already_cancelled'])
}))()


/**
 * Hosts see their own visitors by default. Front-desk and admin users can list all visits; pass mine=true to scope to the caller. Use today=true for the reception board. format=csv for download (desk/admin).
 * @summary List visits (host, front desk, or admin)
 */
export const listVisitsQueryQMax = 100;

export const listVisitsQueryLimitDefault = 50;
export const listVisitsQueryLimitMax = 200;

export const listVisitsQueryOffsetDefault = 0;
export const listVisitsQueryOffsetMin = 0;

export const listVisitsQueryFormatDefault = `json`;

export const ListVisitsQueryParams = /*#__PURE__*/ (() => zod.object({
  "mine": zod.boolean().optional(),
  "today": zod.boolean().optional(),
  "bookingId": zod.uuid().optional(),
  "hostUserId": zod.uuid().optional(),
  "status": zod.string().optional().describe('Comma-separated visitor visit statuses'),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "q": zod.string().max(listVisitsQueryQMax).optional().describe('Search visitor name, email, or company'),
  "limit": zod.int().min(1).max(listVisitsQueryLimitMax).default(listVisitsQueryLimitDefault),
  "offset": zod.int().min(listVisitsQueryOffsetMin).default(listVisitsQueryOffsetDefault),
  "format": zod.enum(['json', 'csv']).default(listVisitsQueryFormatDefault)
}))()

export const listVisitsHeaderXGroupGraphTokenMax = 16384;


export const listVisitsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListVisitsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listVisitsHeaderXGroupGraphTokenMax).regex(listVisitsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listVisits200ResponseTotalMin = 0;



export const ListVisits200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
})),
  "total": zod.int().min(listVisits200ResponseTotalMin)
}))()

export const listVisits401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listVisits401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listVisits401ResponseOverlapWarningAcknowledgementMin = 16;
export const listVisits401ResponseOverlapWarningAcknowledgementMax = 256;


export const listVisits401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListVisits401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisits401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisits401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listVisits401ResponseOverlapWarningAcknowledgementMin).max(listVisits401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listVisits401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listVisits403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listVisits403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listVisits403ResponseOverlapWarningAcknowledgementMin = 16;
export const listVisits403ResponseOverlapWarningAcknowledgementMax = 256;


export const listVisits403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListVisits403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisits403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisits403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listVisits403ResponseOverlapWarningAcknowledgementMin).max(listVisits403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listVisits403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Pre-register a visitor (booking-linked or standalone)
 */
export const createVisitHeaderXGroupGraphTokenMax = 16384;


export const createVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createVisitHeaderXGroupGraphTokenMax).regex(createVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createVisitBodyVisitorNameMax = 200;

export const createVisitBodyVisitorEmailMax = 200;

export const createVisitBodyVisitorCompanyMax = 200;

export const createVisitBodyNotesMax = 1000;



export const CreateVisitBody = /*#__PURE__*/ (() => zod.object({
  "visitorName": zod.string().min(1).max(createVisitBodyVisitorNameMax),
  "visitorEmail": zod.email().max(createVisitBodyVisitorEmailMax).nullish(),
  "visitorCompany": zod.string().max(createVisitBodyVisitorCompanyMax).nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).nullish().describe('Invitations must use a 15-minute mark; walk-up visits may use the actual arrival time.'),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish().describe('Optional for invitations; when supplied it must use a 15-minute mark.'),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "buildingId": zod.uuid().nullish(),
  "hostUserId": zod.uuid().nullish(),
  "notes": zod.string().max(createVisitBodyNotesMax).nullish()
}))()

export const CreateVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const createVisit400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createVisit400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createVisit400ResponseOverlapWarningAcknowledgementMin = 16;
export const createVisit400ResponseOverlapWarningAcknowledgementMax = 256;


export const createVisit400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateVisit400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createVisit400ResponseOverlapWarningAcknowledgementMin).max(createVisit400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createVisit400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createVisit401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createVisit401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createVisit401ResponseOverlapWarningAcknowledgementMin = 16;
export const createVisit401ResponseOverlapWarningAcknowledgementMax = 256;


export const createVisit401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateVisit401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createVisit401ResponseOverlapWarningAcknowledgementMin).max(createVisit401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createVisit401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createVisit403ResponseOverlapWarningAcknowledgementMin = 16;
export const createVisit403ResponseOverlapWarningAcknowledgementMax = 256;


export const createVisit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateVisit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createVisit403ResponseOverlapWarningAcknowledgementMin).max(createVisit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createVisit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Front-desk walk-up create + check-in
 */
export const createWalkUpVisitHeaderXGroupGraphTokenMax = 16384;


export const createWalkUpVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateWalkUpVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createWalkUpVisitHeaderXGroupGraphTokenMax).regex(createWalkUpVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createWalkUpVisitBodyVisitorNameMax = 200;

export const createWalkUpVisitBodyVisitorEmailMax = 200;

export const createWalkUpVisitBodyVisitorCompanyMax = 200;

export const createWalkUpVisitBodyNotesMax = 1000;



export const CreateWalkUpVisitBody = /*#__PURE__*/ (() => zod.object({
  "visitorName": zod.string().min(1).max(createWalkUpVisitBodyVisitorNameMax),
  "visitorEmail": zod.email().max(createWalkUpVisitBodyVisitorEmailMax).nullish(),
  "visitorCompany": zod.string().max(createWalkUpVisitBodyVisitorCompanyMax).nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}).nullish().describe('Invitations must use a 15-minute mark; walk-up visits may use the actual arrival time.'),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish().describe('Optional for invitations; when supplied it must use a 15-minute mark.'),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "buildingId": zod.uuid().nullish(),
  "hostUserId": zod.uuid().nullish(),
  "notes": zod.string().max(createWalkUpVisitBodyNotesMax).nullish()
}))()

export const CreateWalkUpVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const createWalkUpVisit401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createWalkUpVisit401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createWalkUpVisit401ResponseOverlapWarningAcknowledgementMin = 16;
export const createWalkUpVisit401ResponseOverlapWarningAcknowledgementMax = 256;


export const createWalkUpVisit401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateWalkUpVisit401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWalkUpVisit401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWalkUpVisit401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createWalkUpVisit401ResponseOverlapWarningAcknowledgementMin).max(createWalkUpVisit401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createWalkUpVisit401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createWalkUpVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createWalkUpVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createWalkUpVisit403ResponseOverlapWarningAcknowledgementMin = 16;
export const createWalkUpVisit403ResponseOverlapWarningAcknowledgementMax = 256;


export const createWalkUpVisit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateWalkUpVisit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWalkUpVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWalkUpVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createWalkUpVisit403ResponseOverlapWarningAcknowledgementMin).max(createWalkUpVisit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createWalkUpVisit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update details of an expected or checked-in visit
 */
export const UpdateVisitParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateVisitHeaderXGroupGraphTokenMax = 16384;


export const updateVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateVisitHeaderXGroupGraphTokenMax).regex(updateVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateVisitBodyVisitorNameMax = 200;


export const updateVisitBodyVisitorNameRegExp = new RegExp('\\S');
export const updateVisitBodyVisitorEmailMax = 200;

export const updateVisitBodyVisitorCompanyMax = 200;

export const updateVisitBodyNotesMax = 1000;



export const UpdateVisitBody = /*#__PURE__*/ (() => zod.object({
  "visitorName": zod.string().min(1).max(updateVisitBodyVisitorNameMax).regex(updateVisitBodyVisitorNameRegExp).optional(),
  "visitorEmail": zod.email().max(updateVisitBodyVisitorEmailMax).nullish(),
  "visitorCompany": zod.string().max(updateVisitBodyVisitorCompanyMax).nullish(),
  "notes": zod.string().max(updateVisitBodyNotesMax).nullish()
}).describe('Only the selected visit snapshot changes; guest access and reusable identity are preserved. Omitted fields remain unchanged.'))()

export const UpdateVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const updateVisit400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateVisit400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateVisit400ResponseOverlapWarningAcknowledgementMin = 16;
export const updateVisit400ResponseOverlapWarningAcknowledgementMax = 256;


export const updateVisit400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateVisit400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateVisit400ResponseOverlapWarningAcknowledgementMin).max(updateVisit400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateVisit400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateVisit403ResponseOverlapWarningAcknowledgementMin = 16;
export const updateVisit403ResponseOverlapWarningAcknowledgementMax = 256;


export const updateVisit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateVisit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateVisit403ResponseOverlapWarningAcknowledgementMin).max(updateVisit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateVisit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateVisit404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateVisit404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateVisit404ResponseOverlapWarningAcknowledgementMin = 16;
export const updateVisit404ResponseOverlapWarningAcknowledgementMax = 256;


export const updateVisit404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateVisit404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateVisit404ResponseOverlapWarningAcknowledgementMin).max(updateVisit404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateVisit404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateVisit409ResponseOverlapWarningAcknowledgementMin = 16;
export const updateVisit409ResponseOverlapWarningAcknowledgementMax = 256;


export const updateVisit409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateVisit409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateVisit409ResponseOverlapWarningAcknowledgementMin).max(updateVisit409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateVisit409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get a visit by id
 */
export const GetVisitParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getVisitHeaderXGroupGraphTokenMax = 16384;


export const getVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getVisitHeaderXGroupGraphTokenMax).regex(getVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const getVisit404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getVisit404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getVisit404ResponseOverlapWarningAcknowledgementMin = 16;
export const getVisit404ResponseOverlapWarningAcknowledgementMax = 256;


export const getVisit404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetVisit404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getVisit404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getVisit404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getVisit404ResponseOverlapWarningAcknowledgementMin).max(getVisit404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getVisit404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Cancel an expected visit
 */
export const CancelVisitParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const cancelVisitHeaderXGroupGraphTokenMax = 16384;


export const cancelVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CancelVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(cancelVisitHeaderXGroupGraphTokenMax).regex(cancelVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const CancelVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const cancelVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const cancelVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const cancelVisit409ResponseOverlapWarningAcknowledgementMin = 16;
export const cancelVisit409ResponseOverlapWarningAcknowledgementMax = 256;


export const cancelVisit409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CancelVisit409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(cancelVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(cancelVisit409ResponseOverlapWarningAcknowledgementMin).max(cancelVisit409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(cancelVisit409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Front-desk check-in (notifies host)
 */
export const CheckInVisitParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const checkInVisitHeaderXGroupGraphTokenMax = 16384;


export const checkInVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CheckInVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(checkInVisitHeaderXGroupGraphTokenMax).regex(checkInVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const CheckInVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const checkInVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInVisit403ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInVisit403ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInVisit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInVisit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInVisit403ResponseOverlapWarningAcknowledgementMin).max(checkInVisit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInVisit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkInVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInVisit409ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInVisit409ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInVisit409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInVisit409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInVisit409ResponseOverlapWarningAcknowledgementMin).max(checkInVisit409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInVisit409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const checkInVisit422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkInVisit422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkInVisit422ResponseOverlapWarningAcknowledgementMin = 16;
export const checkInVisit422ResponseOverlapWarningAcknowledgementMax = 256;


export const checkInVisit422ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckInVisit422Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit422ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkInVisit422ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkInVisit422ResponseOverlapWarningAcknowledgementMin).max(checkInVisit422ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkInVisit422ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Front-desk check-out
 */
export const CheckOutVisitParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const checkOutVisitHeaderXGroupGraphTokenMax = 16384;


export const checkOutVisitHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CheckOutVisitHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(checkOutVisitHeaderXGroupGraphTokenMax).regex(checkOutVisitHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const CheckOutVisit200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
}))()

export const checkOutVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const checkOutVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const checkOutVisit409ResponseOverlapWarningAcknowledgementMin = 16;
export const checkOutVisit409ResponseOverlapWarningAcknowledgementMax = 256;


export const checkOutVisit409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CheckOutVisit409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutVisit409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(checkOutVisit409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(checkOutVisit409ResponseOverlapWarningAcknowledgementMin).max(checkOutVisit409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(checkOutVisit409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Requires visitors:admin. Defaults to full history within filters.
 * @summary Admin visitor log with optional CSV export
 */
export const listAdminVisitsQueryQMax = 100;

export const listAdminVisitsQueryLimitDefault = 100;
export const listAdminVisitsQueryLimitMax = 200;

export const listAdminVisitsQueryOffsetDefault = 0;
export const listAdminVisitsQueryOffsetMin = 0;

export const listAdminVisitsQueryFormatDefault = `json`;

export const ListAdminVisitsQueryParams = /*#__PURE__*/ (() => zod.object({
  "today": zod.boolean().optional(),
  "bookingId": zod.uuid().optional(),
  "hostUserId": zod.uuid().optional(),
  "status": zod.string().optional(),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "q": zod.string().max(listAdminVisitsQueryQMax).optional(),
  "limit": zod.int().min(1).max(listAdminVisitsQueryLimitMax).default(listAdminVisitsQueryLimitDefault),
  "offset": zod.int().min(listAdminVisitsQueryOffsetMin).default(listAdminVisitsQueryOffsetDefault),
  "format": zod.enum(['json', 'csv']).default(listAdminVisitsQueryFormatDefault)
}))()

export const listAdminVisitsHeaderXGroupGraphTokenMax = 16384;


export const listAdminVisitsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListAdminVisitsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listAdminVisitsHeaderXGroupGraphTokenMax).regex(listAdminVisitsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listAdminVisits200ResponseTotalMin = 0;



export const ListAdminVisits200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "visitorId": zod.uuid().nullish(),
  "hostUserId": zod.uuid(),
  "hostDisplayName": zod.string().nullish(),
  "hostEmail": zod.string().nullish(),
  "bookingId": zod.uuid().nullish(),
  "siteId": zod.uuid().nullish(),
  "siteName": zod.string().nullish(),
  "timezone": zod.string().nullish().describe('Timezone of the visit site; absent for visits without a site.'),
  "buildingId": zod.uuid().nullish(),
  "buildingName": zod.string().nullish(),
  "visitorName": zod.string(),
  "visitorEmail": zod.string().nullish(),
  "visitorCompany": zod.string().nullish(),
  "expectedStart": zod.iso.datetime({"offset":true}),
  "expectedEnd": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['expected', 'checked_in', 'checked_out', 'cancelled', 'no_show']),
  "notes": zod.string().nullish(),
  "checkedInAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedOutAt": zod.iso.datetime({"offset":true}).nullish(),
  "checkedInByUserId": zod.uuid().nullish(),
  "cancelledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdByUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "bookingTitle": zod.string().nullish(),
  "spaceName": zod.string().nullish()
})),
  "total": zod.int().min(listAdminVisits200ResponseTotalMin)
}))()

export const listAdminVisits403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listAdminVisits403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listAdminVisits403ResponseOverlapWarningAcknowledgementMin = 16;
export const listAdminVisits403ResponseOverlapWarningAcknowledgementMax = 256;


export const listAdminVisits403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListAdminVisits403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminVisits403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listAdminVisits403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listAdminVisits403ResponseOverlapWarningAcknowledgementMin).max(listAdminVisits403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listAdminVisits403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns favourite spaces for the caller (newest first), with optional availability annotation for a booking window. Per-user; never includes other users' favourites.
 * @summary List the signed-in user's favourite spaces
 */
export const listMyFavouritesQueryLimitDefault = 20;
export const listMyFavouritesQueryLimitMax = 50;



export const ListMyFavouritesQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}).optional().describe('Window start (ISO-8601). When both start and end are set, items include available + reasons.'),
  "end": zod.iso.datetime({"offset":true}).optional().describe('Window end (ISO-8601, exclusive).'),
  "limit": zod.int().min(1).max(listMyFavouritesQueryLimitMax).default(listMyFavouritesQueryLimitDefault)
}))()

export const listMyFavouritesHeaderXGroupGraphTokenMax = 16384;


export const listMyFavouritesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyFavouritesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyFavouritesHeaderXGroupGraphTokenMax).regex(listMyFavouritesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const listMyFavourites200ResponseItemsItemSpaceMapOutlineOneMax = 12;

export const listMyFavourites200ResponseTotalMin = 0;

export const listMyFavourites200ResponseLimitMax = 50;



export const ListMyFavourites200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneMin).max(listMyFavourites200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "available": zod.boolean().nullish().describe('Present when start/end were provided on list. True when the space can be reserved for that window; false when blocked, inactive, or non-bookable.\n'),
  "reasons": zod.array(zod.enum(['AVAILABLE', 'CONFLICT', 'UNAVAILABLE_MODE', 'RETIRED', 'INACTIVE'])).optional().describe('Reason codes when available is false (or empty when free / no window)'),
  "reasonDetail": zod.string().nullish()
})),
  "total": zod.int().min(listMyFavourites200ResponseTotalMin),
  "limit": zod.int().min(1).max(listMyFavourites200ResponseLimitMax),
  "windowStart": zod.iso.datetime({"offset":true}).nullish(),
  "windowEnd": zod.iso.datetime({"offset":true}).nullish()
}))()

export const listMyFavourites400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyFavourites400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyFavourites400ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyFavourites400ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyFavourites400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyFavourites400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyFavourites400ResponseOverlapWarningAcknowledgementMin).max(listMyFavourites400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyFavourites400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyFavourites401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyFavourites401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyFavourites401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyFavourites401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyFavourites401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyFavourites401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyFavourites401ResponseOverlapWarningAcknowledgementMin).max(listMyFavourites401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyFavourites401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyFavourites409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyFavourites409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyFavourites409ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyFavourites409ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyFavourites409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyFavourites409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyFavourites409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyFavourites409ResponseOverlapWarningAcknowledgementMin).max(listMyFavourites409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyFavourites409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Favourites the given space for the caller. Idempotent when already favourited. Enforces a per-user cap (20).
 * @summary Add a space to the signed-in user's favourites
 */
export const PutMyFavouriteParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid()
}))()

export const putMyFavouriteHeaderXGroupGraphTokenMax = 16384;


export const putMyFavouriteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutMyFavouriteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putMyFavouriteHeaderXGroupGraphTokenMax).regex(putMyFavouriteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const putMyFavourite200ResponseSpaceMapOutlineOneItemXMin = 0;
export const putMyFavourite200ResponseSpaceMapOutlineOneItemXMax = 1000;

export const putMyFavourite200ResponseSpaceMapOutlineOneItemYMin = 0;
export const putMyFavourite200ResponseSpaceMapOutlineOneItemYMax = 1000;

export const putMyFavourite200ResponseSpaceMapOutlineOneMin = 3;
export const putMyFavourite200ResponseSpaceMapOutlineOneMax = 12;



export const PutMyFavourite200Response = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(putMyFavourite200ResponseSpaceMapOutlineOneItemXMin).max(putMyFavourite200ResponseSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(putMyFavourite200ResponseSpaceMapOutlineOneItemYMin).max(putMyFavourite200ResponseSpaceMapOutlineOneItemYMax)
})).min(putMyFavourite200ResponseSpaceMapOutlineOneMin).max(putMyFavourite200ResponseSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "available": zod.boolean().nullish().describe('Present when start/end were provided on list. True when the space can be reserved for that window; false when blocked, inactive, or non-bookable.\n'),
  "reasons": zod.array(zod.enum(['AVAILABLE', 'CONFLICT', 'UNAVAILABLE_MODE', 'RETIRED', 'INACTIVE'])).optional().describe('Reason codes when available is false (or empty when free / no window)'),
  "reasonDetail": zod.string().nullish()
}))()

export const putMyFavourite400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyFavourite400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyFavourite400ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyFavourite400ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyFavourite400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyFavourite400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyFavourite400ResponseOverlapWarningAcknowledgementMin).max(putMyFavourite400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyFavourite400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyFavourite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyFavourite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyFavourite401ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyFavourite401ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyFavourite401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyFavourite401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyFavourite401ResponseOverlapWarningAcknowledgementMin).max(putMyFavourite401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyFavourite401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyFavourite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyFavourite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyFavourite404ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyFavourite404ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyFavourite404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyFavourite404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyFavourite404ResponseOverlapWarningAcknowledgementMin).max(putMyFavourite404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyFavourite404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putMyFavourite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putMyFavourite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putMyFavourite409ResponseOverlapWarningAcknowledgementMin = 16;
export const putMyFavourite409ResponseOverlapWarningAcknowledgementMax = 256;


export const putMyFavourite409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutMyFavourite409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putMyFavourite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putMyFavourite409ResponseOverlapWarningAcknowledgementMin).max(putMyFavourite409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putMyFavourite409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Idempotent — returns 204 even when the favourite was not present.
 * @summary Remove a space from the signed-in user's favourites
 */
export const DeleteMyFavouriteParams = /*#__PURE__*/ (() => zod.object({
  "spaceId": zod.uuid()
}))()

export const deleteMyFavouriteHeaderXGroupGraphTokenMax = 16384;


export const deleteMyFavouriteHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteMyFavouriteHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteMyFavouriteHeaderXGroupGraphTokenMax).regex(deleteMyFavouriteHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteMyFavourite204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteMyFavourite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteMyFavourite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteMyFavourite401ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteMyFavourite401ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteMyFavourite401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteMyFavourite401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteMyFavourite401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteMyFavourite401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteMyFavourite401ResponseOverlapWarningAcknowledgementMin).max(deleteMyFavourite401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteMyFavourite401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteMyFavourite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteMyFavourite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteMyFavourite409ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteMyFavourite409ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteMyFavourite409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteMyFavourite409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteMyFavourite409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteMyFavourite409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteMyFavourite409ResponseOverlapWarningAcknowledgementMin).max(deleteMyFavourite409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteMyFavourite409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns spaces the caller booked most recently/frequently (last 90 days), one row per space, with optional availability for a chosen window. Never auto-books — powered by the Book page Book-again rail.
 * @summary Recent/frequent spaces for one-tap book-again
 */
export const listMyBookAgainQueryLimitDefault = 8;
export const listMyBookAgainQueryLimitMax = 20;



export const ListMyBookAgainQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}).optional().describe('Window start (ISO-8601). When both start and end are set, items include available + reasons.'),
  "end": zod.iso.datetime({"offset":true}).optional().describe('Window end (ISO-8601, exclusive).'),
  "limit": zod.int().min(1).max(listMyBookAgainQueryLimitMax).default(listMyBookAgainQueryLimitDefault)
}))()

export const listMyBookAgainHeaderXGroupGraphTokenMax = 16384;


export const listMyBookAgainHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyBookAgainHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyBookAgainHeaderXGroupGraphTokenMax).regex(listMyBookAgainHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneMax = 12;


export const listMyBookAgain200ResponseItemsItemTypicalDurationMinutesMin = 15;

export const listMyBookAgain200ResponseTotalMin = 0;




export const ListMyBookAgain200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneMin).max(listMyBookAgain200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "bookingCount": zod.int().min(1),
  "lastBookedAt": zod.iso.datetime({"offset":true}),
  "lastStart": zod.iso.datetime({"offset":true}),
  "lastEnd": zod.iso.datetime({"offset":true}),
  "typicalDurationMinutes": zod.int().min(listMyBookAgain200ResponseItemsItemTypicalDurationMinutesMin),
  "available": zod.boolean().nullish(),
  "reasons": zod.array(zod.string()).optional(),
  "reasonDetail": zod.string().nullish(),
  "isFavourite": zod.boolean().describe('Space is starred by the caller')
})),
  "total": zod.int().min(listMyBookAgain200ResponseTotalMin),
  "limit": zod.int().min(1),
  "windowStart": zod.iso.datetime({"offset":true}).nullish(),
  "windowEnd": zod.iso.datetime({"offset":true}).nullish()
}))()

export const listMyBookAgain400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyBookAgain400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyBookAgain400ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyBookAgain400ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyBookAgain400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyBookAgain400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyBookAgain400ResponseOverlapWarningAcknowledgementMin).max(listMyBookAgain400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyBookAgain400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyBookAgain401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyBookAgain401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyBookAgain401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyBookAgain401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyBookAgain401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyBookAgain401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyBookAgain401ResponseOverlapWarningAcknowledgementMin).max(listMyBookAgain401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyBookAgain401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyBookAgain409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyBookAgain409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyBookAgain409ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyBookAgain409ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyBookAgain409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyBookAgain409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookAgain409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyBookAgain409ResponseOverlapWarningAcknowledgementMin).max(listMyBookAgain409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyBookAgain409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Read-only, at most fourteen calendar days starting today. Uses saved office hours, current beneficiary booking coverage, favourite then regular spaces, and current booking eligibility/availability. Requires current entity, self-booking, effective booking and work-planning modules and published Home admission. Unknown coverage or availability never proves an unbooked or available space. Never reserves. Simplified Home may opt into one additional unplanned-today row after complete booking coverage, using the usual office or the supplied device timezone.
 * @summary Available personal spaces for unbooked office days
 */
export const listMyOfficeDaySuggestionsQueryTimeZoneMax = 100;



export const ListMyOfficeDaySuggestionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "includeToday": zod.boolean().optional().describe('Include today\'s fallback when no booking or planned-office card exists.'),
  "timeZone": zod.string().max(listMyOfficeDaySuggestionsQueryTimeZoneMax).optional().describe('Valid IANA device timezone, required with includeToday; usual-office timezone takes priority.')
}))()

export const listMyOfficeDaySuggestionsHeaderXGroupGraphTokenMax = 16384;


export const listMyOfficeDaySuggestionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyOfficeDaySuggestionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyOfficeDaySuggestionsHeaderXGroupGraphTokenMax).regex(listMyOfficeDaySuggestionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemXMin = 0;
export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemXMax = 1000;

export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemYMin = 0;
export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemYMax = 1000;

export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneMin = 3;
export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneMax = 12;

export const listMyOfficeDaySuggestions200ResponseItemsItemSuggestionOccurrenceCountMin = 0;

export const listMyOfficeDaySuggestions200ResponseItemsMax = 15;



export const ListMyOfficeDaySuggestions200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "organizationId": zod.uuid(),
  "userId": zod.uuid(),
  "items": zod.array(zod.object({
  "kind": zod.enum(['today']).optional().describe('Unplanned today fallback; omitted for saved work-plan days.'),
  "date": zod.iso.date(),
  "state": zod.enum(['available', 'no_personal_match', 'availability_unknown', 'coverage_unknown', 'review_plan']),
  "explanation": zod.string(),
  "location": zod.object({
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "timeZone": zod.string().nullable()
}).nullable(),
  "locationSource": zod.union([zod.literal('planned'),zod.literal('usual'),zod.literal(null)]).nullable(),
  "start": zod.iso.datetime({"offset":true}).nullable(),
  "end": zod.iso.datetime({"offset":true}).nullable(),
  "officeStartTime": zod.string().nullable(),
  "officeEndTime": zod.string().nullable(),
  "suggestion": zod.object({
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemXMin).max(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemYMin).max(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneItemYMax)
})).min(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneMin).max(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "reason": zod.enum(['favourite', 'regular']),
  "occurrenceCount": zod.int().min(listMyOfficeDaySuggestions200ResponseItemsItemSuggestionOccurrenceCountMin),
  "availabilitySource": zod.enum(['app', 'app_fallback', 'exchange'])
}).nullable()
})).max(listMyOfficeDaySuggestions200ResponseItemsMax),
  "coverageComplete": zod.boolean(),
  "candidatesTruncated": zod.boolean()
}))()

export const ListMyOfficeDaySuggestions400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMyOfficeDaySuggestions401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMyOfficeDaySuggestions403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMyOfficeDaySuggestions409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Derives patterns from the caller's own bookings (last 90 days, frequency + recency) for space × weekday × start-hour. Patterns need at least 3 matching bookings. Dismissed patterns are omitted. Suggestions never auto-book.
 * @summary Habit-based booking suggestions for the signed-in user
 */
export const listMyBookingSuggestionsQueryLimitDefault = 5;
export const listMyBookingSuggestionsQueryLimitMax = 20;

export const listMyBookingSuggestionsQueryCheckAvailabilityDefault = true;

export const ListMyBookingSuggestionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listMyBookingSuggestionsQueryLimitMax).default(listMyBookingSuggestionsQueryLimitDefault),
  "checkAvailability": zod.boolean().default(listMyBookingSuggestionsQueryCheckAvailabilityDefault).describe('When true, annotates each next-slot with availability.'),
  "forStart": zod.iso.datetime({"offset":true}).optional().describe('Optional search window start to bias ranking toward matching weekday/hour.'),
  "forEnd": zod.iso.datetime({"offset":true}).optional()
}))()

export const listMyBookingSuggestionsHeaderXGroupGraphTokenMax = 16384;


export const listMyBookingSuggestionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyBookingSuggestionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyBookingSuggestionsHeaderXGroupGraphTokenMax).regex(listMyBookingSuggestionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemXMin = 0;
export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemXMax = 1000;

export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemYMin = 0;
export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemYMax = 1000;

export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneMin = 3;
export const listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneMax = 12;

export const listMyBookingSuggestions200ResponseItemsItemWeekdayMin = 0;
export const listMyBookingSuggestions200ResponseItemsItemWeekdayMax = 6;

export const listMyBookingSuggestions200ResponseItemsItemStartHourMin = 0;
export const listMyBookingSuggestions200ResponseItemsItemStartHourMax = 23;

export const listMyBookingSuggestions200ResponseItemsItemDurationMinutesMin = 15;
export const listMyBookingSuggestions200ResponseItemsItemDurationMinutesMax = 1440;






export const ListMyBookingSuggestions200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "patternKey": zod.string().describe('Stable id for dismiss (space:{uuid}|wd:{0-6}|h:{0-23})'),
  "space": zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "capacity": zod.int(),
  "layoutRequired": zod.boolean().optional(),
  "layouts": zod.array(zod.object({
  "id": zod.uuid(),
  "spaceId": zod.uuid(),
  "name": zod.string(),
  "capacity": zod.int().min(1),
  "active": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "mode": zod.string(),
  "zoneId": zod.uuid(),
  "zoneName": zod.string(),
  "floorId": zod.uuid(),
  "floorName": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeCode": zod.string(),
  "spaceTypeName": zod.string(),
  "availabilitySot": zod.string(),
  "tags": zod.array(zod.string()),
  "accessibility": zod.boolean(),
  "mapX": zod.int().nullish().describe('Floor-plan grid column (0-based)'),
  "mapY": zod.int().nullish().describe('Floor-plan grid row (0-based)'),
  "mapOutline": zod.union([zod.array(zod.object({
  "x": zod.number().min(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemXMin).max(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemXMax),
  "y": zod.number().min(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemYMin).max(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneItemYMax)
})).min(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneMin).max(listMyBookingSuggestions200ResponseItemsItemSpaceMapOutlineOneMax).describe('Resource outline in normalized 0–1000 floor-plan coordinates; the pin remains its anchor.'),zod.null()]).optional()
}),
  "weekday": zod.int().min(listMyBookingSuggestions200ResponseItemsItemWeekdayMin).max(listMyBookingSuggestions200ResponseItemsItemWeekdayMax).describe('Local weekday of the habit (0=Sunday)'),
  "weekdayLabel": zod.string(),
  "startHour": zod.int().min(listMyBookingSuggestions200ResponseItemsItemStartHourMin).max(listMyBookingSuggestions200ResponseItemsItemStartHourMax),
  "typicalStartTime": zod.string().optional().describe('Site-local HH:mm habit start (includes median minute)'),
  "durationMinutes": zod.int().min(listMyBookingSuggestions200ResponseItemsItemDurationMinutesMin).max(listMyBookingSuggestions200ResponseItemsItemDurationMinutesMax),
  "occurrenceCount": zod.int().min(1),
  "score": zod.number().describe('Frequency + recency score used for ranking'),
  "nextStart": zod.iso.datetime({"offset":true}),
  "nextEnd": zod.iso.datetime({"offset":true}),
  "summary": zod.string().describe('Human-readable habit line for UI cards'),
  "available": zod.boolean().nullish().describe('Next-slot availability when checkAvailability was true'),
  "reasonDetail": zod.string().nullish(),
  "isFavourite": zod.boolean().describe('Space is starred by the caller'),
  "nearTeam": zod.boolean().describe('Teammates plan or booked nearby that day'),
  "reasons": zod.array(zod.enum(['history', 'favourite', 'near_team'])).describe('Why this item ranked')
})),
  "historyDays": zod.int().min(1),
  "minOccurrences": zod.int().min(1).describe('Minimum matching bookings required before a pattern is suggested'),
  "favouriteSpaceIds": zod.array(zod.uuid()).optional(),
  "nearTeamFloorIds": zod.array(zod.uuid()).optional(),
  "nearTeamBuildingIds": zod.array(zod.uuid()).optional()
}))()

export const listMyBookingSuggestions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyBookingSuggestions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyBookingSuggestions401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyBookingSuggestions401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyBookingSuggestions401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyBookingSuggestions401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookingSuggestions401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookingSuggestions401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyBookingSuggestions401ResponseOverlapWarningAcknowledgementMin).max(listMyBookingSuggestions401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyBookingSuggestions401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyBookingSuggestions409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyBookingSuggestions409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyBookingSuggestions409ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyBookingSuggestions409ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyBookingSuggestions409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyBookingSuggestions409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookingSuggestions409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyBookingSuggestions409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyBookingSuggestions409ResponseOverlapWarningAcknowledgementMin).max(listMyBookingSuggestions409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyBookingSuggestions409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Hides the pattern for the signed-in user across sessions. Key is the patternKey from listMyBookingSuggestions (URL-encode before use).
 * @summary Persistently dismiss a habit suggestion pattern
 */
export const dismissMyBookingSuggestionPathKeyMax = 200;



export const DismissMyBookingSuggestionParams = /*#__PURE__*/ (() => zod.object({
  "key": zod.string().min(1).max(dismissMyBookingSuggestionPathKeyMax).describe('Pattern key, e.g. space:{uuid}|wd:2|h:9 (URL-encoded)')
}))()

export const dismissMyBookingSuggestionHeaderXGroupGraphTokenMax = 16384;


export const dismissMyBookingSuggestionHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DismissMyBookingSuggestionHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(dismissMyBookingSuggestionHeaderXGroupGraphTokenMax).regex(dismissMyBookingSuggestionHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DismissMyBookingSuggestion204Response = /*#__PURE__*/ (() => zod.void())()

export const dismissMyBookingSuggestion400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const dismissMyBookingSuggestion400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const dismissMyBookingSuggestion400ResponseOverlapWarningAcknowledgementMin = 16;
export const dismissMyBookingSuggestion400ResponseOverlapWarningAcknowledgementMax = 256;


export const dismissMyBookingSuggestion400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DismissMyBookingSuggestion400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(dismissMyBookingSuggestion400ResponseOverlapWarningAcknowledgementMin).max(dismissMyBookingSuggestion400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(dismissMyBookingSuggestion400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const dismissMyBookingSuggestion401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const dismissMyBookingSuggestion401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const dismissMyBookingSuggestion401ResponseOverlapWarningAcknowledgementMin = 16;
export const dismissMyBookingSuggestion401ResponseOverlapWarningAcknowledgementMax = 256;


export const dismissMyBookingSuggestion401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DismissMyBookingSuggestion401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(dismissMyBookingSuggestion401ResponseOverlapWarningAcknowledgementMin).max(dismissMyBookingSuggestion401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(dismissMyBookingSuggestion401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const dismissMyBookingSuggestion409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const dismissMyBookingSuggestion409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const dismissMyBookingSuggestion409ResponseOverlapWarningAcknowledgementMin = 16;
export const dismissMyBookingSuggestion409ResponseOverlapWarningAcknowledgementMax = 256;


export const dismissMyBookingSuggestion409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DismissMyBookingSuggestion409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(dismissMyBookingSuggestion409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(dismissMyBookingSuggestion409ResponseOverlapWarningAcknowledgementMin).max(dismissMyBookingSuggestion409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(dismissMyBookingSuggestion409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List workgroups the signed-in user belongs to
 */
export const listMyWorkgroupsHeaderXGroupGraphTokenMax = 16384;


export const listMyWorkgroupsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyWorkgroupsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyWorkgroupsHeaderXGroupGraphTokenMax).regex(listMyWorkgroupsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listMyWorkgroups200ResponseItemsItemMemberCountMin = 0;

export const listMyWorkgroups200ResponseTotalMin = 0;



export const ListMyWorkgroups200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(listMyWorkgroups200ResponseItemsItemMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMyWorkgroups200ResponseTotalMin)
}))()

export const listMyWorkgroups401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyWorkgroups401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyWorkgroups401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyWorkgroups401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyWorkgroups401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyWorkgroups401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyWorkgroups401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyWorkgroups401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyWorkgroups401ResponseOverlapWarningAcknowledgementMin).max(listMyWorkgroups401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyWorkgroups401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a workgroup (caller becomes owner)
 */
export const createWorkgroupHeaderXGroupGraphTokenMax = 16384;


export const createWorkgroupHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateWorkgroupHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createWorkgroupHeaderXGroupGraphTokenMax).regex(createWorkgroupHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createWorkgroupBodyNameMax = 120;

export const createWorkgroupBodyDescriptionMax = 500;



export const CreateWorkgroupBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(createWorkgroupBodyNameMax),
  "description": zod.string().max(createWorkgroupBodyDescriptionMax).nullish()
}))()

export const createWorkgroup201ResponseOneMemberCountMin = 0;

export const createWorkgroup201ResponseTwoGuidanceOneWeekdaysItemMin = 0;
export const createWorkgroup201ResponseTwoGuidanceOneWeekdaysItemMax = 6;



export const CreateWorkgroup201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(createWorkgroup201ResponseOneMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(createWorkgroup201ResponseTwoGuidanceOneWeekdaysItemMin).max(createWorkgroup201ResponseTwoGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()])
})))()

export const createWorkgroup400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createWorkgroup400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createWorkgroup400ResponseOverlapWarningAcknowledgementMin = 16;
export const createWorkgroup400ResponseOverlapWarningAcknowledgementMax = 256;


export const createWorkgroup400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateWorkgroup400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWorkgroup400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWorkgroup400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createWorkgroup400ResponseOverlapWarningAcknowledgementMin).max(createWorkgroup400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createWorkgroup400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createWorkgroup401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createWorkgroup401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createWorkgroup401ResponseOverlapWarningAcknowledgementMin = 16;
export const createWorkgroup401ResponseOverlapWarningAcknowledgementMax = 256;


export const createWorkgroup401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateWorkgroup401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWorkgroup401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createWorkgroup401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createWorkgroup401ResponseOverlapWarningAcknowledgementMin).max(createWorkgroup401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createWorkgroup401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get workgroup detail (members + guidance)
 */
export const GetWorkgroupParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getWorkgroupHeaderXGroupGraphTokenMax = 16384;


export const getWorkgroupHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkgroupHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkgroupHeaderXGroupGraphTokenMax).regex(getWorkgroupHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getWorkgroup200ResponseOneMemberCountMin = 0;

export const getWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMin = 0;
export const getWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMax = 6;



export const GetWorkgroup200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(getWorkgroup200ResponseOneMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(getWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMin).max(getWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()])
})))()

export const getWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getWorkgroup403ResponseOverlapWarningAcknowledgementMin = 16;
export const getWorkgroup403ResponseOverlapWarningAcknowledgementMax = 256;


export const getWorkgroup403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetWorkgroup403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getWorkgroup403ResponseOverlapWarningAcknowledgementMin).max(getWorkgroup403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getWorkgroup403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getWorkgroup404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getWorkgroup404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getWorkgroup404ResponseOverlapWarningAcknowledgementMin = 16;
export const getWorkgroup404ResponseOverlapWarningAcknowledgementMax = 256;


export const getWorkgroup404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetWorkgroup404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroup404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroup404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getWorkgroup404ResponseOverlapWarningAcknowledgementMin).max(getWorkgroup404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getWorkgroup404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update workgroup name/description (owner only)
 */
export const UpdateWorkgroupParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateWorkgroupHeaderXGroupGraphTokenMax = 16384;


export const updateWorkgroupHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateWorkgroupHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateWorkgroupHeaderXGroupGraphTokenMax).regex(updateWorkgroupHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateWorkgroupBodyNameMax = 120;

export const updateWorkgroupBodyDescriptionMax = 500;



export const UpdateWorkgroupBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(updateWorkgroupBodyNameMax).optional(),
  "description": zod.string().max(updateWorkgroupBodyDescriptionMax).nullish()
}))()

export const updateWorkgroup200ResponseOneMemberCountMin = 0;

export const updateWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMin = 0;
export const updateWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMax = 6;



export const UpdateWorkgroup200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(updateWorkgroup200ResponseOneMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(updateWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMin).max(updateWorkgroup200ResponseTwoGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()])
})))()

export const updateWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateWorkgroup403ResponseOverlapWarningAcknowledgementMin = 16;
export const updateWorkgroup403ResponseOverlapWarningAcknowledgementMax = 256;


export const updateWorkgroup403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateWorkgroup403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateWorkgroup403ResponseOverlapWarningAcknowledgementMin).max(updateWorkgroup403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateWorkgroup403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Delete a workgroup (owner only)
 */
export const DeleteWorkgroupParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteWorkgroupHeaderXGroupGraphTokenMax = 16384;


export const deleteWorkgroupHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteWorkgroupHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteWorkgroupHeaderXGroupGraphTokenMax).regex(deleteWorkgroupHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteWorkgroup200Response = /*#__PURE__*/ (() => zod.object({
  "deleted": zod.literal(true)
}))()

export const deleteWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteWorkgroup403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteWorkgroup403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteWorkgroup403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteWorkgroup403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteWorkgroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteWorkgroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteWorkgroup403ResponseOverlapWarningAcknowledgementMin).max(deleteWorkgroup403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteWorkgroup403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Add a member from the directory (owner only)
 */
export const AddWorkgroupMemberParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const addWorkgroupMemberHeaderXGroupGraphTokenMax = 16384;


export const addWorkgroupMemberHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AddWorkgroupMemberHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(addWorkgroupMemberHeaderXGroupGraphTokenMax).regex(addWorkgroupMemberHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const AddWorkgroupMemberBody = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const addWorkgroupMember200ResponseOneMemberCountMin = 0;

export const addWorkgroupMember200ResponseTwoGuidanceOneWeekdaysItemMin = 0;
export const addWorkgroupMember200ResponseTwoGuidanceOneWeekdaysItemMax = 6;



export const AddWorkgroupMember200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(addWorkgroupMember200ResponseOneMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(addWorkgroupMember200ResponseTwoGuidanceOneWeekdaysItemMin).max(addWorkgroupMember200ResponseTwoGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()])
})))()

export const addWorkgroupMember403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addWorkgroupMember403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addWorkgroupMember403ResponseOverlapWarningAcknowledgementMin = 16;
export const addWorkgroupMember403ResponseOverlapWarningAcknowledgementMax = 256;


export const addWorkgroupMember403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddWorkgroupMember403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addWorkgroupMember403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addWorkgroupMember403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addWorkgroupMember403ResponseOverlapWarningAcknowledgementMin).max(addWorkgroupMember403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addWorkgroupMember403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const addWorkgroupMember404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addWorkgroupMember404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addWorkgroupMember404ResponseOverlapWarningAcknowledgementMin = 16;
export const addWorkgroupMember404ResponseOverlapWarningAcknowledgementMax = 256;


export const addWorkgroupMember404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddWorkgroupMember404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addWorkgroupMember404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addWorkgroupMember404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addWorkgroupMember404ResponseOverlapWarningAcknowledgementMin).max(addWorkgroupMember404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addWorkgroupMember404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove a member (owner) or leave the group (self)
 */
export const RemoveWorkgroupMemberParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid()
}))()

export const removeWorkgroupMemberHeaderXGroupGraphTokenMax = 16384;


export const removeWorkgroupMemberHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveWorkgroupMemberHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeWorkgroupMemberHeaderXGroupGraphTokenMax).regex(removeWorkgroupMemberHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const removeWorkgroupMember200ResponseOneOneMemberCountMin = 0;

export const removeWorkgroupMember200ResponseOneTwoGuidanceOneWeekdaysItemMin = 0;
export const removeWorkgroupMember200ResponseOneTwoGuidanceOneWeekdaysItemMax = 6;



export const RemoveWorkgroupMember200Response = /*#__PURE__*/ (() => zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "ownerId": zod.uuid(),
  "memberCount": zod.int().min(removeWorkgroupMember200ResponseOneOneMemberCountMin),
  "myRole": zod.enum(['owner', 'member']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(removeWorkgroupMember200ResponseOneTwoGuidanceOneWeekdaysItemMin).max(removeWorkgroupMember200ResponseOneTwoGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()])
})),zod.object({
  "left": zod.literal(true)
})]))()

export const removeWorkgroupMember403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeWorkgroupMember403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeWorkgroupMember403ResponseOverlapWarningAcknowledgementMin = 16;
export const removeWorkgroupMember403ResponseOverlapWarningAcknowledgementMax = 256;


export const removeWorkgroupMember403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveWorkgroupMember403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeWorkgroupMember403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeWorkgroupMember403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeWorkgroupMember403ResponseOverlapWarningAcknowledgementMin).max(removeWorkgroupMember403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeWorkgroupMember403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Members only. Presence is privacy-trimmed; shared membership satisfies
 * the workgroups sharing level. Private subjects remain hidden.
 * @summary Team week presence grid for a workgroup
 */
export const GetWorkgroupWeekParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const GetWorkgroupWeekQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date()
}))()

export const getWorkgroupWeekHeaderXGroupGraphTokenMax = 16384;


export const getWorkgroupWeekHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkgroupWeekHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkgroupWeekHeaderXGroupGraphTokenMax).regex(getWorkgroupWeekHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getWorkgroupWeek200ResponseGuidanceOneWeekdaysItemMin = 0;
export const getWorkgroupWeek200ResponseGuidanceOneWeekdaysItemMax = 6;

export const getWorkgroupWeek200ResponseMembersItemTwoPresenceDaysItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkgroupWeek200ResponseMembersItemTwoPresenceDaysItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');


export const GetWorkgroupWeek200Response = /*#__PURE__*/ (() => zod.object({
  "workgroupId": zod.uuid(),
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "guidance": zod.union([zod.object({
  "weekdays": zod.array(zod.int().min(getWorkgroupWeek200ResponseGuidanceOneWeekdaysItemMin).max(getWorkgroupWeek200ResponseGuidanceOneWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}),zod.null()]),
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "role": zod.enum(['owner', 'member']),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "joinedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "presence": zod.object({
  "userId": zod.uuid(),
  "days": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "officeStartTime": zod.string().regex(getWorkgroupWeek200ResponseMembersItemTwoPresenceDaysItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(getWorkgroupWeek200ResponseMembersItemTwoPresenceDaysItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "officeHoursSource": zod.union([zod.literal('dated'),zod.literal('recurring'),zod.literal('timed'),zod.literal('ambiguous'),zod.literal(null)]).nullish().describe('Ambiguous timed days have no usable single-office window and must not receive default hours or an inferred office.'),
  "officeStartAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact original start for an unambiguous timed stop, preserving timestamp precision.'),
  "officeEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "source": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable()
})),
  "visible": zod.boolean(),
  "sharingLevel": zod.union([zod.enum(['everyone', 'workgroups', 'selected', 'private']),zod.null()])
})
})))
}))()

export const getWorkgroupWeek403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getWorkgroupWeek403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getWorkgroupWeek403ResponseOverlapWarningAcknowledgementMin = 16;
export const getWorkgroupWeek403ResponseOverlapWarningAcknowledgementMax = 256;


export const getWorkgroupWeek403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetWorkgroupWeek403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroupWeek403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroupWeek403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getWorkgroupWeek403ResponseOverlapWarningAcknowledgementMin).max(getWorkgroupWeek403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getWorkgroupWeek403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Publish recommended office days (owner only)
 */
export const SetWorkgroupGuidanceParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const setWorkgroupGuidanceHeaderXGroupGraphTokenMax = 16384;


export const setWorkgroupGuidanceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetWorkgroupGuidanceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setWorkgroupGuidanceHeaderXGroupGraphTokenMax).regex(setWorkgroupGuidanceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setWorkgroupGuidanceBodyWeekdaysItemMin = 0;
export const setWorkgroupGuidanceBodyWeekdaysItemMax = 6;

export const setWorkgroupGuidanceBodyWeekdaysMax = 7;

export const setWorkgroupGuidanceBodyNoteMax = 1000;



export const SetWorkgroupGuidanceBody = /*#__PURE__*/ (() => zod.object({
  "weekdays": zod.array(zod.int().min(setWorkgroupGuidanceBodyWeekdaysItemMin).max(setWorkgroupGuidanceBodyWeekdaysItemMax)).max(setWorkgroupGuidanceBodyWeekdaysMax),
  "buildingId": zod.uuid().nullish(),
  "note": zod.string().max(setWorkgroupGuidanceBodyNoteMax).nullish()
}))()

export const setWorkgroupGuidance200ResponseWeekdaysItemMin = 0;
export const setWorkgroupGuidance200ResponseWeekdaysItemMax = 6;



export const SetWorkgroupGuidance200Response = /*#__PURE__*/ (() => zod.object({
  "weekdays": zod.array(zod.int().min(setWorkgroupGuidance200ResponseWeekdaysItemMin).max(setWorkgroupGuidance200ResponseWeekdaysItemMax)).describe('0 = Sunday … 6 = Saturday'),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "note": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedByUserId": zod.uuid().nullable()
}))()

export const setWorkgroupGuidance403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setWorkgroupGuidance403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setWorkgroupGuidance403ResponseOverlapWarningAcknowledgementMin = 16;
export const setWorkgroupGuidance403ResponseOverlapWarningAcknowledgementMax = 256;


export const setWorkgroupGuidance403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetWorkgroupGuidance403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setWorkgroupGuidance403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setWorkgroupGuidance403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setWorkgroupGuidance403ResponseOverlapWarningAcknowledgementMin).max(setWorkgroupGuidance403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setWorkgroupGuidance403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Owner-only. Returns privacy-trimmed desk bookings for each team member.
 * Members with `private` sharing level are invisible regardless of team
 * membership.
 * @summary Team member desk bookings for a date range (owner only)
 */
export const GetWorkgroupBookingsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const GetWorkgroupBookingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date()
}))()

export const getWorkgroupBookingsHeaderXGroupGraphTokenMax = 16384;


export const getWorkgroupBookingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkgroupBookingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkgroupBookingsHeaderXGroupGraphTokenMax).regex(getWorkgroupBookingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetWorkgroupBookings200Response = /*#__PURE__*/ (() => zod.object({
  "workgroupId": zod.uuid(),
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "members": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string(),
  "role": zod.enum(['owner', 'member']),
  "visible": zod.boolean(),
  "bookings": zod.array(zod.object({
  "bookingId": zod.uuid(),
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceCode": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "timezone": zod.string().nullish().describe('Site timezone for this disclosed booking'),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "status": zod.string()
}))
}))
}))()

export const getWorkgroupBookings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getWorkgroupBookings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getWorkgroupBookings403ResponseOverlapWarningAcknowledgementMin = 16;
export const getWorkgroupBookings403ResponseOverlapWarningAcknowledgementMax = 256;


export const getWorkgroupBookings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetWorkgroupBookings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroupBookings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getWorkgroupBookings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getWorkgroupBookings403ResponseOverlapWarningAcknowledgementMin).max(getWorkgroupBookings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getWorkgroupBookings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns materialised presence only when the subject's sharing level
 * allows the viewer to see it. Private users are never visible to others.
 * @summary Privacy-trimmed presence for one or more users
 */
export const GetUsersPresenceQueryParams = /*#__PURE__*/ (() => zod.object({
  "userIds": zod.string().describe('Comma-separated user UUIDs (max 50)'),
  "from": zod.iso.date(),
  "to": zod.iso.date()
}))()

export const getUsersPresenceHeaderXGroupGraphTokenMax = 16384;


export const getUsersPresenceHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetUsersPresenceHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getUsersPresenceHeaderXGroupGraphTokenMax).regex(getUsersPresenceHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getUsersPresence200ResponseItemsItemDaysItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getUsersPresence200ResponseItemsItemDaysItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');


export const GetUsersPresence200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "days": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "officeStartTime": zod.string().regex(getUsersPresence200ResponseItemsItemDaysItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(getUsersPresence200ResponseItemsItemDaysItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "officeHoursSource": zod.union([zod.literal('dated'),zod.literal('recurring'),zod.literal('timed'),zod.literal('ambiguous'),zod.literal(null)]).nullish().describe('Ambiguous timed days have no usable single-office window and must not receive default hours or an inferred office.'),
  "officeStartAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact original start for an unambiguous timed stop, preserving timestamp precision.'),
  "officeEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "source": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable()
})),
  "visible": zod.boolean(),
  "sharingLevel": zod.union([zod.enum(['everyone', 'workgroups', 'selected', 'private']),zod.null()])
}))
}))()

export const getUsersPresence400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUsersPresence400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUsersPresence400ResponseOverlapWarningAcknowledgementMin = 16;
export const getUsersPresence400ResponseOverlapWarningAcknowledgementMax = 256;


export const getUsersPresence400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUsersPresence400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUsersPresence400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUsersPresence400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUsersPresence400ResponseOverlapWarningAcknowledgementMin).max(getUsersPresence400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUsersPresence400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getUsersPresence401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getUsersPresence401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getUsersPresence401ResponseOverlapWarningAcknowledgementMin = 16;
export const getUsersPresence401ResponseOverlapWarningAcknowledgementMax = 256;


export const getUsersPresence401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetUsersPresence401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUsersPresence401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getUsersPresence401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getUsersPresence401ResponseOverlapWarningAcknowledgementMin).max(getUsersPresence401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getUsersPresence401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Matches directory users by name or email. Presence status and building
 * are included only when the subject's sharing level allows the viewer.
 * Private users appear in results without presence fields.
 * @summary Search people with privacy-trimmed presence and same-building flag
 */
export const searchColleaguesQueryQMax = 120;

export const searchColleaguesQueryLimitDefault = 20;
export const searchColleaguesQueryLimitMax = 50;



export const SearchColleaguesQueryParams = /*#__PURE__*/ (() => zod.object({
  "q": zod.string().min(1).max(searchColleaguesQueryQMax).describe('Name or email search text'),
  "date": zod.iso.date().optional().describe('Day used for today status and same-building (defaults to local today)'),
  "limit": zod.int().min(1).max(searchColleaguesQueryLimitMax).default(searchColleaguesQueryLimitDefault)
}))()

export const searchColleaguesHeaderXGroupGraphTokenMax = 16384;


export const searchColleaguesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SearchColleaguesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(searchColleaguesHeaderXGroupGraphTokenMax).regex(searchColleaguesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const searchColleagues200ResponseTotalMin = 0;



export const SearchColleagues200Response = /*#__PURE__*/ (() => zod.object({
  "date": zod.iso.date(),
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "presenceVisible": zod.boolean().describe('False when privacy hides presence from the viewer'),
  "todayStatus": zod.union([zod.enum(['office', 'remote', 'off', 'unknown']),zod.null()]),
  "todayBuildingId": zod.uuid().nullable(),
  "todayBuildingName": zod.string().nullable(),
  "sameBuildingToday": zod.boolean().describe('True when viewer and colleague are both office in the same building today')
})),
  "total": zod.int().min(searchColleagues200ResponseTotalMin)
}))()

export const searchColleagues400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchColleagues400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchColleagues400ResponseOverlapWarningAcknowledgementMin = 16;
export const searchColleagues400ResponseOverlapWarningAcknowledgementMax = 256;


export const searchColleagues400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchColleagues400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchColleagues400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchColleagues400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchColleagues400ResponseOverlapWarningAcknowledgementMin).max(searchColleagues400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchColleagues400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchColleagues401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchColleagues401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchColleagues401ResponseOverlapWarningAcknowledgementMin = 16;
export const searchColleagues401ResponseOverlapWarningAcknowledgementMax = 256;


export const searchColleagues401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchColleagues401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchColleagues401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchColleagues401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchColleagues401ResponseOverlapWarningAcknowledgementMin).max(searchColleagues401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchColleagues401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns the subject's week plan only when privacy allows. Shared
 * workgroup names are always listed when membership overlaps.
 * @summary Colleague week presence, shared workgroups, and same-building flag
 */
export const GetColleagueWeekParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const GetColleagueWeekQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date().optional().describe('Week start (YYYY-MM-DD). Defaults to Monday of the date week.'),
  "to": zod.iso.date().optional().describe('Week end (YYYY-MM-DD). Defaults to Sunday of the date week.'),
  "date": zod.iso.date().optional().describe('Day used for today fields / same-building (defaults to local today)')
}))()

export const getColleagueWeekHeaderXGroupGraphTokenMax = 16384;


export const getColleagueWeekHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetColleagueWeekHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getColleagueWeekHeaderXGroupGraphTokenMax).regex(getColleagueWeekHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getColleagueWeek200ResponseDaysItemOfficeStartTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getColleagueWeek200ResponseDaysItemOfficeEndTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');


export const GetColleagueWeek200Response = /*#__PURE__*/ (() => zod.object({
  "deskBooking": zod.union([zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "floorId": zod.uuid(),
  "buildingName": zod.string(),
  "siteName": zod.string(),
  "timezone": zod.string().nullish().describe('Site timezone for the disclosed booking, without exposing additional location details'),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "teamsUserId": zod.uuid().nullable().describe('Entra user ID only when this viewer may request Teams presence'),
  "userId": zod.uuid(),
  "displayName": zod.string().nullable(),
  "email": zod.string(),
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "presenceVisible": zod.boolean(),
  "days": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "date": zod.iso.date(),
  "status": zod.enum(['office', 'remote', 'off', 'unknown']),
  "buildingId": zod.uuid().nullable(),
  "buildingName": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "officeStartTime": zod.string().regex(getColleagueWeek200ResponseDaysItemOfficeStartTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeEndTime": zod.string().regex(getColleagueWeek200ResponseDaysItemOfficeEndTimeRegExp).nullish().describe('Same-day local office time. Supply start and end together, with end after start. Omitted fields preserve compatible custom hours; null pairs restore 09:00-17:00 defaults for office days.'),
  "officeTimeZone": zod.string().nullish().describe('Selected office site IANA timezone; null when unknown. Never use the browser timezone as a substitute.'),
  "officeHoursSource": zod.union([zod.literal('dated'),zod.literal('recurring'),zod.literal('timed'),zod.literal('ambiguous'),zod.literal(null)]).nullish().describe('Ambiguous timed days have no usable single-office window and must not receive default hours or an inferred office.'),
  "officeStartAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact original start for an unambiguous timed stop, preserving timestamp precision.'),
  "officeEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "source": zod.union([zod.literal('manual'),zod.literal('recurring'),zod.literal(null)]).nullable()
})),
  "sameBuildingToday": zod.boolean(),
  "todayStatus": zod.union([zod.enum(['office', 'remote', 'off', 'unknown']),zod.null()]),
  "todayBuildingId": zod.uuid().nullable(),
  "todayBuildingName": zod.string().nullable(),
  "sharedWorkgroups": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}))
}))()

export const getColleagueWeek400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getColleagueWeek400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getColleagueWeek400ResponseOverlapWarningAcknowledgementMin = 16;
export const getColleagueWeek400ResponseOverlapWarningAcknowledgementMax = 256;


export const getColleagueWeek400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetColleagueWeek400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getColleagueWeek400ResponseOverlapWarningAcknowledgementMin).max(getColleagueWeek400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getColleagueWeek400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getColleagueWeek401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getColleagueWeek401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getColleagueWeek401ResponseOverlapWarningAcknowledgementMin = 16;
export const getColleagueWeek401ResponseOverlapWarningAcknowledgementMax = 256;


export const getColleagueWeek401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetColleagueWeek401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getColleagueWeek401ResponseOverlapWarningAcknowledgementMin).max(getColleagueWeek401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getColleagueWeek401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getColleagueWeek404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getColleagueWeek404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getColleagueWeek404ResponseOverlapWarningAcknowledgementMin = 16;
export const getColleagueWeek404ResponseOverlapWarningAcknowledgementMax = 256;


export const getColleagueWeek404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetColleagueWeek404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getColleagueWeek404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getColleagueWeek404ResponseOverlapWarningAcknowledgementMin).max(getColleagueWeek404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getColleagueWeek404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Privacy-filtered booked desks for map and colleague views
 */
export const listVisibleColleagueDesksQueryLimitDefault = 50;
export const listVisibleColleagueDesksQueryLimitMax = 50;

export const listVisibleColleagueDesksQueryOffsetDefault = 0;
export const listVisibleColleagueDesksQueryOffsetMin = 0;



export const ListVisibleColleagueDesksQueryParams = /*#__PURE__*/ (() => zod.object({
  "at": zod.iso.datetime({"offset":true}),
  "floorId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listVisibleColleagueDesksQueryLimitMax).default(listVisibleColleagueDesksQueryLimitDefault),
  "offset": zod.int().min(listVisibleColleagueDesksQueryOffsetMin).default(listVisibleColleagueDesksQueryOffsetDefault)
}))()

export const listVisibleColleagueDesksHeaderXGroupGraphTokenMax = 16384;


export const listVisibleColleagueDesksHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListVisibleColleagueDesksHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listVisibleColleagueDesksHeaderXGroupGraphTokenMax).regex(listVisibleColleagueDesksHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listVisibleColleagueDesks200ResponseTotalMin = 0;



export const ListVisibleColleagueDesks200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "floorId": zod.uuid(),
  "buildingName": zod.string(),
  "siteName": zod.string(),
  "timezone": zod.string().nullish().describe('Site timezone for the disclosed booking, without exposing additional location details'),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listVisibleColleagueDesks200ResponseTotalMin),
  "at": zod.iso.datetime({"offset":true})
}))()

export const listVisibleColleagueDesks401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listVisibleColleagueDesks401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listVisibleColleagueDesks401ResponseOverlapWarningAcknowledgementMin = 16;
export const listVisibleColleagueDesks401ResponseOverlapWarningAcknowledgementMax = 256;


export const listVisibleColleagueDesks401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListVisibleColleagueDesks401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisibleColleagueDesks401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listVisibleColleagueDesks401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listVisibleColleagueDesks401ResponseOverlapWarningAcknowledgementMin).max(listVisibleColleagueDesks401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listVisibleColleagueDesks401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns the viewer's one-way nominated-colleague shortlist.
 * Nomination grants no visibility — each colleague's own sharing
 * settings decide what presence/booking data is exposed elsewhere.
 * @summary List the viewer's nominated colleagues
 */
export const listNominationsHeaderXGroupGraphTokenMax = 16384;


export const listNominationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListNominationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listNominationsHeaderXGroupGraphTokenMax).regex(listNominationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listNominations200ResponseTotalMin = 0;



export const ListNominations200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "colleagueUserId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listNominations200ResponseTotalMin)
}))()

export const listNominations401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listNominations401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listNominations401ResponseOverlapWarningAcknowledgementMin = 16;
export const listNominations401ResponseOverlapWarningAcknowledgementMax = 256;


export const listNominations401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListNominations401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listNominations401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listNominations401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listNominations401ResponseOverlapWarningAcknowledgementMin).max(listNominations401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listNominations401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Adds a colleague to the viewer's personal shortlist. Self-nomination
 * is rejected. Idempotent — nominating an existing colleague is a no-op.
 * Nomination grants no visibility by itself.
 * @summary Nominate a colleague (one-way follow)
 */
export const addNominationHeaderXGroupGraphTokenMax = 16384;


export const addNominationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AddNominationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(addNominationHeaderXGroupGraphTokenMax).regex(addNominationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const AddNominationBody = /*#__PURE__*/ (() => zod.object({
  "colleagueUserId": zod.uuid()
}))()

export const AddNomination201Response = /*#__PURE__*/ (() => zod.object({
  "colleagueUserId": zod.uuid(),
  "nominated": zod.boolean()
}))()

export const addNomination400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addNomination400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addNomination400ResponseOverlapWarningAcknowledgementMin = 16;
export const addNomination400ResponseOverlapWarningAcknowledgementMax = 256;


export const addNomination400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddNomination400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addNomination400ResponseOverlapWarningAcknowledgementMin).max(addNomination400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addNomination400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const addNomination401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addNomination401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addNomination401ResponseOverlapWarningAcknowledgementMin = 16;
export const addNomination401ResponseOverlapWarningAcknowledgementMax = 256;


export const addNomination401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddNomination401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addNomination401ResponseOverlapWarningAcknowledgementMin).max(addNomination401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addNomination401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const addNomination404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const addNomination404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const addNomination404ResponseOverlapWarningAcknowledgementMin = 16;
export const addNomination404ResponseOverlapWarningAcknowledgementMax = 256;


export const addNomination404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const AddNomination404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(addNomination404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(addNomination404ResponseOverlapWarningAcknowledgementMin).max(addNomination404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(addNomination404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Removes a colleague from the viewer's personal shortlist.
 * @summary Remove a nominated colleague
 */
export const RemoveNominationParams = /*#__PURE__*/ (() => zod.object({
  "colleagueUserId": zod.uuid()
}))()

export const removeNominationHeaderXGroupGraphTokenMax = 16384;


export const removeNominationHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveNominationHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeNominationHeaderXGroupGraphTokenMax).regex(removeNominationHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const RemoveNomination200Response = /*#__PURE__*/ (() => zod.object({
  "colleagueUserId": zod.uuid(),
  "removed": zod.boolean()
}))()

export const removeNomination400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeNomination400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeNomination400ResponseOverlapWarningAcknowledgementMin = 16;
export const removeNomination400ResponseOverlapWarningAcknowledgementMax = 256;


export const removeNomination400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveNomination400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeNomination400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeNomination400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeNomination400ResponseOverlapWarningAcknowledgementMin).max(removeNomination400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeNomination400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeNomination401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeNomination401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeNomination401ResponseOverlapWarningAcknowledgementMin = 16;
export const removeNomination401ResponseOverlapWarningAcknowledgementMax = 256;


export const removeNomination401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveNomination401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeNomination401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeNomination401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeNomination401ResponseOverlapWarningAcknowledgementMin).max(removeNomination401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeNomination401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns booked desks/offices for the viewer's nominated colleagues
 * over a date range (cross-office by design). Each colleague's
 * visibility is gated by their own sharing settings via the same
 * canViewerSeePresence check used for presence. Private colleagues
 * appear with visible=false and an empty bookings array.
 * @summary Privacy-trimmed bookings for nominated colleagues
 */
export const GetNominatedColleagueBookingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date().optional().describe('Window start (YYYY-MM-DD). Defaults to local today.'),
  "to": zod.iso.date().optional().describe('Window end (YYYY-MM-DD). Defaults to 6 days after from.')
}))()

export const getNominatedColleagueBookingsHeaderXGroupGraphTokenMax = 16384;


export const getNominatedColleagueBookingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetNominatedColleagueBookingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getNominatedColleagueBookingsHeaderXGroupGraphTokenMax).regex(getNominatedColleagueBookingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetNominatedColleagueBookings200Response = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.date(),
  "to": zod.iso.date(),
  "items": zod.array(zod.object({
  "colleagueUserId": zod.uuid(),
  "displayName": zod.string(),
  "visible": zod.boolean(),
  "bookings": zod.array(zod.object({
  "bookingId": zod.uuid(),
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceCode": zod.string(),
  "buildingId": zod.uuid(),
  "buildingName": zod.string(),
  "siteId": zod.uuid(),
  "siteName": zod.string(),
  "timezone": zod.string().nullish().describe('Site timezone for this disclosed booking'),
  "startAt": zod.iso.datetime({"offset":true}),
  "endAt": zod.iso.datetime({"offset":true}),
  "status": zod.string()
}))
}))
}))()

export const getNominatedColleagueBookings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNominatedColleagueBookings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNominatedColleagueBookings400ResponseOverlapWarningAcknowledgementMin = 16;
export const getNominatedColleagueBookings400ResponseOverlapWarningAcknowledgementMax = 256;


export const getNominatedColleagueBookings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNominatedColleagueBookings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNominatedColleagueBookings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNominatedColleagueBookings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNominatedColleagueBookings400ResponseOverlapWarningAcknowledgementMin).max(getNominatedColleagueBookings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNominatedColleagueBookings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getNominatedColleagueBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getNominatedColleagueBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getNominatedColleagueBookings401ResponseOverlapWarningAcknowledgementMin = 16;
export const getNominatedColleagueBookings401ResponseOverlapWarningAcknowledgementMax = 256;


export const getNominatedColleagueBookings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetNominatedColleagueBookings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNominatedColleagueBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getNominatedColleagueBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getNominatedColleagueBookings401ResponseOverlapWarningAcknowledgementMin).max(getNominatedColleagueBookings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getNominatedColleagueBookings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Read-only active overlapping slots for an owned floor. The window must be increasing and at most 31 days. Pages contain no total or completion token; consume bounded pages until fewer than limit rows, and withhold identity display if completeness is uncertain.
 * @summary Floor booking slots with privacy-filtered booker names
 */
export const ListFloorBookingsParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const listFloorBookingsQueryLimitDefault = 50;
export const listFloorBookingsQueryLimitMax = 50;

export const listFloorBookingsQueryOffsetDefault = 0;
export const listFloorBookingsQueryOffsetMin = 0;
export const listFloorBookingsQueryOffsetMax = 10000;



export const ListFloorBookingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "spaceId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listFloorBookingsQueryLimitMax).default(listFloorBookingsQueryLimitDefault),
  "offset": zod.int().min(listFloorBookingsQueryOffsetMin).max(listFloorBookingsQueryOffsetMax).default(listFloorBookingsQueryOffsetDefault)
}))()

export const listFloorBookingsHeaderXGroupGraphTokenMax = 16384;


export const listFloorBookingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListFloorBookingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listFloorBookingsHeaderXGroupGraphTokenMax).regex(listFloorBookingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListFloorBookings200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "bookerName": zod.string().nullable(),
  "bookingId": zod.uuid().optional().describe('Present only on the viewer’s own bookings'),
  "isOwnBooking": zod.boolean().optional().describe('Display fact only. True when the booking beneficiary is the current user, including bookings made on their behalf. Omission is unknown; this grants no booking action.'),
  "isVisibleWorkgroupBooking": zod.boolean().optional().describe('Display fact only. True for another beneficiary with a current shared workgroup and a nonblank bookerName permitted by existing subject and customer disclosure rules. A disclosed name alone does not imply a teammate. Omission is unknown.')
})),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const listFloorBookings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listFloorBookings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listFloorBookings400ResponseOverlapWarningAcknowledgementMin = 16;
export const listFloorBookings400ResponseOverlapWarningAcknowledgementMax = 256;


export const listFloorBookings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListFloorBookings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFloorBookings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFloorBookings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listFloorBookings400ResponseOverlapWarningAcknowledgementMin).max(listFloorBookings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listFloorBookings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listFloorBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listFloorBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listFloorBookings401ResponseOverlapWarningAcknowledgementMin = 16;
export const listFloorBookings401ResponseOverlapWarningAcknowledgementMax = 256;


export const listFloorBookings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListFloorBookings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFloorBookings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listFloorBookings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listFloorBookings401ResponseOverlapWarningAcknowledgementMin).max(listFloorBookings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listFloorBookings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Floor plan metadata (no image bytes)
 */
export const GetFloorPlanMetaParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorPlanMetaHeaderXGroupGraphTokenMax = 16384;


export const getFloorPlanMetaHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorPlanMetaHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorPlanMetaHeaderXGroupGraphTokenMax).regex(getFloorPlanMetaHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getFloorPlanMeta200ResponseByteSizeMin = 0;





export const GetFloorPlanMeta200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "contentType": zod.string(),
  "byteSize": zod.int().min(getFloorPlanMeta200ResponseByteSizeMin),
  "width": zod.int().min(1),
  "height": zod.int().min(1),
  "fileName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "hasPlan": zod.literal(true)
}))()

export const getFloorPlanMeta401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorPlanMeta401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorPlanMeta401ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorPlanMeta401ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorPlanMeta401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorPlanMeta401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanMeta401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanMeta401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorPlanMeta401ResponseOverlapWarningAcknowledgementMin).max(getFloorPlanMeta401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorPlanMeta401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorPlanMeta404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorPlanMeta404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorPlanMeta404ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorPlanMeta404ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorPlanMeta404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorPlanMeta404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanMeta404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanMeta404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorPlanMeta404ResponseOverlapWarningAcknowledgementMin).max(getFloorPlanMeta404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorPlanMeta404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Upload or replace a floor-plan image (inventory managers)
 */
export const UpsertFloorPlanParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const upsertFloorPlanHeaderXGroupGraphTokenMax = 16384;


export const upsertFloorPlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpsertFloorPlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(upsertFloorPlanHeaderXGroupGraphTokenMax).regex(upsertFloorPlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const upsertFloorPlanBodyWidthMax = 20000;

export const upsertFloorPlanBodyHeightMax = 20000;



export const UpsertFloorPlanBody = /*#__PURE__*/ (() => zod.object({
  "file": zod.instanceof(Blob),
  "width": zod.int().min(1).max(upsertFloorPlanBodyWidthMax).optional().describe('Natural image width in pixels'),
  "height": zod.int().min(1).max(upsertFloorPlanBodyHeightMax).optional().describe('Natural image height in pixels')
}))()

export const upsertFloorPlan200ResponseByteSizeMin = 0;





export const UpsertFloorPlan200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "contentType": zod.string(),
  "byteSize": zod.int().min(upsertFloorPlan200ResponseByteSizeMin),
  "width": zod.int().min(1),
  "height": zod.int().min(1),
  "fileName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "hasPlan": zod.literal(true)
}))()

export const upsertFloorPlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertFloorPlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertFloorPlan400ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertFloorPlan400ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertFloorPlan400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertFloorPlan400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertFloorPlan400ResponseOverlapWarningAcknowledgementMin).max(upsertFloorPlan400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertFloorPlan400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const upsertFloorPlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertFloorPlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertFloorPlan401ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertFloorPlan401ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertFloorPlan401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertFloorPlan401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertFloorPlan401ResponseOverlapWarningAcknowledgementMin).max(upsertFloorPlan401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertFloorPlan401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const upsertFloorPlan403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertFloorPlan403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertFloorPlan403ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertFloorPlan403ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertFloorPlan403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertFloorPlan403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertFloorPlan403ResponseOverlapWarningAcknowledgementMin).max(upsertFloorPlan403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertFloorPlan403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const upsertFloorPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const upsertFloorPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const upsertFloorPlan404ResponseOverlapWarningAcknowledgementMin = 16;
export const upsertFloorPlan404ResponseOverlapWarningAcknowledgementMax = 256;


export const upsertFloorPlan404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpsertFloorPlan404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(upsertFloorPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(upsertFloorPlan404ResponseOverlapWarningAcknowledgementMin).max(upsertFloorPlan404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(upsertFloorPlan404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @deprecated
 * @summary Legacy removal refused; use reviewed plan-removal preview and confirm
 */
export const DeleteFloorPlanParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const deleteFloorPlanHeaderXGroupGraphTokenMax = 16384;


export const deleteFloorPlanHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteFloorPlanHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteFloorPlanHeaderXGroupGraphTokenMax).regex(deleteFloorPlanHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteFloorPlan200Response = /*#__PURE__*/ (() => zod.object({
  "ok": zod.boolean()
}))()

export const deleteFloorPlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFloorPlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFloorPlan401ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFloorPlan401ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFloorPlan401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFloorPlan401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFloorPlan401ResponseOverlapWarningAcknowledgementMin).max(deleteFloorPlan401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFloorPlan401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteFloorPlan403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFloorPlan403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFloorPlan403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFloorPlan403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFloorPlan403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFloorPlan403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFloorPlan403ResponseOverlapWarningAcknowledgementMin).max(deleteFloorPlan403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFloorPlan403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteFloorPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteFloorPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteFloorPlan404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteFloorPlan404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteFloorPlan404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteFloorPlan404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteFloorPlan404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteFloorPlan404ResponseOverlapWarningAcknowledgementMin).max(deleteFloorPlan404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteFloorPlan404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Review immediate closure and booking impact before removing a pin
 */
export const PreviewSpacePlanRemovalParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const previewSpacePlanRemovalHeaderXGroupGraphTokenMax = 16384;


export const previewSpacePlanRemovalHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewSpacePlanRemovalHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewSpacePlanRemovalHeaderXGroupGraphTokenMax).regex(previewSpacePlanRemovalHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewSpacePlanRemoval200ResponseSelectedBeforeRevisionMin = 0;

export const previewSpacePlanRemoval200ResponseSelectedAfterRevisionMin = 0;

export const previewSpacePlanRemoval200ResponseChildrenItemsItemBeforeRevisionMin = 0;

export const previewSpacePlanRemoval200ResponseChildrenItemsItemAfterRevisionMin = 0;

export const previewSpacePlanRemoval200ResponseChildrenItemsItemBookingImpactCancellationCountMin = 0;

export const previewSpacePlanRemoval200ResponseChildrenItemsItemBookingImpactUnderwayCountMin = 0;



export const PreviewSpacePlanRemoval200Response = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "selectedBefore": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewSpacePlanRemoval200ResponseSelectedBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "selectedAfter": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewSpacePlanRemoval200ResponseSelectedAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "counts": zod.record(zod.string(), zod.int()),
  "children": zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewSpacePlanRemoval200ResponseChildrenItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewSpacePlanRemoval200ResponseChildrenItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(previewSpacePlanRemoval200ResponseChildrenItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(previewSpacePlanRemoval200ResponseChildrenItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}),
  "bookingImpact": zod.object({
  "available": zod.boolean(),
  "cancellationCount": zod.int().nullable(),
  "underwayCount": zod.int().nullable(),
  "revision": zod.string().nullable(),
  "bookings": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}).optional()
}),
  "confirmationAvailable": zod.boolean(),
  "explanation": zod.string()
}))()

export const previewSpacePlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewSpacePlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMin = 16;
export const previewSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMax = 256;


export const previewSpacePlanRemoval403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewSpacePlanRemoval403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewSpacePlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewSpacePlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMin).max(previewSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewSpacePlanRemoval403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewSpacePlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewSpacePlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMin = 16;
export const previewSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMax = 256;


export const previewSpacePlanRemoval409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewSpacePlanRemoval409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewSpacePlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewSpacePlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMin).max(previewSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewSpacePlanRemoval409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Close the space, clear its pin, cancel future bookings and notify owners atomically
 */
export const ConfirmSpacePlanRemovalParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const confirmSpacePlanRemovalHeaderXGroupGraphTokenMax = 16384;


export const confirmSpacePlanRemovalHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ConfirmSpacePlanRemovalHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(confirmSpacePlanRemovalHeaderXGroupGraphTokenMax).regex(confirmSpacePlanRemovalHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const confirmSpacePlanRemovalBodyImpactRevisionMin = 64;
export const confirmSpacePlanRemovalBodyImpactRevisionMax = 64;



export const ConfirmSpacePlanRemovalBody = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string().min(confirmSpacePlanRemovalBodyImpactRevisionMin).max(confirmSpacePlanRemovalBodyImpactRevisionMax),
  "idempotencyKey": zod.uuid()
}))()

export const confirmSpacePlanRemoval200ResponseRevisionMin = 0;



export const ConfirmSpacePlanRemoval200Response = /*#__PURE__*/ (() => zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(confirmSpacePlanRemoval200ResponseRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}))()

export const confirmSpacePlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const confirmSpacePlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const confirmSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMin = 16;
export const confirmSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMax = 256;


export const confirmSpacePlanRemoval403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ConfirmSpacePlanRemoval403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmSpacePlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmSpacePlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(confirmSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMin).max(confirmSpacePlanRemoval403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(confirmSpacePlanRemoval403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const confirmSpacePlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const confirmSpacePlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const confirmSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMin = 16;
export const confirmSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMax = 256;


export const confirmSpacePlanRemoval409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ConfirmSpacePlanRemoval409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmSpacePlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmSpacePlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(confirmSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMin).max(confirmSpacePlanRemoval409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(confirmSpacePlanRemoval409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Review whole-floor closure and booking impact before removing the image
 */
export const PreviewFloorPlanRemovalParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const previewFloorPlanRemovalHeaderXGroupGraphTokenMax = 16384;


export const previewFloorPlanRemovalHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewFloorPlanRemovalHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewFloorPlanRemovalHeaderXGroupGraphTokenMax).regex(previewFloorPlanRemovalHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewFloorPlanRemoval200ResponseSelectedBeforeRevisionMin = 0;

export const previewFloorPlanRemoval200ResponseSelectedAfterRevisionMin = 0;

export const previewFloorPlanRemoval200ResponseChildrenItemsItemBeforeRevisionMin = 0;

export const previewFloorPlanRemoval200ResponseChildrenItemsItemAfterRevisionMin = 0;

export const previewFloorPlanRemoval200ResponseChildrenItemsItemBookingImpactCancellationCountMin = 0;

export const previewFloorPlanRemoval200ResponseChildrenItemsItemBookingImpactUnderwayCountMin = 0;



export const PreviewFloorPlanRemoval200Response = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "action": zod.enum(['deactivate', 'retire', 'reopen', 'remove_schedule']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "selectedBefore": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorPlanRemoval200ResponseSelectedBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "selectedAfter": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorPlanRemoval200ResponseSelectedAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "counts": zod.record(zod.string(), zod.int()),
  "children": zod.object({
  "items": zod.array(zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "before": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorPlanRemoval200ResponseChildrenItemsItemBeforeRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "after": zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(previewFloorPlanRemoval200ResponseChildrenItemsItemAfterRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}),
  "effect": zod.enum(['newly_unavailable', 'already_unavailable', 'restored', 'remains_unavailable', 'unchanged']),
  "bookingImpact": zod.object({
  "cancellationCount": zod.int().min(previewFloorPlanRemoval200ResponseChildrenItemsItemBookingImpactCancellationCountMin),
  "underwayCount": zod.int().min(previewFloorPlanRemoval200ResponseChildrenItemsItemBookingImpactUnderwayCountMin)
}).optional().describe('Complete reviewed booking counts for a space, omitted for parent locations or unavailable booking impact')
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}),
  "bookingImpact": zod.object({
  "available": zod.boolean(),
  "cancellationCount": zod.int().nullable(),
  "underwayCount": zod.int().nullable(),
  "revision": zod.string().nullable(),
  "bookings": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "space": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "status": zod.string(),
  "effect": zod.enum(['cancelled_on_confirmation', 'underway_preserved'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
}).optional()
}),
  "confirmationAvailable": zod.boolean(),
  "explanation": zod.string()
}))()

export const previewFloorPlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewFloorPlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMin = 16;
export const previewFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMax = 256;


export const previewFloorPlanRemoval403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewFloorPlanRemoval403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewFloorPlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewFloorPlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMin).max(previewFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewFloorPlanRemoval403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewFloorPlanRemoval404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewFloorPlanRemoval404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewFloorPlanRemoval404ResponseOverlapWarningAcknowledgementMin = 16;
export const previewFloorPlanRemoval404ResponseOverlapWarningAcknowledgementMax = 256;


export const previewFloorPlanRemoval404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewFloorPlanRemoval404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewFloorPlanRemoval404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewFloorPlanRemoval404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewFloorPlanRemoval404ResponseOverlapWarningAcknowledgementMin).max(previewFloorPlanRemoval404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewFloorPlanRemoval404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Close the floor, delete its image, keep pins and cancel future bookings atomically
 */
export const ConfirmFloorPlanRemovalParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const confirmFloorPlanRemovalHeaderXGroupGraphTokenMax = 16384;


export const confirmFloorPlanRemovalHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ConfirmFloorPlanRemovalHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(confirmFloorPlanRemovalHeaderXGroupGraphTokenMax).regex(confirmFloorPlanRemovalHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const confirmFloorPlanRemovalBodyImpactRevisionMin = 64;
export const confirmFloorPlanRemovalBodyImpactRevisionMax = 64;



export const ConfirmFloorPlanRemovalBody = /*#__PURE__*/ (() => zod.object({
  "previewId": zod.uuid(),
  "impactRevision": zod.string().min(confirmFloorPlanRemovalBodyImpactRevisionMin).max(confirmFloorPlanRemovalBodyImpactRevisionMax),
  "idempotencyKey": zod.uuid()
}))()

export const confirmFloorPlanRemoval200ResponseRevisionMin = 0;



export const ConfirmFloorPlanRemoval200Response = /*#__PURE__*/ (() => zod.object({
  "item": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "timezone": zod.string(),
  "revision": zod.int().min(confirmFloorPlanRemoval200ResponseRevisionMin),
  "ownStatus": zod.enum(['active', 'inactive', 'retired']),
  "effectiveStatus": zod.enum(['active', 'inactive', 'retired']),
  "restrictions": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
})),
  "pendingClosures": zod.array(zod.object({
  "source": zod.object({
  "id": zod.uuid(),
  "level": zod.enum(['site', 'building', 'floor', 'zone', 'space']),
  "name": zod.string(),
  "code": zod.string(),
  "path": zod.array(zod.string())
}),
  "status": zod.enum(['active', 'inactive', 'retired']),
  "effectiveAt": zod.iso.datetime({"offset":true}),
  "inherited": zod.boolean(),
  "reason": zod.enum(['lifecycle', 'booking_mode']).optional(),
  "transitionId": zod.uuid().nullable()
}))
}))()

export const confirmFloorPlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const confirmFloorPlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const confirmFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMin = 16;
export const confirmFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMax = 256;


export const confirmFloorPlanRemoval403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ConfirmFloorPlanRemoval403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmFloorPlanRemoval403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmFloorPlanRemoval403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(confirmFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMin).max(confirmFloorPlanRemoval403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(confirmFloorPlanRemoval403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const confirmFloorPlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const confirmFloorPlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const confirmFloorPlanRemoval409ResponseOverlapWarningAcknowledgementMin = 16;
export const confirmFloorPlanRemoval409ResponseOverlapWarningAcknowledgementMax = 256;


export const confirmFloorPlanRemoval409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ConfirmFloorPlanRemoval409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmFloorPlanRemoval409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(confirmFloorPlanRemoval409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(confirmFloorPlanRemoval409ResponseOverlapWarningAcknowledgementMin).max(confirmFloorPlanRemoval409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(confirmFloorPlanRemoval409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the tenant-scoped floor geometry
 */
export const GetFloorGeometryParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorGeometryHeaderXGroupGraphTokenMax = 16384;


export const getFloorGeometryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorGeometryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorGeometryHeaderXGroupGraphTokenMax).regex(getFloorGeometryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getFloorGeometry200ResponseDocumentSourceNameMax = 255;

export const getFloorGeometry200ResponseDocumentImageWidthMax = 20000;

export const getFloorGeometry200ResponseDocumentImageHeightMax = 20000;

export const getFloorGeometry200ResponseDocumentFeaturesItemCodeMax = 64;

export const getFloorGeometry200ResponseDocumentFeaturesItemLabelMax = 200;

export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMin = 0;
export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMax = 1000;

export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMin = 0;
export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMax = 1000;

export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonMin = 3;
export const getFloorGeometry200ResponseDocumentFeaturesItemPolygonMax = 24;

export const getFloorGeometry200ResponseDocumentFeaturesItemPinOneXMin = 0;
export const getFloorGeometry200ResponseDocumentFeaturesItemPinOneXMax = 1000;

export const getFloorGeometry200ResponseDocumentFeaturesItemPinOneYMin = 0;
export const getFloorGeometry200ResponseDocumentFeaturesItemPinOneYMax = 1000;

export const getFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMin = 0;
export const getFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMax = 10;

export const getFloorGeometry200ResponseDocumentFeaturesMax = 500;



export const GetFloorGeometry200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "revision": zod.int().min(1),
  "document": zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(getFloorGeometry200ResponseDocumentSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(getFloorGeometry200ResponseDocumentImageWidthMax),
  "imageHeight": zod.int().min(1).max(getFloorGeometry200ResponseDocumentImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(getFloorGeometry200ResponseDocumentFeaturesItemCodeMax),
  "label": zod.string().min(1).max(getFloorGeometry200ResponseDocumentFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMin).max(getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMax),
  "y": zod.number().min(getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMin).max(getFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMax)
})).min(getFloorGeometry200ResponseDocumentFeaturesItemPolygonMin).max(getFloorGeometry200ResponseDocumentFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(getFloorGeometry200ResponseDocumentFeaturesItemPinOneXMin).max(getFloorGeometry200ResponseDocumentFeaturesItemPinOneXMax),
  "y": zod.number().min(getFloorGeometry200ResponseDocumentFeaturesItemPinOneYMin).max(getFloorGeometry200ResponseDocumentFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(getFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMin).max(getFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMax)
})).max(getFloorGeometry200ResponseDocumentFeaturesMax)
}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getFloorGeometry401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorGeometry401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorGeometry401ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorGeometry401ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorGeometry401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorGeometry401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorGeometry401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorGeometry401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorGeometry401ResponseOverlapWarningAcknowledgementMin).max(getFloorGeometry401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorGeometry401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorGeometry404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorGeometry404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorGeometry404ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorGeometry404ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorGeometry404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorGeometry404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorGeometry404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorGeometry404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorGeometry404ResponseOverlapWarningAcknowledgementMin).max(getFloorGeometry404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorGeometry404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Replace floor geometry with optimistic version check
 */
export const UpdateFloorGeometryParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateFloorGeometryHeaderXGroupGraphTokenMax = 16384;


export const updateFloorGeometryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateFloorGeometryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateFloorGeometryHeaderXGroupGraphTokenMax).regex(updateFloorGeometryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateFloorGeometryBodyExpectedRevisionMin = 0;

export const updateFloorGeometryBodyDocumentSourceNameMax = 255;

export const updateFloorGeometryBodyDocumentImageWidthMax = 20000;

export const updateFloorGeometryBodyDocumentImageHeightMax = 20000;

export const updateFloorGeometryBodyDocumentFeaturesItemCodeMax = 64;

export const updateFloorGeometryBodyDocumentFeaturesItemLabelMax = 200;

export const updateFloorGeometryBodyDocumentFeaturesItemPolygonItemXMin = 0;
export const updateFloorGeometryBodyDocumentFeaturesItemPolygonItemXMax = 1000;

export const updateFloorGeometryBodyDocumentFeaturesItemPolygonItemYMin = 0;
export const updateFloorGeometryBodyDocumentFeaturesItemPolygonItemYMax = 1000;

export const updateFloorGeometryBodyDocumentFeaturesItemPolygonMin = 3;
export const updateFloorGeometryBodyDocumentFeaturesItemPolygonMax = 24;

export const updateFloorGeometryBodyDocumentFeaturesItemPinOneXMin = 0;
export const updateFloorGeometryBodyDocumentFeaturesItemPinOneXMax = 1000;

export const updateFloorGeometryBodyDocumentFeaturesItemPinOneYMin = 0;
export const updateFloorGeometryBodyDocumentFeaturesItemPinOneYMax = 1000;

export const updateFloorGeometryBodyDocumentFeaturesItemHeightMetersMin = 0;
export const updateFloorGeometryBodyDocumentFeaturesItemHeightMetersMax = 10;

export const updateFloorGeometryBodyDocumentFeaturesMax = 500;



export const UpdateFloorGeometryBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(updateFloorGeometryBodyExpectedRevisionMin),
  "document": zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(updateFloorGeometryBodyDocumentSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(updateFloorGeometryBodyDocumentImageWidthMax),
  "imageHeight": zod.int().min(1).max(updateFloorGeometryBodyDocumentImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(updateFloorGeometryBodyDocumentFeaturesItemCodeMax),
  "label": zod.string().min(1).max(updateFloorGeometryBodyDocumentFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(updateFloorGeometryBodyDocumentFeaturesItemPolygonItemXMin).max(updateFloorGeometryBodyDocumentFeaturesItemPolygonItemXMax),
  "y": zod.number().min(updateFloorGeometryBodyDocumentFeaturesItemPolygonItemYMin).max(updateFloorGeometryBodyDocumentFeaturesItemPolygonItemYMax)
})).min(updateFloorGeometryBodyDocumentFeaturesItemPolygonMin).max(updateFloorGeometryBodyDocumentFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(updateFloorGeometryBodyDocumentFeaturesItemPinOneXMin).max(updateFloorGeometryBodyDocumentFeaturesItemPinOneXMax),
  "y": zod.number().min(updateFloorGeometryBodyDocumentFeaturesItemPinOneYMin).max(updateFloorGeometryBodyDocumentFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(updateFloorGeometryBodyDocumentFeaturesItemHeightMetersMin).max(updateFloorGeometryBodyDocumentFeaturesItemHeightMetersMax)
})).max(updateFloorGeometryBodyDocumentFeaturesMax)
})
}))()


export const updateFloorGeometry200ResponseDocumentSourceNameMax = 255;

export const updateFloorGeometry200ResponseDocumentImageWidthMax = 20000;

export const updateFloorGeometry200ResponseDocumentImageHeightMax = 20000;

export const updateFloorGeometry200ResponseDocumentFeaturesItemCodeMax = 64;

export const updateFloorGeometry200ResponseDocumentFeaturesItemLabelMax = 200;

export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMin = 0;
export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMax = 1000;

export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMin = 0;
export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMax = 1000;

export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonMin = 3;
export const updateFloorGeometry200ResponseDocumentFeaturesItemPolygonMax = 24;

export const updateFloorGeometry200ResponseDocumentFeaturesItemPinOneXMin = 0;
export const updateFloorGeometry200ResponseDocumentFeaturesItemPinOneXMax = 1000;

export const updateFloorGeometry200ResponseDocumentFeaturesItemPinOneYMin = 0;
export const updateFloorGeometry200ResponseDocumentFeaturesItemPinOneYMax = 1000;

export const updateFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMin = 0;
export const updateFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMax = 10;

export const updateFloorGeometry200ResponseDocumentFeaturesMax = 500;



export const UpdateFloorGeometry200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "revision": zod.int().min(1),
  "document": zod.object({
  "schemaVersion": zod.literal(1),
  "sourceName": zod.string().min(1).max(updateFloorGeometry200ResponseDocumentSourceNameMax),
  "sourceDate": zod.iso.date(),
  "imageWidth": zod.int().min(1).max(updateFloorGeometry200ResponseDocumentImageWidthMax),
  "imageHeight": zod.int().min(1).max(updateFloorGeometry200ResponseDocumentImageHeightMax),
  "illustrative": zod.boolean(),
  "features": zod.array(zod.object({
  "code": zod.string().min(1).max(updateFloorGeometry200ResponseDocumentFeaturesItemCodeMax),
  "label": zod.string().min(1).max(updateFloorGeometry200ResponseDocumentFeaturesItemLabelMax),
  "kind": zod.enum(['room', 'chamber', 'office', 'workstation', 'context', 'sample']),
  "provenance": zod.enum(['existing', 'proposed', 'ambiguous', 'sample', 'context']),
  "confidence": zod.enum(['visual', 'approximate', 'unlocated']),
  "spaceId": zod.uuid().nullish(),
  "polygon": zod.array(zod.object({
  "x": zod.number().min(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemXMax),
  "y": zod.number().min(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonItemYMax)
})).min(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemPolygonMax).optional(),
  "pin": zod.union([zod.object({
  "x": zod.number().min(updateFloorGeometry200ResponseDocumentFeaturesItemPinOneXMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemPinOneXMax),
  "y": zod.number().min(updateFloorGeometry200ResponseDocumentFeaturesItemPinOneYMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemPinOneYMax)
}),zod.null()]).optional(),
  "heightMeters": zod.number().min(updateFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMin).max(updateFloorGeometry200ResponseDocumentFeaturesItemHeightMetersMax)
})).max(updateFloorGeometry200ResponseDocumentFeaturesMax)
}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const updateFloorGeometry400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateFloorGeometry400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateFloorGeometry400ResponseOverlapWarningAcknowledgementMin = 16;
export const updateFloorGeometry400ResponseOverlapWarningAcknowledgementMax = 256;


export const updateFloorGeometry400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateFloorGeometry400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateFloorGeometry400ResponseOverlapWarningAcknowledgementMin).max(updateFloorGeometry400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateFloorGeometry400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateFloorGeometry403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateFloorGeometry403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateFloorGeometry403ResponseOverlapWarningAcknowledgementMin = 16;
export const updateFloorGeometry403ResponseOverlapWarningAcknowledgementMax = 256;


export const updateFloorGeometry403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateFloorGeometry403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateFloorGeometry403ResponseOverlapWarningAcknowledgementMin).max(updateFloorGeometry403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateFloorGeometry403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateFloorGeometry409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateFloorGeometry409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateFloorGeometry409ResponseOverlapWarningAcknowledgementMin = 16;
export const updateFloorGeometry409ResponseOverlapWarningAcknowledgementMax = 256;


export const updateFloorGeometry409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateFloorGeometry409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateFloorGeometry409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateFloorGeometry409ResponseOverlapWarningAcknowledgementMin).max(updateFloorGeometry409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateFloorGeometry409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * App bookings apply to the requested half-open window. Simulated physical occupancy applies only to the current instant and never decides booking eligibility. Unknown calendar data is not treated as free.
 * @summary Read separate app, calendar and simulated occupancy status
 */
export const GetFloorTwinStatusParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorTwinStatusQueryLimitDefault = 50;
export const getFloorTwinStatusQueryLimitMax = 100;

export const getFloorTwinStatusQueryOffsetDefault = 0;
export const getFloorTwinStatusQueryOffsetMin = 0;



export const GetFloorTwinStatusQueryParams = /*#__PURE__*/ (() => zod.object({
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "limit": zod.int().min(1).max(getFloorTwinStatusQueryLimitMax).default(getFloorTwinStatusQueryLimitDefault),
  "offset": zod.int().min(getFloorTwinStatusQueryOffsetMin).default(getFloorTwinStatusQueryOffsetDefault)
}))()

export const getFloorTwinStatusHeaderXGroupGraphTokenMax = 16384;


export const getFloorTwinStatusHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorTwinStatusHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorTwinStatusHeaderXGroupGraphTokenMax).regex(getFloorTwinStatusHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getFloorTwinStatus200ResponseItemsItemAppActiveBookingCountMin = 0;

export const getFloorTwinStatus200ResponseItemsItemAppCheckedInCountMin = 0;

export const getFloorTwinStatus200ResponseTotalMin = 0;

export const getFloorTwinStatus200ResponseLimitMax = 100;

export const getFloorTwinStatus200ResponseOffsetMin = 0;



export const GetFloorTwinStatus200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "items": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "app": zod.object({
  "state": zod.enum(['busy', 'free', 'unavailable', 'unknown']),
  "activeBookingCount": zod.int().min(getFloorTwinStatus200ResponseItemsItemAppActiveBookingCountMin),
  "checkedInCount": zod.int().min(getFloorTwinStatus200ResponseItemsItemAppCheckedInCountMin),
  "source": zod.enum(['app']),
  "observedAt": zod.iso.datetime({"offset":true}).nullable(),
  "freshness": zod.enum(['fresh', 'stale', 'unavailable']),
  "errorCode": zod.string().nullable()
}),
  "calendar": zod.object({
  "state": zod.enum(['busy', 'free', 'unknown', 'not_applicable']),
  "source": zod.enum(['microsoft_365', 'none']),
  "mailboxUpn": zod.string().nullable().describe('Administrator-linked room mailbox'),
  "observedAt": zod.iso.datetime({"offset":true}).nullable(),
  "freshness": zod.enum(['fresh', 'stale', 'unavailable']),
  "errorCode": zod.string().nullable()
}),
  "occupancy": zod.object({
  "state": zod.enum(['occupied', 'vacant', 'unknown']),
  "source": zod.enum(['simulated_sensor']),
  "simulated": zod.literal(true),
  "observedAt": zod.iso.datetime({"offset":true}),
  "appliesAt": zod.iso.datetime({"offset":true}).describe('Current instant, independent of the booking window'),
  "freshness": zod.enum(['fresh', 'stale', 'offline']),
  "errorCode": zod.string().nullable()
}),
  "displayStatus": zod.enum(['busy', 'unavailable', 'unknown', 'no_known_conflict']).describe('Overlay summary only; booking policy and write-time conflict checks remain authoritative.')
})),
  "total": zod.int().min(getFloorTwinStatus200ResponseTotalMin),
  "limit": zod.int().min(1).max(getFloorTwinStatus200ResponseLimitMax),
  "offset": zod.int().min(getFloorTwinStatus200ResponseOffsetMin)
}))()

export const getFloorTwinStatus400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorTwinStatus400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorTwinStatus400ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorTwinStatus400ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorTwinStatus400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorTwinStatus400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorTwinStatus400ResponseOverlapWarningAcknowledgementMin).max(getFloorTwinStatus400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorTwinStatus400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorTwinStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorTwinStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorTwinStatus401ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorTwinStatus401ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorTwinStatus401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorTwinStatus401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorTwinStatus401ResponseOverlapWarningAcknowledgementMin).max(getFloorTwinStatus401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorTwinStatus401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorTwinStatus403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorTwinStatus403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorTwinStatus403ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorTwinStatus403ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorTwinStatus403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorTwinStatus403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorTwinStatus403ResponseOverlapWarningAcknowledgementMin).max(getFloorTwinStatus403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorTwinStatus403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorTwinStatus404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorTwinStatus404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorTwinStatus404ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorTwinStatus404ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorTwinStatus404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorTwinStatus404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorTwinStatus404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorTwinStatus404ResponseOverlapWarningAcknowledgementMin).max(getFloorTwinStatus404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorTwinStatus404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Administrator-only process-local test control. An empty assignment list resets the floor to deterministic defaults; this never writes presence, check-ins, reports or bookings.
 * @summary Replace bounded simulated sensor scenarios for a floor
 */
export const SetFloorTwinSensorScenariosParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const setFloorTwinSensorScenariosHeaderXGroupGraphTokenMax = 16384;


export const setFloorTwinSensorScenariosHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SetFloorTwinSensorScenariosHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(setFloorTwinSensorScenariosHeaderXGroupGraphTokenMax).regex(setFloorTwinSensorScenariosHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const setFloorTwinSensorScenariosBodyAssignmentsMax = 100;



export const SetFloorTwinSensorScenariosBody = /*#__PURE__*/ (() => zod.object({
  "assignments": zod.array(zod.object({
  "spaceId": zod.uuid(),
  "scenario": zod.enum(['occupied', 'vacant', 'stale', 'offline'])
})).max(setFloorTwinSensorScenariosBodyAssignmentsMax)
}))()

export const setFloorTwinSensorScenarios200ResponseAssignedCountMin = 0;
export const setFloorTwinSensorScenarios200ResponseAssignedCountMax = 100;



export const SetFloorTwinSensorScenarios200Response = /*#__PURE__*/ (() => zod.object({
  "floorId": zod.uuid(),
  "assignedCount": zod.int().min(setFloorTwinSensorScenarios200ResponseAssignedCountMin).max(setFloorTwinSensorScenarios200ResponseAssignedCountMax),
  "simulated": zod.literal(true)
}))()

export const setFloorTwinSensorScenarios400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setFloorTwinSensorScenarios400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setFloorTwinSensorScenarios400ResponseOverlapWarningAcknowledgementMin = 16;
export const setFloorTwinSensorScenarios400ResponseOverlapWarningAcknowledgementMax = 256;


export const setFloorTwinSensorScenarios400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetFloorTwinSensorScenarios400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setFloorTwinSensorScenarios400ResponseOverlapWarningAcknowledgementMin).max(setFloorTwinSensorScenarios400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setFloorTwinSensorScenarios400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const setFloorTwinSensorScenarios401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setFloorTwinSensorScenarios401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setFloorTwinSensorScenarios401ResponseOverlapWarningAcknowledgementMin = 16;
export const setFloorTwinSensorScenarios401ResponseOverlapWarningAcknowledgementMax = 256;


export const setFloorTwinSensorScenarios401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetFloorTwinSensorScenarios401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setFloorTwinSensorScenarios401ResponseOverlapWarningAcknowledgementMin).max(setFloorTwinSensorScenarios401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setFloorTwinSensorScenarios401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const setFloorTwinSensorScenarios403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setFloorTwinSensorScenarios403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setFloorTwinSensorScenarios403ResponseOverlapWarningAcknowledgementMin = 16;
export const setFloorTwinSensorScenarios403ResponseOverlapWarningAcknowledgementMax = 256;


export const setFloorTwinSensorScenarios403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetFloorTwinSensorScenarios403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setFloorTwinSensorScenarios403ResponseOverlapWarningAcknowledgementMin).max(setFloorTwinSensorScenarios403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setFloorTwinSensorScenarios403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const setFloorTwinSensorScenarios404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const setFloorTwinSensorScenarios404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const setFloorTwinSensorScenarios404ResponseOverlapWarningAcknowledgementMin = 16;
export const setFloorTwinSensorScenarios404ResponseOverlapWarningAcknowledgementMax = 256;


export const setFloorTwinSensorScenarios404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SetFloorTwinSensorScenarios404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(setFloorTwinSensorScenarios404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(setFloorTwinSensorScenarios404ResponseOverlapWarningAcknowledgementMin).max(setFloorTwinSensorScenarios404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(setFloorTwinSensorScenarios404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Download floor-plan image bytes
 */
export const GetFloorPlanContentParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const getFloorPlanContentHeaderXGroupGraphTokenMax = 16384;


export const getFloorPlanContentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetFloorPlanContentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getFloorPlanContentHeaderXGroupGraphTokenMax).regex(getFloorPlanContentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetFloorPlanContent200Response = /*#__PURE__*/ (() => zod.unknown())()

export const getFloorPlanContent401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorPlanContent401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorPlanContent401ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorPlanContent401ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorPlanContent401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorPlanContent401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanContent401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanContent401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorPlanContent401ResponseOverlapWarningAcknowledgementMin).max(getFloorPlanContent401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorPlanContent401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getFloorPlanContent404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getFloorPlanContent404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getFloorPlanContent404ResponseOverlapWarningAcknowledgementMin = 16;
export const getFloorPlanContent404ResponseOverlapWarningAcknowledgementMax = 256;


export const getFloorPlanContent404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetFloorPlanContent404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanContent404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getFloorPlanContent404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getFloorPlanContent404ResponseOverlapWarningAcknowledgementMin).max(getFloorPlanContent404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getFloorPlanContent404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Returns utilisation trends, underuse/overbook flags, no-show hotspots, and a 4-week demand forecast for admins.
 * @summary AI insights overview
 */
export const GetInsightsOverviewQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional()
}))()

export const getInsightsOverviewHeaderXGroupGraphTokenMax = 16384;


export const getInsightsOverviewHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetInsightsOverviewHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getInsightsOverviewHeaderXGroupGraphTokenMax).regex(getInsightsOverviewHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetInsightsOverview200Response = /*#__PURE__*/ (() => zod.object({
  "window": zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true})
}),
  "filters": zod.object({
  "siteId": zod.uuid().nullish(),
  "buildingId": zod.uuid().nullish(),
  "typeCode": zod.string().nullish()
}),
  "summary": zod.object({
  "overallUtilisationPct": zod.number().nullable(),
  "totalSpaces": zod.int(),
  "totalBookedMinutes": zod.int(),
  "totalAvailableMinutes": zod.int(),
  "noShowCount": zod.int(),
  "underuseFlagCount": zod.int(),
  "overbookFlagCount": zod.int()
}),
  "utilisationByType": zod.array(zod.object({
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "utilisationPct": zod.number().nullable(),
  "spaceCount": zod.int(),
  "bookedMinutes": zod.number(),
  "availableMinutes": zod.number()
})),
  "utilisationTrend": zod.array(zod.object({
  "day": zod.string(),
  "utilisationPct": zod.number().nullable()
})),
  "underuseFlags": zod.array(zod.object({
  "buildingName": zod.string(),
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "occupancyPct": zod.number(),
  "capacity": zod.int(),
  "spaceName": zod.string()
})),
  "overbookFlags": zod.array(zod.object({
  "buildingName": zod.string(),
  "day": zod.string(),
  "bookedCount": zod.int(),
  "checkedInCount": zod.int(),
  "declaredOfficeCount": zod.int(),
  "attendanceRatio": zod.number()
})),
  "noShowHotspots": zod.array(zod.object({
  "typeCode": zod.string(),
  "typeName": zod.string(),
  "count": zod.int()
})),
  "forecast": zod.object({
  "method": zod.string(),
  "historyWeeks": zod.int(),
  "weeks": zod.array(zod.object({
  "weekStart": zod.string(),
  "projectedBookings": zod.int(),
  "weekdayBreakdown": zod.array(zod.object({
  "weekday": zod.string(),
  "projectedBookings": zod.int()
}))
}))
})
}))()

export const getInsightsOverview401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInsightsOverview401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInsightsOverview401ResponseOverlapWarningAcknowledgementMin = 16;
export const getInsightsOverview401ResponseOverlapWarningAcknowledgementMax = 256;


export const getInsightsOverview401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInsightsOverview401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInsightsOverview401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInsightsOverview401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInsightsOverview401ResponseOverlapWarningAcknowledgementMin).max(getInsightsOverview401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInsightsOverview401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getInsightsOverview403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInsightsOverview403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInsightsOverview403ResponseOverlapWarningAcknowledgementMin = 16;
export const getInsightsOverview403ResponseOverlapWarningAcknowledgementMax = 256;


export const getInsightsOverview403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInsightsOverview403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInsightsOverview403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInsightsOverview403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInsightsOverview403ResponseOverlapWarningAcknowledgementMin).max(getInsightsOverview403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInsightsOverview403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Generates a labeled LLM weekly workplace summary from the computed metrics. Degrades to a heuristic fallback when the LLM is unavailable.
 * @summary Generate LLM weekly summary
 */
export const GenerateWeeklySummaryQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional()
}))()

export const generateWeeklySummaryHeaderXGroupGraphTokenMax = 16384;


export const generateWeeklySummaryHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GenerateWeeklySummaryHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(generateWeeklySummaryHeaderXGroupGraphTokenMax).regex(generateWeeklySummaryHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GenerateWeeklySummary200Response = /*#__PURE__*/ (() => zod.object({
  "summary": zod.string(),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "model": zod.string(),
  "degraded": zod.boolean()
}))()

export const generateWeeklySummary401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const generateWeeklySummary401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const generateWeeklySummary401ResponseOverlapWarningAcknowledgementMin = 16;
export const generateWeeklySummary401ResponseOverlapWarningAcknowledgementMax = 256;


export const generateWeeklySummary401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GenerateWeeklySummary401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(generateWeeklySummary401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(generateWeeklySummary401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(generateWeeklySummary401ResponseOverlapWarningAcknowledgementMin).max(generateWeeklySummary401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(generateWeeklySummary401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const generateWeeklySummary403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const generateWeeklySummary403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const generateWeeklySummary403ResponseOverlapWarningAcknowledgementMin = 16;
export const generateWeeklySummary403ResponseOverlapWarningAcknowledgementMax = 256;


export const generateWeeklySummary403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GenerateWeeklySummary403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(generateWeeklySummary403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(generateWeeklySummary403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(generateWeeklySummary403ResponseOverlapWarningAcknowledgementMin).max(generateWeeklySummary403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(generateWeeklySummary403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Requires inventory management permission in the selected entity. Never exports another entity.
 * UTF-8 space-row CSV; an empty entity returns the same headers and no example rows.
 * Existing hierarchy and catalogues are referenced, never provisioned.
 * Identity: spaceId (keep for updates; blank for additions).
 * Location/type references: siteId, buildingId, floorId, zoneId, spaceTypeId.
 * Context only: siteCode, siteName, buildingCode, buildingName, floorName, zoneName,
 * typeCode, typeName, amenityCodes, amenityNames. Names do not rename referenced records.
 * Editable: spaceCode, spaceName, capacity, mode, sotOverride, assignedUserId,
 * mapX, mapY, mapSnapEnabled, tags, attributes, amenityIds.
 * Status is exported for context; changes require the existing lifecycle review.
 * tags and amenityIds are JSON arrays; attributes is a JSON object or null.
 * Null scalar fields are empty cells. Formula-sensitive strings are apostrophe-escaped
 * reversibly, including original leading apostrophes.
 * Source-prefixed attribute keys and source geometry are excluded and must be preserved
 * on updates. External integration references, images, layouts, lifecycle metadata,
 * bookings, ownership, timestamps and hierarchy configuration are never exported.
 * See docs/requirements/inventory-space-csv.md for field and compatibility semantics.
 * @summary Export selected-entity inventory as CSV
 */
export const exportInventoryCsvHeaderXGroupGraphTokenMax = 16384;


export const exportInventoryCsvHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportInventoryCsvHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportInventoryCsvHeaderXGroupGraphTokenMax).regex(exportInventoryCsvHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ExportInventoryCsv200Response = /*#__PURE__*/ (() => zod.unknown())()

export const exportInventoryCsv401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const exportInventoryCsv401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const exportInventoryCsv401ResponseOverlapWarningAcknowledgementMin = 16;
export const exportInventoryCsv401ResponseOverlapWarningAcknowledgementMax = 256;


export const exportInventoryCsv401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ExportInventoryCsv401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportInventoryCsv401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportInventoryCsv401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(exportInventoryCsv401ResponseOverlapWarningAcknowledgementMin).max(exportInventoryCsv401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(exportInventoryCsv401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const exportInventoryCsv403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const exportInventoryCsv403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const exportInventoryCsv403ResponseOverlapWarningAcknowledgementMin = 16;
export const exportInventoryCsv403ResponseOverlapWarningAcknowledgementMax = 256;


export const exportInventoryCsv403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ExportInventoryCsv403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportInventoryCsv403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportInventoryCsv403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(exportInventoryCsv403ResponseOverlapWarningAcknowledgementMin).max(exportInventoryCsv403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(exportInventoryCsv403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Requires inventory management permission and a selected entity.
 * Returns headers only: siteCode, buildingCode, floorName, zoneName, typeCode,
 * spaceCode, spaceName. Fill these with existing selected-entity location/type
 * references and the new space code/name. No IDs are required.
 * New spaces receive generated IDs and default to capacity 1, reservable, active.
 * A matching existing zone and space code updates that space instead; preview
 * always shows additions, updates and conflicts before applying.
 * Locations and types are never created by import.
 * @summary Download a CSV template for adding spaces
 */
export const downloadInventoryAddSpacesTemplateHeaderXGroupGraphTokenMax = 16384;


export const downloadInventoryAddSpacesTemplateHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DownloadInventoryAddSpacesTemplateHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(downloadInventoryAddSpacesTemplateHeaderXGroupGraphTokenMax).regex(downloadInventoryAddSpacesTemplateHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DownloadInventoryAddSpacesTemplate200Response = /*#__PURE__*/ (() => zod.unknown())()

export const downloadInventoryAddSpacesTemplate401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadInventoryAddSpacesTemplate401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadInventoryAddSpacesTemplate401ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadInventoryAddSpacesTemplate401ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadInventoryAddSpacesTemplate401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadInventoryAddSpacesTemplate401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadInventoryAddSpacesTemplate401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadInventoryAddSpacesTemplate401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadInventoryAddSpacesTemplate401ResponseOverlapWarningAcknowledgementMin).max(downloadInventoryAddSpacesTemplate401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadInventoryAddSpacesTemplate401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const downloadInventoryAddSpacesTemplate403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadInventoryAddSpacesTemplate403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadInventoryAddSpacesTemplate403ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadInventoryAddSpacesTemplate403ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadInventoryAddSpacesTemplate403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadInventoryAddSpacesTemplate403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadInventoryAddSpacesTemplate403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadInventoryAddSpacesTemplate403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadInventoryAddSpacesTemplate403ResponseOverlapWarningAcknowledgementMin).max(downloadInventoryAddSpacesTemplate403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadInventoryAddSpacesTemplate403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Stable space IDs update originals; blank IDs use unique existing zone/code matching or create.
 * References resolve only within the selected entity. Omitted rows stay untouched.
 * Preview classifies all rows; returns at most limit rows starting at offset.
 * Malformed/duplicate headers fail validation. Booking/lifecycle conflicts are row-level blocks.
 * @summary Validate selected-entity CSV import (preview)
 */
export const previewInventoryImportHeaderXGroupGraphTokenMax = 16384;


export const previewInventoryImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewInventoryImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewInventoryImportHeaderXGroupGraphTokenMax).regex(previewInventoryImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewInventoryImportBodyCsvMax = 2000000;

export const previewInventoryImportBodyLimitDefault = 50;
export const previewInventoryImportBodyLimitMax = 100;

export const previewInventoryImportBodyOffsetDefault = 0;
export const previewInventoryImportBodyOffsetMin = 0;



export const PreviewInventoryImportBody = /*#__PURE__*/ (() => zod.object({
  "csv": zod.string().min(1).max(previewInventoryImportBodyCsvMax),
  "limit": zod.int().min(1).max(previewInventoryImportBodyLimitMax).default(previewInventoryImportBodyLimitDefault),
  "offset": zod.int().min(previewInventoryImportBodyOffsetMin).default(previewInventoryImportBodyOffsetDefault)
}))()

export const previewInventoryImport200ResponseTotalRowsMin = 0;

export const previewInventoryImport200ResponseValidRowsMin = 0;

export const previewInventoryImport200ResponseErrorRowsMin = 0;

export const previewInventoryImport200ResponseSummaryAdditionsMin = 0;

export const previewInventoryImport200ResponseSummaryUpdatesMin = 0;

export const previewInventoryImport200ResponseSummaryUnchangedMin = 0;

export const previewInventoryImport200ResponseSummaryBlockedMin = 0;

export const previewInventoryImport200ResponseLimitMax = 100;

export const previewInventoryImport200ResponseOffsetMin = 0;


export const previewInventoryImport200ResponseRowsMax = 100;



export const PreviewInventoryImport200Response = /*#__PURE__*/ (() => zod.object({
  "totalRows": zod.int().min(previewInventoryImport200ResponseTotalRowsMin),
  "validRows": zod.int().min(previewInventoryImport200ResponseValidRowsMin),
  "errorRows": zod.int().min(previewInventoryImport200ResponseErrorRowsMin),
  "summary": zod.object({
  "additions": zod.int().min(previewInventoryImport200ResponseSummaryAdditionsMin),
  "updates": zod.int().min(previewInventoryImport200ResponseSummaryUpdatesMin),
  "unchanged": zod.int().min(previewInventoryImport200ResponseSummaryUnchangedMin),
  "blocked": zod.int().min(previewInventoryImport200ResponseSummaryBlockedMin)
}),
  "limit": zod.int().min(1).max(previewInventoryImport200ResponseLimitMax),
  "offset": zod.int().min(previewInventoryImport200ResponseOffsetMin),
  "rows": zod.array(zod.object({
  "rowIndex": zod.int().min(1).describe('One-based data row number after the header'),
  "raw": zod.record(zod.string(), zod.string()),
  "valid": zod.boolean(),
  "action": zod.enum(['add', 'update', 'unchanged', 'blocked']),
  "spaceId": zod.uuid().nullish(),
  "changedFields": zod.array(zod.string()),
  "errors": zod.array(zod.string())
})).max(previewInventoryImport200ResponseRowsMax)
}))()

export const previewInventoryImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewInventoryImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewInventoryImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const previewInventoryImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const previewInventoryImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewInventoryImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewInventoryImport400ResponseOverlapWarningAcknowledgementMin).max(previewInventoryImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewInventoryImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewInventoryImport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewInventoryImport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewInventoryImport401ResponseOverlapWarningAcknowledgementMin = 16;
export const previewInventoryImport401ResponseOverlapWarningAcknowledgementMax = 256;


export const previewInventoryImport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewInventoryImport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewInventoryImport401ResponseOverlapWarningAcknowledgementMin).max(previewInventoryImport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewInventoryImport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewInventoryImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewInventoryImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewInventoryImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const previewInventoryImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const previewInventoryImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewInventoryImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewInventoryImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewInventoryImport403ResponseOverlapWarningAcknowledgementMin).max(previewInventoryImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewInventoryImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Re-validates the CSV against the selected entity server-side and commits valid rows.
 * Never trusts a client-supplied preview object or resolves codes from another entity.
 * Each successful row change retains an actor-bound entity audit event.
 * Each row rechecks current inventory, bookings and administrator authority under the common
 * lifecycle/booking lock. Blocked and unchanged rows perform no space or booking writes.
 * Response rows/errors are paginated; reportId retrieves remaining results without replaying writes.
 * @summary Commit validated CSV import
 */
export const commitInventoryImportHeaderXGroupGraphTokenMax = 16384;


export const commitInventoryImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CommitInventoryImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(commitInventoryImportHeaderXGroupGraphTokenMax).regex(commitInventoryImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const commitInventoryImportBodyCsvMax = 2000000;

export const commitInventoryImportBodyLimitDefault = 50;
export const commitInventoryImportBodyLimitMax = 100;

export const commitInventoryImportBodyOffsetDefault = 0;
export const commitInventoryImportBodyOffsetMin = 0;



export const CommitInventoryImportBody = /*#__PURE__*/ (() => zod.object({
  "csv": zod.string().min(1).max(commitInventoryImportBodyCsvMax),
  "limit": zod.int().min(1).max(commitInventoryImportBodyLimitMax).default(commitInventoryImportBodyLimitDefault),
  "offset": zod.int().min(commitInventoryImportBodyOffsetMin).default(commitInventoryImportBodyOffsetDefault)
}))()

export const commitInventoryImport200ResponseCreatedMin = 0;

export const commitInventoryImport200ResponseUpdatedMin = 0;

export const commitInventoryImport200ResponseSkippedMin = 0;

export const commitInventoryImport200ResponseUnchangedMin = 0;

export const commitInventoryImport200ResponseBlockedMin = 0;

export const commitInventoryImport200ResponseTotalRowsMin = 0;

export const commitInventoryImport200ResponseLimitMax = 100;

export const commitInventoryImport200ResponseOffsetMin = 0;

export const commitInventoryImport200ResponseErrorsMax = 100;


export const commitInventoryImport200ResponseRowsMax = 100;



export const CommitInventoryImport200Response = /*#__PURE__*/ (() => zod.object({
  "created": zod.int().min(commitInventoryImport200ResponseCreatedMin),
  "updated": zod.int().min(commitInventoryImport200ResponseUpdatedMin),
  "skipped": zod.int().min(commitInventoryImport200ResponseSkippedMin).describe('Unchanged plus blocked rows'),
  "unchanged": zod.int().min(commitInventoryImport200ResponseUnchangedMin),
  "blocked": zod.int().min(commitInventoryImport200ResponseBlockedMin),
  "totalRows": zod.int().min(commitInventoryImport200ResponseTotalRowsMin),
  "limit": zod.int().min(1).max(commitInventoryImport200ResponseLimitMax),
  "offset": zod.int().min(commitInventoryImport200ResponseOffsetMin),
  "reportId": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "errors": zod.array(zod.string().describe('Row errors for this page; counts cover the whole file')).max(commitInventoryImport200ResponseErrorsMax),
  "rows": zod.array(zod.object({
  "rowIndex": zod.int().min(1),
  "action": zod.enum(['created', 'updated', 'unchanged', 'blocked']),
  "spaceId": zod.uuid().nullish(),
  "errors": zod.array(zod.string())
})).max(commitInventoryImport200ResponseRowsMax)
}))()

export const commitInventoryImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const commitInventoryImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const commitInventoryImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const commitInventoryImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const commitInventoryImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CommitInventoryImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(commitInventoryImport400ResponseOverlapWarningAcknowledgementMin).max(commitInventoryImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(commitInventoryImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const commitInventoryImport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const commitInventoryImport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const commitInventoryImport401ResponseOverlapWarningAcknowledgementMin = 16;
export const commitInventoryImport401ResponseOverlapWarningAcknowledgementMax = 256;


export const commitInventoryImport401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CommitInventoryImport401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(commitInventoryImport401ResponseOverlapWarningAcknowledgementMin).max(commitInventoryImport401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(commitInventoryImport401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const commitInventoryImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const commitInventoryImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const commitInventoryImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const commitInventoryImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const commitInventoryImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CommitInventoryImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(commitInventoryImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(commitInventoryImport403ResponseOverlapWarningAcknowledgementMin).max(commitInventoryImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(commitInventoryImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Actor/entity-bound report retained for 15 minutes in the serving process. Missing or expired reports return 404; never replay commit to paginate.
 * @summary Read one page of an import result without replaying writes
 */
export const GetInventoryImportResultParams = /*#__PURE__*/ (() => zod.object({
  "reportId": zod.uuid()
}))()

export const getInventoryImportResultQueryLimitDefault = 50;
export const getInventoryImportResultQueryLimitMax = 100;

export const getInventoryImportResultQueryOffsetDefault = 0;
export const getInventoryImportResultQueryOffsetMin = 0;



export const GetInventoryImportResultQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getInventoryImportResultQueryLimitMax).default(getInventoryImportResultQueryLimitDefault),
  "offset": zod.int().min(getInventoryImportResultQueryOffsetMin).default(getInventoryImportResultQueryOffsetDefault)
}))()

export const getInventoryImportResultHeaderXGroupGraphTokenMax = 16384;


export const getInventoryImportResultHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetInventoryImportResultHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getInventoryImportResultHeaderXGroupGraphTokenMax).regex(getInventoryImportResultHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getInventoryImportResult200ResponseCreatedMin = 0;

export const getInventoryImportResult200ResponseUpdatedMin = 0;

export const getInventoryImportResult200ResponseSkippedMin = 0;

export const getInventoryImportResult200ResponseUnchangedMin = 0;

export const getInventoryImportResult200ResponseBlockedMin = 0;

export const getInventoryImportResult200ResponseTotalRowsMin = 0;

export const getInventoryImportResult200ResponseLimitMax = 100;

export const getInventoryImportResult200ResponseOffsetMin = 0;

export const getInventoryImportResult200ResponseErrorsMax = 100;


export const getInventoryImportResult200ResponseRowsMax = 100;



export const GetInventoryImportResult200Response = /*#__PURE__*/ (() => zod.object({
  "created": zod.int().min(getInventoryImportResult200ResponseCreatedMin),
  "updated": zod.int().min(getInventoryImportResult200ResponseUpdatedMin),
  "skipped": zod.int().min(getInventoryImportResult200ResponseSkippedMin).describe('Unchanged plus blocked rows'),
  "unchanged": zod.int().min(getInventoryImportResult200ResponseUnchangedMin),
  "blocked": zod.int().min(getInventoryImportResult200ResponseBlockedMin),
  "totalRows": zod.int().min(getInventoryImportResult200ResponseTotalRowsMin),
  "limit": zod.int().min(1).max(getInventoryImportResult200ResponseLimitMax),
  "offset": zod.int().min(getInventoryImportResult200ResponseOffsetMin),
  "reportId": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "errors": zod.array(zod.string().describe('Row errors for this page; counts cover the whole file')).max(getInventoryImportResult200ResponseErrorsMax),
  "rows": zod.array(zod.object({
  "rowIndex": zod.int().min(1),
  "action": zod.enum(['created', 'updated', 'unchanged', 'blocked']),
  "spaceId": zod.uuid().nullish(),
  "errors": zod.array(zod.string())
})).max(getInventoryImportResult200ResponseRowsMax)
}))()

export const getInventoryImportResult400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInventoryImportResult400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInventoryImportResult400ResponseOverlapWarningAcknowledgementMin = 16;
export const getInventoryImportResult400ResponseOverlapWarningAcknowledgementMax = 256;


export const getInventoryImportResult400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInventoryImportResult400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInventoryImportResult400ResponseOverlapWarningAcknowledgementMin).max(getInventoryImportResult400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInventoryImportResult400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getInventoryImportResult401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInventoryImportResult401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInventoryImportResult401ResponseOverlapWarningAcknowledgementMin = 16;
export const getInventoryImportResult401ResponseOverlapWarningAcknowledgementMax = 256;


export const getInventoryImportResult401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInventoryImportResult401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInventoryImportResult401ResponseOverlapWarningAcknowledgementMin).max(getInventoryImportResult401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInventoryImportResult401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getInventoryImportResult403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInventoryImportResult403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInventoryImportResult403ResponseOverlapWarningAcknowledgementMin = 16;
export const getInventoryImportResult403ResponseOverlapWarningAcknowledgementMax = 256;


export const getInventoryImportResult403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInventoryImportResult403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInventoryImportResult403ResponseOverlapWarningAcknowledgementMin).max(getInventoryImportResult403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInventoryImportResult403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getInventoryImportResult404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getInventoryImportResult404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getInventoryImportResult404ResponseOverlapWarningAcknowledgementMin = 16;
export const getInventoryImportResult404ResponseOverlapWarningAcknowledgementMax = 256;


export const getInventoryImportResult404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetInventoryImportResult404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getInventoryImportResult404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getInventoryImportResult404ResponseOverlapWarningAcknowledgementMin).max(getInventoryImportResult404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getInventoryImportResult404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Export bookings/utilisation as CSV
 */
export const ExportBookingsCsvQueryParams = /*#__PURE__*/ (() => zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "siteId": zod.uuid().optional(),
  "buildingId": zod.uuid().optional(),
  "typeCode": zod.string().optional()
}))()

export const exportBookingsCsvHeaderXGroupGraphTokenMax = 16384;


export const exportBookingsCsvHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportBookingsCsvHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportBookingsCsvHeaderXGroupGraphTokenMax).regex(exportBookingsCsvHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ExportBookingsCsv200Response = /*#__PURE__*/ (() => zod.unknown())()

export const exportBookingsCsv401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const exportBookingsCsv401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const exportBookingsCsv401ResponseOverlapWarningAcknowledgementMin = 16;
export const exportBookingsCsv401ResponseOverlapWarningAcknowledgementMax = 256;


export const exportBookingsCsv401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ExportBookingsCsv401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportBookingsCsv401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportBookingsCsv401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(exportBookingsCsv401ResponseOverlapWarningAcknowledgementMin).max(exportBookingsCsv401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(exportBookingsCsv401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const exportBookingsCsv403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const exportBookingsCsv403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const exportBookingsCsv403ResponseOverlapWarningAcknowledgementMin = 16;
export const exportBookingsCsv403ResponseOverlapWarningAcknowledgementMax = 256;


export const exportBookingsCsv403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ExportBookingsCsv403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportBookingsCsv403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportBookingsCsv403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(exportBookingsCsv403ResponseOverlapWarningAcknowledgementMin).max(exportBookingsCsv403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(exportBookingsCsv403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List tenants (platform admin only)
 */
export const getApiPlatformAdminTenantsQueryLimitDefault = 50;
export const getApiPlatformAdminTenantsQueryLimitMax = 200;

export const getApiPlatformAdminTenantsQueryOffsetDefault = 0;
export const getApiPlatformAdminTenantsQueryOffsetMin = 0;



export const GetApiPlatformAdminTenantsQueryParams = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['active', 'suspended', 'archived']).optional(),
  "limit": zod.int().min(1).max(getApiPlatformAdminTenantsQueryLimitMax).default(getApiPlatformAdminTenantsQueryLimitDefault),
  "offset": zod.int().min(getApiPlatformAdminTenantsQueryOffsetMin).default(getApiPlatformAdminTenantsQueryOffsetDefault)
}))()

export const getApiPlatformAdminTenants200ResponseItemsItemTwoEntityCountMin = 0;



export const GetApiPlatformAdminTenants200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "entityCount": zod.int().min(getApiPlatformAdminTenants200ResponseItemsItemTwoEntityCountMin)
}))),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenants403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenants403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenants403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a new tenant (platform admin only)
 */
export const postApiPlatformAdminTenantsBodyNameMax = 200;

export const postApiPlatformAdminTenantsBodySlugMax = 100;



export const PostApiPlatformAdminTenantsBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().max(postApiPlatformAdminTenantsBodyNameMax),
  "slug": zod.string().max(postApiPlatformAdminTenantsBodySlugMax).optional().describe('Optional initial friendly alias. The GUID base address is generated automatically.'),
  "settings": zod.looseObject({

}).optional(),
  "initialOwnerEmail": zod.email()
}))()

export const PostApiPlatformAdminTenants201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenants403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenants403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenants403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenants403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenants403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenants409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenants409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenants409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenants409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenants409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenants409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenants409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenants409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenants409ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenants409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenants409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read a governance tenant
 */
export const GetApiPlatformAdminTenantsTenantIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const GetApiPlatformAdminTenantsTenantId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * @summary Rename an active governance tenant (platform admin only)
 */
export const PatchApiPlatformAdminTenantsTenantIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const patchApiPlatformAdminTenantsTenantIdBodyNameMax = 200;



export const PatchApiPlatformAdminTenantsTenantIdBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(patchApiPlatformAdminTenantsTenantIdBodyNameMax)
}))()

export const PatchApiPlatformAdminTenantsTenantId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantId400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantId400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantId400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantId400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantId409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantId409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantId409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantId409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Changes the parent tenant alias only. Its GUID base remains stable; entity addresses are unchanged.
 * @summary Change an active governance tenant friendly alias (platform admin only)
 */
export const PatchApiPlatformAdminTenantsTenantIdSlugParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const patchApiPlatformAdminTenantsTenantIdSlugBodySlugMax = 100;


export const patchApiPlatformAdminTenantsTenantIdSlugBodySlugRegExp = new RegExp('^[a-z0-9](?:[a-z0-9-]{0,98}[a-z0-9])?$');


export const PatchApiPlatformAdminTenantsTenantIdSlugBody = /*#__PURE__*/ (() => zod.object({
  "slug": zod.string().min(1).max(patchApiPlatformAdminTenantsTenantIdSlugBodySlugMax).regex(patchApiPlatformAdminTenantsTenantIdSlugBodySlugRegExp)
}))()

export const PatchApiPlatformAdminTenantsTenantIdSlug200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdSlug400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdSlug400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdSlug400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdSlug400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdSlug403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdSlug403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdSlug403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdSlug403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdSlug404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdSlug404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdSlug404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdSlug404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdSlug409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdSlug409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdSlug409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdSlug409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Changes the parent and sole entity names and friendly aliases. Their GUID base addresses remain stable; prior aliases stop resolving.
 * @summary Rename an active tenant and its sole entity together (platform admin only)
 */
export const PatchApiPlatformAdminTenantsTenantIdIdentityParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const patchApiPlatformAdminTenantsTenantIdIdentityBodyNameMax = 200;

export const patchApiPlatformAdminTenantsTenantIdIdentityBodySlugMax = 100;


export const patchApiPlatformAdminTenantsTenantIdIdentityBodySlugRegExp = new RegExp('^[a-z0-9](?:[a-z0-9-]{0,98}[a-z0-9])?$');


export const PatchApiPlatformAdminTenantsTenantIdIdentityBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(patchApiPlatformAdminTenantsTenantIdIdentityBodyNameMax),
  "slug": zod.string().min(1).max(patchApiPlatformAdminTenantsTenantIdIdentityBodySlugMax).regex(patchApiPlatformAdminTenantsTenantIdIdentityBodySlugRegExp),
  "expectedTenantUpdatedAt": zod.iso.datetime({"offset":true}),
  "expectedEntityUpdatedAt": zod.iso.datetime({"offset":true})
}))()

export const PatchApiPlatformAdminTenantsTenantIdIdentity200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdIdentity400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdIdentity400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdIdentity400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdIdentity400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdIdentity403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdIdentity403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdIdentity403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdIdentity403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdIdentity404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdIdentity404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdIdentity404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdIdentity404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdIdentity409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdIdentity409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdIdentity409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdIdentity409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read homepage catalogue
 */
export const getApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMin = 64;
export const getApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMax = 64;

export const getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneNameMax = 80;

export const getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneDescriptionMax = 400;

export const getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneModuleKeysMax = 7;

export const getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMin = 11;
export const getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMax = 11;



export const GetApiPlatformAdminHomeWebpartCatalogue200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(getApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMin).max(getApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneNameMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMin).max(getApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}))()

export const getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebpartCatalogue400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebpartCatalogue400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebpartCatalogue400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebpartCatalogue403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebpartCatalogue403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebpartCatalogue403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebpartCatalogue409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebpartCatalogue409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebpartCatalogue409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Publish or reset homepage catalogue
 */
export const putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionMin = 64;
export const putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionMax = 64;


export const putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemNameMax = 80;

export const putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemDescriptionMax = 400;

export const putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemModuleKeysMax = 7;

export const putApiPlatformAdminHomeWebpartCatalogueBodyEntriesMin = 11;
export const putApiPlatformAdminHomeWebpartCatalogueBodyEntriesMax = 11;



export const PutApiPlatformAdminHomeWebpartCatalogueBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.string().min(putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionMin).max(putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionMax).regex(putApiPlatformAdminHomeWebpartCatalogueBodyExpectedRevisionRegExp),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemNameMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(putApiPlatformAdminHomeWebpartCatalogueBodyEntriesItemModuleKeysMax)
})).min(putApiPlatformAdminHomeWebpartCatalogueBodyEntriesMin).max(putApiPlatformAdminHomeWebpartCatalogueBodyEntriesMax)
}))()

export const putApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMin = 64;
export const putApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMax = 64;

export const putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneNameMax = 80;

export const putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneDescriptionMax = 400;

export const putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneModuleKeysMax = 7;

export const putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMin = 11;
export const putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMax = 11;



export const PutApiPlatformAdminHomeWebpartCatalogue200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(putApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMin).max(putApiPlatformAdminHomeWebpartCatalogue200ResponseRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneNameMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMin).max(putApiPlatformAdminHomeWebpartCatalogue200ResponseEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}))()

export const putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebpartCatalogue400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebpartCatalogue400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebpartCatalogue400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebpartCatalogue400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebpartCatalogue403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebpartCatalogue403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebpartCatalogue403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebpartCatalogue403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebpartCatalogue409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebpartCatalogue409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebpartCatalogue409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebpartCatalogue409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read homepage configuration
 */
export const GetApiPlatformAdminHomeWebpartsQueryParams = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional()
}))()

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax = 60;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsMax = 2;

export const getApiPlatformAdminHomeWebparts200ResponseLayoutRowsMax = 30;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax = 60;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax = 2;

export const getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsMax = 30;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax = 60;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax = 2;

export const getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsMax = 30;

export const getApiPlatformAdminHomeWebparts200ResponseRevisionMin = 64;
export const getApiPlatformAdminHomeWebparts200ResponseRevisionMax = 64;

export const getApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMin = 64;
export const getApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMax = 64;

export const getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneNameMax = 80;

export const getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax = 400;

export const getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax = 7;

export const getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMin = 11;
export const getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMax = 11;

export const getApiPlatformAdminHomeWebparts200ResponseSiteTileTargetsMax = 120;



export const GetApiPlatformAdminHomeWebparts200Response = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "layout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsMax)
})).max(getApiPlatformAdminHomeWebparts200ResponseLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "savedLayout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax)
})).max(getApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()]),
  "inheritedLayout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax)
})).max(getApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "revision": zod.string().min(getApiPlatformAdminHomeWebparts200ResponseRevisionMin).max(getApiPlatformAdminHomeWebparts200ResponseRevisionMax),
  "canManage": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "catalogue": zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(getApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMin).max(getApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneNameMax),
  "description": zod.string().max(getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMin).max(getApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}),
  "sanitisedInstanceIds": zod.array(zod.string()),
  "siteTileTargets": zod.array(zod.object({
  "instanceId": zod.string(),
  "cardId": zod.string(),
  "siteId": zod.uuid().nullable(),
  "spaceTypeId": zod.uuid().nullable(),
  "spaceTypeCode": zod.string().nullable().describe('Actual scoped booking type code, only when the target is available.'),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('unmapped'),zod.literal('missing'),zod.literal('type'),zod.literal('inactive'),zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}).describe('Current entity-scoped admission; no foreign site metadata or booking availability counts. Targets with no eligible site never link to unfiltered booking.')).max(getApiPlatformAdminHomeWebparts200ResponseSiteTileTargetsMax).optional()
}).describe('Managers receive retained unavailable instances and saved/inherited layouts; other viewers receive admitted published instances only. Null save resets inheritance. Sanitised IDs report modified input.'))()

export const getApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebparts400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebparts400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebparts400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebparts403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebparts403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebparts403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeWebparts409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeWebparts409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeWebparts409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Publish or reset homepage configuration
 */
export const putApiPlatformAdminHomeWebpartsBodyExpectedRevisionMin = 64;
export const putApiPlatformAdminHomeWebpartsBodyExpectedRevisionMax = 64;


export const putApiPlatformAdminHomeWebpartsBodyExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemIdMax = 64;


export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesMax = 60;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsMax = 2;

export const putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsMax = 30;



export const PutApiPlatformAdminHomeWebpartsBody = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "expectedRevision": zod.string().min(putApiPlatformAdminHomeWebpartsBodyExpectedRevisionMin).max(putApiPlatformAdminHomeWebpartsBodyExpectedRevisionMax).regex(putApiPlatformAdminHomeWebpartsBodyExpectedRevisionRegExp),
  "layout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemIdMax).regex(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsItemCellsMax)
})).max(putApiPlatformAdminHomeWebpartsBodyLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()])
}))()

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax = 60;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsMax = 2;

export const putApiPlatformAdminHomeWebparts200ResponseLayoutRowsMax = 30;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax = 60;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax = 2;

export const putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsMax = 30;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax = 60;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax = 2;

export const putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsMax = 30;

export const putApiPlatformAdminHomeWebparts200ResponseRevisionMin = 64;
export const putApiPlatformAdminHomeWebparts200ResponseRevisionMax = 64;

export const putApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMin = 64;
export const putApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMax = 64;

export const putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneNameMax = 80;

export const putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax = 400;

export const putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax = 7;

export const putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMin = 11;
export const putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMax = 11;

export const putApiPlatformAdminHomeWebparts200ResponseSiteTileTargetsMax = 120;



export const PutApiPlatformAdminHomeWebparts200Response = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "layout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsItemCellsMax)
})).max(putApiPlatformAdminHomeWebparts200ResponseLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "savedLayout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax)
})).max(putApiPlatformAdminHomeWebparts200ResponseSavedLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()]),
  "inheritedLayout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax)
})).max(putApiPlatformAdminHomeWebparts200ResponseInheritedLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "revision": zod.string().min(putApiPlatformAdminHomeWebparts200ResponseRevisionMin).max(putApiPlatformAdminHomeWebparts200ResponseRevisionMax),
  "canManage": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "catalogue": zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(putApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMin).max(putApiPlatformAdminHomeWebparts200ResponseCatalogueRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneNameMax),
  "description": zod.string().max(putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMin).max(putApiPlatformAdminHomeWebparts200ResponseCatalogueEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}),
  "sanitisedInstanceIds": zod.array(zod.string()),
  "siteTileTargets": zod.array(zod.object({
  "instanceId": zod.string(),
  "cardId": zod.string(),
  "siteId": zod.uuid().nullable(),
  "spaceTypeId": zod.uuid().nullable(),
  "spaceTypeCode": zod.string().nullable().describe('Actual scoped booking type code, only when the target is available.'),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('unmapped'),zod.literal('missing'),zod.literal('type'),zod.literal('inactive'),zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}).describe('Current entity-scoped admission; no foreign site metadata or booking availability counts. Targets with no eligible site never link to unfiltered booking.')).max(putApiPlatformAdminHomeWebparts200ResponseSiteTileTargetsMax).optional()
}).describe('Managers receive retained unavailable instances and saved/inherited layouts; other viewers receive admitted published instances only. Null save resets inheritance. Sanitised IDs report modified input.'))()

export const putApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebparts400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebparts400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebparts400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebparts400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebparts403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebparts403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebparts403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebparts403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeWebparts409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeWebparts409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeWebparts409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeWebparts409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read paginated entity-owned homepage targets
 */
export const getHomeWebpartOptionsPathTenantSlugMax = 100;



export const GetHomeWebpartOptionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(getHomeWebpartOptionsPathTenantSlugMax)
}))()

export const getHomeWebpartOptionsQueryScopeDefault = `entity`;
export const getHomeWebpartOptionsQuerySearchMax = 100;

export const getHomeWebpartOptionsQueryLimitDefault = 20;
export const getHomeWebpartOptionsQueryLimitMax = 50;

export const getHomeWebpartOptionsQueryOffsetDefault = 0;
export const getHomeWebpartOptionsQueryOffsetMin = 0;
export const getHomeWebpartOptionsQueryOffsetMax = 100000;



export const GetHomeWebpartOptionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(getHomeWebpartOptionsQueryScopeDefault),
  "kind": zod.enum(['site', 'type']),
  "search": zod.string().max(getHomeWebpartOptionsQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(getHomeWebpartOptionsQueryLimitMax).default(getHomeWebpartOptionsQueryLimitDefault),
  "offset": zod.int().min(getHomeWebpartOptionsQueryOffsetMin).max(getHomeWebpartOptionsQueryOffsetMax).default(getHomeWebpartOptionsQueryOffsetDefault)
}))()

export const getHomeWebpartOptionsHeaderXGroupGraphTokenMax = 16384;


export const getHomeWebpartOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetHomeWebpartOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getHomeWebpartOptionsHeaderXGroupGraphTokenMax).regex(getHomeWebpartOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getHomeWebpartOptions200ResponseItemsMax = 50;

export const getHomeWebpartOptions200ResponseTotalMin = 0;



export const GetHomeWebpartOptions200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "code": zod.string(),
  "status": zod.enum(['active', 'inactive'])
})).max(getHomeWebpartOptions200ResponseItemsMax),
  "total": zod.int().min(getHomeWebpartOptions200ResponseTotalMin)
}))()

export const getHomeWebpartOptions400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getHomeWebpartOptions400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getHomeWebpartOptions400ResponseOverlapWarningAcknowledgementMin = 16;
export const getHomeWebpartOptions400ResponseOverlapWarningAcknowledgementMax = 256;


export const getHomeWebpartOptions400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetHomeWebpartOptions400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHomeWebpartOptions400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHomeWebpartOptions400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getHomeWebpartOptions400ResponseOverlapWarningAcknowledgementMin).max(getHomeWebpartOptions400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getHomeWebpartOptions400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getHomeWebpartOptions403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getHomeWebpartOptions403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getHomeWebpartOptions403ResponseOverlapWarningAcknowledgementMin = 16;
export const getHomeWebpartOptions403ResponseOverlapWarningAcknowledgementMax = 256;


export const getHomeWebpartOptions403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetHomeWebpartOptions403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHomeWebpartOptions403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getHomeWebpartOptions403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getHomeWebpartOptions403ResponseOverlapWarningAcknowledgementMin).max(getHomeWebpartOptions403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getHomeWebpartOptions403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read homepage configuration
 */
export const getApiTenantsTenantSlugHomeWebpartsPathTenantSlugMax = 100;



export const GetApiTenantsTenantSlugHomeWebpartsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebpartsPathTenantSlugMax)
}))()

export const getApiTenantsTenantSlugHomeWebpartsQueryScopeDefault = `entity`;

export const GetApiTenantsTenantSlugHomeWebpartsQueryParams = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional(),
  "scope": zod.enum(['tenant', 'entity']).default(getApiTenantsTenantSlugHomeWebpartsQueryScopeDefault)
}))()

export const getApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugHomeWebpartsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax = 60;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsMax = 2;

export const getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsMax = 30;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax = 60;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax = 2;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsMax = 30;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax = 60;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax = 2;

export const getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsMax = 30;

export const getApiTenantsTenantSlugHomeWebparts200ResponseRevisionMin = 64;
export const getApiTenantsTenantSlugHomeWebparts200ResponseRevisionMax = 64;

export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMin = 64;
export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMax = 64;

export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneNameMax = 80;

export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax = 400;

export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax = 7;

export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMin = 11;
export const getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMax = 11;

export const getApiTenantsTenantSlugHomeWebparts200ResponseSiteTileTargetsMax = 120;



export const GetApiTenantsTenantSlugHomeWebparts200Response = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "layout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsMax)
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "savedLayout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax)
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()]),
  "inheritedLayout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax)
})).max(getApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "revision": zod.string().min(getApiTenantsTenantSlugHomeWebparts200ResponseRevisionMin).max(getApiTenantsTenantSlugHomeWebparts200ResponseRevisionMax),
  "canManage": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "catalogue": zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMin).max(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneNameMax),
  "description": zod.string().max(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMin).max(getApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}),
  "sanitisedInstanceIds": zod.array(zod.string()),
  "siteTileTargets": zod.array(zod.object({
  "instanceId": zod.string(),
  "cardId": zod.string(),
  "siteId": zod.uuid().nullable(),
  "spaceTypeId": zod.uuid().nullable(),
  "spaceTypeCode": zod.string().nullable().describe('Actual scoped booking type code, only when the target is available.'),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('unmapped'),zod.literal('missing'),zod.literal('type'),zod.literal('inactive'),zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}).describe('Current entity-scoped admission; no foreign site metadata or booking availability counts. Targets with no eligible site never link to unfiltered booking.')).max(getApiTenantsTenantSlugHomeWebparts200ResponseSiteTileTargetsMax).optional()
}).describe('Managers receive retained unavailable instances and saved/inherited layouts; other viewers receive admitted published instances only. Null save resets inheritance. Sanitised IDs report modified input.'))()

export const getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugHomeWebparts400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugHomeWebparts400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugHomeWebparts400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugHomeWebparts403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugHomeWebparts403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugHomeWebparts403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugHomeWebparts409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugHomeWebparts409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugHomeWebparts409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Publish or reset homepage configuration
 */
export const putApiTenantsTenantSlugHomeWebpartsPathTenantSlugMax = 100;



export const PutApiTenantsTenantSlugHomeWebpartsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsPathTenantSlugMax)
}))()

export const putApiTenantsTenantSlugHomeWebpartsQueryScopeDefault = `entity`;

export const PutApiTenantsTenantSlugHomeWebpartsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(putApiTenantsTenantSlugHomeWebpartsQueryScopeDefault)
}))()

export const putApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenMax = 16384;


export const putApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutApiTenantsTenantSlugHomeWebpartsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenMax).regex(putApiTenantsTenantSlugHomeWebpartsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionMin = 64;
export const putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionMax = 64;


export const putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesMax = 60;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsMax = 2;

export const putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsMax = 30;



export const PutApiTenantsTenantSlugHomeWebpartsBody = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "expectedRevision": zod.string().min(putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionMin).max(putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionMax).regex(putApiTenantsTenantSlugHomeWebpartsBodyExpectedRevisionRegExp),
  "layout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemIdMax).regex(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsItemCellsMax)
})).max(putApiTenantsTenantSlugHomeWebpartsBodyLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()])
}))()

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax = 60;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsMax = 2;

export const putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsMax = 30;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax = 60;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax = 2;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsMax = 30;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax = 16000;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax = 160;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax = 800;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax = 64;


export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$');
export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax = 100;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax = 400;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax = 12;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax = 60;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax = 2;

export const putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsMax = 30;

export const putApiTenantsTenantSlugHomeWebparts200ResponseRevisionMin = 64;
export const putApiTenantsTenantSlugHomeWebparts200ResponseRevisionMax = 64;

export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMin = 64;
export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMax = 64;

export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneNameMax = 80;

export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax = 400;

export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax = 7;

export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMin = 11;
export const putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMax = 11;

export const putApiTenantsTenantSlugHomeWebparts200ResponseSiteTileTargetsMax = 120;



export const PutApiTenantsTenantSlugHomeWebparts200Response = /*#__PURE__*/ (() => zod.object({
  "page": zod.enum(['home', 'home-simple']).optional().describe('Omitted targeting retains standard Home. Simplified Home resolves independently.'),
  "layout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsItemCellsMax)
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "savedLayout": zod.union([zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsItemInstancesMax)
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsItemCellsMax)
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseSavedLayoutOneRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),zod.null()]),
  "inheritedLayout": zod.object({
  "version": zod.literal(1),
  "rows": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemIdRegExp),
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "presentation": zod.enum(['default', 'header']).optional().describe('Header requires two columns; stacks below lg and bounds the right column to 32rem. No custom CSS.'),
  "cells": zod.array(zod.object({
  "instances": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemIdRegExp),
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "visible": zod.boolean(),
  "html": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemHtmlMax).optional().describe('Rich HTML only; sanitised on save and read.'),
  "headingTone": zod.enum(['default', 'accent']).optional().describe('Rich HTML only; scoped semantic heading colour, never arbitrary CSS.'),
  "presentation": zod.enum(['default', 'masthead']).optional().describe('Rich HTML only; bounded regular card or centred page introduction.'),
  "siteTiles": zod.object({
  "eyebrow": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesEyebrowMax),
  "title": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesTitleMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesDescriptionMax),
  "headingTone": zod.enum(['default', 'accent']),
  "actionTone": zod.enum(['default', 'positive']),
  "cards": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdMax).regex(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemLabelMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemDescriptionMax),
  "actionLabel": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsItemActionLabelMax),
  "siteId": zod.uuid().nullable().describe('Entity-owned site, or null for an explicitly unmapped office.'),
  "spaceTypeId": zod.uuid().nullable().describe('Optional entity-owned booking type; requires a site.'),
  "requireBookingType": zod.boolean().optional().describe('Keep this action unavailable until a real booking type is selected.')
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesItemSiteTilesCardsMax)
}).optional()
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsItemInstancesMax)
})).min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsItemCellsMax)
})).max(putApiTenantsTenantSlugHomeWebparts200ResponseInheritedLayoutRowsMax)
}).describe('Version 1. Cell count equals columns; unique IDs; singleton built-ins; up to 30 rows, 60 instances, 20 rich HTML instances and 128000 UTF-8 bytes. Empty pages are valid.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "revision": zod.string().min(putApiTenantsTenantSlugHomeWebparts200ResponseRevisionMin).max(putApiTenantsTenantSlugHomeWebparts200ResponseRevisionMax),
  "canManage": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "catalogue": zod.object({
  "version": zod.literal(1),
  "revision": zod.string().min(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMin).max(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueRevisionMax),
  "entries": zod.array(zod.object({
  "type": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking', 'rich-html', 'site-tiles', 'days-ahead', 'find-a-space', 'usual-office', 'greeting']),
  "name": zod.string().min(1).max(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneNameMax),
  "description": zod.string().max(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneDescriptionMax),
  "enabled": zod.boolean(),
  "moduleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])).max(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesItemOneModuleKeysMax)
}).and(zod.object({
  "singleton": zod.boolean(),
  "requiredModuleKeys": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}))).min(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMin).max(putApiTenantsTenantSlugHomeWebparts200ResponseCatalogueEntriesMax),
  "registeredModules": zod.array(zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']))
}),
  "sanitisedInstanceIds": zod.array(zod.string()),
  "siteTileTargets": zod.array(zod.object({
  "instanceId": zod.string(),
  "cardId": zod.string(),
  "siteId": zod.uuid().nullable(),
  "spaceTypeId": zod.uuid().nullable(),
  "spaceTypeCode": zod.string().nullable().describe('Actual scoped booking type code, only when the target is available.'),
  "available": zod.boolean(),
  "unavailableReason": zod.union([zod.literal('unmapped'),zod.literal('missing'),zod.literal('type'),zod.literal('inactive'),zod.literal('catalogue'),zod.literal('module'),zod.literal('access'),zod.literal(null)]).nullable()
}).describe('Current entity-scoped admission; no foreign site metadata or booking availability counts. Targets with no eligible site never link to unfiltered booking.')).max(putApiTenantsTenantSlugHomeWebparts200ResponseSiteTileTargetsMax).optional()
}).describe('Managers receive retained unavailable instances and saved/inherited layouts; other viewers receive admitted published instances only. Null save resets inheritance. Sanitised IDs report modified input.'))()

export const putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiTenantsTenantSlugHomeWebparts400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiTenantsTenantSlugHomeWebparts400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMin).max(putApiTenantsTenantSlugHomeWebparts400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiTenantsTenantSlugHomeWebparts400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiTenantsTenantSlugHomeWebparts403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiTenantsTenantSlugHomeWebparts403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMin).max(putApiTenantsTenantSlugHomeWebparts403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiTenantsTenantSlugHomeWebparts403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiTenantsTenantSlugHomeWebparts409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiTenantsTenantSlugHomeWebparts409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMin).max(putApiTenantsTenantSlugHomeWebparts409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiTenantsTenantSlugHomeWebparts409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the platform Home layout default
 */
export const getApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin = 5;
export const getApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax = 5;



export const GetApiPlatformAdminHomeLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(getApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin).max(getApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const getApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminHomeLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Replace the platform Home layout default
 */
export const putApiPlatformAdminHomeLayoutBodySectionsMin = 5;
export const putApiPlatformAdminHomeLayoutBodySectionsMax = 5;



export const PutApiPlatformAdminHomeLayoutBody = /*#__PURE__*/ (() => zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiPlatformAdminHomeLayoutBodySectionsMin).max(putApiPlatformAdminHomeLayoutBodySectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'))()

export const putApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin = 5;
export const putApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax = 5;



export const PutApiPlatformAdminHomeLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin).max(putApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const putApiPlatformAdminHomeLayout400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeLayout400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeLayout400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeLayout400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeLayout400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeLayout400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeLayout400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeLayout400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeLayout400ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeLayout400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeLayout400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminHomeLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Reset the platform Home layout to the built-in default
 */
export const deleteApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin = 5;
export const deleteApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax = 5;



export const DeleteApiPlatformAdminHomeLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiPlatformAdminHomeLayout200ResponseLayoutSectionsMin).max(deleteApiPlatformAdminHomeLayout200ResponseLayoutSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformAdminHomeLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformAdminHomeLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformAdminHomeLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the platform navigation layout default
 */
export const getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax = 40;


export const getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax = 40;

export const getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax = 10;



export const GetApiPlatformAdminNavigationLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax).regex(getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp),
  "label": zod.string().min(1).max(getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(getApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax)
}),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const getApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminNavigationLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Replace the platform navigation layout default
 */
export const putApiPlatformAdminNavigationLayoutBodyGroupsItemIdMax = 40;


export const putApiPlatformAdminNavigationLayoutBodyGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiPlatformAdminNavigationLayoutBodyGroupsItemLabelMax = 40;

export const putApiPlatformAdminNavigationLayoutBodyGroupsMax = 10;



export const PutApiPlatformAdminNavigationLayoutBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminNavigationLayoutBodyGroupsItemIdMax).regex(putApiPlatformAdminNavigationLayoutBodyGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminNavigationLayoutBodyGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiPlatformAdminNavigationLayoutBodyGroupsMax)
}))()

export const putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax = 40;


export const putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax = 40;

export const putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax = 10;



export const PutApiPlatformAdminNavigationLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax).regex(putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax)
}),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const putApiPlatformAdminNavigationLayout400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminNavigationLayout400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminNavigationLayout400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminNavigationLayout400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminNavigationLayout400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminNavigationLayout400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminNavigationLayout400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminNavigationLayout400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminNavigationLayout400ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminNavigationLayout400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminNavigationLayout400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformAdminNavigationLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Reset the platform navigation layout to the built-in default
 */
export const deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax = 40;


export const deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax = 40;

export const deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax = 10;



export const DeleteApiPlatformAdminNavigationLayout200Response = /*#__PURE__*/ (() => zod.object({
  "layout": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdMax).regex(deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiPlatformAdminNavigationLayout200ResponseLayoutGroupsMax)
}),
  "source": zod.enum(['platform', 'builtIn'])
}))()

export const deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformAdminNavigationLayout403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformAdminNavigationLayout403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformAdminNavigationLayout403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read governance tenant settings
 */
export const GetApiPlatformAdminTenantsTenantIdSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const GetApiPlatformAdminTenantsTenantIdSettings200Response = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

}).nullable()
}))()


/**
 * @summary Replace governance tenant settings
 */
export const PatchApiPlatformAdminTenantsTenantIdSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const PatchApiPlatformAdminTenantsTenantIdSettingsBody = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

})
}))()

export const PatchApiPlatformAdminTenantsTenantIdSettings200Response = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

})
}))()


/**
 * @summary List entities in a governance tenant
 */
export const GetApiPlatformAdminTenantsTenantIdEntitiesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesQueryLimitDefault = 25;
export const getApiPlatformAdminTenantsTenantIdEntitiesQueryLimitMax = 100;

export const getApiPlatformAdminTenantsTenantIdEntitiesQueryOffsetDefault = 0;
export const getApiPlatformAdminTenantsTenantIdEntitiesQueryOffsetMin = 0;



export const GetApiPlatformAdminTenantsTenantIdEntitiesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getApiPlatformAdminTenantsTenantIdEntitiesQueryLimitMax).default(getApiPlatformAdminTenantsTenantIdEntitiesQueryLimitDefault),
  "offset": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesQueryOffsetMin).default(getApiPlatformAdminTenantsTenantIdEntitiesQueryOffsetDefault)
}))()

export const GetApiPlatformAdminTenantsTenantIdEntities200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntities403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntities403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntities403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntities403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * The GUID base address and entity identity remain stable. The prior alias stops resolving.
 * @summary Change an entity friendly alias (platform admin only)
 */
export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
}))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasBodyAliasMax = 100;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasBodyAliasRegExp = new RegExp('^[a-z0-9](?:[a-z0-9-]{0,98}[a-z0-9])?$');


export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasBody = /*#__PURE__*/ (() => zod.object({
  "alias": zod.string().min(1).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasBodyAliasMax).regex(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAliasBodyAliasRegExp).nullable()
}))()

export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdAlias409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List selectable roles for an entity (platform admin only)
 */
export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryLimitDefault = 25;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryLimitMax = 100;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryOffsetDefault = 0;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryOffsetMin = 0;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryLimitMax).default(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryLimitDefault),
  "offset": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryOffsetMin).default(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRolesQueryOffsetDefault)
}))()

export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdRoles409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Find registered users for a platform entity access grant
 */
export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQuerySearchDefault = ``;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQuerySearchMax = 120;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryLimitDefault = 25;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryLimitMax = 50;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetDefault = 0;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetMin = 0;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetMax = 10000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryParams = /*#__PURE__*/ (() => zod.object({
  "search": zod.string().max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQuerySearchMax).default(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQuerySearchDefault),
  "limit": zod.int().min(1).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryLimitMax).default(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryLimitDefault),
  "offset": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetMax).default(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidatesQueryOffsetDefault)
}))()

export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.email()
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdMemberCandidates409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Adds explicit entity access, synchronizes parent membership, and records a platform audit event. Selected roles are added to any existing roles.
 * @summary Grant entity membership and roles to an existing app user
 */
export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
}))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersBodyEmailMax = 320;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersBodyRoleIdsMax = 100;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersBody = /*#__PURE__*/ (() => zod.object({
  "email": zod.email().max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersBodyEmailMax),
  "userId": zod.uuid().optional().describe('Selected registered account; must still match the email at save time'),
  "roleIds": zod.array(zod.uuid()).min(1).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembersBodyRoleIdsMax)
}))()

export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers201Response = /*#__PURE__*/ (() => zod.object({
  "accessOrigin": zod.enum(['individual', 'group']).optional().describe('Stored reference provenance, not proof of current access. Use administrator access-sources for current verification.'),
  "memberId": zod.uuid(),
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "isSystem": zod.boolean()
})),
  "joinedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdEntitiesEntityIdMembers409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Suspend an active tenant (platform admin only)
 */
export const PostApiPlatformAdminTenantsTenantIdSuspendParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const PostApiPlatformAdminTenantsTenantIdSuspend200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdSuspend403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdSuspend403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdSuspend403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdSuspend403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdSuspend404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdSuspend404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdSuspend404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdSuspend404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Reactivates the tenant, clears its suspension and archive timestamps, and restores access under existing permissions.
 * @summary Restore a suspended or archived tenant (platform admin only)
 */
export const PostApiPlatformAdminTenantsTenantIdRestoreParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const PostApiPlatformAdminTenantsTenantIdRestore200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdRestore403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdRestore403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdRestore403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdRestore403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdRestore404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdRestore404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdRestore404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdRestore404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Archive a suspended tenant (platform admin only)
 */
export const PostApiPlatformAdminTenantsTenantIdArchiveParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const PostApiPlatformAdminTenantsTenantIdArchive200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "settings": zod.looseObject({

}).nullable(),
  "createdBy": zod.uuid().nullable(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdArchive403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdArchive403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdArchive403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdArchive403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminTenantsTenantIdArchive404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminTenantsTenantIdArchive404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminTenantsTenantIdArchive404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminTenantsTenantIdArchive404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Read-only impact preview. No deletion endpoint is available until immediate erasure from live data, backups and external copies can be verified.
 * @summary Preview tenant deletion impact and governance blockers
 */
export const GetApiPlatformAdminTenantsTenantIdDeletionPreviewParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const getApiPlatformAdminTenantsTenantIdDeletionPreview200ResponseEntityCountMin = 0;

export const getApiPlatformAdminTenantsTenantIdDeletionPreview200ResponseRecordCountsItemCountMin = 0;



export const GetApiPlatformAdminTenantsTenantIdDeletionPreview200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "entityCount": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview200ResponseEntityCountMin),
  "recordCounts": zod.array(zod.object({
  "table": zod.string(),
  "count": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview200ResponseRecordCountsItemCountMin)
})),
  "unclassifiedTables": zod.array(zod.string()),
  "blockers": zod.array(zod.string()),
  "deletionEnabled": zod.literal(false)
}))()

export const getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdDeletionPreview403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdDeletionPreview403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdDeletionPreview404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdDeletionPreview404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List platform admins (platform admin only)
 */
export const GetApiPlatformAdminAdmins200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "assignedBy": zod.uuid().nullable(),
  "assignedAt": zod.iso.datetime({"offset":true})
}))
}))()

export const getApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminAdmins403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminAdmins403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminAdmins403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Add a platform admin (platform admin only)
 */
export const postApiPlatformAdminAdminsBodyDisplayNameMax = 200;



export const PostApiPlatformAdminAdminsBody = /*#__PURE__*/ (() => zod.object({
  "email": zod.email(),
  "objectId": zod.uuid().optional().describe('Tenant-local Entra object ID returned by administrator-initiated directory lookup'),
  "displayName": zod.string().min(1).max(postApiPlatformAdminAdminsBodyDisplayNameMax).optional().describe('Directory display name; required with objectId')
}))()

export const PostApiPlatformAdminAdmins201Response = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "assignedBy": zod.uuid().nullable(),
  "assignedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminAdmins403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminAdmins403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminAdmins403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminAdmins403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminAdmins403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminAdmins404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminAdmins404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminAdmins404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminAdmins404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminAdmins404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminAdmins404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminAdmins404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminAdmins404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminAdmins404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminAdmins404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminAdmins404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove a platform admin (platform admin only)
 */
export const DeleteApiPlatformAdminAdminsUserIdParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid()
}))()

export const DeleteApiPlatformAdminAdminsUserId204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformAdminAdminsUserId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformAdminAdminsUserId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformAdminAdminsUserId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformAdminAdminsUserId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformAdminAdminsUserId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformAdminAdminsUserId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformAdminAdminsUserId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformAdminAdminsUserId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Continue from a legacy invitation link (signed-in user)
 */
export const postApiInvitesAcceptHeaderXGroupGraphTokenMax = 16384;


export const postApiInvitesAcceptHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiInvitesAcceptHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiInvitesAcceptHeaderXGroupGraphTokenMax).regex(postApiInvitesAcceptHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PostApiInvitesAcceptBody = /*#__PURE__*/ (() => zod.object({
  "token": zod.string().describe('Single-use invite token.')
}))()

export const PostApiInvitesAccept200Response = /*#__PURE__*/ (() => zod.object({
  "accepted": zod.boolean(),
  "organizationId": zod.uuid(),
  "slug": zod.string(),
  "name": zod.string()
}))()

export const postApiInvitesAccept404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiInvitesAccept404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiInvitesAccept404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiInvitesAccept404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiInvitesAccept404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiInvitesAccept404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiInvitesAccept404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiInvitesAccept404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiInvitesAccept404ResponseOverlapWarningAcknowledgementMin).max(postApiInvitesAccept404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiInvitesAccept404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiInvitesAccept409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiInvitesAccept409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiInvitesAccept409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiInvitesAccept409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiInvitesAccept409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiInvitesAccept409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiInvitesAccept409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiInvitesAccept409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiInvitesAccept409ResponseOverlapWarningAcknowledgementMin).max(postApiInvitesAccept409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiInvitesAccept409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the selected entity profile
 */
export const GetApiTenantsTenantSlugEntityParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugEntityHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugEntityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugEntityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugEntityHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugEntityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugEntity200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugEntity403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugEntity403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugEntity403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update the selected entity profile
 */
export const PatchApiTenantsTenantSlugEntityParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const patchApiTenantsTenantSlugEntityHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugEntityHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugEntityHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugEntityHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugEntityHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const patchApiTenantsTenantSlugEntityBodyNameMax = 200;



export const PatchApiTenantsTenantSlugEntityBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(patchApiTenantsTenantSlugEntityBodyNameMax).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}).optional()
}))()

export const PatchApiTenantsTenantSlugEntity200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugEntity403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugEntity403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugEntity403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugEntity403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugEntity403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List granted entities in the selected governance tenant
 */
export const GetApiTenantsTenantSlugEntitiesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugEntitiesQueryLimitDefault = 25;
export const getApiTenantsTenantSlugEntitiesQueryLimitMax = 100;

export const getApiTenantsTenantSlugEntitiesQueryOffsetDefault = 0;
export const getApiTenantsTenantSlugEntitiesQueryOffsetMin = 0;



export const GetApiTenantsTenantSlugEntitiesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugEntitiesQueryLimitMax).default(getApiTenantsTenantSlugEntitiesQueryLimitDefault),
  "offset": zod.int().min(getApiTenantsTenantSlugEntitiesQueryOffsetMin).default(getApiTenantsTenantSlugEntitiesQueryOffsetDefault)
}))()

export const getApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugEntitiesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugEntities200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()


/**
 * @summary Create an entity in the selected governance tenant
 */
export const PostApiTenantsTenantSlugEntitiesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugEntitiesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugEntitiesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugEntitiesBodyNameMax = 200;

export const postApiTenantsTenantSlugEntitiesBodySlugMax = 100;



export const PostApiTenantsTenantSlugEntitiesBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(postApiTenantsTenantSlugEntitiesBodyNameMax),
  "slug": zod.string().min(1).max(postApiTenantsTenantSlugEntitiesBodySlugMax).optional().describe('Optional friendly alias; GUID base is generated.')
}))()

export const PostApiTenantsTenantSlugEntities201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiTenantsTenantSlugEntities403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugEntities403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugEntities403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugEntities403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugEntities403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugEntities403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugEntities403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugEntities403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugEntities403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugEntities403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugEntities403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Suspend or restore the selected entity
 */
export const PostApiTenantsTenantSlugEntityLifecycleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugEntityLifecycleHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugEntityLifecycleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugEntityLifecycleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugEntityLifecycleHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugEntityLifecycleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugEntityLifecycleBodyReasonMin = 10;
export const postApiTenantsTenantSlugEntityLifecycleBodyReasonMax = 2000;



export const PostApiTenantsTenantSlugEntityLifecycleBody = /*#__PURE__*/ (() => zod.object({
  "action": zod.enum(['suspend', 'restore']),
  "reason": zod.string().min(postApiTenantsTenantSlugEntityLifecycleBodyReasonMin).max(postApiTenantsTenantSlugEntityLifecycleBodyReasonMax)
}))()

export const PostApiTenantsTenantSlugEntityLifecycle200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string().describe('Preferred address using the current alias or GUID base.'),
  "baseSlug": zod.uuid(),
  "alias": zod.string().nullable(),
  "status": zod.enum(['active', 'suspended', 'archived']),
  "parentStatus": zod.enum(['active', 'suspended', 'archived']).optional(),
  "profile": zod.object({
  "description": zod.string(),
  "websiteUrl": zod.string(),
  "industry": zod.string(),
  "locations": zod.string(),
  "contacts": zod.string(),
  "strategicGoals": zod.string(),
  "constraints": zod.string(),
  "notes": zod.string(),
  "enrichedSummary": zod.string(),
  "requirementSimilarityScope": zod.string(),
  "logoIdentity": zod.string()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()


/**
 * Requires existing entity member-management permission. Effective platform administrators may select any registered user; others may select only active members of this entity's parent tenant.
 * @summary Find eligible registered users for entity membership
 */
export const GetApiTenantsTenantSlugMemberCandidatesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugMemberCandidatesQuerySearchDefault = ``;
export const getApiTenantsTenantSlugMemberCandidatesQuerySearchMax = 120;

export const getApiTenantsTenantSlugMemberCandidatesQueryLimitDefault = 25;
export const getApiTenantsTenantSlugMemberCandidatesQueryLimitMax = 50;

export const getApiTenantsTenantSlugMemberCandidatesQueryOffsetDefault = 0;
export const getApiTenantsTenantSlugMemberCandidatesQueryOffsetMin = 0;
export const getApiTenantsTenantSlugMemberCandidatesQueryOffsetMax = 10000;



export const GetApiTenantsTenantSlugMemberCandidatesQueryParams = /*#__PURE__*/ (() => zod.object({
  "search": zod.string().max(getApiTenantsTenantSlugMemberCandidatesQuerySearchMax).default(getApiTenantsTenantSlugMemberCandidatesQuerySearchDefault),
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugMemberCandidatesQueryLimitMax).default(getApiTenantsTenantSlugMemberCandidatesQueryLimitDefault),
  "offset": zod.int().min(getApiTenantsTenantSlugMemberCandidatesQueryOffsetMin).max(getApiTenantsTenantSlugMemberCandidatesQueryOffsetMax).default(getApiTenantsTenantSlugMemberCandidatesQueryOffsetDefault)
}))()

export const getApiTenantsTenantSlugMemberCandidatesHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugMemberCandidatesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugMemberCandidatesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugMemberCandidatesHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugMemberCandidatesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugMemberCandidates200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "userId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.email()
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMemberCandidates400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMemberCandidates400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMemberCandidates400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMemberCandidates400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMemberCandidates401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMemberCandidates401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMemberCandidates401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMemberCandidates401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMemberCandidates403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMemberCandidates403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMemberCandidates403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMemberCandidates403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMemberCandidates404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMemberCandidates404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMemberCandidates404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMemberCandidates404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMemberCandidates409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMemberCandidates409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMemberCandidates409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMemberCandidates409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read administrator Microsoft group setup status
 */
export const GetOrganisationGroupAccessStatusParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getOrganisationGroupAccessStatusHeaderXGroupGraphTokenMaxOne = 16384;


export const getOrganisationGroupAccessStatusHeaderXGroupGraphTokenRegExpOne = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetOrganisationGroupAccessStatusHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getOrganisationGroupAccessStatusHeaderXGroupGraphTokenMaxOne).regex(getOrganisationGroupAccessStatusHeaderXGroupGraphTokenRegExpOne).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getOrganisationGroupAccessStatus200ResponseMessageMax = 1000;



export const GetOrganisationGroupAccessStatus200Response = /*#__PURE__*/ (() => zod.object({
  "state": zod.enum(['ready', 'setup_required', 'unavailable', 'directory_mismatch']),
  "message": zod.string().min(1).max(getOrganisationGroupAccessStatus200ResponseMessageMax),
  "retryable": zod.boolean(),
  "directoryId": zod.uuid().optional(),
  "transitiveMembership": zod.literal(true)
}).describe('Administrator-only readiness probes group reads and user membership permissions in the configured sign-in directory. Missing configuration or denied consent requires setup; outages are retryable. No credentials or directory enumeration for normal members.'))()

export const getOrganisationGroupAccessStatus400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus400ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus400ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus400ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupAccessStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus401ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus401ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus401ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupAccessStatus403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus403ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus403ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus403ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupAccessStatus404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus404ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus404ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus404ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupAccessStatus409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus409ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus409ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus409ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupAccessStatus503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupAccessStatus503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupAccessStatus503ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupAccessStatus503ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupAccessStatus503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupAccessStatus503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupAccessStatus503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupAccessStatus503ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupAccessStatus503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupAccessStatus503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Display-name prefix search. Signed continuation cursors bind actor, organisation, directory, prefix and page size, expire after ten minutes and on server restart, and allow at most 100 pages. Hidden groups are visible as unusable; unsupported group types are omitted.
 * @summary Search real groups in the configured sign-in directory as an administrator
 */
export const SearchOrganisationDirectoryGroupsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const searchOrganisationDirectoryGroupsQueryLimitDefault = 25;
export const searchOrganisationDirectoryGroupsQueryLimitMax = 100;

export const searchOrganisationDirectoryGroupsQueryCursorMax = 2048;

export const searchOrganisationDirectoryGroupsQuerySearchMin = 2;
export const searchOrganisationDirectoryGroupsQuerySearchMax = 100;



export const SearchOrganisationDirectoryGroupsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(searchOrganisationDirectoryGroupsQueryLimitMax).default(searchOrganisationDirectoryGroupsQueryLimitDefault),
  "cursor": zod.string().min(1).max(searchOrganisationDirectoryGroupsQueryCursorMax).optional(),
  "search": zod.string().min(searchOrganisationDirectoryGroupsQuerySearchMin).max(searchOrganisationDirectoryGroupsQuerySearchMax)
}))()

export const searchOrganisationDirectoryGroupsHeaderXGroupGraphTokenMaxOne = 16384;


export const searchOrganisationDirectoryGroupsHeaderXGroupGraphTokenRegExpOne = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SearchOrganisationDirectoryGroupsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(searchOrganisationDirectoryGroupsHeaderXGroupGraphTokenMaxOne).regex(searchOrganisationDirectoryGroupsHeaderXGroupGraphTokenRegExpOne).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const searchOrganisationDirectoryGroups200ResponseItemsItemDisplayNameMax = 256;

export const searchOrganisationDirectoryGroups200ResponseItemsItemUnavailableReasonMax = 1000;

export const searchOrganisationDirectoryGroups200ResponseItemsMax = 100;

export const searchOrganisationDirectoryGroups200ResponseLimitMax = 100;

export const searchOrganisationDirectoryGroups200ResponseNextCursorMax = 2048;



export const SearchOrganisationDirectoryGroups200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "directoryId": zod.uuid(),
  "displayName": zod.string().min(1).max(searchOrganisationDirectoryGroups200ResponseItemsItemDisplayNameMax),
  "kind": zod.enum(['security', 'microsoft365']),
  "membershipVerifiable": zod.boolean(),
  "unavailableReason": zod.string().max(searchOrganisationDirectoryGroups200ResponseItemsItemUnavailableReasonMax).optional()
}).describe('Server-discovered security or Microsoft 365 group in the configured sign-in directory. Hidden membership is marked unverifiable and never grants access; display names are never authority.')).max(searchOrganisationDirectoryGroups200ResponseItemsMax),
  "limit": zod.int().min(1).max(searchOrganisationDirectoryGroups200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(searchOrganisationDirectoryGroups200ResponseNextCursorMax).optional()
}))()

export const searchOrganisationDirectoryGroups400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups400ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups400ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups400ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchOrganisationDirectoryGroups401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups401ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups401ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups401ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchOrganisationDirectoryGroups403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups403ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups403ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups403ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchOrganisationDirectoryGroups404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups404ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups404ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups404ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchOrganisationDirectoryGroups409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups409ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups409ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups409ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const searchOrganisationDirectoryGroups503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const searchOrganisationDirectoryGroups503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const searchOrganisationDirectoryGroups503ResponseOverlapWarningAcknowledgementMin = 16;
export const searchOrganisationDirectoryGroups503ResponseOverlapWarningAcknowledgementMax = 256;


export const searchOrganisationDirectoryGroups503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SearchOrganisationDirectoryGroups503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(searchOrganisationDirectoryGroups503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(searchOrganisationDirectoryGroups503ResponseOverlapWarningAcknowledgementMin).max(searchOrganisationDirectoryGroups503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(searchOrganisationDirectoryGroups503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read and validate one real directory group as an administrator
 */
export const GetOrganisationDirectoryGroupParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "groupId": zod.uuid()
}))()

export const getOrganisationDirectoryGroupHeaderXGroupGraphTokenMaxOne = 16384;


export const getOrganisationDirectoryGroupHeaderXGroupGraphTokenRegExpOne = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetOrganisationDirectoryGroupHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getOrganisationDirectoryGroupHeaderXGroupGraphTokenMaxOne).regex(getOrganisationDirectoryGroupHeaderXGroupGraphTokenRegExpOne).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getOrganisationDirectoryGroup200ResponseDisplayNameMax = 256;

export const getOrganisationDirectoryGroup200ResponseUnavailableReasonMax = 1000;



export const GetOrganisationDirectoryGroup200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "directoryId": zod.uuid(),
  "displayName": zod.string().min(1).max(getOrganisationDirectoryGroup200ResponseDisplayNameMax),
  "kind": zod.enum(['security', 'microsoft365']),
  "membershipVerifiable": zod.boolean(),
  "unavailableReason": zod.string().max(getOrganisationDirectoryGroup200ResponseUnavailableReasonMax).optional()
}).describe('Server-discovered security or Microsoft 365 group in the configured sign-in directory. Hidden membership is marked unverifiable and never grants access; display names are never authority.'))()

export const getOrganisationDirectoryGroup400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup400ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup400ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup400ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationDirectoryGroup401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup401ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup401ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup401ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationDirectoryGroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup403ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup403ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup403ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationDirectoryGroup404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup404ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup404ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup404ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationDirectoryGroup409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup409ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup409ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup409ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationDirectoryGroup503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationDirectoryGroup503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationDirectoryGroup503ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationDirectoryGroup503ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationDirectoryGroup503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationDirectoryGroup503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationDirectoryGroup503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationDirectoryGroup503ResponseOverlapWarningAcknowledgementMin).max(getOrganisationDirectoryGroup503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationDirectoryGroup503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Page existing organisation roles available to group administrators
 */
export const ListOrganisationGroupRolesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listOrganisationGroupRolesQueryLimitDefault = 25;
export const listOrganisationGroupRolesQueryLimitMax = 100;

export const listOrganisationGroupRolesQueryOffsetDefault = 0;
export const listOrganisationGroupRolesQueryOffsetMin = 0;
export const listOrganisationGroupRolesQueryOffsetMax = 10000;



export const ListOrganisationGroupRolesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listOrganisationGroupRolesQueryLimitMax).default(listOrganisationGroupRolesQueryLimitDefault),
  "offset": zod.int().min(listOrganisationGroupRolesQueryOffsetMin).max(listOrganisationGroupRolesQueryOffsetMax).default(listOrganisationGroupRolesQueryOffsetDefault)
}))()

export const listOrganisationGroupRolesHeaderXGroupGraphTokenMax = 16384;


export const listOrganisationGroupRolesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListOrganisationGroupRolesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listOrganisationGroupRolesHeaderXGroupGraphTokenMax).regex(listOrganisationGroupRolesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listOrganisationGroupRoles200ResponseItemsMax = 100;

export const listOrganisationGroupRoles200ResponseLimitMax = 100;

export const listOrganisationGroupRoles200ResponseOffsetMin = 0;
export const listOrganisationGroupRoles200ResponseOffsetMax = 10000;



export const ListOrganisationGroupRoles200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listOrganisationGroupRoles200ResponseItemsMax),
  "limit": zod.int().min(1).max(listOrganisationGroupRoles200ResponseLimitMax),
  "offset": zod.int().min(listOrganisationGroupRoles200ResponseOffsetMin).max(listOrganisationGroupRoles200ResponseOffsetMax),
  "hasMore": zod.boolean()
}))()

export const ListOrganisationGroupRoles400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListOrganisationGroupRoles403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Page group assignments across all role families
 */
export const ListGroupRoleAssignmentsParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string()
}))()

export const listGroupRoleAssignmentsQueryLimitDefault = 25;
export const listGroupRoleAssignmentsQueryLimitMax = 100;

export const listGroupRoleAssignmentsQueryCursorMax = 2048;



export const ListGroupRoleAssignmentsQueryParams = /*#__PURE__*/ (() => zod.strictObject({
  "limit": zod.int().min(1).max(listGroupRoleAssignmentsQueryLimitMax).default(listGroupRoleAssignmentsQueryLimitDefault),
  "cursor": zod.string().min(1).max(listGroupRoleAssignmentsQueryCursorMax).optional()
}))()

export const listGroupRoleAssignmentsHeaderXGroupGraphTokenMax = 16384;


export const listGroupRoleAssignmentsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListGroupRoleAssignmentsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listGroupRoleAssignmentsHeaderXGroupGraphTokenMax).regex(listGroupRoleAssignmentsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listGroupRoleAssignments200ResponseItemsItemDisplayNameMax = 256;

export const listGroupRoleAssignments200ResponseItemsItemAssignmentOneRoleIdsMax = 100;

export const listGroupRoleAssignments200ResponseItemsItemRevisionMax = 2147483647;

export const listGroupRoleAssignments200ResponseItemsMax = 100;

export const listGroupRoleAssignments200ResponseLimitMax = 100;

export const listGroupRoleAssignments200ResponseNextCursorMax = 2048;



export const ListGroupRoleAssignments200Response = /*#__PURE__*/ (() => zod.strictObject({
  "items": zod.array(zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(listGroupRoleAssignments200ResponseItemsItemDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(listGroupRoleAssignments200ResponseItemsItemAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(listGroupRoleAssignments200ResponseItemsItemRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listGroupRoleAssignments200ResponseItemsMax),
  "limit": zod.int().min(1).max(listGroupRoleAssignments200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(listGroupRoleAssignments200ResponseNextCursorMax).optional()
}))()

export const ListGroupRoleAssignments400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListGroupRoleAssignments401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListGroupRoleAssignments403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListGroupRoleAssignments409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListGroupRoleAssignments503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Assign a verified group an existing scoped role
 */
export const CreateGroupRoleAssignmentParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string()
}))()

export const createGroupRoleAssignmentHeaderXGroupGraphTokenMax = 16384;


export const createGroupRoleAssignmentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateGroupRoleAssignmentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createGroupRoleAssignmentHeaderXGroupGraphTokenMax).regex(createGroupRoleAssignmentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createGroupRoleAssignmentBodyAssignmentOneRoleIdsMax = 100;

export const createGroupRoleAssignmentBodyExpectedRoleRevisionMax = 2147483647;



export const CreateGroupRoleAssignmentBody = /*#__PURE__*/ (() => zod.strictObject({
  "groupId": zod.uuid(),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(createGroupRoleAssignmentBodyAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "expectedRoleRevision": zod.int().min(1).max(createGroupRoleAssignmentBodyExpectedRoleRevisionMax).optional().describe('Optional booking definition revision reviewed by the caller. When supplied, the current owned booking role must still match at commit. Other families reject it.')
}))()

export const createGroupRoleAssignment201ResponseDisplayNameMax = 256;

export const createGroupRoleAssignment201ResponseAssignmentOneRoleIdsMax = 100;

export const createGroupRoleAssignment201ResponseRevisionMax = 2147483647;



export const CreateGroupRoleAssignment201Response = /*#__PURE__*/ (() => zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(createGroupRoleAssignment201ResponseDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(createGroupRoleAssignment201ResponseAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(createGroupRoleAssignment201ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const CreateGroupRoleAssignment400Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateGroupRoleAssignment401Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateGroupRoleAssignment403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateGroupRoleAssignment409Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateGroupRoleAssignment503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read a group role assignment
 */
export const GetGroupRoleAssignmentParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const getGroupRoleAssignmentHeaderXGroupGraphTokenMax = 16384;


export const getGroupRoleAssignmentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetGroupRoleAssignmentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getGroupRoleAssignmentHeaderXGroupGraphTokenMax).regex(getGroupRoleAssignmentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getGroupRoleAssignment200ResponseDisplayNameMax = 256;

export const getGroupRoleAssignment200ResponseAssignmentOneRoleIdsMax = 100;

export const getGroupRoleAssignment200ResponseRevisionMax = 2147483647;



export const GetGroupRoleAssignment200Response = /*#__PURE__*/ (() => zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(getGroupRoleAssignment200ResponseDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(getGroupRoleAssignment200ResponseAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(getGroupRoleAssignment200ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const GetGroupRoleAssignment400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetGroupRoleAssignment401Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetGroupRoleAssignment403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetGroupRoleAssignment409Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetGroupRoleAssignment503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Review and change this source using its current revision
 */
export const UpdateGroupRoleAssignmentParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const updateGroupRoleAssignmentHeaderXGroupGraphTokenMax = 16384;


export const updateGroupRoleAssignmentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateGroupRoleAssignmentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateGroupRoleAssignmentHeaderXGroupGraphTokenMax).regex(updateGroupRoleAssignmentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateGroupRoleAssignmentBodyRevisionMax = 2147483647;

export const updateGroupRoleAssignmentBodyAssignmentOneRoleIdsMax = 100;

export const updateGroupRoleAssignmentBodyExpectedRoleRevisionMax = 2147483647;



export const UpdateGroupRoleAssignmentBody = /*#__PURE__*/ (() => zod.strictObject({
  "revision": zod.int().min(1).max(updateGroupRoleAssignmentBodyRevisionMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(updateGroupRoleAssignmentBodyAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "expectedRoleRevision": zod.int().min(1).max(updateGroupRoleAssignmentBodyExpectedRoleRevisionMax).optional().describe('Optional booking definition revision reviewed by the caller. When supplied, the current owned booking role must still match at commit. Other families reject it.')
}))()

export const updateGroupRoleAssignment200ResponseDisplayNameMax = 256;

export const updateGroupRoleAssignment200ResponseAssignmentOneRoleIdsMax = 100;

export const updateGroupRoleAssignment200ResponseRevisionMax = 2147483647;



export const UpdateGroupRoleAssignment200Response = /*#__PURE__*/ (() => zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(updateGroupRoleAssignment200ResponseDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(updateGroupRoleAssignment200ResponseAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(updateGroupRoleAssignment200ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const UpdateGroupRoleAssignment400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateGroupRoleAssignment401Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateGroupRoleAssignment403Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateGroupRoleAssignment409Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateGroupRoleAssignment503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Remove only this group role source
 */
export const RemoveGroupRoleAssignmentParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const removeGroupRoleAssignmentQueryRevisionMax = 2147483647;



export const RemoveGroupRoleAssignmentQueryParams = /*#__PURE__*/ (() => zod.strictObject({
  "revision": zod.int().min(1).max(removeGroupRoleAssignmentQueryRevisionMax)
}))()

export const removeGroupRoleAssignmentHeaderXGroupGraphTokenMax = 16384;


export const removeGroupRoleAssignmentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveGroupRoleAssignmentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeGroupRoleAssignmentHeaderXGroupGraphTokenMax).regex(removeGroupRoleAssignmentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const RemoveGroupRoleAssignment204Response = /*#__PURE__*/ (() => zod.void())()

export const RemoveGroupRoleAssignment403Response = /*#__PURE__*/ (() => zod.unknown())()

export const RemoveGroupRoleAssignment409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read impact of an exact proposed role or enabled-state change
 */
export const PreviewGroupRoleAssignmentImpactParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const previewGroupRoleAssignmentImpactHeaderXGroupGraphTokenMax = 16384;


export const previewGroupRoleAssignmentImpactHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewGroupRoleAssignmentImpactHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewGroupRoleAssignmentImpactHeaderXGroupGraphTokenMax).regex(previewGroupRoleAssignmentImpactHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewGroupRoleAssignmentImpactBodyRevisionMax = 2147483647;

export const previewGroupRoleAssignmentImpactBodyAssignmentOneRoleIdsMax = 100;

export const previewGroupRoleAssignmentImpactBodyExpectedRoleRevisionMax = 2147483647;



export const PreviewGroupRoleAssignmentImpactBody = /*#__PURE__*/ (() => zod.strictObject({
  "revision": zod.int().min(1).max(previewGroupRoleAssignmentImpactBodyRevisionMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(previewGroupRoleAssignmentImpactBodyAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "expectedRoleRevision": zod.int().min(1).max(previewGroupRoleAssignmentImpactBodyExpectedRoleRevisionMax).optional().describe('Optional booking definition revision reviewed by the caller. When supplied, the current owned booking role must still match at commit. Other families reject it.')
}))()

export const previewGroupRoleAssignmentImpact200ResponseRevisionMax = 2147483647;

export const previewGroupRoleAssignmentImpact200ResponseCurrentDisplayNameMax = 256;

export const previewGroupRoleAssignmentImpact200ResponseCurrentAssignmentOneRoleIdsMax = 100;

export const previewGroupRoleAssignmentImpact200ResponseCurrentRevisionMax = 2147483647;

export const previewGroupRoleAssignmentImpact200ResponseProposedRevisionMax = 2147483647;

export const previewGroupRoleAssignmentImpact200ResponseProposedAssignmentOneRoleIdsMax = 100;

export const previewGroupRoleAssignmentImpact200ResponseProposedExpectedRoleRevisionMax = 2147483647;



export const PreviewGroupRoleAssignmentImpact200Response = /*#__PURE__*/ (() => zod.strictObject({
  "revision": zod.int().min(1).max(previewGroupRoleAssignmentImpact200ResponseRevisionMax),
  "current": zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(previewGroupRoleAssignmentImpact200ResponseCurrentDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(previewGroupRoleAssignmentImpact200ResponseCurrentAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(previewGroupRoleAssignmentImpact200ResponseCurrentRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "proposed": zod.strictObject({
  "revision": zod.int().min(1).max(previewGroupRoleAssignmentImpact200ResponseProposedRevisionMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(previewGroupRoleAssignmentImpact200ResponseProposedAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "expectedRoleRevision": zod.int().min(1).max(previewGroupRoleAssignmentImpact200ResponseProposedExpectedRoleRevisionMax).optional().describe('Optional booking definition revision reviewed by the caller. When supplied, the current owned booking role must still match at commit. Other families reject it.')
}),
  "entryEffect": zod.enum(['provides_entry', 'withdraws_this_source']),
  "independentAccessPreserved": zod.literal(true),
  "requiresFreshVerification": zod.literal(true)
}))()

export const PreviewGroupRoleAssignmentImpact400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewGroupRoleAssignmentImpact401Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewGroupRoleAssignmentImpact403Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewGroupRoleAssignmentImpact409Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewGroupRoleAssignmentImpact503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Explain target-person current group role sources
 */
export const ListMemberGroupRoleSourcesParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "memberId": zod.uuid()
}))()

export const listMemberGroupRoleSourcesQueryLimitDefault = 25;
export const listMemberGroupRoleSourcesQueryLimitMax = 100;

export const listMemberGroupRoleSourcesQueryCursorMax = 2048;



export const ListMemberGroupRoleSourcesQueryParams = /*#__PURE__*/ (() => zod.strictObject({
  "limit": zod.int().min(1).max(listMemberGroupRoleSourcesQueryLimitMax).default(listMemberGroupRoleSourcesQueryLimitDefault),
  "cursor": zod.string().min(1).max(listMemberGroupRoleSourcesQueryCursorMax).optional()
}))()

export const listMemberGroupRoleSourcesHeaderXGroupGraphTokenMax = 16384;


export const listMemberGroupRoleSourcesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMemberGroupRoleSourcesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMemberGroupRoleSourcesHeaderXGroupGraphTokenMax).regex(listMemberGroupRoleSourcesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listMemberGroupRoleSources200ResponseItemsItemBindingDisplayNameMax = 256;

export const listMemberGroupRoleSources200ResponseItemsItemBindingAssignmentOneRoleIdsMax = 100;

export const listMemberGroupRoleSources200ResponseItemsItemBindingRevisionMax = 2147483647;

export const listMemberGroupRoleSources200ResponseItemsMax = 100;

export const listMemberGroupRoleSources200ResponseLimitMax = 100;

export const listMemberGroupRoleSources200ResponseNextCursorMax = 2048;



export const ListMemberGroupRoleSources200Response = /*#__PURE__*/ (() => zod.strictObject({
  "items": zod.array(zod.strictObject({
  "binding": zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(listMemberGroupRoleSources200ResponseItemsItemBindingDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(listMemberGroupRoleSources200ResponseItemsItemBindingAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(listMemberGroupRoleSources200ResponseItemsItemBindingRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "verification": zod.enum(['verified', 'not_member', 'unavailable', 'disabled', 'retired']),
  "contributesEntry": zod.boolean(),
  "contributesRole": zod.boolean()
})).max(listMemberGroupRoleSources200ResponseItemsMax),
  "limit": zod.int().min(1).max(listMemberGroupRoleSources200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(listMemberGroupRoleSources200ResponseNextCursorMax).optional()
}))()

export const ListMemberGroupRoleSources400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMemberGroupRoleSources401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMemberGroupRoleSources403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMemberGroupRoleSources409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListMemberGroupRoleSources503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Explain target-person current group role sources
 */
export const ListUserGroupRoleSourcesParams = /*#__PURE__*/ (() => zod.strictObject({
  "tenantSlug": zod.string(),
  "userId": zod.uuid()
}))()

export const listUserGroupRoleSourcesQueryLimitDefault = 25;
export const listUserGroupRoleSourcesQueryLimitMax = 100;

export const listUserGroupRoleSourcesQueryCursorMax = 2048;



export const ListUserGroupRoleSourcesQueryParams = /*#__PURE__*/ (() => zod.strictObject({
  "limit": zod.int().min(1).max(listUserGroupRoleSourcesQueryLimitMax).default(listUserGroupRoleSourcesQueryLimitDefault),
  "cursor": zod.string().min(1).max(listUserGroupRoleSourcesQueryCursorMax).optional()
}))()

export const listUserGroupRoleSourcesHeaderXGroupGraphTokenMax = 16384;


export const listUserGroupRoleSourcesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListUserGroupRoleSourcesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listUserGroupRoleSourcesHeaderXGroupGraphTokenMax).regex(listUserGroupRoleSourcesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listUserGroupRoleSources200ResponseItemsItemBindingDisplayNameMax = 256;

export const listUserGroupRoleSources200ResponseItemsItemBindingAssignmentOneRoleIdsMax = 100;

export const listUserGroupRoleSources200ResponseItemsItemBindingRevisionMax = 2147483647;

export const listUserGroupRoleSources200ResponseItemsMax = 100;

export const listUserGroupRoleSources200ResponseLimitMax = 100;

export const listUserGroupRoleSources200ResponseNextCursorMax = 2048;



export const ListUserGroupRoleSources200Response = /*#__PURE__*/ (() => zod.strictObject({
  "items": zod.array(zod.strictObject({
  "binding": zod.strictObject({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(listUserGroupRoleSources200ResponseItemsItemBindingDisplayNameMax),
  "assignment": zod.union([zod.strictObject({
  "family": zod.enum(['organisation']),
  "roleIds": zod.array(zod.uuid()).min(1).max(listUserGroupRoleSources200ResponseItemsItemBindingAssignmentOneRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}),zod.strictObject({
  "family": zod.enum(['product']),
  "roleCode": zod.enum(['employee', 'team_assistant', 'space_admin', 'it_admin', 'visitor_host'])
}),zod.strictObject({
  "family": zod.enum(['booking']),
  "roleId": zod.uuid(),
  "scope": zod.union([zod.strictObject({
  "kind": zod.enum(['entity'])
}),zod.strictObject({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.strictObject({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
})]).describe('Organisation and product roles are entity-scoped. Booking scopes restrict operational privileges, while each active valid assignment supplies organisation entry. Never supplies platform or parent authority.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(listUserGroupRoleSources200ResponseItemsItemBindingRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "verification": zod.enum(['verified', 'not_member', 'unavailable', 'disabled', 'retired']),
  "contributesEntry": zod.boolean(),
  "contributesRole": zod.boolean()
})).max(listUserGroupRoleSources200ResponseItemsMax),
  "limit": zod.int().min(1).max(listUserGroupRoleSources200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(listUserGroupRoleSources200ResponseNextCursorMax).optional()
}))()

export const ListUserGroupRoleSources400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListUserGroupRoleSources401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListUserGroupRoleSources403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListUserGroupRoleSources409Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListUserGroupRoleSources503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary List organisation group role bindings as an administrator
 */
export const ListOrganisationGroupBindingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listOrganisationGroupBindingsQueryLimitDefault = 25;
export const listOrganisationGroupBindingsQueryLimitMax = 100;

export const listOrganisationGroupBindingsQueryCursorMax = 2048;



export const ListOrganisationGroupBindingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listOrganisationGroupBindingsQueryLimitMax).default(listOrganisationGroupBindingsQueryLimitDefault),
  "cursor": zod.string().min(1).max(listOrganisationGroupBindingsQueryCursorMax).optional()
}))()

export const listOrganisationGroupBindingsHeaderXGroupGraphTokenMax = 16384;


export const listOrganisationGroupBindingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListOrganisationGroupBindingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listOrganisationGroupBindingsHeaderXGroupGraphTokenMax).regex(listOrganisationGroupBindingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listOrganisationGroupBindings200ResponseItemsItemDisplayNameMax = 256;

export const listOrganisationGroupBindings200ResponseItemsItemRoleIdsMax = 100;

export const listOrganisationGroupBindings200ResponseItemsItemRevisionMax = 2147483647;

export const listOrganisationGroupBindings200ResponseItemsMax = 100;

export const listOrganisationGroupBindings200ResponseLimitMax = 100;

export const listOrganisationGroupBindings200ResponseNextCursorMax = 2048;



export const ListOrganisationGroupBindings200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(listOrganisationGroupBindings200ResponseItemsItemDisplayNameMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(listOrganisationGroupBindings200ResponseItemsItemRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(listOrganisationGroupBindings200ResponseItemsItemRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Organisation-only configuration. Never grants parent/platform authority or proves current user membership.')).max(listOrganisationGroupBindings200ResponseItemsMax),
  "limit": zod.int().min(1).max(listOrganisationGroupBindings200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(listOrganisationGroupBindings200ResponseNextCursorMax).optional()
}))()

export const listOrganisationGroupBindings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings400ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings400ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings400ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listOrganisationGroupBindings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings401ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings401ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings401ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listOrganisationGroupBindings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings403ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings403ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings403ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listOrganisationGroupBindings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings404ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings404ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings404ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listOrganisationGroupBindings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings409ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings409ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings409ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listOrganisationGroupBindings503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listOrganisationGroupBindings503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listOrganisationGroupBindings503ResponseOverlapWarningAcknowledgementMin = 16;
export const listOrganisationGroupBindings503ResponseOverlapWarningAcknowledgementMax = 256;


export const listOrganisationGroupBindings503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListOrganisationGroupBindings503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listOrganisationGroupBindings503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listOrganisationGroupBindings503ResponseOverlapWarningAcknowledgementMin).max(listOrganisationGroupBindings503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listOrganisationGroupBindings503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Bind a verified directory group to allowed existing organisation roles
 */
export const CreateOrganisationGroupBindingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const createOrganisationGroupBindingHeaderXGroupGraphTokenMax = 16384;


export const createOrganisationGroupBindingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateOrganisationGroupBindingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createOrganisationGroupBindingHeaderXGroupGraphTokenMax).regex(createOrganisationGroupBindingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createOrganisationGroupBindingBodyRoleIdsMax = 100;



export const CreateOrganisationGroupBindingBody = /*#__PURE__*/ (() => zod.object({
  "groupId": zod.uuid(),
  "roleIds": zod.array(zod.uuid()).min(1).max(createOrganisationGroupBindingBodyRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.')
}).describe('Server owns the directory and real group lookup. Client group names, membership and directory overrides are rejected.'))()

export const createOrganisationGroupBinding201ResponseDisplayNameMax = 256;

export const createOrganisationGroupBinding201ResponseRoleIdsMax = 100;

export const createOrganisationGroupBinding201ResponseRevisionMax = 2147483647;



export const CreateOrganisationGroupBinding201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(createOrganisationGroupBinding201ResponseDisplayNameMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(createOrganisationGroupBinding201ResponseRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(createOrganisationGroupBinding201ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Organisation-only configuration. Never grants parent/platform authority or proves current user membership.'))()

export const createOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin = 16;
export const createOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax = 256;


export const createOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateOrganisationGroupBinding503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin).max(createOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read an organisation group binding
 */
export const GetOrganisationGroupBindingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const getOrganisationGroupBindingHeaderXGroupGraphTokenMax = 16384;


export const getOrganisationGroupBindingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetOrganisationGroupBindingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getOrganisationGroupBindingHeaderXGroupGraphTokenMax).regex(getOrganisationGroupBindingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getOrganisationGroupBinding200ResponseDisplayNameMax = 256;

export const getOrganisationGroupBinding200ResponseRoleIdsMax = 100;

export const getOrganisationGroupBinding200ResponseRevisionMax = 2147483647;



export const GetOrganisationGroupBinding200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(getOrganisationGroupBinding200ResponseDisplayNameMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(getOrganisationGroupBinding200ResponseRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(getOrganisationGroupBinding200ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Organisation-only configuration. Never grants parent/platform authority or proves current user membership.'))()

export const getOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationGroupBinding503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin).max(getOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update group roles or enabled state using the current binding revision
 */
export const UpdateOrganisationGroupBindingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const updateOrganisationGroupBindingHeaderXGroupGraphTokenMax = 16384;


export const updateOrganisationGroupBindingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateOrganisationGroupBindingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateOrganisationGroupBindingHeaderXGroupGraphTokenMax).regex(updateOrganisationGroupBindingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateOrganisationGroupBindingBodyRevisionMax = 2147483647;

export const updateOrganisationGroupBindingBodyRoleIdsMax = 100;



export const UpdateOrganisationGroupBindingBody = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).max(updateOrganisationGroupBindingBodyRevisionMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(updateOrganisationGroupBindingBodyRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "enabled": zod.boolean()
}))()

export const updateOrganisationGroupBinding200ResponseDisplayNameMax = 256;

export const updateOrganisationGroupBinding200ResponseRoleIdsMax = 100;

export const updateOrganisationGroupBinding200ResponseRevisionMax = 2147483647;



export const UpdateOrganisationGroupBinding200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "directoryId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(updateOrganisationGroupBinding200ResponseDisplayNameMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(updateOrganisationGroupBinding200ResponseRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1).max(updateOrganisationGroupBinding200ResponseRevisionMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Organisation-only configuration. Never grants parent/platform authority or proves current user membership.'))()

export const updateOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin = 16;
export const updateOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax = 256;


export const updateOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateOrganisationGroupBinding503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin).max(updateOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove only this group access source
 */
export const RemoveOrganisationGroupBindingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "bindingId": zod.uuid()
}))()

export const removeOrganisationGroupBindingQueryRevisionMax = 2147483647;



export const RemoveOrganisationGroupBindingQueryParams = /*#__PURE__*/ (() => zod.object({
  "revision": zod.int().min(1).max(removeOrganisationGroupBindingQueryRevisionMax)
}))()

export const removeOrganisationGroupBindingHeaderXGroupGraphTokenMax = 16384;


export const removeOrganisationGroupBindingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RemoveOrganisationGroupBindingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(removeOrganisationGroupBindingHeaderXGroupGraphTokenMax).regex(removeOrganisationGroupBindingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const RemoveOrganisationGroupBinding204Response = /*#__PURE__*/ (() => zod.void())()

export const removeOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const removeOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const removeOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const removeOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin = 16;
export const removeOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax = 256;


export const removeOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const RemoveOrganisationGroupBinding503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(removeOrganisationGroupBinding503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(removeOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMin).max(removeOrganisationGroupBinding503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(removeOrganisationGroupBinding503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read current access sources for this member as an administrator
 */
export const GetOrganisationMemberAccessSourcesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "memberId": zod.uuid()
}))()

export const getOrganisationMemberAccessSourcesQueryLimitDefault = 25;
export const getOrganisationMemberAccessSourcesQueryLimitMax = 100;

export const getOrganisationMemberAccessSourcesQueryCursorMax = 2048;



export const GetOrganisationMemberAccessSourcesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getOrganisationMemberAccessSourcesQueryLimitMax).default(getOrganisationMemberAccessSourcesQueryLimitDefault),
  "cursor": zod.string().min(1).max(getOrganisationMemberAccessSourcesQueryCursorMax).optional()
}))()

export const getOrganisationMemberAccessSourcesHeaderXGroupGraphTokenMax = 16384;


export const getOrganisationMemberAccessSourcesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetOrganisationMemberAccessSourcesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getOrganisationMemberAccessSourcesHeaderXGroupGraphTokenMax).regex(getOrganisationMemberAccessSourcesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getOrganisationMemberAccessSources200ResponseIndividualRoleIdsMax = 100;

export const getOrganisationMemberAccessSources200ResponseGroupsItemDisplayNameMax = 256;

export const getOrganisationMemberAccessSources200ResponseGroupsItemRoleIdsMax = 100;

export const getOrganisationMemberAccessSources200ResponseGroupsMax = 100;

export const getOrganisationMemberAccessSources200ResponseLimitMax = 100;

export const getOrganisationMemberAccessSources200ResponseNextCursorMax = 2048;



export const GetOrganisationMemberAccessSources200Response = /*#__PURE__*/ (() => zod.object({
  "memberId": zod.uuid(),
  "individualAccess": zod.boolean(),
  "individualRoleIds": zod.array(zod.uuid()).max(getOrganisationMemberAccessSources200ResponseIndividualRoleIdsMax),
  "suspended": zod.boolean(),
  "groups": zod.array(zod.object({
  "bindingId": zod.uuid(),
  "groupId": zod.uuid(),
  "displayName": zod.string().min(1).max(getOrganisationMemberAccessSources200ResponseGroupsItemDisplayNameMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(getOrganisationMemberAccessSources200ResponseGroupsItemRoleIdsMax).describe('Existing roles owned by this organisation; apply the same assignment limits as individual members.'),
  "verification": zod.enum(['verified', 'not_member', 'unavailable', 'disabled'])
}).describe('Request-current verification only. Failed checks contribute no roles; names/details visible to administrators only.')).max(getOrganisationMemberAccessSources200ResponseGroupsMax),
  "limit": zod.int().min(1).max(getOrganisationMemberAccessSources200ResponseLimitMax),
  "hasMore": zod.boolean(),
  "nextCursor": zod.string().min(1).max(getOrganisationMemberAccessSources200ResponseNextCursorMax).optional()
}).describe('Individual grants and group contributions stay separate. Suspension denies both. Group membership is never restored as individual access.'))()

export const getOrganisationMemberAccessSources400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources400ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources400ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources400ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationMemberAccessSources401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources401ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources401ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources401ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationMemberAccessSources403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources403ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources403ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources403ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationMemberAccessSources404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources404ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources404ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources404ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationMemberAccessSources409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources409ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources409ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources409ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getOrganisationMemberAccessSources503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getOrganisationMemberAccessSources503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getOrganisationMemberAccessSources503ResponseOverlapWarningAcknowledgementMin = 16;
export const getOrganisationMemberAccessSources503ResponseOverlapWarningAcknowledgementMax = 256;


export const getOrganisationMemberAccessSources503ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetOrganisationMemberAccessSources503Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources503ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getOrganisationMemberAccessSources503ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getOrganisationMemberAccessSources503ResponseOverlapWarningAcknowledgementMin).max(getOrganisationMemberAccessSources503ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getOrganisationMemberAccessSources503ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List tenant members
 */
export const GetApiTenantsTenantSlugMembersParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugMembersQueryLimitDefault = 25;
export const getApiTenantsTenantSlugMembersQueryLimitMax = 100;

export const getApiTenantsTenantSlugMembersQueryOffsetDefault = 0;
export const getApiTenantsTenantSlugMembersQueryOffsetMin = 0;



export const GetApiTenantsTenantSlugMembersQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugMembersQueryLimitMax).default(getApiTenantsTenantSlugMembersQueryLimitDefault),
  "offset": zod.int().min(getApiTenantsTenantSlugMembersQueryOffsetMin).default(getApiTenantsTenantSlugMembersQueryOffsetDefault)
}))()

export const getApiTenantsTenantSlugMembersHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugMembersHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugMembersHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugMembersHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugMembersHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugMembers200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "accessOrigin": zod.enum(['individual', 'group']).optional().describe('Stored reference provenance, not proof of current access. Use administrator access-sources for current verification.'),
  "memberId": zod.uuid(),
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "isSystem": zod.boolean()
})),
  "joinedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugMembers403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugMembers403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugMembers403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Add an eligible registered member to the entity (by email)
 */
export const PostApiTenantsTenantSlugMembersParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugMembersHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugMembersHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugMembersHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugMembersHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugMembersHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugMembersBodyEmailMax = 320;

export const postApiTenantsTenantSlugMembersBodyRoleIdsMax = 100;



export const PostApiTenantsTenantSlugMembersBody = /*#__PURE__*/ (() => zod.object({
  "email": zod.email().max(postApiTenantsTenantSlugMembersBodyEmailMax),
  "userId": zod.uuid().optional().describe('Selected registered account; must still match the email at save time'),
  "roleIds": zod.array(zod.uuid()).min(1).max(postApiTenantsTenantSlugMembersBodyRoleIdsMax)
}))()

export const PostApiTenantsTenantSlugMembers201Response = /*#__PURE__*/ (() => zod.object({
  "accessOrigin": zod.enum(['individual', 'group']).optional().describe('Stored reference provenance, not proof of current access. Use administrator access-sources for current verification.'),
  "memberId": zod.uuid(),
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "isSystem": zod.boolean()
})),
  "joinedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugMembers403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugMembers403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugMembers403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugMembers403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugMembers403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugMembers404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugMembers404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugMembers404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugMembers404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugMembers404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugMembers404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugMembers404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugMembers404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugMembers404ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugMembers404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugMembers404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update member roles
 */
export const PatchApiTenantsTenantSlugMembersMemberIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "memberId": zod.uuid()
}))()

export const patchApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugMembersMemberIdHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const PatchApiTenantsTenantSlugMembersMemberIdBody = /*#__PURE__*/ (() => zod.object({
  "roleIds": zod.array(zod.uuid()).min(1)
}))()

export const PatchApiTenantsTenantSlugMembersMemberId200Response = /*#__PURE__*/ (() => zod.object({
  "accessOrigin": zod.enum(['individual', 'group']).optional().describe('Stored reference provenance, not proof of current access. Use administrator access-sources for current verification.'),
  "memberId": zod.uuid(),
  "userId": zod.uuid(),
  "email": zod.string().nullable(),
  "displayName": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "isSystem": zod.boolean()
})),
  "joinedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugMembersMemberId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugMembersMemberId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugMembersMemberId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugMembersMemberId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugMembersMemberId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugMembersMemberId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugMembersMemberId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove a member from the tenant
 */
export const DeleteApiTenantsTenantSlugMembersMemberIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "memberId": zod.uuid()
}))()

export const deleteApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenMax = 16384;


export const deleteApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteApiTenantsTenantSlugMembersMemberIdHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenMax).regex(deleteApiTenantsTenantSlugMembersMemberIdHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteApiTenantsTenantSlugMembersMemberId204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiTenantsTenantSlugMembersMemberId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiTenantsTenantSlugMembersMemberId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMin).max(deleteApiTenantsTenantSlugMembersMemberId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiTenantsTenantSlugMembersMemberId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List tenant invites
 */
export const GetApiTenantsTenantSlugInvitesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugInvitesQueryLimitDefault = 25;
export const getApiTenantsTenantSlugInvitesQueryLimitMax = 100;

export const getApiTenantsTenantSlugInvitesQueryOffsetDefault = 0;
export const getApiTenantsTenantSlugInvitesQueryOffsetMin = 0;



export const GetApiTenantsTenantSlugInvitesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugInvitesQueryLimitMax).default(getApiTenantsTenantSlugInvitesQueryLimitDefault),
  "offset": zod.int().min(getApiTenantsTenantSlugInvitesQueryOffsetMin).default(getApiTenantsTenantSlugInvitesQueryOffsetDefault)
}))()

export const getApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugInvitesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugInvites200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "email": zod.string(),
  "roleId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'revoked', 'expired']),
  "invitedBy": zod.uuid().nullable(),
  "invitedByName": zod.string().nullable(),
  "acceptedBy": zod.uuid().nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "hasMore": zod.boolean()
}))()

export const getApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugInvites403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugInvites403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugInvites403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Creates a seven-day invitation. No acceptance email is sent and no acceptance token is returned.
 * @summary Invite a person to join automatically on sign-in
 */
export const PostApiTenantsTenantSlugInvitesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugInvitesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugInvitesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PostApiTenantsTenantSlugInvitesBody = /*#__PURE__*/ (() => zod.object({
  "email": zod.email(),
  "roleId": zod.uuid()
}))()

export const PostApiTenantsTenantSlugInvites201Response = /*#__PURE__*/ (() => zod.object({
  "invite": zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "email": zod.string(),
  "roleId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'revoked', 'expired']),
  "invitedBy": zod.uuid().nullable(),
  "invitedByName": zod.string().nullable(),
  "acceptedBy": zod.uuid().nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})
}))()

export const postApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugInvites403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugInvites403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvites403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugInvites403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugInvites403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugInvites409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugInvites409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugInvites409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugInvites409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugInvites409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugInvites409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvites409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvites409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugInvites409ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugInvites409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugInvites409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Revoke a pending invite
 */
export const PostApiTenantsTenantSlugInvitesInviteIdRevokeParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "inviteId": zod.uuid()
}))()

export const postApiTenantsTenantSlugInvitesInviteIdRevokeHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugInvitesInviteIdRevokeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugInvitesInviteIdRevokeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugInvitesInviteIdRevokeHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugInvitesInviteIdRevokeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PostApiTenantsTenantSlugInvitesInviteIdRevoke204Response = /*#__PURE__*/ (() => zod.void())()

export const postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugInvitesInviteIdRevoke403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugInvitesInviteIdRevoke403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugInvitesInviteIdRevoke404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugInvitesInviteIdRevoke404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List tenant roles (system + custom)
 */
export const GetApiTenantsTenantSlugRolesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugRolesHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugRolesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugRolesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugRolesHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugRolesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugRoles200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))()

export const getApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugRoles403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugRoles403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugRoles403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a custom tenant role (tenant.roles.manage)
 */
export const PostApiTenantsTenantSlugRolesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugRolesHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugRolesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugRolesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugRolesHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugRolesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugRolesBodyKeyMax = 64;

export const postApiTenantsTenantSlugRolesBodyNameMax = 200;

export const postApiTenantsTenantSlugRolesBodyDescriptionMax = 2000;



export const PostApiTenantsTenantSlugRolesBody = /*#__PURE__*/ (() => zod.object({
  "key": zod.string().min(1).max(postApiTenantsTenantSlugRolesBodyKeyMax),
  "name": zod.string().min(1).max(postApiTenantsTenantSlugRolesBodyNameMax),
  "description": zod.string().max(postApiTenantsTenantSlugRolesBodyDescriptionMax).optional(),
  "permissionKeys": zod.array(zod.string()).optional()
}))()

export const PostApiTenantsTenantSlugRoles201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugRoles403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugRoles403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugRoles403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugRoles403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugRoles403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugRoles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugRoles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugRoles409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugRoles409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugRoles409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugRoles409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugRoles409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugRoles409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugRoles409ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugRoles409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugRoles409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read global platform module settings
 */
export const GetApiPlatformAdminFeatures200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))
}))()

export const getApiPlatformAdminFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminFeatures403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminFeatures403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminFeatures403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminFeatures403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminFeatures403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminFeatures403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminFeatures403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Set a global platform module switch for all tenants
 */
export const PatchApiPlatformAdminFeaturesModuleKeyParams = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])
}))()

export const PatchApiPlatformAdminFeaturesModuleKeyBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean()
}))()

export const PatchApiPlatformAdminFeaturesModuleKey200Response = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))()

export const patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminFeaturesModuleKey403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read parent feature settings as a platform administrator
 */
export const GetApiPlatformAdminTenantsTenantIdParentFeaturesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const GetApiPlatformAdminTenantsTenantIdParentFeatures200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))
}))()

export const getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdParentFeatures403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdParentFeatures403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdParentFeatures403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdParentFeatures403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Set a parent feature switch as a platform administrator
 */
export const PatchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKeyParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])
}))()

export const PatchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKeyBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean()
}))()

export const PatchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey200Response = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))()

export const patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdParentFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read effective entity features as a platform administrator
 */
export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
}))()

export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "platformEnabled": zod.boolean(),
  "tenantEnabled": zod.boolean(),
  "entityOverride": zod.enum(['off', 'inherit']),
  "inheritedEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal(null)]).nullable(),
  "ready": zod.boolean()
}))
}))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeatures404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Set or reset an entity feature opt-out as a platform administrator
 */
export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKeyParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])
}))()

export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKeyBody = /*#__PURE__*/ (() => zod.object({
  "override": zod.enum(['off', 'inherit'])
}))()

export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey200Response = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "platformEnabled": zod.boolean(),
  "tenantEnabled": zod.boolean(),
  "entityOverride": zod.enum(['off', 'inherit']),
  "inheritedEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal(null)]).nullable(),
  "ready": zod.boolean()
}))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningAcknowledgementMin).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiPlatformAdminTenantsTenantIdEntitiesEntityIdFeaturesModuleKey404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read the combined tenant check-in and automatic release policy
 */
export const GetTenantCheckInPolicyParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const getTenantCheckInPolicy200ResponseRevisionMin = 0;
export const getTenantCheckInPolicy200ResponseRevisionMax = 9007199254740991;



export const GetTenantCheckInPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "enabled": zod.boolean().describe('Allows existing per-resource check-in policy; false also disables missed-check-in release and takeover.'),
  "revision": zod.int().min(getTenantCheckInPolicy200ResponseRevisionMin).max(getTenantCheckInPolicy200ResponseRevisionMax),
  "canManage": zod.boolean()
}))()

export const GetTenantCheckInPolicy403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetTenantCheckInPolicy503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Save the combined tenant policy and durable waiver boundary
 */
export const UpdateTenantCheckInPolicyParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const updateTenantCheckInPolicyBodyExpectedRevisionMin = 0;
export const updateTenantCheckInPolicyBodyExpectedRevisionMax = 9007199254740990;



export const UpdateTenantCheckInPolicyBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean(),
  "expectedRevision": zod.int().min(updateTenantCheckInPolicyBodyExpectedRevisionMin).max(updateTenantCheckInPolicyBodyExpectedRevisionMax)
}))()

export const updateTenantCheckInPolicy200ResponseRevisionMin = 0;
export const updateTenantCheckInPolicy200ResponseRevisionMax = 9007199254740991;



export const UpdateTenantCheckInPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "enabled": zod.boolean().describe('Allows existing per-resource check-in policy; false also disables missed-check-in release and takeover.'),
  "revision": zod.int().min(updateTenantCheckInPolicy200ResponseRevisionMin).max(updateTenantCheckInPolicy200ResponseRevisionMax),
  "canManage": zod.boolean()
}))()

export const UpdateTenantCheckInPolicy400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateTenantCheckInPolicy403Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateTenantCheckInPolicy409Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateTenantCheckInPolicy503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read the authoritative parent policy for the selected entity
 */
export const GetEntityCheckInPolicyParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getEntityCheckInPolicy200ResponseRevisionMin = 0;
export const getEntityCheckInPolicy200ResponseRevisionMax = 9007199254740991;



export const GetEntityCheckInPolicy200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "enabled": zod.boolean(),
  "revision": zod.int().min(getEntityCheckInPolicy200ResponseRevisionMin).max(getEntityCheckInPolicy200ResponseRevisionMax),
  "canManage": zod.boolean()
}))()

export const GetEntityCheckInPolicy403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetEntityCheckInPolicy503Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read parent tenant feature settings
 */
export const GetApiTenantAdminTenantsTenantIdFeaturesParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid()
}))()

export const GetApiTenantAdminTenantsTenantIdFeatures200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))
}))()

export const getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantAdminTenantsTenantIdFeatures403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantAdminTenantsTenantIdFeatures403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantAdminTenantsTenantIdFeatures403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantAdminTenantsTenantIdFeatures403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Set a parent tenant feature switch
 */
export const PatchApiTenantAdminTenantsTenantIdFeaturesModuleKeyParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])
}))()

export const PatchApiTenantAdminTenantsTenantIdFeaturesModuleKeyBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean()
}))()

export const PatchApiTenantAdminTenantsTenantIdFeaturesModuleKey200Response = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "enabled": zod.boolean()
}))()

export const patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantAdminTenantsTenantIdFeaturesModuleKey403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantAdminTenantsTenantIdFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read effective features for the selected entity
 */
export const GetApiTenantsTenantSlugFeaturesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugFeaturesHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugFeaturesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugFeaturesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugFeaturesHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugFeaturesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugFeatures200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "platformEnabled": zod.boolean(),
  "tenantEnabled": zod.boolean(),
  "entityOverride": zod.enum(['off', 'inherit']),
  "inheritedEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal(null)]).nullable(),
  "ready": zod.boolean()
}))
}))()

export const getApiTenantsTenantSlugFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugFeatures403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugFeatures403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugFeatures403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugFeatures403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugFeatures403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugFeatures403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugFeatures403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugFeatures403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugFeatures403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Set or reset an entity off override
 */
export const PatchApiTenantsTenantSlugFeaturesModuleKeyParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools'])
}))()

export const patchApiTenantsTenantSlugFeaturesModuleKeyHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugFeaturesModuleKeyHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugFeaturesModuleKeyHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugFeaturesModuleKeyHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugFeaturesModuleKeyHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PatchApiTenantsTenantSlugFeaturesModuleKeyBody = /*#__PURE__*/ (() => zod.object({
  "override": zod.enum(['off', 'inherit'])
}))()

export const PatchApiTenantsTenantSlugFeaturesModuleKey200Response = /*#__PURE__*/ (() => zod.object({
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "platformEnabled": zod.boolean(),
  "tenantEnabled": zod.boolean(),
  "entityOverride": zod.enum(['off', 'inherit']),
  "inheritedEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal(null)]).nullable(),
  "ready": zod.boolean()
}))()

export const patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugFeaturesModuleKey403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugFeaturesModuleKey403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugFeaturesModuleKey403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read tenant settings
 */
export const GetApiTenantsTenantSlugSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugSettings200Response = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

}).nullable()
}))()

export const getApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugSettings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugSettings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugSettings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update tenant settings (shallow merge)
 */
export const PatchApiTenantsTenantSlugSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const patchApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PatchApiTenantsTenantSlugSettingsBody = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

})
}))()

export const PatchApiTenantsTenantSlugSettings200Response = /*#__PURE__*/ (() => zod.object({
  "settings": zod.looseObject({

})
}))()

export const patchApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugSettings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugSettings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugSettings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugSettings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read effective workplace options for the selected entity
 */
export const GetApiTenantsTenantSlugWorkplaceOptionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugWorkplaceOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getApiTenantsTenantSlugWorkplaceOptions200ResponsePlatformDefaultsDefaultSiteTimezoneMax = 64;

export const getApiTenantsTenantSlugWorkplaceOptions200ResponseEffectiveDefaultSiteTimezoneMax = 64;

export const getApiTenantsTenantSlugWorkplaceOptions200ResponseTenantValuesDefaultSiteTimezoneMax = 64;

export const getApiTenantsTenantSlugWorkplaceOptions200ResponseEntityValuesDefaultSiteTimezoneMax = 64;



export const GetApiTenantsTenantSlugWorkplaceOptions200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "platformDefaults": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(getApiTenantsTenantSlugWorkplaceOptions200ResponsePlatformDefaultsDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "effective": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(getApiTenantsTenantSlugWorkplaceOptions200ResponseEffectiveDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "tenantValues": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(getApiTenantsTenantSlugWorkplaceOptions200ResponseTenantValuesDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "entityValues": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(getApiTenantsTenantSlugWorkplaceOptions200ResponseEntityValuesDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "allowEntityOverrides": zod.object({
  "siteCoordinatesDisabled": zod.boolean().optional(),
  "australianTimezoneList": zod.boolean().optional(),
  "oneScreenBook": zod.boolean().optional().describe('Legacy field; the Book layout is shared across entities.')
}),
  "platformAdmin": zod.boolean().optional(),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean()
}))()


/**
 * @summary Update tenant values or permitted entity overrides for workplace options
 */
export const PatchApiTenantsTenantSlugWorkplaceOptionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const patchApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugWorkplaceOptionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugWorkplaceOptionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const patchApiTenantsTenantSlugWorkplaceOptionsBodyValuesDefaultSiteTimezoneMax = 64;



export const PatchApiTenantsTenantSlugWorkplaceOptionsBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptionsBodyValuesDefaultSiteTimezoneMax).nullish().describe('Tenant scope only. Null clears the default.')
}).optional(),
  "allowEntityOverrides": zod.object({
  "siteCoordinatesDisabled": zod.boolean().optional(),
  "australianTimezoneList": zod.boolean().optional()
}).optional()
}))()

export const patchApiTenantsTenantSlugWorkplaceOptions200ResponsePlatformDefaultsDefaultSiteTimezoneMax = 64;

export const patchApiTenantsTenantSlugWorkplaceOptions200ResponseEffectiveDefaultSiteTimezoneMax = 64;

export const patchApiTenantsTenantSlugWorkplaceOptions200ResponseTenantValuesDefaultSiteTimezoneMax = 64;

export const patchApiTenantsTenantSlugWorkplaceOptions200ResponseEntityValuesDefaultSiteTimezoneMax = 64;



export const PatchApiTenantsTenantSlugWorkplaceOptions200Response = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "platformDefaults": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptions200ResponsePlatformDefaultsDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "effective": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptions200ResponseEffectiveDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "tenantValues": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptions200ResponseTenantValuesDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "entityValues": zod.object({
  "siteCoordinatesDisabled": zod.boolean().nullish(),
  "australianTimezoneList": zod.boolean().nullish(),
  "defaultSiteTimezone": zod.string().min(1).max(patchApiTenantsTenantSlugWorkplaceOptions200ResponseEntityValuesDefaultSiteTimezoneMax).nullish().describe('Tenant-only default for new sites; unset uses Australia/Sydney.'),
  "oneScreenBook": zod.boolean().nullish().describe('Legacy field; Book always uses the one-screen layout.')
}),
  "allowEntityOverrides": zod.object({
  "siteCoordinatesDisabled": zod.boolean().optional(),
  "australianTimezoneList": zod.boolean().optional(),
  "oneScreenBook": zod.boolean().optional().describe('Legacy field; the Book layout is shared across entities.')
}),
  "platformAdmin": zod.boolean().optional(),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean()
}))()

export const patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugWorkplaceOptions403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugWorkplaceOptions403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugWorkplaceOptions403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugWorkplaceOptions403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List Security.txt entries by web address (platform administrators only)
 */
export const getApiPlatformSecurityTxtQueryPageDefault = 1;
export const getApiPlatformSecurityTxtQueryPageMax = 10000;

export const getApiPlatformSecurityTxtQueryPageSizeDefault = 25;
export const getApiPlatformSecurityTxtQueryPageSizeMax = 100;

export const getApiPlatformSecurityTxtQuerySearchMax = 200;



export const GetApiPlatformSecurityTxtQueryParams = /*#__PURE__*/ (() => zod.object({
  "page": zod.int().min(1).max(getApiPlatformSecurityTxtQueryPageMax).default(getApiPlatformSecurityTxtQueryPageDefault),
  "pageSize": zod.int().min(1).max(getApiPlatformSecurityTxtQueryPageSizeMax).default(getApiPlatformSecurityTxtQueryPageSizeDefault),
  "search": zod.string().max(getApiPlatformSecurityTxtQuerySearchMax).optional().describe('Matches the web address or organisation label')
}))()

export const GetApiPlatformSecurityTxt200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "hostPattern": zod.string(),
  "isWildcard": zod.boolean(),
  "organization": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}),zod.null()]),
  "note": zod.string().nullable(),
  "errorCount": zod.int(),
  "warningCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "page": zod.int(),
  "pageSize": zod.int(),
  "total": zod.int()
}))()

export const getApiPlatformSecurityTxt400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformSecurityTxt400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformSecurityTxt400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformSecurityTxt400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformSecurityTxt400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformSecurityTxt400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxt400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxt400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformSecurityTxt400ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformSecurityTxt400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformSecurityTxt400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformSecurityTxt403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformSecurityTxt403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformSecurityTxt403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a Security.txt entry for a web address (platform administrators only)
 */
export const postApiPlatformSecurityTxtBodyHostPatternMax = 300;

export const postApiPlatformSecurityTxtBodyContentMax = 65536;

export const postApiPlatformSecurityTxtBodyNoteMax = 600;



export const PostApiPlatformSecurityTxtBody = /*#__PURE__*/ (() => zod.object({
  "hostPattern": zod.string().max(postApiPlatformSecurityTxtBodyHostPatternMax).describe('Exact hostname or a leading wildcard such as *.example.gov.au. Stored lowercase in punycode.'),
  "content": zod.string().max(postApiPlatformSecurityTxtBodyContentMax).describe('UTF-8 Security.txt text; must have no validator errors.'),
  "organizationId": zod.uuid().nullish().describe('Optional organisation label; never affects which text is served.'),
  "note": zod.string().max(postApiPlatformSecurityTxtBodyNoteMax).nullish()
}))()

export const PostApiPlatformSecurityTxt201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "hostPattern": zod.string(),
  "isWildcard": zod.boolean(),
  "organization": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}),zod.null()]),
  "note": zod.string().nullable(),
  "content": zod.string(),
  "findings": zod.object({
  "errors": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "warnings": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "fields": zod.array(zod.object({
  "name": zod.string(),
  "value": zod.string(),
  "line": zod.int()
}))
}),
  "servedUrl": zod.string().nullable().describe('Public address for exact entries; null for wildcards.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformSecurityTxt400ResponseOneOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformSecurityTxt400ResponseOneOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformSecurityTxt400ResponseOneOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformSecurityTxt400ResponseOneOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformSecurityTxt400ResponseOnePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformSecurityTxt400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt400ResponseOneOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt400ResponseOneOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformSecurityTxt400ResponseOneOverlapWarningAcknowledgementMin).max(postApiPlatformSecurityTxt400ResponseOneOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformSecurityTxt400ResponseOnePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.').and(zod.object({
  "errors": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "warnings": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "fields": zod.array(zod.object({
  "name": zod.string(),
  "value": zod.string(),
  "line": zod.int()
}))
})))()

export const postApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformSecurityTxt403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformSecurityTxt403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformSecurityTxt403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformSecurityTxt403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformSecurityTxt409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformSecurityTxt409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformSecurityTxt409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformSecurityTxt409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformSecurityTxt409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformSecurityTxt409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformSecurityTxt409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformSecurityTxt409ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformSecurityTxt409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformSecurityTxt409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read a Security.txt entry (platform administrators only)
 */
export const GetApiPlatformSecurityTxtIdParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const GetApiPlatformSecurityTxtId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "hostPattern": zod.string(),
  "isWildcard": zod.boolean(),
  "organization": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}),zod.null()]),
  "note": zod.string().nullable(),
  "content": zod.string(),
  "findings": zod.object({
  "errors": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "warnings": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "fields": zod.array(zod.object({
  "name": zod.string(),
  "value": zod.string(),
  "line": zod.int()
}))
}),
  "servedUrl": zod.string().nullable().describe('Public address for exact entries; null for wildcards.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformSecurityTxtId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformSecurityTxtId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Replace a Security.txt entry (platform administrators only)
 */
export const PutApiPlatformSecurityTxtIdParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const putApiPlatformSecurityTxtIdBodyHostPatternMax = 300;

export const putApiPlatformSecurityTxtIdBodyContentMax = 65536;

export const putApiPlatformSecurityTxtIdBodyNoteMax = 600;



export const PutApiPlatformSecurityTxtIdBody = /*#__PURE__*/ (() => zod.object({
  "hostPattern": zod.string().max(putApiPlatformSecurityTxtIdBodyHostPatternMax).describe('Exact hostname or a leading wildcard such as *.example.gov.au. Stored lowercase in punycode.'),
  "content": zod.string().max(putApiPlatformSecurityTxtIdBodyContentMax).describe('UTF-8 Security.txt text; must have no validator errors.'),
  "organizationId": zod.uuid().nullish().describe('Optional organisation label; never affects which text is served.'),
  "note": zod.string().max(putApiPlatformSecurityTxtIdBodyNoteMax).nullish()
}))()

export const PutApiPlatformSecurityTxtId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "hostPattern": zod.string(),
  "isWildcard": zod.boolean(),
  "organization": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}),zod.null()]),
  "note": zod.string().nullable(),
  "content": zod.string(),
  "findings": zod.object({
  "errors": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "warnings": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "fields": zod.array(zod.object({
  "name": zod.string(),
  "value": zod.string(),
  "line": zod.int()
}))
}),
  "servedUrl": zod.string().nullable().describe('Public address for exact entries; null for wildcards.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const putApiPlatformSecurityTxtId400ResponseOneOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformSecurityTxtId400ResponseOneOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformSecurityTxtId400ResponseOneOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformSecurityTxtId400ResponseOneOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformSecurityTxtId400ResponseOnePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformSecurityTxtId400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId400ResponseOneOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId400ResponseOneOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformSecurityTxtId400ResponseOneOverlapWarningAcknowledgementMin).max(putApiPlatformSecurityTxtId400ResponseOneOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformSecurityTxtId400ResponseOnePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.').and(zod.object({
  "errors": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "warnings": zod.array(zod.object({
  "message": zod.string(),
  "line": zod.int().nullable(),
  "field": zod.string().nullable()
})),
  "fields": zod.array(zod.object({
  "name": zod.string(),
  "value": zod.string(),
  "line": zod.int()
}))
})))()

export const putApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformSecurityTxtId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformSecurityTxtId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformSecurityTxtId409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformSecurityTxtId409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformSecurityTxtId409ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformSecurityTxtId409ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformSecurityTxtId409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformSecurityTxtId409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformSecurityTxtId409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformSecurityTxtId409ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformSecurityTxtId409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformSecurityTxtId409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Delete a Security.txt entry and stop serving it (platform administrators only)
 */
export const DeleteApiPlatformSecurityTxtIdParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const DeleteApiPlatformSecurityTxtId204Response = /*#__PURE__*/ (() => zod.void())()

export const deleteApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformSecurityTxtId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformSecurityTxtId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformSecurityTxtId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformSecurityTxtId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const deleteApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiPlatformSecurityTxtId404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiPlatformSecurityTxtId404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMin).max(deleteApiPlatformSecurityTxtId404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiPlatformSecurityTxtId404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Off by default. A missing or unrecognised setting reads as disabled, so signed-out visitors see the sign-in screen until a platform administrator turns the public Welcome, Features and FAQ pages on.
 * @summary Read the public visitor pages switch (platform administrators only)
 */
export const GetApiPlatformPublicPages200Response = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean().describe('Whether signed-out visitors see the Welcome, Features and FAQ pages'),
  "source": zod.enum(['default', 'platform']).describe('default when no value has been saved'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const getApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformPublicPages401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformPublicPages401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformPublicPages401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformPublicPages403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformPublicPages403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformPublicPages403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Changes are recorded in the platform audit log with the previous and new value.
 * @summary Turn the public visitor pages on or off (platform administrators only)
 */
export const PutApiPlatformPublicPagesBody = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean()
}))()

export const PutApiPlatformPublicPages200Response = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean().describe('Whether signed-out visitors see the Welcome, Features and FAQ pages'),
  "source": zod.enum(['default', 'platform']).describe('default when no value has been saved'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const putApiPlatformPublicPages400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformPublicPages400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformPublicPages400ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformPublicPages400ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformPublicPages400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformPublicPages400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformPublicPages400ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformPublicPages400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformPublicPages400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformPublicPages401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformPublicPages401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformPublicPages401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformPublicPages401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const putApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiPlatformPublicPages403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiPlatformPublicPages403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiPlatformPublicPages403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMin).max(putApiPlatformPublicPages403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiPlatformPublicPages403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Unauthenticated and read-only. Returns only whether signed-out visitors may see the Welcome, Features and FAQ pages.
 * @summary Read whether the public visitor pages are on
 */
export const GetPublicPagesStatus200Response = /*#__PURE__*/ (() => zod.object({
  "enabled": zod.boolean()
}))()

export const GetPublicPagesStatus429Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read effective customer settings for the selected entity
 */
export const GetApiTenantsTenantSlugCustomerSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugCustomerSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const getApiTenantsTenantSlugCustomerSettings200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const getApiTenantsTenantSlugCustomerSettings200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinVersionMax = 1;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveVersionMax = 1;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesVersionMax = 1;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesVersionMax = 1;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const GetApiTenantsTenantSlugCustomerSettings200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(getApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(getApiTenantsTenantSlugCustomerSettings200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(getApiTenantsTenantSlugCustomerSettings200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMin).max(getApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()


/**
 * @summary Update tenant defaults or permitted entity overrides
 */
export const PatchApiTenantsTenantSlugCustomerSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const patchApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugCustomerSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugCustomerSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const patchApiTenantsTenantSlugCustomerSettingsBodySidebarDisplayExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyPrivacyOneExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyAllowEntityOverridesSkinScopeFlagsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinVersionMax = 1;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyWeightsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoMinWidthMin = 24;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoMinWidthMax = 640;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoClearSpaceMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoClearSpaceMax = 160;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesColorsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesTopStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesTopStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesBottomStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesBottomStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesOverlapMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesOverlapMax = 100;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesCropMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesCropMax = 80;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightThicknessMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightThicknessMax = 12;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightWidthMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightWidthMax = 480;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesControlRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesControlRadiusMax = 32;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesCardRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesCardRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesOverlayRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesOverlayRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusSmMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusSmMax = 32;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusMdMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusMdMax = 32;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusLgMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusLgMax = 48;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusXlMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusXlMax = 48;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusFullMin = 999;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusFullMax = 9999;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateHoverOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateHoverOpacityMax = 0.24;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStatePressedOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStatePressedOpacityMax = 0.32;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateDisabledOpacityMin = 0.38;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateDisabledOpacityMax = 0.6;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingWidthMin = 2;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingWidthMax = 4;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingOffsetMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingOffsetMax = 4;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationFastMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationFastMax = 300;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationBaseMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationBaseMax = 500;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinIconsStrokeWidthMax = 3;
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinIconsStrokeWidthMultipleOf = 0.25;

export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingApplicationNameMax = 80;


export const patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingOrderMin = 4;
export const patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingOrderMax = 4;

export const patchApiTenantsTenantSlugCustomerSettingsBodyHeaderDisplayExpectedRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemIdMax = 40;


export const patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemLabelMax = 40;

export const patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettingsBodyHomeLayoutSectionsMin = 5;
export const patchApiTenantsTenantSlugCustomerSettingsBodyHomeLayoutSectionsMax = 5;

export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneWidthExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneWidthMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneHeightExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneHeightMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneWidthExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneWidthMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneHeightExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneHeightMax = 1000;



export const PatchApiTenantsTenantSlugCustomerSettingsBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional().describe('Entity scope only.'),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "expectedRevision": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySidebarDisplayExpectedRevisionRegExp)
}).optional(),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "expectedRevision": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodyPrivacyOneExpectedRevisionRegExp)
}).optional().describe('Entity scope only. Current entity settings authority required; stale revision returns 409.'),
  "values": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}).optional(),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(patchApiTenantsTenantSlugCustomerSettingsBodyAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}).optional(),
  "skin": zod.object({
  "version": zod.int().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoMinWidthMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoClearSpaceMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesTopStrokeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesBottomStrokeMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesOverlapMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesCropMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightThicknessMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightWidthMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesControlRadiusMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesCardRadiusMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesOverlayRadiusMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusSmMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusMdMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusLgMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusXlMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusFullMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateHoverOpacityMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinStatePressedOpacityMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateDisabledOpacityMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingWidthMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingOffsetMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationFastMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationBaseMin).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodySkinIconsStrokeWidthMax).multipleOf(patchApiTenantsTenantSlugCustomerSettingsBodySkinIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodySkinMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Ordinary skin edits. Null restores inheritance; transfer-only app-default masks cannot be written here.'),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingApplicationNameMax).regex(patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingOrderMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyHeaderBrandingOrderMax).nullish()
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "expectedRevision": zod.string().regex(patchApiTenantsTenantSlugCustomerSettingsBodyHeaderDisplayExpectedRevisionRegExp)
}).optional(),
  "navigationLayout": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemIdMax).regex(patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemIdRegExp),
  "label": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(patchApiTenantsTenantSlugCustomerSettingsBodyNavigationLayoutGroupsMax)
}).nullish(),
  "homeLayout": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(patchApiTenantsTenantSlugCustomerSettingsBodyHomeLayoutSectionsMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyHomeLayoutSectionsMax)
}).nullish(),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneWidthExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneWidthMax),
  "height": zod.number().gt(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneHeightExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional(),
  "office": zod.union([zod.object({
  "width": zod.number().gt(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneWidthExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneWidthMax),
  "height": zod.number().gt(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneHeightExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettingsBodyMapOutlineStandardsOneOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]).optional()
}).describe('Null or absent classes use the organisation default.').optional().describe('Tenant scope only. Omitted classes are unchanged; null clears the organisation default.')
}))()

export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const patchApiTenantsTenantSlugCustomerSettings200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinVersionMax = 1;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveVersionMax = 1;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesVersionMax = 1;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesVersionMax = 1;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const PatchApiTenantsTenantSlugCustomerSettings200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(patchApiTenantsTenantSlugCustomerSettings200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(patchApiTenantsTenantSlugCustomerSettings200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(patchApiTenantsTenantSlugCustomerSettings200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMin).max(patchApiTenantsTenantSlugCustomerSettings200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()

export const patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugCustomerSettings403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugCustomerSettings403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugCustomerSettings403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugCustomerSettings403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Export the complete saved appearance, including inherited and app defaults
 */
export const ExportCustomerBrandingParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const ExportCustomerBrandingQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity'])
}))()

export const exportCustomerBrandingHeaderXGroupGraphTokenMax = 16384;


export const exportCustomerBrandingHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ExportCustomerBrandingHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(exportCustomerBrandingHeaderXGroupGraphTokenMax).regex(exportCustomerBrandingHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const exportCustomerBranding200ResponseValuesLightPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseValuesDarkPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinLightOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinDarkOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinTypographyOneWeightsMax = 4;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleXsSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScaleXsSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleXsLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleSmSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScaleSmSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleSmLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleBaseSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScaleBaseSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleBaseLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleLgSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScaleLgSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleLgLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleXlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScaleXlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScaleXlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScale2xlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScale2xlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScale2xlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinTypographyOneScale3xlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinTypographyOneScale3xlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinTypographyOneScale3xlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinLogoOneMinWidthMin = 24;
export const exportCustomerBranding200ResponseSkinLogoOneMinWidthMax = 640;

export const exportCustomerBranding200ResponseSkinLogoOneClearSpaceMin = 0;
export const exportCustomerBranding200ResponseSkinLogoOneClearSpaceMax = 160;

export const exportCustomerBranding200ResponseSkinSurfacesOneControlRadiusMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneControlRadiusMax = 32;

export const exportCustomerBranding200ResponseSkinSurfacesOneCardRadiusMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneCardRadiusMax = 48;

export const exportCustomerBranding200ResponseSkinSurfacesOneOverlayRadiusMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneOverlayRadiusMax = 48;

export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusSmMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusSmMax = 32;

export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusMdMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusMdMax = 32;

export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusLgMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusLgMax = 48;

export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusXlMin = 0;
export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusXlMax = 48;

export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusFullMin = 999;
export const exportCustomerBranding200ResponseSkinSurfacesOneRadiusFullMax = 9999;

export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneColorsMax = 4;

export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneTopStrokeMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneTopStrokeMax = 24;

export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneBottomStrokeMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneBottomStrokeMax = 24;

export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneOverlapMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneOverlapMax = 100;

export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneCropMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsCirclesOneCropMax = 80;

export const exportCustomerBranding200ResponseSkinDecorationsHighlightOneThicknessMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsHighlightOneThicknessMax = 12;

export const exportCustomerBranding200ResponseSkinDecorationsHighlightOneWidthMin = 0;
export const exportCustomerBranding200ResponseSkinDecorationsHighlightOneWidthMax = 480;

export const exportCustomerBranding200ResponseSkinExtendedLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlSizeMin = 0.625;
export const exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlSizeMax = 3;

export const exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlLineHeightMax = 2;

export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusSmMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusSmMax = 32;

export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusMdMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusMdMax = 32;

export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusLgMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusLgMax = 48;

export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusXlMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusXlMax = 48;

export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusFullMin = 999;
export const exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusFullMax = 9999;

export const exportCustomerBranding200ResponseSkinExtendedStateHoverOpacityMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedStateHoverOpacityMax = 0.24;

export const exportCustomerBranding200ResponseSkinExtendedStatePressedOpacityMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedStatePressedOpacityMax = 0.32;

export const exportCustomerBranding200ResponseSkinExtendedStateDisabledOpacityMin = 0.38;
export const exportCustomerBranding200ResponseSkinExtendedStateDisabledOpacityMax = 0.6;

export const exportCustomerBranding200ResponseSkinExtendedStateFocusRingWidthMin = 2;
export const exportCustomerBranding200ResponseSkinExtendedStateFocusRingWidthMax = 4;

export const exportCustomerBranding200ResponseSkinExtendedStateFocusRingOffsetMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedStateFocusRingOffsetMax = 4;

export const exportCustomerBranding200ResponseSkinExtendedMotionDurationFastMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedMotionDurationFastMax = 300;

export const exportCustomerBranding200ResponseSkinExtendedMotionDurationBaseMin = 0;
export const exportCustomerBranding200ResponseSkinExtendedMotionDurationBaseMax = 500;

export const exportCustomerBranding200ResponseSkinExtendedIconsStrokeWidthMax = 3;
export const exportCustomerBranding200ResponseSkinExtendedIconsStrokeWidthMultipleOf = 0.25;

export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseSkinExtendedMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const exportCustomerBranding200ResponseHeaderBrandingApplicationNameMax = 80;


export const exportCustomerBranding200ResponseHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const exportCustomerBranding200ResponseHeaderBrandingOrderMin = 4;
export const exportCustomerBranding200ResponseHeaderBrandingOrderMax = 4;

export const exportCustomerBranding200ResponseLogosCustomerOneImageBase64Max = 350000;

export const exportCustomerBranding200ResponseLogosCustomerOneAltTextMax = 120;

export const exportCustomerBranding200ResponseLogosApplicationOneImageBase64Max = 350000;

export const exportCustomerBranding200ResponseLogosApplicationOneAltTextMax = 120;



export const ExportCustomerBranding200Response = /*#__PURE__*/ (() => zod.object({
  "kind": zod.enum(['app-branding']),
  "version": zod.literal(1),
  "sourceScope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "lightPrimary": zod.string().regex(exportCustomerBranding200ResponseValuesLightPrimaryRegExp).nullable(),
  "darkPrimary": zod.string().regex(exportCustomerBranding200ResponseValuesDarkPrimaryRegExp).nullable()
}),
  "skin": zod.object({
  "version": zod.literal(1),
  "light": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(exportCustomerBranding200ResponseSkinLightOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinLightOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "dark": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinDarkOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "palette": zod.object({
  "primary": zod.string().nullable(),
  "secondary": zod.string().nullable(),
  "accent": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "subtle": zod.string().nullable(),
  "neutral": zod.string().nullable()
}).describe('Named supporting colours that decorative elements can reference.').and(zod.looseObject({

})),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullable(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(exportCustomerBranding200ResponseSkinTypographyOneWeightsMax).nullable(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullable(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScaleXsSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScaleSmSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScaleBaseSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScaleLgSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScaleXlSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScale2xlSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinTypographyOneScale3xlSizeMin).max(exportCustomerBranding200ResponseSkinTypographyOneScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinTypographyOneScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.').and(zod.looseObject({

})),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullable().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(exportCustomerBranding200ResponseSkinLogoOneMinWidthMin).max(exportCustomerBranding200ResponseSkinLogoOneMinWidthMax).nullable(),
  "clearSpace": zod.int().min(exportCustomerBranding200ResponseSkinLogoOneClearSpaceMin).max(exportCustomerBranding200ResponseSkinLogoOneClearSpaceMax).nullable(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullable()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.').and(zod.looseObject({

})),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(exportCustomerBranding200ResponseSkinSurfacesOneControlRadiusMin).max(exportCustomerBranding200ResponseSkinSurfacesOneControlRadiusMax).nullable(),
  "cardRadius": zod.number().min(exportCustomerBranding200ResponseSkinSurfacesOneCardRadiusMin).max(exportCustomerBranding200ResponseSkinSurfacesOneCardRadiusMax).nullable(),
  "overlayRadius": zod.number().min(exportCustomerBranding200ResponseSkinSurfacesOneOverlayRadiusMin).max(exportCustomerBranding200ResponseSkinSurfacesOneOverlayRadiusMax).nullable(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullable(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullable(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullable(),
  "radius": zod.object({
  "sm": zod.int().min(exportCustomerBranding200ResponseSkinSurfacesOneRadiusSmMin).max(exportCustomerBranding200ResponseSkinSurfacesOneRadiusSmMax).nullish(),
  "md": zod.int().min(exportCustomerBranding200ResponseSkinSurfacesOneRadiusMdMin).max(exportCustomerBranding200ResponseSkinSurfacesOneRadiusMdMax).nullish(),
  "lg": zod.int().min(exportCustomerBranding200ResponseSkinSurfacesOneRadiusLgMin).max(exportCustomerBranding200ResponseSkinSurfacesOneRadiusLgMax).nullish(),
  "xl": zod.int().min(exportCustomerBranding200ResponseSkinSurfacesOneRadiusXlMin).max(exportCustomerBranding200ResponseSkinSurfacesOneRadiusXlMax).nullish(),
  "full": zod.int().min(exportCustomerBranding200ResponseSkinSurfacesOneRadiusFullMin).max(exportCustomerBranding200ResponseSkinSurfacesOneRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).and(zod.looseObject({

})),
  "decorations": zod.object({
  "enabled": zod.boolean().nullable(),
  "circles": zod.object({
  "enabled": zod.boolean().nullable(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(exportCustomerBranding200ResponseSkinDecorationsCirclesOneColorsMax).nullable(),
  "topStroke": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsCirclesOneTopStrokeMin).max(exportCustomerBranding200ResponseSkinDecorationsCirclesOneTopStrokeMax).nullable(),
  "bottomStroke": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsCirclesOneBottomStrokeMin).max(exportCustomerBranding200ResponseSkinDecorationsCirclesOneBottomStrokeMax).nullable(),
  "overlap": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsCirclesOneOverlapMin).max(exportCustomerBranding200ResponseSkinDecorationsCirclesOneOverlapMax).nullable(),
  "crop": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsCirclesOneCropMin).max(exportCustomerBranding200ResponseSkinDecorationsCirclesOneCropMax).nullable(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Overlapping-circle decoration, bounded to safe measurements.').and(zod.looseObject({

})),
  "highlight": zod.object({
  "enabled": zod.boolean().nullable(),
  "color": zod.string().nullable(),
  "thickness": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsHighlightOneThicknessMin).max(exportCustomerBranding200ResponseSkinDecorationsHighlightOneThicknessMax).nullable(),
  "width": zod.number().min(exportCustomerBranding200ResponseSkinDecorationsHighlightOneWidthMin).max(exportCustomerBranding200ResponseSkinDecorationsHighlightOneWidthMax).nullable(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Short accent line under main page titles.').and(zod.looseObject({

}))
}),
  "extended": zod.object({
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "typography": zod.object({
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlSizeMin).max(exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish()
}).optional(),
  "surfaces": zod.object({
  "radius": zod.object({
  "sm": zod.int().min(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusSmMin).max(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusMdMin).max(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusLgMin).max(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusXlMin).max(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusFullMin).max(exportCustomerBranding200ResponseSkinExtendedSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(exportCustomerBranding200ResponseSkinExtendedStateHoverOpacityMin).max(exportCustomerBranding200ResponseSkinExtendedStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(exportCustomerBranding200ResponseSkinExtendedStatePressedOpacityMin).max(exportCustomerBranding200ResponseSkinExtendedStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(exportCustomerBranding200ResponseSkinExtendedStateDisabledOpacityMin).max(exportCustomerBranding200ResponseSkinExtendedStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(exportCustomerBranding200ResponseSkinExtendedStateFocusRingWidthMin).max(exportCustomerBranding200ResponseSkinExtendedStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(exportCustomerBranding200ResponseSkinExtendedStateFocusRingOffsetMin).max(exportCustomerBranding200ResponseSkinExtendedStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(exportCustomerBranding200ResponseSkinExtendedMotionDurationFastMin).max(exportCustomerBranding200ResponseSkinExtendedMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(exportCustomerBranding200ResponseSkinExtendedMotionDurationBaseMin).max(exportCustomerBranding200ResponseSkinExtendedMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(exportCustomerBranding200ResponseSkinExtendedIconsStrokeWidthMax).multipleOf(exportCustomerBranding200ResponseSkinExtendedIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(exportCustomerBranding200ResponseSkinExtendedMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Extended tokens (theme pairs, scales, state, motion, icons, map colours and brand scope). Optional; when absent an import keeps the destination\'s stored extended tokens.')
}),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(exportCustomerBranding200ResponseHeaderBrandingApplicationNameMax).regex(exportCustomerBranding200ResponseHeaderBrandingApplicationNameRegExp),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(exportCustomerBranding200ResponseHeaderBrandingOrderMin).max(exportCustomerBranding200ResponseHeaderBrandingOrderMax)
}),
  "logos": zod.object({
  "customer": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(exportCustomerBranding200ResponseLogosCustomerOneImageBase64Max),
  "altText": zod.string().min(1).max(exportCustomerBranding200ResponseLogosCustomerOneAltTextMax)
}),zod.object({
  "state": zod.enum(['absent'])
})]),
  "application": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(exportCustomerBranding200ResponseLogosApplicationOneImageBase64Max),
  "altText": zod.string().min(1).max(exportCustomerBranding200ResponseLogosApplicationOneAltTextMax)
}),zod.object({
  "state": zod.enum(['builtIn'])
})])
})
}))()

export const exportCustomerBranding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const exportCustomerBranding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const exportCustomerBranding403ResponseOverlapWarningAcknowledgementMin = 16;
export const exportCustomerBranding403ResponseOverlapWarningAcknowledgementMax = 256;


export const exportCustomerBranding403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ExportCustomerBranding403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportCustomerBranding403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(exportCustomerBranding403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(exportCustomerBranding403ResponseOverlapWarningAcknowledgementMin).max(exportCustomerBranding403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(exportCustomerBranding403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * At most 1 MiB total JSON. Confirmation expires after ten minutes and is invalidated by a server restart.
 * @summary Validate and review a branding replacement without saving
 */
export const PreviewCustomerBrandingImportParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const previewCustomerBrandingImportHeaderXGroupGraphTokenMax = 16384;


export const previewCustomerBrandingImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewCustomerBrandingImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewCustomerBrandingImportHeaderXGroupGraphTokenMax).regex(previewCustomerBrandingImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewCustomerBrandingImportBodyBrandingValuesLightPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingValuesDarkPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinLightOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinDarkOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneWeightsMax = 4;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMin = 24;
export const previewCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMax = 640;

export const previewCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMax = 160;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMax = 32;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMax = 32;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMax = 32;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMin = 999;
export const previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMax = 9999;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneColorsMax = 4;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMax = 24;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMax = 24;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMax = 100;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMax = 80;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMax = 12;

export const previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMax = 480;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMax = 3;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMax = 32;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMax = 32;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMax = 48;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMin = 999;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMax = 9999;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMax = 0.24;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMax = 0.32;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMin = 0.38;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMax = 0.6;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMin = 2;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMax = 4;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMax = 4;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMax = 300;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMin = 0;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMax = 500;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMax = 3;
export const previewCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameMax = 80;


export const previewCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const previewCustomerBrandingImportBodyBrandingHeaderBrandingOrderMin = 4;
export const previewCustomerBrandingImportBodyBrandingHeaderBrandingOrderMax = 4;

export const previewCustomerBrandingImportBodyBrandingLogosCustomerOneImageBase64Max = 350000;

export const previewCustomerBrandingImportBodyBrandingLogosCustomerOneAltTextMax = 120;

export const previewCustomerBrandingImportBodyBrandingLogosApplicationOneImageBase64Max = 350000;

export const previewCustomerBrandingImportBodyBrandingLogosApplicationOneAltTextMax = 120;



export const PreviewCustomerBrandingImportBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "branding": zod.object({
  "kind": zod.enum(['app-branding']),
  "version": zod.literal(1),
  "sourceScope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "lightPrimary": zod.string().regex(previewCustomerBrandingImportBodyBrandingValuesLightPrimaryRegExp).nullable(),
  "darkPrimary": zod.string().regex(previewCustomerBrandingImportBodyBrandingValuesDarkPrimaryRegExp).nullable()
}),
  "skin": zod.object({
  "version": zod.literal(1),
  "light": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinLightOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "dark": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinDarkOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "palette": zod.object({
  "primary": zod.string().nullable(),
  "secondary": zod.string().nullable(),
  "accent": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "subtle": zod.string().nullable(),
  "neutral": zod.string().nullable()
}).describe('Named supporting colours that decorative elements can reference.').and(zod.looseObject({

})),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullable(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneWeightsMax).nullable(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullable(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.').and(zod.looseObject({

})),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullable().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMin).max(previewCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMax).nullable(),
  "clearSpace": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMin).max(previewCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMax).nullable(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullable()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.').and(zod.looseObject({

})),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMax).nullable(),
  "cardRadius": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMax).nullable(),
  "overlayRadius": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMax).nullable(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullable(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullable(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullable(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMin).max(previewCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).and(zod.looseObject({

})),
  "decorations": zod.object({
  "enabled": zod.boolean().nullable(),
  "circles": zod.object({
  "enabled": zod.boolean().nullable(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneColorsMax).nullable(),
  "topStroke": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMax).nullable(),
  "bottomStroke": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMax).nullable(),
  "overlap": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMax).nullable(),
  "crop": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMax).nullable(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Overlapping-circle decoration, bounded to safe measurements.').and(zod.looseObject({

})),
  "highlight": zod.object({
  "enabled": zod.boolean().nullable(),
  "color": zod.string().nullable(),
  "thickness": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMax).nullable(),
  "width": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMin).max(previewCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMax).nullable(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Short accent line under main page titles.').and(zod.looseObject({

}))
}),
  "extended": zod.object({
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "typography": zod.object({
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish()
}).optional(),
  "surfaces": zod.object({
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMin).max(previewCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMax).multipleOf(previewCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Extended tokens (theme pairs, scales, state, motion, icons, map colours and brand scope). Optional; when absent an import keeps the destination\'s stored extended tokens.')
}),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(previewCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameMax).regex(previewCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameRegExp),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(previewCustomerBrandingImportBodyBrandingHeaderBrandingOrderMin).max(previewCustomerBrandingImportBodyBrandingHeaderBrandingOrderMax)
}),
  "logos": zod.object({
  "customer": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImportBodyBrandingLogosCustomerOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImportBodyBrandingLogosCustomerOneAltTextMax)
}),zod.object({
  "state": zod.enum(['absent'])
})]),
  "application": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImportBodyBrandingLogosApplicationOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImportBodyBrandingLogosApplicationOneAltTextMax)
}),zod.object({
  "state": zod.enum(['builtIn'])
})])
})
})
}))()

export const previewCustomerBrandingImport200ResponseBeforeValuesLightPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeValuesDarkPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinLightOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinDarkOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneWeightsMax = 4;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinLogoOneMinWidthMin = 24;
export const previewCustomerBrandingImport200ResponseBeforeSkinLogoOneMinWidthMax = 640;

export const previewCustomerBrandingImport200ResponseBeforeSkinLogoOneClearSpaceMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinLogoOneClearSpaceMax = 160;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneControlRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneControlRadiusMax = 32;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneCardRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneCardRadiusMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneOverlayRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneOverlayRadiusMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusSmMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusSmMax = 32;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusMdMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusMdMax = 32;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusLgMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusLgMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusXlMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusXlMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusFullMin = 999;
export const previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusFullMax = 9999;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneColorsMax = 4;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneTopStrokeMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneTopStrokeMax = 24;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneBottomStrokeMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneBottomStrokeMax = 24;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneOverlapMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneOverlapMax = 100;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneCropMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneCropMax = 80;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneThicknessMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneThicknessMax = 12;

export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneWidthMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneWidthMax = 480;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusSmMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusSmMax = 32;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusMdMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusMdMax = 32;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusLgMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusLgMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusXlMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusXlMax = 48;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusFullMin = 999;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusFullMax = 9999;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateHoverOpacityMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateHoverOpacityMax = 0.24;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStatePressedOpacityMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStatePressedOpacityMax = 0.32;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateDisabledOpacityMin = 0.38;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateDisabledOpacityMax = 0.6;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingWidthMin = 2;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingWidthMax = 4;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingOffsetMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingOffsetMax = 4;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationFastMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationFastMax = 300;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationBaseMin = 0;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationBaseMax = 500;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedIconsStrokeWidthMax = 3;
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseBeforeHeaderBrandingApplicationNameMax = 80;


export const previewCustomerBrandingImport200ResponseBeforeHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const previewCustomerBrandingImport200ResponseBeforeHeaderBrandingOrderMin = 4;
export const previewCustomerBrandingImport200ResponseBeforeHeaderBrandingOrderMax = 4;

export const previewCustomerBrandingImport200ResponseBeforeLogosCustomerOneImageBase64Max = 350000;

export const previewCustomerBrandingImport200ResponseBeforeLogosCustomerOneAltTextMax = 120;

export const previewCustomerBrandingImport200ResponseBeforeLogosApplicationOneImageBase64Max = 350000;

export const previewCustomerBrandingImport200ResponseBeforeLogosApplicationOneAltTextMax = 120;

export const previewCustomerBrandingImport200ResponseAfterValuesLightPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterValuesDarkPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinLightOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinDarkOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneWeightsMax = 4;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinLogoOneMinWidthMin = 24;
export const previewCustomerBrandingImport200ResponseAfterSkinLogoOneMinWidthMax = 640;

export const previewCustomerBrandingImport200ResponseAfterSkinLogoOneClearSpaceMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinLogoOneClearSpaceMax = 160;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneControlRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneControlRadiusMax = 32;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneCardRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneCardRadiusMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneOverlayRadiusMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneOverlayRadiusMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusSmMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusSmMax = 32;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusMdMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusMdMax = 32;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusLgMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusLgMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusXlMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusXlMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusFullMin = 999;
export const previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusFullMax = 9999;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneColorsMax = 4;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneTopStrokeMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneTopStrokeMax = 24;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneBottomStrokeMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneBottomStrokeMax = 24;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneOverlapMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneOverlapMax = 100;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneCropMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneCropMax = 80;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneThicknessMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneThicknessMax = 12;

export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneWidthMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneWidthMax = 480;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlSizeMin = 0.625;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlSizeMax = 3;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlLineHeightMax = 2;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusSmMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusSmMax = 32;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusMdMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusMdMax = 32;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusLgMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusLgMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusXlMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusXlMax = 48;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusFullMin = 999;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusFullMax = 9999;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateHoverOpacityMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateHoverOpacityMax = 0.24;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStatePressedOpacityMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStatePressedOpacityMax = 0.32;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateDisabledOpacityMin = 0.38;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateDisabledOpacityMax = 0.6;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingWidthMin = 2;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingWidthMax = 4;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingOffsetMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingOffsetMax = 4;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationFastMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationFastMax = 300;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationBaseMin = 0;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationBaseMax = 500;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedIconsStrokeWidthMax = 3;
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerBrandingImport200ResponseAfterHeaderBrandingApplicationNameMax = 80;


export const previewCustomerBrandingImport200ResponseAfterHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const previewCustomerBrandingImport200ResponseAfterHeaderBrandingOrderMin = 4;
export const previewCustomerBrandingImport200ResponseAfterHeaderBrandingOrderMax = 4;

export const previewCustomerBrandingImport200ResponseAfterLogosCustomerOneImageBase64Max = 350000;

export const previewCustomerBrandingImport200ResponseAfterLogosCustomerOneAltTextMax = 120;

export const previewCustomerBrandingImport200ResponseAfterLogosApplicationOneImageBase64Max = 350000;

export const previewCustomerBrandingImport200ResponseAfterLogosApplicationOneAltTextMax = 120;

export const previewCustomerBrandingImport200ResponseInheritanceImpactDescendantCountMin = 0;



export const PreviewCustomerBrandingImport200Response = /*#__PURE__*/ (() => zod.object({
  "target": zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable()
}),
  "before": zod.object({
  "kind": zod.enum(['app-branding']),
  "version": zod.literal(1),
  "sourceScope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "lightPrimary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeValuesLightPrimaryRegExp).nullable(),
  "darkPrimary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeValuesDarkPrimaryRegExp).nullable()
}),
  "skin": zod.object({
  "version": zod.literal(1),
  "light": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinLightOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "dark": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinDarkOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "palette": zod.object({
  "primary": zod.string().nullable(),
  "secondary": zod.string().nullable(),
  "accent": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "subtle": zod.string().nullable(),
  "neutral": zod.string().nullable()
}).describe('Named supporting colours that decorative elements can reference.').and(zod.looseObject({

})),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullable(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneWeightsMax).nullable(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullable(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinTypographyOneScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.').and(zod.looseObject({

})),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullable().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinLogoOneMinWidthMin).max(previewCustomerBrandingImport200ResponseBeforeSkinLogoOneMinWidthMax).nullable(),
  "clearSpace": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinLogoOneClearSpaceMin).max(previewCustomerBrandingImport200ResponseBeforeSkinLogoOneClearSpaceMax).nullable(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullable()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.').and(zod.looseObject({

})),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneControlRadiusMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneControlRadiusMax).nullable(),
  "cardRadius": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneCardRadiusMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneCardRadiusMax).nullable(),
  "overlayRadius": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneOverlayRadiusMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneOverlayRadiusMax).nullable(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullable(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullable(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullable(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusSmMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusMdMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusLgMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusXlMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusFullMin).max(previewCustomerBrandingImport200ResponseBeforeSkinSurfacesOneRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).and(zod.looseObject({

})),
  "decorations": zod.object({
  "enabled": zod.boolean().nullable(),
  "circles": zod.object({
  "enabled": zod.boolean().nullable(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneColorsMax).nullable(),
  "topStroke": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneTopStrokeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneTopStrokeMax).nullable(),
  "bottomStroke": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneBottomStrokeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneBottomStrokeMax).nullable(),
  "overlap": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneOverlapMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneOverlapMax).nullable(),
  "crop": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneCropMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsCirclesOneCropMax).nullable(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Overlapping-circle decoration, bounded to safe measurements.').and(zod.looseObject({

})),
  "highlight": zod.object({
  "enabled": zod.boolean().nullable(),
  "color": zod.string().nullable(),
  "thickness": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneThicknessMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneThicknessMax).nullable(),
  "width": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneWidthMin).max(previewCustomerBrandingImport200ResponseBeforeSkinDecorationsHighlightOneWidthMax).nullable(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Short accent line under main page titles.').and(zod.looseObject({

}))
}),
  "extended": zod.object({
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "typography": zod.object({
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlSizeMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish()
}).optional(),
  "surfaces": zod.object({
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusSmMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusMdMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusLgMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusXlMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusFullMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateHoverOpacityMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStatePressedOpacityMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateDisabledOpacityMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingWidthMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingOffsetMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationFastMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationBaseMin).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerBrandingImport200ResponseBeforeSkinExtendedIconsStrokeWidthMax).multipleOf(previewCustomerBrandingImport200ResponseBeforeSkinExtendedIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImport200ResponseBeforeSkinExtendedMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Extended tokens (theme pairs, scales, state, motion, icons, map colours and brand scope). Optional; when absent an import keeps the destination\'s stored extended tokens.')
}),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(previewCustomerBrandingImport200ResponseBeforeHeaderBrandingApplicationNameMax).regex(previewCustomerBrandingImport200ResponseBeforeHeaderBrandingApplicationNameRegExp),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(previewCustomerBrandingImport200ResponseBeforeHeaderBrandingOrderMin).max(previewCustomerBrandingImport200ResponseBeforeHeaderBrandingOrderMax)
}),
  "logos": zod.object({
  "customer": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImport200ResponseBeforeLogosCustomerOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImport200ResponseBeforeLogosCustomerOneAltTextMax)
}),zod.object({
  "state": zod.enum(['absent'])
})]),
  "application": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImport200ResponseBeforeLogosApplicationOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImport200ResponseBeforeLogosApplicationOneAltTextMax)
}),zod.object({
  "state": zod.enum(['builtIn'])
})])
})
}),
  "after": zod.object({
  "kind": zod.enum(['app-branding']),
  "version": zod.literal(1),
  "sourceScope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "lightPrimary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterValuesLightPrimaryRegExp).nullable(),
  "darkPrimary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterValuesDarkPrimaryRegExp).nullable()
}),
  "skin": zod.object({
  "version": zod.literal(1),
  "light": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinLightOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "dark": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinDarkOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "palette": zod.object({
  "primary": zod.string().nullable(),
  "secondary": zod.string().nullable(),
  "accent": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "subtle": zod.string().nullable(),
  "neutral": zod.string().nullable()
}).describe('Named supporting colours that decorative elements can reference.').and(zod.looseObject({

})),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullable(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneWeightsMax).nullable(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullable(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinTypographyOneScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.').and(zod.looseObject({

})),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullable().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinLogoOneMinWidthMin).max(previewCustomerBrandingImport200ResponseAfterSkinLogoOneMinWidthMax).nullable(),
  "clearSpace": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinLogoOneClearSpaceMin).max(previewCustomerBrandingImport200ResponseAfterSkinLogoOneClearSpaceMax).nullable(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullable()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.').and(zod.looseObject({

})),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneControlRadiusMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneControlRadiusMax).nullable(),
  "cardRadius": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneCardRadiusMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneCardRadiusMax).nullable(),
  "overlayRadius": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneOverlayRadiusMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneOverlayRadiusMax).nullable(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullable(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullable(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullable(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusSmMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusMdMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusLgMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusXlMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusFullMin).max(previewCustomerBrandingImport200ResponseAfterSkinSurfacesOneRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).and(zod.looseObject({

})),
  "decorations": zod.object({
  "enabled": zod.boolean().nullable(),
  "circles": zod.object({
  "enabled": zod.boolean().nullable(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneColorsMax).nullable(),
  "topStroke": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneTopStrokeMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneTopStrokeMax).nullable(),
  "bottomStroke": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneBottomStrokeMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneBottomStrokeMax).nullable(),
  "overlap": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneOverlapMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneOverlapMax).nullable(),
  "crop": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneCropMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsCirclesOneCropMax).nullable(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Overlapping-circle decoration, bounded to safe measurements.').and(zod.looseObject({

})),
  "highlight": zod.object({
  "enabled": zod.boolean().nullable(),
  "color": zod.string().nullable(),
  "thickness": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneThicknessMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneThicknessMax).nullable(),
  "width": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneWidthMin).max(previewCustomerBrandingImport200ResponseAfterSkinDecorationsHighlightOneWidthMax).nullable(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Short accent line under main page titles.').and(zod.looseObject({

}))
}),
  "extended": zod.object({
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "typography": zod.object({
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlSizeMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish()
}).optional(),
  "surfaces": zod.object({
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusSmMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusMdMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusLgMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusXlMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusFullMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateHoverOpacityMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedStatePressedOpacityMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateDisabledOpacityMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingWidthMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingOffsetMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationFastMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationBaseMin).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerBrandingImport200ResponseAfterSkinExtendedIconsStrokeWidthMax).multipleOf(previewCustomerBrandingImport200ResponseAfterSkinExtendedIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerBrandingImport200ResponseAfterSkinExtendedMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Extended tokens (theme pairs, scales, state, motion, icons, map colours and brand scope). Optional; when absent an import keeps the destination\'s stored extended tokens.')
}),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(previewCustomerBrandingImport200ResponseAfterHeaderBrandingApplicationNameMax).regex(previewCustomerBrandingImport200ResponseAfterHeaderBrandingApplicationNameRegExp),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(previewCustomerBrandingImport200ResponseAfterHeaderBrandingOrderMin).max(previewCustomerBrandingImport200ResponseAfterHeaderBrandingOrderMax)
}),
  "logos": zod.object({
  "customer": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImport200ResponseAfterLogosCustomerOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImport200ResponseAfterLogosCustomerOneAltTextMax)
}),zod.object({
  "state": zod.enum(['absent'])
})]),
  "application": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(previewCustomerBrandingImport200ResponseAfterLogosApplicationOneImageBase64Max),
  "altText": zod.string().min(1).max(previewCustomerBrandingImport200ResponseAfterLogosApplicationOneAltTextMax)
}),zod.object({
  "state": zod.enum(['builtIn'])
})])
})
}),
  "differences": zod.array(zod.object({
  "path": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "cleared": zod.boolean()
})),
  "clearedFields": zod.array(zod.string()),
  "inheritanceImpact": zod.object({
  "descendantCount": zod.int().min(previewCustomerBrandingImport200ResponseInheritanceImpactDescendantCountMin),
  "overridesRetained": zod.literal(true)
}),
  "confirmation": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true})
}))()

export const previewCustomerBrandingImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewCustomerBrandingImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const previewCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const previewCustomerBrandingImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewCustomerBrandingImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerBrandingImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerBrandingImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMin).max(previewCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewCustomerBrandingImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewCustomerBrandingImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewCustomerBrandingImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const previewCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const previewCustomerBrandingImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewCustomerBrandingImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerBrandingImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerBrandingImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMin).max(previewCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewCustomerBrandingImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const PreviewCustomerBrandingImport413Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Rechecks current authority, exact file and target/parent/asset state. Exact confirmed retries return unchanged.
 * @summary Confirm and atomically replace branding and both app logo purposes
 */
export const ApplyCustomerBrandingImportParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const applyCustomerBrandingImportHeaderXGroupGraphTokenMax = 16384;


export const applyCustomerBrandingImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ApplyCustomerBrandingImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(applyCustomerBrandingImportHeaderXGroupGraphTokenMax).regex(applyCustomerBrandingImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const applyCustomerBrandingImportBodyBrandingValuesLightPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingValuesDarkPrimaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinLightOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOnePopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinDarkOneRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneWeightsMax = 4;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMin = 24;
export const applyCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMax = 640;

export const applyCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMax = 160;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMax = 32;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMax = 32;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMax = 32;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMin = 999;
export const applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMax = 9999;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneColorsMax = 4;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMax = 24;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMax = 24;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMax = 100;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMax = 80;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMax = 12;

export const applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMax = 480;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMin = 0.625;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMax = 3;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlLineHeightMax = 2;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMax = 32;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMax = 32;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMax = 48;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMin = 999;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMax = 9999;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMax = 0.24;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMax = 0.32;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMin = 0.38;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMax = 0.6;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMin = 2;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMax = 4;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMax = 4;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMax = 300;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMin = 0;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMax = 500;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMax = 3;
export const applyCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMultipleOf = 0.25;

export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const applyCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameMax = 80;


export const applyCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const applyCustomerBrandingImportBodyBrandingHeaderBrandingOrderMin = 4;
export const applyCustomerBrandingImportBodyBrandingHeaderBrandingOrderMax = 4;

export const applyCustomerBrandingImportBodyBrandingLogosCustomerOneImageBase64Max = 350000;

export const applyCustomerBrandingImportBodyBrandingLogosCustomerOneAltTextMax = 120;

export const applyCustomerBrandingImportBodyBrandingLogosApplicationOneImageBase64Max = 350000;

export const applyCustomerBrandingImportBodyBrandingLogosApplicationOneAltTextMax = 120;

export const applyCustomerBrandingImportBodyConfirmationMax = 4096;



export const ApplyCustomerBrandingImportBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "branding": zod.object({
  "kind": zod.enum(['app-branding']),
  "version": zod.literal(1),
  "sourceScope": zod.enum(['tenant', 'entity']),
  "values": zod.object({
  "lightPrimary": zod.string().regex(applyCustomerBrandingImportBodyBrandingValuesLightPrimaryRegExp).nullable(),
  "darkPrimary": zod.string().regex(applyCustomerBrandingImportBodyBrandingValuesDarkPrimaryRegExp).nullable()
}),
  "skin": zod.object({
  "version": zod.literal(1),
  "light": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinLightOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "dark": zod.object({
  "primary": zod.string().nullable(),
  "onPrimary": zod.string().nullable(),
  "headerBackground": zod.string().nullable(),
  "headerForeground": zod.string().nullable(),
  "navigationBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationBackgroundRegExp).nullable().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationForegroundRegExp).nullable().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullable(),
  "background": zod.string().nullable(),
  "foreground": zod.string().nullable(),
  "surface": zod.string().nullable(),
  "onSurface": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "onMuted": zod.string().nullable(),
  "border": zod.string().nullable(),
  "secondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOnePopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneWarningRegExp).nullish(),
  "onWarning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnWarningRegExp).nullish(),
  "info": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneInfoRegExp).nullish(),
  "onInfo": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneOnInfoRegExp).nullish(),
  "input": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinDarkOneRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.').and(zod.looseObject({

})),
  "palette": zod.object({
  "primary": zod.string().nullable(),
  "secondary": zod.string().nullable(),
  "accent": zod.string().nullable(),
  "muted": zod.string().nullable(),
  "subtle": zod.string().nullable(),
  "neutral": zod.string().nullable()
}).describe('Named supporting colours that decorative elements can reference.').and(zod.looseObject({

})),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullable(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneWeightsMax).nullable(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullable(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinTypographyOneScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.').and(zod.looseObject({

})),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullable().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMin).max(applyCustomerBrandingImportBodyBrandingSkinLogoOneMinWidthMax).nullable(),
  "clearSpace": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMin).max(applyCustomerBrandingImportBodyBrandingSkinLogoOneClearSpaceMax).nullable(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullable()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.').and(zod.looseObject({

})),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneControlRadiusMax).nullable(),
  "cardRadius": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneCardRadiusMax).nullable(),
  "overlayRadius": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneOverlayRadiusMax).nullable(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullable(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullable(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullable(),
  "radius": zod.object({
  "sm": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusSmMax).nullish(),
  "md": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusMdMax).nullish(),
  "lg": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusLgMax).nullish(),
  "xl": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusXlMax).nullish(),
  "full": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMin).max(applyCustomerBrandingImportBodyBrandingSkinSurfacesOneRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).and(zod.looseObject({

})),
  "decorations": zod.object({
  "enabled": zod.boolean().nullable(),
  "circles": zod.object({
  "enabled": zod.boolean().nullable(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneColorsMax).nullable(),
  "topStroke": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneTopStrokeMax).nullable(),
  "bottomStroke": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneBottomStrokeMax).nullable(),
  "overlap": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneOverlapMax).nullable(),
  "crop": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsCirclesOneCropMax).nullable(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Overlapping-circle decoration, bounded to safe measurements.').and(zod.looseObject({

})),
  "highlight": zod.object({
  "enabled": zod.boolean().nullable(),
  "color": zod.string().nullable(),
  "thickness": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneThicknessMax).nullable(),
  "width": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMin).max(applyCustomerBrandingImportBodyBrandingSkinDecorationsHighlightOneWidthMax).nullable(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullable()
}).describe('Short accent line under main page titles.').and(zod.looseObject({

}))
}),
  "extended": zod.object({
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "typography": zod.object({
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish()
}).optional(),
  "surfaces": zod.object({
  "radius": zod.object({
  "sm": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(applyCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMin).max(applyCustomerBrandingImportBodyBrandingSkinExtendedMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(applyCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMax).multipleOf(applyCustomerBrandingImportBodyBrandingSkinExtendedIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(applyCustomerBrandingImportBodyBrandingSkinExtendedMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).optional().describe('Extended tokens (theme pairs, scales, state, motion, icons, map colours and brand scope). Optional; when absent an import keeps the destination\'s stored extended tokens.')
}),
  "headerBranding": zod.object({
  "applicationName": zod.string().min(1).max(applyCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameMax).regex(applyCustomerBrandingImportBodyBrandingHeaderBrandingApplicationNameRegExp),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(applyCustomerBrandingImportBodyBrandingHeaderBrandingOrderMin).max(applyCustomerBrandingImportBodyBrandingHeaderBrandingOrderMax)
}),
  "logos": zod.object({
  "customer": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(applyCustomerBrandingImportBodyBrandingLogosCustomerOneImageBase64Max),
  "altText": zod.string().min(1).max(applyCustomerBrandingImportBodyBrandingLogosCustomerOneAltTextMax)
}),zod.object({
  "state": zod.enum(['absent'])
})]),
  "application": zod.union([zod.object({
  "state": zod.enum(['png']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(applyCustomerBrandingImportBodyBrandingLogosApplicationOneImageBase64Max),
  "altText": zod.string().min(1).max(applyCustomerBrandingImportBodyBrandingLogosApplicationOneAltTextMax)
}),zod.object({
  "state": zod.enum(['builtIn'])
})])
})
}),
  "confirmation": zod.string().min(1).max(applyCustomerBrandingImportBodyConfirmationMax),
  "confirm": zod.enum(['replace'])
}))()

export const ApplyCustomerBrandingImport200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['applied', 'unchanged']),
  "target": zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable()
}),
  "payloadDigest": zod.string()
}))()

export const applyCustomerBrandingImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerBrandingImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerBrandingImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerBrandingImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMin).max(applyCustomerBrandingImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerBrandingImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyCustomerBrandingImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerBrandingImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerBrandingImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerBrandingImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMin).max(applyCustomerBrandingImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerBrandingImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyCustomerBrandingImport409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerBrandingImport409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerBrandingImport409ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerBrandingImport409ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerBrandingImport409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerBrandingImport409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerBrandingImport409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerBrandingImport409ResponseOverlapWarningAcknowledgementMin).max(applyCustomerBrandingImport409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerBrandingImport409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const ApplyCustomerBrandingImport413Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Returns field-level errors, contrast warnings and the before/after effective skin. A confirmation is issued only for a valid file; it expires after ten minutes.
 * @summary Validate a workspace design-system file and preview the resulting skin without saving
 */
export const PreviewCustomerDesignSystemImportParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const previewCustomerDesignSystemImportHeaderXGroupGraphTokenMax = 16384;


export const previewCustomerDesignSystemImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewCustomerDesignSystemImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewCustomerDesignSystemImportHeaderXGroupGraphTokenMax).regex(previewCustomerDesignSystemImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const PreviewCustomerDesignSystemImportBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "file": zod.record(zod.string(), zod.unknown()).describe('Workspace design-system token file (formatVersion, designSystem, light, dark, palette, typography, shape, icons, $extensions). Validated server-side; at most 256 KB.')
}))()

export const previewCustomerDesignSystemImport200ResponseHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewCustomerDesignSystemImport200ResponseFindingsItemPairMin = 2;
export const previewCustomerDesignSystemImport200ResponseFindingsItemPairMax = 2;

export const previewCustomerDesignSystemImport200ResponseCountsErrorsMin = 0;

export const previewCustomerDesignSystemImport200ResponseCountsWarningsMin = 0;

export const previewCustomerDesignSystemImport200ResponseCountsInfoMin = 0;

export const previewCustomerDesignSystemImport200ResponseBeforeVersionMax = 1;

export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyWeightsMax = 4;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseBeforeLogoMinWidthMin = 24;
export const previewCustomerDesignSystemImport200ResponseBeforeLogoMinWidthMax = 640;

export const previewCustomerDesignSystemImport200ResponseBeforeLogoClearSpaceMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeLogoClearSpaceMax = 160;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesColorsMax = 4;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesTopStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesTopStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesBottomStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesBottomStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesOverlapMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesOverlapMax = 100;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesCropMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesCropMax = 80;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightThicknessMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightThicknessMax = 12;

export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightWidthMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightWidthMax = 480;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesControlRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesControlRadiusMax = 32;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesCardRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesCardRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesOverlayRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesOverlayRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusSmMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusSmMax = 32;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusMdMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusMdMax = 32;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusLgMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusLgMax = 48;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusXlMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusXlMax = 48;

export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusFullMin = 999;
export const previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusFullMax = 9999;

export const previewCustomerDesignSystemImport200ResponseBeforeStateHoverOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeStateHoverOpacityMax = 0.24;

export const previewCustomerDesignSystemImport200ResponseBeforeStatePressedOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeStatePressedOpacityMax = 0.32;

export const previewCustomerDesignSystemImport200ResponseBeforeStateDisabledOpacityMin = 0.38;
export const previewCustomerDesignSystemImport200ResponseBeforeStateDisabledOpacityMax = 0.6;

export const previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingWidthMin = 2;
export const previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingWidthMax = 4;

export const previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingOffsetMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingOffsetMax = 4;

export const previewCustomerDesignSystemImport200ResponseBeforeMotionDurationFastMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeMotionDurationFastMax = 300;

export const previewCustomerDesignSystemImport200ResponseBeforeMotionDurationBaseMin = 0;
export const previewCustomerDesignSystemImport200ResponseBeforeMotionDurationBaseMax = 500;

export const previewCustomerDesignSystemImport200ResponseBeforeIconsStrokeWidthMax = 3;
export const previewCustomerDesignSystemImport200ResponseBeforeIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneVersionMax = 1;

export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyWeightsMax = 4;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseAfterOneLogoMinWidthMin = 24;
export const previewCustomerDesignSystemImport200ResponseAfterOneLogoMinWidthMax = 640;

export const previewCustomerDesignSystemImport200ResponseAfterOneLogoClearSpaceMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneLogoClearSpaceMax = 160;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesColorsMax = 4;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesTopStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesTopStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesBottomStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesBottomStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesOverlapMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesOverlapMax = 100;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesCropMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesCropMax = 80;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightThicknessMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightThicknessMax = 12;

export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightWidthMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightWidthMax = 480;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesControlRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesControlRadiusMax = 32;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesCardRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesCardRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesOverlayRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesOverlayRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusSmMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusSmMax = 32;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusMdMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusMdMax = 32;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusLgMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusLgMax = 48;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusXlMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusXlMax = 48;

export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusFullMin = 999;
export const previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusFullMax = 9999;

export const previewCustomerDesignSystemImport200ResponseAfterOneStateHoverOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneStateHoverOpacityMax = 0.24;

export const previewCustomerDesignSystemImport200ResponseAfterOneStatePressedOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneStatePressedOpacityMax = 0.32;

export const previewCustomerDesignSystemImport200ResponseAfterOneStateDisabledOpacityMin = 0.38;
export const previewCustomerDesignSystemImport200ResponseAfterOneStateDisabledOpacityMax = 0.6;

export const previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingWidthMin = 2;
export const previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingWidthMax = 4;

export const previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingOffsetMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingOffsetMax = 4;

export const previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationFastMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationFastMax = 300;

export const previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationBaseMin = 0;
export const previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationBaseMax = 500;

export const previewCustomerDesignSystemImport200ResponseAfterOneIconsStrokeWidthMax = 3;
export const previewCustomerDesignSystemImport200ResponseAfterOneIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneAppDefaultsMax = 70;

export const previewCustomerDesignSystemImport200ResponseCandidateOneVersionMax = 1;

export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyWeightsMax = 4;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlSizeMin = 0.625;
export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlSizeMax = 3;

export const previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlLineHeightMax = 2;

export const previewCustomerDesignSystemImport200ResponseCandidateOneLogoMinWidthMin = 24;
export const previewCustomerDesignSystemImport200ResponseCandidateOneLogoMinWidthMax = 640;

export const previewCustomerDesignSystemImport200ResponseCandidateOneLogoClearSpaceMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneLogoClearSpaceMax = 160;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesColorsMax = 4;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesTopStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesTopStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesBottomStrokeMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesBottomStrokeMax = 24;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesOverlapMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesOverlapMax = 100;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesCropMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesCropMax = 80;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightThicknessMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightThicknessMax = 12;

export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightWidthMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightWidthMax = 480;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesControlRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesControlRadiusMax = 32;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesCardRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesCardRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesOverlayRadiusMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesOverlayRadiusMax = 48;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusSmMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusSmMax = 32;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusMdMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusMdMax = 32;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusLgMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusLgMax = 48;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusXlMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusXlMax = 48;

export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusFullMin = 999;
export const previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusFullMax = 9999;

export const previewCustomerDesignSystemImport200ResponseCandidateOneStateHoverOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneStateHoverOpacityMax = 0.24;

export const previewCustomerDesignSystemImport200ResponseCandidateOneStatePressedOpacityMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneStatePressedOpacityMax = 0.32;

export const previewCustomerDesignSystemImport200ResponseCandidateOneStateDisabledOpacityMin = 0.38;
export const previewCustomerDesignSystemImport200ResponseCandidateOneStateDisabledOpacityMax = 0.6;

export const previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingWidthMin = 2;
export const previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingWidthMax = 4;

export const previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingOffsetMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingOffsetMax = 4;

export const previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationFastMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationFastMax = 300;

export const previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationBaseMin = 0;
export const previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationBaseMax = 500;

export const previewCustomerDesignSystemImport200ResponseCandidateOneIconsStrokeWidthMax = 3;
export const previewCustomerDesignSystemImport200ResponseCandidateOneIconsStrokeWidthMultipleOf = 0.25;

export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewCustomerDesignSystemImport200ResponseInheritanceImpactDescendantCountMin = 0;



export const PreviewCustomerDesignSystemImport200Response = /*#__PURE__*/ (() => zod.object({
  "target": zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable()
}),
  "valid": zod.boolean(),
  "hash": zod.string().regex(previewCustomerDesignSystemImport200ResponseHashRegExp),
  "designSystem": zod.object({
  "id": zod.string().nullable(),
  "name": zod.string().nullable(),
  "version": zod.int().nullable()
}).nullable(),
  "findings": zod.array(zod.object({
  "severity": zod.enum(['error', 'warning', 'info']),
  "code": zod.string(),
  "path": zod.string(),
  "mode": zod.union([zod.literal('light'),zod.literal('dark'),zod.literal(null)]).nullable(),
  "message": zod.string(),
  "ratio": zod.number().nullable(),
  "threshold": zod.number().nullable(),
  "pair": zod.array(zod.string()).min(previewCustomerDesignSystemImport200ResponseFindingsItemPairMin).max(previewCustomerDesignSystemImport200ResponseFindingsItemPairMax).nullable(),
  "resolution": zod.union([zod.literal('derived'),zod.literal('ignored'),zod.literal(null)]).nullable()
})),
  "counts": zod.object({
  "errors": zod.int().min(previewCustomerDesignSystemImport200ResponseCountsErrorsMin),
  "warnings": zod.int().min(previewCustomerDesignSystemImport200ResponseCountsWarningsMin),
  "info": zod.int().min(previewCustomerDesignSystemImport200ResponseCountsInfoMin)
}),
  "requiresAcknowledgement": zod.boolean(),
  "before": zod.object({
  "version": zod.int().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlSizeMin).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeLogoMinWidthMin).max(previewCustomerDesignSystemImport200ResponseBeforeLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeLogoClearSpaceMin).max(previewCustomerDesignSystemImport200ResponseBeforeLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesTopStrokeMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesBottomStrokeMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesOverlapMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesCropMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightThicknessMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightWidthMin).max(previewCustomerDesignSystemImport200ResponseBeforeDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesControlRadiusMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesCardRadiusMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesOverlayRadiusMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusSmMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusMdMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusLgMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusXlMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusFullMin).max(previewCustomerDesignSystemImport200ResponseBeforeSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeStateHoverOpacityMin).max(previewCustomerDesignSystemImport200ResponseBeforeStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeStatePressedOpacityMin).max(previewCustomerDesignSystemImport200ResponseBeforeStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseBeforeStateDisabledOpacityMin).max(previewCustomerDesignSystemImport200ResponseBeforeStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingWidthMin).max(previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingOffsetMin).max(previewCustomerDesignSystemImport200ResponseBeforeStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeMotionDurationFastMin).max(previewCustomerDesignSystemImport200ResponseBeforeMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerDesignSystemImport200ResponseBeforeMotionDurationBaseMin).max(previewCustomerDesignSystemImport200ResponseBeforeMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseBeforeIconsStrokeWidthMax).multipleOf(previewCustomerDesignSystemImport200ResponseBeforeIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseBeforeMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "after": zod.union([zod.object({
  "version": zod.int().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlSizeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneLogoMinWidthMin).max(previewCustomerDesignSystemImport200ResponseAfterOneLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneLogoClearSpaceMin).max(previewCustomerDesignSystemImport200ResponseAfterOneLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesTopStrokeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesBottomStrokeMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesOverlapMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesCropMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightThicknessMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightWidthMin).max(previewCustomerDesignSystemImport200ResponseAfterOneDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesControlRadiusMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesCardRadiusMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesOverlayRadiusMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusSmMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusMdMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusLgMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusXlMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusFullMin).max(previewCustomerDesignSystemImport200ResponseAfterOneSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneStateHoverOpacityMin).max(previewCustomerDesignSystemImport200ResponseAfterOneStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneStatePressedOpacityMin).max(previewCustomerDesignSystemImport200ResponseAfterOneStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseAfterOneStateDisabledOpacityMin).max(previewCustomerDesignSystemImport200ResponseAfterOneStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingWidthMin).max(previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingOffsetMin).max(previewCustomerDesignSystemImport200ResponseAfterOneStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationFastMin).max(previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationBaseMin).max(previewCustomerDesignSystemImport200ResponseAfterOneMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseAfterOneIconsStrokeWidthMax).multipleOf(previewCustomerDesignSystemImport200ResponseAfterOneIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseAfterOneMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),zod.null()]),
  "candidate": zod.union([zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(previewCustomerDesignSystemImport200ResponseCandidateOneAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlSizeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneLogoMinWidthMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneLogoClearSpaceMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesTopStrokeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesBottomStrokeMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesOverlapMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesCropMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightThicknessMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightWidthMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesControlRadiusMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesCardRadiusMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesOverlayRadiusMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusSmMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusMdMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusLgMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusXlMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusFullMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneStateHoverOpacityMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneStatePressedOpacityMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(previewCustomerDesignSystemImport200ResponseCandidateOneStateDisabledOpacityMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingWidthMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingOffsetMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationFastMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationBaseMin).max(previewCustomerDesignSystemImport200ResponseCandidateOneMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(previewCustomerDesignSystemImport200ResponseCandidateOneIconsStrokeWidthMax).multipleOf(previewCustomerDesignSystemImport200ResponseCandidateOneIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(previewCustomerDesignSystemImport200ResponseCandidateOneMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),zod.null()]),
  "changedPaths": zod.array(zod.string()),
  "inheritanceImpact": zod.object({
  "descendantCount": zod.int().min(previewCustomerDesignSystemImport200ResponseInheritanceImpactDescendantCountMin)
}),
  "confirmation": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const previewCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const previewCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const previewCustomerDesignSystemImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewCustomerDesignSystemImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMin).max(previewCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewCustomerDesignSystemImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const previewCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const previewCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const previewCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const previewCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const previewCustomerDesignSystemImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PreviewCustomerDesignSystemImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(previewCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(previewCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMin).max(previewCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(previewCustomerDesignSystemImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const PreviewCustomerDesignSystemImport413Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Rechecks authority, file hash and branding state. Files with warnings require acknowledgeWarnings true. The audit records actor, target, file SHA-256 and findings.
 * @summary Apply a reviewed design-system file to one tenant or entity and audit it
 */
export const ApplyCustomerDesignSystemImportParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const applyCustomerDesignSystemImportHeaderXGroupGraphTokenMax = 16384;


export const applyCustomerDesignSystemImportHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ApplyCustomerDesignSystemImportHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(applyCustomerDesignSystemImportHeaderXGroupGraphTokenMax).regex(applyCustomerDesignSystemImportHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const applyCustomerDesignSystemImportBodyConfirmationMax = 4096;



export const ApplyCustomerDesignSystemImportBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "file": zod.record(zod.string(), zod.unknown()).describe('Workspace design-system token file (formatVersion, designSystem, light, dark, palette, typography, shape, icons, $extensions). Validated server-side; at most 256 KB.'),
  "confirmation": zod.string().min(1).max(applyCustomerDesignSystemImportBodyConfirmationMax),
  "acknowledgeWarnings": zod.boolean()
}))()

export const ApplyCustomerDesignSystemImport200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['applied', 'unchanged']),
  "target": zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable()
}),
  "hash": zod.string()
}))()

export const applyCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerDesignSystemImport400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerDesignSystemImport400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMin).max(applyCustomerDesignSystemImport400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerDesignSystemImport400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerDesignSystemImport403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerDesignSystemImport403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMin).max(applyCustomerDesignSystemImport403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerDesignSystemImport403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const applyCustomerDesignSystemImport409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const applyCustomerDesignSystemImport409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const applyCustomerDesignSystemImport409ResponseOverlapWarningAcknowledgementMin = 16;
export const applyCustomerDesignSystemImport409ResponseOverlapWarningAcknowledgementMax = 256;


export const applyCustomerDesignSystemImport409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ApplyCustomerDesignSystemImport409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(applyCustomerDesignSystemImport409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(applyCustomerDesignSystemImport409ResponseOverlapWarningAcknowledgementMin).max(applyCustomerDesignSystemImport409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(applyCustomerDesignSystemImport409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const ApplyCustomerDesignSystemImport413Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Upload or replace a validated customer logo
 */
export const PutApiTenantsTenantSlugCustomerLogoParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const putApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenMax = 16384;


export const putApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutApiTenantsTenantSlugCustomerLogoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenMax).regex(putApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putApiTenantsTenantSlugCustomerLogoBodyImageBase64Max = 350000;

export const putApiTenantsTenantSlugCustomerLogoBodyAltTextMax = 120;



export const PutApiTenantsTenantSlugCustomerLogoBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().max(putApiTenantsTenantSlugCustomerLogoBodyImageBase64Max),
  "altText": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogoBodyAltTextMax)
}))()

export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const putApiTenantsTenantSlugCustomerLogo200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const putApiTenantsTenantSlugCustomerLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinVersionMax = 1;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveVersionMax = 1;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesVersionMax = 1;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesVersionMax = 1;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const PutApiTenantsTenantSlugCustomerLogo200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(putApiTenantsTenantSlugCustomerLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(putApiTenantsTenantSlugCustomerLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMin).max(putApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()


/**
 * @summary Remove a customer logo default or entity override
 */
export const DeleteApiTenantsTenantSlugCustomerLogoParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const DeleteApiTenantsTenantSlugCustomerLogoQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity'])
}))()

export const deleteApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenMax = 16384;


export const deleteApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteApiTenantsTenantSlugCustomerLogoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenMax).regex(deleteApiTenantsTenantSlugCustomerLogoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinVersionMax = 1;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveVersionMax = 1;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesVersionMax = 1;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesVersionMax = 1;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const DeleteApiTenantsTenantSlugCustomerLogo200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMin).max(deleteApiTenantsTenantSlugCustomerLogo200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()


/**
 * @summary Upload or replace an independent private application logo
 */
export const PutApiTenantsTenantSlugApplicationLogoParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const putApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenMax = 16384;


export const putApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PutApiTenantsTenantSlugApplicationLogoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenMax).regex(putApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const putApiTenantsTenantSlugApplicationLogoBodyImageBase64Max = 350000;

export const putApiTenantsTenantSlugApplicationLogoBodyAltTextMax = 120;



export const PutApiTenantsTenantSlugApplicationLogoBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "contentType": zod.enum(['image/png']),
  "imageBase64": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogoBodyImageBase64Max),
  "altText": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogoBodyAltTextMax)
}))()

export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const putApiTenantsTenantSlugApplicationLogo200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const putApiTenantsTenantSlugApplicationLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinVersionMax = 1;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveVersionMax = 1;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesVersionMax = 1;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesVersionMax = 1;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const PutApiTenantsTenantSlugApplicationLogo200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(putApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(putApiTenantsTenantSlugApplicationLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(putApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(putApiTenantsTenantSlugApplicationLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMin).max(putApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()

export const putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMin = 16;
export const putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMax = 256;


export const putApiTenantsTenantSlugApplicationLogo403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PutApiTenantsTenantSlugApplicationLogo403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMin).max(putApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(putApiTenantsTenantSlugApplicationLogo403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Remove an application logo and restore inheritance
 */
export const DeleteApiTenantsTenantSlugApplicationLogoParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const DeleteApiTenantsTenantSlugApplicationLogoQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity'])
}))()

export const deleteApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenMax = 16384;


export const deleteApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteApiTenantsTenantSlugApplicationLogoHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenMax).regex(deleteApiTenantsTenantSlugApplicationLogoHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthMax = 1000;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightMax = 1000;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthMax = 1000;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightMax = 1000;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponsePrivacyRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax = 40;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,39}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax = 40;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMin = 5;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMax = 5;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMin = 5;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMax = 5;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinVersionMax = 1;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveVersionMax = 1;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesAppDefaultsMax = 70;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesVersionMax = 1;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesAppDefaultsMax = 70;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesVersionMax = 1;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyWeightsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin = 0.625;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax = 3;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax = 2;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMin = 24;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMax = 640;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMax = 160;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax = 24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax = 100;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax = 80;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax = 12;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax = 480;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax = 32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax = 48;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin = 999;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax = 9999;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMax = 0.24;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMax = 0.32;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMin = 0.38;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMax = 0.6;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMin = 2;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMax = 300;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMin = 0;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMax = 500;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMax = 3;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf = 0.25;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax = 10;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMin = 4;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax = 80;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMin = 4;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMax = 4;

export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax = 80;


export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp = new RegExp('^[^<>\\x00-\\x1f\\x7f]*$');
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMin = 4;
export const deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMax = 4;



export const DeleteApiTenantsTenantSlugApplicationLogo200Response = /*#__PURE__*/ (() => zod.object({
  "brandingDefaults": zod.object({
  "tenantValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.literal(true).optional(),
  "darkPrimary": zod.literal(true).optional(),
  "customerLogo": zod.enum(['absent']).optional(),
  "applicationLogo": zod.enum(['builtIn']).optional()
})
}).optional(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "defaultHomepage": zod.enum(['home-1', 'home-2']).optional(),
  "effective": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "mapOutlineStandards": zod.object({
  "desk": zod.union([zod.object({
  "width": zod.number().gt(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthExclusiveMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneWidthMax),
  "height": zod.number().gt(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightExclusiveMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsDeskOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()]),
  "office": zod.union([zod.object({
  "width": zod.number().gt(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthExclusiveMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneWidthMax),
  "height": zod.number().gt(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightExclusiveMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseMapOutlineStandardsOfficeOneHeightMax)
}).describe('Finite dimensions in normalized 0–1000 map units. Width times height must be at least 0.5 square map units.'),zod.null()])
}),
  "privacy": zod.object({
  "mode": zod.enum(['always_private', 'always_open', 'user_defined']).describe('Entity policy for plans and personal desk identity, location, hours and linked Teams disclosure. Unset defaults to user_defined.'),
  "revision": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponsePrivacyRevisionRegExp)
}).optional(),
  "sidebarDisplay": zod.object({
  "hiddenByDefault": zod.boolean(),
  "revision": zod.string()
}).optional(),
  "navigationLayout": zod.object({
  "effective": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEffectiveGroupsMax)
}),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutPlatformValueGroupsMax)
}).nullable(),
  "tenantValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutTenantValueGroupsMax)
}).nullable(),
  "entityValue": zod.object({
  "enabled": zod.boolean(),
  "groups": zod.array(zod.object({
  "id": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemIdRegExp),
  "label": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsItemLabelMax),
  "defaultCollapsed": zod.boolean(),
  "items": zod.array(zod.enum(['home', 'book', 'my-bookings', 'work-plan', 'my-visitors', 'assistant', 'teams', 'colleagues', 'manager-attendance', 'floor-map', 'resources', 'staffed-services']))
})).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseNavigationLayoutEntityValueGroupsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "homeLayout": zod.object({
  "effective": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEffectiveSectionsMax)
}).describe('Each current Home section ID must appear exactly once; order and visible control its presentation.'),
  "source": zod.enum(['entity', 'tenant', 'platform', 'builtIn']),
  "platformValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutPlatformValueSectionsMax)
}).nullable(),
  "tenantValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutTenantValueSectionsMax)
}).nullable(),
  "entityValue": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.enum(['welcome', 'upcoming-bookings', 'suggestions', 'more-ways', 'booking']),
  "visible": zod.boolean()
})).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHomeLayoutEntityValueSectionsMax)
}).nullable(),
  "allowEntityOverride": zod.boolean()
}),
  "foreground": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish()
}),
  "tenantValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "entityValues": zod.object({
  "lightPrimary": zod.string().nullish(),
  "darkPrimary": zod.string().nullish(),
  "bookingNameAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish(),
  "deskLocationAudience": zod.union([zod.literal('private'),zod.literal('authorised_roles'),zod.literal('entity_colleagues'),zod.literal(null)]).nullish()
}),
  "allowEntityOverrides": zod.object({
  "lightPrimary": zod.boolean().optional(),
  "darkPrimary": zod.boolean().optional(),
  "bookingNameAudience": zod.boolean().optional(),
  "deskLocationAudience": zod.boolean().optional(),
  "logo": zod.boolean().optional(),
  "applicationLogo": zod.boolean().optional(),
  "applicationName": zod.boolean().optional(),
  "headerOrder": zod.boolean().optional(),
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.'),
  "navigationLayout": zod.boolean().optional(),
  "homeLayout": zod.boolean().optional()
}),
  "canManageTenant": zod.boolean(),
  "canManageEntity": zod.boolean(),
  "logo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "skin": zod.object({
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinVersionMax),
  "effective": zod.object({
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEffectiveMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),
  "tenantValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinTenantValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "entityValues": zod.object({
  "appDefaults": zod.array(zod.enum(['light.sidebarBackground', 'light.navigationItemBackground', 'light.navigationItemForeground', 'light.navigationActiveBackground', 'light.navigationActiveForeground', 'dark.sidebarBackground', 'dark.navigationItemBackground', 'dark.navigationItemForeground', 'dark.navigationActiveBackground', 'dark.navigationActiveForeground', 'light.primary', 'light.onPrimary', 'light.headerBackground', 'light.headerForeground', 'light.navigationBackground', 'light.navigationForeground', 'light.accent', 'light.background', 'light.foreground', 'light.surface', 'light.onSurface', 'light.muted', 'light.onMuted', 'light.border', 'dark.primary', 'dark.onPrimary', 'dark.headerBackground', 'dark.headerForeground', 'dark.navigationBackground', 'dark.navigationForeground', 'dark.accent', 'dark.background', 'dark.foreground', 'dark.surface', 'dark.onSurface', 'dark.muted', 'dark.onMuted', 'dark.border', 'palette.primary', 'palette.secondary', 'palette.accent', 'palette.muted', 'palette.subtle', 'palette.neutral', 'typography.font', 'typography.weights', 'typography.fallback', 'logo.showEntityName', 'logo.minWidth', 'logo.clearSpace', 'logo.onDark', 'decorations.circles.enabled', 'decorations.circles.colors', 'decorations.circles.topStroke', 'decorations.circles.bottomStroke', 'decorations.circles.overlap', 'decorations.circles.crop', 'decorations.circles.placement', 'decorations.highlight.enabled', 'decorations.highlight.color', 'decorations.highlight.thickness', 'decorations.highlight.width', 'decorations.highlight.placement', 'surfaces.controlRadius', 'surfaces.cardRadius', 'surfaces.overlayRadius', 'surfaces.density', 'surfaces.shadow', 'surfaces.treatment', 'decorations.enabled'])).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesAppDefaultsMax).optional(),
  "version": zod.int().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesVersionMax).optional(),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).optional().describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).optional().describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).optional().describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).optional().describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).optional().describe('Short accent line under main page titles.')
}).optional().describe('Decorative elements and their supported placement.'),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMax).multipleOf(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapLightSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinEntityValuesMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).optional().describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional(),
  "applyScope": zod.object({
  "header": zod.boolean().nullish(),
  "navigation": zod.boolean().nullish(),
  "controls": zod.boolean().nullish(),
  "cards": zod.boolean().nullish(),
  "decorations": zod.boolean().nullish(),
  "mobile": zod.boolean().nullish(),
  "maps": zod.boolean().nullish(),
  "publicPages": zod.boolean().nullish(),
  "browserIdentity": zod.boolean().nullish(),
  "emails": zod.boolean().nullish()
}).optional().describe('Where the brand applies. Null or absent inherits from the tenant, then the platform default.')
}).describe('Stored skin configuration. appDefaults explicitly masks inherited leaves; absent metadata preserves legacy inheritance. Ordinary null edits restore inheritance for the edited leaf.'),
  "allowEntityOverrides": zod.object({
  "skinColors": zod.boolean().optional(),
  "skinTypography": zod.boolean().optional(),
  "skinLogo": zod.boolean().optional(),
  "skinDecorations": zod.boolean().optional(),
  "skinSurfaces": zod.boolean().optional(),
  "skinMap": zod.boolean().optional(),
  "skinScope": zod.boolean().optional(),
  "skinScopeFlags": zod.array(zod.enum(['header', 'navigation', 'controls', 'cards', 'decorations', 'mobile', 'maps', 'publicPages', 'browserIdentity', 'emails'])).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseSkinAllowEntityOverridesSkinScopeFlagsMax).optional().describe('Brand-scope switches entity administrators may change. Absent means every switch when skinScope is on.')
})
}),
  "headerBranding": zod.object({
  "effective": zod.object({
  "applicationName": zod.string(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEffectiveOrderMax).nullable()
}),
  "source": zod.object({
  "applicationName": zod.enum(['tenant', 'entity', 'builtIn']),
  "order": zod.enum(['tenant', 'entity', 'builtIn'])
}),
  "tenantValues": zod.object({
  "applicationName": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingTenantValuesOrderMax).nullish()
}),
  "entityValues": zod.object({
  "applicationName": zod.string().min(1).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameMax).regex(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesApplicationNameRegExp).nullish(),
  "order": zod.array(zod.enum(['entityLogo', 'entityTitle', 'applicationLogo', 'applicationName'])).min(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMin).max(deleteApiTenantsTenantSlugApplicationLogo200ResponseHeaderBrandingEntityValuesOrderMax).nullish()
}),
  "applicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "applicationLogoSource": zod.enum(['tenant', 'entity', 'builtIn']),
  "tenantApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()]),
  "entityApplicationLogo": zod.union([zod.object({
  "dataUrl": zod.string(),
  "altText": zod.string(),
  "scope": zod.enum(['tenant', 'entity'])
}),zod.null()])
}).optional(),
  "headerDisplay": zod.object({
  "showNotificationIcon": zod.boolean(),
  "revision": zod.string()
}).optional()
}))()

export const deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiTenantsTenantSlugApplicationLogo403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiTenantsTenantSlugApplicationLogo403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMin).max(deleteApiTenantsTenantSlugApplicationLogo403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiTenantsTenantSlugApplicationLogo403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List tenant audit events
 */
export const GetApiTenantsTenantSlugAuditParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugAuditQueryLimitDefault = 50;
export const getApiTenantsTenantSlugAuditQueryLimitMax = 200;

export const getApiTenantsTenantSlugAuditQueryOffsetDefault = 0;
export const getApiTenantsTenantSlugAuditQueryOffsetMin = 0;



export const GetApiTenantsTenantSlugAuditQueryParams = /*#__PURE__*/ (() => zod.object({
  "action": zod.string().optional(),
  "actorUserId": zod.uuid().optional(),
  "targetType": zod.string().optional(),
  "targetId": zod.uuid().optional(),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugAuditQueryLimitMax).default(getApiTenantsTenantSlugAuditQueryLimitDefault),
  "offset": zod.int().min(getApiTenantsTenantSlugAuditQueryOffsetMin).default(getApiTenantsTenantSlugAuditQueryOffsetDefault)
}))()

export const getApiTenantsTenantSlugAuditHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugAuditHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugAuditHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugAuditHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugAuditHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugAudit200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "at": zod.iso.datetime({"offset":true}),
  "actorUserId": zod.uuid().nullable(),
  "tenantId": zod.uuid().nullable(),
  "organizationId": zod.uuid().nullable(),
  "plane": zod.enum(['platform', 'tenant']),
  "action": zod.string(),
  "targetType": zod.string(),
  "targetId": zod.uuid().nullable(),
  "metadata": zod.looseObject({

}).nullable(),
  "requestId": zod.string().nullable(),
  "correlationId": zod.string().nullable()
})),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const getApiTenantsTenantSlugAudit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugAudit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugAudit403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugAudit403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugAudit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugAudit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugAudit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugAudit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugAudit403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugAudit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugAudit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Delegated Microsoft Graph user search (displayName/mail typeahead) for invite and member-picker flows. Returns `{ available: false }` when Graph consent/token is unavailable so the UI can fall back to manual email entry without a hard failure.
 * @summary Search Entra directory people for invites
 */
export const GetApiTenantsTenantSlugDirectorySearchParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugDirectorySearchQueryQMin = 2;
export const getApiTenantsTenantSlugDirectorySearchQueryQMax = 100;

export const getApiTenantsTenantSlugDirectorySearchQueryLimitDefault = 10;
export const getApiTenantsTenantSlugDirectorySearchQueryLimitMax = 25;



export const GetApiTenantsTenantSlugDirectorySearchQueryParams = /*#__PURE__*/ (() => zod.object({
  "q": zod.string().min(getApiTenantsTenantSlugDirectorySearchQueryQMin).max(getApiTenantsTenantSlugDirectorySearchQueryQMax).describe('Search string (minimum 2 characters, maximum 100)'),
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugDirectorySearchQueryLimitMax).default(getApiTenantsTenantSlugDirectorySearchQueryLimitDefault)
}))()

export const getApiTenantsTenantSlugDirectorySearchHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugDirectorySearchHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugDirectorySearchHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugDirectorySearchHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugDirectorySearchHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugDirectorySearch200Response = /*#__PURE__*/ (() => zod.object({
  "available": zod.boolean().describe('false when Graph is not configured or consent is missing — UI falls back to manual email entry'),
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string(),
  "mail": zod.string()
})),
  "source": zod.enum(['graph_delegated', 'graph_app', 'unavailable']).describe('How results were obtained — delegated OBO, app-only fallback, or unavailable')
}))()

export const getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugDirectorySearch400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugDirectorySearch400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugDirectorySearch400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugDirectorySearch400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugDirectorySearch401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugDirectorySearch401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugDirectorySearch401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugDirectorySearch401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugDirectorySearch403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugDirectorySearch403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugDirectorySearch403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugDirectorySearch403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update a custom tenant role (tenant.roles.manage)
 */
export const PatchApiTenantsTenantSlugRolesRoleIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const patchApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenMax = 16384;


export const patchApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PatchApiTenantsTenantSlugRolesRoleIdHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(patchApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenMax).regex(patchApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const patchApiTenantsTenantSlugRolesRoleIdBodyNameMax = 200;

export const patchApiTenantsTenantSlugRolesRoleIdBodyDescriptionMax = 2000;



export const PatchApiTenantsTenantSlugRolesRoleIdBody = /*#__PURE__*/ (() => zod.object({
  "name": zod.string().min(1).max(patchApiTenantsTenantSlugRolesRoleIdBodyNameMax).optional(),
  "description": zod.string().max(patchApiTenantsTenantSlugRolesRoleIdBodyDescriptionMax).nullish(),
  "permissionKeys": zod.array(zod.string()).optional()
}))()

export const PatchApiTenantsTenantSlugRolesRoleId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMin = 16;
export const patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMax = 256;


export const patchApiTenantsTenantSlugRolesRoleId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PatchApiTenantsTenantSlugRolesRoleId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMin).max(patchApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(patchApiTenantsTenantSlugRolesRoleId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Delete a custom tenant role (tenant.roles.manage)
 */
export const DeleteApiTenantsTenantSlugRolesRoleIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const deleteApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenMax = 16384;


export const deleteApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteApiTenantsTenantSlugRolesRoleIdHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenMax).regex(deleteApiTenantsTenantSlugRolesRoleIdHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DeleteApiTenantsTenantSlugRolesRoleId200Response = /*#__PURE__*/ (() => zod.object({
  "removedAssignments": zod.int()
}))()

export const deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMin = 16;
export const deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMax = 256;


export const deleteApiTenantsTenantSlugRolesRoleId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DeleteApiTenantsTenantSlugRolesRoleId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMin).max(deleteApiTenantsTenantSlugRolesRoleId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(deleteApiTenantsTenantSlugRolesRoleId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List elevation requests (tenant.elevation.request)
 */
export const GetApiTenantsTenantSlugElevationsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getApiTenantsTenantSlugElevationsQueryLimitMax = 200;

export const getApiTenantsTenantSlugElevationsQueryOffsetMin = 0;



export const GetApiTenantsTenantSlugElevationsQueryParams = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['pending', 'approved', 'denied', 'expired']).optional(),
  "requesterId": zod.uuid().optional(),
  "pendingApprovals": zod.boolean().optional(),
  "limit": zod.int().min(1).max(getApiTenantsTenantSlugElevationsQueryLimitMax).optional(),
  "offset": zod.int().min(getApiTenantsTenantSlugElevationsQueryOffsetMin).optional()
}))()

export const getApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugElevationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugElevations200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "requesterId": zod.uuid(),
  "requesterEmail": zod.string().nullish(),
  "requesterDisplayName": zod.string(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "permissionKeys": zod.array(zod.string()).nullable(),
  "requestedDurationHours": zod.int(),
  "reason": zod.string(),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired']),
  "approvedBy": zod.uuid().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "deniedReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const getApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugElevations403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugElevations403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugElevations403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Request a JIT elevation (tenant.elevation.request)
 */
export const PostApiTenantsTenantSlugElevationsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const postApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugElevationsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugElevationsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugElevationsBodyReasonMin = 10;
export const postApiTenantsTenantSlugElevationsBodyReasonMax = 2000;

export const postApiTenantsTenantSlugElevationsBodyDurationHoursMax = 8;



export const PostApiTenantsTenantSlugElevationsBody = /*#__PURE__*/ (() => zod.object({
  "roleId": zod.uuid().optional(),
  "permissionKeys": zod.array(zod.string()).optional(),
  "reason": zod.string().min(postApiTenantsTenantSlugElevationsBodyReasonMin).max(postApiTenantsTenantSlugElevationsBodyReasonMax),
  "durationHours": zod.int().min(1).max(postApiTenantsTenantSlugElevationsBodyDurationHoursMax)
}))()

export const PostApiTenantsTenantSlugElevations201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requesterId": zod.uuid(),
  "requesterEmail": zod.string().nullish(),
  "requesterDisplayName": zod.string(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "permissionKeys": zod.array(zod.string()).nullable(),
  "requestedDurationHours": zod.int(),
  "reason": zod.string(),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired']),
  "approvedBy": zod.uuid().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "deniedReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugElevations403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugElevations403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevations403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugElevations403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugElevations403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugElevations409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugElevations409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugElevations409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugElevations409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugElevations409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugElevations409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevations409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevations409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugElevations409ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugElevations409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugElevations409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Get a single elevation request (tenant.elevation.request)
 */
export const GetApiTenantsTenantSlugElevationsElevationIdParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "elevationId": zod.uuid()
}))()

export const getApiTenantsTenantSlugElevationsElevationIdHeaderXGroupGraphTokenMax = 16384;


export const getApiTenantsTenantSlugElevationsElevationIdHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetApiTenantsTenantSlugElevationsElevationIdHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getApiTenantsTenantSlugElevationsElevationIdHeaderXGroupGraphTokenMax).regex(getApiTenantsTenantSlugElevationsElevationIdHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const GetApiTenantsTenantSlugElevationsElevationId200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requesterId": zod.uuid(),
  "requesterEmail": zod.string().nullish(),
  "requesterDisplayName": zod.string(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "permissionKeys": zod.array(zod.string()).nullable(),
  "requestedDurationHours": zod.int(),
  "reason": zod.string(),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired']),
  "approvedBy": zod.uuid().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "deniedReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiTenantsTenantSlugElevationsElevationId403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiTenantsTenantSlugElevationsElevationId403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningAcknowledgementMin).max(getApiTenantsTenantSlugElevationsElevationId403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiTenantsTenantSlugElevationsElevationId403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Approve or deny an elevation request (tenant.elevation.approve)
 */
export const PostApiTenantsTenantSlugElevationsElevationIdResolveParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "elevationId": zod.uuid()
}))()

export const postApiTenantsTenantSlugElevationsElevationIdResolveHeaderXGroupGraphTokenMax = 16384;


export const postApiTenantsTenantSlugElevationsElevationIdResolveHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PostApiTenantsTenantSlugElevationsElevationIdResolveHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(postApiTenantsTenantSlugElevationsElevationIdResolveHeaderXGroupGraphTokenMax).regex(postApiTenantsTenantSlugElevationsElevationIdResolveHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const postApiTenantsTenantSlugElevationsElevationIdResolveBodyDurationHoursMax = 8;

export const postApiTenantsTenantSlugElevationsElevationIdResolveBodyDeniedReasonMax = 2000;



export const PostApiTenantsTenantSlugElevationsElevationIdResolveBody = /*#__PURE__*/ (() => zod.object({
  "approve": zod.boolean(),
  "durationHours": zod.int().min(1).max(postApiTenantsTenantSlugElevationsElevationIdResolveBodyDurationHoursMax).optional(),
  "deniedReason": zod.string().max(postApiTenantsTenantSlugElevationsElevationIdResolveBodyDeniedReasonMax).optional()
}))()

export const PostApiTenantsTenantSlugElevationsElevationIdResolve200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "requesterId": zod.uuid(),
  "requesterEmail": zod.string().nullish(),
  "requesterDisplayName": zod.string(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "permissionKeys": zod.array(zod.string()).nullable(),
  "requestedDurationHours": zod.int(),
  "reason": zod.string(),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired']),
  "approvedBy": zod.uuid().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "deniedReason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugElevationsElevationIdResolve403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugElevationsElevationIdResolve403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugElevationsElevationIdResolve403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugElevationsElevationIdResolve403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiTenantsTenantSlugElevationsElevationIdResolve409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiTenantsTenantSlugElevationsElevationIdResolve409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningAcknowledgementMin).max(postApiTenantsTenantSlugElevationsElevationIdResolve409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiTenantsTenantSlugElevationsElevationIdResolve409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Start a break-glass override session into a tenant (platform admin only)
 */
export const postApiPlatformAdminOverrideBodyReasonMin = 10;
export const postApiPlatformAdminOverrideBodyReasonMax = 2000;

export const postApiPlatformAdminOverrideBodyDurationHoursMax = 4;



export const PostApiPlatformAdminOverrideBody = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid(),
  "reason": zod.string().min(postApiPlatformAdminOverrideBodyReasonMin).max(postApiPlatformAdminOverrideBodyReasonMax),
  "durationHours": zod.int().min(1).max(postApiPlatformAdminOverrideBodyDurationHoursMax)
}))()

export const PostApiPlatformAdminOverride201Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "platformAdminId": zod.uuid(),
  "organizationId": zod.uuid(),
  "tenantName": zod.string(),
  "tenantSlug": zod.string(),
  "reason": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "endedBy": zod.uuid().nullable(),
  "metadata": zod.looseObject({

}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminOverride403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminOverride403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminOverride403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminOverride409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminOverride409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminOverride409ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminOverride409ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminOverride409ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminOverride409Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverride409ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverride409ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminOverride409ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminOverride409ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminOverride409ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List override sessions for the current platform admin
 */
export const getApiPlatformAdminOverrideQueryLimitMax = 200;

export const getApiPlatformAdminOverrideQueryOffsetMin = 0;



export const GetApiPlatformAdminOverrideQueryParams = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid().optional(),
  "activeOnly": zod.boolean().optional(),
  "limit": zod.int().min(1).max(getApiPlatformAdminOverrideQueryLimitMax).optional(),
  "offset": zod.int().min(getApiPlatformAdminOverrideQueryOffsetMin).optional()
}))()

export const GetApiPlatformAdminOverride200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "platformAdminId": zod.uuid(),
  "organizationId": zod.uuid(),
  "tenantName": zod.string(),
  "tenantSlug": zod.string(),
  "reason": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "endedBy": zod.uuid().nullable(),
  "metadata": zod.looseObject({

}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const getApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminOverride403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminOverride403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminOverride403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminOverride403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminOverride403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary End an active override session (platform admin only)
 */
export const PostApiPlatformAdminOverrideEndBody = /*#__PURE__*/ (() => zod.object({
  "tenantId": zod.uuid().optional(),
  "overrideId": zod.uuid().optional()
}))()

export const PostApiPlatformAdminOverrideEnd200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "platformAdminId": zod.uuid(),
  "organizationId": zod.uuid(),
  "tenantName": zod.string(),
  "tenantSlug": zod.string(),
  "reason": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "endedBy": zod.uuid().nullable(),
  "metadata": zod.looseObject({

}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))()

export const postApiPlatformAdminOverrideEnd403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminOverrideEnd403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminOverrideEnd403ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminOverrideEnd403ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminOverrideEnd403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminOverrideEnd403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverrideEnd403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverrideEnd403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminOverrideEnd403ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminOverrideEnd403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminOverrideEnd403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const postApiPlatformAdminOverrideEnd404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const postApiPlatformAdminOverrideEnd404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const postApiPlatformAdminOverrideEnd404ResponseOverlapWarningAcknowledgementMin = 16;
export const postApiPlatformAdminOverrideEnd404ResponseOverlapWarningAcknowledgementMax = 256;


export const postApiPlatformAdminOverrideEnd404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const PostApiPlatformAdminOverrideEnd404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverrideEnd404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(postApiPlatformAdminOverrideEnd404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(postApiPlatformAdminOverrideEnd404ResponseOverlapWarningAcknowledgementMin).max(postApiPlatformAdminOverrideEnd404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(postApiPlatformAdminOverrideEnd404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * Both privileged operations remain unavailable until their separate custody and complete aggregate adapters are configured.
 * @summary Read audit custody and entity transfer readiness
 */
export const GetApiPlatformAdminGovernanceReadiness200Response = /*#__PURE__*/ (() => zod.object({
  "audit": zod.object({
  "retentionEnabled": zod.boolean(),
  "custodyConfigured": zod.boolean(),
  "minimumAgeDays": zod.int(),
  "blockers": zod.array(zod.string())
}),
  "transfer": zod.object({
  "enabled": zod.boolean(),
  "registeredTableCount": zod.int(),
  "missingAdapters": zod.array(zod.string()),
  "blockers": zod.array(zod.string())
})
}))()

export const getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminGovernanceReadiness403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminGovernanceReadiness403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminGovernanceReadiness403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminGovernanceReadiness403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Query platform-plane audit events (platform admin only)
 */
export const getApiPlatformAdminAuditQueryLimitMax = 200;

export const getApiPlatformAdminAuditQueryOffsetMin = 0;



export const GetApiPlatformAdminAuditQueryParams = /*#__PURE__*/ (() => zod.object({
  "action": zod.string().optional(),
  "actorUserId": zod.uuid().optional(),
  "organizationId": zod.uuid().optional(),
  "targetType": zod.string().optional(),
  "targetId": zod.uuid().optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional(),
  "limit": zod.int().min(1).max(getApiPlatformAdminAuditQueryLimitMax).optional(),
  "offset": zod.int().min(getApiPlatformAdminAuditQueryOffsetMin).optional()
}))()

export const GetApiPlatformAdminAudit200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "at": zod.iso.datetime({"offset":true}),
  "actorUserId": zod.uuid().nullable(),
  "tenantId": zod.uuid().nullable(),
  "organizationId": zod.uuid().nullable(),
  "plane": zod.enum(['platform', 'tenant']),
  "action": zod.string(),
  "targetType": zod.string(),
  "targetId": zod.uuid().nullable(),
  "metadata": zod.looseObject({

}).nullable(),
  "requestId": zod.string().nullable(),
  "correlationId": zod.string().nullable()
})),
  "limit": zod.int(),
  "offset": zod.int()
}))()

export const getApiPlatformAdminAudit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getApiPlatformAdminAudit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getApiPlatformAdminAudit403ResponseOverlapWarningAcknowledgementMin = 16;
export const getApiPlatformAdminAudit403ResponseOverlapWarningAcknowledgementMax = 256;


export const getApiPlatformAdminAudit403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetApiPlatformAdminAudit403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminAudit403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getApiPlatformAdminAudit403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getApiPlatformAdminAudit403ResponseOverlapWarningAcknowledgementMin).max(getApiPlatformAdminAudit403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getApiPlatformAdminAudit403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List selected-entity credential types; employees see enabled types only
 */
export const ListCredentialTypesQueryParams = /*#__PURE__*/ (() => zod.object({
  "enabledOnly": zod.enum(['true', 'false']).optional()
}))()

export const listCredentialTypesHeaderXGroupGraphTokenMax = 16384;


export const listCredentialTypesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListCredentialTypesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listCredentialTypesHeaderXGroupGraphTokenMax).regex(listCredentialTypesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListCredentialTypes200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullable(),
  "enabled": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
}))()

export const listCredentialTypes400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialTypes400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialTypes400ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialTypes400ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialTypes400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialTypes400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialTypes400ResponseOverlapWarningAcknowledgementMin).max(listCredentialTypes400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialTypes400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialTypes401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialTypes401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialTypes401ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialTypes401ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialTypes401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialTypes401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialTypes401ResponseOverlapWarningAcknowledgementMin).max(listCredentialTypes401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialTypes401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialTypes403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialTypes403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialTypes403ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialTypes403ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialTypes403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialTypes403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialTypes403ResponseOverlapWarningAcknowledgementMin).max(listCredentialTypes403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialTypes403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialTypes404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialTypes404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialTypes404ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialTypes404ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialTypes404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialTypes404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialTypes404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialTypes404ResponseOverlapWarningAcknowledgementMin).max(listCredentialTypes404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialTypes404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Create a credential type with policy management permission
 */
export const createCredentialTypeHeaderXGroupGraphTokenMax = 16384;


export const createCredentialTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateCredentialTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createCredentialTypeHeaderXGroupGraphTokenMax).regex(createCredentialTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createCredentialTypeBodyCodeMax = 64;

export const createCredentialTypeBodyDisplayNameMax = 200;

export const createCredentialTypeBodyDescriptionMax = 2000;



export const CreateCredentialTypeBody = /*#__PURE__*/ (() => zod.object({
  "code": zod.string().min(1).max(createCredentialTypeBodyCodeMax),
  "displayName": zod.string().min(1).max(createCredentialTypeBodyDisplayNameMax),
  "description": zod.string().max(createCredentialTypeBodyDescriptionMax).nullish(),
  "enabled": zod.boolean().optional()
}))()

export const CreateCredentialType200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullable(),
  "enabled": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const createCredentialType400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createCredentialType400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createCredentialType400ResponseOverlapWarningAcknowledgementMin = 16;
export const createCredentialType400ResponseOverlapWarningAcknowledgementMax = 256;


export const createCredentialType400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateCredentialType400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createCredentialType400ResponseOverlapWarningAcknowledgementMin).max(createCredentialType400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createCredentialType400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createCredentialType401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createCredentialType401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createCredentialType401ResponseOverlapWarningAcknowledgementMin = 16;
export const createCredentialType401ResponseOverlapWarningAcknowledgementMax = 256;


export const createCredentialType401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateCredentialType401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createCredentialType401ResponseOverlapWarningAcknowledgementMin).max(createCredentialType401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createCredentialType401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createCredentialType403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createCredentialType403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createCredentialType403ResponseOverlapWarningAcknowledgementMin = 16;
export const createCredentialType403ResponseOverlapWarningAcknowledgementMax = 256;


export const createCredentialType403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateCredentialType403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createCredentialType403ResponseOverlapWarningAcknowledgementMin).max(createCredentialType403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createCredentialType403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const createCredentialType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const createCredentialType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const createCredentialType404ResponseOverlapWarningAcknowledgementMin = 16;
export const createCredentialType404ResponseOverlapWarningAcknowledgementMax = 256;


export const createCredentialType404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const CreateCredentialType404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(createCredentialType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(createCredentialType404ResponseOverlapWarningAcknowledgementMin).max(createCredentialType404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(createCredentialType404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Update a selected-entity credential type
 */
export const UpdateCredentialTypeParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const updateCredentialTypeHeaderXGroupGraphTokenMax = 16384;


export const updateCredentialTypeHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateCredentialTypeHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateCredentialTypeHeaderXGroupGraphTokenMax).regex(updateCredentialTypeHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateCredentialTypeBodyDisplayNameMax = 200;

export const updateCredentialTypeBodyDescriptionMax = 2000;



export const UpdateCredentialTypeBody = /*#__PURE__*/ (() => zod.object({
  "displayName": zod.string().min(1).max(updateCredentialTypeBodyDisplayNameMax).optional(),
  "description": zod.string().max(updateCredentialTypeBodyDescriptionMax).nullish(),
  "enabled": zod.boolean().optional()
}))()

export const UpdateCredentialType200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "displayName": zod.string(),
  "description": zod.string().nullable(),
  "enabled": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const updateCredentialType400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateCredentialType400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateCredentialType400ResponseOverlapWarningAcknowledgementMin = 16;
export const updateCredentialType400ResponseOverlapWarningAcknowledgementMax = 256;


export const updateCredentialType400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateCredentialType400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateCredentialType400ResponseOverlapWarningAcknowledgementMin).max(updateCredentialType400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateCredentialType400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateCredentialType401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateCredentialType401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateCredentialType401ResponseOverlapWarningAcknowledgementMin = 16;
export const updateCredentialType401ResponseOverlapWarningAcknowledgementMax = 256;


export const updateCredentialType401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateCredentialType401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateCredentialType401ResponseOverlapWarningAcknowledgementMin).max(updateCredentialType401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateCredentialType401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateCredentialType403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateCredentialType403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateCredentialType403ResponseOverlapWarningAcknowledgementMin = 16;
export const updateCredentialType403ResponseOverlapWarningAcknowledgementMax = 256;


export const updateCredentialType403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateCredentialType403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateCredentialType403ResponseOverlapWarningAcknowledgementMin).max(updateCredentialType403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateCredentialType403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const updateCredentialType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const updateCredentialType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const updateCredentialType404ResponseOverlapWarningAcknowledgementMin = 16;
export const updateCredentialType404ResponseOverlapWarningAcknowledgementMax = 256;


export const updateCredentialType404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const UpdateCredentialType404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(updateCredentialType404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(updateCredentialType404ResponseOverlapWarningAcknowledgementMin).max(updateCredentialType404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(updateCredentialType404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List the signed-in user's selected-entity submissions without document bytes
 */
export const listMyCredentialsQueryLimitDefault = 50;
export const listMyCredentialsQueryLimitMax = 200;

export const listMyCredentialsQueryOffsetDefault = 0;
export const listMyCredentialsQueryOffsetMin = 0;



export const ListMyCredentialsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listMyCredentialsQueryLimitMax).default(listMyCredentialsQueryLimitDefault),
  "offset": zod.int().min(listMyCredentialsQueryOffsetMin).default(listMyCredentialsQueryOffsetDefault)
}))()

export const listMyCredentialsHeaderXGroupGraphTokenMax = 16384;


export const listMyCredentialsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListMyCredentialsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listMyCredentialsHeaderXGroupGraphTokenMax).regex(listMyCredentialsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListMyCredentials200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "credentialTypeId": zod.uuid(),
  "credentialTypeCode": zod.string(),
  "credentialTypeName": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'revoked']),
  "isEffectivelyApproved": zod.boolean(),
  "referenceNumber": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "documentContentType": zod.string(),
  "documentFileName": zod.string(),
  "documentByteSize": zod.int(),
  "reviewerNote": zod.string().nullable(),
  "reviewedByUserId": zod.uuid().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
}))()

export const listMyCredentials400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyCredentials400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyCredentials400ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyCredentials400ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyCredentials400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyCredentials400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyCredentials400ResponseOverlapWarningAcknowledgementMin).max(listMyCredentials400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyCredentials400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyCredentials401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyCredentials401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyCredentials401ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyCredentials401ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyCredentials401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyCredentials401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyCredentials401ResponseOverlapWarningAcknowledgementMin).max(listMyCredentials401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyCredentials401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyCredentials403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyCredentials403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyCredentials403ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyCredentials403ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyCredentials403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyCredentials403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyCredentials403ResponseOverlapWarningAcknowledgementMin).max(listMyCredentials403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyCredentials403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listMyCredentials404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listMyCredentials404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listMyCredentials404ResponseOverlapWarningAcknowledgementMin = 16;
export const listMyCredentials404ResponseOverlapWarningAcknowledgementMax = 256;


export const listMyCredentials404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListMyCredentials404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listMyCredentials404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listMyCredentials404ResponseOverlapWarningAcknowledgementMin).max(listMyCredentials404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listMyCredentials404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Submit a selected-entity credential with one PDF, JPEG or PNG document (maximum 10 MB)
 */
export const submitMyCredentialHeaderXGroupGraphTokenMax = 16384;


export const submitMyCredentialHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SubmitMyCredentialHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(submitMyCredentialHeaderXGroupGraphTokenMax).regex(submitMyCredentialHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const submitMyCredentialBodyReferenceNumberMax = 120;



export const SubmitMyCredentialBody = /*#__PURE__*/ (() => zod.object({
  "credentialTypeId": zod.uuid(),
  "referenceNumber": zod.string().min(1).max(submitMyCredentialBodyReferenceNumberMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "document": zod.instanceof(Blob)
}))()

export const SubmitMyCredential200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "credentialTypeId": zod.uuid(),
  "credentialTypeCode": zod.string(),
  "credentialTypeName": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'revoked']),
  "isEffectivelyApproved": zod.boolean(),
  "referenceNumber": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "documentContentType": zod.string(),
  "documentFileName": zod.string(),
  "documentByteSize": zod.int(),
  "reviewerNote": zod.string().nullable(),
  "reviewedByUserId": zod.uuid().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const submitMyCredential400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const submitMyCredential400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const submitMyCredential400ResponseOverlapWarningAcknowledgementMin = 16;
export const submitMyCredential400ResponseOverlapWarningAcknowledgementMax = 256;


export const submitMyCredential400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SubmitMyCredential400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(submitMyCredential400ResponseOverlapWarningAcknowledgementMin).max(submitMyCredential400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(submitMyCredential400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const submitMyCredential401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const submitMyCredential401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const submitMyCredential401ResponseOverlapWarningAcknowledgementMin = 16;
export const submitMyCredential401ResponseOverlapWarningAcknowledgementMax = 256;


export const submitMyCredential401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SubmitMyCredential401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(submitMyCredential401ResponseOverlapWarningAcknowledgementMin).max(submitMyCredential401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(submitMyCredential401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const submitMyCredential403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const submitMyCredential403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const submitMyCredential403ResponseOverlapWarningAcknowledgementMin = 16;
export const submitMyCredential403ResponseOverlapWarningAcknowledgementMax = 256;


export const submitMyCredential403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SubmitMyCredential403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(submitMyCredential403ResponseOverlapWarningAcknowledgementMin).max(submitMyCredential403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(submitMyCredential403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const submitMyCredential404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const submitMyCredential404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const submitMyCredential404ResponseOverlapWarningAcknowledgementMin = 16;
export const submitMyCredential404ResponseOverlapWarningAcknowledgementMax = 256;


export const submitMyCredential404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SubmitMyCredential404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(submitMyCredential404ResponseOverlapWarningAcknowledgementMin).max(submitMyCredential404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(submitMyCredential404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const submitMyCredential413ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const submitMyCredential413ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const submitMyCredential413ResponseOverlapWarningAcknowledgementMin = 16;
export const submitMyCredential413ResponseOverlapWarningAcknowledgementMax = 256;


export const submitMyCredential413ResponsePolicyRequirementsMissingRulesMax = 1000;



export const SubmitMyCredential413Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential413ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(submitMyCredential413ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(submitMyCredential413ResponseOverlapWarningAcknowledgementMin).max(submitMyCredential413ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(submitMyCredential413ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Download own document or review an entity document with policy management permission
 */
export const DownloadCredentialDocumentParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const downloadCredentialDocumentHeaderXGroupGraphTokenMax = 16384;


export const downloadCredentialDocumentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DownloadCredentialDocumentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(downloadCredentialDocumentHeaderXGroupGraphTokenMax).regex(downloadCredentialDocumentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const DownloadCredentialDocument200Response = /*#__PURE__*/ (() => zod.unknown())()

export const downloadCredentialDocument400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadCredentialDocument400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadCredentialDocument400ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadCredentialDocument400ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadCredentialDocument400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadCredentialDocument400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadCredentialDocument400ResponseOverlapWarningAcknowledgementMin).max(downloadCredentialDocument400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadCredentialDocument400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const downloadCredentialDocument401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadCredentialDocument401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadCredentialDocument401ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadCredentialDocument401ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadCredentialDocument401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadCredentialDocument401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadCredentialDocument401ResponseOverlapWarningAcknowledgementMin).max(downloadCredentialDocument401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadCredentialDocument401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const downloadCredentialDocument403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadCredentialDocument403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadCredentialDocument403ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadCredentialDocument403ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadCredentialDocument403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadCredentialDocument403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadCredentialDocument403ResponseOverlapWarningAcknowledgementMin).max(downloadCredentialDocument403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadCredentialDocument403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const downloadCredentialDocument404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const downloadCredentialDocument404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const downloadCredentialDocument404ResponseOverlapWarningAcknowledgementMin = 16;
export const downloadCredentialDocument404ResponseOverlapWarningAcknowledgementMax = 256;


export const downloadCredentialDocument404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const DownloadCredentialDocument404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(downloadCredentialDocument404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(downloadCredentialDocument404ResponseOverlapWarningAcknowledgementMin).max(downloadCredentialDocument404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(downloadCredentialDocument404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary List selected-entity submissions with policy management permission
 */
export const listCredentialReviewsQueryLimitDefault = 50;
export const listCredentialReviewsQueryLimitMax = 200;

export const listCredentialReviewsQueryOffsetDefault = 0;
export const listCredentialReviewsQueryOffsetMin = 0;



export const ListCredentialReviewsQueryParams = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['pending', 'approved', 'rejected', 'revoked']).optional(),
  "limit": zod.int().min(1).max(listCredentialReviewsQueryLimitMax).default(listCredentialReviewsQueryLimitDefault),
  "offset": zod.int().min(listCredentialReviewsQueryOffsetMin).default(listCredentialReviewsQueryOffsetDefault)
}))()

export const listCredentialReviewsHeaderXGroupGraphTokenMax = 16384;


export const listCredentialReviewsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListCredentialReviewsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listCredentialReviewsHeaderXGroupGraphTokenMax).regex(listCredentialReviewsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ListCredentialReviews200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "credentialTypeId": zod.uuid(),
  "credentialTypeCode": zod.string(),
  "credentialTypeName": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'revoked']),
  "isEffectivelyApproved": zod.boolean(),
  "referenceNumber": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "documentContentType": zod.string(),
  "documentFileName": zod.string(),
  "documentByteSize": zod.int(),
  "reviewerNote": zod.string().nullable(),
  "reviewedByUserId": zod.uuid().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
}))()

export const listCredentialReviews400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialReviews400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialReviews400ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialReviews400ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialReviews400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialReviews400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialReviews400ResponseOverlapWarningAcknowledgementMin).max(listCredentialReviews400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialReviews400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialReviews401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialReviews401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialReviews401ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialReviews401ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialReviews401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialReviews401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialReviews401ResponseOverlapWarningAcknowledgementMin).max(listCredentialReviews401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialReviews401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialReviews403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialReviews403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialReviews403ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialReviews403ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialReviews403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialReviews403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialReviews403ResponseOverlapWarningAcknowledgementMin).max(listCredentialReviews403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialReviews403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const listCredentialReviews404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const listCredentialReviews404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const listCredentialReviews404ResponseOverlapWarningAcknowledgementMin = 16;
export const listCredentialReviews404ResponseOverlapWarningAcknowledgementMax = 256;


export const listCredentialReviews404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ListCredentialReviews404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(listCredentialReviews404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(listCredentialReviews404ResponseOverlapWarningAcknowledgementMin).max(listCredentialReviews404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(listCredentialReviews404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Approve or reject a pending entity submission; rejection requires a note
 */
export const ReviewCredentialParams = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid()
}))()

export const reviewCredentialHeaderXGroupGraphTokenMax = 16384;


export const reviewCredentialHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ReviewCredentialHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(reviewCredentialHeaderXGroupGraphTokenMax).regex(reviewCredentialHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const reviewCredentialBodyReviewerNoteMax = 2000;



export const ReviewCredentialBody = /*#__PURE__*/ (() => zod.object({
  "decision": zod.enum(['approved', 'rejected']),
  "reviewerNote": zod.string().max(reviewCredentialBodyReviewerNoteMax).nullish()
}))()

export const ReviewCredential200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "userId": zod.uuid(),
  "credentialTypeId": zod.uuid(),
  "credentialTypeCode": zod.string(),
  "credentialTypeName": zod.string(),
  "status": zod.enum(['pending', 'approved', 'rejected', 'revoked']),
  "isEffectivelyApproved": zod.boolean(),
  "referenceNumber": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "documentContentType": zod.string(),
  "documentFileName": zod.string(),
  "documentByteSize": zod.int(),
  "reviewerNote": zod.string().nullable(),
  "reviewedByUserId": zod.uuid().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const reviewCredential400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const reviewCredential400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const reviewCredential400ResponseOverlapWarningAcknowledgementMin = 16;
export const reviewCredential400ResponseOverlapWarningAcknowledgementMax = 256;


export const reviewCredential400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ReviewCredential400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(reviewCredential400ResponseOverlapWarningAcknowledgementMin).max(reviewCredential400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(reviewCredential400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const reviewCredential401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const reviewCredential401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const reviewCredential401ResponseOverlapWarningAcknowledgementMin = 16;
export const reviewCredential401ResponseOverlapWarningAcknowledgementMax = 256;


export const reviewCredential401ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ReviewCredential401Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential401ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential401ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(reviewCredential401ResponseOverlapWarningAcknowledgementMin).max(reviewCredential401ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(reviewCredential401ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const reviewCredential403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const reviewCredential403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const reviewCredential403ResponseOverlapWarningAcknowledgementMin = 16;
export const reviewCredential403ResponseOverlapWarningAcknowledgementMax = 256;


export const reviewCredential403ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ReviewCredential403Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential403ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential403ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(reviewCredential403ResponseOverlapWarningAcknowledgementMin).max(reviewCredential403ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(reviewCredential403ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const reviewCredential404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const reviewCredential404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const reviewCredential404ResponseOverlapWarningAcknowledgementMin = 16;
export const reviewCredential404ResponseOverlapWarningAcknowledgementMax = 256;


export const reviewCredential404ResponsePolicyRequirementsMissingRulesMax = 1000;



export const ReviewCredential404Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential404ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(reviewCredential404ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(reviewCredential404ResponseOverlapWarningAcknowledgementMin).max(reviewCredential404ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(reviewCredential404ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()


/**
 * @summary Read all customer email defaults (platform administrator only)
 */
export const listPlatformEmailTemplates200ResponseItemsMax = 10;



export const ListPlatformEmailTemplates200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "allowEntityOverrides": zod.object({
  "booking_confirmed": zod.boolean().optional(),
  "booking_modified": zod.boolean().optional(),
  "booking_cancelled": zod.boolean().optional(),
  "booking_auto_released": zod.boolean().optional(),
  "booking_reminder": zod.boolean().optional(),
  "check_in_prompt": zod.boolean().optional(),
  "auto_release_warning": zod.boolean().optional(),
  "resource_unavailable": zod.boolean().optional(),
  "visitor_arrival": zod.boolean().optional(),
  "visitor_approval": zod.boolean().optional()
}),
  "items": zod.array(zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})).max(listPlatformEmailTemplates200ResponseItemsMax)
}))()

export const ListPlatformEmailTemplates403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Save platform default customer email wording
 */
export const SavePlatformEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval'])
}))()

export const savePlatformEmailTemplateBodySubjectMax = 200;

export const savePlatformEmailTemplateBodyBodyMax = 10000;

export const savePlatformEmailTemplateBodyFormatDefault = `plain`;

export const SavePlatformEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "subject": zod.string().min(1).max(savePlatformEmailTemplateBodySubjectMax),
  "body": zod.string().min(1).max(savePlatformEmailTemplateBodyBodyMax),
  "format": zod.enum(['plain', 'formatted']).default(savePlatformEmailTemplateBodyFormatDefault)
}))()

export const SavePlatformEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const SavePlatformEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const SavePlatformEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Reset platform customer email wording to the built-in default
 */
export const ResetPlatformEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval'])
}))()

export const ResetPlatformEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const ResetPlatformEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Uses sample details and optional unsaved drafts. Provider acceptance is not delivery confirmation. Never retries a send.
 * @summary Send a sample email only to the signed-in platform administrator
 */
export const testSendPlatformEmailTemplateBodySubjectMax = 200;

export const testSendPlatformEmailTemplateBodyBodyMax = 10000;

export const testSendPlatformEmailTemplateBodyStyleDraftBannerTextMax = 120;

export const testSendPlatformEmailTemplateBodyStyleDraftLogoMaxHeightMin = 40;
export const testSendPlatformEmailTemplateBodyStyleDraftLogoMaxHeightMax = 120;

export const testSendPlatformEmailTemplateBodyStyleDraftColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendPlatformEmailTemplateBodyStyleDraftButtonLabelMax = 40;

export const testSendPlatformEmailTemplateBodyStyleDraftFooterTextMax = 2000;



export const TestSendPlatformEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "subject": zod.string().min(1).max(testSendPlatformEmailTemplateBodySubjectMax).optional(),
  "body": zod.string().min(1).max(testSendPlatformEmailTemplateBodyBodyMax).optional(),
  "format": zod.enum(['plain', 'formatted']).optional(),
  "styleDraft": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(testSendPlatformEmailTemplateBodyStyleDraftBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(testSendPlatformEmailTemplateBodyStyleDraftLogoMaxHeightMin).max(testSendPlatformEmailTemplateBodyStyleDraftLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursTextRegExp).nullish(),
  "heading": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(testSendPlatformEmailTemplateBodyStyleDraftColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(testSendPlatformEmailTemplateBodyStyleDraftButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(testSendPlatformEmailTemplateBodyStyleDraftFooterTextMax).nullish()
}).nullish()
}).optional()
}))()

export const TestSendPlatformEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['accepted', 'not_configured']),
  "sentTo": zod.string().describe('Masked account email; never supplied by the request'),
  "message": zod.string()
}))()

export const TestSendPlatformEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendPlatformEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendPlatformEmailTemplate429Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendPlatformEmailTemplate502Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Render customer email wording using sample details without sending
 */
export const previewPlatformEmailTemplateBodySubjectMax = 200;

export const previewPlatformEmailTemplateBodyBodyMax = 10000;

export const previewPlatformEmailTemplateBodyFormatDefault = `plain`;

export const PreviewPlatformEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "subject": zod.string().min(1).max(previewPlatformEmailTemplateBodySubjectMax),
  "body": zod.string().min(1).max(previewPlatformEmailTemplateBodyBodyMax),
  "format": zod.enum(['plain', 'formatted']).default(previewPlatformEmailTemplateBodyFormatDefault)
}))()

export const previewPlatformEmailTemplate200ResponseHtmlMax = 102399;



export const PreviewPlatformEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "subject": zod.string(),
  "body": zod.string(),
  "html": zod.string().max(previewPlatformEmailTemplate200ResponseHtmlMax),
  "plainText": zod.string()
}))()

export const PreviewPlatformEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewPlatformEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read the stored and effective email look
 */
export const GetEmailStyleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getEmailStyleQueryScopeDefault = `entity`;
export const getEmailStyleQueryAuthorityDefault = `tenant`;

export const GetEmailStyleQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(getEmailStyleQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(getEmailStyleQueryAuthorityDefault)
}))()

export const getEmailStyleHeaderXGroupGraphTokenMax = 16384;


export const getEmailStyleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetEmailStyleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getEmailStyleHeaderXGroupGraphTokenMax).regex(getEmailStyleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getEmailStyle200ResponseStoredBannerTextMax = 120;

export const getEmailStyle200ResponseStoredLogoMaxHeightMin = 40;
export const getEmailStyle200ResponseStoredLogoMaxHeightMax = 120;

export const getEmailStyle200ResponseStoredColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseStoredButtonLabelMax = 40;

export const getEmailStyle200ResponseStoredFooterTextMax = 2000;

export const getEmailStyle200ResponseTenantValuesBannerTextMax = 120;

export const getEmailStyle200ResponseTenantValuesLogoMaxHeightMin = 40;
export const getEmailStyle200ResponseTenantValuesLogoMaxHeightMax = 120;

export const getEmailStyle200ResponseTenantValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseTenantValuesButtonLabelMax = 40;

export const getEmailStyle200ResponseTenantValuesFooterTextMax = 2000;

export const getEmailStyle200ResponseEntityValuesBannerTextMax = 120;

export const getEmailStyle200ResponseEntityValuesLogoMaxHeightMin = 40;
export const getEmailStyle200ResponseEntityValuesLogoMaxHeightMax = 120;

export const getEmailStyle200ResponseEntityValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEntityValuesButtonLabelMax = 40;

export const getEmailStyle200ResponseEntityValuesFooterTextMax = 2000;

export const getEmailStyle200ResponseEffectiveBannerTextMax = 120;

export const getEmailStyle200ResponseEffectiveLogoMaxHeightMin = 40;
export const getEmailStyle200ResponseEffectiveLogoMaxHeightMax = 120;

export const getEmailStyle200ResponseEffectiveColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getEmailStyle200ResponseEffectiveButtonLabelMax = 40;

export const getEmailStyle200ResponseEffectiveFooterTextMax = 2000;

export const getEmailStyle200ResponseImagesBannerOneAltTextMax = 120;

export const getEmailStyle200ResponseImagesLogoOneAltTextMax = 120;



export const GetEmailStyle200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "stored": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(getEmailStyle200ResponseStoredBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(getEmailStyle200ResponseStoredLogoMaxHeightMin).max(getEmailStyle200ResponseStoredLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(getEmailStyle200ResponseStoredColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(getEmailStyle200ResponseStoredColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(getEmailStyle200ResponseStoredColoursTextRegExp).nullish(),
  "heading": zod.string().regex(getEmailStyle200ResponseStoredColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(getEmailStyle200ResponseStoredColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(getEmailStyle200ResponseStoredColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(getEmailStyle200ResponseStoredColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(getEmailStyle200ResponseStoredColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(getEmailStyle200ResponseStoredColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(getEmailStyle200ResponseStoredColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(getEmailStyle200ResponseStoredColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(getEmailStyle200ResponseStoredButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(getEmailStyle200ResponseStoredFooterTextMax).nullish()
}).nullish()
}),
  "tenantValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(getEmailStyle200ResponseTenantValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(getEmailStyle200ResponseTenantValuesLogoMaxHeightMin).max(getEmailStyle200ResponseTenantValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(getEmailStyle200ResponseTenantValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(getEmailStyle200ResponseTenantValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(getEmailStyle200ResponseTenantValuesFooterTextMax).nullish()
}).nullish()
}),
  "entityValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(getEmailStyle200ResponseEntityValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(getEmailStyle200ResponseEntityValuesLogoMaxHeightMin).max(getEmailStyle200ResponseEntityValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(getEmailStyle200ResponseEntityValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(getEmailStyle200ResponseEntityValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(getEmailStyle200ResponseEntityValuesFooterTextMax).nullish()
}).nullish()
}),
  "effective": zod.object({
  "version": zod.literal(1),
  "banner": zod.object({
  "mode": zod.enum(['none', 'colour', 'image']),
  "text": zod.string().max(getEmailStyle200ResponseEffectiveBannerTextMax),
  "alignment": zod.enum(['left', 'centre']),
  "imageId": zod.uuid().nullable()
}),
  "logo": zod.object({
  "source": zod.enum(['app', 'uploaded', 'none']),
  "position": zod.enum(['left', 'centre']),
  "maxHeight": zod.int().min(getEmailStyle200ResponseEffectiveLogoMaxHeightMin).max(getEmailStyle200ResponseEffectiveLogoMaxHeightMax),
  "imageId": zod.uuid().nullable()
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "headingFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18)])
}),
  "colours": zod.object({
  "pageBackground": zod.string().regex(getEmailStyle200ResponseEffectiveColoursPageBackgroundRegExp),
  "contentBackground": zod.string().regex(getEmailStyle200ResponseEffectiveColoursContentBackgroundRegExp),
  "text": zod.string().regex(getEmailStyle200ResponseEffectiveColoursTextRegExp),
  "heading": zod.string().regex(getEmailStyle200ResponseEffectiveColoursHeadingRegExp),
  "link": zod.string().regex(getEmailStyle200ResponseEffectiveColoursLinkRegExp),
  "bannerBackground": zod.string().regex(getEmailStyle200ResponseEffectiveColoursBannerBackgroundRegExp),
  "bannerText": zod.string().regex(getEmailStyle200ResponseEffectiveColoursBannerTextRegExp),
  "buttonBackground": zod.string().regex(getEmailStyle200ResponseEffectiveColoursButtonBackgroundRegExp),
  "buttonText": zod.string().regex(getEmailStyle200ResponseEffectiveColoursButtonTextRegExp),
  "footerBackground": zod.string().regex(getEmailStyle200ResponseEffectiveColoursFooterBackgroundRegExp),
  "footerText": zod.string().regex(getEmailStyle200ResponseEffectiveColoursFooterTextRegExp)
}),
  "button": zod.object({
  "shape": zod.enum(['square', 'rounded', 'pill']),
  "label": zod.string().min(1).max(getEmailStyle200ResponseEffectiveButtonLabelMax)
}),
  "footer": zod.object({
  "text": zod.string().max(getEmailStyle200ResponseEffectiveFooterTextMax)
})
}),
  "source": zod.object({
  "banner": zod.object({
  "mode": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "alignment": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "logo": zod.object({
  "source": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "position": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "maxHeight": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "headingFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "baseSize": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "colours": zod.object({
  "pageBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "contentBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "heading": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "link": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerText": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "button": zod.object({
  "shape": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "label": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "footer": zod.object({
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
})
}),
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
}),
  "images": zod.object({
  "banner": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(getEmailStyle200ResponseImagesBannerOneAltTextMax)
}),zod.null()]),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(getEmailStyle200ResponseImagesLogoOneAltTextMax)
}),zod.null()])
}),
  "warnings": zod.array(zod.string())
}))()

export const GetEmailStyle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetEmailStyle403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Patch email look fields; null clears a field or group to inheritance
 */
export const SaveEmailStyleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const saveEmailStyleQueryScopeDefault = `entity`;
export const saveEmailStyleQueryAuthorityDefault = `tenant`;

export const SaveEmailStyleQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(saveEmailStyleQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(saveEmailStyleQueryAuthorityDefault)
}))()

export const saveEmailStyleHeaderXGroupGraphTokenMax = 16384;


export const saveEmailStyleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveEmailStyleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveEmailStyleHeaderXGroupGraphTokenMax).regex(saveEmailStyleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveEmailStyleBodyBannerTextMax = 120;

export const saveEmailStyleBodyLogoMaxHeightMin = 40;
export const saveEmailStyleBodyLogoMaxHeightMax = 120;

export const saveEmailStyleBodyColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyleBodyButtonLabelMax = 40;

export const saveEmailStyleBodyFooterTextMax = 2000;



export const SaveEmailStyleBody = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(saveEmailStyleBodyBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(saveEmailStyleBodyLogoMaxHeightMin).max(saveEmailStyleBodyLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(saveEmailStyleBodyColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(saveEmailStyleBodyColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(saveEmailStyleBodyColoursTextRegExp).nullish(),
  "heading": zod.string().regex(saveEmailStyleBodyColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(saveEmailStyleBodyColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(saveEmailStyleBodyColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(saveEmailStyleBodyColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(saveEmailStyleBodyColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(saveEmailStyleBodyColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(saveEmailStyleBodyColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(saveEmailStyleBodyColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(saveEmailStyleBodyButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(saveEmailStyleBodyFooterTextMax).nullish()
}).nullish()
}))()

export const saveEmailStyle200ResponseStoredBannerTextMax = 120;

export const saveEmailStyle200ResponseStoredLogoMaxHeightMin = 40;
export const saveEmailStyle200ResponseStoredLogoMaxHeightMax = 120;

export const saveEmailStyle200ResponseStoredColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseStoredButtonLabelMax = 40;

export const saveEmailStyle200ResponseStoredFooterTextMax = 2000;

export const saveEmailStyle200ResponseTenantValuesBannerTextMax = 120;

export const saveEmailStyle200ResponseTenantValuesLogoMaxHeightMin = 40;
export const saveEmailStyle200ResponseTenantValuesLogoMaxHeightMax = 120;

export const saveEmailStyle200ResponseTenantValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseTenantValuesButtonLabelMax = 40;

export const saveEmailStyle200ResponseTenantValuesFooterTextMax = 2000;

export const saveEmailStyle200ResponseEntityValuesBannerTextMax = 120;

export const saveEmailStyle200ResponseEntityValuesLogoMaxHeightMin = 40;
export const saveEmailStyle200ResponseEntityValuesLogoMaxHeightMax = 120;

export const saveEmailStyle200ResponseEntityValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEntityValuesButtonLabelMax = 40;

export const saveEmailStyle200ResponseEntityValuesFooterTextMax = 2000;

export const saveEmailStyle200ResponseEffectiveBannerTextMax = 120;

export const saveEmailStyle200ResponseEffectiveLogoMaxHeightMin = 40;
export const saveEmailStyle200ResponseEffectiveLogoMaxHeightMax = 120;

export const saveEmailStyle200ResponseEffectiveColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveEmailStyle200ResponseEffectiveButtonLabelMax = 40;

export const saveEmailStyle200ResponseEffectiveFooterTextMax = 2000;

export const saveEmailStyle200ResponseImagesBannerOneAltTextMax = 120;

export const saveEmailStyle200ResponseImagesLogoOneAltTextMax = 120;



export const SaveEmailStyle200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "stored": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(saveEmailStyle200ResponseStoredBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(saveEmailStyle200ResponseStoredLogoMaxHeightMin).max(saveEmailStyle200ResponseStoredLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(saveEmailStyle200ResponseStoredColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(saveEmailStyle200ResponseStoredColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(saveEmailStyle200ResponseStoredColoursTextRegExp).nullish(),
  "heading": zod.string().regex(saveEmailStyle200ResponseStoredColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(saveEmailStyle200ResponseStoredColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(saveEmailStyle200ResponseStoredColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(saveEmailStyle200ResponseStoredColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(saveEmailStyle200ResponseStoredColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(saveEmailStyle200ResponseStoredColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(saveEmailStyle200ResponseStoredColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(saveEmailStyle200ResponseStoredColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(saveEmailStyle200ResponseStoredButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(saveEmailStyle200ResponseStoredFooterTextMax).nullish()
}).nullish()
}),
  "tenantValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(saveEmailStyle200ResponseTenantValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(saveEmailStyle200ResponseTenantValuesLogoMaxHeightMin).max(saveEmailStyle200ResponseTenantValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(saveEmailStyle200ResponseTenantValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(saveEmailStyle200ResponseTenantValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(saveEmailStyle200ResponseTenantValuesFooterTextMax).nullish()
}).nullish()
}),
  "entityValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(saveEmailStyle200ResponseEntityValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(saveEmailStyle200ResponseEntityValuesLogoMaxHeightMin).max(saveEmailStyle200ResponseEntityValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(saveEmailStyle200ResponseEntityValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(saveEmailStyle200ResponseEntityValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(saveEmailStyle200ResponseEntityValuesFooterTextMax).nullish()
}).nullish()
}),
  "effective": zod.object({
  "version": zod.literal(1),
  "banner": zod.object({
  "mode": zod.enum(['none', 'colour', 'image']),
  "text": zod.string().max(saveEmailStyle200ResponseEffectiveBannerTextMax),
  "alignment": zod.enum(['left', 'centre']),
  "imageId": zod.uuid().nullable()
}),
  "logo": zod.object({
  "source": zod.enum(['app', 'uploaded', 'none']),
  "position": zod.enum(['left', 'centre']),
  "maxHeight": zod.int().min(saveEmailStyle200ResponseEffectiveLogoMaxHeightMin).max(saveEmailStyle200ResponseEffectiveLogoMaxHeightMax),
  "imageId": zod.uuid().nullable()
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "headingFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18)])
}),
  "colours": zod.object({
  "pageBackground": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursPageBackgroundRegExp),
  "contentBackground": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursContentBackgroundRegExp),
  "text": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursTextRegExp),
  "heading": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursHeadingRegExp),
  "link": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursLinkRegExp),
  "bannerBackground": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursBannerBackgroundRegExp),
  "bannerText": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursBannerTextRegExp),
  "buttonBackground": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursButtonBackgroundRegExp),
  "buttonText": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursButtonTextRegExp),
  "footerBackground": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursFooterBackgroundRegExp),
  "footerText": zod.string().regex(saveEmailStyle200ResponseEffectiveColoursFooterTextRegExp)
}),
  "button": zod.object({
  "shape": zod.enum(['square', 'rounded', 'pill']),
  "label": zod.string().min(1).max(saveEmailStyle200ResponseEffectiveButtonLabelMax)
}),
  "footer": zod.object({
  "text": zod.string().max(saveEmailStyle200ResponseEffectiveFooterTextMax)
})
}),
  "source": zod.object({
  "banner": zod.object({
  "mode": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "alignment": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "logo": zod.object({
  "source": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "position": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "maxHeight": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "headingFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "baseSize": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "colours": zod.object({
  "pageBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "contentBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "heading": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "link": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerText": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "button": zod.object({
  "shape": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "label": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "footer": zod.object({
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
})
}),
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
}),
  "images": zod.object({
  "banner": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(saveEmailStyle200ResponseImagesBannerOneAltTextMax)
}),zod.null()]),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(saveEmailStyle200ResponseImagesLogoOneAltTextMax)
}),zod.null()])
}),
  "warnings": zod.array(zod.string())
}))()

export const SaveEmailStyle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveEmailStyle403Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetPublicEmailFontParams = /*#__PURE__*/ (() => zod.object({
  "font": zod.enum(['lato-400.woff2', 'lato-700.woff2'])
}))()

export const GetPublicEmailFont200Response = /*#__PURE__*/ (() => zod.unknown())()


export const HeadPublicEmailFontParams = /*#__PURE__*/ (() => zod.object({
  "font": zod.enum(['lato-400.woff2', 'lato-700.woff2'])
}))()

export const HeadPublicEmailFont200Response = /*#__PURE__*/ (() => zod.unknown())()


export const PreviewEmailStyleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const previewEmailStyleQueryScopeDefault = `entity`;
export const previewEmailStyleQueryAuthorityDefault = `tenant`;

export const PreviewEmailStyleQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(previewEmailStyleQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(previewEmailStyleQueryAuthorityDefault)
}))()

export const previewEmailStyleHeaderXGroupGraphTokenMax = 16384;


export const previewEmailStyleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewEmailStyleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewEmailStyleHeaderXGroupGraphTokenMax).regex(previewEmailStyleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewEmailStyleBodyStyleDraftBannerTextMax = 120;

export const previewEmailStyleBodyStyleDraftLogoMaxHeightMin = 40;
export const previewEmailStyleBodyStyleDraftLogoMaxHeightMax = 120;

export const previewEmailStyleBodyStyleDraftColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewEmailStyleBodyStyleDraftButtonLabelMax = 40;

export const previewEmailStyleBodyStyleDraftFooterTextMax = 2000;



export const PreviewEmailStyleBody = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "styleDraft": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(previewEmailStyleBodyStyleDraftBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(previewEmailStyleBodyStyleDraftLogoMaxHeightMin).max(previewEmailStyleBodyStyleDraftLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(previewEmailStyleBodyStyleDraftColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(previewEmailStyleBodyStyleDraftColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(previewEmailStyleBodyStyleDraftColoursTextRegExp).nullish(),
  "heading": zod.string().regex(previewEmailStyleBodyStyleDraftColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(previewEmailStyleBodyStyleDraftColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(previewEmailStyleBodyStyleDraftColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(previewEmailStyleBodyStyleDraftColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(previewEmailStyleBodyStyleDraftColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(previewEmailStyleBodyStyleDraftColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(previewEmailStyleBodyStyleDraftColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(previewEmailStyleBodyStyleDraftColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(previewEmailStyleBodyStyleDraftButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(previewEmailStyleBodyStyleDraftFooterTextMax).nullish()
}).nullish()
})
}))()

export const previewEmailStyle200ResponseHtmlMax = 102399;



export const PreviewEmailStyle200Response = /*#__PURE__*/ (() => zod.object({
  "subject": zod.string(),
  "body": zod.string(),
  "html": zod.string().max(previewEmailStyle200ResponseHtmlMax),
  "plainText": zod.string()
}))()

export const PreviewEmailStyle400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewEmailStyle403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Upload an email banner or logo and replace its look reference
 */
export const UploadEmailStyleImageParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const uploadEmailStyleImageQueryAuthorityDefault = `tenant`;

export const UploadEmailStyleImageQueryParams = /*#__PURE__*/ (() => zod.object({
  "authority": zod.enum(['tenant', 'platform']).default(uploadEmailStyleImageQueryAuthorityDefault)
}))()

export const uploadEmailStyleImageHeaderXGroupGraphTokenMax = 16384;


export const uploadEmailStyleImageHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UploadEmailStyleImageHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(uploadEmailStyleImageHeaderXGroupGraphTokenMax).regex(uploadEmailStyleImageHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const uploadEmailStyleImageBodyImageBase64Max = 699052;

export const uploadEmailStyleImageBodyAltTextMax = 120;



export const UploadEmailStyleImageBody = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "kind": zod.enum(['banner', 'logo']),
  "contentType": zod.enum(['image/png', 'image/jpeg']),
  "imageBase64": zod.string().min(1).max(uploadEmailStyleImageBodyImageBase64Max),
  "altText": zod.string().min(1).max(uploadEmailStyleImageBodyAltTextMax)
}))()

export const uploadEmailStyleImage200ResponseStoredBannerTextMax = 120;

export const uploadEmailStyleImage200ResponseStoredLogoMaxHeightMin = 40;
export const uploadEmailStyleImage200ResponseStoredLogoMaxHeightMax = 120;

export const uploadEmailStyleImage200ResponseStoredColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseStoredButtonLabelMax = 40;

export const uploadEmailStyleImage200ResponseStoredFooterTextMax = 2000;

export const uploadEmailStyleImage200ResponseTenantValuesBannerTextMax = 120;

export const uploadEmailStyleImage200ResponseTenantValuesLogoMaxHeightMin = 40;
export const uploadEmailStyleImage200ResponseTenantValuesLogoMaxHeightMax = 120;

export const uploadEmailStyleImage200ResponseTenantValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseTenantValuesButtonLabelMax = 40;

export const uploadEmailStyleImage200ResponseTenantValuesFooterTextMax = 2000;

export const uploadEmailStyleImage200ResponseEntityValuesBannerTextMax = 120;

export const uploadEmailStyleImage200ResponseEntityValuesLogoMaxHeightMin = 40;
export const uploadEmailStyleImage200ResponseEntityValuesLogoMaxHeightMax = 120;

export const uploadEmailStyleImage200ResponseEntityValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEntityValuesButtonLabelMax = 40;

export const uploadEmailStyleImage200ResponseEntityValuesFooterTextMax = 2000;

export const uploadEmailStyleImage200ResponseEffectiveBannerTextMax = 120;

export const uploadEmailStyleImage200ResponseEffectiveLogoMaxHeightMin = 40;
export const uploadEmailStyleImage200ResponseEffectiveLogoMaxHeightMax = 120;

export const uploadEmailStyleImage200ResponseEffectiveColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const uploadEmailStyleImage200ResponseEffectiveButtonLabelMax = 40;

export const uploadEmailStyleImage200ResponseEffectiveFooterTextMax = 2000;

export const uploadEmailStyleImage200ResponseImagesBannerOneAltTextMax = 120;

export const uploadEmailStyleImage200ResponseImagesLogoOneAltTextMax = 120;



export const UploadEmailStyleImage200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "stored": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(uploadEmailStyleImage200ResponseStoredBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(uploadEmailStyleImage200ResponseStoredLogoMaxHeightMin).max(uploadEmailStyleImage200ResponseStoredLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursTextRegExp).nullish(),
  "heading": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(uploadEmailStyleImage200ResponseStoredColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(uploadEmailStyleImage200ResponseStoredButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(uploadEmailStyleImage200ResponseStoredFooterTextMax).nullish()
}).nullish()
}),
  "tenantValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(uploadEmailStyleImage200ResponseTenantValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(uploadEmailStyleImage200ResponseTenantValuesLogoMaxHeightMin).max(uploadEmailStyleImage200ResponseTenantValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(uploadEmailStyleImage200ResponseTenantValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(uploadEmailStyleImage200ResponseTenantValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(uploadEmailStyleImage200ResponseTenantValuesFooterTextMax).nullish()
}).nullish()
}),
  "entityValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(uploadEmailStyleImage200ResponseEntityValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(uploadEmailStyleImage200ResponseEntityValuesLogoMaxHeightMin).max(uploadEmailStyleImage200ResponseEntityValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(uploadEmailStyleImage200ResponseEntityValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(uploadEmailStyleImage200ResponseEntityValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(uploadEmailStyleImage200ResponseEntityValuesFooterTextMax).nullish()
}).nullish()
}),
  "effective": zod.object({
  "version": zod.literal(1),
  "banner": zod.object({
  "mode": zod.enum(['none', 'colour', 'image']),
  "text": zod.string().max(uploadEmailStyleImage200ResponseEffectiveBannerTextMax),
  "alignment": zod.enum(['left', 'centre']),
  "imageId": zod.uuid().nullable()
}),
  "logo": zod.object({
  "source": zod.enum(['app', 'uploaded', 'none']),
  "position": zod.enum(['left', 'centre']),
  "maxHeight": zod.int().min(uploadEmailStyleImage200ResponseEffectiveLogoMaxHeightMin).max(uploadEmailStyleImage200ResponseEffectiveLogoMaxHeightMax),
  "imageId": zod.uuid().nullable()
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "headingFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18)])
}),
  "colours": zod.object({
  "pageBackground": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursPageBackgroundRegExp),
  "contentBackground": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursContentBackgroundRegExp),
  "text": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursTextRegExp),
  "heading": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursHeadingRegExp),
  "link": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursLinkRegExp),
  "bannerBackground": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursBannerBackgroundRegExp),
  "bannerText": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursBannerTextRegExp),
  "buttonBackground": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursButtonBackgroundRegExp),
  "buttonText": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursButtonTextRegExp),
  "footerBackground": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursFooterBackgroundRegExp),
  "footerText": zod.string().regex(uploadEmailStyleImage200ResponseEffectiveColoursFooterTextRegExp)
}),
  "button": zod.object({
  "shape": zod.enum(['square', 'rounded', 'pill']),
  "label": zod.string().min(1).max(uploadEmailStyleImage200ResponseEffectiveButtonLabelMax)
}),
  "footer": zod.object({
  "text": zod.string().max(uploadEmailStyleImage200ResponseEffectiveFooterTextMax)
})
}),
  "source": zod.object({
  "banner": zod.object({
  "mode": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "alignment": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "logo": zod.object({
  "source": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "position": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "maxHeight": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "headingFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "baseSize": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "colours": zod.object({
  "pageBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "contentBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "heading": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "link": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerText": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "button": zod.object({
  "shape": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "label": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "footer": zod.object({
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
})
}),
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
}),
  "images": zod.object({
  "banner": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(uploadEmailStyleImage200ResponseImagesBannerOneAltTextMax)
}),zod.null()]),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(uploadEmailStyleImage200ResponseImagesLogoOneAltTextMax)
}),zod.null()])
}),
  "warnings": zod.array(zod.string())
}))()

export const UploadEmailStyleImage400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UploadEmailStyleImage403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Remove the uploaded image override and return to inheritance
 */
export const DeleteEmailStyleImageParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "kind": zod.enum(['banner', 'logo'])
}))()

export const deleteEmailStyleImageQueryScopeDefault = `entity`;
export const deleteEmailStyleImageQueryAuthorityDefault = `tenant`;

export const DeleteEmailStyleImageQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(deleteEmailStyleImageQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(deleteEmailStyleImageQueryAuthorityDefault)
}))()

export const deleteEmailStyleImageHeaderXGroupGraphTokenMax = 16384;


export const deleteEmailStyleImageHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteEmailStyleImageHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteEmailStyleImageHeaderXGroupGraphTokenMax).regex(deleteEmailStyleImageHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const deleteEmailStyleImage200ResponseStoredBannerTextMax = 120;

export const deleteEmailStyleImage200ResponseStoredLogoMaxHeightMin = 40;
export const deleteEmailStyleImage200ResponseStoredLogoMaxHeightMax = 120;

export const deleteEmailStyleImage200ResponseStoredColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseStoredButtonLabelMax = 40;

export const deleteEmailStyleImage200ResponseStoredFooterTextMax = 2000;

export const deleteEmailStyleImage200ResponseTenantValuesBannerTextMax = 120;

export const deleteEmailStyleImage200ResponseTenantValuesLogoMaxHeightMin = 40;
export const deleteEmailStyleImage200ResponseTenantValuesLogoMaxHeightMax = 120;

export const deleteEmailStyleImage200ResponseTenantValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseTenantValuesButtonLabelMax = 40;

export const deleteEmailStyleImage200ResponseTenantValuesFooterTextMax = 2000;

export const deleteEmailStyleImage200ResponseEntityValuesBannerTextMax = 120;

export const deleteEmailStyleImage200ResponseEntityValuesLogoMaxHeightMin = 40;
export const deleteEmailStyleImage200ResponseEntityValuesLogoMaxHeightMax = 120;

export const deleteEmailStyleImage200ResponseEntityValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEntityValuesButtonLabelMax = 40;

export const deleteEmailStyleImage200ResponseEntityValuesFooterTextMax = 2000;

export const deleteEmailStyleImage200ResponseEffectiveBannerTextMax = 120;

export const deleteEmailStyleImage200ResponseEffectiveLogoMaxHeightMin = 40;
export const deleteEmailStyleImage200ResponseEffectiveLogoMaxHeightMax = 120;

export const deleteEmailStyleImage200ResponseEffectiveColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const deleteEmailStyleImage200ResponseEffectiveButtonLabelMax = 40;

export const deleteEmailStyleImage200ResponseEffectiveFooterTextMax = 2000;

export const deleteEmailStyleImage200ResponseImagesBannerOneAltTextMax = 120;

export const deleteEmailStyleImage200ResponseImagesLogoOneAltTextMax = 120;



export const DeleteEmailStyleImage200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "stored": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(deleteEmailStyleImage200ResponseStoredBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(deleteEmailStyleImage200ResponseStoredLogoMaxHeightMin).max(deleteEmailStyleImage200ResponseStoredLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursTextRegExp).nullish(),
  "heading": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(deleteEmailStyleImage200ResponseStoredColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(deleteEmailStyleImage200ResponseStoredButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(deleteEmailStyleImage200ResponseStoredFooterTextMax).nullish()
}).nullish()
}),
  "tenantValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(deleteEmailStyleImage200ResponseTenantValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(deleteEmailStyleImage200ResponseTenantValuesLogoMaxHeightMin).max(deleteEmailStyleImage200ResponseTenantValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(deleteEmailStyleImage200ResponseTenantValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(deleteEmailStyleImage200ResponseTenantValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(deleteEmailStyleImage200ResponseTenantValuesFooterTextMax).nullish()
}).nullish()
}),
  "entityValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(deleteEmailStyleImage200ResponseEntityValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(deleteEmailStyleImage200ResponseEntityValuesLogoMaxHeightMin).max(deleteEmailStyleImage200ResponseEntityValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(deleteEmailStyleImage200ResponseEntityValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(deleteEmailStyleImage200ResponseEntityValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(deleteEmailStyleImage200ResponseEntityValuesFooterTextMax).nullish()
}).nullish()
}),
  "effective": zod.object({
  "version": zod.literal(1),
  "banner": zod.object({
  "mode": zod.enum(['none', 'colour', 'image']),
  "text": zod.string().max(deleteEmailStyleImage200ResponseEffectiveBannerTextMax),
  "alignment": zod.enum(['left', 'centre']),
  "imageId": zod.uuid().nullable()
}),
  "logo": zod.object({
  "source": zod.enum(['app', 'uploaded', 'none']),
  "position": zod.enum(['left', 'centre']),
  "maxHeight": zod.int().min(deleteEmailStyleImage200ResponseEffectiveLogoMaxHeightMin).max(deleteEmailStyleImage200ResponseEffectiveLogoMaxHeightMax),
  "imageId": zod.uuid().nullable()
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "headingFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18)])
}),
  "colours": zod.object({
  "pageBackground": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursPageBackgroundRegExp),
  "contentBackground": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursContentBackgroundRegExp),
  "text": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursTextRegExp),
  "heading": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursHeadingRegExp),
  "link": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursLinkRegExp),
  "bannerBackground": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursBannerBackgroundRegExp),
  "bannerText": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursBannerTextRegExp),
  "buttonBackground": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursButtonBackgroundRegExp),
  "buttonText": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursButtonTextRegExp),
  "footerBackground": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursFooterBackgroundRegExp),
  "footerText": zod.string().regex(deleteEmailStyleImage200ResponseEffectiveColoursFooterTextRegExp)
}),
  "button": zod.object({
  "shape": zod.enum(['square', 'rounded', 'pill']),
  "label": zod.string().min(1).max(deleteEmailStyleImage200ResponseEffectiveButtonLabelMax)
}),
  "footer": zod.object({
  "text": zod.string().max(deleteEmailStyleImage200ResponseEffectiveFooterTextMax)
})
}),
  "source": zod.object({
  "banner": zod.object({
  "mode": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "alignment": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "logo": zod.object({
  "source": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "position": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "maxHeight": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "headingFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "baseSize": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "colours": zod.object({
  "pageBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "contentBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "heading": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "link": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerText": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "button": zod.object({
  "shape": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "label": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "footer": zod.object({
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
})
}),
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
}),
  "images": zod.object({
  "banner": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(deleteEmailStyleImage200ResponseImagesBannerOneAltTextMax)
}),zod.null()]),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(deleteEmailStyleImage200ResponseImagesLogoOneAltTextMax)
}),zod.null()])
}),
  "warnings": zod.array(zod.string())
}))()

export const DeleteEmailStyleImage403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read a publicly linked email image
 */
export const getPublicEmailImagePathTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const GetPublicEmailImageParams = /*#__PURE__*/ (() => zod.object({
  "token": zod.string().regex(getPublicEmailImagePathTokenRegExp)
}))()

export const GetPublicEmailImage200Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetPublicEmailImage304Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetPublicEmailImage404Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetPublicEmailImage429Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read public email image headers
 */
export const headPublicEmailImagePathTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const HeadPublicEmailImageParams = /*#__PURE__*/ (() => zod.object({
  "token": zod.string().regex(headPublicEmailImagePathTokenRegExp)
}))()

export const HeadPublicEmailImage200Response = /*#__PURE__*/ (() => zod.unknown())()

export const HeadPublicEmailImage304Response = /*#__PURE__*/ (() => zod.unknown())()

export const HeadPublicEmailImage404Response = /*#__PURE__*/ (() => zod.unknown())()

export const HeadPublicEmailImage429Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Returns only visual configuration. Unknown, unavailable and switched-off organisations receive the same neutral response so addresses cannot be probed.
 * @summary Read the brand-safe look for public pages and the browser tab
 */
export const getPublicBrandPathTenantSlugRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9-]{0,127}$');


export const GetPublicBrandParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string().regex(getPublicBrandPathTenantSlugRegExp).describe('Organisation address (alias, base slug or id).')
}))()

export const getPublicBrand200ResponseSkinOneVersionMax = 1;

export const getPublicBrand200ResponseSkinOneLightNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneLightRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkSidebarBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationItemBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationItemForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationActiveBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkNavigationActiveForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnSecondaryRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnPopoverRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnAccentSurfaceRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnDestructiveRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnSuccessRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnWarningRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkOnInfoRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkInputRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneDarkRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneTypographyWeightsMax = 4;

export const getPublicBrand200ResponseSkinOneTypographyScaleXsSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScaleXsSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScaleXsLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScaleSmSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScaleSmSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScaleSmLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScaleBaseSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScaleBaseSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScaleBaseLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScaleLgSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScaleLgSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScaleLgLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScaleXlSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScaleXlSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScaleXlLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScale2xlSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScale2xlSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScale2xlLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneTypographyScale3xlSizeMin = 0.625;
export const getPublicBrand200ResponseSkinOneTypographyScale3xlSizeMax = 3;

export const getPublicBrand200ResponseSkinOneTypographyScale3xlLineHeightMax = 2;

export const getPublicBrand200ResponseSkinOneLogoMinWidthMin = 24;
export const getPublicBrand200ResponseSkinOneLogoMinWidthMax = 640;

export const getPublicBrand200ResponseSkinOneLogoClearSpaceMin = 0;
export const getPublicBrand200ResponseSkinOneLogoClearSpaceMax = 160;

export const getPublicBrand200ResponseSkinOneDecorationsCirclesColorsMax = 4;

export const getPublicBrand200ResponseSkinOneDecorationsCirclesTopStrokeMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsCirclesTopStrokeMax = 24;

export const getPublicBrand200ResponseSkinOneDecorationsCirclesBottomStrokeMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsCirclesBottomStrokeMax = 24;

export const getPublicBrand200ResponseSkinOneDecorationsCirclesOverlapMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsCirclesOverlapMax = 100;

export const getPublicBrand200ResponseSkinOneDecorationsCirclesCropMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsCirclesCropMax = 80;

export const getPublicBrand200ResponseSkinOneDecorationsHighlightThicknessMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsHighlightThicknessMax = 12;

export const getPublicBrand200ResponseSkinOneDecorationsHighlightWidthMin = 0;
export const getPublicBrand200ResponseSkinOneDecorationsHighlightWidthMax = 480;

export const getPublicBrand200ResponseSkinOneSurfacesControlRadiusMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesControlRadiusMax = 32;

export const getPublicBrand200ResponseSkinOneSurfacesCardRadiusMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesCardRadiusMax = 48;

export const getPublicBrand200ResponseSkinOneSurfacesOverlayRadiusMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesOverlayRadiusMax = 48;

export const getPublicBrand200ResponseSkinOneSurfacesRadiusSmMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesRadiusSmMax = 32;

export const getPublicBrand200ResponseSkinOneSurfacesRadiusMdMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesRadiusMdMax = 32;

export const getPublicBrand200ResponseSkinOneSurfacesRadiusLgMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesRadiusLgMax = 48;

export const getPublicBrand200ResponseSkinOneSurfacesRadiusXlMin = 0;
export const getPublicBrand200ResponseSkinOneSurfacesRadiusXlMax = 48;

export const getPublicBrand200ResponseSkinOneSurfacesRadiusFullMin = 999;
export const getPublicBrand200ResponseSkinOneSurfacesRadiusFullMax = 9999;

export const getPublicBrand200ResponseSkinOneStateHoverOpacityMin = 0;
export const getPublicBrand200ResponseSkinOneStateHoverOpacityMax = 0.24;

export const getPublicBrand200ResponseSkinOneStatePressedOpacityMin = 0;
export const getPublicBrand200ResponseSkinOneStatePressedOpacityMax = 0.32;

export const getPublicBrand200ResponseSkinOneStateDisabledOpacityMin = 0.38;
export const getPublicBrand200ResponseSkinOneStateDisabledOpacityMax = 0.6;

export const getPublicBrand200ResponseSkinOneStateFocusRingWidthMin = 2;
export const getPublicBrand200ResponseSkinOneStateFocusRingWidthMax = 4;

export const getPublicBrand200ResponseSkinOneStateFocusRingOffsetMin = 0;
export const getPublicBrand200ResponseSkinOneStateFocusRingOffsetMax = 4;

export const getPublicBrand200ResponseSkinOneMotionDurationFastMin = 0;
export const getPublicBrand200ResponseSkinOneMotionDurationFastMax = 300;

export const getPublicBrand200ResponseSkinOneMotionDurationBaseMin = 0;
export const getPublicBrand200ResponseSkinOneMotionDurationBaseMax = 500;

export const getPublicBrand200ResponseSkinOneIconsStrokeWidthMax = 3;
export const getPublicBrand200ResponseSkinOneIconsStrokeWidthMultipleOf = 0.25;

export const getPublicBrand200ResponseSkinOneMapLightSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapLightSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceBookedTeamStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceMineFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceMineStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceMineForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownAreaFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownAreaStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConfirmedFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSpaceConfirmedForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneAvailableFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneAvailableStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneBusyFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneBusyStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneNeutralFillRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkToneNeutralStrokeRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceAwayRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceDoNotDisturbRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceOfflineRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceAwayMarkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkPresenceForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCapacityGoodRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCapacityLimitedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCapacityFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCapacityForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusAvailableSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusFullRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusFullSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusUnknownRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusUnknownSelectedRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusPinForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusPinBorderRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkCampusSelectedRingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneFloorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneLabelRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneLabelForegroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneAvailableRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneBusyRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneNeutralRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneHighlightRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicBrand200ResponseSkinOneMapDarkSceneMarkerRegExp = new RegExp('^#[0-9a-fA-F]{6}$');


export const GetPublicBrand200Response = /*#__PURE__*/ (() => zod.object({
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "name": zod.string().nullable().describe('Customer display name; set only when a public switch is on.'),
  "logo": zod.object({
  "url": zod.string(),
  "altText": zod.string()
}).nullable(),
  "skin": zod.union([zod.object({
  "version": zod.int().min(1).max(getPublicBrand200ResponseSkinOneVersionMax),
  "light": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getPublicBrand200ResponseSkinOneLightSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getPublicBrand200ResponseSkinOneLightNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getPublicBrand200ResponseSkinOneLightSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getPublicBrand200ResponseSkinOneLightPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getPublicBrand200ResponseSkinOneLightAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getPublicBrand200ResponseSkinOneLightDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getPublicBrand200ResponseSkinOneLightSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getPublicBrand200ResponseSkinOneLightWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnWarningRegExp).nullish(),
  "info": zod.string().regex(getPublicBrand200ResponseSkinOneLightInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getPublicBrand200ResponseSkinOneLightOnInfoRegExp).nullish(),
  "input": zod.string().regex(getPublicBrand200ResponseSkinOneLightInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getPublicBrand200ResponseSkinOneLightRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "dark": zod.object({
  "primary": zod.string().nullish(),
  "onPrimary": zod.string().nullish(),
  "headerBackground": zod.string().nullish(),
  "headerForeground": zod.string().nullish(),
  "navigationBackground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationBackgroundRegExp).nullish().describe('Left navigation background, including the mobile drawer. If only text is set, a readable background is derived.'),
  "navigationForeground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationForegroundRegExp).nullish().describe('Left navigation text and icons. If omitted with a background, readable text is derived. Configured pairs require at least 4.5 to 1 contrast.'),
  "sidebarBackground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkSidebarBackgroundRegExp).nullish(),
  "navigationItemBackground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationItemBackgroundRegExp).nullish(),
  "navigationItemForeground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationItemForegroundRegExp).nullish(),
  "navigationActiveBackground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationActiveBackgroundRegExp).nullish(),
  "navigationActiveForeground": zod.string().regex(getPublicBrand200ResponseSkinOneDarkNavigationActiveForegroundRegExp).nullish(),
  "accent": zod.string().nullish(),
  "background": zod.string().nullish(),
  "foreground": zod.string().nullish(),
  "surface": zod.string().nullish(),
  "onSurface": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "onMuted": zod.string().nullish(),
  "border": zod.string().nullish(),
  "secondary": zod.string().regex(getPublicBrand200ResponseSkinOneDarkSecondaryRegExp).nullish().describe('Secondary button and badge surface. Absent keeps muted driving --secondary.'),
  "onSecondary": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnSecondaryRegExp).nullish(),
  "popover": zod.string().regex(getPublicBrand200ResponseSkinOneDarkPopoverRegExp).nullish().describe('Popover, menu and tooltip surface. Absent keeps surface.'),
  "onPopover": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnPopoverRegExp).nullish(),
  "accentSurface": zod.string().regex(getPublicBrand200ResponseSkinOneDarkAccentSurfaceRegExp).nullish().describe('Hover and selected surface for menu items, ghost buttons and tabs (--accent). Absent keeps muted.'),
  "onAccentSurface": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnAccentSurfaceRegExp).nullish(),
  "destructive": zod.string().regex(getPublicBrand200ResponseSkinOneDarkDestructiveRegExp).nullish(),
  "onDestructive": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnDestructiveRegExp).nullish(),
  "success": zod.string().regex(getPublicBrand200ResponseSkinOneDarkSuccessRegExp).nullish(),
  "onSuccess": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnSuccessRegExp).nullish(),
  "warning": zod.string().regex(getPublicBrand200ResponseSkinOneDarkWarningRegExp).nullish(),
  "onWarning": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnWarningRegExp).nullish(),
  "info": zod.string().regex(getPublicBrand200ResponseSkinOneDarkInfoRegExp).nullish(),
  "onInfo": zod.string().regex(getPublicBrand200ResponseSkinOneDarkOnInfoRegExp).nullish(),
  "input": zod.string().regex(getPublicBrand200ResponseSkinOneDarkInputRegExp).nullish().describe('Field border colour (--input).'),
  "ring": zod.string().regex(getPublicBrand200ResponseSkinOneDarkRingRegExp).nullish().describe('Focus indicator (--ring). Absent keeps primary.')
}).describe('Semantic colours for one colour theme.'),
  "palette": zod.object({
  "primary": zod.string().nullish(),
  "secondary": zod.string().nullish(),
  "accent": zod.string().nullish(),
  "muted": zod.string().nullish(),
  "subtle": zod.string().nullish(),
  "neutral": zod.string().nullish()
}).describe('Named supporting colours that decorative elements can reference.'),
  "typography": zod.object({
  "font": zod.union([zod.literal('app'),zod.literal('lato'),zod.literal(null)]).nullish(),
  "weights": zod.array(zod.enum(['regular', 'bold', 'heavy', 'italic'])).min(1).max(getPublicBrand200ResponseSkinOneTypographyWeightsMax).nullish(),
  "fallback": zod.union([zod.literal('calibri'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingWeight": zod.union([zod.literal('regular'),zod.literal('bold'),zod.literal('heavy'),zod.literal(null)]).nullish(),
  "scale": zod.object({
  "xs": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScaleXsSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScaleXsSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScaleXsLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "sm": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScaleSmSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScaleSmSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScaleSmLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "base": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScaleBaseSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScaleBaseSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScaleBaseLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "lg": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScaleLgSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScaleLgSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScaleLgLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "xl": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScaleXlSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScaleXlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScaleXlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "2xl": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScale2xlSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScale2xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScale2xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.'),
  "3xl": zod.object({
  "size": zod.number().min(getPublicBrand200ResponseSkinOneTypographyScale3xlSizeMin).max(getPublicBrand200ResponseSkinOneTypographyScale3xlSizeMax).nullish(),
  "lineHeight": zod.number().min(1).max(getPublicBrand200ResponseSkinOneTypographyScale3xlLineHeightMax).nullish()
}).optional().describe('One typography step; size in rem and unitless line height.')
}).optional()
}).describe('Approved typeface, supported weights and controlled fallback stack.'),
  "logo": zod.object({
  "showEntityName": zod.boolean().nullish().describe('Show tenant/entity context text in the header. Omitted values inherit, with visible as the app default. The logo and application identity remain unchanged.'),
  "minWidth": zod.int().min(getPublicBrand200ResponseSkinOneLogoMinWidthMin).max(getPublicBrand200ResponseSkinOneLogoMinWidthMax).nullish(),
  "clearSpace": zod.int().min(getPublicBrand200ResponseSkinOneLogoClearSpaceMin).max(getPublicBrand200ResponseSkinOneLogoClearSpaceMax).nullish(),
  "onDark": zod.union([zod.literal('as-uploaded'),zod.literal('light-plate'),zod.literal(null)]).nullish()
}).describe('Logo and adjacent header name presentation; logo content stays in the existing scoped logo storage.'),
  "decorations": zod.object({
  "enabled": zod.boolean().nullish(),
  "circles": zod.object({
  "enabled": zod.boolean().nullish(),
  "colors": zod.array(zod.enum(['primary', 'secondary', 'accent', 'muted', 'subtle', 'neutral'])).min(1).max(getPublicBrand200ResponseSkinOneDecorationsCirclesColorsMax).nullish(),
  "topStroke": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsCirclesTopStrokeMin).max(getPublicBrand200ResponseSkinOneDecorationsCirclesTopStrokeMax).nullish(),
  "bottomStroke": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsCirclesBottomStrokeMin).max(getPublicBrand200ResponseSkinOneDecorationsCirclesBottomStrokeMax).nullish(),
  "overlap": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsCirclesOverlapMin).max(getPublicBrand200ResponseSkinOneDecorationsCirclesOverlapMax).nullish(),
  "crop": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsCirclesCropMin).max(getPublicBrand200ResponseSkinOneDecorationsCirclesCropMax).nullish(),
  "placement": zod.union([zod.literal('home'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Overlapping-circle decoration, bounded to safe measurements.'),
  "highlight": zod.object({
  "enabled": zod.boolean().nullish(),
  "color": zod.string().nullish(),
  "thickness": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsHighlightThicknessMin).max(getPublicBrand200ResponseSkinOneDecorationsHighlightThicknessMax).nullish(),
  "width": zod.number().min(getPublicBrand200ResponseSkinOneDecorationsHighlightWidthMin).max(getPublicBrand200ResponseSkinOneDecorationsHighlightWidthMax).nullish(),
  "placement": zod.union([zod.literal('main-title'),zod.literal('none'),zod.literal(null)]).nullish()
}).describe('Short accent line under main page titles.')
}),
  "surfaces": zod.object({
  "controlRadius": zod.number().min(getPublicBrand200ResponseSkinOneSurfacesControlRadiusMin).max(getPublicBrand200ResponseSkinOneSurfacesControlRadiusMax).nullish(),
  "cardRadius": zod.number().min(getPublicBrand200ResponseSkinOneSurfacesCardRadiusMin).max(getPublicBrand200ResponseSkinOneSurfacesCardRadiusMax).nullish(),
  "overlayRadius": zod.number().min(getPublicBrand200ResponseSkinOneSurfacesOverlayRadiusMin).max(getPublicBrand200ResponseSkinOneSurfacesOverlayRadiusMax).nullish(),
  "density": zod.union([zod.literal('compact'),zod.literal('comfortable'),zod.literal(null)]).nullish(),
  "shadow": zod.union([zod.literal('none'),zod.literal('soft'),zod.literal('raised'),zod.literal(null)]).nullish(),
  "treatment": zod.union([zod.literal('flat'),zod.literal('bordered'),zod.literal('elevated'),zod.literal(null)]).nullish(),
  "radius": zod.object({
  "sm": zod.int().min(getPublicBrand200ResponseSkinOneSurfacesRadiusSmMin).max(getPublicBrand200ResponseSkinOneSurfacesRadiusSmMax).nullish(),
  "md": zod.int().min(getPublicBrand200ResponseSkinOneSurfacesRadiusMdMin).max(getPublicBrand200ResponseSkinOneSurfacesRadiusMdMax).nullish(),
  "lg": zod.int().min(getPublicBrand200ResponseSkinOneSurfacesRadiusLgMin).max(getPublicBrand200ResponseSkinOneSurfacesRadiusLgMax).nullish(),
  "xl": zod.int().min(getPublicBrand200ResponseSkinOneSurfacesRadiusXlMin).max(getPublicBrand200ResponseSkinOneSurfacesRadiusXlMax).nullish(),
  "full": zod.int().min(getPublicBrand200ResponseSkinOneSurfacesRadiusFullMin).max(getPublicBrand200ResponseSkinOneSurfacesRadiusFullMax).nullish()
}).optional().describe('Pixel radius scale. Setting md alone derives sm, lg and xl as md-2, md+2 and md+6.')
}).optional(),
  "state": zod.object({
  "hoverOpacity": zod.number().min(getPublicBrand200ResponseSkinOneStateHoverOpacityMin).max(getPublicBrand200ResponseSkinOneStateHoverOpacityMax).nullish(),
  "pressedOpacity": zod.number().min(getPublicBrand200ResponseSkinOneStatePressedOpacityMin).max(getPublicBrand200ResponseSkinOneStatePressedOpacityMax).nullish(),
  "disabledOpacity": zod.number().min(getPublicBrand200ResponseSkinOneStateDisabledOpacityMin).max(getPublicBrand200ResponseSkinOneStateDisabledOpacityMax).nullish(),
  "focusRingWidth": zod.int().min(getPublicBrand200ResponseSkinOneStateFocusRingWidthMin).max(getPublicBrand200ResponseSkinOneStateFocusRingWidthMax).nullish(),
  "focusRingOffset": zod.int().min(getPublicBrand200ResponseSkinOneStateFocusRingOffsetMin).max(getPublicBrand200ResponseSkinOneStateFocusRingOffsetMax).nullish()
}).optional().describe('Interaction state tokens. Absent values keep each kit component\'s current behaviour.'),
  "motion": zod.object({
  "durationFast": zod.int().min(getPublicBrand200ResponseSkinOneMotionDurationFastMin).max(getPublicBrand200ResponseSkinOneMotionDurationFastMax).nullish(),
  "durationBase": zod.int().min(getPublicBrand200ResponseSkinOneMotionDurationBaseMin).max(getPublicBrand200ResponseSkinOneMotionDurationBaseMax).nullish(),
  "easing": zod.union([zod.literal('standard'),zod.literal('emphasized'),zod.literal('linear'),zod.literal(null)]).nullish()
}).optional(),
  "icons": zod.object({
  "strokeWidth": zod.number().min(1).max(getPublicBrand200ResponseSkinOneIconsStrokeWidthMax).multipleOf(getPublicBrand200ResponseSkinOneIconsStrokeWidthMultipleOf).nullish()
}).optional(),
  "map": zod.object({
  "light": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getPublicBrand200ResponseSkinOneMapLightSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.'),
  "dark": zod.object({
  "space": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceAvailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "selected": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceSelectedAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "considering": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringAreaStrokeRegExp).nullish(),
  "ring": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConsideringRingRegExp).nullish()
}).optional(),
  "booked": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedAreaStrokeRegExp).nullish(),
  "teamStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceBookedTeamStrokeRegExp).nullish()
}).optional(),
  "mine": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceMineFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceMineStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceMineForegroundRegExp).nullish()
}).optional().describe('Booked by me. Absent values follow the customer accent pair, then primary.'),
  "teammate": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceTeammateForegroundRegExp).nullish()
}).optional().describe('Booked by a visible workgroup teammate. Absent values use the platform teammate default.'),
  "unavailable": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnavailableAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "unknown": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownStrokeRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownForegroundRegExp).nullish(),
  "areaFill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownAreaFillRegExp).nullish(),
  "areaStroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceUnknownAreaStrokeRegExp).nullish()
}).optional().describe('Dot badge (fill, stroke, foreground) and floor-outline (areaFill, areaStroke) colours for one space state.'),
  "confirmed": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConfirmedFillRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSpaceConfirmedForegroundRegExp).nullish()
}).optional()
}).optional(),
  "tone": zod.object({
  "available": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneAvailableFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneAvailableStrokeRegExp).nullish()
}).optional(),
  "busy": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneBusyFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneBusyStrokeRegExp).nullish()
}).optional(),
  "neutral": zod.object({
  "fill": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneNeutralFillRegExp).nullish(),
  "stroke": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkToneNeutralStrokeRegExp).nullish()
}).optional()
}).optional(),
  "presence": zod.object({
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceAvailableRegExp).nullish(),
  "busy": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceBusyRegExp).nullish(),
  "away": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceAwayRegExp).nullish(),
  "doNotDisturb": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceDoNotDisturbRegExp).nullish(),
  "offline": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceOfflineRegExp).nullish(),
  "awayMark": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceAwayMarkRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkPresenceForegroundRegExp).nullish()
}).optional(),
  "capacity": zod.object({
  "good": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCapacityGoodRegExp).nullish(),
  "limited": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCapacityLimitedRegExp).nullish(),
  "full": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCapacityFullRegExp).nullish(),
  "foreground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCapacityForegroundRegExp).nullish()
}).optional(),
  "campus": zod.object({
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusAvailableRegExp).nullish(),
  "availableSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusAvailableSelectedRegExp).nullish(),
  "full": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusFullRegExp).nullish(),
  "fullSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusFullSelectedRegExp).nullish(),
  "unknown": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusUnknownRegExp).nullish(),
  "unknownSelected": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusUnknownSelectedRegExp).nullish(),
  "pinForeground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusPinForegroundRegExp).nullish(),
  "pinBorder": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusPinBorderRegExp).nullish(),
  "selectedRing": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkCampusSelectedRingRegExp).nullish()
}).optional(),
  "scene": zod.object({
  "background": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneBackgroundRegExp).nullish(),
  "floor": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneFloorRegExp).nullish(),
  "label": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneLabelRegExp).nullish(),
  "labelForeground": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneLabelForegroundRegExp).nullish(),
  "available": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneAvailableRegExp).nullish(),
  "busy": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneBusyRegExp).nullish(),
  "neutral": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneNeutralRegExp).nullish(),
  "highlight": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneHighlightRegExp).nullish(),
  "marker": zod.string().regex(getPublicBrand200ResponseSkinOneMapDarkSceneMarkerRegExp).nullish()
}).optional()
}).describe('Floor-plan and map colours for one colour mode. Every leaf is an optional six-digit hex colour; absent leaves use the platform defaults.')
}).optional().describe('Merged tenant and entity map colours per mode, with outline colours falling back to the same state\'s dot colours. Platform defaults are applied by the renderer.'),
  "applyScope": zod.object({
  "header": zod.boolean(),
  "navigation": zod.boolean(),
  "controls": zod.boolean(),
  "cards": zod.boolean(),
  "decorations": zod.boolean(),
  "mobile": zod.boolean(),
  "maps": zod.boolean(),
  "publicPages": zod.boolean(),
  "browserIdentity": zod.boolean(),
  "emails": zod.boolean().nullable()
}).optional().describe('Resolved brand scope. Signed-in areas and maps default on, public pages and browser identity off; emails null follows the email style setting.')
}),zod.null()]).describe('Resolved visual skin; set only when public pages carry the brand.')
}))()

export const getPublicBrand400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin = 0;

export const getPublicBrand400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin = 0;


export const getPublicBrand400ResponseOverlapWarningAcknowledgementMin = 16;
export const getPublicBrand400ResponseOverlapWarningAcknowledgementMax = 256;


export const getPublicBrand400ResponsePolicyRequirementsMissingRulesMax = 1000;



export const GetPublicBrand400Response = /*#__PURE__*/ (() => zod.object({
  "error": zod.string(),
  "code": zod.string().optional(),
  "overlapWarning": zod.object({
  "bookedForUserId": zod.uuid(),
  "beneficiaryName": zod.string(),
  "overlaps": zod.array(zod.object({
  "proposed": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPublicBrand400ResponseOverlapWarningOverlapsItemProposedProposedIndexMin).optional(),
  "status": zod.string().optional()
}),
  "overlapping": zod.object({
  "spaceId": zod.uuid(),
  "spaceName": zod.string(),
  "spaceTypeId": zod.uuid(),
  "spaceTypeName": zod.string(),
  "start": zod.iso.datetime({"offset":true}),
  "end": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "bookingId": zod.uuid().optional(),
  "proposedIndex": zod.int().min(getPublicBrand400ResponseOverlapWarningOverlapsItemOverlappingProposedIndexMin).optional(),
  "status": zod.string().optional()
})
})).min(1),
  "acknowledgement": zod.string().min(getPublicBrand400ResponseOverlapWarningAcknowledgementMin).max(getPublicBrand400ResponseOverlapWarningAcknowledgementMax)
}).optional(),
  "policyRequirements": zod.object({
  "spaceId": zod.uuid(),
  "beneficiaryUserId": zod.uuid(),
  "revision": zod.string(),
  "legacySiteId": zod.uuid().nullish(),
  "missingRules": zod.array(zod.object({
  "ruleId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string()
})).max(getPublicBrand400ResponsePolicyRequirementsMissingRulesMax)
}).optional().describe('Current missing requirements for the booking beneficiary. Acceptance must be submitted by that person; this response grants no access and is not a write token.')
}).describe('BOOKING_OVERLAP_CONFIRMATION_REQUIRED (409) acknowledges only different-space same-type beneficiary overlaps; BOOKING_CONFLICT remains blocking.'))()

export const GetPublicBrand429Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Unlock email look groups for organisations (tenant scope only)
 */
export const UpdateEmailStylePermissionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const updateEmailStylePermissionsQueryScopeDefault = `tenant`;
export const updateEmailStylePermissionsQueryAuthorityDefault = `tenant`;

export const UpdateEmailStylePermissionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(updateEmailStylePermissionsQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(updateEmailStylePermissionsQueryAuthorityDefault)
}))()

export const updateEmailStylePermissionsHeaderXGroupGraphTokenMax = 16384;


export const updateEmailStylePermissionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateEmailStylePermissionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateEmailStylePermissionsHeaderXGroupGraphTokenMax).regex(updateEmailStylePermissionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const UpdateEmailStylePermissionsBody = /*#__PURE__*/ (() => zod.object({
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
})
}))()

export const updateEmailStylePermissions200ResponseStoredBannerTextMax = 120;

export const updateEmailStylePermissions200ResponseStoredLogoMaxHeightMin = 40;
export const updateEmailStylePermissions200ResponseStoredLogoMaxHeightMax = 120;

export const updateEmailStylePermissions200ResponseStoredColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseStoredButtonLabelMax = 40;

export const updateEmailStylePermissions200ResponseStoredFooterTextMax = 2000;

export const updateEmailStylePermissions200ResponseTenantValuesBannerTextMax = 120;

export const updateEmailStylePermissions200ResponseTenantValuesLogoMaxHeightMin = 40;
export const updateEmailStylePermissions200ResponseTenantValuesLogoMaxHeightMax = 120;

export const updateEmailStylePermissions200ResponseTenantValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseTenantValuesButtonLabelMax = 40;

export const updateEmailStylePermissions200ResponseTenantValuesFooterTextMax = 2000;

export const updateEmailStylePermissions200ResponseEntityValuesBannerTextMax = 120;

export const updateEmailStylePermissions200ResponseEntityValuesLogoMaxHeightMin = 40;
export const updateEmailStylePermissions200ResponseEntityValuesLogoMaxHeightMax = 120;

export const updateEmailStylePermissions200ResponseEntityValuesColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEntityValuesButtonLabelMax = 40;

export const updateEmailStylePermissions200ResponseEntityValuesFooterTextMax = 2000;

export const updateEmailStylePermissions200ResponseEffectiveBannerTextMax = 120;

export const updateEmailStylePermissions200ResponseEffectiveLogoMaxHeightMin = 40;
export const updateEmailStylePermissions200ResponseEffectiveLogoMaxHeightMax = 120;

export const updateEmailStylePermissions200ResponseEffectiveColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateEmailStylePermissions200ResponseEffectiveButtonLabelMax = 40;

export const updateEmailStylePermissions200ResponseEffectiveFooterTextMax = 2000;

export const updateEmailStylePermissions200ResponseImagesBannerOneAltTextMax = 120;

export const updateEmailStylePermissions200ResponseImagesLogoOneAltTextMax = 120;



export const UpdateEmailStylePermissions200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "stored": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(updateEmailStylePermissions200ResponseStoredBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(updateEmailStylePermissions200ResponseStoredLogoMaxHeightMin).max(updateEmailStylePermissions200ResponseStoredLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursTextRegExp).nullish(),
  "heading": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(updateEmailStylePermissions200ResponseStoredColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(updateEmailStylePermissions200ResponseStoredButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(updateEmailStylePermissions200ResponseStoredFooterTextMax).nullish()
}).nullish()
}),
  "tenantValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(updateEmailStylePermissions200ResponseTenantValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(updateEmailStylePermissions200ResponseTenantValuesLogoMaxHeightMin).max(updateEmailStylePermissions200ResponseTenantValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(updateEmailStylePermissions200ResponseTenantValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(updateEmailStylePermissions200ResponseTenantValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(updateEmailStylePermissions200ResponseTenantValuesFooterTextMax).nullish()
}).nullish()
}),
  "entityValues": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(updateEmailStylePermissions200ResponseEntityValuesBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(updateEmailStylePermissions200ResponseEntityValuesLogoMaxHeightMin).max(updateEmailStylePermissions200ResponseEntityValuesLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursTextRegExp).nullish(),
  "heading": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(updateEmailStylePermissions200ResponseEntityValuesColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(updateEmailStylePermissions200ResponseEntityValuesButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(updateEmailStylePermissions200ResponseEntityValuesFooterTextMax).nullish()
}).nullish()
}),
  "effective": zod.object({
  "version": zod.literal(1),
  "banner": zod.object({
  "mode": zod.enum(['none', 'colour', 'image']),
  "text": zod.string().max(updateEmailStylePermissions200ResponseEffectiveBannerTextMax),
  "alignment": zod.enum(['left', 'centre']),
  "imageId": zod.uuid().nullable()
}),
  "logo": zod.object({
  "source": zod.enum(['app', 'uploaded', 'none']),
  "position": zod.enum(['left', 'centre']),
  "maxHeight": zod.int().min(updateEmailStylePermissions200ResponseEffectiveLogoMaxHeightMin).max(updateEmailStylePermissions200ResponseEffectiveLogoMaxHeightMax),
  "imageId": zod.uuid().nullable()
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "headingFont": zod.enum(['lato', 'calibri', 'arial', 'verdana', 'georgia', 'trebuchet', 'system']),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18)])
}),
  "colours": zod.object({
  "pageBackground": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursPageBackgroundRegExp),
  "contentBackground": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursContentBackgroundRegExp),
  "text": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursTextRegExp),
  "heading": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursHeadingRegExp),
  "link": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursLinkRegExp),
  "bannerBackground": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursBannerBackgroundRegExp),
  "bannerText": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursBannerTextRegExp),
  "buttonBackground": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursButtonBackgroundRegExp),
  "buttonText": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursButtonTextRegExp),
  "footerBackground": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursFooterBackgroundRegExp),
  "footerText": zod.string().regex(updateEmailStylePermissions200ResponseEffectiveColoursFooterTextRegExp)
}),
  "button": zod.object({
  "shape": zod.enum(['square', 'rounded', 'pill']),
  "label": zod.string().min(1).max(updateEmailStylePermissions200ResponseEffectiveButtonLabelMax)
}),
  "footer": zod.object({
  "text": zod.string().max(updateEmailStylePermissions200ResponseEffectiveFooterTextMax)
})
}),
  "source": zod.object({
  "banner": zod.object({
  "mode": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "alignment": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "logo": zod.object({
  "source": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "position": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "maxHeight": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "imageId": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "typography": zod.object({
  "bodyFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "headingFont": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "baseSize": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "colours": zod.object({
  "pageBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "contentBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "heading": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "link": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "bannerText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "buttonText": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerBackground": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "footerText": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "button": zod.object({
  "shape": zod.enum(['entity', 'tenant', 'app_branding', 'default']),
  "label": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
}),
  "footer": zod.object({
  "text": zod.enum(['entity', 'tenant', 'app_branding', 'default'])
})
}),
  "allowEntityOverrides": zod.object({
  "emailBanner": zod.boolean().optional(),
  "emailLogo": zod.boolean().optional(),
  "emailTypography": zod.boolean().optional(),
  "emailColours": zod.boolean().optional(),
  "emailButton": zod.boolean().optional(),
  "emailFooter": zod.boolean().optional()
}),
  "images": zod.object({
  "banner": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(updateEmailStylePermissions200ResponseImagesBannerOneAltTextMax)
}),zod.null()]),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "url": zod.string().nullable(),
  "altText": zod.string().max(updateEmailStylePermissions200ResponseImagesLogoOneAltTextMax)
}),zod.null()])
}),
  "warnings": zod.array(zod.string())
}))()

export const UpdateEmailStylePermissions400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateEmailStylePermissions403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Scope defaults to entity. Parent tenant scope requires explicit tenant administrator authority.
 * @summary Read effective customer emails for an entity or its parent tenant
 */
export const ListTenantEmailTemplatesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listTenantEmailTemplatesQueryScopeDefault = `entity`;

export const ListTenantEmailTemplatesQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(listTenantEmailTemplatesQueryScopeDefault)
}))()

export const listTenantEmailTemplatesHeaderXGroupGraphTokenMax = 16384;


export const listTenantEmailTemplatesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListTenantEmailTemplatesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listTenantEmailTemplatesHeaderXGroupGraphTokenMax).regex(listTenantEmailTemplatesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listTenantEmailTemplates200ResponseItemsMax = 10;



export const ListTenantEmailTemplates200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "allowEntityOverrides": zod.object({
  "booking_confirmed": zod.boolean().optional(),
  "booking_modified": zod.boolean().optional(),
  "booking_cancelled": zod.boolean().optional(),
  "booking_auto_released": zod.boolean().optional(),
  "booking_reminder": zod.boolean().optional(),
  "check_in_prompt": zod.boolean().optional(),
  "auto_release_warning": zod.boolean().optional(),
  "resource_unavailable": zod.boolean().optional(),
  "visitor_arrival": zod.boolean().optional(),
  "visitor_approval": zod.boolean().optional()
}),
  "items": zod.array(zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})).max(listTenantEmailTemplates200ResponseItemsMax)
}))()

export const ListTenantEmailTemplates403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Save tenant wording or an unlocked entity override
 */
export const SaveTenantEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval'])
}))()

export const saveTenantEmailTemplateQueryScopeDefault = `entity`;

export const SaveTenantEmailTemplateQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(saveTenantEmailTemplateQueryScopeDefault)
}))()

export const saveTenantEmailTemplateHeaderXGroupGraphTokenMax = 16384;


export const saveTenantEmailTemplateHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveTenantEmailTemplateHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveTenantEmailTemplateHeaderXGroupGraphTokenMax).regex(saveTenantEmailTemplateHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveTenantEmailTemplateBodySubjectMax = 200;

export const saveTenantEmailTemplateBodyBodyMax = 10000;

export const saveTenantEmailTemplateBodyFormatDefault = `plain`;

export const SaveTenantEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "subject": zod.string().min(1).max(saveTenantEmailTemplateBodySubjectMax),
  "body": zod.string().min(1).max(saveTenantEmailTemplateBodyBodyMax),
  "format": zod.enum(['plain', 'formatted']).default(saveTenantEmailTemplateBodyFormatDefault)
}))()

export const SaveTenantEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const SaveTenantEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveTenantEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Remove an override and inherit the parent wording
 */
export const ResetTenantEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval'])
}))()

export const resetTenantEmailTemplateQueryScopeDefault = `entity`;

export const ResetTenantEmailTemplateQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(resetTenantEmailTemplateQueryScopeDefault)
}))()

export const resetTenantEmailTemplateHeaderXGroupGraphTokenMax = 16384;


export const resetTenantEmailTemplateHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ResetTenantEmailTemplateHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(resetTenantEmailTemplateHeaderXGroupGraphTokenMax).regex(resetTenantEmailTemplateHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const ResetTenantEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))()

export const ResetTenantEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Allow or lock entity customisation of individual emails (tenant scope only)
 */
export const UpdateEmailTemplatePermissionsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const updateEmailTemplatePermissionsQueryScopeDefault = `tenant`;

export const UpdateEmailTemplatePermissionsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(updateEmailTemplatePermissionsQueryScopeDefault).describe('Permissions belong to the tenant. Entity scope is refused.')
}))()

export const updateEmailTemplatePermissionsHeaderXGroupGraphTokenMax = 16384;


export const updateEmailTemplatePermissionsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateEmailTemplatePermissionsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateEmailTemplatePermissionsHeaderXGroupGraphTokenMax).regex(updateEmailTemplatePermissionsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const UpdateEmailTemplatePermissionsBody = /*#__PURE__*/ (() => zod.object({
  "allowEntityOverrides": zod.object({
  "booking_confirmed": zod.boolean().optional(),
  "booking_modified": zod.boolean().optional(),
  "booking_cancelled": zod.boolean().optional(),
  "booking_auto_released": zod.boolean().optional(),
  "booking_reminder": zod.boolean().optional(),
  "check_in_prompt": zod.boolean().optional(),
  "auto_release_warning": zod.boolean().optional(),
  "resource_unavailable": zod.boolean().optional(),
  "visitor_arrival": zod.boolean().optional(),
  "visitor_approval": zod.boolean().optional()
})
}))()

export const updateEmailTemplatePermissions200ResponseItemsMax = 10;



export const UpdateEmailTemplatePermissions200Response = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "allowEntityOverrides": zod.object({
  "booking_confirmed": zod.boolean().optional(),
  "booking_modified": zod.boolean().optional(),
  "booking_cancelled": zod.boolean().optional(),
  "booking_auto_released": zod.boolean().optional(),
  "booking_reminder": zod.boolean().optional(),
  "check_in_prompt": zod.boolean().optional(),
  "auto_release_warning": zod.boolean().optional(),
  "resource_unavailable": zod.boolean().optional(),
  "visitor_arrival": zod.boolean().optional(),
  "visitor_approval": zod.boolean().optional()
}),
  "items": zod.array(zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "label": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "format": zod.enum(['plain', 'formatted']),
  "source": zod.enum(['platform', 'tenant', 'entity']),
  "builtIn": zod.boolean(),
  "locked": zod.boolean(),
  "hasOverride": zod.boolean(),
  "allowEntityOverride": zod.boolean(),
  "allowedFields": zod.array(zod.object({
  "path": zod.string(),
  "label": zod.string(),
  "sample": zod.string()
})),
  "updatedBy": zod.uuid().nullable(),
  "updatedByName": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})).max(updateEmailTemplatePermissions200ResponseItemsMax)
}))()

export const UpdateEmailTemplatePermissions400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateEmailTemplatePermissions403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * Uses preview authority, sample details and optional unsaved drafts. Counts all attempts before contacting the provider. Never retries a send.
 * @summary Send a sample email only to the signed-in administrator
 */
export const TestSendTenantEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const testSendTenantEmailTemplateQueryScopeDefault = `entity`;
export const testSendTenantEmailTemplateQueryAuthorityDefault = `tenant`;

export const TestSendTenantEmailTemplateQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(testSendTenantEmailTemplateQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(testSendTenantEmailTemplateQueryAuthorityDefault)
}))()

export const testSendTenantEmailTemplateHeaderXGroupGraphTokenMax = 16384;


export const testSendTenantEmailTemplateHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const TestSendTenantEmailTemplateHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(testSendTenantEmailTemplateHeaderXGroupGraphTokenMax).regex(testSendTenantEmailTemplateHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const testSendTenantEmailTemplateBodySubjectMax = 200;

export const testSendTenantEmailTemplateBodyBodyMax = 10000;

export const testSendTenantEmailTemplateBodyStyleDraftBannerTextMax = 120;

export const testSendTenantEmailTemplateBodyStyleDraftLogoMaxHeightMin = 40;
export const testSendTenantEmailTemplateBodyStyleDraftLogoMaxHeightMax = 120;

export const testSendTenantEmailTemplateBodyStyleDraftColoursPageBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursContentBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursHeadingRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursLinkRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursBannerBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursBannerTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursButtonBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursButtonTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursFooterBackgroundRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftColoursFooterTextRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const testSendTenantEmailTemplateBodyStyleDraftButtonLabelMax = 40;

export const testSendTenantEmailTemplateBodyStyleDraftFooterTextMax = 2000;



export const TestSendTenantEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "subject": zod.string().min(1).max(testSendTenantEmailTemplateBodySubjectMax).optional(),
  "body": zod.string().min(1).max(testSendTenantEmailTemplateBodyBodyMax).optional(),
  "format": zod.enum(['plain', 'formatted']).optional(),
  "styleDraft": zod.object({
  "version": zod.literal(1).optional(),
  "banner": zod.object({
  "mode": zod.union([zod.literal('none'),zod.literal('colour'),zod.literal('image'),zod.literal(null)]).nullish(),
  "text": zod.string().max(testSendTenantEmailTemplateBodyStyleDraftBannerTextMax).nullish(),
  "alignment": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "logo": zod.object({
  "source": zod.union([zod.literal('app'),zod.literal('uploaded'),zod.literal('none'),zod.literal(null)]).nullish(),
  "position": zod.union([zod.literal('left'),zod.literal('centre'),zod.literal(null)]).nullish(),
  "maxHeight": zod.int().min(testSendTenantEmailTemplateBodyStyleDraftLogoMaxHeightMin).max(testSendTenantEmailTemplateBodyStyleDraftLogoMaxHeightMax).nullish(),
  "imageId": zod.uuid().nullish()
}).nullish(),
  "typography": zod.object({
  "bodyFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "headingFont": zod.union([zod.literal('lato'),zod.literal('calibri'),zod.literal('arial'),zod.literal('verdana'),zod.literal('georgia'),zod.literal('trebuchet'),zod.literal('system'),zod.literal(null)]).nullish(),
  "baseSize": zod.union([zod.literal(14),zod.literal(16),zod.literal(18),zod.literal(null)]).nullish()
}).nullish(),
  "colours": zod.object({
  "pageBackground": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursPageBackgroundRegExp).nullish(),
  "contentBackground": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursContentBackgroundRegExp).nullish(),
  "text": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursTextRegExp).nullish(),
  "heading": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursHeadingRegExp).nullish(),
  "link": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursLinkRegExp).nullish(),
  "bannerBackground": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursBannerBackgroundRegExp).nullish(),
  "bannerText": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursBannerTextRegExp).nullish(),
  "buttonBackground": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursButtonBackgroundRegExp).nullish(),
  "buttonText": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursButtonTextRegExp).nullish(),
  "footerBackground": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursFooterBackgroundRegExp).nullish(),
  "footerText": zod.string().regex(testSendTenantEmailTemplateBodyStyleDraftColoursFooterTextRegExp).nullish()
}).nullish(),
  "button": zod.object({
  "shape": zod.union([zod.literal('square'),zod.literal('rounded'),zod.literal('pill'),zod.literal(null)]).nullish(),
  "label": zod.string().min(1).max(testSendTenantEmailTemplateBodyStyleDraftButtonLabelMax).nullish()
}).nullish(),
  "footer": zod.object({
  "text": zod.string().max(testSendTenantEmailTemplateBodyStyleDraftFooterTextMax).nullish()
}).nullish()
}).optional()
}))()

export const TestSendTenantEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "status": zod.enum(['accepted', 'not_configured']),
  "sentTo": zod.string().describe('Masked account email; never supplied by the request'),
  "message": zod.string()
}))()

export const TestSendTenantEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendTenantEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendTenantEmailTemplate429Response = /*#__PURE__*/ (() => zod.unknown())()

export const TestSendTenantEmailTemplate502Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Render customer email wording with sample details without saving or sending
 */
export const PreviewTenantEmailTemplateParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const previewTenantEmailTemplateQueryScopeDefault = `entity`;

export const PreviewTenantEmailTemplateQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(previewTenantEmailTemplateQueryScopeDefault)
}))()

export const previewTenantEmailTemplateHeaderXGroupGraphTokenMax = 16384;


export const previewTenantEmailTemplateHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const PreviewTenantEmailTemplateHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(previewTenantEmailTemplateHeaderXGroupGraphTokenMax).regex(previewTenantEmailTemplateHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const previewTenantEmailTemplateBodySubjectMax = 200;

export const previewTenantEmailTemplateBodyBodyMax = 10000;

export const previewTenantEmailTemplateBodyFormatDefault = `plain`;

export const PreviewTenantEmailTemplateBody = /*#__PURE__*/ (() => zod.object({
  "type": zod.enum(['booking_confirmed', 'booking_modified', 'booking_cancelled', 'booking_auto_released', 'booking_reminder', 'check_in_prompt', 'auto_release_warning', 'resource_unavailable', 'visitor_arrival', 'visitor_approval']),
  "subject": zod.string().min(1).max(previewTenantEmailTemplateBodySubjectMax),
  "body": zod.string().min(1).max(previewTenantEmailTemplateBodyBodyMax),
  "format": zod.enum(['plain', 'formatted']).default(previewTenantEmailTemplateBodyFormatDefault)
}))()

export const previewTenantEmailTemplate200ResponseHtmlMax = 102399;



export const PreviewTenantEmailTemplate200Response = /*#__PURE__*/ (() => zod.object({
  "subject": zod.string(),
  "body": zod.string(),
  "html": zod.string().max(previewTenantEmailTemplate200ResponseHtmlMax),
  "plainText": zod.string()
}))()

export const PreviewTenantEmailTemplate400Response = /*#__PURE__*/ (() => zod.unknown())()

export const PreviewTenantEmailTemplate403Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Read versioned opt-in settings, sources and implementation availability
 */
export const GetEnhancementSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getEnhancementSettingsQueryScopeDefault = `entity`;
export const getEnhancementSettingsQueryAuthorityDefault = `tenant`;

export const GetEnhancementSettingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(getEnhancementSettingsQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(getEnhancementSettingsQueryAuthorityDefault)
}))()

export const getEnhancementSettingsHeaderXGroupGraphTokenMax = 16384;


export const getEnhancementSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetEnhancementSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getEnhancementSettingsHeaderXGroupGraphTokenMax).regex(getEnhancementSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getEnhancementSettings200ResponseItemsItemStoredHorizonDaysMin = 0;
export const getEnhancementSettings200ResponseItemsItemStoredHorizonDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemStoredSimultaneousPerClassMax = 20;

export const getEnhancementSettings200ResponseItemsItemStoredOrganiserDeskLimitMax = 20;

export const getEnhancementSettings200ResponseItemsItemStoredMaxAssignmentsMax = 20;

export const getEnhancementSettings200ResponseItemsItemStoredMaxDesksMax = 20;

export const getEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMin = 0;
export const getEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMax = 10080;

export const getEnhancementSettings200ResponseItemsItemStoredCandidateWaitMinutesMax = 60;

export const getEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMin = 0;
export const getEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMax = 10080;

export const getEnhancementSettings200ResponseItemsItemStoredMinPeopleMin = 5;
export const getEnhancementSettings200ResponseItemsItemStoredMinPeopleMax = 100;

export const getEnhancementSettings200ResponseItemsItemStoredRangeDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemStoredMaxInteractiveDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMin = 0;
export const getEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMax = 1440;

export const getEnhancementSettings200ResponseItemsItemStoredPriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsItemStoredBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsItemStoredNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMin = 0;
export const getEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemEffectiveSimultaneousPerClassMax = 20;

export const getEnhancementSettings200ResponseItemsItemEffectiveOrganiserDeskLimitMax = 20;

export const getEnhancementSettings200ResponseItemsItemEffectiveMaxAssignmentsMax = 20;

export const getEnhancementSettings200ResponseItemsItemEffectiveMaxDesksMax = 20;

export const getEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMin = 0;
export const getEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMax = 10080;

export const getEnhancementSettings200ResponseItemsItemEffectiveCandidateWaitMinutesMax = 60;

export const getEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMin = 0;
export const getEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMax = 10080;

export const getEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMin = 5;
export const getEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMax = 100;

export const getEnhancementSettings200ResponseItemsItemEffectiveRangeDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemEffectiveMaxInteractiveDaysMax = 366;

export const getEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMin = 0;
export const getEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMax = 1440;

export const getEnhancementSettings200ResponseItemsItemEffectivePriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsItemEffectiveBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsItemEffectiveNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getEnhancementSettings200ResponseItemsMax = 9;



export const GetEnhancementSettings200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "revision": zod.string(),
  "items": zod.array(zod.object({
  "key": zod.enum(['entitlements', 'named_desks', 'holds', 'published_maps', 'wayfinding', 'schedules', 'invitations', 'reports', 'scenarios']),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "label": zod.string(),
  "implemented": zod.boolean(),
  "configuredEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal('not_ready'),zod.literal('capability'),zod.literal('not_implemented'),zod.literal(null)]).nullable(),
  "stored": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(getEnhancementSettings200ResponseItemsItemStoredHorizonDaysMin).max(getEnhancementSettings200ResponseItemsItemStoredHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(getEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMin).max(getEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(getEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMin).max(getEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(getEnhancementSettings200ResponseItemsItemStoredMinPeopleMin).max(getEnhancementSettings200ResponseItemsItemStoredMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemStoredMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(getEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMin).max(getEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemStoredPriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemStoredBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemStoredNoShowLocalTimeRegExp).optional()
}),
  "effective": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(getEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMin).max(getEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(getEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMin).max(getEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(getEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMin).max(getEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(getEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMin).max(getEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(getEnhancementSettings200ResponseItemsItemEffectiveMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(getEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMin).max(getEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemEffectivePriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemEffectiveBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(getEnhancementSettings200ResponseItemsItemEffectiveNoShowLocalTimeRegExp).optional()
}),
  "sources": zod.record(zod.string(), zod.enum(['legacy', 'default', 'tenant', 'entity'])),
  "allowEntityOverride": zod.boolean()
})).max(getEnhancementSettings200ResponseItemsMax)
}))()

export const GetEnhancementSettings400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetEnhancementSettings403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetEnhancementSettings409Response = /*#__PURE__*/ (() => zod.unknown())()


/**
 * @summary Save one capability or reset to inheritance with revision and authority checks
 */
export const SaveEnhancementSettingsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const saveEnhancementSettingsQueryScopeDefault = `entity`;
export const saveEnhancementSettingsQueryAuthorityDefault = `tenant`;

export const SaveEnhancementSettingsQueryParams = /*#__PURE__*/ (() => zod.object({
  "scope": zod.enum(['tenant', 'entity']).default(saveEnhancementSettingsQueryScopeDefault),
  "authority": zod.enum(['tenant', 'platform']).default(saveEnhancementSettingsQueryAuthorityDefault)
}))()

export const saveEnhancementSettingsHeaderXGroupGraphTokenMax = 16384;


export const saveEnhancementSettingsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const SaveEnhancementSettingsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(saveEnhancementSettingsHeaderXGroupGraphTokenMax).regex(saveEnhancementSettingsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const saveEnhancementSettingsBodyExpectedRevisionMax = 128;

export const saveEnhancementSettingsBodyValuesHorizonDaysMin = 0;
export const saveEnhancementSettingsBodyValuesHorizonDaysMax = 366;

export const saveEnhancementSettingsBodyValuesSimultaneousPerClassMax = 20;

export const saveEnhancementSettingsBodyValuesOrganiserDeskLimitMax = 20;

export const saveEnhancementSettingsBodyValuesMaxAssignmentsMax = 20;

export const saveEnhancementSettingsBodyValuesMaxDesksMax = 20;

export const saveEnhancementSettingsBodyValuesClaimMinutesBeforeStartMin = 0;
export const saveEnhancementSettingsBodyValuesClaimMinutesBeforeStartMax = 10080;

export const saveEnhancementSettingsBodyValuesCandidateWaitMinutesMax = 60;

export const saveEnhancementSettingsBodyValuesEventReminderMinutesMin = 0;
export const saveEnhancementSettingsBodyValuesEventReminderMinutesMax = 10080;

export const saveEnhancementSettingsBodyValuesMinPeopleMin = 5;
export const saveEnhancementSettingsBodyValuesMinPeopleMax = 100;

export const saveEnhancementSettingsBodyValuesRangeDaysMax = 366;

export const saveEnhancementSettingsBodyValuesMaxInteractiveDaysMax = 366;

export const saveEnhancementSettingsBodyValuesNoShowGraceMinutesMin = 0;
export const saveEnhancementSettingsBodyValuesNoShowGraceMinutesMax = 1440;

export const saveEnhancementSettingsBodyValuesPriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettingsBodyValuesBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettingsBodyValuesNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');


export const SaveEnhancementSettingsBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.string().min(1).max(saveEnhancementSettingsBodyExpectedRevisionMax),
  "capability": zod.enum(['entitlements', 'named_desks', 'holds', 'published_maps', 'wayfinding', 'schedules', 'invitations', 'reports', 'scenarios']),
  "values": zod.object({
  "enabled": zod.boolean().nullish(),
  "horizonDays": zod.int().min(saveEnhancementSettingsBodyValuesHorizonDaysMin).max(saveEnhancementSettingsBodyValuesHorizonDaysMax).nullish(),
  "simultaneousPerClass": zod.int().min(1).max(saveEnhancementSettingsBodyValuesSimultaneousPerClassMax).nullish(),
  "organiserDeskLimit": zod.int().min(1).max(saveEnhancementSettingsBodyValuesOrganiserDeskLimitMax).nullish(),
  "maxAssignments": zod.int().min(1).max(saveEnhancementSettingsBodyValuesMaxAssignmentsMax).nullish(),
  "maxDesks": zod.int().min(1).max(saveEnhancementSettingsBodyValuesMaxDesksMax).nullish(),
  "claimMinutesBeforeStart": zod.int().min(saveEnhancementSettingsBodyValuesClaimMinutesBeforeStartMin).max(saveEnhancementSettingsBodyValuesClaimMinutesBeforeStartMax).nullish(),
  "candidateWaitMinutes": zod.int().min(1).max(saveEnhancementSettingsBodyValuesCandidateWaitMinutesMax).nullish(),
  "eventReminderMinutes": zod.int().min(saveEnhancementSettingsBodyValuesEventReminderMinutesMin).max(saveEnhancementSettingsBodyValuesEventReminderMinutesMax).nullish(),
  "minPeople": zod.int().min(saveEnhancementSettingsBodyValuesMinPeopleMin).max(saveEnhancementSettingsBodyValuesMinPeopleMax).nullish(),
  "personLevel": zod.boolean().nullish(),
  "rangeDays": zod.int().min(1).max(saveEnhancementSettingsBodyValuesRangeDaysMax).nullish(),
  "maxInteractiveDays": zod.int().min(1).max(saveEnhancementSettingsBodyValuesMaxInteractiveDaysMax).nullish(),
  "noShowGraceMinutes": zod.int().min(saveEnhancementSettingsBodyValuesNoShowGraceMinutesMin).max(saveEnhancementSettingsBodyValuesNoShowGraceMinutesMax).nullish(),
  "priorBusinessDayTime": zod.string().regex(saveEnhancementSettingsBodyValuesPriorBusinessDayTimeRegExp).nullish(),
  "bookingDayTime": zod.string().regex(saveEnhancementSettingsBodyValuesBookingDayTimeRegExp).nullish(),
  "noShowLocalTime": zod.string().regex(saveEnhancementSettingsBodyValuesNoShowLocalTimeRegExp).nullish()
}).optional(),
  "reset": zod.boolean().optional(),
  "allowEntityOverride": zod.boolean().optional()
}))()

export const saveEnhancementSettings200ResponseItemsItemStoredHorizonDaysMin = 0;
export const saveEnhancementSettings200ResponseItemsItemStoredHorizonDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemStoredSimultaneousPerClassMax = 20;

export const saveEnhancementSettings200ResponseItemsItemStoredOrganiserDeskLimitMax = 20;

export const saveEnhancementSettings200ResponseItemsItemStoredMaxAssignmentsMax = 20;

export const saveEnhancementSettings200ResponseItemsItemStoredMaxDesksMax = 20;

export const saveEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMin = 0;
export const saveEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMax = 10080;

export const saveEnhancementSettings200ResponseItemsItemStoredCandidateWaitMinutesMax = 60;

export const saveEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMin = 0;
export const saveEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMax = 10080;

export const saveEnhancementSettings200ResponseItemsItemStoredMinPeopleMin = 5;
export const saveEnhancementSettings200ResponseItemsItemStoredMinPeopleMax = 100;

export const saveEnhancementSettings200ResponseItemsItemStoredRangeDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemStoredMaxInteractiveDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMin = 0;
export const saveEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMax = 1440;

export const saveEnhancementSettings200ResponseItemsItemStoredPriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsItemStoredBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsItemStoredNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMin = 0;
export const saveEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemEffectiveSimultaneousPerClassMax = 20;

export const saveEnhancementSettings200ResponseItemsItemEffectiveOrganiserDeskLimitMax = 20;

export const saveEnhancementSettings200ResponseItemsItemEffectiveMaxAssignmentsMax = 20;

export const saveEnhancementSettings200ResponseItemsItemEffectiveMaxDesksMax = 20;

export const saveEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMin = 0;
export const saveEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMax = 10080;

export const saveEnhancementSettings200ResponseItemsItemEffectiveCandidateWaitMinutesMax = 60;

export const saveEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMin = 0;
export const saveEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMax = 10080;

export const saveEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMin = 5;
export const saveEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMax = 100;

export const saveEnhancementSettings200ResponseItemsItemEffectiveRangeDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemEffectiveMaxInteractiveDaysMax = 366;

export const saveEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMin = 0;
export const saveEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMax = 1440;

export const saveEnhancementSettings200ResponseItemsItemEffectivePriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsItemEffectiveBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsItemEffectiveNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const saveEnhancementSettings200ResponseItemsMax = 9;



export const SaveEnhancementSettings200Response = /*#__PURE__*/ (() => zod.object({
  "version": zod.literal(1),
  "scope": zod.enum(['tenant', 'entity']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "revision": zod.string(),
  "items": zod.array(zod.object({
  "key": zod.enum(['entitlements', 'named_desks', 'holds', 'published_maps', 'wayfinding', 'schedules', 'invitations', 'reports', 'scenarios']),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "label": zod.string(),
  "implemented": zod.boolean(),
  "configuredEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal('not_ready'),zod.literal('capability'),zod.literal('not_implemented'),zod.literal(null)]).nullable(),
  "stored": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(saveEnhancementSettings200ResponseItemsItemStoredHorizonDaysMin).max(saveEnhancementSettings200ResponseItemsItemStoredHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(saveEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMin).max(saveEnhancementSettings200ResponseItemsItemStoredClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(saveEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMin).max(saveEnhancementSettings200ResponseItemsItemStoredEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(saveEnhancementSettings200ResponseItemsItemStoredMinPeopleMin).max(saveEnhancementSettings200ResponseItemsItemStoredMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemStoredMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(saveEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMin).max(saveEnhancementSettings200ResponseItemsItemStoredNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemStoredPriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemStoredBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemStoredNoShowLocalTimeRegExp).optional()
}),
  "effective": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(saveEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMin).max(saveEnhancementSettings200ResponseItemsItemEffectiveHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(saveEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMin).max(saveEnhancementSettings200ResponseItemsItemEffectiveClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(saveEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMin).max(saveEnhancementSettings200ResponseItemsItemEffectiveEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(saveEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMin).max(saveEnhancementSettings200ResponseItemsItemEffectiveMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(saveEnhancementSettings200ResponseItemsItemEffectiveMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(saveEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMin).max(saveEnhancementSettings200ResponseItemsItemEffectiveNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemEffectivePriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemEffectiveBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(saveEnhancementSettings200ResponseItemsItemEffectiveNoShowLocalTimeRegExp).optional()
}),
  "sources": zod.record(zod.string(), zod.enum(['legacy', 'default', 'tenant', 'entity'])),
  "allowEntityOverride": zod.boolean()
})).max(saveEnhancementSettings200ResponseItemsMax)
}))()

export const SaveEnhancementSettings400Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveEnhancementSettings403Response = /*#__PURE__*/ (() => zod.unknown())()

export const SaveEnhancementSettings409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ListWorkplaceRolesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listWorkplaceRolesQueryLimitDefault = 25;
export const listWorkplaceRolesQueryLimitMax = 100;

export const listWorkplaceRolesQueryOffsetDefault = 0;
export const listWorkplaceRolesQueryOffsetMin = 0;
export const listWorkplaceRolesQueryOffsetMax = 100000;

export const listWorkplaceRolesQueryIncludeInactiveDefault = `false`;

export const ListWorkplaceRolesQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listWorkplaceRolesQueryLimitMax).default(listWorkplaceRolesQueryLimitDefault),
  "offset": zod.int().min(listWorkplaceRolesQueryOffsetMin).max(listWorkplaceRolesQueryOffsetMax).default(listWorkplaceRolesQueryOffsetDefault),
  "includeInactive": zod.enum(['true', 'false']).default(listWorkplaceRolesQueryIncludeInactiveDefault)
}))()

export const listWorkplaceRolesHeaderXGroupGraphTokenMax = 16384;


export const listWorkplaceRolesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListWorkplaceRolesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listWorkplaceRolesHeaderXGroupGraphTokenMax).regex(listWorkplaceRolesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listWorkplaceRoles200ResponseItemsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const listWorkplaceRoles200ResponseItemsItemNameMax = 100;

export const listWorkplaceRoles200ResponseItemsItemDescriptionMax = 1000;

export const listWorkplaceRoles200ResponseItemsItemGrantsPermissionsMax = 9;

export const listWorkplaceRoles200ResponseItemsItemGrantsLimitsDeskMax = 20;

export const listWorkplaceRoles200ResponseItemsItemGrantsLimitsRoomMax = 20;

export const listWorkplaceRoles200ResponseItemsItemGrantsLimitsOfficeMax = 20;

export const listWorkplaceRoles200ResponseItemsItemGrantsLimitsParkingMax = 20;

export const listWorkplaceRoles200ResponseItemsItemGrantsOrganiserDeskLimitMax = 20;

export const listWorkplaceRoles200ResponseItemsItemGrantsHorizonDaysMin = 0;
export const listWorkplaceRoles200ResponseItemsItemGrantsHorizonDaysMax = 366;


export const listWorkplaceRoles200ResponseItemsMax = 100;

export const listWorkplaceRoles200ResponseTotalMin = 0;

export const listWorkplaceRoles200ResponseLimitMax = 100;

export const listWorkplaceRoles200ResponseOffsetMin = 0;



export const ListWorkplaceRoles200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string().regex(listWorkplaceRoles200ResponseItemsItemKeyRegExp),
  "name": zod.string().min(1).max(listWorkplaceRoles200ResponseItemsItemNameMax),
  "description": zod.string().max(listWorkplaceRoles200ResponseItemsItemDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(listWorkplaceRoles200ResponseItemsItemGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(listWorkplaceRoles200ResponseItemsItemGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(listWorkplaceRoles200ResponseItemsItemGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(listWorkplaceRoles200ResponseItemsItemGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(listWorkplaceRoles200ResponseItemsItemGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(listWorkplaceRoles200ResponseItemsItemGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(listWorkplaceRoles200ResponseItemsItemGrantsHorizonDaysMin).max(listWorkplaceRoles200ResponseItemsItemGrantsHorizonDaysMax)
}),
  "revision": zod.int().min(1),
  "retiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listWorkplaceRoles200ResponseItemsMax),
  "total": zod.int().min(listWorkplaceRoles200ResponseTotalMin),
  "limit": zod.int().min(1).max(listWorkplaceRoles200ResponseLimitMax),
  "offset": zod.int().min(listWorkplaceRoles200ResponseOffsetMin)
}))()

export const ListWorkplaceRoles400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoles401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoles403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoles404Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoles409Response = /*#__PURE__*/ (() => zod.unknown())()


export const CreateWorkplaceRoleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const createWorkplaceRoleHeaderXGroupGraphTokenMax = 16384;


export const createWorkplaceRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const CreateWorkplaceRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(createWorkplaceRoleHeaderXGroupGraphTokenMax).regex(createWorkplaceRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const createWorkplaceRoleBodyKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const createWorkplaceRoleBodyNameMax = 100;

export const createWorkplaceRoleBodyDescriptionMax = 1000;

export const createWorkplaceRoleBodyGrantsPermissionsMax = 9;

export const createWorkplaceRoleBodyGrantsLimitsDeskMax = 20;

export const createWorkplaceRoleBodyGrantsLimitsRoomMax = 20;

export const createWorkplaceRoleBodyGrantsLimitsOfficeMax = 20;

export const createWorkplaceRoleBodyGrantsLimitsParkingMax = 20;

export const createWorkplaceRoleBodyGrantsOrganiserDeskLimitMax = 20;

export const createWorkplaceRoleBodyGrantsHorizonDaysMin = 0;
export const createWorkplaceRoleBodyGrantsHorizonDaysMax = 366;



export const CreateWorkplaceRoleBody = /*#__PURE__*/ (() => zod.object({
  "key": zod.string().regex(createWorkplaceRoleBodyKeyRegExp),
  "name": zod.string().min(1).max(createWorkplaceRoleBodyNameMax),
  "description": zod.string().max(createWorkplaceRoleBodyDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(createWorkplaceRoleBodyGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(createWorkplaceRoleBodyGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(createWorkplaceRoleBodyGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(createWorkplaceRoleBodyGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(createWorkplaceRoleBodyGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(createWorkplaceRoleBodyGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(createWorkplaceRoleBodyGrantsHorizonDaysMin).max(createWorkplaceRoleBodyGrantsHorizonDaysMax)
})
}))()

export const createWorkplaceRole200ResponseKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const createWorkplaceRole200ResponseNameMax = 100;

export const createWorkplaceRole200ResponseDescriptionMax = 1000;

export const createWorkplaceRole200ResponseGrantsPermissionsMax = 9;

export const createWorkplaceRole200ResponseGrantsLimitsDeskMax = 20;

export const createWorkplaceRole200ResponseGrantsLimitsRoomMax = 20;

export const createWorkplaceRole200ResponseGrantsLimitsOfficeMax = 20;

export const createWorkplaceRole200ResponseGrantsLimitsParkingMax = 20;

export const createWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax = 20;

export const createWorkplaceRole200ResponseGrantsHorizonDaysMin = 0;
export const createWorkplaceRole200ResponseGrantsHorizonDaysMax = 366;




export const CreateWorkplaceRole200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string().regex(createWorkplaceRole200ResponseKeyRegExp),
  "name": zod.string().min(1).max(createWorkplaceRole200ResponseNameMax),
  "description": zod.string().max(createWorkplaceRole200ResponseDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(createWorkplaceRole200ResponseGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(createWorkplaceRole200ResponseGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(createWorkplaceRole200ResponseGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(createWorkplaceRole200ResponseGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(createWorkplaceRole200ResponseGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(createWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(createWorkplaceRole200ResponseGrantsHorizonDaysMin).max(createWorkplaceRole200ResponseGrantsHorizonDaysMax)
}),
  "revision": zod.int().min(1),
  "retiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const CreateWorkplaceRole400Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateWorkplaceRole401Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateWorkplaceRole403Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateWorkplaceRole404Response = /*#__PURE__*/ (() => zod.unknown())()

export const CreateWorkplaceRole409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetWorkplaceRoleTemplatesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const getWorkplaceRoleTemplatesHeaderXGroupGraphTokenMax = 16384;


export const getWorkplaceRoleTemplatesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkplaceRoleTemplatesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkplaceRoleTemplatesHeaderXGroupGraphTokenMax).regex(getWorkplaceRoleTemplatesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getWorkplaceRoleTemplates200ResponseItemsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const getWorkplaceRoleTemplates200ResponseItemsItemNameMax = 100;

export const getWorkplaceRoleTemplates200ResponseItemsItemDescriptionMax = 1000;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsPermissionsMax = 9;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsDeskMax = 20;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsRoomMax = 20;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsOfficeMax = 20;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsParkingMax = 20;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsOrganiserDeskLimitMax = 20;

export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsHorizonDaysMin = 0;
export const getWorkplaceRoleTemplates200ResponseItemsItemGrantsHorizonDaysMax = 366;

export const getWorkplaceRoleTemplates200ResponseItemsMax = 4;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingPermissionsMax = 9;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsDeskMax = 20;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsRoomMax = 20;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsOfficeMax = 20;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsParkingMax = 20;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingOrganiserDeskLimitMax = 20;

export const getWorkplaceRoleTemplates200ResponseGrantCeilingHorizonDaysMin = 0;
export const getWorkplaceRoleTemplates200ResponseGrantCeilingHorizonDaysMax = 366;



export const GetWorkplaceRoleTemplates200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().regex(getWorkplaceRoleTemplates200ResponseItemsItemKeyRegExp),
  "name": zod.string().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemNameMax),
  "description": zod.string().max(getWorkplaceRoleTemplates200ResponseItemsItemDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(getWorkplaceRoleTemplates200ResponseItemsItemGrantsHorizonDaysMin).max(getWorkplaceRoleTemplates200ResponseItemsItemGrantsHorizonDaysMax)
})
})).max(getWorkplaceRoleTemplates200ResponseItemsMax),
  "proposedOccupancyLabel": zod.string(),
  "grantCeiling": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(getWorkplaceRoleTemplates200ResponseGrantCeilingPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsDeskMax),
  "room": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsRoomMax),
  "office": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsOfficeMax),
  "parking": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseGrantCeilingLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceRoleTemplates200ResponseGrantCeilingOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(getWorkplaceRoleTemplates200ResponseGrantCeilingHorizonDaysMin).max(getWorkplaceRoleTemplates200ResponseGrantCeilingHorizonDaysMax)
})
}))()

export const GetWorkplaceRoleTemplates400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleTemplates401Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleTemplates403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleTemplates404Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleTemplates409Response = /*#__PURE__*/ (() => zod.unknown())()


export const UpdateWorkplaceRoleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const updateWorkplaceRoleHeaderXGroupGraphTokenMax = 16384;


export const updateWorkplaceRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const UpdateWorkplaceRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(updateWorkplaceRoleHeaderXGroupGraphTokenMax).regex(updateWorkplaceRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const updateWorkplaceRoleBodyKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const updateWorkplaceRoleBodyNameMax = 100;

export const updateWorkplaceRoleBodyDescriptionMax = 1000;

export const updateWorkplaceRoleBodyGrantsPermissionsMax = 9;

export const updateWorkplaceRoleBodyGrantsLimitsDeskMax = 20;

export const updateWorkplaceRoleBodyGrantsLimitsRoomMax = 20;

export const updateWorkplaceRoleBodyGrantsLimitsOfficeMax = 20;

export const updateWorkplaceRoleBodyGrantsLimitsParkingMax = 20;

export const updateWorkplaceRoleBodyGrantsOrganiserDeskLimitMax = 20;

export const updateWorkplaceRoleBodyGrantsHorizonDaysMin = 0;
export const updateWorkplaceRoleBodyGrantsHorizonDaysMax = 366;


export const updateWorkplaceRoleBodyExpectedImpactRevisionMin = 64;
export const updateWorkplaceRoleBodyExpectedImpactRevisionMax = 64;



export const UpdateWorkplaceRoleBody = /*#__PURE__*/ (() => zod.object({
  "key": zod.string().regex(updateWorkplaceRoleBodyKeyRegExp),
  "name": zod.string().min(1).max(updateWorkplaceRoleBodyNameMax),
  "description": zod.string().max(updateWorkplaceRoleBodyDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(updateWorkplaceRoleBodyGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(updateWorkplaceRoleBodyGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(updateWorkplaceRoleBodyGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(updateWorkplaceRoleBodyGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(updateWorkplaceRoleBodyGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(updateWorkplaceRoleBodyGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(updateWorkplaceRoleBodyGrantsHorizonDaysMin).max(updateWorkplaceRoleBodyGrantsHorizonDaysMax)
}),
  "expectedRevision": zod.int().min(1),
  "expectedImpactRevision": zod.string().min(updateWorkplaceRoleBodyExpectedImpactRevisionMin).max(updateWorkplaceRoleBodyExpectedImpactRevisionMax)
}))()

export const updateWorkplaceRole200ResponseKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const updateWorkplaceRole200ResponseNameMax = 100;

export const updateWorkplaceRole200ResponseDescriptionMax = 1000;

export const updateWorkplaceRole200ResponseGrantsPermissionsMax = 9;

export const updateWorkplaceRole200ResponseGrantsLimitsDeskMax = 20;

export const updateWorkplaceRole200ResponseGrantsLimitsRoomMax = 20;

export const updateWorkplaceRole200ResponseGrantsLimitsOfficeMax = 20;

export const updateWorkplaceRole200ResponseGrantsLimitsParkingMax = 20;

export const updateWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax = 20;

export const updateWorkplaceRole200ResponseGrantsHorizonDaysMin = 0;
export const updateWorkplaceRole200ResponseGrantsHorizonDaysMax = 366;




export const UpdateWorkplaceRole200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string().regex(updateWorkplaceRole200ResponseKeyRegExp),
  "name": zod.string().min(1).max(updateWorkplaceRole200ResponseNameMax),
  "description": zod.string().max(updateWorkplaceRole200ResponseDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(updateWorkplaceRole200ResponseGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(updateWorkplaceRole200ResponseGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(updateWorkplaceRole200ResponseGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(updateWorkplaceRole200ResponseGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(updateWorkplaceRole200ResponseGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(updateWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(updateWorkplaceRole200ResponseGrantsHorizonDaysMin).max(updateWorkplaceRole200ResponseGrantsHorizonDaysMax)
}),
  "revision": zod.int().min(1),
  "retiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const UpdateWorkplaceRole400Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateWorkplaceRole401Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateWorkplaceRole403Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateWorkplaceRole404Response = /*#__PURE__*/ (() => zod.unknown())()

export const UpdateWorkplaceRole409Response = /*#__PURE__*/ (() => zod.unknown())()


export const DeleteWorkplaceRoleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const deleteWorkplaceRoleHeaderXGroupGraphTokenMax = 16384;


export const deleteWorkplaceRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const DeleteWorkplaceRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(deleteWorkplaceRoleHeaderXGroupGraphTokenMax).regex(deleteWorkplaceRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const deleteWorkplaceRoleBodyExpectedImpactRevisionMin = 64;
export const deleteWorkplaceRoleBodyExpectedImpactRevisionMax = 64;



export const DeleteWorkplaceRoleBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1),
  "expectedImpactRevision": zod.string().min(deleteWorkplaceRoleBodyExpectedImpactRevisionMin).max(deleteWorkplaceRoleBodyExpectedImpactRevisionMax)
}))()

export const DeleteWorkplaceRole200Response = /*#__PURE__*/ (() => zod.object({
  "deleted": zod.literal(true)
}))()

export const DeleteWorkplaceRole400Response = /*#__PURE__*/ (() => zod.unknown())()

export const DeleteWorkplaceRole401Response = /*#__PURE__*/ (() => zod.unknown())()

export const DeleteWorkplaceRole403Response = /*#__PURE__*/ (() => zod.unknown())()

export const DeleteWorkplaceRole404Response = /*#__PURE__*/ (() => zod.unknown())()

export const DeleteWorkplaceRole409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetWorkplaceRoleImpactParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const getWorkplaceRoleImpactHeaderXGroupGraphTokenMax = 16384;


export const getWorkplaceRoleImpactHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkplaceRoleImpactHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkplaceRoleImpactHeaderXGroupGraphTokenMax).regex(getWorkplaceRoleImpactHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const getWorkplaceRoleImpact200ResponseActiveAssignmentsMin = 0;

export const getWorkplaceRoleImpact200ResponseTotalAssignmentsMin = 0;



export const GetWorkplaceRoleImpact200Response = /*#__PURE__*/ (() => zod.object({
  "roleId": zod.uuid(),
  "roleRevision": zod.int().min(1),
  "activeAssignments": zod.int().min(getWorkplaceRoleImpact200ResponseActiveAssignmentsMin),
  "totalAssignments": zod.int().min(getWorkplaceRoleImpact200ResponseTotalAssignmentsMin),
  "impactRevision": zod.string()
}))()

export const GetWorkplaceRoleImpact400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleImpact401Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleImpact403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleImpact404Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceRoleImpact409Response = /*#__PURE__*/ (() => zod.unknown())()


export const RetireWorkplaceRoleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "roleId": zod.uuid()
}))()

export const retireWorkplaceRoleHeaderXGroupGraphTokenMax = 16384;


export const retireWorkplaceRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RetireWorkplaceRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(retireWorkplaceRoleHeaderXGroupGraphTokenMax).regex(retireWorkplaceRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const retireWorkplaceRoleBodyExpectedImpactRevisionMin = 64;
export const retireWorkplaceRoleBodyExpectedImpactRevisionMax = 64;



export const RetireWorkplaceRoleBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1),
  "expectedImpactRevision": zod.string().min(retireWorkplaceRoleBodyExpectedImpactRevisionMin).max(retireWorkplaceRoleBodyExpectedImpactRevisionMax)
}))()

export const retireWorkplaceRole200ResponseKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]{0,63}$');
export const retireWorkplaceRole200ResponseNameMax = 100;

export const retireWorkplaceRole200ResponseDescriptionMax = 1000;

export const retireWorkplaceRole200ResponseGrantsPermissionsMax = 9;

export const retireWorkplaceRole200ResponseGrantsLimitsDeskMax = 20;

export const retireWorkplaceRole200ResponseGrantsLimitsRoomMax = 20;

export const retireWorkplaceRole200ResponseGrantsLimitsOfficeMax = 20;

export const retireWorkplaceRole200ResponseGrantsLimitsParkingMax = 20;

export const retireWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax = 20;

export const retireWorkplaceRole200ResponseGrantsHorizonDaysMin = 0;
export const retireWorkplaceRole200ResponseGrantsHorizonDaysMax = 366;




export const RetireWorkplaceRole200Response = /*#__PURE__*/ (() => zod.object({
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "key": zod.string().regex(retireWorkplaceRole200ResponseKeyRegExp),
  "name": zod.string().min(1).max(retireWorkplaceRole200ResponseNameMax),
  "description": zod.string().max(retireWorkplaceRole200ResponseDescriptionMax),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(retireWorkplaceRole200ResponseGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(retireWorkplaceRole200ResponseGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(retireWorkplaceRole200ResponseGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(retireWorkplaceRole200ResponseGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(retireWorkplaceRole200ResponseGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(retireWorkplaceRole200ResponseGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(retireWorkplaceRole200ResponseGrantsHorizonDaysMin).max(retireWorkplaceRole200ResponseGrantsHorizonDaysMax)
}),
  "revision": zod.int().min(1),
  "retiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const RetireWorkplaceRole400Response = /*#__PURE__*/ (() => zod.unknown())()

export const RetireWorkplaceRole401Response = /*#__PURE__*/ (() => zod.unknown())()

export const RetireWorkplaceRole403Response = /*#__PURE__*/ (() => zod.unknown())()

export const RetireWorkplaceRole404Response = /*#__PURE__*/ (() => zod.unknown())()

export const RetireWorkplaceRole409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ListWorkplaceRoleAssignmentsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listWorkplaceRoleAssignmentsQueryLimitDefault = 25;
export const listWorkplaceRoleAssignmentsQueryLimitMax = 100;

export const listWorkplaceRoleAssignmentsQueryOffsetDefault = 0;
export const listWorkplaceRoleAssignmentsQueryOffsetMin = 0;
export const listWorkplaceRoleAssignmentsQueryOffsetMax = 100000;

export const listWorkplaceRoleAssignmentsQueryIncludeInactiveDefault = `false`;

export const ListWorkplaceRoleAssignmentsQueryParams = /*#__PURE__*/ (() => zod.object({
  "limit": zod.int().min(1).max(listWorkplaceRoleAssignmentsQueryLimitMax).default(listWorkplaceRoleAssignmentsQueryLimitDefault),
  "offset": zod.int().min(listWorkplaceRoleAssignmentsQueryOffsetMin).max(listWorkplaceRoleAssignmentsQueryOffsetMax).default(listWorkplaceRoleAssignmentsQueryOffsetDefault),
  "includeInactive": zod.enum(['true', 'false']).default(listWorkplaceRoleAssignmentsQueryIncludeInactiveDefault)
}))()

export const listWorkplaceRoleAssignmentsHeaderXGroupGraphTokenMax = 16384;


export const listWorkplaceRoleAssignmentsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListWorkplaceRoleAssignmentsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listWorkplaceRoleAssignmentsHeaderXGroupGraphTokenMax).regex(listWorkplaceRoleAssignmentsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()


export const listWorkplaceRoleAssignments200ResponseItemsMax = 100;

export const listWorkplaceRoleAssignments200ResponseTotalMin = 0;

export const listWorkplaceRoleAssignments200ResponseLimitMax = 100;

export const listWorkplaceRoleAssignments200ResponseOffsetMin = 0;



export const ListWorkplaceRoleAssignments200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "roleName": zod.string().optional(),
  "userName": zod.string().optional(),
  "scopeName": zod.string().optional(),
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid(),
  "userId": zod.uuid(),
  "scopeKind": zod.enum(['entity', 'site', 'team']),
  "siteId": zod.uuid().nullable(),
  "teamId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listWorkplaceRoleAssignments200ResponseItemsMax),
  "total": zod.int().min(listWorkplaceRoleAssignments200ResponseTotalMin),
  "limit": zod.int().min(1).max(listWorkplaceRoleAssignments200ResponseLimitMax),
  "offset": zod.int().min(listWorkplaceRoleAssignments200ResponseOffsetMin)
}))()

export const ListWorkplaceRoleAssignments400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoleAssignments401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoleAssignments403Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoleAssignments404Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceRoleAssignments409Response = /*#__PURE__*/ (() => zod.unknown())()


export const AssignWorkplaceRoleParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const assignWorkplaceRoleHeaderXGroupGraphTokenMax = 16384;


export const assignWorkplaceRoleHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const AssignWorkplaceRoleHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(assignWorkplaceRoleHeaderXGroupGraphTokenMax).regex(assignWorkplaceRoleHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const AssignWorkplaceRoleBody = /*#__PURE__*/ (() => zod.object({
  "roleId": zod.uuid(),
  "expectedRoleRevision": zod.int().min(1),
  "userId": zod.uuid(),
  "scope": zod.union([zod.object({
  "kind": zod.enum(['entity'])
}),zod.object({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})])
}))()




export const AssignWorkplaceRole200Response = /*#__PURE__*/ (() => zod.object({
  "roleName": zod.string().optional(),
  "userName": zod.string().optional(),
  "scopeName": zod.string().optional(),
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid(),
  "userId": zod.uuid(),
  "scopeKind": zod.enum(['entity', 'site', 'team']),
  "siteId": zod.uuid().nullable(),
  "teamId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const AssignWorkplaceRole400Response = /*#__PURE__*/ (() => zod.unknown())()

export const AssignWorkplaceRole401Response = /*#__PURE__*/ (() => zod.unknown())()

export const AssignWorkplaceRole403Response = /*#__PURE__*/ (() => zod.unknown())()

export const AssignWorkplaceRole404Response = /*#__PURE__*/ (() => zod.unknown())()

export const AssignWorkplaceRole409Response = /*#__PURE__*/ (() => zod.unknown())()


export const RevokeWorkplaceRoleAssignmentParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string(),
  "assignmentId": zod.uuid()
}))()

export const revokeWorkplaceRoleAssignmentHeaderXGroupGraphTokenMax = 16384;


export const revokeWorkplaceRoleAssignmentHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const RevokeWorkplaceRoleAssignmentHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(revokeWorkplaceRoleAssignmentHeaderXGroupGraphTokenMax).regex(revokeWorkplaceRoleAssignmentHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()




export const RevokeWorkplaceRoleAssignmentBody = /*#__PURE__*/ (() => zod.object({
  "expectedRevision": zod.int().min(1)
}))()




export const RevokeWorkplaceRoleAssignment200Response = /*#__PURE__*/ (() => zod.object({
  "roleName": zod.string().optional(),
  "userName": zod.string().optional(),
  "scopeName": zod.string().optional(),
  "id": zod.uuid(),
  "organizationId": zod.uuid(),
  "roleId": zod.uuid(),
  "userId": zod.uuid(),
  "scopeKind": zod.enum(['entity', 'site', 'team']),
  "siteId": zod.uuid().nullable(),
  "teamId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))()

export const RevokeWorkplaceRoleAssignment400Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevokeWorkplaceRoleAssignment401Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevokeWorkplaceRoleAssignment403Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevokeWorkplaceRoleAssignment404Response = /*#__PURE__*/ (() => zod.unknown())()

export const RevokeWorkplaceRoleAssignment409Response = /*#__PURE__*/ (() => zod.unknown())()


export const GetWorkplaceEntitlementsParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const GetWorkplaceEntitlementsQueryParams = /*#__PURE__*/ (() => zod.object({
  "userId": zod.uuid().optional(),
  "siteId": zod.uuid().optional()
}))()

export const getWorkplaceEntitlementsHeaderXGroupGraphTokenMax = 16384;


export const getWorkplaceEntitlementsHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const GetWorkplaceEntitlementsHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(getWorkplaceEntitlementsHeaderXGroupGraphTokenMax).regex(getWorkplaceEntitlementsHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const getWorkplaceEntitlements200ResponseGrantsPermissionsMax = 9;

export const getWorkplaceEntitlements200ResponseGrantsLimitsDeskMax = 20;

export const getWorkplaceEntitlements200ResponseGrantsLimitsRoomMax = 20;

export const getWorkplaceEntitlements200ResponseGrantsLimitsOfficeMax = 20;

export const getWorkplaceEntitlements200ResponseGrantsLimitsParkingMax = 20;

export const getWorkplaceEntitlements200ResponseGrantsOrganiserDeskLimitMax = 20;

export const getWorkplaceEntitlements200ResponseGrantsHorizonDaysMin = 0;
export const getWorkplaceEntitlements200ResponseGrantsHorizonDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyStoredHorizonDaysMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyStoredHorizonDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyStoredSimultaneousPerClassMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyStoredOrganiserDeskLimitMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyStoredMaxAssignmentsMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyStoredMaxDesksMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyStoredClaimMinutesBeforeStartMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyStoredClaimMinutesBeforeStartMax = 10080;

export const getWorkplaceEntitlements200ResponsePolicyStoredCandidateWaitMinutesMax = 60;

export const getWorkplaceEntitlements200ResponsePolicyStoredEventReminderMinutesMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyStoredEventReminderMinutesMax = 10080;

export const getWorkplaceEntitlements200ResponsePolicyStoredMinPeopleMin = 5;
export const getWorkplaceEntitlements200ResponsePolicyStoredMinPeopleMax = 100;

export const getWorkplaceEntitlements200ResponsePolicyStoredRangeDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyStoredMaxInteractiveDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyStoredNoShowGraceMinutesMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyStoredNoShowGraceMinutesMax = 1440;

export const getWorkplaceEntitlements200ResponsePolicyStoredPriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponsePolicyStoredBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponsePolicyStoredNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponsePolicyEffectiveHorizonDaysMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyEffectiveHorizonDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveSimultaneousPerClassMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveOrganiserDeskLimitMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveMaxAssignmentsMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveMaxDesksMax = 20;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveClaimMinutesBeforeStartMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyEffectiveClaimMinutesBeforeStartMax = 10080;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveCandidateWaitMinutesMax = 60;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveEventReminderMinutesMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyEffectiveEventReminderMinutesMax = 10080;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveMinPeopleMin = 5;
export const getWorkplaceEntitlements200ResponsePolicyEffectiveMinPeopleMax = 100;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveRangeDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveMaxInteractiveDaysMax = 366;

export const getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowGraceMinutesMin = 0;
export const getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowGraceMinutesMax = 1440;

export const getWorkplaceEntitlements200ResponsePolicyEffectivePriorBusinessDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponsePolicyEffectiveBookingDayTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowLocalTimeRegExp = new RegExp('^([01][0-9]|2[0-3]):[0-5][0-9]$');
export const getWorkplaceEntitlements200ResponseSourcesItemGrantsPermissionsMax = 9;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsDeskMax = 20;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsRoomMax = 20;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsOfficeMax = 20;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsParkingMax = 20;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsOrganiserDeskLimitMax = 20;

export const getWorkplaceEntitlements200ResponseSourcesItemGrantsHorizonDaysMin = 0;
export const getWorkplaceEntitlements200ResponseSourcesItemGrantsHorizonDaysMax = 366;

export const getWorkplaceEntitlements200ResponseSourcesMax = 200;



export const GetWorkplaceEntitlements200Response = /*#__PURE__*/ (() => zod.object({
  "mode": zod.enum(['legacy', 'scoped']),
  "entityId": zod.uuid(),
  "userId": zod.uuid(),
  "siteId": zod.uuid().nullable(),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(getWorkplaceEntitlements200ResponseGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(getWorkplaceEntitlements200ResponseGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(getWorkplaceEntitlements200ResponseGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(getWorkplaceEntitlements200ResponseGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(getWorkplaceEntitlements200ResponseGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceEntitlements200ResponseGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(getWorkplaceEntitlements200ResponseGrantsHorizonDaysMin).max(getWorkplaceEntitlements200ResponseGrantsHorizonDaysMax)
}),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal('not_ready'),zod.literal('capability'),zod.literal('not_implemented'),zod.literal(null)]).nullable(),
  "policy": zod.object({
  "key": zod.enum(['entitlements', 'named_desks', 'holds', 'published_maps', 'wayfinding', 'schedules', 'invitations', 'reports', 'scenarios']),
  "moduleKey": zod.enum(['booking', 'workplace_planning', 'teams_and_colleagues', 'visitors', 'staffed_services', 'maps_rooms', 'reporting', 'ai_tools']),
  "label": zod.string(),
  "implemented": zod.boolean(),
  "configuredEnabled": zod.boolean(),
  "effectiveEnabled": zod.boolean(),
  "blockedBy": zod.union([zod.literal('platform'),zod.literal('tenant'),zod.literal('entity'),zod.literal('not_ready'),zod.literal('capability'),zod.literal('not_implemented'),zod.literal(null)]).nullable(),
  "stored": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(getWorkplaceEntitlements200ResponsePolicyStoredHorizonDaysMin).max(getWorkplaceEntitlements200ResponsePolicyStoredHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(getWorkplaceEntitlements200ResponsePolicyStoredClaimMinutesBeforeStartMin).max(getWorkplaceEntitlements200ResponsePolicyStoredClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(getWorkplaceEntitlements200ResponsePolicyStoredEventReminderMinutesMin).max(getWorkplaceEntitlements200ResponsePolicyStoredEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(getWorkplaceEntitlements200ResponsePolicyStoredMinPeopleMin).max(getWorkplaceEntitlements200ResponsePolicyStoredMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyStoredMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(getWorkplaceEntitlements200ResponsePolicyStoredNoShowGraceMinutesMin).max(getWorkplaceEntitlements200ResponsePolicyStoredNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyStoredPriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyStoredBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyStoredNoShowLocalTimeRegExp).optional()
}),
  "effective": zod.object({
  "enabled": zod.boolean().optional(),
  "horizonDays": zod.int().min(getWorkplaceEntitlements200ResponsePolicyEffectiveHorizonDaysMin).max(getWorkplaceEntitlements200ResponsePolicyEffectiveHorizonDaysMax).optional(),
  "simultaneousPerClass": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveSimultaneousPerClassMax).optional(),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveOrganiserDeskLimitMax).optional(),
  "maxAssignments": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveMaxAssignmentsMax).optional(),
  "maxDesks": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveMaxDesksMax).optional(),
  "claimMinutesBeforeStart": zod.int().min(getWorkplaceEntitlements200ResponsePolicyEffectiveClaimMinutesBeforeStartMin).max(getWorkplaceEntitlements200ResponsePolicyEffectiveClaimMinutesBeforeStartMax).optional(),
  "candidateWaitMinutes": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveCandidateWaitMinutesMax).optional(),
  "eventReminderMinutes": zod.int().min(getWorkplaceEntitlements200ResponsePolicyEffectiveEventReminderMinutesMin).max(getWorkplaceEntitlements200ResponsePolicyEffectiveEventReminderMinutesMax).optional(),
  "minPeople": zod.int().min(getWorkplaceEntitlements200ResponsePolicyEffectiveMinPeopleMin).max(getWorkplaceEntitlements200ResponsePolicyEffectiveMinPeopleMax).optional(),
  "personLevel": zod.boolean().optional(),
  "rangeDays": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveRangeDaysMax).optional(),
  "maxInteractiveDays": zod.int().min(1).max(getWorkplaceEntitlements200ResponsePolicyEffectiveMaxInteractiveDaysMax).optional(),
  "noShowGraceMinutes": zod.int().min(getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowGraceMinutesMin).max(getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowGraceMinutesMax).optional(),
  "priorBusinessDayTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyEffectivePriorBusinessDayTimeRegExp).optional(),
  "bookingDayTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyEffectiveBookingDayTimeRegExp).optional(),
  "noShowLocalTime": zod.string().regex(getWorkplaceEntitlements200ResponsePolicyEffectiveNoShowLocalTimeRegExp).optional()
}),
  "sources": zod.record(zod.string(), zod.enum(['legacy', 'default', 'tenant', 'entity'])),
  "allowEntityOverride": zod.boolean()
}),
  "sources": zod.array(zod.object({
  "assignmentId": zod.uuid(),
  "roleId": zod.uuid(),
  "roleName": zod.string(),
  "scope": zod.union([zod.object({
  "kind": zod.enum(['entity'])
}),zod.object({
  "kind": zod.enum(['site']),
  "siteId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['team']),
  "teamId": zod.uuid()
})]),
  "grants": zod.object({
  "permissions": zod.array(zod.enum(['self', 'delegate', 'organise', 'inventory', 'report', 'roles', 'settings', 'office', 'parking'])).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsPermissionsMax),
  "limits": zod.object({
  "desk": zod.int().min(1).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsDeskMax),
  "room": zod.int().min(1).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsRoomMax),
  "office": zod.int().min(1).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsOfficeMax),
  "parking": zod.int().min(1).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsLimitsParkingMax)
}),
  "organiserDeskLimit": zod.int().min(1).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsOrganiserDeskLimitMax),
  "horizonDays": zod.int().min(getWorkplaceEntitlements200ResponseSourcesItemGrantsHorizonDaysMin).max(getWorkplaceEntitlements200ResponseSourcesItemGrantsHorizonDaysMax)
})
})).max(getWorkplaceEntitlements200ResponseSourcesMax),
  "canAdministerRoles": zod.boolean(),
  "canManageSettings": zod.boolean()
}))()

export const GetWorkplaceEntitlements400Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceEntitlements401Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceEntitlements403Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceEntitlements404Response = /*#__PURE__*/ (() => zod.unknown())()

export const GetWorkplaceEntitlements409Response = /*#__PURE__*/ (() => zod.unknown())()


export const ListWorkplaceChoicesParams = /*#__PURE__*/ (() => zod.object({
  "tenantSlug": zod.string()
}))()

export const listWorkplaceChoicesQuerySearchMax = 100;

export const listWorkplaceChoicesQueryLimitDefault = 25;
export const listWorkplaceChoicesQueryLimitMax = 100;

export const listWorkplaceChoicesQueryOffsetDefault = 0;
export const listWorkplaceChoicesQueryOffsetMin = 0;
export const listWorkplaceChoicesQueryOffsetMax = 100000;



export const ListWorkplaceChoicesQueryParams = /*#__PURE__*/ (() => zod.object({
  "kind": zod.enum(['member', 'site', 'team']),
  "search": zod.string().max(listWorkplaceChoicesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listWorkplaceChoicesQueryLimitMax).default(listWorkplaceChoicesQueryLimitDefault),
  "offset": zod.int().min(listWorkplaceChoicesQueryOffsetMin).max(listWorkplaceChoicesQueryOffsetMax).default(listWorkplaceChoicesQueryOffsetDefault)
}))()

export const listWorkplaceChoicesHeaderXGroupGraphTokenMax = 16384;


export const listWorkplaceChoicesHeaderXGroupGraphTokenRegExp = new RegExp('^[A-Za-z0-9._~+/=-]+$');


export const ListWorkplaceChoicesHeader = /*#__PURE__*/ (() => zod.object({
  "X-Group-Graph-Token": zod.string().min(1).max(listWorkplaceChoicesHeaderXGroupGraphTokenMax).regex(listWorkplaceChoicesHeaderXGroupGraphTokenRegExp).optional().describe('Opaque delegated Microsoft Graph credential from the signed-in caller. Authorization remains an independently validated custom-API bearer. The server verifies Graph /me and /organization against API oid/tid before any group read or check of a server-enrolled subject. Requires delegated User.Read, User.ReadBasic.All and administrator-consented GroupMember.Read.All. Never persist, log or include in URLs. Missing or rejected credentials grant no group access; valid individual access remains available.\n')
}))()

export const listWorkplaceChoices200ResponseItemsMax = 100;

export const listWorkplaceChoices200ResponseTotalMin = 0;

export const listWorkplaceChoices200ResponseLimitMax = 100;

export const listWorkplaceChoices200ResponseOffsetMin = 0;



export const ListWorkplaceChoices200Response = /*#__PURE__*/ (() => zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string()
})).max(listWorkplaceChoices200ResponseItemsMax),
  "total": zod.int().min(listWorkplaceChoices200ResponseTotalMin),
  "limit": zod.int().min(1).max(listWorkplaceChoices200ResponseLimitMax),
  "offset": zod.int().min(listWorkplaceChoices200ResponseOffsetMin)
}))()

export const ListWorkplaceChoices400Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceChoices401Response = /*#__PURE__*/ (() => zod.unknown())()

export const ListWorkplaceChoices403Response = /*#__PURE__*/ (() => zod.unknown())()
